/**
 * Export format to support Node.js scripts
 */

const { vlaamsGewest } = require("../../functions/libs/proxies")

const deprecatedCodesByDeployment = {
  nl: ['0756', '1702', '1685', '0856', '0398', '0416', '0370', '9000'],
  be: [],
  uk: [],
  de: [],
}

const gemeentenByDeployment = {
  nl: [
    {
      code: '1680',
      label: 'Aa en Hunze',
      provincie: 22,
      slug: 'aa-en-hunze',
    },
    { code: '0358', label: 'Aalsmeer', provincie: 27, slug: 'aalsmeer' },
    { code: '0197', label: 'Aalten', provincie: 25, slug: 'aalten' },
    {
      code: '0059',
      label: 'Achtkarspelen',
      provincie: 21,
      slug: 'achtkarspelen',
    },
    {
      code: '0482',
      label: 'Alblasserdam',
      provincie: 28,
      slug: 'alblasserdam',
    },
    {
      code: '0613',
      label: 'Albrandswaard',
      provincie: 28,
      slug: 'albrandswaard',
    },
    { code: '0361', label: 'Alkmaar', provincie: 27, slug: 'alkmaar' },
    { code: '0141', label: 'Almelo', provincie: 23, slug: 'almelo' },
    { code: '0034', label: 'Almere', provincie: 24, slug: 'almere' },
    {
      code: '0484',
      label: 'Alphen aan den Rijn',
      provincie: 28,
      slug: 'alphen-aan-den-rijn',
    },
    {
      code: '1723',
      label: 'Alphen-Chaam',
      provincie: 30,
      slug: 'alphen-chaam',
    },
    { code: '1959', label: 'Altena', provincie: 30, slug: 'altena' },
    { code: '0060', label: 'Ameland', provincie: 21, slug: 'ameland' },
    { code: '0307', label: 'Amersfoort', provincie: 26, slug: 'amersfoort' },
    { code: '0362', label: 'Amstelveen', provincie: 27, slug: 'amstelveen' },
    { code: '0363', label: 'Amsterdam', provincie: 27, slug: 'amsterdam' },
    { code: '0200', label: 'Apeldoorn', provincie: 25, slug: 'apeldoorn' },
    { code: '0202', label: 'Arnhem', provincie: 25, slug: 'arnhem' },
    { code: '0106', label: 'Assen', provincie: 22, slug: 'assen' },
    { code: '0743', label: 'Asten', provincie: 30, slug: 'asten' },
    {
      code: '0744',
      label: 'Baarle-Nassau',
      provincie: 30,
      slug: 'baarle-nassau',
    },
    { code: '0308', label: 'Baarn', provincie: 26, slug: 'baarn' },
    {
      code: '0489',
      label: 'Barendrecht',
      provincie: 28,
      slug: 'barendrecht',
    },
    { code: '0203', label: 'Barneveld', provincie: 25, slug: 'barneveld' },
    { code: '0888', label: 'Beek', provincie: 31, slug: 'beek' },
    { code: '1954', label: 'Beekdaelen', provincie: 31, slug: 'beekdaelen' },
    { code: '0889', label: 'Beesel', provincie: 31, slug: 'beesel' },
    {
      code: '1945',
      label: 'Berg en Dal',
      provincie: 25,
      slug: 'berg-en-dal',
    },
    { code: '1724', label: 'Bergeijk', provincie: 30, slug: 'bergeijk' },
    {
      code: '0893',
      label: 'Bergen (L.)',
      provincie: 31,
      slug: 'bergen-limburg',
    },
    {
      code: '0373',
      label: 'Bergen (NH.)',
      provincie: 27,
      slug: 'bergen-noord-holland',
    },
    {
      code: '0748',
      label: 'Bergen op Zoom',
      provincie: 30,
      slug: 'bergen-op-zoom',
    },
    { code: '1859', label: 'Berkelland', provincie: 25, slug: 'berkelland' },
    { code: '1721', label: 'Bernheze', provincie: 30, slug: 'bernheze' },
    { code: '0753', label: 'Best', provincie: 30, slug: 'best' },
    { code: '0209', label: 'Beuningen', provincie: 25, slug: 'beuningen' },
    { code: '0375', label: 'Beverwijk', provincie: 27, slug: 'beverwijk' },
    { code: '0310', label: 'De Bilt', provincie: 26, slug: 'de-bilt' },
    { code: '1728', label: 'Bladel', provincie: 30, slug: 'bladel' },
    { code: '0376', label: 'Blaricum', provincie: 27, slug: 'blaricum' },
    {
      code: '0377',
      label: 'Bloemendaal',
      provincie: 27,
      slug: 'bloemendaal',
    },
    {
      code: '1901',
      label: 'Bodegraven-Reeuwijk',
      provincie: 28,
      slug: 'bodegraven-reeuwijk',
    },
    { code: '0755', label: 'Boekel', provincie: 30, slug: 'boekel' },
    {
      code: '1681',
      label: 'Borger-Odoorn',
      provincie: 22,
      slug: 'borger-odoorn',
    },
    { code: '0147', label: 'Borne', provincie: 23, slug: 'borne' },
    { code: '0654', label: 'Borsele', provincie: 29, slug: 'borsele' },
    { code: '0757', label: 'Boxtel', provincie: 30, slug: 'boxtel' },
    { code: '0758', label: 'Breda', provincie: 30, slug: 'breda' },
    {
      code: '1876',
      label: 'Bronckhorst',
      provincie: 25,
      slug: 'bronckhorst',
    },
    { code: '0213', label: 'Brummen', provincie: 25, slug: 'brummen' },
    { code: '0899', label: 'Brunssum', provincie: 31, slug: 'brunssum' },
    { code: '0312', label: 'Bunnik', provincie: 26, slug: 'bunnik' },
    { code: '0313', label: 'Bunschoten', provincie: 26, slug: 'bunschoten' },
    { code: '0214', label: 'Buren', provincie: 25, slug: 'buren' },
    {
      code: '0502',
      label: 'Capelle aan den IJssel',
      provincie: 28,
      slug: 'capelle-aan-den-ijssel',
    },
    { code: '0383', label: 'Castricum', provincie: 27, slug: 'castricum' },
    { code: '0109', label: 'Coevorden', provincie: 22, slug: 'coevorden' },
    {
      code: '1706',
      label: 'Cranendonck',
      provincie: 30,
      slug: 'cranendonck',
    },
    { code: '0216', label: 'Culemborg', provincie: 25, slug: 'culemborg' },
    { code: '0148', label: 'Dalfsen', provincie: 23, slug: 'dalfsen' },
    {
      code: '1891',
      label: 'Dantumadiel',
      provincie: 21,
      slug: 'dantumadiel',
    },
    { code: '0503', label: 'Delft', provincie: 28, slug: 'delft' },
    { code: '0762', label: 'Deurne', provincie: 30, slug: 'deurne' },
    { code: '0150', label: 'Deventer', provincie: 23, slug: 'deventer' },
    { code: '0384', label: 'Diemen', provincie: 27, slug: 'diemen' },
    { code: '1774', label: 'Dinkelland', provincie: 23, slug: 'dinkelland' },
    { code: '0221', label: 'Doesburg', provincie: 25, slug: 'doesburg' },
    { code: '0222', label: 'Doetinchem', provincie: 25, slug: 'doetinchem' },
    { code: '0766', label: 'Dongen', provincie: 30, slug: 'dongen' },
    { code: '0505', label: 'Dordrecht', provincie: 28, slug: 'dordrecht' },
    {
      code: '0498',
      label: 'Drechterland',
      provincie: 27,
      slug: 'drechterland',
    },
    { code: '1719', label: 'Drimmelen', provincie: 30, slug: 'drimmelen' },
    { code: '0303', label: 'Dronten', provincie: 24, slug: 'dronten' },
    { code: '0225', label: 'Druten', provincie: 25, slug: 'druten' },
    { code: '0226', label: 'Duiven', provincie: 25, slug: 'duiven' },
    {
      code: '1711',
      label: 'Echt-Susteren',
      provincie: 31,
      slug: 'echt-susteren',
    },
    {
      code: '0385',
      label: 'Edam-Volendam',
      provincie: 27,
      slug: 'edam-volendam',
    },
    { code: '0228', label: 'Ede', provincie: 25, slug: 'ede' },
    { code: '0317', label: 'Eemnes', provincie: 26, slug: 'eemnes' },
    { code: '1979', label: 'Eemsdelta', provincie: 20, slug: 'eemsdelta' },
    { code: '0770', label: 'Eersel', provincie: 30, slug: 'eersel' },
    {
      code: '1903',
      label: 'Eijsden-Margraten',
      provincie: 31,
      slug: 'eijsden-margraten',
    },
    { code: '0772', label: 'Eindhoven', provincie: 30, slug: 'eindhoven' },
    { code: '0230', label: 'Elburg', provincie: 25, slug: 'elburg' },
    { code: '0114', label: 'Emmen', provincie: 22, slug: 'emmen' },
    { code: '0388', label: 'Enkhuizen', provincie: 27, slug: 'enkhuizen' },
    { code: '0153', label: 'Enschede', provincie: 23, slug: 'enschede' },
    { code: '0232', label: 'Epe', provincie: 25, slug: 'epe' },
    { code: '0233', label: 'Ermelo', provincie: 25, slug: 'ermelo' },
    { code: '0777', label: 'Etten-Leur', provincie: 30, slug: 'etten-leur' },
    {
      code: '1940',
      label: 'De Fryske Marren',
      provincie: 21,
      slug: 'de-fryske-marren',
    },
    {
      code: '0779',
      label: 'Geertruidenberg',
      provincie: 30,
      slug: 'geertruidenberg',
    },
    {
      code: '1771',
      label: 'Geldrop-Mierlo',
      provincie: 30,
      slug: 'geldrop-mierlo',
    },
    {
      code: '1652',
      label: 'Gemert-Bakel',
      provincie: 30,
      slug: 'gemert-bakel',
    },
    { code: '0907', label: 'Gennep', provincie: 31, slug: 'gennep' },
    {
      code: '0784',
      label: 'Gilze en Rijen',
      provincie: 30,
      slug: 'gilze-en-rijen',
    },
    {
      code: '1924',
      label: 'Goeree-Overflakkee',
      provincie: 28,
      slug: 'goeree-overflakkee',
    },
    { code: '0664', label: 'Goes', provincie: 29, slug: 'goes' },
    { code: '0785', label: 'Goirle', provincie: 30, slug: 'goirle' },
    {
      code: '1942',
      label: 'Gooise Meren',
      provincie: 27,
      slug: 'gooise-meren',
    },
    { code: '0512', label: 'Gorinchem', provincie: 28, slug: 'gorinchem' },
    { code: '0513', label: 'Gouda', provincie: 28, slug: 'gouda' },
    {
      code: '0518',
      label: '\'s-Gravenhage',
      provincie: 28,
      slug: 's-gravenhage',
    },
    { code: '0014', label: 'Groningen', provincie: 20, slug: 'groningen' },
    {
      code: '1729',
      label: 'Gulpen-Wittem',
      provincie: 31,
      slug: 'gulpen-wittem',
    },
    {
      code: '0158',
      label: 'Haaksbergen',
      provincie: 23,
      slug: 'haaksbergen',
    },
    { code: '0788', label: 'Haaren', provincie: 30, slug: 'haaren' },
    { code: '0392', label: 'Haarlem', provincie: 27, slug: 'haarlem' },
    {
      code: '0394',
      label: 'Haarlemmermeer',
      provincie: 27,
      slug: 'haarlemmermeer',
    },
    {
      code: '1655',
      label: 'Halderberge',
      provincie: 30,
      slug: 'halderberge',
    },
    { code: '0160', label: 'Hardenberg', provincie: 23, slug: 'hardenberg' },
    { code: '0243', label: 'Harderwijk', provincie: 25, slug: 'harderwijk' },
    {
      code: '0523',
      label: 'Hardinxveld-Giessendam',
      provincie: 28,
      slug: 'hardinxveld-giessendam',
    },
    { code: '0072', label: 'Harlingen', provincie: 21, slug: 'harlingen' },
    { code: '0244', label: 'Hattem', provincie: 25, slug: 'hattem' },
    { code: '0396', label: 'Heemskerk', provincie: 27, slug: 'heemskerk' },
    { code: '0397', label: 'Heemstede', provincie: 27, slug: 'heemstede' },
    { code: '0246', label: 'Heerde', provincie: 25, slug: 'heerde' },
    { code: '0074', label: 'Heerenveen', provincie: 21, slug: 'heerenveen' },
    { code: '0917', label: 'Heerlen', provincie: 31, slug: 'heerlen' },
    {
      code: '1658',
      label: 'Heeze-Leende',
      provincie: 30,
      slug: 'heeze-leende',
    },
    { code: '0399', label: 'Heiloo', provincie: 27, slug: 'heiloo' },
    { code: '0400', label: 'Den Helder', provincie: 27, slug: 'den-helder' },
    {
      code: '0163',
      label: 'Hellendoorn',
      provincie: 23,
      slug: 'hellendoorn',
    },
    { code: '0794', label: 'Helmond', provincie: 30, slug: 'helmond' },
    {
      code: '0531',
      label: 'Hendrik-Ido-Ambacht',
      provincie: 28,
      slug: 'hendrik-ido-ambacht',
    },
    { code: '0164', label: 'Hengelo', provincie: 23, slug: 'hengelo' },
    {
      code: '0796',
      label: '\'s-Hertogenbosch',
      provincie: 30,
      slug: 's-hertogenbosch',
    },
    { code: '0252', label: 'Heumen', provincie: 25, slug: 'heumen' },
    { code: '0797', label: 'Heusden', provincie: 30, slug: 'heusden' },
    { code: '0534', label: 'Hillegom', provincie: 28, slug: 'hillegom' },
    {
      code: '0798',
      label: 'Hilvarenbeek',
      provincie: 30,
      slug: 'hilvarenbeek',
    },
    { code: '0402', label: 'Hilversum', provincie: 27, slug: 'hilversum' },
    {
      code: '1963',
      label: 'Hoeksche Waard',
      provincie: 28,
      slug: 'hoeksche-waard',
    },
    {
      code: '1735',
      label: 'Hof van Twente',
      provincie: 23,
      slug: 'hof-van-twente',
    },
    {
      code: '1966',
      label: 'Het Hogeland',
      provincie: 20,
      slug: 'het-hogeland',
    },
    {
      code: '1911',
      label: 'Hollands Kroon',
      provincie: 27,
      slug: 'hollands-kroon',
    },
    { code: '0118', label: 'Hoogeveen', provincie: 22, slug: 'hoogeveen' },
    { code: '0405', label: 'Hoorn', provincie: 27, slug: 'hoorn' },
    {
      code: '1507',
      label: 'Horst aan de Maas',
      provincie: 31,
      slug: 'horst-aan-de-maas',
    },
    { code: '0321', label: 'Houten', provincie: 26, slug: 'houten' },
    { code: '0406', label: 'Huizen', provincie: 27, slug: 'huizen' },
    { code: '0677', label: 'Hulst', provincie: 29, slug: 'hulst' },
    {
      code: '0353',
      label: 'IJsselstein',
      provincie: 26,
      slug: 'ijsselstein',
    },
    {
      code: '1884',
      label: 'Kaag en Braassem',
      provincie: 28,
      slug: 'kaag-en-braassem',
    },
    { code: '0166', label: 'Kampen', provincie: 23, slug: 'kampen' },
    { code: '0678', label: 'Kapelle', provincie: 29, slug: 'kapelle' },
    { code: '0537', label: 'Katwijk', provincie: 28, slug: 'katwijk' },
    { code: '0928', label: 'Kerkrade', provincie: 31, slug: 'kerkrade' },
    { code: '1598', label: 'Koggenland', provincie: 27, slug: 'koggenland' },
    {
      code: '0542',
      label: 'Krimpen aan den IJssel',
      provincie: 28,
      slug: 'krimpen-aan-den-ijssel',
    },
    {
      code: '1931',
      label: 'Krimpenerwaard',
      provincie: 28,
      slug: 'krimpenerwaard',
    },
    { code: '1659', label: 'Laarbeek', provincie: 30, slug: 'laarbeek' },
    { code: '0882', label: 'Landgraaf', provincie: 31, slug: 'landgraaf' },
    { code: '0415', label: 'Landsmeer', provincie: 27, slug: 'landsmeer' },
    {
      code: '1980',
      label: 'Dijk en Waard',
      provincie: 27,
      slug: 'dijk-en-waard',
    },
    {
      code: '1621',
      label: 'Lansingerland',
      provincie: 28,
      slug: 'lansingerland',
    },
    { code: '0417', label: 'Laren', provincie: 27, slug: 'laren' },
    { code: '0080', label: 'Leeuwarden', provincie: 21, slug: 'leeuwarden' },
    { code: '0546', label: 'Leiden', provincie: 28, slug: 'leiden' },
    { code: '0547', label: 'Leiderdorp', provincie: 28, slug: 'leiderdorp' },
    {
      code: '1916',
      label: 'Leidschendam-Voorburg',
      provincie: 28,
      slug: 'leidschendam-voorburg',
    },
    { code: '0995', label: 'Lelystad', provincie: 24, slug: 'lelystad' },
    { code: '1640', label: 'Leudal', provincie: 31, slug: 'leudal' },
    { code: '0327', label: 'Leusden', provincie: 26, slug: 'leusden' },
    { code: '1705', label: 'Lingewaard', provincie: 25, slug: 'lingewaard' },
    { code: '0553', label: 'Lisse', provincie: 28, slug: 'lisse' },
    { code: '0262', label: 'Lochem', provincie: 25, slug: 'lochem' },
    {
      code: '0809',
      label: 'Loon op Zand',
      provincie: 30,
      slug: 'loon-op-zand',
    },
    { code: '0331', label: 'Lopik', provincie: 26, slug: 'lopik' },
    { code: '0168', label: 'Losser', provincie: 23, slug: 'losser' },
    { code: '0263', label: 'Maasdriel', provincie: 25, slug: 'maasdriel' },
    { code: '1641', label: 'Maasgouw', provincie: 31, slug: 'maasgouw' },
    { code: '0556', label: 'Maassluis', provincie: 28, slug: 'maassluis' },
    { code: '0935', label: 'Maastricht', provincie: 31, slug: 'maastricht' },
    { code: '0420', label: 'Medemblik', provincie: 27, slug: 'medemblik' },
    { code: '0938', label: 'Meerssen', provincie: 31, slug: 'meerssen' },
    {
      code: '1948',
      label: 'Meierijstad',
      provincie: 30,
      slug: 'meierijstad',
    },
    { code: '0119', label: 'Meppel', provincie: 22, slug: 'meppel' },
    { code: '0687', label: 'Middelburg', provincie: 29, slug: 'middelburg' },
    {
      code: '1842',
      label: 'Midden-Delfland',
      provincie: 28,
      slug: 'midden-delfland',
    },
    {
      code: '1731',
      label: 'Midden-Drenthe',
      provincie: 22,
      slug: 'midden-drenthe',
    },
    {
      code: '1952',
      label: 'Midden-Groningen',
      provincie: 20,
      slug: 'midden-groningen',
    },
    { code: '1709', label: 'Moerdijk', provincie: 30, slug: 'moerdijk' },
    {
      code: '1978',
      label: 'Molenlanden',
      provincie: 28,
      slug: 'molenlanden',
    },
    {
      code: '1955',
      label: 'Montferland',
      provincie: 25,
      slug: 'montferland',
    },
    { code: '0335', label: 'Montfoort', provincie: 26, slug: 'montfoort' },
    {
      code: '0944',
      label: 'Mook en Middelaar',
      provincie: 31,
      slug: 'mook-en-middelaar',
    },
    {
      code: '1740',
      label: 'Neder-Betuwe',
      provincie: 25,
      slug: 'neder-betuwe',
    },
    { code: '0946', label: 'Nederweert', provincie: 31, slug: 'nederweert' },
    { code: '0356', label: 'Nieuwegein', provincie: 26, slug: 'nieuwegein' },
    { code: '0569', label: 'Nieuwkoop', provincie: 28, slug: 'nieuwkoop' },
    { code: '0267', label: 'Nijkerk', provincie: 25, slug: 'nijkerk' },
    { code: '0268', label: 'Nijmegen', provincie: 25, slug: 'nijmegen' },
    { code: '1930', label: 'Nissewaard', provincie: 28, slug: 'nissewaard' },
    {
      code: '1970',
      label: 'Noardeast-Fryslân',
      provincie: 21,
      slug: 'noardeast-fryslan',
    },
    {
      code: '1695',
      label: 'Noord-Beveland',
      provincie: 29,
      slug: 'noord-beveland',
    },
    {
      code: '1699',
      label: 'Noordenveld',
      provincie: 22,
      slug: 'noordenveld',
    },
    {
      code: '0171',
      label: 'Noordoostpolder',
      provincie: 24,
      slug: 'noordoostpolder',
    },
    { code: '0575', label: 'Noordwijk', provincie: 28, slug: 'noordwijk' },
    {
      code: '0820',
      label: 'Nuenen, Gerwen en Nederwetten',
      provincie: 30,
      slug: 'nuenen-gerwen-en-nederwetten',
    },
    { code: '0302', label: 'Nunspeet', provincie: 25, slug: 'nunspeet' },
    { code: '0579', label: 'Oegstgeest', provincie: 28, slug: 'oegstgeest' },
    { code: '0823', label: 'Oirschot', provincie: 30, slug: 'oirschot' },
    { code: '0824', label: 'Oisterwijk', provincie: 30, slug: 'oisterwijk' },
    { code: '1895', label: 'Oldambt', provincie: 20, slug: 'oldambt' },
    { code: '0269', label: 'Oldebroek', provincie: 25, slug: 'oldebroek' },
    { code: '0173', label: 'Oldenzaal', provincie: 23, slug: 'oldenzaal' },
    { code: '1773', label: 'Olst-Wijhe', provincie: 23, slug: 'olst-wijhe' },
    { code: '0175', label: 'Ommen', provincie: 23, slug: 'ommen' },
    { code: '1586', label: 'Oost Gelre', provincie: 25, slug: 'oost-gelre' },
    { code: '0826', label: 'Oosterhout', provincie: 30, slug: 'oosterhout' },
    {
      code: '0085',
      label: 'Ooststellingwerf',
      provincie: 21,
      slug: 'ooststellingwerf',
    },
    { code: '0431', label: 'Oostzaan', provincie: 27, slug: 'oostzaan' },
    { code: '0432', label: 'Opmeer', provincie: 27, slug: 'opmeer' },
    { code: '0086', label: 'Opsterland', provincie: 21, slug: 'opsterland' },
    { code: '0828', label: 'Oss', provincie: 30, slug: 'oss' },
    {
      code: '1509',
      label: 'Oude IJsselstreek',
      provincie: 25,
      slug: 'oude-ijsselstreek',
    },
    {
      code: '0437',
      label: 'Ouder-Amstel',
      provincie: 27,
      slug: 'ouder-amstel',
    },
    { code: '0589', label: 'Oudewater', provincie: 26, slug: 'oudewater' },
    { code: '1734', label: 'Overbetuwe', provincie: 25, slug: 'overbetuwe' },
    {
      code: '0590',
      label: 'Papendrecht',
      provincie: 28,
      slug: 'papendrecht',
    },
    {
      code: '1894',
      label: 'Peel en Maas',
      provincie: 31,
      slug: 'peel-en-maas',
    },
    { code: '0765', label: 'Pekela', provincie: 20, slug: 'pekela' },
    {
      code: '1926',
      label: 'Pijnacker-Nootdorp',
      provincie: 28,
      slug: 'pijnacker-nootdorp',
    },
    { code: '0439', label: 'Purmerend', provincie: 27, slug: 'purmerend' },
    { code: '0273', label: 'Putten', provincie: 25, slug: 'putten' },
    { code: '0177', label: 'Raalte', provincie: 23, slug: 'raalte' },
    {
      code: '0703',
      label: 'Reimerswaal',
      provincie: 29,
      slug: 'reimerswaal',
    },
    { code: '0274', label: 'Renkum', provincie: 25, slug: 'renkum' },
    { code: '0339', label: 'Renswoude', provincie: 26, slug: 'renswoude' },
    {
      code: '1667',
      label: 'Reusel-De Mierden',
      provincie: 30,
      slug: 'reusel-de-mierden',
    },
    { code: '0275', label: 'Rheden', provincie: 25, slug: 'rheden' },
    { code: '0340', label: 'Rhenen', provincie: 26, slug: 'rhenen' },
    { code: '0597', label: 'Ridderkerk', provincie: 28, slug: 'ridderkerk' },
    {
      code: '1742',
      label: 'Rijssen-Holten',
      provincie: 23,
      slug: 'rijssen-holten',
    },
    { code: '0603', label: 'Rijswijk', provincie: 28, slug: 'rijswijk' },
    { code: '1669', label: 'Roerdalen', provincie: 31, slug: 'roerdalen' },
    { code: '0957', label: 'Roermond', provincie: 31, slug: 'roermond' },
    {
      code: '0736',
      label: 'De Ronde Venen',
      provincie: 26,
      slug: 'de-ronde-venen',
    },
    { code: '1674', label: 'Roosendaal', provincie: 30, slug: 'roosendaal' },
    { code: '0599', label: 'Rotterdam', provincie: 28, slug: 'rotterdam' },
    { code: '0277', label: 'Rozendaal', provincie: 25, slug: 'rozendaal' },
    { code: '0840', label: 'Rucphen', provincie: 30, slug: 'rucphen' },
    { code: '0441', label: 'Schagen', provincie: 27, slug: 'schagen' },
    {
      code: '0279',
      label: 'Scherpenzeel',
      provincie: 25,
      slug: 'scherpenzeel',
    },
    { code: '0606', label: 'Schiedam', provincie: 28, slug: 'schiedam' },
    {
      code: '0088',
      label: 'Schiermonnikoog',
      provincie: 21,
      slug: 'schiermonnikoog',
    },
    {
      code: '1676',
      label: 'Schouwen-Duiveland',
      provincie: 29,
      slug: 'schouwen-duiveland',
    },
    { code: '0965', label: 'Simpelveld', provincie: 31, slug: 'simpelveld' },
    {
      code: '0845',
      label: 'Sint-Michielsgestel',
      provincie: 30,
      slug: 'sint-michielsgestel',
    },
    {
      code: '1883',
      label: 'Sittard-Geleen',
      provincie: 31,
      slug: 'sittard-geleen',
    },
    { code: '0610', label: 'Sliedrecht', provincie: 28, slug: 'sliedrecht' },
    { code: '1714', label: 'Sluis', provincie: 29, slug: 'sluis' },
    {
      code: '0090',
      label: 'Smallingerland',
      provincie: 21,
      slug: 'smallingerland',
    },
    { code: '0342', label: 'Soest', provincie: 26, slug: 'soest' },
    { code: '0847', label: 'Someren', provincie: 30, slug: 'someren' },
    {
      code: '0848',
      label: 'Son en Breugel',
      provincie: 30,
      slug: 'son-en-breugel',
    },
    {
      code: '0037',
      label: 'Stadskanaal',
      provincie: 20,
      slug: 'stadskanaal',
    },
    { code: '0180', label: 'Staphorst', provincie: 23, slug: 'staphorst' },
    {
      code: '0532',
      label: 'Stede Broec',
      provincie: 27,
      slug: 'stede-broec',
    },
    {
      code: '0851',
      label: 'Steenbergen',
      provincie: 30,
      slug: 'steenbergen',
    },
    {
      code: '1708',
      label: 'Steenwijkerland',
      provincie: 23,
      slug: 'steenwijkerland',
    },
    { code: '0971', label: 'Stein', provincie: 31, slug: 'stein' },
    {
      code: '1904',
      label: 'Stichtse Vecht',
      provincie: 26,
      slug: 'stichtse-vecht',
    },
    {
      code: '1900',
      label: 'Súdwest-Fryslân',
      provincie: 21,
      slug: 'sudwest-fryslan',
    },
    { code: '0715', label: 'Terneuzen', provincie: 29, slug: 'terneuzen' },
    {
      code: '0093',
      label: 'Terschelling',
      provincie: 21,
      slug: 'terschelling',
    },
    { code: '0448', label: 'Texel', provincie: 27, slug: 'texel' },
    { code: '1525', label: 'Teylingen', provincie: 28, slug: 'teylingen' },
    { code: '0716', label: 'Tholen', provincie: 29, slug: 'tholen' },
    { code: '0281', label: 'Tiel', provincie: 25, slug: 'tiel' },
    { code: '0855', label: 'Tilburg', provincie: 30, slug: 'tilburg' },
    { code: '0183', label: 'Tubbergen', provincie: 23, slug: 'tubbergen' },
    { code: '1700', label: 'Twenterand', provincie: 23, slug: 'twenterand' },
    { code: '1730', label: 'Tynaarlo', provincie: 22, slug: 'tynaarlo' },
    {
      code: '0737',
      label: 'Tytsjerksteradiel',
      provincie: 21,
      slug: 'tytsjerksteradiel',
    },
    { code: '0450', label: 'Uitgeest', provincie: 27, slug: 'uitgeest' },
    { code: '0451', label: 'Uithoorn', provincie: 27, slug: 'uithoorn' },
    { code: '0184', label: 'Urk', provincie: 24, slug: 'urk' },
    { code: '0344', label: 'Utrecht', provincie: 26, slug: 'utrecht' },
    {
      code: '1581',
      label: 'Utrechtse Heuvelrug',
      provincie: 26,
      slug: 'utrechtse-heuvelrug',
    },
    { code: '0981', label: 'Vaals', provincie: 31, slug: 'vaals' },
    {
      code: '0994',
      label: 'Valkenburg aan de Geul',
      provincie: 31,
      slug: 'valkenburg-aan-de-geul',
    },
    {
      code: '0858',
      label: 'Valkenswaard',
      provincie: 30,
      slug: 'valkenswaard',
    },
    { code: '0047', label: 'Veendam', provincie: 20, slug: 'veendam' },
    { code: '0345', label: 'Veenendaal', provincie: 26, slug: 'veenendaal' },
    { code: '0717', label: 'Veere', provincie: 29, slug: 'veere' },
    { code: '0861', label: 'Veldhoven', provincie: 30, slug: 'veldhoven' },
    { code: '0453', label: 'Velsen', provincie: 27, slug: 'velsen' },
    { code: '0983', label: 'Venlo', provincie: 31, slug: 'venlo' },
    { code: '0984', label: 'Venray', provincie: 31, slug: 'venray' },
    {
      code: '1961',
      label: 'Vijfheerenlanden',
      provincie: 26,
      slug: 'vijfheerenlanden',
    },
    {
      code: '0622',
      label: 'Vlaardingen',
      provincie: 28,
      slug: 'vlaardingen',
    },
    { code: '0096', label: 'Vlieland', provincie: 21, slug: 'vlieland' },
    { code: '0718', label: 'Vlissingen', provincie: 29, slug: 'vlissingen' },
    { code: '0986', label: 'Voerendaal', provincie: 31, slug: 'voerendaal' },
    {
      code: '1992',
      label: 'Voorne aan Zee',
      provincie: 28,
      slug: 'voorne-aan-zee',
    },
    {
      code: '0626',
      label: 'Voorschoten',
      provincie: 28,
      slug: 'voorschoten',
    },
    { code: '0285', label: 'Voorst', provincie: 25, slug: 'voorst' },
    { code: '0865', label: 'Vught', provincie: 30, slug: 'vught' },
    { code: '1949', label: 'Waadhoeke', provincie: 21, slug: 'waadhoeke' },
    { code: '0866', label: 'Waalre', provincie: 30, slug: 'waalre' },
    { code: '0867', label: 'Waalwijk', provincie: 30, slug: 'waalwijk' },
    {
      code: '0627',
      label: 'Waddinxveen',
      provincie: 28,
      slug: 'waddinxveen',
    },
    { code: '0289', label: 'Wageningen', provincie: 25, slug: 'wageningen' },
    { code: '0629', label: 'Wassenaar', provincie: 28, slug: 'wassenaar' },
    { code: '0852', label: 'Waterland', provincie: 27, slug: 'waterland' },
    { code: '0988', label: 'Weert', provincie: 31, slug: 'weert' },
    { code: '0457', label: 'Weesp', provincie: 27, slug: 'weesp' },
    {
      code: '1960',
      label: 'West Betuwe',
      provincie: 25,
      slug: 'west-betuwe',
    },
    {
      code: '0668',
      label: 'West Maas en Waal',
      provincie: 25,
      slug: 'west-maas-en-waal',
    },
    {
      code: '1969',
      label: 'Westerkwartier',
      provincie: 20,
      slug: 'westerkwartier',
    },
    { code: '1701', label: 'Westerveld', provincie: 22, slug: 'westerveld' },
    {
      code: '0293',
      label: 'Westervoort',
      provincie: 25,
      slug: 'westervoort',
    },
    {
      code: '1950',
      label: 'Westerwolde',
      provincie: 20,
      slug: 'westerwolde',
    },
    { code: '1783', label: 'Westland', provincie: 28, slug: 'westland' },
    {
      code: '0098',
      label: 'Weststellingwerf',
      provincie: 21,
      slug: 'weststellingwerf',
    },
    { code: '0189', label: 'Wierden', provincie: 23, slug: 'wierden' },
    { code: '0296', label: 'Wijchen', provincie: 25, slug: 'wijchen' },
    { code: '1696', label: 'Wijdemeren', provincie: 27, slug: 'wijdemeren' },
    {
      code: '0352',
      label: 'Wijk bij Duurstede',
      provincie: 26,
      slug: 'wijk-bij-duurstede',
    },
    {
      code: '0294',
      label: 'Winterswijk',
      provincie: 25,
      slug: 'winterswijk',
    },
    {
      code: '0873',
      label: 'Woensdrecht',
      provincie: 30,
      slug: 'woensdrecht',
    },
    { code: '0632', label: 'Woerden', provincie: 26, slug: 'woerden' },
    { code: '1690', label: 'De Wolden', provincie: 22, slug: 'de-wolden' },
    { code: '0880', label: 'Wormerland', provincie: 27, slug: 'wormerland' },
    { code: '0351', label: 'Woudenberg', provincie: 26, slug: 'woudenberg' },
    { code: '0479', label: 'Zaanstad', provincie: 27, slug: 'zaanstad' },
    { code: '0297', label: 'Zaltbommel', provincie: 25, slug: 'zaltbommel' },
    { code: '0473', label: 'Zandvoort', provincie: 27, slug: 'zandvoort' },
    { code: '0050', label: 'Zeewolde', provincie: 24, slug: 'zeewolde' },
    { code: '0355', label: 'Zeist', provincie: 26, slug: 'zeist' },
    { code: '0299', label: 'Zevenaar', provincie: 25, slug: 'zevenaar' },
    { code: '0637', label: 'Zoetermeer', provincie: 28, slug: 'zoetermeer' },
    {
      code: '0638',
      label: 'Zoeterwoude',
      provincie: 28,
      slug: 'zoeterwoude',
    },
    { code: '1892', label: 'Zuidplas', provincie: 28, slug: 'zuidplas' },
    { code: '0879', label: 'Zundert', provincie: 30, slug: 'zundert' },
    { code: '0301', label: 'Zutphen', provincie: 25, slug: 'zutphen' },
    {
      code: '1896',
      label: 'Zwartewaterland',
      provincie: 23,
      slug: 'zwartewaterland',
    },
    {
      code: '0642',
      label: 'Zwijndrecht',
      provincie: 28,
      slug: 'zwijndrecht',
    },
    { code: '0193', label: 'Zwolle', provincie: 23, slug: 'zwolle' },
    {
      code: '1982',
      label: 'Land van Cuijk',
      provincie: 30,
      slug: 'land-van-cuijk',
      // proxy: ['1982', '1702', '0756'],
    },
    { code: '1991', label: 'Maashorst', provincie: 30, slug: 'maashorst' },

    // Gecombineerde gemeenten
    {
      code: '9001',
      label: 'Friese Waddeneilanden',
      provincie: 21,
      slug: 'friese-waddeneilanden',
      codeLabel: '9001 (0096, 0093, 0060, 0088)',
    },
    {
      code: '9002',
      label: 'ABG',
      provincie: 30,
      slug: 'abg',
      codeLabel: '9002 (1723, 0744, 0784)',
    },
    {
      code: '9003',
      label: 'kempen-gemeenten',
      provincie: 30,
      slug: 'kempen-gemeenten',
      codeLabel: '9003 (1724, 1728, 0770, 0823, 1667)',
    },
    {
      code: '9004',
      label: 'Boxtel en Sint-Michielsgestel',
      provincie: 30,
      slug: 'boxtel-en-sint-michielsgestel',
      codeLabel: '9004 (0757, 0845)',
    },
    // 9005 - 9016 = provincies
    {
      code: '9017',
      label: 'BAR gemeenten',
      provincie: 28,
      slug: 'bar-gemeenten',
      codeLabel: '9017 (0613, 0489, 0597)',
    },

    // Provincies - NOTE: Proxy access also has to be defined in functions/chargingpointsload
    {
      code: '9005',
      label: 'Provincie Flevoland',
      provincie: 24,
      slug: 'flevoland',
      proxy: ['0034', '0050', '0171', '0184', '0303', '0995'],
    },
    {
      code: '9006',
      label: 'Provincie Limburg',
      provincie: 31,
      slug: 'limburg',
      proxy: [
        '0888',
        '1954',
        '0889',
        '0893',
        '0899',
        '1711',
        '1903',
        '0907',
        '1729',
        '0917',
        '1507',
        '0928',
        '0882',
        '1640',
        '1641',
        '0935',
        '0938',
        '0944',
        '0946',
        '1894',
        '1669',
        '0957',
        '0965',
        '1883',
        '0971',
        '0981',
        '0994',
        '0983',
        '0984',
        '0986',
        '0988',
        '9006',
      ],
    },
    {
      code: '9007',
      label: 'Provincie Noord-Brabant',
      provincie: 30,
      slug: 'noord-brabant',
      proxy: [
        '1723',
        '1959',
        '0743',
        '0744',
        '1724',
        '0748',
        '1721',
        '0753',
        '1728',
        '0755',
        '0757',
        '0758',
        '1706',
        '0762',
        '0766',
        '1719',
        '0770',
        '0772',
        '0777',
        '0779',
        '1771',
        '1652',
        '0784',
        '0785',
        '0788',
        '1655',
        '1658',
        '0794',
        '0796',
        '0797',
        '0798',
        '1659',
        '0809',
        '1948',
        '1709',
        '0820',
        '0823',
        '0824',
        '0826',
        '0828',
        '1667',
        '1674',
        '0840',
        '0845',
        '0847',
        '0848',
        '0851',
        '0855',
        '0858',
        '0861',
        '0865',
        '0866',
        '0867',
        '0873',
        '0879',
        '1982',
        '1991',
        '9002',
        '9003',
        '9004',
        '9007',
      ],
    },
    {
      code: '9019',
      label: 'ZL-ZH gemeenten',
      provincie: 100,
      slug: 'zl-zh-gemeenten',
      proxy: [
        '0613',
        '0484',
        '0505',
        '1924',
        '0531',
        '0534',
        '1931',
        '1621',
        '1916',
        '0553',
        '0556',
        '1842',
        '0569',
        '0590',
        '0597',
        '0606',
        '0610',
        '1525',
        '0622',
        '0627',
        '1783',
        '0637',
        '0642',
        '1695',
        '1676',
        '1714',
      ],
    },
    {
      code: '9008',
      label: 'Provincie Drenthe',
      provincie: 22,
      slug: 'drenthe',
      proxy: [
        '0106', '0109', '0114', '0118', '0119', '1680', '1681', '1690', '1699', '1701', '1730', '1731',
      ],
    },
    {
      code: '9009',
      label: 'Provincie Gelderland',
      provincie: 25,
      slug: 'gelderland',
      proxy: [
        '0197', '0200', '0202', '0203', '0209', '0213', '0214', '0216', '0221', '0222', '0225', '0226', '0228', '0230', '0232', '0233', '0243', '0244', '0246', '0252', '0262', '0263', '0267', '0268', '0269', '0273', '0274', '0275', '0277', '0279', '0281', '0285', '0289', '0293', '0294', '0296', '0297', '0299', '0301', '0302', '0668', '1509', '1586', '1705', '1734', '1740', '1859', '1876', '1945', '1955', '1960',
      ],
    },
    {
      code: '9010',
      label: 'Provincie Noord-Holland',
      provincie: 27,
      slug: 'noord-holland',
      proxy: [
        '0358', '0361', '0362', '0373', '0375', '0376', '0377', '0383', '0384', '0385', '0388', '0392', '0394', '0396', '0397', '0399', '0400', '0402', '0405', '0406', '0415', '0417', '0420', '0431', '0432', '0437', '0439', '0441', '0448', '0450', '0451', '0453', '0473', '0479', '0498', '0532', '0852', '0880', '1598', '1696', '1911', '1942', '1980',
      ],
    },
    {
      code: '9011',
      label: 'Provincie Utrecht',
      provincie: 26,
      slug: 'provincie-utrecht',
      proxy: [
        '0307', '0308', '0310', '0312', '0313', '0317', '0321', '0327', '0331', '0335', '0339', '0340', '0342', '0345', '0351', '0352', '0353', '0355', '0356', '0589', '0632', '0736', '1581', '1904', '1961',
      ],
    },
    {
      code: '9012',
      label: 'Provincie Overijssel',
      provincie: 23,
      slug: 'overijssel',
      proxy: [
        '0141', '0147', '0148', '0150', '0153', '0158', '0160', '0163', '0164', '0166', '0168', '0173', '0175', '0177', '0180', '0183', '0189', '0193', '1700', '1708', '1735', '1742', '1773', '1774', '1896',
      ],
    },
    {
      code: '9013',
      label: 'Provincie Zeeland',
      provincie: 29,
      slug: 'zeeland',
      proxy: [
        '0654', '0664', '0677', '0678', '0687', '0703', '0715', '0716', '0717', '0718', '1676', '1695', '1714',
      ],
    },
    {
      code: '9014',
      label: 'Provincie Zuid-Holland',
      provincie: 28,
      slug: 'zuid-holland',
      proxy: [
        '0482', '0484', '0489', '0501', '0502', '0503', '0505', '0512', '0513', '0518', '0523', '0530', '0531', '0534', '0537', '0542', '0546', '0547', '0553', '0556', '0569', '0575', '0579', '0590', '0597', '0599', '0603', '0606', '0610', '0613', '0614', '0622', '0626', '0627', '0629', '0637', '0638', '0642', '1525', '1621', '1783', '1842', '1884', '1892', '1901', '1916', '1924', '1926', '1930', '1931', '1963', '1978',
      ],
    },
    {
      code: '9015',
      label: 'Provincie Friesland',
      provincie: 21,
      slug: 'friesland',
      proxy: [
        '0059', '0060', '0072', '0074', '0080', '0085', '0086', '0088', '0090', '0093', '0096', '0098', '0737', '1891', '1900', '1940', '1949', '1970',
      ],
    },
    {
      code: '9016',
      label: 'Provincie Groningen',
      provincie: 20,
      slug: 'groningen',
      proxy: [
        '0014', '0037', '0047', '0765', '1895', '1950', '1952', '1966', '1969', '1979',
      ],
    },
    {
      code: '9020',
      label: 'Zeeland (ZH-ZL)',
      provincie: 29,
      slug: 'zeeland-zhzl',
      proxy: ["0654", "0664", "0677", "0678", "0687", "1695", "0703", "1676", "1714", "0715", "0716", "0717", "0718"]
    },
    {
      code: '9021',
      label: 'Drechtsteden',
      provincie: 28,
      slug: 'drechtsteden',
      proxy: ['0482', '0505', '0523', '0531', '0590', '0610', '0642']

    },
    {
      code: '9022',
      label: 'Midden-Holland',
      provincie: 28,
      slug: 'midden-holland',
      proxy: ['1901', '0513', '1931', '0627', '1892']
    },
    {
      code: '9023',
      label: 'MRDH',
      provincie: 28,
      slug: 'mrdh',
      proxy: ['0613', '0489', '0502', '0503', '0542', '1621', '1916', '0556', '1842', '1930', '1926', '0597', '0603', '0606', '0622', '1992', '0629', '1783', '0637']
    },
    {
      code: '9024',
      label: 'Holland-Rijnland',
      provincie: 28,
      slug: 'holland-rijnland',
      proxy: ["0484", "0534", "0553", "1525", "1884", "0537", "0546", "0547", "0569", "0575", "0579", "0626", "0638"]

    },

    // Reserved codes for Workflow
    // { code: "9018", label: 'Intern - EVnetNL', provincie: 0, slug: 'intern-evnetnl' }, // Reserved for PARKnCHARGE

    // Deprecated
    {
      code: '0756',
      label: 'Boxmeer',
      slug: 'boxmeer',
      provincie: 0,
      deprecated: true,
    },
    {
      code: '1702',
      label: 'Sint Anthonis',
      slug: 'sint-anthonis',
      provincie: 0,
      deprecated: true,
    },
    {
      code: '1685',
      label: 'Landerd',
      slug: 'landerd',
      provincie: 0,
      deprecated: true,
    },
    {
      code: '0856',
      label: 'Uden',
      slug: 'uden',
      provincie: 0,
      deprecated: true,
    },
    {
      code: '0398',
      label: 'Heerhugowaard',
      slug: 'heerhugowaard',
      provincie: 0,
      deprecated: true,
    },
    {
      code: '0416',
      label: 'Langedijk',
      slug: 'langedijk',
      provincie: 0,
      deprecated: true,
    },
    {
      code: '0370',
      label: 'Beemster',
      slug: 'beemster',
      provincie: 0,
      deprecated: true,
    },
    {
      code: '9000',
      label: 'CMG Gemeenten',
      slug: 'cmg-gemeenten',
      provincie: 0,
      deprecated: true,
    },
  ],
  be: [
    {
      code: '83034',
      label: 'Marche-en-Famenne',
      provincie: 0,
      slug: 'marche-en-famenne',
    },
    { code: '23027', label: 'Halle', provincie: 0, slug: 'halle' },
    { code: '91103', label: 'Onhaye', provincie: 0, slug: 'onhaye' },
    { code: '91034', label: 'Dinant', provincie: 0, slug: 'dinant' },
    { code: '82037', label: 'Gouvy', provincie: 0, slug: 'gouvy' },
    { code: '91072', label: 'Houyet', provincie: 0, slug: 'houyet' },
    { code: '91142', label: 'Hastière', provincie: 0, slug: 'hastiere' },
    { code: '82014', label: 'Houffalize', provincie: 0, slug: 'houffalize' },
    {
      code: '56029',
      label: 'Froidchapelle',
      provincie: 0,
      slug: 'froidchapelle',
    },
    { code: '91114', label: 'Rochefort', provincie: 0, slug: 'rochefort' },
    {
      code: '93010',
      label: 'Cerfontaine',
      provincie: 0,
      slug: 'cerfontaine',
    },
    {
      code: '83031',
      label: 'La Roche-en-Ardenne',
      provincie: 0,
      slug: 'la-roche-en-ardenne',
    },
    {
      code: '56088',
      label: 'Sivry-Rance',
      provincie: 0,
      slug: 'sivry-rance',
    },
    { code: '93018', label: 'Doische', provincie: 0, slug: 'doische' },
    { code: '91013', label: 'Beauraing', provincie: 0, slug: 'beauraing' },
    { code: '93014', label: 'Couvin', provincie: 0, slug: 'couvin' },
    { code: '56016', label: 'Chimay', provincie: 0, slug: 'chimay' },
    { code: '84075', label: 'Wellin', provincie: 0, slug: 'wellin' },
    { code: '93090', label: 'Viroinval', provincie: 0, slug: 'viroinval' },
    {
      code: '84059',
      label: 'Saint-Hubert',
      provincie: 0,
      slug: 'saint-hubert',
    },
    { code: '91054', label: 'Gedinne', provincie: 0, slug: 'gedinne' },
    {
      code: '84077',
      label: 'Libramont-Chevigny',
      provincie: 0,
      slug: 'libramont-chevigny',
    },
    {
      code: '82036',
      label: 'Vaux-sur-Sûre',
      provincie: 0,
      slug: 'vaux-sur-sure',
    },
    { code: '82009', label: 'Fauvillers', provincie: 0, slug: 'fauvillers' },
    { code: '84009', label: 'Bertrix', provincie: 0, slug: 'bertrix' },
    {
      code: '91143',
      label: 'Vresse-sur-Semois',
      provincie: 0,
      slug: 'vresse-sur-semois',
    },
    {
      code: '84043',
      label: 'Neufchâteau',
      provincie: 0,
      slug: 'neufchateau',
    },
    { code: '84033', label: 'Léglise', provincie: 0, slug: 'leglise' },
    { code: '84010', label: 'Bouillon', provincie: 0, slug: 'bouillon' },
    { code: '81013', label: 'Martelange', provincie: 0, slug: 'martelange' },
    { code: '84029', label: 'Herbeumont', provincie: 0, slug: 'herbeumont' },
    { code: '81003', label: 'Attert', provincie: 0, slug: 'attert' },
    { code: '85007', label: 'Chiny', provincie: 0, slug: 'chiny' },
    { code: '85046', label: 'Habay', provincie: 0, slug: 'habay' },
    { code: '85039', label: 'Tintigny', provincie: 0, slug: 'tintigny' },
    { code: '81001', label: 'Arlon', provincie: 0, slug: 'arlon' },
    {
      code: '85034',
      label: 'Saint-Léger',
      provincie: 0,
      slug: 'saint-leger',
    },
    { code: '85045', label: 'Virton', provincie: 0, slug: 'virton' },
    { code: '85047', label: 'Rouvroy', provincie: 0, slug: 'rouvroy' },
    { code: '21009', label: 'Elsene', provincie: 0, slug: 'elsene' },
    {
      code: '21014',
      label: 'Sint-Joost-ten-Node',
      provincie: 0,
      slug: 'sint-joost-ten-node',
    },
    {
      code: '21017',
      label: 'Watermaal-Bosvoorde',
      provincie: 0,
      slug: 'watermaal-bosvoorde',
    },
    {
      code: '21012',
      label: 'Sint-Jans-Molenbeek',
      provincie: 0,
      slug: 'sint-jans-molenbeek',
    },
    {
      code: '21013',
      label: 'Sint-Gillis',
      provincie: 0,
      slug: 'sint-gillis',
    },
    {
      code: '21019',
      label: 'Sint-Pieters-Woluwe',
      provincie: 0,
      slug: 'sint-pieters-woluwe',
    },
    {
      code: '21018',
      label: 'Sint-Lambrechts-Woluwe',
      provincie: 0,
      slug: 'sint-lambrechts-woluwe',
    },
    { code: '41034', label: 'Lede', provincie: 0, slug: 'lede' },
    {
      code: '71024',
      label: 'Herk-de-Stad',
      provincie: 0,
      slug: 'herk-de-stad',
    },
    { code: '84050', label: 'Paliseul', provincie: 0, slug: 'paliseul' },
    {
      code: '46021',
      label: 'Sint-Niklaas',
      provincie: 0,
      slug: 'sint-niklaas',
    },
    { code: '72030', label: 'Peer', provincie: 0, slug: 'peer' },
    { code: '12007', label: 'Bornem', provincie: 0, slug: 'bornem' },
    { code: '42008', label: 'Hamme', provincie: 0, slug: 'hamme' },
    { code: '36008', label: 'Izegem', provincie: 0, slug: 'izegem' },
    {
      code: '36007',
      label: 'Ingelmunster',
      provincie: 0,
      slug: 'ingelmunster',
    },
    { code: '23047', label: 'Machelen', provincie: 0, slug: 'machelen' },
    { code: '23094', label: 'Zaventem', provincie: 0, slug: 'zaventem' },
    { code: '71017', label: 'Gingelom', provincie: 0, slug: 'gingelom' },
    { code: '57018', label: 'Celles', provincie: 0, slug: 'celles' },
    { code: '63003', label: 'Aubel', provincie: 0, slug: 'aubel' },
    { code: '64029', label: 'Geer', provincie: 0, slug: 'geer' },
    {
      code: '62118',
      label: 'Grâce-Hollogne',
      provincie: 0,
      slug: 'grace-hollogne',
    },
    { code: '63012', label: 'Bullange', provincie: 0, slug: 'bullange' },
    {
      code: '13014',
      label: 'Hoogstraten',
      provincie: 0,
      slug: 'hoogstraten',
    },
    { code: '13035', label: 'Ravels', provincie: 0, slug: 'ravels' },
    { code: '11016', label: 'Essen', provincie: 0, slug: 'essen' },
    {
      code: '13002',
      label: 'Baarle-Hertog',
      provincie: 0,
      slug: 'baarle-hertog',
    },
    { code: '11053', label: 'Wuustwezel', provincie: 0, slug: 'wuustwezel' },
    { code: '13023', label: 'Merksplas', provincie: 0, slug: 'merksplas' },
    {
      code: '13037',
      label: 'Rijkevorsel',
      provincie: 0,
      slug: 'rijkevorsel',
    },
    { code: '11002', label: 'Antwerpen', provincie: 0, slug: 'antwerpen' },
    {
      code: '31043',
      label: 'Knokke-Heist',
      provincie: 0,
      slug: 'knokke-heist',
    },
    {
      code: '13031',
      label: 'Oud-Turnhout',
      provincie: 0,
      slug: 'oud-turnhout',
    },
    //  { code: '46003', label: 'Beveren', provincie: 0, slug: 'beveren' },
    { code: '46030', label: 'Beveren-Kruibeke-Zwijndrecht', provincie: 0, slug: 'beveren-kruibeke-zwijndrecht' },
    {
      code: '31004',
      label: 'Blankenberge',
      provincie: 0,
      slug: 'blankenberge',
    },
    { code: '11057', label: 'Malle', provincie: 0, slug: 'malle' },
    { code: '13025', label: 'Mol', provincie: 0, slug: 'mol' },
    { code: '31006', label: 'Damme', provincie: 0, slug: 'damme' },
    {
      code: '72037',
      label: 'Hamont-Achel',
      provincie: 0,
      slug: 'hamont-achel',
    },
    { code: '11040', label: 'Schoten', provincie: 0, slug: 'schoten' },
    { code: '13036', label: 'Retie', provincie: 0, slug: 'retie' },
    { code: '13017', label: 'Kasterlee', provincie: 0, slug: 'kasterlee' },
    { code: '61041', label: 'Modave', provincie: 0, slug: 'modave' },
    { code: '52011', label: 'Charleroi', provincie: 0, slug: 'charleroi' },
    { code: '72020', label: 'Lommel', provincie: 0, slug: 'lommel' },
    { code: '13006', label: 'Dessel', provincie: 0, slug: 'dessel' },
    { code: '35002', label: 'Bredene', provincie: 0, slug: 'bredene' },
    // { code: '11056', label: 'Zwijndrecht', provincie: 0, slug: 'zwijndrecht' },
    { code: '13044', label: 'Vorselaar', provincie: 0, slug: 'vorselaar' },
    { code: '46024', label: 'Stekene', provincie: 0, slug: 'stekene' },
    { code: '13003', label: 'Balen', provincie: 0, slug: 'balen' },
    { code: '35005', label: 'Gistel', provincie: 0, slug: 'gistel' },
    { code: '13001', label: 'Arendonk', provincie: 0, slug: 'arendonk' },
    { code: '43010', label: 'Maldegem', provincie: 0, slug: 'maldegem' },
    { code: '31012', label: 'Jabbeke', provincie: 0, slug: 'jabbeke' },
    { code: '11050', label: 'Wijnegem', provincie: 0, slug: 'wijnegem' },
    { code: '11035', label: 'Ranst', provincie: 0, slug: 'ranst' },
    { code: '35014', label: 'Oudenburg', provincie: 0, slug: 'oudenburg' },
    { code: '72003', label: 'Bocholt', provincie: 0, slug: 'bocholt' },
    // { code: '44045', label: 'Moerbeke', provincie: 0, slug: 'moerbeke' },
    { code: '43005', label: 'Eeklo', provincie: 0, slug: 'eeklo' },
    { code: '43018', label: 'Zelzate', provincie: 0, slug: 'zelzate' },
    { code: '44019', label: 'Evergem', provincie: 0, slug: 'evergem' },
    // { code: '46013', label: 'Kruibeke', provincie: 0, slug: 'kruibeke' },
    { code: '11004', label: 'Boechout', provincie: 0, slug: 'boechout' },
    { code: '11029', label: 'Mortsel', provincie: 0, slug: 'mortsel' },
    {
      code: '72038',
      label: 'Hechtel-Eksel',
      provincie: 0,
      slug: 'hechtel-eksel',
    },
    { code: '46025', label: 'Temse', provincie: 0, slug: 'temse' },
    { code: '38016', label: 'Nieuwpoort', provincie: 0, slug: 'nieuwpoort' },
    { code: '13012', label: 'Herenthout', provincie: 0, slug: 'herenthout' },
    { code: '11018', label: 'Hemiksem', provincie: 0, slug: 'hemiksem' },
    { code: '38014', label: 'Koksijde', provincie: 0, slug: 'koksijde' },
    {
      code: '71034',
      label: 'Leopoldsburg',
      provincie: 0,
      slug: 'leopoldsburg',
    },
    // { code: '71069', label: 'Ham', provincie: 0, slug: 'ham' },
    { code: '32010', label: 'Koekelare', provincie: 0, slug: 'koekelare' },
    { code: '11038', label: 'Schelle', provincie: 0, slug: 'schelle' },
    { code: '32003', label: 'Diksmuide', provincie: 0, slug: 'diksmuide' },
    { code: '11037', label: 'Rumst', provincie: 0, slug: 'rumst' },
    {
      code: '85011',
      label: 'Florenville',
      provincie: 0,
      slug: 'florenville',
    },
    { code: '85009', label: 'Étalle', provincie: 0, slug: 'etalle' },
    {
      code: '85024',
      label: 'Meix-devant-Virton',
      provincie: 0,
      slug: 'meix-devant-virton',
    },
    { code: '21015', label: 'Schaarbeek', provincie: 0, slug: 'schaarbeek' },
    { code: '21016', label: 'Ukkel', provincie: 0, slug: 'ukkel' },
    { code: '21007', label: 'Vorst', provincie: 0, slug: 'vorst' },
    { code: '12009', label: 'Duffel', provincie: 0, slug: 'duffel' },
    { code: '71004', label: 'Beringen', provincie: 0, slug: 'beringen' },
    {
      code: '72039',
      label: 'Houthalen-Helchteren',
      provincie: 0,
      slug: 'houthalen-helchteren',
    },
    // { code: '37012', label: 'Ruiselede', provincie: 0, slug: 'ruiselede' },
    { code: '13013', label: 'Herselt', provincie: 0, slug: 'herselt' },
    {
      code: '12035',
      label: 'Sint-Katelijne-Waver',
      provincie: 0,
      slug: 'sint-katelijne-waver',
    },
    { code: '12029', label: 'Putte', provincie: 0, slug: 'putte' },
    { code: '42010', label: 'Laarne', provincie: 0, slug: 'laarne' },
    {
      code: '36011',
      label: 'Lichtervelde',
      provincie: 0,
      slug: 'lichtervelde',
    },
    {
      code: '42006',
      label: 'Dendermonde',
      provincie: 0,
      slug: 'dendermonde',
    },
    { code: '38002', label: 'Alveringem', provincie: 0, slug: 'alveringem' },
    { code: '71037', label: 'Lummen', provincie: 0, slug: 'lummen' },
    {
      code: '21003',
      label: 'Sint-Agatha-Berchem',
      provincie: 0,
      slug: 'sint-agatha-berchem',
    },
    { code: '35006', label: 'Ichtegem', provincie: 0, slug: 'ichtegem' },
    { code: '11021', label: 'Hove', provincie: 0, slug: 'hove' },
    { code: '13021', label: 'Meerhout', provincie: 0, slug: 'meerhout' },
    { code: '11001', label: 'Aartselaar', provincie: 0, slug: 'aartselaar' },
    { code: '44087', label: 'Lochristi', provincie: 0, slug: 'lochristi' },
    { code: '41027', label: 'Herzele', provincie: 0, slug: 'herzele' },
    { code: '41024', label: 'Haaltert', provincie: 0, slug: 'haaltert' },
    { code: '73001', label: 'Alken', provincie: 0, slug: 'alken' },
    { code: '34025', label: 'Lendelede', provincie: 0, slug: 'lendelede' },
    { code: '24137', label: 'Glabbeek', provincie: 0, slug: 'glabbeek' },
    // { code: '73032', label: 'Hoeselt', provincie: 0, slug: 'hoeselt' },
    { code: '23016', label: 'Dilbeek', provincie: 0, slug: 'dilbeek' },
    {
      code: '45061',
      label: 'Wortegem-Petegem',
      provincie: 0,
      slug: 'wortegem-petegem',
    },
    { code: '24130', label: 'Zoutleeuw', provincie: 0, slug: 'zoutleeuw' },
    { code: '21008', label: 'Ganshoren', provincie: 0, slug: 'ganshoren' },
    { code: '34022', label: 'Kortrijk', provincie: 0, slug: 'kortrijk' },
    { code: '24016', label: 'Boutersem', provincie: 0, slug: 'boutersem' },
    { code: '41048', label: 'Ninove', provincie: 0, slug: 'ninove' },
    { code: '34002', label: 'Anzegem', provincie: 0, slug: 'anzegem' },
    { code: '13049', label: 'Westerlo', provincie: 0, slug: 'westerlo' },
    { code: '12002', label: 'Berlaar', provincie: 0, slug: 'berlaar' },
    {
      code: '12014',
      label: 'Heist-op-den-Berg',
      provincie: 0,
      slug: 'heist-op-den-berg',
    },
    { code: '38008', label: 'De Panne', provincie: 0, slug: 'de-panne' },
    { code: '13053', label: 'Laakdal', provincie: 0, slug: 'laakdal' },
    { code: '31033', label: 'Torhout', provincie: 0, slug: 'torhout' },
    { code: '24107', label: 'Tienen', provincie: 0, slug: 'tienen' },
    { code: '33029', label: 'Wervik', provincie: 0, slug: 'wervik' },
    { code: '21001', label: 'Anderlecht', provincie: 0, slug: 'anderlecht' },
    { code: '73066', label: 'Riemst', provincie: 0, slug: 'riemst' },
    { code: '21005', label: 'Etterbeek', provincie: 0, slug: 'etterbeek' },
    { code: '23104', label: 'Lennik', provincie: 0, slug: 'lennik' },
    { code: '34027', label: 'Menen', provincie: 0, slug: 'menen' },
    {
      code: '41018',
      label: 'Geraardsbergen',
      provincie: 0,
      slug: 'geraardsbergen',
    },
    {
      code: '23077',
      label: 'Sint-Pieters-Leeuw',
      provincie: 0,
      slug: 'sint-pieters-leeuw',
    },
    { code: '34003', label: 'Avelgem', provincie: 0, slug: 'avelgem' },
    { code: '62011', label: 'Bassenge', provincie: 0, slug: 'bassenge' },
    {
      code: '45060',
      label: 'Kluisbergen',
      provincie: 0,
      slug: 'kluisbergen',
    },
    { code: '23098', label: 'Drogenbos', provincie: 0, slug: 'drogenbos' },
    {
      code: '25005',
      label: 'Beauvechain',
      provincie: 0,
      slug: 'beauvechain',
    },
    { code: '24059', label: 'Landen', provincie: 0, slug: 'landen' },
    { code: '31005', label: 'Brugge', provincie: 0, slug: 'brugge' },
    { code: '11008', label: 'Brasschaat', provincie: 0, slug: 'brasschaat' },
    { code: '13046', label: 'Vosselaar', provincie: 0, slug: 'vosselaar' },
    { code: '13019', label: 'Lille', provincie: 0, slug: 'lille' },
    { code: '31042', label: 'Zuienkerke', provincie: 0, slug: 'zuienkerke' },
    { code: '11054', label: 'Zandhoven', provincie: 0, slug: 'zandhoven' },
    { code: '11024', label: 'Kontich', provincie: 0, slug: 'kontich' },
    { code: '35029', label: 'De Haan', provincie: 0, slug: 'de-haan' },
    {
      code: '43014',
      label: 'Sint-Laureins',
      provincie: 0,
      slug: 'sint-laureins',
    },
    { code: '45041', label: 'Ronse', provincie: 0, slug: 'ronse' },
    { code: '23033', label: 'Hoeilaart', provincie: 0, slug: 'hoeilaart' },
    { code: '23003', label: 'Beersel', provincie: 0, slug: 'beersel' },
    { code: '51017', label: 'Ellezelles', provincie: 0, slug: 'ellezelles' },
    {
      code: '23101',
      label: 'Sint-Genesius-Rode',
      provincie: 0,
      slug: 'sint-genesius-rode',
    },
    { code: '25118', label: 'Hélécine', provincie: 0, slug: 'helecine' },
    {
      code: '63040',
      label: 'La Calamine',
      provincie: 0,
      slug: 'la-calamine',
    },
    { code: '62027', label: 'Dalhem', provincie: 0, slug: 'dalhem' },
    // { code: '23032', label: 'Herne', provincie: 0, slug: 'herne' },
    { code: '62060', label: 'Juprelle', provincie: 0, slug: 'juprelle' },
    { code: '64047', label: 'Lincent', provincie: 0, slug: 'lincent' },
    { code: '64056', label: 'Oreye', provincie: 0, slug: 'oreye' },
    { code: '62006', label: 'Awans', provincie: 0, slug: 'awans' },
    {
      code: '51065',
      label: 'Frasnes-lez-Anvaing',
      provincie: 0,
      slug: 'frasnes-lez-anvaing',
    },
    {
      code: '25014',
      label: 'Braine-l\'Alleud',
      provincie: 0,
      slug: 'braine-lalleud',
    },
    { code: '43002', label: 'Assenede', provincie: 0, slug: 'assenede' },
    // { code: '44073', label: 'Wachtebeke', provincie: 0, slug: 'wachtebeke' },
    {
      code: '35011',
      label: 'Middelkerke',
      provincie: 0,
      slug: 'middelkerke',
    },
    { code: '64074', label: 'Waremme', provincie: 0, slug: 'waremme' },
    { code: '57062', label: 'Pecq', provincie: 0, slug: 'pecq' },
    { code: '25119', label: 'Lasne', provincie: 0, slug: 'lasne' },
    { code: '64034', label: 'Hannut', provincie: 0, slug: 'hannut' },
    {
      code: '63084',
      label: 'Welkenraedt',
      provincie: 0,
      slug: 'welkenraedt',
    },
    { code: '62051', label: 'Herstal', provincie: 0, slug: 'herstal' },
    { code: '64063', label: 'Remicourt', provincie: 0, slug: 'remicourt' },
    {
      code: '64025',
      label: 'Fexhe-le-Haut-Clocher',
      provincie: 0,
      slug: 'fexhe-le-haut-clocher',
    },
    { code: '63023', label: 'Eupen', provincie: 0, slug: 'eupen' },
    { code: '25084', label: 'Perwez', provincie: 0, slug: 'perwez' },
    { code: '62099', label: 'Soumagne', provincie: 0, slug: 'soumagne' },
    {
      code: '24134',
      label: 'Scherpenheuvel-Zichem',
      provincie: 0,
      slug: 'scherpenheuvel-zichem',
    },
    { code: '21011', label: 'Koekelberg', provincie: 0, slug: 'koekelberg' },
    { code: '21002', label: 'Oudergem', provincie: 0, slug: 'oudergem' },
    {
      code: '13010',
      label: 'Grobbendonk',
      provincie: 0,
      slug: 'grobbendonk',
    },
    { code: '25124', label: 'Walhain', provincie: 0, slug: 'walhain' },
    {
      code: '25068',
      label: 'Mont-Saint-Guibert',
      provincie: 0,
      slug: 'mont-saint-guibert',
    },
    { code: '11007', label: 'Borsbeek', provincie: 0, slug: 'borsbeek' },
    { code: '13029', label: 'Olen', provincie: 0, slug: 'olen' },
    { code: '44084', label: 'Aalter', provincie: 0, slug: 'aalter' },
    {
      code: '12041',
      label: 'Puurs-Sint-Amands',
      provincie: 0,
      slug: 'puurs-sint-amands',
    },
    { code: '51067', label: 'Edingen', provincie: 0, slug: 'edingen' },
    { code: '51068', label: 'Silly', provincie: 0, slug: 'silly' },
    { code: '72018', label: 'Kinrooi', provincie: 0, slug: 'kinrooi' },
    { code: '44021', label: 'Gent', provincie: 0, slug: 'gent' },
    { code: '62038', label: 'Fléron', provincie: 0, slug: 'fleron' },
    { code: '44085', label: 'Lievegem', provincie: 0, slug: 'lievegem' },
    { code: '72042', label: 'Oudsbergen', provincie: 0, slug: 'oudsbergen' },
    { code: '72043', label: 'Pelt', provincie: 0, slug: 'pelt' },
    { code: '12026', label: 'Nijlen', provincie: 0, slug: 'nijlen' },
    { code: '31040', label: 'Zedelgem', provincie: 0, slug: 'zedelgem' },
    { code: '42004', label: 'Buggenhout', provincie: 0, slug: 'buggenhout' },
    { code: '37011', label: 'Pittem', provincie: 0, slug: 'pittem' },
    { code: '56005', label: 'Beaumont', provincie: 0, slug: 'beaumont' },
    { code: '24001', label: 'Aarschot', provincie: 0, slug: 'aarschot' },
    {
      code: '23039',
      label: 'Kapelle-op-den-Bos',
      provincie: 0,
      slug: 'kapelle-op-den-bos',
    },
    // { code: '44043', label: 'Merelbeke', provincie: 0, slug: 'merelbeke' },
    { code: '44088', label: 'Merelbeke-Melle', provincie: 0, slug: 'merelbeke-melle' },
    { code: '32030', label: 'Lo-Reninge', provincie: 0, slug: 'lo-reninge' },
    { code: '71016', label: 'Genk', provincie: 0, slug: 'genk' },
    { code: '24048', label: 'Keerbergen', provincie: 0, slug: 'keerbergen' },
    {
      code: '73107',
      label: 'Maasmechelen',
      provincie: 0,
      slug: 'maasmechelen',
    },
    { code: '23096', label: 'Zemst', provincie: 0, slug: 'zemst' },
    { code: '23050', label: 'Meise', provincie: 0, slug: 'meise' },
    {
      code: '24014',
      label: 'Boortmeerbeek',
      provincie: 0,
      slug: 'boortmeerbeek',
    },
    { code: '36015', label: 'Roeselare', provincie: 0, slug: 'roeselare' },
    { code: '24033', label: 'Haacht', provincie: 0, slug: 'haacht' },
    { code: '23060', label: 'Opwijk', provincie: 0, slug: 'opwijk' },
    { code: '83040', label: 'Nassogne', provincie: 0, slug: 'nassogne' },
    { code: '83049', label: 'Tenneville', provincie: 0, slug: 'tenneville' },
    { code: '82039', label: 'Bastogne', provincie: 0, slug: 'bastogne' },
    // { code: '82005', label: 'Bertogne', provincie: 0, slug: 'bertogne' },
    { code: '84068', label: 'Tellin', provincie: 0, slug: 'tellin' },
    { code: '82038', label: 'Sainte-Ode', provincie: 0, slug: 'sainte-ode' },
    { code: '37002', label: 'Dentergem', provincie: 0, slug: 'dentergem' },
    // { code: '37007', label: 'Meulebeke', provincie: 0, slug: 'meulebeke' },
    { code: '24008', label: 'Bekkevoort', provincie: 0, slug: 'bekkevoort' },
    {
      code: '37010',
      label: 'Oostrozebeke',
      provincie: 0,
      slug: 'oostrozebeke',
    },
    {
      code: '33040',
      label: 'Langemark-Poelkapelle',
      provincie: 0,
      slug: 'langemark-poelkapelle',
    },
    {
      code: '24135',
      label: 'Tielt-Winge',
      provincie: 0,
      slug: 'tielt-winge',
    },
    {
      code: '23081',
      label: 'Steenokkerzeel',
      provincie: 0,
      slug: 'steenokkerzeel',
    },
    { code: '41082', label: 'Erpe-Mere', provincie: 0, slug: 'erpe-mere' },
    { code: '73042', label: 'Lanaken', provincie: 0, slug: 'lanaken' },
    { code: '33021', label: 'Poperinge', provincie: 0, slug: 'poperinge' },
    { code: '23002', label: 'Asse', provincie: 0, slug: 'asse' },
    { code: '24062', label: 'Leuven', provincie: 0, slug: 'leuven' },
    { code: '36012', label: 'Moorslede', provincie: 0, slug: 'moorslede' },
    { code: '23105', label: 'Affligem', provincie: 0, slug: 'affligem' },
    { code: '24028', label: 'Geetbets', provincie: 0, slug: 'geetbets' },
    { code: '84016', label: 'Daverdisse', provincie: 0, slug: 'daverdisse' },
    {
      code: '71045',
      label: 'Nieuwerkerken',
      provincie: 0,
      slug: 'nieuwerkerken',
    },
    { code: '23044', label: 'Liedekerke', provincie: 0, slug: 'liedekerke' },
    {
      code: '34043',
      label: 'Spiere-Helkijn',
      provincie: 0,
      slug: 'spiere-helkijn',
    },
    { code: '62119', label: 'Blegny', provincie: 0, slug: 'blegny' },
    { code: '57081', label: 'Tournai', provincie: 0, slug: 'tournai' },
    { code: '61081', label: 'Tinlot', provincie: 0, slug: 'tinlot' },
    {
      code: '52010',
      label: 'Chapelle-lez-Herlaimont',
      provincie: 0,
      slug: 'chapelle-lez-herlaimont',
    },
    { code: '92097', label: 'Ohey', provincie: 0, slug: 'ohey' },
    { code: '61024', label: 'Hamoir', provincie: 0, slug: 'hamoir' },
    { code: '61012', label: 'Clavier', provincie: 0, slug: 'clavier' },
    { code: '53065', label: 'Quaregnon', provincie: 0, slug: 'quaregnon' },
    { code: '52018', label: 'Farciennes', provincie: 0, slug: 'farciennes' },
    { code: '52012', label: 'Châtelet', provincie: 0, slug: 'chatelet' },
    { code: '83012', label: 'Durbuy', provincie: 0, slug: 'durbuy' },
    {
      code: '92048',
      label: 'Fosses-la-Ville',
      provincie: 0,
      slug: 'fosses-la-ville',
    },
    { code: '53020', label: 'Dour', provincie: 0, slug: 'dour' },
    { code: '91064', label: 'Havelange', provincie: 0, slug: 'havelange' },
    { code: '63001', label: 'Amblève', provincie: 0, slug: 'ambleve' },
    { code: '53084', label: 'Quévy', provincie: 0, slug: 'quevy' },
    { code: '53083', label: 'Honnelles', provincie: 0, slug: 'honnelles' },
    { code: '63088', label: 'Plombières', provincie: 0, slug: 'plombieres' },
    { code: '25112', label: 'Wavre', provincie: 0, slug: 'wavre' },
    { code: '62079', label: 'Oupeye', provincie: 0, slug: 'oupeye' },
    { code: '25050', label: 'La Hulpe', provincie: 0, slug: 'la-hulpe' },
    { code: '51069', label: 'Lessines', provincie: 0, slug: 'lessines' },
    { code: '25091', label: 'Rixensart', provincie: 0, slug: 'rixensart' },
    { code: '92087', label: 'Mettet', provincie: 0, slug: 'mettet' },
    { code: '52025', label: 'Gerpinnes', provincie: 0, slug: 'gerpinnes' },
    { code: '56078', label: 'Thuin', provincie: 0, slug: 'thuin' },
    { code: '91141', label: 'Yvoir', provincie: 0, slug: 'yvoir' },
    { code: '63067', label: 'Saint-Vith', provincie: 0, slug: 'saint-vith' },
    { code: '91005', label: 'Anhée', provincie: 0, slug: 'anhee' },
    { code: '82032', label: 'Vielsalm', provincie: 0, slug: 'vielsalm' },
    {
      code: '56022',
      label: 'Erquelinnes',
      provincie: 0,
      slug: 'erquelinnes',
    },
    { code: '83013', label: 'Érezée', provincie: 0, slug: 'erezee' },
    { code: '93088', label: 'Walcourt', provincie: 0, slug: 'walcourt' },
    { code: '83028', label: 'Hotton', provincie: 0, slug: 'hotton' },
    { code: '93022', label: 'Florennes', provincie: 0, slug: 'florennes' },
    { code: '61019', label: 'Ferrières', provincie: 0, slug: 'ferrieres' },
    { code: '53028', label: 'Frameries', provincie: 0, slug: 'frameries' },
    { code: '83055', label: 'Manhay', provincie: 0, slug: 'manhay' },
    { code: '11044', label: 'Stabroek', provincie: 0, slug: 'stabroek' },
    { code: '35013', label: 'Oostende', provincie: 0, slug: 'oostende' },
    { code: '72021', label: 'Maaseik', provincie: 0, slug: 'maaseik' },
    { code: '44083', label: 'Deinze', provincie: 0, slug: 'deinze' },
    { code: '24055', label: 'Kortenberg', provincie: 0, slug: 'kortenberg' },
    { code: '34041', label: 'Wevelgem', provincie: 0, slug: 'wevelgem' },
    { code: '25120', label: 'Orp-Jauche', provincie: 0, slug: 'orp-jauche' },
    // { code: '73083', label: 'Tongeren', provincie: 0, slug: 'tongeren' },
    {
      code: '73111',
      label: 'Tongeren-Borgloon',
      provincie: 0,
      slug: 'tongeren-borgloon',
    },
    { code: '57096', label: 'Moeskroen', provincie: 0, slug: 'moeskroen' },
    { code: '64008', label: 'Berloz', provincie: 0, slug: 'berloz' },
    { code: '63004', label: 'Baelen', provincie: 0, slug: 'baelen' },
    { code: '64015', label: 'Braives', provincie: 0, slug: 'braives' },
    { code: '61003', label: 'Amay', provincie: 0, slug: 'amay' },
    { code: '61079', label: 'Anthisnes', provincie: 0, slug: 'anthisnes' },
    {
      code: '53082',
      label: 'Colfontaine',
      provincie: 0,
      slug: 'colfontaine',
    },
    { code: '91030', label: 'Ciney', provincie: 0, slug: 'ciney' },
    { code: '21004', label: 'Brussel', provincie: 0, slug: 'brussel' },
    { code: '12021', label: 'Lier', provincie: 0, slug: 'lier' },
    { code: '63061', label: 'Raeren', provincie: 0, slug: 'raeren' },
    { code: '11022', label: 'Kalmthout', provincie: 0, slug: 'kalmthout' },
    { code: '13004', label: 'Beerse', provincie: 0, slug: 'beerse' },
    { code: '13008', label: 'Geel', provincie: 0, slug: 'geel' },
    { code: '37021', label: 'Wingene', provincie: 0, slug: 'wingene' },
    { code: '42003', label: 'Berlare', provincie: 0, slug: 'berlare' },
    { code: '71066', label: 'Zonhoven', provincie: 0, slug: 'zonhoven' },
    { code: '45068', label: 'Kruisem', provincie: 0, slug: 'kruisem' },
    { code: '21010', label: 'Jette', provincie: 0, slug: 'jette' },
    { code: '34042', label: 'Zwevegem', provincie: 0, slug: 'zwevegem' },
    { code: '73022', label: 'Heers', provincie: 0, slug: 'heers' },
    { code: '73028', label: 'Herstappe', provincie: 0, slug: 'herstappe' },
    { code: '64076', label: 'Faimes', provincie: 0, slug: 'faimes' },
    { code: '55085', label: 'Seneffe', provincie: 0, slug: 'seneffe' },
    { code: '52015', label: 'Courcelles', provincie: 0, slug: 'courcelles' },
    { code: '56001', label: 'Anderlues', provincie: 0, slug: 'anderlues' },
    { code: '63045', label: 'Lierneux', provincie: 0, slug: 'lierneux' },
    { code: '85026', label: 'Musson', provincie: 0, slug: 'musson' },
    { code: '11009', label: 'Brecht', provincie: 0, slug: 'brecht' },
    { code: '11052', label: 'Wommelgem', provincie: 0, slug: 'wommelgem' },
    {
      code: '44013',
      label: 'Destelbergen',
      provincie: 0,
      slug: 'destelbergen',
    },
    { code: '41002', label: 'Aalst', provincie: 0, slug: 'aalst' },
    { code: '24066', label: 'Lubbeek', provincie: 0, slug: 'lubbeek' },
    { code: '45064', label: 'Maarkedal', provincie: 0, slug: 'maarkedal' },
    { code: '25110', label: 'Waterloo', provincie: 0, slug: 'waterloo' },
    { code: '23009', label: 'Bever', provincie: 0, slug: 'bever' },
    { code: '62003', label: 'Ans', provincie: 0, slug: 'ans' },
    { code: '57027', label: 'Estaimpuis', provincie: 0, slug: 'estaimpuis' },
    {
      code: '25018',
      label: 'Chaumont-Gistoux',
      provincie: 0,
      slug: 'chaumont-gistoux',
    },
    { code: '25123', label: 'Rebecq', provincie: 0, slug: 'rebecq' },
    { code: '64021', label: 'Crisnée', provincie: 0, slug: 'crisnee' },
    { code: '63020', label: 'Dison', provincie: 0, slug: 'dison' },
    { code: '61031', label: 'Huy', provincie: 0, slug: 'huy' },
    {
      code: '91120',
      label: 'Somme-Leuze',
      provincie: 0,
      slug: 'somme-leuze',
    },
    { code: '56051', label: 'Momignies', provincie: 0, slug: 'momignies' },
    { code: '11025', label: 'Lint', provincie: 0, slug: 'lint' },
    { code: '13040', label: 'Turnhout', provincie: 0, slug: 'turnhout' },
    { code: '13011', label: 'Herentals', provincie: 0, slug: 'herentals' },
    { code: '11030', label: 'Niel', provincie: 0, slug: 'niel' },
    // { code: '44040', label: 'Melle', provincie: 0, slug: 'melle' },
    { code: '24038', label: 'Herent', provincie: 0, slug: 'herent' },
    { code: '24009', label: 'Bertem', provincie: 0, slug: 'bertem' },
    { code: '62108', label: 'Visé', provincie: 0, slug: 'vise' },
    { code: '25105', label: 'Tubize', provincie: 0, slug: 'tubize' },
    {
      code: '57094',
      label: 'Leuze-en-Hainaut',
      provincie: 0,
      slug: 'leuze-en-hainaut',
    },
    { code: '63035', label: 'Herve', provincie: 0, slug: 'herve' },
    {
      code: '63089',
      label: 'Thimister-Clermont',
      provincie: 0,
      slug: 'thimister-clermont',
    },
    { code: '25122', label: 'Ramillies', provincie: 0, slug: 'ramillies' },
    {
      code: '25121',
      label: 'Ottignies-Louvain-la-Neuve',
      provincie: 0,
      slug: 'ottignies-louvain-la-neuve',
    },
    { code: '62063', label: 'Liège', provincie: 0, slug: 'liege' },
    { code: '64023', label: 'Donceel', provincie: 0, slug: 'donceel' },
    {
      code: '25023',
      label: 'Court-Saint-Étienne',
      provincie: 0,
      slug: 'court-saint-etienne',
    },
    {
      code: '62093',
      label: 'Saint-Nicolas',
      provincie: 0,
      slug: 'saint-nicolas',
    },
    { code: '92035', label: 'Éghezée', provincie: 0, slug: 'eghezee' },
    { code: '61063', label: 'Verlaine', provincie: 0, slug: 'verlaine' },
    { code: '63079', label: 'Verviers', provincie: 0, slug: 'verviers' },
    { code: '25072', label: 'Nivelles', provincie: 0, slug: 'nivelles' },
    { code: '62120', label: 'Flémalle', provincie: 0, slug: 'flemalle' },
    {
      code: '61068',
      label: 'Villers-le-Bouillet',
      provincie: 0,
      slug: 'villers-le-bouillet',
    },
    { code: '92138', label: 'Fernelmont', provincie: 0, slug: 'fernelmont' },
    { code: '53046', label: 'Lens', provincie: 0, slug: 'lens' },
    { code: '63058', label: 'Pepinster', provincie: 0, slug: 'pepinster' },
    { code: '92142', label: 'Gembloux', provincie: 0, slug: 'gembloux' },
    { code: '63038', label: 'Jalhay', provincie: 0, slug: 'jalhay' },
    {
      code: '25107',
      label: 'Villers-la-Ville',
      provincie: 0,
      slug: 'villers-la-ville',
    },
    { code: '62032', label: 'Esneux', provincie: 0, slug: 'esneux' },
    {
      code: '55004',
      label: 'Braine-le-Comte',
      provincie: 0,
      slug: 'braine-le-comte',
    },
    { code: '63046', label: 'Limbourg', provincie: 0, slug: 'limbourg' },
    { code: '25031', label: 'Genappe', provincie: 0, slug: 'genappe' },
    { code: '23045', label: 'Londerzeel', provincie: 0, slug: 'londerzeel' },
    {
      code: '24007',
      label: 'Begijnendijk',
      provincie: 0,
      slug: 'begijnendijk',
    },
    { code: '37020', label: 'Ardooie', provincie: 0, slug: 'ardooie' },
    { code: '63080', label: 'Waimes', provincie: 0, slug: 'waimes' },
    { code: '57064', label: 'Péruwelz', provincie: 0, slug: 'peruwelz' },
    { code: '63076', label: 'Theux', provincie: 0, slug: 'theux' },
    { code: '62121', label: 'Neupré', provincie: 0, slug: 'neupre' },
    { code: '57093', label: 'Brunehaut', provincie: 0, slug: 'brunehaut' },
    {
      code: '52055',
      label: 'Pont-à-Celles',
      provincie: 0,
      slug: 'pont-a-celles',
    },
    { code: '53044', label: 'Jurbise', provincie: 0, slug: 'jurbise' },
    { code: '55035', label: 'Le Rœulx', provincie: 0, slug: 'le-roeulx' },
    { code: '52021', label: 'Fleurus', provincie: 0, slug: 'fleurus' },
    { code: '92003', label: 'Andenne', provincie: 0, slug: 'andenne' },
    { code: '62009', label: 'Aywaille', provincie: 0, slug: 'aywaille' },
    {
      code: '58001',
      label: 'La Louvière',
      provincie: 0,
      slug: 'la-louviere',
    },
    { code: '63072', label: 'Spa', provincie: 0, slug: 'spa' },
    { code: '51009', label: 'Bernissart', provincie: 0, slug: 'bernissart' },
    {
      code: '92140',
      label: 'Jemeppe-sur-Sambre',
      provincie: 0,
      slug: 'jemeppe-sur-sambre',
    },
    { code: '42025', label: 'Wetteren', provincie: 0, slug: 'wetteren' },
    { code: '24109', label: 'Tremelo', provincie: 0, slug: 'tremelo' },
    { code: '36006', label: 'Hooglede', provincie: 0, slug: 'hooglede' },
    { code: '42011', label: 'Lebbeke', provincie: 0, slug: 'lebbeke' },
    { code: '32006', label: 'Houthulst', provincie: 0, slug: 'houthulst' },
    { code: '36019', label: 'Staden', provincie: 0, slug: 'staden' },
    { code: '63049', label: 'Malmedy', provincie: 0, slug: 'malmedy' },
    { code: '53014', label: 'Boussu', provincie: 0, slug: 'boussu' },
    { code: '83044', label: 'Rendeux', provincie: 0, slug: 'rendeux' },
    { code: '81004', label: 'Aubange', provincie: 0, slug: 'aubange' },
    { code: '11023', label: 'Kapellen', provincie: 0, slug: 'kapellen' },
    { code: '43007', label: 'Kaprijke', provincie: 0, slug: 'kaprijke' },
    // { code: '44012', label: 'De Pinte', provincie: 0, slug: 'de-pinte' },
    { code: '34013', label: 'Harelbeke', provincie: 0, slug: 'harelbeke' },
    { code: '73109', label: 'Voeren', provincie: 0, slug: 'voeren' },
    { code: '25043', label: 'Incourt', provincie: 0, slug: 'incourt' },
    {
      code: '62022',
      label: 'Chaudfontaine',
      provincie: 0,
      slug: 'chaudfontaine',
    },
    {
      code: '92137',
      label: 'Sambreville',
      provincie: 0,
      slug: 'sambreville',
    },
    {
      code: '46020',
      label: 'Sint-Gillis-Waas',
      provincie: 0,
      slug: 'sint-gillis-waas',
    },
    { code: '71020', label: 'Halen', provincie: 0, slug: 'halen' },
    { code: '23052', label: 'Merchtem', provincie: 0, slug: 'merchtem' },
    { code: '23025', label: 'Grimbergen', provincie: 0, slug: 'grimbergen' },
    { code: '44081', label: 'Zulte', provincie: 0, slug: 'zulte' },
    { code: '71067', label: 'Zutendaal', provincie: 0, slug: 'zutendaal' },
    { code: '44052', label: 'Oosterzele', provincie: 0, slug: 'oosterzele' },
    { code: '23038', label: 'Kampenhout', provincie: 0, slug: 'kampenhout' },
    { code: '33041', label: 'Vleteren', provincie: 0, slug: 'vleteren' },
    { code: '24043', label: 'Holsbeek', provincie: 0, slug: 'holsbeek' },
    { code: '44020', label: 'Gavere', provincie: 0, slug: 'gavere' },
    { code: '71011', label: 'Diepenbeek', provincie: 0, slug: 'diepenbeek' },
    { code: '37017', label: 'Wielsbeke', provincie: 0, slug: 'wielsbeke' },
    { code: '33011', label: 'Ieper', provincie: 0, slug: 'ieper' },
    { code: '33037', label: 'Zonnebeke', provincie: 0, slug: 'zonnebeke' },
    { code: '24054', label: 'Kortenaken', provincie: 0, slug: 'kortenaken' },
    { code: '23102', label: 'Wemmel', provincie: 0, slug: 'wemmel' },
    { code: '41081', label: 'Zottegem', provincie: 0, slug: 'zottegem' },
    { code: '63073', label: 'Stavelot', provincie: 0, slug: 'stavelot' },
    { code: '61048', label: 'Ouffet', provincie: 0, slug: 'ouffet' },
    { code: '63075', label: 'Stoumont', provincie: 0, slug: 'stoumont' },
    { code: '53039', label: 'Hensies', provincie: 0, slug: 'hensies' },
    { code: '92054', label: 'Gesves', provincie: 0, slug: 'gesves' },
    {
      code: '52022',
      label: 'Fontaine-l\'Évêque',
      provincie: 0,
      slug: 'fontaine-leveque',
    },
    {
      code: '52074',
      label: 'Aiseau-Presles',
      provincie: 0,
      slug: 'aiseau-presles',
    },
    { code: '58003', label: 'Estinnes', provincie: 0, slug: 'estinnes' },
    { code: '53068', label: 'Quiévrain', provincie: 0, slug: 'quievrain' },
    { code: '92006', label: 'Assesse', provincie: 0, slug: 'assesse' },
    {
      code: '92101',
      label: 'Profondeville',
      provincie: 0,
      slug: 'profondeville',
    },
    {
      code: '63086',
      label: 'Trois-Ponts',
      provincie: 0,
      slug: 'trois-ponts',
    },
    { code: '91059', label: 'Hamois', provincie: 0, slug: 'hamois' },
    { code: '58002', label: 'Binche', provincie: 0, slug: 'binche' },
    {
      code: '52048',
      label: 'Montigny-le-Tilleul',
      provincie: 0,
      slug: 'montigny-le-tilleul',
    },
    {
      code: '56086',
      label: 'Ham-sur-Heure-Nalinnes',
      provincie: 0,
      slug: 'ham-sur-heure-nalinnes',
    },
    { code: '31022', label: 'Oostkamp', provincie: 0, slug: 'oostkamp' },
    { code: '13016', label: 'Hulshout', provincie: 0, slug: 'hulshout' },
    { code: '24094', label: 'Rotselaar', provincie: 0, slug: 'rotselaar' },
    { code: '34023', label: 'Kuurne', provincie: 0, slug: 'kuurne' },
    { code: '31003', label: 'Beernem', provincie: 0, slug: 'beernem' },
    {
      code: '42023',
      label: 'Waasmunster',
      provincie: 0,
      slug: 'waasmunster',
    },
    {
      code: '44064',
      label: 'Sint-Martens-Latem',
      provincie: 0,
      slug: 'sint-martens-latem',
    },
    { code: '71072', label: 'Hasselt', provincie: 0, slug: 'hasselt' },
    { code: '73110', label: 'Bilzen-Hoeselt', provincie: 0, slug: 'bilzen-hoeselt' },
    {
      code: '23103',
      label: 'Wezembeek-Oppem',
      provincie: 0,
      slug: 'wezembeek-oppem',
    },
    { code: '33016', label: 'Mesen', provincie: 0, slug: 'mesen' },
    { code: '63048', label: 'Lontzen', provincie: 0, slug: 'lontzen' },
    { code: '55040', label: 'Soignies', provincie: 0, slug: 'soignies' },
    {
      code: '52075',
      label: 'Les Bons Villers',
      provincie: 0,
      slug: 'les-bons-villers',
    },
    { code: '58004', label: 'Morlanwelz', provincie: 0, slug: 'morlanwelz' },
    {
      code: '93056',
      label: 'Philippeville',
      provincie: 0,
      slug: 'philippeville',
    },
    { code: '11055', label: 'Zoersel', provincie: 0, slug: 'zoersel' },
    { code: '11013', label: 'Edegem', provincie: 0, slug: 'edegem' },
    { code: '42026', label: 'Wichelen', provincie: 0, slug: 'wichelen' },
    {
      code: '41063',
      label: 'Sint-Lievens-Houtem',
      provincie: 0,
      slug: 'sint-lievens-houtem',
    },
    { code: '24133', label: 'Linter', provincie: 0, slug: 'linter' },
    {
      code: '25015',
      label: 'Braine-le-Château',
      provincie: 0,
      slug: 'braine-le-chateau',
    },
    {
      code: '55050',
      label: 'Écaussinnes',
      provincie: 0,
      slug: 'ecaussinnes',
    },
    { code: '92045', label: 'Floreffe', provincie: 0, slug: 'floreffe' },
    {
      code: '63087',
      label: 'Burg-Reuland',
      provincie: 0,
      slug: 'burg-reuland',
    },
    { code: '81015', label: 'Messancy', provincie: 0, slug: 'messancy' },
    { code: '11039', label: 'Schilde', provincie: 0, slug: 'schilde' },
    { code: '46029', label: 'Lokeren', provincie: 0, slug: 'lokeren' },
    { code: '12040', label: 'Willebroek', provincie: 0, slug: 'willebroek' },
    { code: '44046', label: 'Nazareth-De Pinte', provincie: 0, slug: 'nazareth-de-pinte' },
    { code: '34009', label: 'Deerlijk', provincie: 0, slug: 'deerlijk' },
    { code: '25048', label: 'Jodoigne', provincie: 0, slug: 'jodoigne' },
    { code: '25044', label: 'Ittre', provincie: 0, slug: 'ittre' },
    { code: '57003', label: 'Antoing', provincie: 0, slug: 'antoing' },
    {
      code: '62015',
      label: 'Beyne-Heusay',
      provincie: 0,
      slug: 'beyne-heusay',
    },
    { code: '64075', label: 'Wasseiges', provincie: 0, slug: 'wasseiges' },
    {
      code: '64065',
      label: 'Saint-Georges-sur-Meuse',
      provincie: 0,
      slug: 'saint-georges-sur-meuse',
    },
    { code: '51012', label: 'Brugelette', provincie: 0, slug: 'brugelette' },
    { code: '62096', label: 'Seraing', provincie: 0, slug: 'seraing' },
    { code: '25117', label: 'Chastre', provincie: 0, slug: 'chastre' },
    { code: '63057', label: 'Olne', provincie: 0, slug: 'olne' },
    { code: '51014', label: 'Chièvres', provincie: 0, slug: 'chievres' },
    { code: '61010', label: 'Burdinne', provincie: 0, slug: 'burdinne' },
    { code: '62122', label: 'Trooz', provincie: 0, slug: 'trooz' },
    { code: '61080', label: 'Engis', provincie: 0, slug: 'engis' },
    { code: '61072', label: 'Wanze', provincie: 0, slug: 'wanze' },
    { code: '51008', label: 'Belœil', provincie: 0, slug: 'beloeil' },
    { code: '61028', label: 'Héron', provincie: 0, slug: 'heron' },
    { code: '57072', label: 'Rumes', provincie: 0, slug: 'rumes' },
    { code: '92141', label: 'La Bruyère', provincie: 0, slug: 'la-bruyere' },
    { code: '62100', label: 'Sprimont', provincie: 0, slug: 'sprimont' },
    { code: '61043', label: 'Nandrin', provincie: 0, slug: 'nandrin' },
    {
      code: '53070',
      label: 'Saint-Ghislain',
      provincie: 0,
      slug: 'saint-ghislain',
    },
    { code: '63013', label: 'Butgenbach', provincie: 0, slug: 'butgenbach' },
    { code: '92094', label: 'Namur', provincie: 0, slug: 'namur' },
    { code: '55086', label: 'Manage', provincie: 0, slug: 'manage' },
    {
      code: '62026',
      label: 'Comblain-au-Pont',
      provincie: 0,
      slug: 'comblain-au-pont',
    },
    { code: '53053', label: 'Mons', provincie: 0, slug: 'mons' },
    { code: '61039', label: 'Marchin', provincie: 0, slug: 'marchin' },
    {
      code: '56049',
      label: 'Merbes-le-Château',
      provincie: 0,
      slug: 'merbes-le-chateau',
    },
    { code: '84035', label: 'Libin', provincie: 0, slug: 'libin' },
    { code: '37022', label: 'Tielt', provincie: 0, slug: 'tielt' },
    { code: '23088', label: 'Vilvoorde', provincie: 0, slug: 'vilvoorde' },
    {
      code: '24086',
      label: 'Oud-Heverlee',
      provincie: 0,
      slug: 'oud-heverlee',
    },
    { code: '51004', label: 'Ath', provincie: 0, slug: 'ath' },
    { code: '92114', label: 'Sombreffe', provincie: 0, slug: 'sombreffe' },
    { code: '56044', label: 'Lobbes', provincie: 0, slug: 'lobbes' },
    { code: '91015', label: 'Bièvre', provincie: 0, slug: 'bievre' },
    { code: '38025', label: 'Veurne', provincie: 0, slug: 'veurne' },
    { code: '11005', label: 'Boom', provincie: 0, slug: 'boom' },
    { code: '42028', label: 'Zele', provincie: 0, slug: 'zele' },
    {
      code: '72041',
      label: 'Dilsen-Stokkem',
      provincie: 0,
      slug: 'dilsen-stokkem',
    },
    { code: '72004', label: 'Bree', provincie: 0, slug: 'bree' },
    { code: '71071', label: 'Tessenderlo-Ham', provincie: 0, slug: 'tessenderlo-ham' },
    { code: '12025', label: 'Mechelen', provincie: 0, slug: 'mechelen' },
    { code: '32011', label: 'Kortemark', provincie: 0, slug: 'kortemark' },
    {
      code: '71070',
      label: 'Heusden-Zolder',
      provincie: 0,
      slug: 'heusden-zolder',
    },
    { code: '24020', label: 'Diest', provincie: 0, slug: 'diest' },
    { code: '12005', label: 'Bonheiden', provincie: 0, slug: 'bonheiden' },
    { code: '71002', label: 'As', provincie: 0, slug: 'as' },
    { code: '34040', label: 'Waregem', provincie: 0, slug: 'waregem' },
    { code: '45065', label: 'Zwalm', provincie: 0, slug: 'zwalm' },
    {
      code: '41011',
      label: 'Denderleeuw',
      provincie: 0,
      slug: 'denderleeuw',
    },
    { code: '45035', label: 'Oudenaarde', provincie: 0, slug: 'oudenaarde' },
    { code: '36010', label: 'Ledegem', provincie: 0, slug: 'ledegem' },
    { code: '23086', label: 'Ternat', provincie: 0, slug: 'ternat' },
    // { code: '73040', label: 'Kortessem', provincie: 0, slug: 'kortessem' },
    { code: '21006', label: 'Evere', provincie: 0, slug: 'evere' },
    {
      code: '71053',
      label: 'Sint-Truiden',
      provincie: 0,
      slug: 'sint-truiden',
    },
    { code: '24011', label: 'Bierbeek', provincie: 0, slug: 'bierbeek' },
    { code: '73098', label: 'Wellen', provincie: 0, slug: 'wellen' },
    { code: '24104', label: 'Tervuren', provincie: 0, slug: 'tervuren' },
    { code: '23099', label: 'Kraainem', provincie: 0, slug: 'kraainem' },
    { code: '45062', label: 'Horebeke', provincie: 0, slug: 'horebeke' },
    { code: '23097', label: 'Roosdaal', provincie: 0, slug: 'roosdaal' },
    //  { code: '73009', label: 'Borgloon', provincie: 0, slug: 'borgloon' },
    { code: '45059', label: 'Brakel', provincie: 0, slug: 'brakel' },
    { code: '45063', label: 'Lierde', provincie: 0, slug: 'lierde' },
    { code: '33039', label: 'Heuvelland', provincie: 0, slug: 'heuvelland' },
    { code: '24045', label: 'Huldenberg', provincie: 0, slug: 'huldenberg' },
    {
      code: '57097',
      label: 'Komen-Waasten',
      provincie: 0,
      slug: 'komen-waasten',
    },
    //  { code: '23024', label: 'Gooik', provincie: 0, slug: 'gooik' },
    { code: '24041', label: 'Hoegaarden', provincie: 0, slug: 'hoegaarden' },
    { code: '23062', label: 'Overijse', provincie: 0, slug: 'overijse' },
    {
      code: '25037',
      label: 'Grez-Doiceau',
      provincie: 0,
      slug: 'grez-doiceau',
    },
    { code: '23064', label: 'Pepingen', provincie: 0, slug: 'pepingen' },
    { code: '51019', label: 'Vloesberg', provincie: 0, slug: 'vloesberg' },
    // { code: '23023', label: 'Galmaarden', provincie: 0, slug: 'galmaarden' },
    { code: '23100', label: 'Linkebeek', provincie: 0, slug: 'linkebeek' },
    { code: '23106', label: 'Pajottegem', provincie: 0, slug: 'pajottegem' },
    {
      code: '57095',
      label: 'Mont-de-l\'Enclus',
      provincie: 0,
      slug: 'mont-de-lenclus',
    },
    {
      code: '02000',
      label: 'Vlaams Gewest',
      provincie: 0,
      slug: 'vlaams-gewest',
      proxy: vlaamsGewest,
    },
  ],
  uk: [
    {
      code: 'E06000060',
      label: 'Buckinghamshire',
      provincie: 1000,
      slug: 'buckinghamshire',
    },
    {
      code: 'E06000064',
      label: 'Westmorland and Furness',
      provincie: 1000,
      slug: 'westmorland-and-furness',
    },
    {
      code: 'E06000059',
      label: 'Dorset',
      provincie: 1000,
      slug: 'dorset',
    },
    {
      code: 'E06000062',
      label: 'West Northamptonshire',
      provincie: 1000,
      slug: 'west-northamptonshire',
    },
    {
      code: 'E08000038',
      label: 'Barnsley District (B)',
      provincie: 1000,
      slug: 'barnsley-district-b',
    },
    {
      code: 'E08000025',
      label: 'Birmingham District (B)',
      provincie: 1000,
      slug: 'birmingham-district-b',
    },
    {
      code: 'E08000001',
      label: 'Bolton District (B)',
      provincie: 1000,
      slug: 'bolton-district-b',
    },
    {
      code: 'E08000032',
      label: 'Bradford District (B)',
      provincie: 1000,
      slug: 'bradford-district-b',
    },
    {
      code: 'E08000002',
      label: 'Bury District (B)',
      provincie: 1000,
      slug: 'bury-district-b',
    },
    {
      code: 'E08000033',
      label: 'Calderdale District (B)',
      provincie: 1000,
      slug: 'calderdale-district-b',
    },
    {
      code: 'E08000031',
      label: 'City of Wolverhampton District (B)',
      provincie: 1000,
      slug: 'city-of-wolverhampton-district-b',
    },
    {
      code: 'E08000026',
      label: 'Coventry District (B)',
      provincie: 1000,
      slug: 'coventry-district-b',
    },
    {
      code: 'E08000017',
      label: 'Doncaster District (B)',
      provincie: 1000,
      slug: 'doncaster-district-b',
    },
    {
      code: 'E08000027',
      label: 'Dudley District (B)',
      provincie: 1000,
      slug: 'dudley-district-b',
    },
    {
      code: 'E08000037',
      label: 'Gateshead District (B)',
      provincie: 1000,
      slug: 'gateshead-district-b',
    },
    {
      code: 'E08000034',
      label: 'Kirklees District (B)',
      provincie: 1000,
      slug: 'kirklees-district-b',
    },
    {
      code: 'E08000011',
      label: 'Knowsley District (B)',
      provincie: 1000,
      slug: 'knowsley-district-b',
    },
    {
      code: 'E08000035',
      label: 'Leeds District (B)',
      provincie: 1000,
      slug: 'leeds-district-b',
    },
    {
      code: 'E08000012',
      label: 'Liverpool District (B)',
      provincie: 1000,
      slug: 'liverpool-district-b',
    },
    {
      code: 'E08000003',
      label: 'Manchester District (B)',
      provincie: 1000,
      slug: 'manchester-district-b',
    },
    {
      code: 'E08000021',
      label: 'Newcastle upon Tyne District (B)',
      provincie: 1000,
      slug: 'newcastle-upon-tyne-district-b',
    },
    {
      code: 'E08000022',
      label: 'North Tyneside District (B)',
      provincie: 1000,
      slug: 'north-tyneside-district-b',
    },
    {
      code: 'E08000004',
      label: 'Oldham District (B)',
      provincie: 1000,
      slug: 'oldham-district-b',
    },
    {
      code: 'E08000005',
      label: 'Rochdale District (B)',
      provincie: 1000,
      slug: 'rochdale-district-b',
    },
    {
      code: 'E08000018',
      label: 'Rotherham District (B)',
      provincie: 1000,
      slug: 'rotherham-district-b',
    },
    {
      code: 'E08000006',
      label: 'Salford District (B)',
      provincie: 1000,
      slug: 'salford-district-b',
    },
    {
      code: 'E08000028',
      label: 'Sandwell District (B)',
      provincie: 1000,
      slug: 'sandwell-district-b',
    },
    {
      code: 'E08000014',
      label: 'Sefton District (B)',
      provincie: 1000,
      slug: 'sefton-district-b',
    },
    {
      code: 'E08000039',
      label: 'Sheffield District (B)',
      provincie: 1000,
      slug: 'sheffield-district-b',
    },
    {
      code: 'E08000029',
      label: 'Solihull District (B)',
      provincie: 1000,
      slug: 'solihull-district-b',
    },
    {
      code: 'E08000023',
      label: 'South Tyneside District (B)',
      provincie: 1000,
      slug: 'south-tyneside-district-b',
    },
    {
      code: 'E08000007',
      label: 'Stockport District (B)',
      provincie: 1000,
      slug: 'stockport-district-b',
    },
    {
      code: 'E08000013',
      label: 'St. Helens District (B)',
      provincie: 1000,
      slug: 'st-helens-district-b',
    },
    {
      code: 'E08000024',
      label: 'Sunderland District (B)',
      provincie: 1000,
      slug: 'sunderland-district-b',
    },
    {
      code: 'E08000008',
      label: 'Tameside District (B)',
      provincie: 1000,
      slug: 'tameside-district-b',
    },
    {
      code: 'E08000009',
      label: 'Trafford District (B)',
      provincie: 1000,
      slug: 'trafford-district-b',
    },
    {
      code: 'E08000036',
      label: 'Wakefield District (B)',
      provincie: 1000,
      slug: 'wakefield-district-b',
    },
    {
      code: 'E08000030',
      label: 'Walsall District (B)',
      provincie: 1000,
      slug: 'walsall-district-b',
    },
    {
      code: 'E08000010',
      label: 'Wigan District (B)',
      provincie: 1000,
      slug: 'wigan-district-b',
    },
    {
      code: 'E08000015',
      label: 'Wirral District (B)',
      provincie: 1000,
      slug: 'wirral-district-b',
    },
    {
      code: 'E06000022',
      label: 'Bath and North East Somerset',
      provincie: 1000,
      slug: 'bath-and-north-east-somerset',
    },
    {
      code: 'E06000055',
      label: 'Bedford (B)',
      provincie: 1000,
      slug: 'bedford-b',
    },
    {
      code: 'E06000008',
      label: 'Blackburn with Darwen (B)',
      provincie: 1000,
      slug: 'blackburn-with-darwen-b',
    },
    {
      code: 'E06000009',
      label: 'Blackpool (B)',
      provincie: 1000,
      slug: 'blackpool-b',
    },
    {
      code: 'W06000019',
      label: 'Blaenau Gwent - Blaenau Gwent',
      provincie: 3000,
      slug: 'blaenau-gwent-blaenau-gwent',
    },
    {
      code: 'E06000058',
      label: 'Bournemouth, Christchurch and Poole',
      provincie: 1000,
      slug: 'bournemouth-christchurch-and-poole',
    },
    {
      code: 'E06000036',
      label: 'Bracknell Forest (B)',
      provincie: 1000,
      slug: 'bracknell-forest-b',
    },
    {
      code: 'W06000014',
      label: 'Bro Morgannwg - the Vale of Glamorgan',
      provincie: 3000,
      slug: 'bro-morgannwg-the-vale-of-glamorgan',
    },
    {
      code: 'W06000018',
      label: 'Caerffili - Caerphilly',
      provincie: 3000,
      slug: 'caerffili-caerphilly',
    },
    {
      code: 'W06000012',
      label: 'Castell-nedd Port Talbot - Neath Port Talbot',
      provincie: 3000,
      slug: 'castell-nedd-port-talbot-neath-port-talbot',
    },
    {
      code: 'E06000056',
      label: 'Central Bedfordshire',
      provincie: 1000,
      slug: 'central-bedfordshire',
    },
    {
      code: 'E06000049',
      label: 'Cheshire East (B)',
      provincie: 1000,
      slug: 'cheshire-east-b',
    },
    {
      code: 'E06000050',
      label: 'Cheshire West and Chester (B)',
      provincie: 1000,
      slug: 'cheshire-west-and-chester-b',
    },
    {
      code: 'E06000023',
      label: 'City of Bristol (B)',
      provincie: 1000,
      slug: 'city-of-bristol-b',
    },
    {
      code: 'E06000015',
      label: 'City of Derby (B)',
      provincie: 1000,
      slug: 'city-of-derby-b',
    },
    {
      code: 'E06000016',
      label: 'City of Leicester (B)',
      provincie: 1000,
      slug: 'city-of-leicester-b',
    },
    {
      code: 'E06000018',
      label: 'City of Nottingham (B)',
      provincie: 1000,
      slug: 'city-of-nottingham-b',
    },
    {
      code: 'E06000031',
      label: 'City of Peterborough (B)',
      provincie: 1000,
      slug: 'city-of-peterborough-b',
    },
    {
      code: 'E06000045',
      label: 'City of Southampton (B)',
      provincie: 1000,
      slug: 'city-of-southampton-b',
    },
    {
      code: 'E06000021',
      label: 'City of Stoke-on-Trent (B)',
      provincie: 1000,
      slug: 'city-of-stoke-on-trent-b',
    },
    {
      code: 'S12000005',
      label: 'Clackmannanshire',
      provincie: 2000,
      slug: 'clackmannanshire',
    },
    {
      code: 'W06000003',
      label: 'Conwy - Conwy',
      provincie: 3000,
      slug: 'conwy-conwy',
    },
    {
      code: 'E06000019',
      label: 'County of Herefordshire',
      provincie: 1000,
      slug: 'county-of-herefordshire',
    },
    {
      code: 'E06000005',
      label: 'Darlington (B)',
      provincie: 1000,
      slug: 'darlington-b',
    },
    {
      code: 'S12000042',
      label: 'Dundee City',
      provincie: 2000,
      slug: 'dundee-city',
    },
    {
      code: 'S12000008',
      label: 'East Ayrshire',
      provincie: 2000,
      slug: 'east-ayrshire',
    },
    {
      code: 'S12000045',
      label: 'East Dunbartonshire',
      provincie: 2000,
      slug: 'east-dunbartonshire',
    },
    {
      code: 'S12000011',
      label: 'East Renfrewshire',
      provincie: 2000,
      slug: 'east-renfrewshire',
    },
    {
      code: 'S12000014',
      label: 'Falkirk',
      provincie: 2000,
      slug: 'falkirk',
    },
    {
      code: 'S12000049',
      label: 'Glasgow City',
      provincie: 2000,
      slug: 'glasgow-city',
    },
    {
      code: 'E06000006',
      label: 'Halton (B)',
      provincie: 1000,
      slug: 'halton-b',
    },
    {
      code: 'S12000018',
      label: 'Inverclyde',
      provincie: 2000,
      slug: 'inverclyde',
    },
    {
      code: 'E06000032',
      label: 'Luton (B)',
      provincie: 1000,
      slug: 'luton-b',
    },
    {
      code: 'E06000035',
      label: 'Medway (B)',
      provincie: 1000,
      slug: 'medway-b',
    },
    {
      code: 'W06000024',
      label: 'Merthyr Tudful - Merthyr Tydfil',
      provincie: 3000,
      slug: 'merthyr-tudful-merthyr-tydfil',
    },
    {
      code: 'E06000002',
      label: 'Middlesbrough (B)',
      provincie: 1000,
      slug: 'middlesbrough-b',
    },
    {
      code: 'S12000019',
      label: 'Midlothian',
      provincie: 2000,
      slug: 'midlothian',
    },
    {
      code: 'E06000042',
      label: 'Milton Keynes (B)',
      provincie: 1000,
      slug: 'milton-keynes-b',
    },
    {
      code: 'E06000012',
      label: 'North East Lincolnshire (B)',
      provincie: 1000,
      slug: 'north-east-lincolnshire-b',
    },
    {
      code: 'S12000050',
      label: 'North Lanarkshire',
      provincie: 2000,
      slug: 'north-lanarkshire',
    },
    {
      code: 'E06000013',
      label: 'North Lincolnshire (B)',
      provincie: 1000,
      slug: 'north-lincolnshire-b',
    },
    {
      code: 'W06000013',
      label: 'Pen-y-bont ar Ogwr - Bridgend',
      provincie: 3000,
      slug: 'pen-y-bont-ar-ogwr-bridgend',
    },
    {
      code: 'S12000048',
      label: 'Perth and Kinross',
      provincie: 2000,
      slug: 'perth-and-kinross',
    },
    {
      code: 'W06000023',
      label: 'Powys - Powys',
      provincie: 3000,
      slug: 'powys-powys',
    },
    {
      code: 'E06000038',
      label: 'Reading (B)',
      provincie: 1000,
      slug: 'reading-b',
    },
    {
      code: 'E06000003',
      label: 'Redcar and Cleveland (B)',
      provincie: 1000,
      slug: 'redcar-and-cleveland-b',
    },
    {
      code: 'S12000038',
      label: 'Renfrewshire',
      provincie: 2000,
      slug: 'renfrewshire',
    },
    {
      code: 'W06000016',
      label: 'Rhondda Cynon Taf - Rhondda Cynon Taf',
      provincie: 3000,
      slug: 'rhondda-cynon-taf-rhondda-cynon-taf',
    },
    {
      code: 'E06000017',
      label: 'Rutland',
      provincie: 1000,
      slug: 'rutland',
    },
    {
      code: 'S12000026',
      label: 'Scottish Borders',
      provincie: 2000,
      slug: 'scottish-borders',
    },
    {
      code: 'E06000051',
      label: 'Shropshire',
      provincie: 1000,
      slug: 'shropshire',
    },
    {
      code: 'W06000004',
      label: 'Sir Ddinbych - Denbighshire',
      provincie: 3000,
      slug: 'sir-ddinbych-denbighshire',
    },
    {
      code: 'W06000005',
      label: 'Sir y Fflint - Flintshire',
      provincie: 3000,
      slug: 'sir-y-fflint-flintshire',
    },
    {
      code: 'E06000039',
      label: 'Slough (B)',
      provincie: 1000,
      slug: 'slough-b',
    },
    {
      code: 'E06000033',
      label: 'Southend-on-Sea (B)',
      provincie: 1000,
      slug: 'southend-on-sea-b',
    },
    {
      code: 'E06000025',
      label: 'South Gloucestershire',
      provincie: 1000,
      slug: 'south-gloucestershire',
    },
    {
      code: 'S12000029',
      label: 'South Lanarkshire',
      provincie: 2000,
      slug: 'south-lanarkshire',
    },
    {
      code: 'S12000030',
      label: 'Stirling',
      provincie: 2000,
      slug: 'stirling',
    },
    {
      code: 'E06000004',
      label: 'Stockton-on-Tees (B)',
      provincie: 1000,
      slug: 'stockton-on-tees-b',
    },
    {
      code: 'E06000030',
      label: 'Swindon (B)',
      provincie: 1000,
      slug: 'swindon-b',
    },
    {
      code: 'E06000020',
      label: 'Telford and Wrekin (B)',
      provincie: 1000,
      slug: 'telford-and-wrekin-b',
    },
    {
      code: 'E06000043',
      label: 'The City of Brighton and Hove (B)',
      provincie: 1000,
      slug: 'the-city-of-brighton-and-hove-b',
    },
    {
      code: 'E06000034',
      label: 'Thurrock (B)',
      provincie: 1000,
      slug: 'thurrock-b',
    },
    {
      code: 'W06000020',
      label: 'Torfaen - Torfaen',
      provincie: 3000,
      slug: 'torfaen-torfaen',
    },
    {
      code: 'E06000027',
      label: 'Torbay (B)',
      provincie: 1000,
      slug: 'torbay-b',
    },
    {
      code: 'E06000007',
      label: 'Warrington (B)',
      provincie: 1000,
      slug: 'warrington-b',
    },
    {
      code: 'E06000037',
      label: 'West Berkshire',
      provincie: 1000,
      slug: 'west-berkshire',
    },
    {
      code: 'S12000039',
      label: 'West Dunbartonshire',
      provincie: 2000,
      slug: 'west-dunbartonshire',
    },
    {
      code: 'S12000040',
      label: 'West Lothian',
      provincie: 2000,
      slug: 'west-lothian',
    },
    {
      code: 'E06000054',
      label: 'Wiltshire',
      provincie: 1000,
      slug: 'wiltshire',
    },
    {
      code: 'E06000040',
      label: 'Windsor and Maidenhead (B)',
      provincie: 1000,
      slug: 'windsor-and-maidenhead-b',
    },
    {
      code: 'E06000041',
      label: 'Wokingham (B)',
      provincie: 1000,
      slug: 'wokingham-b',
    },
    {
      code: 'W06000006',
      label: 'Wrecsam - Wrexham',
      provincie: 3000,
      slug: 'wrecsam-wrexham',
    },
    {
      code: 'E06000014',
      label: 'York (B)',
      provincie: 1000,
      slug: 'york-b',
    },
    {
      code: 'E06000046',
      label: 'Isle of Wight',
      provincie: 1000,
      slug: 'isle-of-wight',
    },
    {
      code: 'W06000001',
      label: 'Sir Ynys Mon - Isle of Anglesey',
      provincie: 3000,
      slug: 'sir-ynys-mon-isle-of-anglesey',
    },
    {
      code: 'W06000002',
      label: 'Gwynedd - Gwynedd',
      provincie: 3000,
      slug: 'gwynedd-gwynedd',
    },
    {
      code: 'W06000008',
      label: 'Sir Ceredigion - Ceredigion',
      provincie: 3000,
      slug: 'sir-ceredigion-ceredigion',
    },
    {
      code: 'W06000009',
      label: 'Sir Benfro - Pembrokeshire',
      provincie: 3000,
      slug: 'sir-benfro-pembrokeshire',
    },
    {
      code: 'E06000044',
      label: 'City of Portsmouth (B)',
      provincie: 1000,
      slug: 'city-of-portsmouth-b',
    },
    {
      code: 'E06000026',
      label: 'City of Plymouth (B)',
      provincie: 1000,
      slug: 'city-of-plymouth-b',
    },
    {
      code: 'E06000057',
      label: 'Northumberland',
      provincie: 1000,
      slug: 'northumberland',
    },
    {
      code: 'E06000053',
      label: 'Isles of Scilly',
      provincie: 1000,
      slug: 'isles-of-scilly',
    },
    {
      code: 'E06000061',
      label: 'North Northamptonshire',
      provincie: 1000,
      slug: 'north-northamptonshire',
    },
    {
      code: 'W06000010',
      label: 'Sir Gaerfyrddin - Carmarthenshire',
      provincie: 3000,
      slug: 'sir-gaerfyrddin-carmarthenshire',
    },
    {
      code: 'S12000020',
      label: 'Moray',
      provincie: 2000,
      slug: 'moray',
    },
    {
      code: 'S12000028',
      label: 'South Ayrshire',
      provincie: 2000,
      slug: 'south-ayrshire',
    },
    {
      code: 'S12000041',
      label: 'Angus',
      provincie: 2000,
      slug: 'angus',
    },
    {
      code: 'S12000034',
      label: 'Aberdeenshire',
      provincie: 2000,
      slug: 'aberdeenshire',
    },
    {
      code: 'S12000047',
      label: 'Fife',
      provincie: 2000,
      slug: 'fife',
    },
    {
      code: 'S12000033',
      label: 'Aberdeen City',
      provincie: 2000,
      slug: 'aberdeen-city',
    },
    {
      code: 'S12000036',
      label: 'City of Edinburgh',
      provincie: 2000,
      slug: 'city-of-edinburgh',
    },
    {
      code: 'S12000010',
      label: 'East Lothian',
      provincie: 2000,
      slug: 'east-lothian',
    },
    {
      code: 'S12000021',
      label: 'North Ayrshire',
      provincie: 2000,
      slug: 'north-ayrshire',
    },
    {
      code: 'S12000006',
      label: 'Dumfries and Galloway',
      provincie: 2000,
      slug: 'dumfries-and-galloway',
    },
    {
      code: 'S12000013',
      label: 'Na h-Eileanan an Iar',
      provincie: 2000,
      slug: 'na-h-eileanan-an-iar',
    },
    {
      code: 'S12000027',
      label: 'Shetland Islands',
      provincie: 2000,
      slug: 'shetland-islands',
    },
    {
      code: 'S12000023',
      label: 'Orkney Islands',
      provincie: 2000,
      slug: 'orkney-islands',
    },
    {
      code: 'E06000065',
      label: 'North Yorkshire',
      provincie: 1000,
      slug: 'north-yorkshire',
    },
    {
      code: 'E06000066',
      label: 'Somerset',
      provincie: 1000,
      slug: 'somerset',
    },
    {
      code: 'W06000011',
      label: 'Abertawe - Swansea',
      provincie: 3000,
      slug: 'abertawe-swansea',
    },
    {
      code: 'W06000022',
      label: 'Casnewydd - Newport',
      provincie: 3000,
      slug: 'casnewydd-newport',
    },
    {
      code: 'E06000010',
      label: 'City of Kingston upon Hull (B)',
      provincie: 1000,
      slug: 'city-of-kingston-upon-hull-b',
    },
    {
      code: 'E06000047',
      label: 'County Durham',
      provincie: 1000,
      slug: 'county-durham',
    },
    {
      code: 'E06000011',
      label: 'East Riding of Yorkshire',
      provincie: 1000,
      slug: 'east-riding-of-yorkshire',
    },
    {
      code: 'E06000001',
      label: 'Hartlepool (B)',
      provincie: 1000,
      slug: 'hartlepool-b',
    },
    {
      code: 'W06000015',
      label: 'Caerdydd - Cardiff',
      provincie: 3000,
      slug: 'caerdydd-cardiff',
    },
    {
      code: 'W06000021',
      label: 'Sir Fynwy - Monmouthshire',
      provincie: 3000,
      slug: 'sir-fynwy-monmouthshire',
    },
    {
      code: 'E06000024',
      label: 'North Somerset',
      provincie: 1000,
      slug: 'north-somerset',
    },
    {
      code: 'E06000052',
      label: 'Cornwall',
      provincie: 1000,
      slug: 'cornwall',
    },
    {
      code: 'E06000063',
      label: 'Cumberland',
      provincie: 1000,
      slug: 'cumberland',
    },
    {
      code: 'S12000017',
      label: 'Highland',
      provincie: 2000,
      slug: 'highland',
    },
    {
      code: 'S12000035',
      label: 'Argyll and Bute',
      provincie: 2000,
      slug: 'argyll-and-bute',
    },
    {
      code: 'E07000081',
      label: 'Gloucester District (B)',
      provincie: 1000,
      slug: 'gloucester-district-b',
    },
    {
      code: 'E07000103',
      label: 'Watford District (B)',
      provincie: 1000,
      slug: 'watford-district-b',
    },
    {
      code: 'E07000135',
      label: 'Oadby and Wigston District (B)',
      provincie: 1000,
      slug: 'oadby-and-wigston-district-b',
    },
    {
      code: 'E07000138',
      label: 'Lincoln District (B)',
      provincie: 1000,
      slug: 'lincoln-district-b',
    },
    {
      code: 'E07000175',
      label: 'Newark and Sherwood District',
      provincie: 1000,
      slug: 'newark-and-sherwood-district',
    },
    {
      code: 'E07000178',
      label: 'Oxford District (B)',
      provincie: 1000,
      slug: 'oxford-district-b',
    },
    {
      code: 'E07000072',
      label: 'Epping Forest District',
      provincie: 1000,
      slug: 'epping-forest-district',
    },
    {
      code: 'E07000068',
      label: 'Brentwood District (B)',
      provincie: 1000,
      slug: 'brentwood-district-b',
    },
    {
      code: 'E07000062',
      label: 'Hastings District (B)',
      provincie: 1000,
      slug: 'hastings-district-b',
    },
    {
      code: 'E07000061',
      label: 'Eastbourne District (B)',
      provincie: 1000,
      slug: 'eastbourne-district-b',
    },
    {
      code: 'E07000073',
      label: 'Harlow District',
      provincie: 1000,
      slug: 'harlow-district',
    },
    {
      code: 'E07000042',
      label: 'Mid Devon District',
      provincie: 1000,
      slug: 'mid-devon-district',
    },
    {
      code: 'E07000047',
      label: 'West Devon District (B)',
      provincie: 1000,
      slug: 'west-devon-district-b',
    },
    {
      code: 'E07000045',
      label: 'Teignbridge District',
      provincie: 1000,
      slug: 'teignbridge-district',
    },
    {
      code: 'E07000084',
      label: 'Basingstoke and Deane District (B)',
      provincie: 1000,
      slug: 'basingstoke-and-deane-district-b',
    },
    {
      code: 'E07000034',
      label: 'Chesterfield District (B)',
      provincie: 1000,
      slug: 'chesterfield-district-b',
    },
    {
      code: 'E07000086',
      label: 'Eastleigh District (B)',
      provincie: 1000,
      slug: 'eastleigh-district-b',
    },
    {
      code: 'E07000033',
      label: 'Bolsover District',
      provincie: 1000,
      slug: 'bolsover-district',
    },
    {
      code: 'E07000032',
      label: 'Amber Valley District (B)',
      provincie: 1000,
      slug: 'amber-valley-district-b',
    },
    {
      code: 'E07000036',
      label: 'Erewash District (B)',
      provincie: 1000,
      slug: 'erewash-district-b',
    },
    {
      code: 'E07000088',
      label: 'Gosport District (B)',
      provincie: 1000,
      slug: 'gosport-district-b',
    },
    {
      code: 'E07000076',
      label: 'Tendring District',
      provincie: 1000,
      slug: 'tendring-district',
    },
    {
      code: 'E07000096',
      label: 'Dacorum District (B)',
      provincie: 1000,
      slug: 'dacorum-district-b',
    },
    {
      code: 'E07000071',
      label: 'Colchester District (B)',
      provincie: 1000,
      slug: 'colchester-district-b',
    },
    {
      code: 'E07000240',
      label: 'St. Albans District (B)',
      provincie: 1000,
      slug: 'st-albans-district-b',
    },
    {
      code: 'E07000241',
      label: 'Welwyn Hatfield District (B)',
      provincie: 1000,
      slug: 'welwyn-hatfield-district-b',
    },
    {
      code: 'E07000066',
      label: 'Basildon District (B)',
      provincie: 1000,
      slug: 'basildon-district-b',
    },
    {
      code: 'E07000080',
      label: 'Forest of Dean District',
      provincie: 1000,
      slug: 'forest-of-dean-district',
    },
    {
      code: 'E07000041',
      label: 'Exeter District (B)',
      provincie: 1000,
      slug: 'exeter-district-b',
    },
    {
      code: 'E07000082',
      label: 'Stroud District',
      provincie: 1000,
      slug: 'stroud-district',
    },
    {
      code: 'E07000083',
      label: 'North Gloucestershire District (B)',
      provincie: 1000,
      slug: 'north-gloucestershire-district-b',
    },
    {
      code: 'E07000078',
      label: 'Cheltenham District (B)',
      provincie: 1000,
      slug: 'cheltenham-district-b',
    },
    {
      code: 'E07000094',
      label: 'Winchester District (B)',
      provincie: 1000,
      slug: 'winchester-district-b',
    },
    {
      code: 'E07000109',
      label: 'Gravesham District (B)',
      provincie: 1000,
      slug: 'gravesham-district-b',
    },
    {
      code: 'E07000038',
      label: 'North East Derbyshire District',
      provincie: 1000,
      slug: 'north-east-derbyshire-district',
    },
    {
      code: 'E07000242',
      label: 'East Hertfordshire District',
      provincie: 1000,
      slug: 'east-hertfordshire-district',
    },
    {
      code: 'E07000243',
      label: 'Stevenage District (B)',
      provincie: 1000,
      slug: 'stevenage-district-b',
    },
    {
      code: 'E07000112',
      label: 'Folkestone and Hythe District',
      provincie: 1000,
      slug: 'folkestone-and-hythe-district',
    },
    {
      code: 'E07000114',
      label: 'Thanet District',
      provincie: 1000,
      slug: 'thanet-district',
    },
    {
      code: 'E07000106',
      label: 'Canterbury District (B)',
      provincie: 1000,
      slug: 'canterbury-district-b',
    },
    {
      code: 'E07000108',
      label: 'Dover District',
      provincie: 1000,
      slug: 'dover-district',
    },
    {
      code: 'E07000107',
      label: 'Dartford District (B)',
      provincie: 1000,
      slug: 'dartford-district-b',
    },
    {
      code: 'E07000087',
      label: 'Fareham District (B)',
      provincie: 1000,
      slug: 'fareham-district-b',
    },
    {
      code: 'E07000102',
      label: 'Three Rivers District',
      provincie: 1000,
      slug: 'three-rivers-district',
    },
    {
      code: 'E07000098',
      label: 'Hertsmere District (B)',
      provincie: 1000,
      slug: 'hertsmere-district-b',
    },
    {
      code: 'E07000095',
      label: 'Broxbourne District (B)',
      provincie: 1000,
      slug: 'broxbourne-district-b',
    },
    {
      code: 'E07000128',
      label: 'Wyre District (B)',
      provincie: 1000,
      slug: 'wyre-district-b',
    },
    {
      code: 'E07000142',
      label: 'West Lindsey District',
      provincie: 1000,
      slug: 'west-lindsey-district',
    },
    {
      code: 'E07000140',
      label: 'South Holland District',
      provincie: 1000,
      slug: 'south-holland-district',
    },
    {
      code: 'E07000136',
      label: 'Boston District (B)',
      provincie: 1000,
      slug: 'boston-district-b',
    },
    {
      code: 'E07000139',
      label: 'North Kesteven District',
      provincie: 1000,
      slug: 'north-kesteven-district',
    },
    {
      code: 'E07000137',
      label: 'East Lindsey District',
      provincie: 1000,
      slug: 'east-lindsey-district',
    },
    {
      code: 'E07000171',
      label: 'Bassetlaw District',
      provincie: 1000,
      slug: 'bassetlaw-district',
    },
    {
      code: 'E07000173',
      label: 'Gedling District (B)',
      provincie: 1000,
      slug: 'gedling-district-b',
    },
    {
      code: 'E07000170',
      label: 'Ashfield District',
      provincie: 1000,
      slug: 'ashfield-district',
    },
    {
      code: 'E07000172',
      label: 'Broxtowe District (B)',
      provincie: 1000,
      slug: 'broxtowe-district-b',
    },
    {
      code: 'E07000174',
      label: 'Mansfield District',
      provincie: 1000,
      slug: 'mansfield-district',
    },
    {
      code: 'E07000179',
      label: 'South Oxfordshire District',
      provincie: 1000,
      slug: 'south-oxfordshire-district',
    },
    {
      code: 'E07000181',
      label: 'West Oxfordshire District',
      provincie: 1000,
      slug: 'west-oxfordshire-district',
    },
    {
      code: 'E07000200',
      label: 'Babergh District',
      provincie: 1000,
      slug: 'babergh-district',
    },
    {
      code: 'E07000202',
      label: 'Ipswich District (B)',
      provincie: 1000,
      slug: 'ipswich-district-b',
    },
    {
      code: 'E07000235',
      label: 'Malvern Hills District',
      provincie: 1000,
      slug: 'malvern-hills-district',
    },
    {
      code: 'E07000238',
      label: 'Wychavon District',
      provincie: 1000,
      slug: 'wychavon-district',
    },
    {
      code: 'E07000237',
      label: 'Worcester District (B)',
      provincie: 1000,
      slug: 'worcester-district-b',
    },
    {
      code: 'E07000236',
      label: 'Redditch District (B)',
      provincie: 1000,
      slug: 'redditch-district-b',
    },
    {
      code: 'E07000229',
      label: 'Worthing District (B)',
      provincie: 1000,
      slug: 'worthing-district-b',
    },
    {
      code: 'E09000018',
      label: 'Hounslow London Borough',
      provincie: 1000,
      slug: 'hounslow-london-borough',
    },
    {
      code: 'E09000009',
      label: 'Ealing London Borough',
      provincie: 1000,
      slug: 'ealing-london-borough',
    },
    {
      code: 'E09000016',
      label: 'Havering London Borough',
      provincie: 1000,
      slug: 'havering-london-borough',
    },
    {
      code: 'E09000005',
      label: 'Brent London Borough',
      provincie: 1000,
      slug: 'brent-london-borough',
    },
    {
      code: 'E09000003',
      label: 'Barnet London Borough',
      provincie: 1000,
      slug: 'barnet-london-borough',
    },
    {
      code: 'E09000022',
      label: 'Lambeth London Borough',
      provincie: 1000,
      slug: 'lambeth-london-borough',
    },
    {
      code: 'E09000028',
      label: 'Southwark London Borough',
      provincie: 1000,
      slug: 'southwark-london-borough',
    },
    {
      code: 'E09000023',
      label: 'Lewisham London Borough',
      provincie: 1000,
      slug: 'lewisham-london-borough',
    },
    {
      code: 'E09000011',
      label: 'Greenwich London Borough',
      provincie: 1000,
      slug: 'greenwich-london-borough',
    },
    {
      code: 'E07000010',
      label: 'Fenland District',
      provincie: 1000,
      slug: 'fenland-district',
    },
    {
      code: 'E07000012',
      label: 'South Cambridgeshire District',
      provincie: 1000,
      slug: 'south-cambridgeshire-district',
    },
    {
      code: 'E07000009',
      label: 'East Cambridgeshire District',
      provincie: 1000,
      slug: 'east-cambridgeshire-district',
    },
    {
      code: 'E07000011',
      label: 'Huntingdonshire District',
      provincie: 1000,
      slug: 'huntingdonshire-district',
    },
    {
      code: 'E07000008',
      label: 'Cambridge District (B)',
      provincie: 1000,
      slug: 'cambridge-district-b',
    },
    {
      code: 'E07000039',
      label: 'South Derbyshire District',
      provincie: 1000,
      slug: 'south-derbyshire-district',
    },
    {
      code: 'E07000035',
      label: 'Derbyshire Dales District',
      provincie: 1000,
      slug: 'derbyshire-dales-district',
    },
    {
      code: 'E07000063',
      label: 'Lewes District',
      provincie: 1000,
      slug: 'lewes-district',
    },
    {
      code: 'E07000064',
      label: 'Rother District',
      provincie: 1000,
      slug: 'rother-district',
    },
    {
      code: 'E07000075',
      label: 'Rochford District',
      provincie: 1000,
      slug: 'rochford-district',
    },
    {
      code: 'E07000077',
      label: 'Uttlesford District',
      provincie: 1000,
      slug: 'uttlesford-district',
    },
    {
      code: 'E07000070',
      label: 'Chelmsford District (B)',
      provincie: 1000,
      slug: 'chelmsford-district-b',
    },
    {
      code: 'E07000067',
      label: 'Braintree District',
      provincie: 1000,
      slug: 'braintree-district',
    },
    {
      code: 'E07000085',
      label: 'East Hampshire District',
      provincie: 1000,
      slug: 'east-hampshire-district',
    },
    {
      code: 'E07000093',
      label: 'Test Valley District',
      provincie: 1000,
      slug: 'test-valley-district',
    },
    {
      code: 'E07000099',
      label: 'North Hertfordshire District',
      provincie: 1000,
      slug: 'north-hertfordshire-district',
    },
    {
      code: 'E07000111',
      label: 'Sevenoaks District',
      provincie: 1000,
      slug: 'sevenoaks-district',
    },
    {
      code: 'E07000105',
      label: 'Ashford District (B)',
      provincie: 1000,
      slug: 'ashford-district-b',
    },
    {
      code: 'E07000110',
      label: 'Maidstone District (B)',
      provincie: 1000,
      slug: 'maidstone-district-b',
    },
    {
      code: 'E07000113',
      label: 'Swale District (B)',
      provincie: 1000,
      slug: 'swale-district-b',
    },
    {
      code: 'E07000127',
      label: 'West Lancashire District (B)',
      provincie: 1000,
      slug: 'west-lancashire-district-b',
    },
    {
      code: 'E07000121',
      label: 'Lancaster District (B)',
      provincie: 1000,
      slug: 'lancaster-district-b',
    },
    {
      code: 'E07000118',
      label: 'Chorley District (B)',
      provincie: 1000,
      slug: 'chorley-district-b',
    },
    {
      code: 'E09000004',
      label: 'Bexley London Borough',
      provincie: 1000,
      slug: 'bexley-london-borough',
    },
    {
      code: 'E09000010',
      label: 'Enfield London Borough',
      provincie: 1000,
      slug: 'enfield-london-borough',
    },
    {
      code: 'E09000031',
      label: 'Waltham Forest London Borough',
      provincie: 1000,
      slug: 'waltham-forest-london-borough',
    },
    {
      code: 'E09000026',
      label: 'Redbridge London Borough',
      provincie: 1000,
      slug: 'redbridge-london-borough',
    },
    {
      code: 'E09000032',
      label: 'Wandsworth London Borough',
      provincie: 1000,
      slug: 'wandsworth-london-borough',
    },
    {
      code: 'E09000013',
      label: 'Hammersmith and Fulham London Borough',
      provincie: 1000,
      slug: 'hammersmith-and-fulham-london-borough',
    },
    {
      code: 'E09000020',
      label: 'Kensington and Chelsea London Borough',
      provincie: 1000,
      slug: 'kensington-and-chelsea-london-borough',
    },
    {
      code: 'E09000033',
      label: 'City of Westminster London Borough',
      provincie: 1000,
      slug: 'city-of-westminster-london-borough',
    },
    {
      code: 'E09000007',
      label: 'Camden London Borough',
      provincie: 1000,
      slug: 'camden-london-borough',
    },
    {
      code: 'E09000030',
      label: 'Tower Hamlets London Borough',
      provincie: 1000,
      slug: 'tower-hamlets-london-borough',
    },
    {
      code: 'E09000019',
      label: 'Islington London Borough',
      provincie: 1000,
      slug: 'islington-london-borough',
    },
    {
      code: 'E09000012',
      label: 'Hackney London Borough',
      provincie: 1000,
      slug: 'hackney-london-borough',
    },
    {
      code: 'E09000017',
      label: 'Hillingdon London Borough',
      provincie: 1000,
      slug: 'hillingdon-london-borough',
    },
    {
      code: 'E09000015',
      label: 'Harrow London Borough',
      provincie: 1000,
      slug: 'harrow-london-borough',
    },
    {
      code: 'E09000002',
      label: 'Barking and Dagenham London Borough',
      provincie: 1000,
      slug: 'barking-and-dagenham-london-borough',
    },
    {
      code: 'E09000001',
      label: 'City and County of the City of London',
      provincie: 1000,
      slug: 'city-and-county-of-the-city-of-london',
    },
    {
      code: 'E07000044',
      label: 'South Hams District',
      provincie: 1000,
      slug: 'south-hams-district',
    },
    {
      code: 'E07000046',
      label: 'Torridge District',
      provincie: 1000,
      slug: 'torridge-district',
    },
    {
      code: 'E09000014',
      label: 'Haringey London Borough',
      provincie: 1000,
      slug: 'haringey-london-borough',
    },
    {
      code: 'E09000025',
      label: 'Newham London Borough',
      provincie: 1000,
      slug: 'newham-london-borough',
    },
    {
      code: 'E07000126',
      label: 'South Ribble District (B)',
      provincie: 1000,
      slug: 'south-ribble-district-b',
    },
    {
      code: 'E07000125',
      label: 'Rossendale District (B)',
      provincie: 1000,
      slug: 'rossendale-district-b',
    },
    {
      code: 'E07000119',
      label: 'Fylde District (B)',
      provincie: 1000,
      slug: 'fylde-district-b',
    },
    {
      code: 'E07000123',
      label: 'Preston District (B)',
      provincie: 1000,
      slug: 'preston-district-b',
    },
    {
      code: 'E07000122',
      label: 'Pendle District (B)',
      provincie: 1000,
      slug: 'pendle-district-b',
    },
    {
      code: 'E07000124',
      label: 'Ribble Valley District (B)',
      provincie: 1000,
      slug: 'ribble-valley-district-b',
    },
    {
      code: 'E07000120',
      label: 'Hyndburn District (B)',
      provincie: 1000,
      slug: 'hyndburn-district-b',
    },
    {
      code: 'E07000117',
      label: 'Burnley District (B)',
      provincie: 1000,
      slug: 'burnley-district-b',
    },
    {
      code: 'E07000132',
      label: 'Hinckley and Bosworth District (B)',
      provincie: 1000,
      slug: 'hinckley-and-bosworth-district-b',
    },
    {
      code: 'E07000134',
      label: 'North West Leicestershire District',
      provincie: 1000,
      slug: 'north-west-leicestershire-district',
    },
    {
      code: 'E07000131',
      label: 'Harborough District',
      provincie: 1000,
      slug: 'harborough-district',
    },
    {
      code: 'E07000129',
      label: 'Blaby District',
      provincie: 1000,
      slug: 'blaby-district',
    },
    {
      code: 'E07000130',
      label: 'Charnwood District (B)',
      provincie: 1000,
      slug: 'charnwood-district-b',
    },
    {
      code: 'E07000141',
      label: 'South Kesteven District',
      provincie: 1000,
      slug: 'south-kesteven-district',
    },
    {
      code: 'E07000145',
      label: 'Great Yarmouth District (B)',
      provincie: 1000,
      slug: 'great-yarmouth-district-b',
    },
    {
      code: 'E07000149',
      label: 'South Norfolk District',
      provincie: 1000,
      slug: 'south-norfolk-district',
    },
    {
      code: 'E07000146',
      label: 'King\'s Lynn and West Norfolk District (B)',
      provincie: 1000,
      slug: 'king-s-lynn-and-west-norfolk-district-b',
    },
    {
      code: 'E07000143',
      label: 'Breckland District',
      provincie: 1000,
      slug: 'breckland-district',
    },
    {
      code: 'E07000148',
      label: 'Norwich District (B)',
      provincie: 1000,
      slug: 'norwich-district-b',
    },
    {
      code: 'E07000176',
      label: 'Rushcliffe District (B)',
      provincie: 1000,
      slug: 'rushcliffe-district-b',
    },
    {
      code: 'E07000196',
      label: 'South Staffordshire District',
      provincie: 1000,
      slug: 'south-staffordshire-district',
    },
    {
      code: 'E07000194',
      label: 'Lichfield District',
      provincie: 1000,
      slug: 'lichfield-district',
    },
    {
      code: 'E07000197',
      label: 'Stafford District (B)',
      provincie: 1000,
      slug: 'stafford-district-b',
    },
    {
      code: 'E07000193',
      label: 'East Staffordshire District (B)',
      provincie: 1000,
      slug: 'east-staffordshire-district-b',
    },
    {
      code: 'E07000192',
      label: 'Cannock Chase District',
      provincie: 1000,
      slug: 'cannock-chase-district',
    },
    {
      code: 'E07000199',
      label: 'Tamworth District (B)',
      provincie: 1000,
      slug: 'tamworth-district-b',
    },
    {
      code: 'E07000244',
      label: 'East Suffolk District',
      provincie: 1000,
      slug: 'east-suffolk-district',
    },
    {
      code: 'E07000216',
      label: 'Waverley District (B)',
      provincie: 1000,
      slug: 'waverley-district-b',
    },
    {
      code: 'E07000215',
      label: 'Tandridge District',
      provincie: 1000,
      slug: 'tandridge-district',
    },
    {
      code: 'E07000217',
      label: 'Woking District (B)',
      provincie: 1000,
      slug: 'woking-district-b',
    },
    {
      code: 'E07000214',
      label: 'Surrey Heath District (B)',
      provincie: 1000,
      slug: 'surrey-heath-district-b',
    },
    {
      code: 'E07000212',
      label: 'Runnymede District (B)',
      provincie: 1000,
      slug: 'runnymede-district-b',
    },
    {
      code: 'E07000209',
      label: 'Guildford District (B)',
      provincie: 1000,
      slug: 'guildford-district-b',
    },
    {
      code: 'E07000210',
      label: 'Mole Valley District',
      provincie: 1000,
      slug: 'mole-valley-district',
    },
    {
      code: 'E07000207',
      label: 'Elmbridge District (B)',
      provincie: 1000,
      slug: 'elmbridge-district-b',
    },
    {
      code: 'E07000213',
      label: 'Spelthorne District (B)',
      provincie: 1000,
      slug: 'spelthorne-district-b',
    },
    {
      code: 'E07000218',
      label: 'North Warwickshire District (B)',
      provincie: 1000,
      slug: 'north-warwickshire-district-b',
    },
    {
      code: 'E07000220',
      label: 'Rugby District (B)',
      provincie: 1000,
      slug: 'rugby-district-b',
    },
    {
      code: 'E07000222',
      label: 'Warwick District',
      provincie: 1000,
      slug: 'warwick-district',
    },
    {
      code: 'E07000221',
      label: 'Stratford-on-Avon District',
      provincie: 1000,
      slug: 'stratford-on-avon-district',
    },
    {
      code: 'E07000219',
      label: 'Nuneaton and Bedworth District (B)',
      provincie: 1000,
      slug: 'nuneaton-and-bedworth-district-b',
    },
    {
      code: 'E07000224',
      label: 'Arun District',
      provincie: 1000,
      slug: 'arun-district',
    },
    {
      code: 'E07000223',
      label: 'Adur District',
      provincie: 1000,
      slug: 'adur-district',
    },
    {
      code: 'E07000225',
      label: 'Chichester District',
      provincie: 1000,
      slug: 'chichester-district',
    },
    {
      code: 'E07000228',
      label: 'Mid Sussex District',
      provincie: 1000,
      slug: 'mid-sussex-district',
    },
    {
      code: 'E07000227',
      label: 'Horsham District',
      provincie: 1000,
      slug: 'horsham-district',
    },
    {
      code: 'E07000226',
      label: 'Crawley District (B)',
      provincie: 1000,
      slug: 'crawley-district-b',
    },
    {
      code: 'E07000239',
      label: 'Wyre Forest District',
      provincie: 1000,
      slug: 'wyre-forest-district',
    },
    {
      code: 'E07000234',
      label: 'Bromsgrove District',
      provincie: 1000,
      slug: 'bromsgrove-district',
    },
    {
      code: 'E09000021',
      label: 'Kingston upon Thames London Borough',
      provincie: 1000,
      slug: 'kingston-upon-thames-london-borough',
    },
    {
      code: 'E09000008',
      label: 'Croydon London Borough',
      provincie: 1000,
      slug: 'croydon-london-borough',
    },
    {
      code: 'E09000006',
      label: 'Bromley London Borough',
      provincie: 1000,
      slug: 'bromley-london-borough',
    },
    {
      code: 'E07000147',
      label: 'North Norfolk District',
      provincie: 1000,
      slug: 'north-norfolk-district',
    },
    {
      code: 'E07000037',
      label: 'High Peak District (B)',
      provincie: 1000,
      slug: 'high-peak-district-b',
    },
    {
      code: 'E07000198',
      label: 'Staffordshire Moorlands District',
      provincie: 1000,
      slug: 'staffordshire-moorlands-district',
    },
    {
      code: 'E07000195',
      label: 'Newcastle-under-Lyme District (B)',
      provincie: 1000,
      slug: 'newcastle-under-lyme-district-b',
    },
    {
      code: 'E07000040',
      label: 'East Devon District',
      provincie: 1000,
      slug: 'east-devon-district',
    },
    {
      code: 'E07000133',
      label: 'Melton District (B)',
      provincie: 1000,
      slug: 'melton-district-b',
    },
    {
      code: 'E07000079',
      label: 'Cotswold District',
      provincie: 1000,
      slug: 'cotswold-district',
    },
    {
      code: 'E07000245',
      label: 'West Suffolk District',
      provincie: 1000,
      slug: 'west-suffolk-district',
    },
    {
      code: 'E07000203',
      label: 'Mid Suffolk District',
      provincie: 1000,
      slug: 'mid-suffolk-district',
    },
    {
      code: 'E07000091',
      label: 'New Forest District',
      provincie: 1000,
      slug: 'new-forest-district',
    },
    {
      code: 'E07000180',
      label: 'Vale of White Horse District',
      provincie: 1000,
      slug: 'vale-of-white-horse-district',
    },
    {
      code: 'E07000177',
      label: 'Cherwell District',
      provincie: 1000,
      slug: 'cherwell-district',
    },
    {
      code: 'E07000074',
      label: 'Maldon District (B)',
      provincie: 1000,
      slug: 'maldon-district-b',
    },
    {
      code: 'E07000069',
      label: 'Castle Point District (B)',
      provincie: 1000,
      slug: 'castle-point-district-b',
    },
    {
      code: 'E07000089',
      label: 'Hart District',
      provincie: 1000,
      slug: 'hart-district',
    },
    {
      code: 'E07000092',
      label: 'Rushmoor District (B)',
      provincie: 1000,
      slug: 'rushmoor-district-b',
    },
    {
      code: 'E07000211',
      label: 'Reigate and Banstead District (B)',
      provincie: 1000,
      slug: 'reigate-and-banstead-district-b',
    },
    {
      code: 'E09000027',
      label: 'Richmond upon Thames London Borough',
      provincie: 1000,
      slug: 'richmond-upon-thames-london-borough',
    },
    {
      code: 'E09000024',
      label: 'Merton London Borough',
      provincie: 1000,
      slug: 'merton-london-borough',
    },
    {
      code: 'E07000065',
      label: 'Wealden District',
      provincie: 1000,
      slug: 'wealden-district',
    },
    {
      code: 'E07000116',
      label: 'Tunbridge Wells District (B)',
      provincie: 1000,
      slug: 'tunbridge-wells-district-b',
    },
    {
      code: 'E07000090',
      label: 'Havant District (B)',
      provincie: 1000,
      slug: 'havant-district-b',
    },
    {
      code: 'E07000208',
      label: 'Epsom and Ewell District (B)',
      provincie: 1000,
      slug: 'epsom-and-ewell-district-b',
    },
    {
      code: 'E07000115',
      label: 'Tonbridge and Malling District (B)',
      provincie: 1000,
      slug: 'tonbridge-and-malling-district-b',
    },
    {
      code: 'E09000029',
      label: 'Sutton London Borough',
      provincie: 1000,
      slug: 'sutton-london-borough',
    },
    {
      code: 'E07000144',
      label: 'Broadland District',
      provincie: 1000,
      slug: 'broadland-district',
    },
    {
      code: 'E07000043',
      label: 'North Devon District',
      provincie: 1000,
      slug: 'north-devon-district',
    },

  ],
  // DE-LOKALBEHOERDE-START (generated by scripts/generate-de-lokalbehoerden.js from a BKG Gemeinde GeoJSON; code = 12-digit ARS)
  de: [
    {
      code: '010010000000',
      label: 'Flensburg',
      provincie: 1,
      slug: 'flensburg',
    },
    {
      code: '010020000000',
      label: 'Kiel',
      provincie: 1,
      slug: 'kiel',
    },
    {
      code: '010030000000',
      label: 'Lübeck',
      provincie: 1,
      slug: 'luebeck',
    },
    {
      code: '010040000000',
      label: 'Neumünster',
      provincie: 1,
      slug: 'neumuenster',
    },
    {
      code: '010510011011',
      label: 'Brunsbüttel',
      provincie: 1,
      slug: 'brunsbuettel',
    },
    {
      code: '010510044044',
      label: 'Heide',
      provincie: 1,
      slug: 'heide',
    },
    {
      code: '010515163003',
      label: 'Averlak',
      provincie: 1,
      slug: 'averlak',
    },
    {
      code: '010515163010',
      label: 'Brickeln',
      provincie: 1,
      slug: 'brickeln',
    },
    {
      code: '010515163012',
      label: 'Buchholz',
      provincie: 1,
      slug: 'buchholz',
    },
    {
      code: '010515163016',
      label: 'Burg (Dithmarschen)',
      provincie: 1,
      slug: 'burg-dithmarschen',
    },
    {
      code: '010515163022',
      label: 'Dingen',
      provincie: 1,
      slug: 'dingen',
    },
    {
      code: '010515163024',
      label: 'Eddelak',
      provincie: 1,
      slug: 'eddelak',
    },
    {
      code: '010515163026',
      label: 'Eggstedt',
      provincie: 1,
      slug: 'eggstedt',
    },
    {
      code: '010515163032',
      label: 'Frestedt',
      provincie: 1,
      slug: 'frestedt',
    },
    {
      code: '010515163037',
      label: 'Großenrade',
      provincie: 1,
      slug: 'grossenrade',
    },
    {
      code: '010515163051',
      label: 'Hochdonn',
      provincie: 1,
      slug: 'hochdonn',
    },
    {
      code: '010515163064',
      label: 'Kuden',
      provincie: 1,
      slug: 'kuden',
    },
    {
      code: '010515163089',
      label: 'Quickborn',
      provincie: 1,
      slug: 'quickborn',
    },
    {
      code: '010515163097',
      label: 'Sankt Michaelisdonn',
      provincie: 1,
      slug: 'sankt-michaelisdonn',
    },
    {
      code: '010515163110',
      label: 'Süderhastedt',
      provincie: 1,
      slug: 'suederhastedt',
    },
    {
      code: '010515166021',
      label: 'Diekhusen-Fahrstedt',
      provincie: 1,
      slug: 'diekhusen-fahrstedt',
    },
    {
      code: '010515166034',
      label: 'Friedrichskoog',
      provincie: 1,
      slug: 'friedrichskoog',
    },
    {
      code: '010515166046',
      label: 'Helse',
      provincie: 1,
      slug: 'helse',
    },
    {
      code: '010515166057',
      label: 'Kaiser-Wilhelm-Koog',
      provincie: 1,
      slug: 'kaiser-wilhelm-koog',
    },
    {
      code: '010515166062',
      label: 'Kronprinzenkoog',
      provincie: 1,
      slug: 'kronprinzenkoog',
    },
    {
      code: '010515166072',
      label: 'Marne',
      provincie: 1,
      slug: 'marne',
    },
    {
      code: '010515166073',
      label: 'Marnerdeich',
      provincie: 1,
      slug: 'marnerdeich',
    },
    {
      code: '010515166076',
      label: 'Neufeld',
      provincie: 1,
      slug: 'neufeld',
    },
    {
      code: '010515166077',
      label: 'Neufelderkoog',
      provincie: 1,
      slug: 'neufelderkoog',
    },
    {
      code: '010515166090',
      label: 'Ramhusen',
      provincie: 1,
      slug: 'ramhusen',
    },
    {
      code: '010515166103',
      label: 'Schmedeswurth',
      provincie: 1,
      slug: 'schmedeswurth',
    },
    {
      code: '010515166118',
      label: 'Trennewurth',
      provincie: 1,
      slug: 'trennewurth',
    },
    {
      code: '010515166119',
      label: 'Volsemenhusen',
      provincie: 1,
      slug: 'volsemenhusen',
    },
    {
      code: '010515169005',
      label: 'Barkenholm',
      provincie: 1,
      slug: 'barkenholm',
    },
    {
      code: '010515169008',
      label: 'Bergewöhrden',
      provincie: 1,
      slug: 'bergewoehrden',
    },
    {
      code: '010515169019',
      label: 'Dellstedt',
      provincie: 1,
      slug: 'dellstedt',
    },
    {
      code: '010515169020',
      label: 'Delve',
      provincie: 1,
      slug: 'delve',
    },
    {
      code: '010515169023',
      label: 'Dörpling',
      provincie: 1,
      slug: 'doerpling',
    },
    {
      code: '010515169030',
      label: 'Fedderingen',
      provincie: 1,
      slug: 'fedderingen',
    },
    {
      code: '010515169035',
      label: 'Gaushorn',
      provincie: 1,
      slug: 'gaushorn',
    },
    {
      code: '010515169036',
      label: 'Glüsing',
      provincie: 1,
      slug: 'gluesing',
    },
    {
      code: '010515169038',
      label: 'Groven',
      provincie: 1,
      slug: 'groven',
    },
    {
      code: '010515169047',
      label: 'Hemme',
      provincie: 1,
      slug: 'hemme',
    },
    {
      code: '010515169049',
      label: 'Hennstedt',
      provincie: 1,
      slug: 'hennstedt',
    },
    {
      code: '010515169052',
      label: 'Hövede',
      provincie: 1,
      slug: 'hoevede',
    },
    {
      code: '010515169053',
      label: 'Hollingstedt',
      provincie: 1,
      slug: 'hollingstedt',
    },
    {
      code: '010515169058',
      label: 'Karolinenkoog',
      provincie: 1,
      slug: 'karolinenkoog',
    },
    {
      code: '010515169060',
      label: 'Kleve',
      provincie: 1,
      slug: 'kleve',
    },
    {
      code: '010515169061',
      label: 'Krempel',
      provincie: 1,
      slug: 'krempel',
    },
    {
      code: '010515169065',
      label: 'Lehe',
      provincie: 1,
      slug: 'lehe',
    },
    {
      code: '010515169068',
      label: 'Linden',
      provincie: 1,
      slug: 'linden',
    },
    {
      code: '010515169071',
      label: 'Lunden',
      provincie: 1,
      slug: 'lunden',
    },
    {
      code: '010515169080',
      label: 'Norderheistedt',
      provincie: 1,
      slug: 'norderheistedt',
    },
    {
      code: '010515169088',
      label: 'Pahlen',
      provincie: 1,
      slug: 'pahlen',
    },
    {
      code: '010515169092',
      label: 'Rehm-Flehde-Bargen',
      provincie: 1,
      slug: 'rehm-flehde-bargen',
    },
    {
      code: '010515169096',
      label: 'Sankt Annen',
      provincie: 1,
      slug: 'sankt-annen',
    },
    {
      code: '010515169100',
      label: 'Schalkholz',
      provincie: 1,
      slug: 'schalkholz',
    },
    {
      code: '010515169102',
      label: 'Schlichting',
      provincie: 1,
      slug: 'schlichting',
    },
    {
      code: '010515169114',
      label: 'Tellingstedt',
      provincie: 1,
      slug: 'tellingstedt',
    },
    {
      code: '010515169117',
      label: 'Tielenhemme',
      provincie: 1,
      slug: 'tielenhemme',
    },
    {
      code: '010515169120',
      label: 'Wallen',
      provincie: 1,
      slug: 'wallen',
    },
    {
      code: '010515169125',
      label: 'Welmbüttel',
      provincie: 1,
      slug: 'welmbuettel',
    },
    {
      code: '010515169131',
      label: 'Westerborstel',
      provincie: 1,
      slug: 'westerborstel',
    },
    {
      code: '010515169133',
      label: 'Wiemerstedt',
      provincie: 1,
      slug: 'wiemerstedt',
    },
    {
      code: '010515169136',
      label: 'Wrohm',
      provincie: 1,
      slug: 'wrohm',
    },
    {
      code: '010515169139',
      label: 'Süderdorf',
      provincie: 1,
      slug: 'suederdorf',
    },
    {
      code: '010515169141',
      label: 'Süderheistedt',
      provincie: 1,
      slug: 'suederheistedt',
    },
    {
      code: '010515172048',
      label: 'Hemmingstedt',
      provincie: 1,
      slug: 'hemmingstedt',
    },
    {
      code: '010515172067',
      label: 'Lieth',
      provincie: 1,
      slug: 'lieth',
    },
    {
      code: '010515172069',
      label: 'Lohe-Rickelshof',
      provincie: 1,
      slug: 'lohe-rickelshof',
    },
    {
      code: '010515172075',
      label: 'Neuenkirchen',
      provincie: 1,
      slug: 'neuenkirchen',
    },
    {
      code: '010515172081',
      label: 'Norderwöhrden',
      provincie: 1,
      slug: 'norderwoehrden',
    },
    {
      code: '010515172082',
      label: 'Nordhastedt',
      provincie: 1,
      slug: 'nordhastedt',
    },
    {
      code: '010515172087',
      label: 'Ostrohe',
      provincie: 1,
      slug: 'ostrohe',
    },
    {
      code: '010515172107',
      label: 'Stelle-Wittenwurth',
      provincie: 1,
      slug: 'stelle-wittenwurth',
    },
    {
      code: '010515172113',
      label: 'Wöhrden',
      provincie: 1,
      slug: 'woehrden',
    },
    {
      code: '010515172122',
      label: 'Weddingstedt',
      provincie: 1,
      slug: 'weddingstedt',
    },
    {
      code: '010515172130',
      label: 'Wesseln',
      provincie: 1,
      slug: 'wesseln',
    },
    {
      code: '010515175001',
      label: 'Albersdorf',
      provincie: 1,
      slug: 'albersdorf',
    },
    {
      code: '010515175002',
      label: 'Arkebek',
      provincie: 1,
      slug: 'arkebek',
    },
    {
      code: '010515175004',
      label: 'Bargenstedt',
      provincie: 1,
      slug: 'bargenstedt',
    },
    {
      code: '010515175006',
      label: 'Barlt',
      provincie: 1,
      slug: 'barlt',
    },
    {
      code: '010515175015',
      label: 'Bunsoh',
      provincie: 1,
      slug: 'bunsoh',
    },
    {
      code: '010515175017',
      label: 'Busenwurth',
      provincie: 1,
      slug: 'busenwurth',
    },
    {
      code: '010515175027',
      label: 'Elpersbüttel',
      provincie: 1,
      slug: 'elpersbuettel',
    },
    {
      code: '010515175028',
      label: 'Epenwöhrden',
      provincie: 1,
      slug: 'epenwoehrden',
    },
    {
      code: '010515175039',
      label: 'Gudendorf',
      provincie: 1,
      slug: 'gudendorf',
    },
    {
      code: '010515175054',
      label: 'Immenstedt',
      provincie: 1,
      slug: 'immenstedt',
    },
    {
      code: '010515175063',
      label: 'Krumstedt',
      provincie: 1,
      slug: 'krumstedt',
    },
    {
      code: '010515175074',
      label: 'Meldorf',
      provincie: 1,
      slug: 'meldorf',
    },
    {
      code: '010515175078',
      label: 'Nindorf',
      provincie: 1,
      slug: 'nindorf',
    },
    {
      code: '010515175083',
      label: 'Odderade',
      provincie: 1,
      slug: 'odderade',
    },
    {
      code: '010515175085',
      label: 'Offenbüttel',
      provincie: 1,
      slug: 'offenbuettel',
    },
    {
      code: '010515175086',
      label: 'Osterrade',
      provincie: 1,
      slug: 'osterrade',
    },
    {
      code: '010515175098',
      label: 'Sarzbüttel',
      provincie: 1,
      slug: 'sarzbuettel',
    },
    {
      code: '010515175099',
      label: 'Schafstedt',
      provincie: 1,
      slug: 'schafstedt',
    },
    {
      code: '010515175104',
      label: 'Schrum',
      provincie: 1,
      slug: 'schrum',
    },
    {
      code: '010515175126',
      label: 'Wennbüttel',
      provincie: 1,
      slug: 'wennbuettel',
    },
    {
      code: '010515175134',
      label: 'Windbergen',
      provincie: 1,
      slug: 'windbergen',
    },
    {
      code: '010515175135',
      label: 'Wolmersdorf',
      provincie: 1,
      slug: 'wolmersdorf',
    },
    {
      code: '010515175137',
      label: 'Nordermeldorf',
      provincie: 1,
      slug: 'nordermeldorf',
    },
    {
      code: '010515175138',
      label: 'Tensbüttel-Röst',
      provincie: 1,
      slug: 'tensbuettel-roest',
    },
    {
      code: '010515178013',
      label: 'Büsum',
      provincie: 1,
      slug: 'buesum',
    },
    {
      code: '010515178014',
      label: 'Büsumer Deichhausen',
      provincie: 1,
      slug: 'buesumer-deichhausen',
    },
    {
      code: '010515178033',
      label: 'Friedrichsgabekoog',
      provincie: 1,
      slug: 'friedrichsgabekoog',
    },
    {
      code: '010515178043',
      label: 'Hedwigenkoog',
      provincie: 1,
      slug: 'hedwigenkoog',
    },
    {
      code: '010515178045',
      label: 'Hellschen-Heringsand-Unterschaar',
      provincie: 1,
      slug: 'hellschen-heringsand-unterschaar',
    },
    {
      code: '010515178050',
      label: 'Hillgroven',
      provincie: 1,
      slug: 'hillgroven',
    },
    {
      code: '010515178079',
      label: 'Norddeich',
      provincie: 1,
      slug: 'norddeich',
    },
    {
      code: '010515178084',
      label: 'Oesterdeichstrich',
      provincie: 1,
      slug: 'oesterdeichstrich',
    },
    {
      code: '010515178093',
      label: 'Reinsbüttel',
      provincie: 1,
      slug: 'reinsbuettel',
    },
    {
      code: '010515178105',
      label: 'Schülp',
      provincie: 1,
      slug: 'schuelp',
    },
    {
      code: '010515178108',
      label: 'Strübbel',
      provincie: 1,
      slug: 'struebbel',
    },
    {
      code: '010515178109',
      label: 'Süderdeich',
      provincie: 1,
      slug: 'suederdeich',
    },
    {
      code: '010515178121',
      label: 'Warwerort',
      provincie: 1,
      slug: 'warwerort',
    },
    {
      code: '010515178127',
      label: 'Wesselburen',
      provincie: 1,
      slug: 'wesselburen',
    },
    {
      code: '010515178128',
      label: 'Wesselburener Deichhausen',
      provincie: 1,
      slug: 'wesselburener-deichhausen',
    },
    {
      code: '010515178129',
      label: 'Wesselburenerkoog',
      provincie: 1,
      slug: 'wesselburenerkoog',
    },
    {
      code: '010515178132',
      label: 'Westerdeichstrich',
      provincie: 1,
      slug: 'westerdeichstrich',
    },
    {
      code: '010515178140',
      label: 'Oesterwurth',
      provincie: 1,
      slug: 'oesterwurth',
    },
    {
      code: '010530032032',
      label: 'Geesthacht',
      provincie: 1,
      slug: 'geesthacht',
    },
    {
      code: '010530083083',
      label: 'Lauenburg/Elbe',
      provincie: 1,
      slug: 'lauenburg-elbe',
    },
    {
      code: '010530090090',
      label: 'Mölln',
      provincie: 1,
      slug: 'moelln',
    },
    {
      code: '010530100100',
      label: 'Ratzeburg',
      provincie: 1,
      slug: 'ratzeburg',
    },
    {
      code: '010530116116',
      label: 'Schwarzenbek',
      provincie: 1,
      slug: 'schwarzenbek',
    },
    {
      code: '010530129129',
      label: 'Wentorf bei Hamburg',
      provincie: 1,
      slug: 'wentorf-bei-hamburg',
    },
    {
      code: '010535308008',
      label: 'Behlendorf',
      provincie: 1,
      slug: 'behlendorf',
    },
    {
      code: '010535308009',
      label: 'Berkenthin',
      provincie: 1,
      slug: 'berkenthin',
    },
    {
      code: '010535308011',
      label: 'Bliestorf',
      provincie: 1,
      slug: 'bliestorf',
    },
    {
      code: '010535308024',
      label: 'Düchelsdorf',
      provincie: 1,
      slug: 'duechelsdorf',
    },
    {
      code: '010535308034',
      label: 'Göldenitz',
      provincie: 1,
      slug: 'goeldenitz',
    },
    {
      code: '010535308061',
      label: 'Kastorf',
      provincie: 1,
      slug: 'kastorf',
    },
    {
      code: '010535308067',
      label: 'Klempau',
      provincie: 1,
      slug: 'klempau',
    },
    {
      code: '010535308075',
      label: 'Krummesse',
      provincie: 1,
      slug: 'krummesse',
    },
    {
      code: '010535308094',
      label: 'Niendorf bei Berkenthin',
      provincie: 1,
      slug: 'niendorf-bei-berkenthin',
    },
    {
      code: '010535308103',
      label: 'Rondeshagen',
      provincie: 1,
      slug: 'rondeshagen',
    },
    {
      code: '010535308120',
      label: 'Sierksrade',
      provincie: 1,
      slug: 'sierksrade',
    },
    {
      code: '010535313002',
      label: 'Alt-Mölln',
      provincie: 1,
      slug: 'alt-moelln',
    },
    {
      code: '010535313005',
      label: 'Bälau',
      provincie: 1,
      slug: 'baelau',
    },
    {
      code: '010535313013',
      label: 'Borstorf',
      provincie: 1,
      slug: 'borstorf',
    },
    {
      code: '010535313014',
      label: 'Breitenfelde',
      provincie: 1,
      slug: 'breitenfelde',
    },
    {
      code: '010535313037',
      label: 'Grambek',
      provincie: 1,
      slug: 'grambek',
    },
    {
      code: '010535313056',
      label: 'Hornbek',
      provincie: 1,
      slug: 'hornbek',
    },
    {
      code: '010535313084',
      label: 'Lehmrade',
      provincie: 1,
      slug: 'lehmrade',
    },
    {
      code: '010535313095',
      label: 'Niendorf/Stecknitz',
      provincie: 1,
      slug: 'niendorf-stecknitz',
    },
    {
      code: '010535313113',
      label: 'Schretstaken',
      provincie: 1,
      slug: 'schretstaken',
    },
    {
      code: '010535313125',
      label: 'Talkau',
      provincie: 1,
      slug: 'talkau',
    },
    {
      code: '010535313134',
      label: 'Woltersdorf',
      provincie: 1,
      slug: 'woltersdorf',
    },
    {
      code: '010535318010',
      label: 'Besenthal',
      provincie: 1,
      slug: 'besenthal',
    },
    {
      code: '010535318015',
      label: 'Bröthen',
      provincie: 1,
      slug: 'broethen',
    },
    {
      code: '010535318020',
      label: 'Büchen',
      provincie: 1,
      slug: 'buechen',
    },
    {
      code: '010535318029',
      label: 'Fitzen',
      provincie: 1,
      slug: 'fitzen',
    },
    {
      code: '010535318035',
      label: 'Göttin',
      provincie: 1,
      slug: 'goettin',
    },
    {
      code: '010535318046',
      label: 'Gudow',
      provincie: 1,
      slug: 'gudow',
    },
    {
      code: '010535318048',
      label: 'Güster',
      provincie: 1,
      slug: 'guester',
    },
    {
      code: '010535318064',
      label: 'Klein Pampau',
      provincie: 1,
      slug: 'klein-pampau',
    },
    {
      code: '010535318080',
      label: 'Langenlehsten',
      provincie: 1,
      slug: 'langenlehsten',
    },
    {
      code: '010535318092',
      label: 'Müssen',
      provincie: 1,
      slug: 'muessen',
    },
    {
      code: '010535318104',
      label: 'Roseburg',
      provincie: 1,
      slug: 'roseburg',
    },
    {
      code: '010535318115',
      label: 'Schulendorf',
      provincie: 1,
      slug: 'schulendorf',
    },
    {
      code: '010535318119',
      label: 'Siebeneichen',
      provincie: 1,
      slug: 'siebeneichen',
    },
    {
      code: '010535318126',
      label: 'Tramm',
      provincie: 1,
      slug: 'tramm',
    },
    {
      code: '010535318132',
      label: 'Witzeeze',
      provincie: 1,
      slug: 'witzeeze',
    },
    {
      code: '010535323003',
      label: 'Aumühle',
      provincie: 1,
      slug: 'aumuehle',
    },
    {
      code: '010535323012',
      label: 'Börnsen',
      provincie: 1,
      slug: 'boernsen',
    },
    {
      code: '010535323023',
      label: 'Dassendorf',
      provincie: 1,
      slug: 'dassendorf',
    },
    {
      code: '010535323028',
      label: 'Escheburg',
      provincie: 1,
      slug: 'escheburg',
    },
    {
      code: '010535323050',
      label: 'Hamwarde',
      provincie: 1,
      slug: 'hamwarde',
    },
    {
      code: '010535323053',
      label: 'Hohenhorn',
      provincie: 1,
      slug: 'hohenhorn',
    },
    {
      code: '010535323072',
      label: 'Kröppelshagen-Fahrendorf',
      provincie: 1,
      slug: 'kroeppelshagen-fahrendorf',
    },
    {
      code: '010535323131',
      label: 'Wiershop',
      provincie: 1,
      slug: 'wiershop',
    },
    {
      code: '010535323133',
      label: 'Wohltorf',
      provincie: 1,
      slug: 'wohltorf',
    },
    {
      code: '010535323135',
      label: 'Worth',
      provincie: 1,
      slug: 'worth',
    },
    {
      code: '010535343006',
      label: 'Basedow',
      provincie: 1,
      slug: 'basedow',
    },
    {
      code: '010535343019',
      label: 'Buchhorst',
      provincie: 1,
      slug: 'buchhorst',
    },
    {
      code: '010535343022',
      label: 'Dalldorf',
      provincie: 1,
      slug: 'dalldorf',
    },
    {
      code: '010535343058',
      label: 'Juliusburg',
      provincie: 1,
      slug: 'juliusburg',
    },
    {
      code: '010535343073',
      label: 'Krüzen',
      provincie: 1,
      slug: 'kruezen',
    },
    {
      code: '010535343074',
      label: 'Krukow',
      provincie: 1,
      slug: 'krukow',
    },
    {
      code: '010535343082',
      label: 'Lanze',
      provincie: 1,
      slug: 'lanze',
    },
    {
      code: '010535343087',
      label: 'Lütau',
      provincie: 1,
      slug: 'luetau',
    },
    {
      code: '010535343111',
      label: 'Schnakenbek',
      provincie: 1,
      slug: 'schnakenbek',
    },
    {
      code: '010535343128',
      label: 'Wangelau',
      provincie: 1,
      slug: 'wangelau',
    },
    {
      code: '010535358001',
      label: 'Albsfelde',
      provincie: 1,
      slug: 'albsfelde',
    },
    {
      code: '010535358004',
      label: 'Bäk',
      provincie: 1,
      slug: 'baek',
    },
    {
      code: '010535358016',
      label: 'Brunsmark',
      provincie: 1,
      slug: 'brunsmark',
    },
    {
      code: '010535358018',
      label: 'Buchholz',
      provincie: 1,
      slug: 'buchholz-gemeinde',
    },
    {
      code: '010535358026',
      label: 'Einhaus',
      provincie: 1,
      slug: 'einhaus',
    },
    {
      code: '010535358030',
      label: 'Fredeburg',
      provincie: 1,
      slug: 'fredeburg',
    },
    {
      code: '010535358033',
      label: 'Giesensdorf',
      provincie: 1,
      slug: 'giesensdorf',
    },
    {
      code: '010535358040',
      label: 'Groß Disnack',
      provincie: 1,
      slug: 'gross-disnack',
    },
    {
      code: '010535358041',
      label: 'Groß Grönau',
      provincie: 1,
      slug: 'gross-groenau',
    },
    {
      code: '010535358043',
      label: 'Groß Sarau',
      provincie: 1,
      slug: 'gross-sarau',
    },
    {
      code: '010535358051',
      label: 'Harmsdorf',
      provincie: 1,
      slug: 'harmsdorf',
    },
    {
      code: '010535358054',
      label: 'Hollenbek',
      provincie: 1,
      slug: 'hollenbek',
    },
    {
      code: '010535358057',
      label: 'Horst',
      provincie: 1,
      slug: 'horst',
    },
    {
      code: '010535358062',
      label: 'Kittlitz',
      provincie: 1,
      slug: 'kittlitz',
    },
    {
      code: '010535358066',
      label: 'Klein Zecher',
      provincie: 1,
      slug: 'klein-zecher',
    },
    {
      code: '010535358078',
      label: 'Kulpin',
      provincie: 1,
      slug: 'kulpin',
    },
    {
      code: '010535358088',
      label: 'Mechow',
      provincie: 1,
      slug: 'mechow',
    },
    {
      code: '010535358093',
      label: 'Mustin',
      provincie: 1,
      slug: 'mustin',
    },
    {
      code: '010535358098',
      label: 'Pogeez',
      provincie: 1,
      slug: 'pogeez',
    },
    {
      code: '010535358102',
      label: 'Römnitz',
      provincie: 1,
      slug: 'roemnitz',
    },
    {
      code: '010535358107',
      label: 'Salem',
      provincie: 1,
      slug: 'salem',
    },
    {
      code: '010535358110',
      label: 'Schmilau',
      provincie: 1,
      slug: 'schmilau',
    },
    {
      code: '010535358117',
      label: 'Seedorf',
      provincie: 1,
      slug: 'seedorf',
    },
    {
      code: '010535358123',
      label: 'Sterley',
      provincie: 1,
      slug: 'sterley',
    },
    {
      code: '010535358136',
      label: 'Ziethen',
      provincie: 1,
      slug: 'ziethen',
    },
    {
      code: '010535373007',
      label: 'Basthorst',
      provincie: 1,
      slug: 'basthorst',
    },
    {
      code: '010535373017',
      label: 'Brunstorf',
      provincie: 1,
      slug: 'brunstorf',
    },
    {
      code: '010535373021',
      label: 'Dahmker',
      provincie: 1,
      slug: 'dahmker',
    },
    {
      code: '010535373027',
      label: 'Elmenhorst',
      provincie: 1,
      slug: 'elmenhorst',
    },
    {
      code: '010535373031',
      label: 'Fuhlenhagen',
      provincie: 1,
      slug: 'fuhlenhagen',
    },
    {
      code: '010535373036',
      label: 'Grabau',
      provincie: 1,
      slug: 'grabau',
    },
    {
      code: '010535373042',
      label: 'Groß Pampau',
      provincie: 1,
      slug: 'gross-pampau',
    },
    {
      code: '010535373045',
      label: 'Grove',
      provincie: 1,
      slug: 'grove',
    },
    {
      code: '010535373047',
      label: 'Gülzow',
      provincie: 1,
      slug: 'guelzow',
    },
    {
      code: '010535373049',
      label: 'Hamfelde',
      provincie: 1,
      slug: 'hamfelde',
    },
    {
      code: '010535373052',
      label: 'Havekost',
      provincie: 1,
      slug: 'havekost',
    },
    {
      code: '010535373059',
      label: 'Kankelau',
      provincie: 1,
      slug: 'kankelau',
    },
    {
      code: '010535373060',
      label: 'Kasseburg',
      provincie: 1,
      slug: 'kasseburg',
    },
    {
      code: '010535373070',
      label: 'Köthel',
      provincie: 1,
      slug: 'koethel',
    },
    {
      code: '010535373071',
      label: 'Kollow',
      provincie: 1,
      slug: 'kollow',
    },
    {
      code: '010535373076',
      label: 'Kuddewörde',
      provincie: 1,
      slug: 'kuddewoerde',
    },
    {
      code: '010535373089',
      label: 'Möhnsen',
      provincie: 1,
      slug: 'moehnsen',
    },
    {
      code: '010535373091',
      label: 'Mühlenrade',
      provincie: 1,
      slug: 'muehlenrade',
    },
    {
      code: '010535373106',
      label: 'Sahms',
      provincie: 1,
      slug: 'sahms',
    },
    {
      code: '010535391025',
      label: 'Duvensee',
      provincie: 1,
      slug: 'duvensee',
    },
    {
      code: '010535391038',
      label: 'Grinau',
      provincie: 1,
      slug: 'grinau',
    },
    {
      code: '010535391039',
      label: 'Groß Boden',
      provincie: 1,
      slug: 'gross-boden',
    },
    {
      code: '010535391044',
      label: 'Groß Schenkenberg',
      provincie: 1,
      slug: 'gross-schenkenberg',
    },
    {
      code: '010535391068',
      label: 'Klinkrade',
      provincie: 1,
      slug: 'klinkrade',
    },
    {
      code: '010535391069',
      label: 'Koberg',
      provincie: 1,
      slug: 'koberg',
    },
    {
      code: '010535391077',
      label: 'Kühsen',
      provincie: 1,
      slug: 'kuehsen',
    },
    {
      code: '010535391079',
      label: 'Labenz',
      provincie: 1,
      slug: 'labenz',
    },
    {
      code: '010535391081',
      label: 'Lankau',
      provincie: 1,
      slug: 'lankau',
    },
    {
      code: '010535391085',
      label: 'Linau',
      provincie: 1,
      slug: 'linau',
    },
    {
      code: '010535391086',
      label: 'Lüchow',
      provincie: 1,
      slug: 'luechow',
    },
    {
      code: '010535391096',
      label: 'Nusse',
      provincie: 1,
      slug: 'nusse',
    },
    {
      code: '010535391097',
      label: 'Panten',
      provincie: 1,
      slug: 'panten',
    },
    {
      code: '010535391099',
      label: 'Poggensee',
      provincie: 1,
      slug: 'poggensee',
    },
    {
      code: '010535391101',
      label: 'Ritzerau',
      provincie: 1,
      slug: 'ritzerau',
    },
    {
      code: '010535391108',
      label: 'Sandesneben',
      provincie: 1,
      slug: 'sandesneben',
    },
    {
      code: '010535391109',
      label: 'Schiphorst',
      provincie: 1,
      slug: 'schiphorst',
    },
    {
      code: '010535391112',
      label: 'Schönberg',
      provincie: 1,
      slug: 'schoenberg',
    },
    {
      code: '010535391114',
      label: 'Schürensöhlen',
      provincie: 1,
      slug: 'schuerensoehlen',
    },
    {
      code: '010535391118',
      label: 'Siebenbäumen',
      provincie: 1,
      slug: 'siebenbaeumen',
    },
    {
      code: '010535391121',
      label: 'Sirksfelde',
      provincie: 1,
      slug: 'sirksfelde',
    },
    {
      code: '010535391122',
      label: 'Steinhorst',
      provincie: 1,
      slug: 'steinhorst',
    },
    {
      code: '010535391124',
      label: 'Stubben',
      provincie: 1,
      slug: 'stubben',
    },
    {
      code: '010535391127',
      label: 'Walksfelde',
      provincie: 1,
      slug: 'walksfelde',
    },
    {
      code: '010535391130',
      label: 'Wentorf (Amt Sandesneben)',
      provincie: 1,
      slug: 'wentorf-amt-sandesneben',
    },
    {
      code: '010540033033',
      label: 'Friedrichstadt',
      provincie: 1,
      slug: 'friedrichstadt',
    },
    {
      code: '010540056056',
      label: 'Husum',
      provincie: 1,
      slug: 'husum',
    },
    {
      code: '010540108108',
      label: 'Reußenköge',
      provincie: 1,
      slug: 'reussenkoege',
    },
    {
      code: '010540138138',
      label: 'Tönning',
      provincie: 1,
      slug: 'toenning',
    },
    {
      code: '010540168168',
      label: 'Sylt',
      provincie: 1,
      slug: 'sylt',
    },
    {
      code: '010545417035',
      label: 'Kirchspiel Garding',
      provincie: 1,
      slug: 'kirchspiel-garding',
    },
    {
      code: '010545417036',
      label: 'Garding',
      provincie: 1,
      slug: 'garding',
    },
    {
      code: '010545417040',
      label: 'Grothusenkoog',
      provincie: 1,
      slug: 'grothusenkoog',
    },
    {
      code: '010545417063',
      label: 'Katharinenheerd',
      provincie: 1,
      slug: 'katharinenheerd',
    },
    {
      code: '010545417072',
      label: 'Kotzenbüll',
      provincie: 1,
      slug: 'kotzenbuell',
    },
    {
      code: '010545417090',
      label: 'Norderfriedrichskoog',
      provincie: 1,
      slug: 'norderfriedrichskoog',
    },
    {
      code: '010545417095',
      label: 'Oldenswort',
      provincie: 1,
      slug: 'oldenswort',
    },
    {
      code: '010545417100',
      label: 'Osterhever',
      provincie: 1,
      slug: 'osterhever',
    },
    {
      code: '010545417104',
      label: 'Poppenbüll',
      provincie: 1,
      slug: 'poppenbuell',
    },
    {
      code: '010545417113',
      label: 'Sankt Peter-Ording',
      provincie: 1,
      slug: 'sankt-peter-ording',
    },
    {
      code: '010545417134',
      label: 'Tating',
      provincie: 1,
      slug: 'tating',
    },
    {
      code: '010545417135',
      label: 'Tetenbüll',
      provincie: 1,
      slug: 'tetenbuell',
    },
    {
      code: '010545417140',
      label: 'Tümlauer Koog',
      provincie: 1,
      slug: 'tuemlauer-koog',
    },
    {
      code: '010545417145',
      label: 'Vollerwiek',
      provincie: 1,
      slug: 'vollerwiek',
    },
    {
      code: '010545417148',
      label: 'Welt',
      provincie: 1,
      slug: 'welt',
    },
    {
      code: '010545417150',
      label: 'Westerhever',
      provincie: 1,
      slug: 'westerhever',
    },
    {
      code: '010545439046',
      label: 'Hörnum (Sylt)',
      provincie: 1,
      slug: 'hoernum-sylt',
    },
    {
      code: '010545439061',
      label: 'Kampen (Sylt)',
      provincie: 1,
      slug: 'kampen-sylt',
    },
    {
      code: '010545439078',
      label: 'List auf Sylt',
      provincie: 1,
      slug: 'list-auf-sylt',
    },
    {
      code: '010545439149',
      label: 'Wenningstedt-Braderup (Sylt)',
      provincie: 1,
      slug: 'wenningstedt-braderup-sylt',
    },
    {
      code: '010545453003',
      label: 'Ahrenviöl',
      provincie: 1,
      slug: 'ahrenvioel',
    },
    {
      code: '010545453004',
      label: 'Ahrenviölfeld',
      provincie: 1,
      slug: 'ahrenvioelfeld',
    },
    {
      code: '010545453011',
      label: 'Behrendorf',
      provincie: 1,
      slug: 'behrendorf',
    },
    {
      code: '010545453013',
      label: 'Bondelum',
      provincie: 1,
      slug: 'bondelum',
    },
    {
      code: '010545453041',
      label: 'Haselund',
      provincie: 1,
      slug: 'haselund',
    },
    {
      code: '010545453057',
      label: 'Immenstedt',
      provincie: 1,
      slug: 'immenstedt-gemeinde',
    },
    {
      code: '010545453079',
      label: 'Löwenstedt',
      provincie: 1,
      slug: 'loewenstedt',
    },
    {
      code: '010545453092',
      label: 'Norstedt',
      provincie: 1,
      slug: 'norstedt',
    },
    {
      code: '010545453101',
      label: 'Oster-Ohrstedt',
      provincie: 1,
      slug: 'oster-ohrstedt',
    },
    {
      code: '010545453118',
      label: 'Schwesing',
      provincie: 1,
      slug: 'schwesing',
    },
    {
      code: '010545453123',
      label: 'Sollwitt',
      provincie: 1,
      slug: 'sollwitt',
    },
    {
      code: '010545453144',
      label: 'Viöl',
      provincie: 1,
      slug: 'vioel',
    },
    {
      code: '010545453152',
      label: 'Wester-Ohrstedt',
      provincie: 1,
      slug: 'wester-ohrstedt',
    },
    {
      code: '010545459039',
      label: 'Gröde',
      provincie: 1,
      slug: 'groede',
    },
    {
      code: '010545459050',
      label: 'Hallig Hooge',
      provincie: 1,
      slug: 'hallig-hooge',
    },
    {
      code: '010545459074',
      label: 'Langeneß',
      provincie: 1,
      slug: 'langeness',
    },
    {
      code: '010545459103',
      label: 'Pellworm',
      provincie: 1,
      slug: 'pellworm',
    },
    {
      code: '010545488005',
      label: 'Alkersum',
      provincie: 1,
      slug: 'alkersum',
    },
    {
      code: '010545488015',
      label: 'Borgsum',
      provincie: 1,
      slug: 'borgsum',
    },
    {
      code: '010545488025',
      label: 'Dunsum',
      provincie: 1,
      slug: 'dunsum',
    },
    {
      code: '010545488083',
      label: 'Midlum',
      provincie: 1,
      slug: 'midlum',
    },
    {
      code: '010545488085',
      label: 'Nebel',
      provincie: 1,
      slug: 'nebel',
    },
    {
      code: '010545488087',
      label: 'Nieblum',
      provincie: 1,
      slug: 'nieblum',
    },
    {
      code: '010545488089',
      label: 'Norddorf auf Amrum',
      provincie: 1,
      slug: 'norddorf-auf-amrum',
    },
    {
      code: '010545488094',
      label: 'Oevenum',
      provincie: 1,
      slug: 'oevenum',
    },
    {
      code: '010545488098',
      label: 'Oldsum',
      provincie: 1,
      slug: 'oldsum',
    },
    {
      code: '010545488129',
      label: 'Süderende',
      provincie: 1,
      slug: 'suederende',
    },
    {
      code: '010545488143',
      label: 'Utersum',
      provincie: 1,
      slug: 'utersum',
    },
    {
      code: '010545488158',
      label: 'Witsum',
      provincie: 1,
      slug: 'witsum',
    },
    {
      code: '010545488160',
      label: 'Wittdün auf Amrum',
      provincie: 1,
      slug: 'wittduen-auf-amrum',
    },
    {
      code: '010545488163',
      label: 'Wrixum',
      provincie: 1,
      slug: 'wrixum',
    },
    {
      code: '010545488164',
      label: 'Wyk auf Föhr',
      provincie: 1,
      slug: 'wyk-auf-foehr',
    },
    {
      code: '010545489001',
      label: 'Achtrup',
      provincie: 1,
      slug: 'achtrup',
    },
    {
      code: '010545489009',
      label: 'Aventoft',
      provincie: 1,
      slug: 'aventoft',
    },
    {
      code: '010545489016',
      label: 'Bosbüll',
      provincie: 1,
      slug: 'bosbuell',
    },
    {
      code: '010545489017',
      label: 'Braderup',
      provincie: 1,
      slug: 'braderup',
    },
    {
      code: '010545489018',
      label: 'Bramstedtlund',
      provincie: 1,
      slug: 'bramstedtlund',
    },
    {
      code: '010545489022',
      label: 'Dagebüll',
      provincie: 1,
      slug: 'dagebuell',
    },
    {
      code: '010545489027',
      label: 'Ellhöft',
      provincie: 1,
      slug: 'ellhoeft',
    },
    {
      code: '010545489034',
      label: 'Friedrich-Wilhelm-Lübke-Koog',
      provincie: 1,
      slug: 'friedrich-wilhelm-luebke-koog',
    },
    {
      code: '010545489048',
      label: 'Holm',
      provincie: 1,
      slug: 'holm',
    },
    {
      code: '010545489055',
      label: 'Humptrup',
      provincie: 1,
      slug: 'humptrup',
    },
    {
      code: '010545489062',
      label: 'Karlum',
      provincie: 1,
      slug: 'karlum',
    },
    {
      code: '010545489065',
      label: 'Klanxbüll',
      provincie: 1,
      slug: 'klanxbuell',
    },
    {
      code: '010545489068',
      label: 'Klixbüll',
      provincie: 1,
      slug: 'klixbuell',
    },
    {
      code: '010545489073',
      label: 'Ladelund',
      provincie: 1,
      slug: 'ladelund',
    },
    {
      code: '010545489076',
      label: 'Leck',
      provincie: 1,
      slug: 'leck',
    },
    {
      code: '010545489077',
      label: 'Lexgaard',
      provincie: 1,
      slug: 'lexgaard',
    },
    {
      code: '010545489086',
      label: 'Neukirchen',
      provincie: 1,
      slug: 'neukirchen',
    },
    {
      code: '010545489088',
      label: 'Niebüll',
      provincie: 1,
      slug: 'niebuell',
    },
    {
      code: '010545489109',
      label: 'Risum-Lindholm',
      provincie: 1,
      slug: 'risum-lindholm',
    },
    {
      code: '010545489110',
      label: 'Rodenäs',
      provincie: 1,
      slug: 'rodenaes',
    },
    {
      code: '010545489124',
      label: 'Sprakebüll',
      provincie: 1,
      slug: 'sprakebuell',
    },
    {
      code: '010545489125',
      label: 'Stadum',
      provincie: 1,
      slug: 'stadum',
    },
    {
      code: '010545489126',
      label: 'Stedesand',
      provincie: 1,
      slug: 'stedesand',
    },
    {
      code: '010545489131',
      label: 'Süderlügum',
      provincie: 1,
      slug: 'suederluegum',
    },
    {
      code: '010545489136',
      label: 'Tinningstedt',
      provincie: 1,
      slug: 'tinningstedt',
    },
    {
      code: '010545489142',
      label: 'Uphusum',
      provincie: 1,
      slug: 'uphusum',
    },
    {
      code: '010545489154',
      label: 'Westre',
      provincie: 1,
      slug: 'westre',
    },
    {
      code: '010545489165',
      label: 'Galmsbüll',
      provincie: 1,
      slug: 'galmsbuell',
    },
    {
      code: '010545489166',
      label: 'Emmelsbüll-Horsbüll',
      provincie: 1,
      slug: 'emmelsbuell-horsbuell',
    },
    {
      code: '010545489167',
      label: 'Enge-Sande',
      provincie: 1,
      slug: 'enge-sande',
    },
    {
      code: '010545492007',
      label: 'Arlewatt',
      provincie: 1,
      slug: 'arlewatt',
    },
    {
      code: '010545492023',
      label: 'Drage',
      provincie: 1,
      slug: 'drage',
    },
    {
      code: '010545492026',
      label: 'Elisabeth-Sophien-Koog',
      provincie: 1,
      slug: 'elisabeth-sophien-koog',
    },
    {
      code: '010545492032',
      label: 'Fresendelf',
      provincie: 1,
      slug: 'fresendelf',
    },
    {
      code: '010545492042',
      label: 'Hattstedt',
      provincie: 1,
      slug: 'hattstedt',
    },
    {
      code: '010545492043',
      label: 'Hattstedtermarsch',
      provincie: 1,
      slug: 'hattstedtermarsch',
    },
    {
      code: '010545492052',
      label: 'Horstedt',
      provincie: 1,
      slug: 'horstedt',
    },
    {
      code: '010545492054',
      label: 'Hude',
      provincie: 1,
      slug: 'hude',
    },
    {
      code: '010545492070',
      label: 'Koldenbüttel',
      provincie: 1,
      slug: 'koldenbuettel',
    },
    {
      code: '010545492084',
      label: 'Mildstedt',
      provincie: 1,
      slug: 'mildstedt',
    },
    {
      code: '010545492091',
      label: 'Nordstrand',
      provincie: 1,
      slug: 'nordstrand',
    },
    {
      code: '010545492096',
      label: 'Oldersbek',
      provincie: 1,
      slug: 'oldersbek',
    },
    {
      code: '010545492097',
      label: 'Olderup',
      provincie: 1,
      slug: 'olderup',
    },
    {
      code: '010545492099',
      label: 'Ostenfeld (Husum)',
      provincie: 1,
      slug: 'ostenfeld-husum',
    },
    {
      code: '010545492105',
      label: 'Ramstedt',
      provincie: 1,
      slug: 'ramstedt',
    },
    {
      code: '010545492106',
      label: 'Rantrum',
      provincie: 1,
      slug: 'rantrum',
    },
    {
      code: '010545492116',
      label: 'Schwabstedt',
      provincie: 1,
      slug: 'schwabstedt',
    },
    {
      code: '010545492119',
      label: 'Seeth',
      provincie: 1,
      slug: 'seeth',
    },
    {
      code: '010545492120',
      label: 'Simonsberg',
      provincie: 1,
      slug: 'simonsberg',
    },
    {
      code: '010545492130',
      label: 'Süderhöft',
      provincie: 1,
      slug: 'suederhoeft',
    },
    {
      code: '010545492132',
      label: 'Südermarsch',
      provincie: 1,
      slug: 'suedermarsch',
    },
    {
      code: '010545492141',
      label: 'Uelvesbüll',
      provincie: 1,
      slug: 'uelvesbuell',
    },
    {
      code: '010545492156',
      label: 'Winnert',
      provincie: 1,
      slug: 'winnert',
    },
    {
      code: '010545492157',
      label: 'Wisch',
      provincie: 1,
      slug: 'wisch',
    },
    {
      code: '010545492159',
      label: 'Wittbek',
      provincie: 1,
      slug: 'wittbek',
    },
    {
      code: '010545492161',
      label: 'Witzwort',
      provincie: 1,
      slug: 'witzwort',
    },
    {
      code: '010545492162',
      label: 'Wobbenbüll',
      provincie: 1,
      slug: 'wobbenbuell',
    },
    {
      code: '010545494002',
      label: 'Ahrenshöft',
      provincie: 1,
      slug: 'ahrenshoeft',
    },
    {
      code: '010545494006',
      label: 'Almdorf',
      provincie: 1,
      slug: 'almdorf',
    },
    {
      code: '010545494010',
      label: 'Bargum',
      provincie: 1,
      slug: 'bargum',
    },
    {
      code: '010545494012',
      label: 'Bohmstedt',
      provincie: 1,
      slug: 'bohmstedt',
    },
    {
      code: '010545494014',
      label: 'Bordelum',
      provincie: 1,
      slug: 'bordelum',
    },
    {
      code: '010545494019',
      label: 'Bredstedt',
      provincie: 1,
      slug: 'bredstedt',
    },
    {
      code: '010545494020',
      label: 'Breklum',
      provincie: 1,
      slug: 'breklum',
    },
    {
      code: '010545494024',
      label: 'Drelsdorf',
      provincie: 1,
      slug: 'drelsdorf',
    },
    {
      code: '010545494037',
      label: 'Goldebek',
      provincie: 1,
      slug: 'goldebek',
    },
    {
      code: '010545494038',
      label: 'Goldelund',
      provincie: 1,
      slug: 'goldelund',
    },
    {
      code: '010545494045',
      label: 'Högel',
      provincie: 1,
      slug: 'hoegel',
    },
    {
      code: '010545494059',
      label: 'Joldelund',
      provincie: 1,
      slug: 'joldelund',
    },
    {
      code: '010545494071',
      label: 'Kolkerheide',
      provincie: 1,
      slug: 'kolkerheide',
    },
    {
      code: '010545494075',
      label: 'Langenhorn',
      provincie: 1,
      slug: 'langenhorn',
    },
    {
      code: '010545494080',
      label: 'Lütjenholm',
      provincie: 1,
      slug: 'luetjenholm',
    },
    {
      code: '010545494093',
      label: 'Ockholm',
      provincie: 1,
      slug: 'ockholm',
    },
    {
      code: '010545494121',
      label: 'Sönnebüll',
      provincie: 1,
      slug: 'soennebuell',
    },
    {
      code: '010545494128',
      label: 'Struckum',
      provincie: 1,
      slug: 'struckum',
    },
    {
      code: '010545494146',
      label: 'Vollstedt',
      provincie: 1,
      slug: 'vollstedt',
    },
    {
      code: '010550001001',
      label: 'Ahrensbök',
      provincie: 1,
      slug: 'ahrensboek',
    },
    {
      code: '010550004004',
      label: 'Bad Schwartau',
      provincie: 1,
      slug: 'bad-schwartau',
    },
    {
      code: '010550007007',
      label: 'Bosau',
      provincie: 1,
      slug: 'bosau',
    },
    {
      code: '010550010010',
      label: 'Dahme',
      provincie: 1,
      slug: 'dahme',
    },
    {
      code: '010550012012',
      label: 'Eutin',
      provincie: 1,
      slug: 'eutin',
    },
    {
      code: '010550016016',
      label: 'Grömitz',
      provincie: 1,
      slug: 'groemitz',
    },
    {
      code: '010550018018',
      label: 'Grube',
      provincie: 1,
      slug: 'grube',
    },
    {
      code: '010550021021',
      label: 'Heiligenhafen',
      provincie: 1,
      slug: 'heiligenhafen',
    },
    {
      code: '010550025025',
      label: 'Kellenhusen (Ostsee)',
      provincie: 1,
      slug: 'kellenhusen-ostsee',
    },
    {
      code: '010550028028',
      label: 'Malente',
      provincie: 1,
      slug: 'malente',
    },
    {
      code: '010550032032',
      label: 'Neustadt in Holstein',
      provincie: 1,
      slug: 'neustadt-in-holstein',
    },
    {
      code: '010550033033',
      label: 'Oldenburg in Holstein',
      provincie: 1,
      slug: 'oldenburg-in-holstein',
    },
    {
      code: '010550035035',
      label: 'Ratekau',
      provincie: 1,
      slug: 'ratekau',
    },
    {
      code: '010550040040',
      label: 'Stockelsdorf',
      provincie: 1,
      slug: 'stockelsdorf',
    },
    {
      code: '010550041041',
      label: 'Süsel',
      provincie: 1,
      slug: 'suesel',
    },
    {
      code: '010550042042',
      label: 'Timmendorfer Strand',
      provincie: 1,
      slug: 'timmendorfer-strand',
    },
    {
      code: '010550044044',
      label: 'Scharbeutz',
      provincie: 1,
      slug: 'scharbeutz',
    },
    {
      code: '010550046046',
      label: 'Fehmarn',
      provincie: 1,
      slug: 'fehmarn',
    },
    {
      code: '010555543014',
      label: 'Göhl',
      provincie: 1,
      slug: 'goehl',
    },
    {
      code: '010555543015',
      label: 'Gremersdorf',
      provincie: 1,
      slug: 'gremersdorf',
    },
    {
      code: '010555543017',
      label: 'Großenbrode',
      provincie: 1,
      slug: 'grossenbrode',
    },
    {
      code: '010555543022',
      label: 'Heringsdorf',
      provincie: 1,
      slug: 'heringsdorf',
    },
    {
      code: '010555543031',
      label: 'Neukirchen',
      provincie: 1,
      slug: 'neukirchen-gemeinde',
    },
    {
      code: '010555543043',
      label: 'Wangels',
      provincie: 1,
      slug: 'wangels',
    },
    {
      code: '010555546006',
      label: 'Beschendorf',
      provincie: 1,
      slug: 'beschendorf',
    },
    {
      code: '010555546011',
      label: 'Damlos',
      provincie: 1,
      slug: 'damlos',
    },
    {
      code: '010555546020',
      label: 'Harmsdorf',
      provincie: 1,
      slug: 'harmsdorf-gemeinde',
    },
    {
      code: '010555546023',
      label: 'Kabelhorst',
      provincie: 1,
      slug: 'kabelhorst',
    },
    {
      code: '010555546027',
      label: 'Lensahn',
      provincie: 1,
      slug: 'lensahn',
    },
    {
      code: '010555546029',
      label: 'Manhagen',
      provincie: 1,
      slug: 'manhagen',
    },
    {
      code: '010555546036',
      label: 'Riepsdorf',
      provincie: 1,
      slug: 'riepsdorf',
    },
    {
      code: '010555591002',
      label: 'Altenkrempe',
      provincie: 1,
      slug: 'altenkrempe',
    },
    {
      code: '010555591024',
      label: 'Kasseedorf',
      provincie: 1,
      slug: 'kasseedorf',
    },
    {
      code: '010555591037',
      label: 'Schashagen',
      provincie: 1,
      slug: 'schashagen',
    },
    {
      code: '010555591038',
      label: 'Schönwalde am Bungsberg',
      provincie: 1,
      slug: 'schoenwalde-am-bungsberg',
    },
    {
      code: '010555591039',
      label: 'Sierksdorf',
      provincie: 1,
      slug: 'sierksdorf',
    },
    {
      code: '010560002002',
      label: 'Barmstedt',
      provincie: 1,
      slug: 'barmstedt',
    },
    {
      code: '010560005005',
      label: 'Bönningstedt',
      provincie: 1,
      slug: 'boenningstedt',
    },
    {
      code: '010560015015',
      label: 'Elmshorn',
      provincie: 1,
      slug: 'elmshorn',
    },
    {
      code: '010560018018',
      label: 'Halstenbek',
      provincie: 1,
      slug: 'halstenbek',
    },
    {
      code: '010560021021',
      label: 'Hasloh',
      provincie: 1,
      slug: 'hasloh',
    },
    {
      code: '010560025025',
      label: 'Helgoland',
      provincie: 1,
      slug: 'helgoland',
    },
    {
      code: '010560039039',
      label: 'Pinneberg',
      provincie: 1,
      slug: 'pinneberg',
    },
    {
      code: '010560041041',
      label: 'Quickborn',
      provincie: 1,
      slug: 'quickborn-stadt',
    },
    {
      code: '010560043043',
      label: 'Rellingen',
      provincie: 1,
      slug: 'rellingen',
    },
    {
      code: '010560044044',
      label: 'Schenefeld',
      provincie: 1,
      slug: 'schenefeld',
    },
    {
      code: '010560048048',
      label: 'Tornesch',
      provincie: 1,
      slug: 'tornesch',
    },
    {
      code: '010560049049',
      label: 'Uetersen',
      provincie: 1,
      slug: 'uetersen',
    },
    {
      code: '010560050050',
      label: 'Wedel',
      provincie: 1,
      slug: 'wedel',
    },
    {
      code: '010565616029',
      label: 'Klein Nordende',
      provincie: 1,
      slug: 'klein-nordende',
    },
    {
      code: '010565616030',
      label: 'Klein Offenseth-Sparrieshoop',
      provincie: 1,
      slug: 'klein-offenseth-sparrieshoop',
    },
    {
      code: '010565616031',
      label: 'Kölln-Reisiek',
      provincie: 1,
      slug: 'koelln-reisiek',
    },
    {
      code: '010565616033',
      label: 'Seester',
      provincie: 1,
      slug: 'seester',
    },
    {
      code: '010565616042',
      label: 'Raa-Besenbek',
      provincie: 1,
      slug: 'raa-besenbek',
    },
    {
      code: '010565616045',
      label: 'Seestermühe',
      provincie: 1,
      slug: 'seestermuehe',
    },
    {
      code: '010565616046',
      label: 'Seeth-Ekholt',
      provincie: 1,
      slug: 'seeth-ekholt',
    },
    {
      code: '010565636006',
      label: 'Bokel',
      provincie: 1,
      slug: 'bokel',
    },
    {
      code: '010565636010',
      label: 'Brande-Hörnerkirchen',
      provincie: 1,
      slug: 'brande-hoernerkirchen',
    },
    {
      code: '010565636038',
      label: 'Osterhorn',
      provincie: 1,
      slug: 'osterhorn',
    },
    {
      code: '010565636051',
      label: 'Westerhorn',
      provincie: 1,
      slug: 'westerhorn',
    },
    {
      code: '010565660003',
      label: 'Bevern',
      provincie: 1,
      slug: 'bevern',
    },
    {
      code: '010565660004',
      label: 'Bilsen',
      provincie: 1,
      slug: 'bilsen',
    },
    {
      code: '010565660008',
      label: 'Bokholt-Hanredder',
      provincie: 1,
      slug: 'bokholt-hanredder',
    },
    {
      code: '010565660011',
      label: 'Bullenkuhlen',
      provincie: 1,
      slug: 'bullenkuhlen',
    },
    {
      code: '010565660014',
      label: 'Ellerhoop',
      provincie: 1,
      slug: 'ellerhoop',
    },
    {
      code: '010565660017',
      label: 'Groß Offenseth-Aspern',
      provincie: 1,
      slug: 'gross-offenseth-aspern',
    },
    {
      code: '010565660022',
      label: 'Heede',
      provincie: 1,
      slug: 'heede',
    },
    {
      code: '010565660026',
      label: 'Hemdingen',
      provincie: 1,
      slug: 'hemdingen',
    },
    {
      code: '010565660034',
      label: 'Langeln',
      provincie: 1,
      slug: 'langeln',
    },
    {
      code: '010565660035',
      label: 'Lutzhorn',
      provincie: 1,
      slug: 'lutzhorn',
    },
    {
      code: '010565687009',
      label: 'Borstel-Hohenraden',
      provincie: 1,
      slug: 'borstel-hohenraden',
    },
    {
      code: '010565687013',
      label: 'Ellerbek',
      provincie: 1,
      slug: 'ellerbek',
    },
    {
      code: '010565687032',
      label: 'Kummerfeld',
      provincie: 1,
      slug: 'kummerfeld',
    },
    {
      code: '010565687040',
      label: 'Prisdorf',
      provincie: 1,
      slug: 'prisdorf',
    },
    {
      code: '010565687047',
      label: 'Tangstedt',
      provincie: 1,
      slug: 'tangstedt',
    },
    {
      code: '010565690001',
      label: 'Appen',
      provincie: 1,
      slug: 'appen',
    },
    {
      code: '010565690016',
      label: 'Groß Nordende',
      provincie: 1,
      slug: 'gross-nordende',
    },
    {
      code: '010565690019',
      label: 'Haselau',
      provincie: 1,
      slug: 'haselau',
    },
    {
      code: '010565690020',
      label: 'Haseldorf',
      provincie: 1,
      slug: 'haseldorf',
    },
    {
      code: '010565690023',
      label: 'Heidgraben',
      provincie: 1,
      slug: 'heidgraben',
    },
    {
      code: '010565690024',
      label: 'Heist',
      provincie: 1,
      slug: 'heist',
    },
    {
      code: '010565690027',
      label: 'Hetlingen',
      provincie: 1,
      slug: 'hetlingen',
    },
    {
      code: '010565690028',
      label: 'Holm',
      provincie: 1,
      slug: 'holm-gemeinde',
    },
    {
      code: '010565690036',
      label: 'Moorrege',
      provincie: 1,
      slug: 'moorrege',
    },
    {
      code: '010565690037',
      label: 'Neuendeich',
      provincie: 1,
      slug: 'neuendeich',
    },
    {
      code: '010570001001',
      label: 'Ascheberg (Holstein)',
      provincie: 1,
      slug: 'ascheberg-holstein',
    },
    {
      code: '010570008008',
      label: 'Bönebüttel',
      provincie: 1,
      slug: 'boenebuettel',
    },
    {
      code: '010570009009',
      label: 'Bösdorf',
      provincie: 1,
      slug: 'boesdorf',
    },
    {
      code: '010570057057',
      label: 'Plön',
      provincie: 1,
      slug: 'ploen',
    },
    {
      code: '010570062062',
      label: 'Preetz',
      provincie: 1,
      slug: 'preetz',
    },
    {
      code: '010570091091',
      label: 'Schwentinental',
      provincie: 1,
      slug: 'schwentinental',
    },
    {
      code: '010575727004',
      label: 'Behrensdorf (Ostsee)',
      provincie: 1,
      slug: 'behrensdorf-ostsee',
    },
    {
      code: '010575727007',
      label: 'Blekendorf',
      provincie: 1,
      slug: 'blekendorf',
    },
    {
      code: '010575727013',
      label: 'Dannau',
      provincie: 1,
      slug: 'dannau',
    },
    {
      code: '010575727021',
      label: 'Giekau',
      provincie: 1,
      slug: 'giekau',
    },
    {
      code: '010575727026',
      label: 'Helmstorf',
      provincie: 1,
      slug: 'helmstorf',
    },
    {
      code: '010575727027',
      label: 'Högsdorf',
      provincie: 1,
      slug: 'hoegsdorf',
    },
    {
      code: '010575727029',
      label: 'Hohenfelde',
      provincie: 1,
      slug: 'hohenfelde',
    },
    {
      code: '010575727030',
      label: 'Hohwacht (Ostsee)',
      provincie: 1,
      slug: 'hohwacht-ostsee',
    },
    {
      code: '010575727034',
      label: 'Kirchnüchel',
      provincie: 1,
      slug: 'kirchnuechel',
    },
    {
      code: '010575727035',
      label: 'Klamp',
      provincie: 1,
      slug: 'klamp',
    },
    {
      code: '010575727038',
      label: 'Kletkamp',
      provincie: 1,
      slug: 'kletkamp',
    },
    {
      code: '010575727048',
      label: 'Lütjenburg',
      provincie: 1,
      slug: 'luetjenburg',
    },
    {
      code: '010575727055',
      label: 'Panker',
      provincie: 1,
      slug: 'panker',
    },
    {
      code: '010575727076',
      label: 'Schwartbuck',
      provincie: 1,
      slug: 'schwartbuck',
    },
    {
      code: '010575727082',
      label: 'Tröndel',
      provincie: 1,
      slug: 'troendel',
    },
    {
      code: '010575739015',
      label: 'Dersau',
      provincie: 1,
      slug: 'dersau',
    },
    {
      code: '010575739017',
      label: 'Dörnick',
      provincie: 1,
      slug: 'doernick',
    },
    {
      code: '010575739022',
      label: 'Grebin',
      provincie: 1,
      slug: 'grebin',
    },
    {
      code: '010575739032',
      label: 'Kalübbe',
      provincie: 1,
      slug: 'kaluebbe',
    },
    {
      code: '010575739045',
      label: 'Lebrade',
      provincie: 1,
      slug: 'lebrade',
    },
    {
      code: '010575739053',
      label: 'Nehmten',
      provincie: 1,
      slug: 'nehmten',
    },
    {
      code: '010575739065',
      label: 'Rantzau',
      provincie: 1,
      slug: 'rantzau',
    },
    {
      code: '010575739067',
      label: 'Rathjensdorf',
      provincie: 1,
      slug: 'rathjensdorf',
    },
    {
      code: '010575739089',
      label: 'Wittmoldt',
      provincie: 1,
      slug: 'wittmoldt',
    },
    {
      code: '010575747002',
      label: 'Barmissen',
      provincie: 1,
      slug: 'barmissen',
    },
    {
      code: '010575747010',
      label: 'Boksee',
      provincie: 1,
      slug: 'boksee',
    },
    {
      code: '010575747011',
      label: 'Bothkamp',
      provincie: 1,
      slug: 'bothkamp',
    },
    {
      code: '010575747023',
      label: 'Großbarkau',
      provincie: 1,
      slug: 'grossbarkau',
    },
    {
      code: '010575747031',
      label: 'Honigsee',
      provincie: 1,
      slug: 'honigsee',
    },
    {
      code: '010575747033',
      label: 'Kirchbarkau',
      provincie: 1,
      slug: 'kirchbarkau',
    },
    {
      code: '010575747037',
      label: 'Klein Barkau',
      provincie: 1,
      slug: 'klein-barkau',
    },
    {
      code: '010575747042',
      label: 'Kühren',
      provincie: 1,
      slug: 'kuehren',
    },
    {
      code: '010575747046',
      label: 'Lehmkuhlen',
      provincie: 1,
      slug: 'lehmkuhlen',
    },
    {
      code: '010575747047',
      label: 'Löptin',
      provincie: 1,
      slug: 'loeptin',
    },
    {
      code: '010575747054',
      label: 'Nettelsee',
      provincie: 1,
      slug: 'nettelsee',
    },
    {
      code: '010575747058',
      label: 'Pohnsdorf',
      provincie: 1,
      slug: 'pohnsdorf',
    },
    {
      code: '010575747059',
      label: 'Postfeld',
      provincie: 1,
      slug: 'postfeld',
    },
    {
      code: '010575747066',
      label: 'Rastorf',
      provincie: 1,
      slug: 'rastorf',
    },
    {
      code: '010575747070',
      label: 'Schellhorn',
      provincie: 1,
      slug: 'schellhorn',
    },
    {
      code: '010575747084',
      label: 'Wahlstorf',
      provincie: 1,
      slug: 'wahlstorf',
    },
    {
      code: '010575747086',
      label: 'Warnau',
      provincie: 1,
      slug: 'warnau',
    },
    {
      code: '010575755003',
      label: 'Barsbek',
      provincie: 1,
      slug: 'barsbek',
    },
    {
      code: '010575755006',
      label: 'Bendfeld',
      provincie: 1,
      slug: 'bendfeld',
    },
    {
      code: '010575755012',
      label: 'Brodersdorf',
      provincie: 1,
      slug: 'brodersdorf',
    },
    {
      code: '010575755018',
      label: 'Fahren',
      provincie: 1,
      slug: 'fahren',
    },
    {
      code: '010575755020',
      label: 'Fiefbergen',
      provincie: 1,
      slug: 'fiefbergen',
    },
    {
      code: '010575755028',
      label: 'Höhndorf',
      provincie: 1,
      slug: 'hoehndorf',
    },
    {
      code: '010575755039',
      label: 'Köhn',
      provincie: 1,
      slug: 'koehn',
    },
    {
      code: '010575755040',
      label: 'Krokau',
      provincie: 1,
      slug: 'krokau',
    },
    {
      code: '010575755041',
      label: 'Krummbek',
      provincie: 1,
      slug: 'krummbek',
    },
    {
      code: '010575755043',
      label: 'Laboe',
      provincie: 1,
      slug: 'laboe',
    },
    {
      code: '010575755049',
      label: 'Lutterbek',
      provincie: 1,
      slug: 'lutterbek',
    },
    {
      code: '010575755056',
      label: 'Passade',
      provincie: 1,
      slug: 'passade',
    },
    {
      code: '010575755060',
      label: 'Prasdorf',
      provincie: 1,
      slug: 'prasdorf',
    },
    {
      code: '010575755063',
      label: 'Probsteierhagen',
      provincie: 1,
      slug: 'probsteierhagen',
    },
    {
      code: '010575755073',
      label: 'Schönberg (Holstein)',
      provincie: 1,
      slug: 'schoenberg-holstein',
    },
    {
      code: '010575755078',
      label: 'Stakendorf',
      provincie: 1,
      slug: 'stakendorf',
    },
    {
      code: '010575755079',
      label: 'Stein',
      provincie: 1,
      slug: 'stein',
    },
    {
      code: '010575755081',
      label: 'Stoltenberg',
      provincie: 1,
      slug: 'stoltenberg',
    },
    {
      code: '010575755087',
      label: 'Wendtorf',
      provincie: 1,
      slug: 'wendtorf',
    },
    {
      code: '010575755088',
      label: 'Wisch',
      provincie: 1,
      slug: 'wisch-gemeinde',
    },
    {
      code: '010575775016',
      label: 'Dobersdorf',
      provincie: 1,
      slug: 'dobersdorf',
    },
    {
      code: '010575775044',
      label: 'Lammershagen',
      provincie: 1,
      slug: 'lammershagen',
    },
    {
      code: '010575775050',
      label: 'Martensrade',
      provincie: 1,
      slug: 'martensrade',
    },
    {
      code: '010575775052',
      label: 'Mucheln',
      provincie: 1,
      slug: 'mucheln',
    },
    {
      code: '010575775072',
      label: 'Schlesen',
      provincie: 1,
      slug: 'schlesen',
    },
    {
      code: '010575775077',
      label: 'Selent',
      provincie: 1,
      slug: 'selent',
    },
    {
      code: '010575775090',
      label: 'Fargau-Pratjau',
      provincie: 1,
      slug: 'fargau-pratjau',
    },
    {
      code: '010575782025',
      label: 'Heikendorf',
      provincie: 1,
      slug: 'heikendorf',
    },
    {
      code: '010575782051',
      label: 'Mönkeberg',
      provincie: 1,
      slug: 'moenkeberg',
    },
    {
      code: '010575782074',
      label: 'Schönkirchen',
      provincie: 1,
      slug: 'schoenkirchen',
    },
    {
      code: '010575785005',
      label: 'Belau',
      provincie: 1,
      slug: 'belau',
    },
    {
      code: '010575785024',
      label: 'Großharrie',
      provincie: 1,
      slug: 'grossharrie',
    },
    {
      code: '010575785068',
      label: 'Rendswühren',
      provincie: 1,
      slug: 'rendswuehren',
    },
    {
      code: '010575785069',
      label: 'Ruhwinkel',
      provincie: 1,
      slug: 'ruhwinkel',
    },
    {
      code: '010575785071',
      label: 'Schillsdorf',
      provincie: 1,
      slug: 'schillsdorf',
    },
    {
      code: '010575785080',
      label: 'Stolpe',
      provincie: 1,
      slug: 'stolpe',
    },
    {
      code: '010575785083',
      label: 'Tasdorf',
      provincie: 1,
      slug: 'tasdorf',
    },
    {
      code: '010575785085',
      label: 'Wankendorf',
      provincie: 1,
      slug: 'wankendorf',
    },
    {
      code: '010580005005',
      label: 'Altenholz',
      provincie: 1,
      slug: 'altenholz',
    },
    {
      code: '010580034034',
      label: 'Büdelsdorf',
      provincie: 1,
      slug: 'buedelsdorf',
    },
    {
      code: '010580043043',
      label: 'Eckernförde',
      provincie: 1,
      slug: 'eckernfoerde',
    },
    {
      code: '010580092092',
      label: 'Kronshagen',
      provincie: 1,
      slug: 'kronshagen',
    },
    {
      code: '010580135135',
      label: 'Rendsburg',
      provincie: 1,
      slug: 'rendsburg',
    },
    {
      code: '010580169169',
      label: 'Wasbek',
      provincie: 1,
      slug: 'wasbek',
    },
    {
      code: '010585803001',
      label: 'Achterwehr',
      provincie: 1,
      slug: 'achterwehr',
    },
    {
      code: '010585803028',
      label: 'Bredenbek',
      provincie: 1,
      slug: 'bredenbek',
    },
    {
      code: '010585803050',
      label: 'Felde',
      provincie: 1,
      slug: 'felde',
    },
    {
      code: '010585803093',
      label: 'Krummwisch',
      provincie: 1,
      slug: 'krummwisch',
    },
    {
      code: '010585803104',
      label: 'Melsdorf',
      provincie: 1,
      slug: 'melsdorf',
    },
    {
      code: '010585803126',
      label: 'Ottendorf',
      provincie: 1,
      slug: 'ottendorf',
    },
    {
      code: '010585803130',
      label: 'Quarnbek',
      provincie: 1,
      slug: 'quarnbek',
    },
    {
      code: '010585803171',
      label: 'Westensee',
      provincie: 1,
      slug: 'westensee',
    },
    {
      code: '010585822037',
      label: 'Dänischenhagen',
      provincie: 1,
      slug: 'daenischenhagen',
    },
    {
      code: '010585822116',
      label: 'Noer',
      provincie: 1,
      slug: 'noer',
    },
    {
      code: '010585822150',
      label: 'Schwedeneck',
      provincie: 1,
      slug: 'schwedeneck',
    },
    {
      code: '010585822157',
      label: 'Strande',
      provincie: 1,
      slug: 'strande',
    },
    {
      code: '010585824051',
      label: 'Felm',
      provincie: 1,
      slug: 'felm',
    },
    {
      code: '010585824058',
      label: 'Gettorf',
      provincie: 1,
      slug: 'gettorf',
    },
    {
      code: '010585824096',
      label: 'Lindau',
      provincie: 1,
      slug: 'lindau',
    },
    {
      code: '010585824110',
      label: 'Neudorf-Bornstein',
      provincie: 1,
      slug: 'neudorf-bornstein',
    },
    {
      code: '010585824112',
      label: 'Neuwittenbek',
      provincie: 1,
      slug: 'neuwittenbek',
    },
    {
      code: '010585824121',
      label: 'Osdorf',
      provincie: 1,
      slug: 'osdorf',
    },
    {
      code: '010585824142',
      label: 'Schinkel',
      provincie: 1,
      slug: 'schinkel',
    },
    {
      code: '010585824165',
      label: 'Tüttendorf',
      provincie: 1,
      slug: 'tuettendorf',
    },
    {
      code: '010585833003',
      label: 'Alt Duvenstedt',
      provincie: 1,
      slug: 'alt-duvenstedt',
    },
    {
      code: '010585833054',
      label: 'Fockbek',
      provincie: 1,
      slug: 'fockbek',
    },
    {
      code: '010585833118',
      label: 'Nübbel',
      provincie: 1,
      slug: 'nuebbel',
    },
    {
      code: '010585833136',
      label: 'Rickert',
      provincie: 1,
      slug: 'rickert',
    },
    {
      code: '010585847010',
      label: 'Bargstall',
      provincie: 1,
      slug: 'bargstall',
    },
    {
      code: '010585847029',
      label: 'Breiholz',
      provincie: 1,
      slug: 'breiholz',
    },
    {
      code: '010585847036',
      label: 'Christiansholm',
      provincie: 1,
      slug: 'christiansholm',
    },
    {
      code: '010585847047',
      label: 'Elsdorf-Westermühlen',
      provincie: 1,
      slug: 'elsdorf-westermuehlen',
    },
    {
      code: '010585847055',
      label: 'Friedrichsgraben',
      provincie: 1,
      slug: 'friedrichsgraben',
    },
    {
      code: '010585847056',
      label: 'Friedrichsholm',
      provincie: 1,
      slug: 'friedrichsholm',
    },
    {
      code: '010585847070',
      label: 'Hamdorf',
      provincie: 1,
      slug: 'hamdorf',
    },
    {
      code: '010585847078',
      label: 'Hohn',
      provincie: 1,
      slug: 'hohn',
    },
    {
      code: '010585847089',
      label: 'Königshügel',
      provincie: 1,
      slug: 'koenigshuegel',
    },
    {
      code: '010585847097',
      label: 'Lohe-Föhrden',
      provincie: 1,
      slug: 'lohe-foehrden',
    },
    {
      code: '010585847129',
      label: 'Prinzenmoor',
      provincie: 1,
      slug: 'prinzenmoor',
    },
    {
      code: '010585847154',
      label: 'Sophienhamm',
      provincie: 1,
      slug: 'sophienhamm',
    },
    {
      code: '010585853031',
      label: 'Brinjahe',
      provincie: 1,
      slug: 'brinjahe',
    },
    {
      code: '010585853048',
      label: 'Embühren',
      provincie: 1,
      slug: 'embuehren',
    },
    {
      code: '010585853068',
      label: 'Haale',
      provincie: 1,
      slug: 'haale',
    },
    {
      code: '010585853071',
      label: 'Hamweddel',
      provincie: 1,
      slug: 'hamweddel',
    },
    {
      code: '010585853075',
      label: 'Hörsten',
      provincie: 1,
      slug: 'hoersten',
    },
    {
      code: '010585853086',
      label: 'Jevenstedt',
      provincie: 1,
      slug: 'jevenstedt',
    },
    {
      code: '010585853101',
      label: 'Luhnstedt',
      provincie: 1,
      slug: 'luhnstedt',
    },
    {
      code: '010585853148',
      label: 'Schülp b.Rendsburg',
      provincie: 1,
      slug: 'schuelp-b-rendsburg',
    },
    {
      code: '010585853155',
      label: 'Stafstedt',
      provincie: 1,
      slug: 'stafstedt',
    },
    {
      code: '010585853172',
      label: 'Westerrönfeld',
      provincie: 1,
      slug: 'westerroenfeld',
    },
    {
      code: '010585864011',
      label: 'Bargstedt',
      provincie: 1,
      slug: 'bargstedt',
    },
    {
      code: '010585864021',
      label: 'Bokel',
      provincie: 1,
      slug: 'bokel-gemeinde',
    },
    {
      code: '010585864023',
      label: 'Borgdorf-Seedorf',
      provincie: 1,
      slug: 'borgdorf-seedorf',
    },
    {
      code: '010585864027',
      label: 'Brammer',
      provincie: 1,
      slug: 'brammer',
    },
    {
      code: '010585864038',
      label: 'Dätgen',
      provincie: 1,
      slug: 'daetgen',
    },
    {
      code: '010585864045',
      label: 'Eisendorf',
      provincie: 1,
      slug: 'eisendorf',
    },
    {
      code: '010585864046',
      label: 'Ellerdorf',
      provincie: 1,
      slug: 'ellerdorf',
    },
    {
      code: '010585864049',
      label: 'Emkendorf',
      provincie: 1,
      slug: 'emkendorf',
    },
    {
      code: '010585864059',
      label: 'Gnutz',
      provincie: 1,
      slug: 'gnutz',
    },
    {
      code: '010585864065',
      label: 'Groß Vollstedt',
      provincie: 1,
      slug: 'gross-vollstedt',
    },
    {
      code: '010585864091',
      label: 'Krogaspe',
      provincie: 1,
      slug: 'krogaspe',
    },
    {
      code: '010585864094',
      label: 'Langwedel',
      provincie: 1,
      slug: 'langwedel',
    },
    {
      code: '010585864117',
      label: 'Nortorf',
      provincie: 1,
      slug: 'nortorf',
    },
    {
      code: '010585864120',
      label: 'Oldenhütten',
      provincie: 1,
      slug: 'oldenhuetten',
    },
    {
      code: '010585864147',
      label: 'Schülp b.Nortorf',
      provincie: 1,
      slug: 'schuelp-b-nortorf',
    },
    {
      code: '010585864163',
      label: 'Timmaspe',
      provincie: 1,
      slug: 'timmaspe',
    },
    {
      code: '010585864168',
      label: 'Warder',
      provincie: 1,
      slug: 'warder',
    },
    {
      code: '010585888026',
      label: 'Bovenau',
      provincie: 1,
      slug: 'bovenau',
    },
    {
      code: '010585888073',
      label: 'Haßmoor',
      provincie: 1,
      slug: 'hassmoor',
    },
    {
      code: '010585888122',
      label: 'Ostenfeld (Rendsburg)',
      provincie: 1,
      slug: 'ostenfeld-rendsburg',
    },
    {
      code: '010585888124',
      label: 'Osterrönfeld',
      provincie: 1,
      slug: 'osterroenfeld',
    },
    {
      code: '010585888132',
      label: 'Rade b.Rendsburg',
      provincie: 1,
      slug: 'rade-b-rendsburg',
    },
    {
      code: '010585888140',
      label: 'Schacht-Audorf',
      provincie: 1,
      slug: 'schacht-audorf',
    },
    {
      code: '010585888146',
      label: 'Schülldorf',
      provincie: 1,
      slug: 'schuelldorf',
    },
    {
      code: '010585889016',
      label: 'Bissee',
      provincie: 1,
      slug: 'bissee',
    },
    {
      code: '010585889022',
      label: 'Bordesholm',
      provincie: 1,
      slug: 'bordesholm',
    },
    {
      code: '010585889033',
      label: 'Brügge',
      provincie: 1,
      slug: 'bruegge',
    },
    {
      code: '010585889063',
      label: 'Grevenkrug',
      provincie: 1,
      slug: 'grevenkrug',
    },
    {
      code: '010585889064',
      label: 'Groß Buchwald',
      provincie: 1,
      slug: 'gross-buchwald',
    },
    {
      code: '010585889076',
      label: 'Hoffeld',
      provincie: 1,
      slug: 'hoffeld',
    },
    {
      code: '010585889098',
      label: 'Loop',
      provincie: 1,
      slug: 'loop',
    },
    {
      code: '010585889108',
      label: 'Mühbrook',
      provincie: 1,
      slug: 'muehbrook',
    },
    {
      code: '010585889109',
      label: 'Negenharrie',
      provincie: 1,
      slug: 'negenharrie',
    },
    {
      code: '010585889133',
      label: 'Reesdorf',
      provincie: 1,
      slug: 'reesdorf',
    },
    {
      code: '010585889143',
      label: 'Schmalstede',
      provincie: 1,
      slug: 'schmalstede',
    },
    {
      code: '010585889144',
      label: 'Schönbek',
      provincie: 1,
      slug: 'schoenbek',
    },
    {
      code: '010585889153',
      label: 'Sören',
      provincie: 1,
      slug: 'soeren',
    },
    {
      code: '010585889170',
      label: 'Wattenbek',
      provincie: 1,
      slug: 'wattenbek',
    },
    {
      code: '010585890008',
      label: 'Ascheffel',
      provincie: 1,
      slug: 'ascheffel',
    },
    {
      code: '010585890024',
      label: 'Borgstedt',
      provincie: 1,
      slug: 'borgstedt',
    },
    {
      code: '010585890030',
      label: 'Brekendorf',
      provincie: 1,
      slug: 'brekendorf',
    },
    {
      code: '010585890035',
      label: 'Bünsdorf',
      provincie: 1,
      slug: 'buensdorf',
    },
    {
      code: '010585890039',
      label: 'Damendorf',
      provincie: 1,
      slug: 'damendorf',
    },
    {
      code: '010585890066',
      label: 'Groß Wittensee',
      provincie: 1,
      slug: 'gross-wittensee',
    },
    {
      code: '010585890069',
      label: 'Haby',
      provincie: 1,
      slug: 'haby',
    },
    {
      code: '010585890080',
      label: 'Holtsee',
      provincie: 1,
      slug: 'holtsee',
    },
    {
      code: '010585890081',
      label: 'Holzbunge',
      provincie: 1,
      slug: 'holzbunge',
    },
    {
      code: '010585890083',
      label: 'Hütten',
      provincie: 1,
      slug: 'huetten',
    },
    {
      code: '010585890088',
      label: 'Klein Wittensee',
      provincie: 1,
      slug: 'klein-wittensee',
    },
    {
      code: '010585890111',
      label: 'Neu Duvenstedt',
      provincie: 1,
      slug: 'neu-duvenstedt',
    },
    {
      code: '010585890123',
      label: 'Osterby',
      provincie: 1,
      slug: 'osterby',
    },
    {
      code: '010585890127',
      label: 'Owschlag',
      provincie: 1,
      slug: 'owschlag',
    },
    {
      code: '010585890152',
      label: 'Sehestedt',
      provincie: 1,
      slug: 'sehestedt',
    },
    {
      code: '010585890175',
      label: 'Ahlefeld-Bistensee',
      provincie: 1,
      slug: 'ahlefeld-bistensee',
    },
    {
      code: '010585893004',
      label: 'Altenhof',
      provincie: 1,
      slug: 'altenhof',
    },
    {
      code: '010585893012',
      label: 'Barkelsby',
      provincie: 1,
      slug: 'barkelsby',
    },
    {
      code: '010585893032',
      label: 'Brodersby',
      provincie: 1,
      slug: 'brodersby',
    },
    {
      code: '010585893040',
      label: 'Damp',
      provincie: 1,
      slug: 'damp',
    },
    {
      code: '010585893042',
      label: 'Dörphof',
      provincie: 1,
      slug: 'doerphof',
    },
    {
      code: '010585893052',
      label: 'Fleckeby',
      provincie: 1,
      slug: 'fleckeby',
    },
    {
      code: '010585893057',
      label: 'Gammelby',
      provincie: 1,
      slug: 'gammelby',
    },
    {
      code: '010585893067',
      label: 'Güby',
      provincie: 1,
      slug: 'gueby',
    },
    {
      code: '010585893082',
      label: 'Holzdorf',
      provincie: 1,
      slug: 'holzdorf',
    },
    {
      code: '010585893084',
      label: 'Hummelfeld',
      provincie: 1,
      slug: 'hummelfeld',
    },
    {
      code: '010585893087',
      label: 'Karby',
      provincie: 1,
      slug: 'karby',
    },
    {
      code: '010585893090',
      label: 'Kosel',
      provincie: 1,
      slug: 'kosel',
    },
    {
      code: '010585893099',
      label: 'Loose',
      provincie: 1,
      slug: 'loose',
    },
    {
      code: '010585893102',
      label: 'Goosefeld',
      provincie: 1,
      slug: 'goosefeld',
    },
    {
      code: '010585893137',
      label: 'Rieseby',
      provincie: 1,
      slug: 'rieseby',
    },
    {
      code: '010585893162',
      label: 'Thumby',
      provincie: 1,
      slug: 'thumby',
    },
    {
      code: '010585893166',
      label: 'Waabs',
      provincie: 1,
      slug: 'waabs',
    },
    {
      code: '010585893173',
      label: 'Windeby',
      provincie: 1,
      slug: 'windeby',
    },
    {
      code: '010585893174',
      label: 'Winnemark',
      provincie: 1,
      slug: 'winnemark',
    },
    {
      code: '010585895007',
      label: 'Arpsdorf',
      provincie: 1,
      slug: 'arpsdorf',
    },
    {
      code: '010585895009',
      label: 'Aukrug',
      provincie: 1,
      slug: 'aukrug',
    },
    {
      code: '010585895013',
      label: 'Beldorf',
      provincie: 1,
      slug: 'beldorf',
    },
    {
      code: '010585895014',
      label: 'Bendorf',
      provincie: 1,
      slug: 'bendorf',
    },
    {
      code: '010585895015',
      label: 'Beringstedt',
      provincie: 1,
      slug: 'beringstedt',
    },
    {
      code: '010585895025',
      label: 'Bornholt',
      provincie: 1,
      slug: 'bornholt',
    },
    {
      code: '010585895044',
      label: 'Ehndorf',
      provincie: 1,
      slug: 'ehndorf',
    },
    {
      code: '010585895061',
      label: 'Gokels',
      provincie: 1,
      slug: 'gokels',
    },
    {
      code: '010585895062',
      label: 'Grauel',
      provincie: 1,
      slug: 'grauel',
    },
    {
      code: '010585895072',
      label: 'Hanerau-Hademarschen',
      provincie: 1,
      slug: 'hanerau-hademarschen',
    },
    {
      code: '010585895074',
      label: 'Heinkenborstel',
      provincie: 1,
      slug: 'heinkenborstel',
    },
    {
      code: '010585895077',
      label: 'Hohenwestedt',
      provincie: 1,
      slug: 'hohenwestedt',
    },
    {
      code: '010585895085',
      label: 'Jahrsdorf',
      provincie: 1,
      slug: 'jahrsdorf',
    },
    {
      code: '010585895100',
      label: 'Lütjenwestedt',
      provincie: 1,
      slug: 'luetjenwestedt',
    },
    {
      code: '010585895103',
      label: 'Meezen',
      provincie: 1,
      slug: 'meezen',
    },
    {
      code: '010585895106',
      label: 'Mörel',
      provincie: 1,
      slug: 'moerel',
    },
    {
      code: '010585895113',
      label: 'Nienborstel',
      provincie: 1,
      slug: 'nienborstel',
    },
    {
      code: '010585895115',
      label: 'Nindorf',
      provincie: 1,
      slug: 'nindorf-gemeinde',
    },
    {
      code: '010585895119',
      label: 'Oldenbüttel',
      provincie: 1,
      slug: 'oldenbuettel',
    },
    {
      code: '010585895125',
      label: 'Osterstedt',
      provincie: 1,
      slug: 'osterstedt',
    },
    {
      code: '010585895128',
      label: 'Padenstedt',
      provincie: 1,
      slug: 'padenstedt',
    },
    {
      code: '010585895131',
      label: 'Rade b.Hohenwestedt',
      provincie: 1,
      slug: 'rade-b-hohenwestedt',
    },
    {
      code: '010585895134',
      label: 'Remmels',
      provincie: 1,
      slug: 'remmels',
    },
    {
      code: '010585895151',
      label: 'Seefeld',
      provincie: 1,
      slug: 'seefeld',
    },
    {
      code: '010585895156',
      label: 'Steenfeld',
      provincie: 1,
      slug: 'steenfeld',
    },
    {
      code: '010585895158',
      label: 'Tackesdorf',
      provincie: 1,
      slug: 'tackesdorf',
    },
    {
      code: '010585895159',
      label: 'Tappendorf',
      provincie: 1,
      slug: 'tappendorf',
    },
    {
      code: '010585895161',
      label: 'Thaden',
      provincie: 1,
      slug: 'thaden',
    },
    {
      code: '010585895164',
      label: 'Todenbüttel',
      provincie: 1,
      slug: 'todenbuettel',
    },
    {
      code: '010585895167',
      label: 'Wapelfeld',
      provincie: 1,
      slug: 'wapelfeld',
    },
    {
      code: '010585896018',
      label: 'Blumenthal',
      provincie: 1,
      slug: 'blumenthal',
    },
    {
      code: '010585896019',
      label: 'Böhnhusen',
      provincie: 1,
      slug: 'boehnhusen',
    },
    {
      code: '010585896053',
      label: 'Flintbek',
      provincie: 1,
      slug: 'flintbek',
    },
    {
      code: '010585896105',
      label: 'Mielkendorf',
      provincie: 1,
      slug: 'mielkendorf',
    },
    {
      code: '010585896107',
      label: 'Molfsee',
      provincie: 1,
      slug: 'molfsee',
    },
    {
      code: '010585896138',
      label: 'Rodenbek',
      provincie: 1,
      slug: 'rodenbek',
    },
    {
      code: '010585896139',
      label: 'Rumohr',
      provincie: 1,
      slug: 'rumohr',
    },
    {
      code: '010585896141',
      label: 'Schierensee',
      provincie: 1,
      slug: 'schierensee',
    },
    {
      code: '010585896145',
      label: 'Schönhorst',
      provincie: 1,
      slug: 'schoenhorst',
    },
    {
      code: '010585896160',
      label: 'Techelsdorf',
      provincie: 1,
      slug: 'techelsdorf',
    },
    {
      code: '010590045045',
      label: 'Kappeln',
      provincie: 1,
      slug: 'kappeln',
    },
    {
      code: '010590075075',
      label: 'Schleswig',
      provincie: 1,
      slug: 'schleswig',
    },
    {
      code: '010590113113',
      label: 'Glücksburg (Ostsee)',
      provincie: 1,
      slug: 'gluecksburg-ostsee',
    },
    {
      code: '010590120120',
      label: 'Harrislee',
      provincie: 1,
      slug: 'harrislee',
    },
    {
      code: '010590183183',
      label: 'Handewitt',
      provincie: 1,
      slug: 'handewitt',
    },
    {
      code: '010595912107',
      label: 'Eggebek',
      provincie: 1,
      slug: 'eggebek',
    },
    {
      code: '010595912128',
      label: 'Janneby',
      provincie: 1,
      slug: 'janneby',
    },
    {
      code: '010595912131',
      label: 'Jerrishoe',
      provincie: 1,
      slug: 'jerrishoe',
    },
    {
      code: '010595912132',
      label: 'Jörl',
      provincie: 1,
      slug: 'joerl',
    },
    {
      code: '010595912138',
      label: 'Langstedt',
      provincie: 1,
      slug: 'langstedt',
    },
    {
      code: '010595912162',
      label: 'Sollerup',
      provincie: 1,
      slug: 'sollerup',
    },
    {
      code: '010595912169',
      label: 'Süderhackstedt',
      provincie: 1,
      slug: 'suederhackstedt',
    },
    {
      code: '010595912174',
      label: 'Wanderup',
      provincie: 1,
      slug: 'wanderup',
    },
    {
      code: '010595915012',
      label: 'Borgwedel',
      provincie: 1,
      slug: 'borgwedel',
    },
    {
      code: '010595915018',
      label: 'Busdorf',
      provincie: 1,
      slug: 'busdorf',
    },
    {
      code: '010595915019',
      label: 'Dannewerk',
      provincie: 1,
      slug: 'dannewerk',
    },
    {
      code: '010595915026',
      label: 'Fahrdorf',
      provincie: 1,
      slug: 'fahrdorf',
    },
    {
      code: '010595915032',
      label: 'Geltorf',
      provincie: 1,
      slug: 'geltorf',
    },
    {
      code: '010595915043',
      label: 'Jagel',
      provincie: 1,
      slug: 'jagel',
    },
    {
      code: '010595915056',
      label: 'Lottorf',
      provincie: 1,
      slug: 'lottorf',
    },
    {
      code: '010595915078',
      label: 'Selk',
      provincie: 1,
      slug: 'selk',
    },
    {
      code: '010595919103',
      label: 'Ausacker',
      provincie: 1,
      slug: 'ausacker',
    },
    {
      code: '010595919116',
      label: 'Großsolt',
      provincie: 1,
      slug: 'grosssolt',
    },
    {
      code: '010595919126',
      label: 'Hürup',
      provincie: 1,
      slug: 'huerup',
    },
    {
      code: '010595919127',
      label: 'Husby',
      provincie: 1,
      slug: 'husby',
    },
    {
      code: '010595919182',
      label: 'Freienwill',
      provincie: 1,
      slug: 'freienwill',
    },
    {
      code: '010595920002',
      label: 'Arnis',
      provincie: 1,
      slug: 'arnis',
    },
    {
      code: '010595920034',
      label: 'Grödersby',
      provincie: 1,
      slug: 'groedersby',
    },
    {
      code: '010595920067',
      label: 'Oersberg',
      provincie: 1,
      slug: 'oersberg',
    },
    {
      code: '010595920068',
      label: 'Rabenkirchen-Faulück',
      provincie: 1,
      slug: 'rabenkirchen-faulueck',
    },
    {
      code: '010595937106',
      label: 'Dollerup',
      provincie: 1,
      slug: 'dollerup',
    },
    {
      code: '010595937118',
      label: 'Grundhof',
      provincie: 1,
      slug: 'grundhof',
    },
    {
      code: '010595937137',
      label: 'Langballig',
      provincie: 1,
      slug: 'langballig',
    },
    {
      code: '010595937145',
      label: 'Munkbrarup',
      provincie: 1,
      slug: 'munkbrarup',
    },
    {
      code: '010595937157',
      label: 'Ringsberg',
      provincie: 1,
      slug: 'ringsberg',
    },
    {
      code: '010595937176',
      label: 'Wees',
      provincie: 1,
      slug: 'wees',
    },
    {
      code: '010595937178',
      label: 'Westerholz',
      provincie: 1,
      slug: 'westerholz',
    },
    {
      code: '010595940159',
      label: 'Sieverstedt',
      provincie: 1,
      slug: 'sieverstedt',
    },
    {
      code: '010595940171',
      label: 'Tarp',
      provincie: 1,
      slug: 'tarp',
    },
    {
      code: '010595940184',
      label: 'Oeversee',
      provincie: 1,
      slug: 'oeversee',
    },
    {
      code: '010595949076',
      label: 'Schnarup-Thumby',
      provincie: 1,
      slug: 'schnarup-thumby',
    },
    {
      code: '010595949161',
      label: 'Sörup',
      provincie: 1,
      slug: 'soerup',
    },
    {
      code: '010595949185',
      label: 'Mittelangeln',
      provincie: 1,
      slug: 'mittelangeln',
    },
    {
      code: '010595952105',
      label: 'Böxlund',
      provincie: 1,
      slug: 'boexlund',
    },
    {
      code: '010595952115',
      label: 'Großenwiehe',
      provincie: 1,
      slug: 'grossenwiehe',
    },
    {
      code: '010595952123',
      label: 'Hörup',
      provincie: 1,
      slug: 'hoerup',
    },
    {
      code: '010595952124',
      label: 'Holt',
      provincie: 1,
      slug: 'holt',
    },
    {
      code: '010595952129',
      label: 'Jardelund',
      provincie: 1,
      slug: 'jardelund',
    },
    {
      code: '010595952143',
      label: 'Medelby',
      provincie: 1,
      slug: 'medelby',
    },
    {
      code: '010595952144',
      label: 'Meyn',
      provincie: 1,
      slug: 'meyn',
    },
    {
      code: '010595952149',
      label: 'Nordhackstedt',
      provincie: 1,
      slug: 'nordhackstedt',
    },
    {
      code: '010595952151',
      label: 'Osterby',
      provincie: 1,
      slug: 'osterby-gemeinde',
    },
    {
      code: '010595952158',
      label: 'Schafflund',
      provincie: 1,
      slug: 'schafflund',
    },
    {
      code: '010595952173',
      label: 'Wallsbüll',
      provincie: 1,
      slug: 'wallsbuell',
    },
    {
      code: '010595952177',
      label: 'Weesby',
      provincie: 1,
      slug: 'weesby',
    },
    {
      code: '010595952179',
      label: 'Lindewitt',
      provincie: 1,
      slug: 'lindewitt',
    },
    {
      code: '010595974006',
      label: 'Böel',
      provincie: 1,
      slug: 'boeel',
    },
    {
      code: '010595974055',
      label: 'Loit',
      provincie: 1,
      slug: 'loit',
    },
    {
      code: '010595974060',
      label: 'Mohrkirch',
      provincie: 1,
      slug: 'mohrkirch',
    },
    {
      code: '010595974063',
      label: 'Norderbrarup',
      provincie: 1,
      slug: 'norderbrarup',
    },
    {
      code: '010595974065',
      label: 'Nottfeld',
      provincie: 1,
      slug: 'nottfeld',
    },
    {
      code: '010595974070',
      label: 'Rügge',
      provincie: 1,
      slug: 'ruegge',
    },
    {
      code: '010595974072',
      label: 'Saustrup',
      provincie: 1,
      slug: 'saustrup',
    },
    {
      code: '010595974074',
      label: 'Scheggerott',
      provincie: 1,
      slug: 'scheggerott',
    },
    {
      code: '010595974080',
      label: 'Steinfeld',
      provincie: 1,
      slug: 'steinfeld',
    },
    {
      code: '010595974083',
      label: 'Süderbrarup',
      provincie: 1,
      slug: 'suederbrarup',
    },
    {
      code: '010595974094',
      label: 'Ulsnis',
      provincie: 1,
      slug: 'ulsnis',
    },
    {
      code: '010595974095',
      label: 'Wagersrott',
      provincie: 1,
      slug: 'wagersrott',
    },
    {
      code: '010595974187',
      label: 'Boren',
      provincie: 1,
      slug: 'boren',
    },
    {
      code: '010595987008',
      label: 'Böklund',
      provincie: 1,
      slug: 'boeklund',
    },
    {
      code: '010595987037',
      label: 'Havetoft',
      provincie: 1,
      slug: 'havetoft',
    },
    {
      code: '010595987042',
      label: 'Idstedt',
      provincie: 1,
      slug: 'idstedt',
    },
    {
      code: '010595987049',
      label: 'Klappholz',
      provincie: 1,
      slug: 'klappholz',
    },
    {
      code: '010595987062',
      label: 'Neuberend',
      provincie: 1,
      slug: 'neuberend',
    },
    {
      code: '010595987073',
      label: 'Schaalby',
      provincie: 1,
      slug: 'schaalby',
    },
    {
      code: '010595987081',
      label: 'Stolk',
      provincie: 1,
      slug: 'stolk',
    },
    {
      code: '010595987082',
      label: 'Struxdorf',
      provincie: 1,
      slug: 'struxdorf',
    },
    {
      code: '010595987084',
      label: 'Süderfahrenstedt',
      provincie: 1,
      slug: 'suederfahrenstedt',
    },
    {
      code: '010595987086',
      label: 'Taarstedt',
      provincie: 1,
      slug: 'taarstedt',
    },
    {
      code: '010595987090',
      label: 'Tolk',
      provincie: 1,
      slug: 'tolk',
    },
    {
      code: '010595987093',
      label: 'Uelsby',
      provincie: 1,
      slug: 'uelsby',
    },
    {
      code: '010595987097',
      label: 'Twedt',
      provincie: 1,
      slug: 'twedt',
    },
    {
      code: '010595987098',
      label: 'Nübel',
      provincie: 1,
      slug: 'nuebel',
    },
    {
      code: '010595987189',
      label: 'Brodersby-Goltoft',
      provincie: 1,
      slug: 'brodersby-goltoft',
    },
    {
      code: '010595990102',
      label: 'Ahneby',
      provincie: 1,
      slug: 'ahneby',
    },
    {
      code: '010595990109',
      label: 'Esgrus',
      provincie: 1,
      slug: 'esgrus',
    },
    {
      code: '010595990112',
      label: 'Gelting',
      provincie: 1,
      slug: 'gelting',
    },
    {
      code: '010595990121',
      label: 'Hasselberg',
      provincie: 1,
      slug: 'hasselberg',
    },
    {
      code: '010595990136',
      label: 'Kronsgaard',
      provincie: 1,
      slug: 'kronsgaard',
    },
    {
      code: '010595990142',
      label: 'Maasholm',
      provincie: 1,
      slug: 'maasholm',
    },
    {
      code: '010595990147',
      label: 'Nieby',
      provincie: 1,
      slug: 'nieby',
    },
    {
      code: '010595990148',
      label: 'Niesgrau',
      provincie: 1,
      slug: 'niesgrau',
    },
    {
      code: '010595990152',
      label: 'Pommerby',
      provincie: 1,
      slug: 'pommerby',
    },
    {
      code: '010595990154',
      label: 'Rabel',
      provincie: 1,
      slug: 'rabel',
    },
    {
      code: '010595990155',
      label: 'Rabenholz',
      provincie: 1,
      slug: 'rabenholz',
    },
    {
      code: '010595990163',
      label: 'Stangheck',
      provincie: 1,
      slug: 'stangheck',
    },
    {
      code: '010595990164',
      label: 'Steinberg',
      provincie: 1,
      slug: 'steinberg',
    },
    {
      code: '010595990167',
      label: 'Sterup',
      provincie: 1,
      slug: 'sterup',
    },
    {
      code: '010595990168',
      label: 'Stoltebüll',
      provincie: 1,
      slug: 'stoltebuell',
    },
    {
      code: '010595990186',
      label: 'Steinbergkirche',
      provincie: 1,
      slug: 'steinbergkirche',
    },
    {
      code: '010595993010',
      label: 'Bollingstedt',
      provincie: 1,
      slug: 'bollingstedt',
    },
    {
      code: '010595993023',
      label: 'Ellingstedt',
      provincie: 1,
      slug: 'ellingstedt',
    },
    {
      code: '010595993039',
      label: 'Hollingstedt',
      provincie: 1,
      slug: 'hollingstedt-gemeinde',
    },
    {
      code: '010595993041',
      label: 'Hüsby',
      provincie: 1,
      slug: 'huesby',
    },
    {
      code: '010595993044',
      label: 'Jübek',
      provincie: 1,
      slug: 'juebek',
    },
    {
      code: '010595993057',
      label: 'Lürschau',
      provincie: 1,
      slug: 'luerschau',
    },
    {
      code: '010595993077',
      label: 'Schuby',
      provincie: 1,
      slug: 'schuby',
    },
    {
      code: '010595993079',
      label: 'Silberstedt',
      provincie: 1,
      slug: 'silberstedt',
    },
    {
      code: '010595993092',
      label: 'Treia',
      provincie: 1,
      slug: 'treia',
    },
    {
      code: '010595996001',
      label: 'Alt Bennebek',
      provincie: 1,
      slug: 'alt-bennebek',
    },
    {
      code: '010595996005',
      label: 'Bergenhusen',
      provincie: 1,
      slug: 'bergenhusen',
    },
    {
      code: '010595996009',
      label: 'Börm',
      provincie: 1,
      slug: 'boerm',
    },
    {
      code: '010595996020',
      label: 'Dörpstedt',
      provincie: 1,
      slug: 'doerpstedt',
    },
    {
      code: '010595996024',
      label: 'Erfde',
      provincie: 1,
      slug: 'erfde',
    },
    {
      code: '010595996035',
      label: 'Groß Rheide',
      provincie: 1,
      slug: 'gross-rheide',
    },
    {
      code: '010595996050',
      label: 'Klein Bennebek',
      provincie: 1,
      slug: 'klein-bennebek',
    },
    {
      code: '010595996051',
      label: 'Klein Rheide',
      provincie: 1,
      slug: 'klein-rheide',
    },
    {
      code: '010595996053',
      label: 'Kropp',
      provincie: 1,
      slug: 'kropp',
    },
    {
      code: '010595996058',
      label: 'Meggerdorf',
      provincie: 1,
      slug: 'meggerdorf',
    },
    {
      code: '010595996087',
      label: 'Tetenhusen',
      provincie: 1,
      slug: 'tetenhusen',
    },
    {
      code: '010595996088',
      label: 'Tielen',
      provincie: 1,
      slug: 'tielen',
    },
    {
      code: '010595996096',
      label: 'Wohlde',
      provincie: 1,
      slug: 'wohlde',
    },
    {
      code: '010595996188',
      label: 'Stapel',
      provincie: 1,
      slug: 'stapel',
    },
    {
      code: '010600004004',
      label: 'Bad Bramstedt',
      provincie: 1,
      slug: 'bad-bramstedt',
    },
    {
      code: '010600005005',
      label: 'Bad Segeberg',
      provincie: 1,
      slug: 'bad-segeberg',
    },
    {
      code: '010600019019',
      label: 'Ellerau',
      provincie: 1,
      slug: 'ellerau',
    },
    {
      code: '010600039039',
      label: 'Henstedt-Ulzburg',
      provincie: 1,
      slug: 'henstedt-ulzburg',
    },
    {
      code: '010600044044',
      label: 'Kaltenkirchen',
      provincie: 1,
      slug: 'kaltenkirchen',
    },
    {
      code: '010600063063',
      label: 'Norderstedt',
      provincie: 1,
      slug: 'norderstedt',
    },
    {
      code: '010600092092',
      label: 'Wahlstedt',
      provincie: 1,
      slug: 'wahlstedt',
    },
    {
      code: '010605005003',
      label: 'Armstedt',
      provincie: 1,
      slug: 'armstedt',
    },
    {
      code: '010605005009',
      label: 'Bimöhlen',
      provincie: 1,
      slug: 'bimoehlen',
    },
    {
      code: '010605005013',
      label: 'Borstel',
      provincie: 1,
      slug: 'borstel',
    },
    {
      code: '010605005021',
      label: 'Föhrden-Barl',
      provincie: 1,
      slug: 'foehrden-barl',
    },
    {
      code: '010605005023',
      label: 'Fuhlendorf',
      provincie: 1,
      slug: 'fuhlendorf',
    },
    {
      code: '010605005027',
      label: 'Großenaspe',
      provincie: 1,
      slug: 'grossenaspe',
    },
    {
      code: '010605005031',
      label: 'Hagen',
      provincie: 1,
      slug: 'hagen',
    },
    {
      code: '010605005033',
      label: 'Hardebek',
      provincie: 1,
      slug: 'hardebek',
    },
    {
      code: '010605005035',
      label: 'Hasenkrug',
      provincie: 1,
      slug: 'hasenkrug',
    },
    {
      code: '010605005037',
      label: 'Heidmoor',
      provincie: 1,
      slug: 'heidmoor',
    },
    {
      code: '010605005040',
      label: 'Hitzhusen',
      provincie: 1,
      slug: 'hitzhusen',
    },
    {
      code: '010605005056',
      label: 'Mönkloh',
      provincie: 1,
      slug: 'moenkloh',
    },
    {
      code: '010605005095',
      label: 'Weddelbrook',
      provincie: 1,
      slug: 'weddelbrook',
    },
    {
      code: '010605005099',
      label: 'Wiemersdorf',
      provincie: 1,
      slug: 'wiemersdorf',
    },
    {
      code: '010605024012',
      label: 'Bornhöved',
      provincie: 1,
      slug: 'bornhoeved',
    },
    {
      code: '010605024017',
      label: 'Damsdorf',
      provincie: 1,
      slug: 'damsdorf',
    },
    {
      code: '010605024026',
      label: 'Gönnebek',
      provincie: 1,
      slug: 'goennebek',
    },
    {
      code: '010605024072',
      label: 'Schmalensee',
      provincie: 1,
      slug: 'schmalensee',
    },
    {
      code: '010605024080',
      label: 'Stocksee',
      provincie: 1,
      slug: 'stocksee',
    },
    {
      code: '010605024086',
      label: 'Tarbek',
      provincie: 1,
      slug: 'tarbek',
    },
    {
      code: '010605024087',
      label: 'Tensfeld',
      provincie: 1,
      slug: 'tensfeld',
    },
    {
      code: '010605024089',
      label: 'Trappenkamp',
      provincie: 1,
      slug: 'trappenkamp',
    },
    {
      code: '010605034043',
      label: 'Itzstedt',
      provincie: 1,
      slug: 'itzstedt',
    },
    {
      code: '010605034046',
      label: 'Kayhude',
      provincie: 1,
      slug: 'kayhude',
    },
    {
      code: '010605034058',
      label: 'Nahe',
      provincie: 1,
      slug: 'nahe',
    },
    {
      code: '010605034065',
      label: 'Oering',
      provincie: 1,
      slug: 'oering',
    },
    {
      code: '010605034076',
      label: 'Seth',
      provincie: 1,
      slug: 'seth',
    },
    {
      code: '010605034085',
      label: 'Sülfeld',
      provincie: 1,
      slug: 'suelfeld',
    },
    {
      code: '010605043002',
      label: 'Alveslohe',
      provincie: 1,
      slug: 'alveslohe',
    },
    {
      code: '010605043034',
      label: 'Hartenholm',
      provincie: 1,
      slug: 'hartenholm',
    },
    {
      code: '010605043036',
      label: 'Hasenmoor',
      provincie: 1,
      slug: 'hasenmoor',
    },
    {
      code: '010605043054',
      label: 'Lentföhrden',
      provincie: 1,
      slug: 'lentfoehrden',
    },
    {
      code: '010605043064',
      label: 'Nützen',
      provincie: 1,
      slug: 'nuetzen',
    },
    {
      code: '010605043073',
      label: 'Schmalfeld',
      provincie: 1,
      slug: 'schmalfeld',
    },
    {
      code: '010605048042',
      label: 'Hüttblek',
      provincie: 1,
      slug: 'huettblek',
    },
    {
      code: '010605048045',
      label: 'Kattendorf',
      provincie: 1,
      slug: 'kattendorf',
    },
    {
      code: '010605048047',
      label: 'Kisdorf',
      provincie: 1,
      slug: 'kisdorf',
    },
    {
      code: '010605048066',
      label: 'Oersdorf',
      provincie: 1,
      slug: 'oersdorf',
    },
    {
      code: '010605048077',
      label: 'Sievershütten',
      provincie: 1,
      slug: 'sievershuetten',
    },
    {
      code: '010605048082',
      label: 'Struvenhütten',
      provincie: 1,
      slug: 'struvenhuetten',
    },
    {
      code: '010605048084',
      label: 'Stuvenborn',
      provincie: 1,
      slug: 'stuvenborn',
    },
    {
      code: '010605048094',
      label: 'Wakendorf II',
      provincie: 1,
      slug: 'wakendorf-ii',
    },
    {
      code: '010605048100',
      label: 'Winsen',
      provincie: 1,
      slug: 'winsen',
    },
    {
      code: '010605053007',
      label: 'Bark',
      provincie: 1,
      slug: 'bark',
    },
    {
      code: '010605053008',
      label: 'Bebensee',
      provincie: 1,
      slug: 'bebensee',
    },
    {
      code: '010605053022',
      label: 'Fredesdorf',
      provincie: 1,
      slug: 'fredesdorf',
    },
    {
      code: '010605053029',
      label: 'Groß Niendorf',
      provincie: 1,
      slug: 'gross-niendorf',
    },
    {
      code: '010605053041',
      label: 'Högersdorf',
      provincie: 1,
      slug: 'hoegersdorf',
    },
    {
      code: '010605053051',
      label: 'Kükels',
      provincie: 1,
      slug: 'kuekels',
    },
    {
      code: '010605053053',
      label: 'Leezen',
      provincie: 1,
      slug: 'leezen',
    },
    {
      code: '010605053057',
      label: 'Mözen',
      provincie: 1,
      slug: 'moezen',
    },
    {
      code: '010605053062',
      label: 'Neversdorf',
      provincie: 1,
      slug: 'neversdorf',
    },
    {
      code: '010605053074',
      label: 'Schwissel',
      provincie: 1,
      slug: 'schwissel',
    },
    {
      code: '010605053088',
      label: 'Todesfelde',
      provincie: 1,
      slug: 'todesfelde',
    },
    {
      code: '010605053101',
      label: 'Wittenborn',
      provincie: 1,
      slug: 'wittenborn',
    },
    {
      code: '010605063011',
      label: 'Boostedt',
      provincie: 1,
      slug: 'boostedt',
    },
    {
      code: '010605063016',
      label: 'Daldorf',
      provincie: 1,
      slug: 'daldorf',
    },
    {
      code: '010605063028',
      label: 'Groß Kummerfeld',
      provincie: 1,
      slug: 'gross-kummerfeld',
    },
    {
      code: '010605063038',
      label: 'Heidmühlen',
      provincie: 1,
      slug: 'heidmuehlen',
    },
    {
      code: '010605063052',
      label: 'Latendorf',
      provincie: 1,
      slug: 'latendorf',
    },
    {
      code: '010605063068',
      label: 'Rickling',
      provincie: 1,
      slug: 'rickling',
    },
    {
      code: '010605086006',
      label: 'Bahrenhof',
      provincie: 1,
      slug: 'bahrenhof',
    },
    {
      code: '010605086010',
      label: 'Blunk',
      provincie: 1,
      slug: 'blunk',
    },
    {
      code: '010605086015',
      label: 'Bühnsdorf',
      provincie: 1,
      slug: 'buehnsdorf',
    },
    {
      code: '010605086018',
      label: 'Dreggers',
      provincie: 1,
      slug: 'dreggers',
    },
    {
      code: '010605086020',
      label: 'Fahrenkrug',
      provincie: 1,
      slug: 'fahrenkrug',
    },
    {
      code: '010605086024',
      label: 'Geschendorf',
      provincie: 1,
      slug: 'geschendorf',
    },
    {
      code: '010605086025',
      label: 'Glasau',
      provincie: 1,
      slug: 'glasau',
    },
    {
      code: '010605086030',
      label: 'Groß Rönnau',
      provincie: 1,
      slug: 'gross-roennau',
    },
    {
      code: '010605086048',
      label: 'Klein Gladebrügge',
      provincie: 1,
      slug: 'klein-gladebruegge',
    },
    {
      code: '010605086049',
      label: 'Klein Rönnau',
      provincie: 1,
      slug: 'klein-roennau',
    },
    {
      code: '010605086050',
      label: 'Krems II',
      provincie: 1,
      slug: 'krems-ii',
    },
    {
      code: '010605086059',
      label: 'Negernbötel',
      provincie: 1,
      slug: 'negernboetel',
    },
    {
      code: '010605086060',
      label: 'Nehms',
      provincie: 1,
      slug: 'nehms',
    },
    {
      code: '010605086061',
      label: 'Neuengörs',
      provincie: 1,
      slug: 'neuengoers',
    },
    {
      code: '010605086067',
      label: 'Pronstorf',
      provincie: 1,
      slug: 'pronstorf',
    },
    {
      code: '010605086069',
      label: 'Rohlstorf',
      provincie: 1,
      slug: 'rohlstorf',
    },
    {
      code: '010605086070',
      label: 'Schackendorf',
      provincie: 1,
      slug: 'schackendorf',
    },
    {
      code: '010605086071',
      label: 'Schieren',
      provincie: 1,
      slug: 'schieren',
    },
    {
      code: '010605086075',
      label: 'Seedorf',
      provincie: 1,
      slug: 'seedorf-gemeinde',
    },
    {
      code: '010605086079',
      label: 'Stipsdorf',
      provincie: 1,
      slug: 'stipsdorf',
    },
    {
      code: '010605086081',
      label: 'Strukdorf',
      provincie: 1,
      slug: 'strukdorf',
    },
    {
      code: '010605086090',
      label: 'Travenhorst',
      provincie: 1,
      slug: 'travenhorst',
    },
    {
      code: '010605086091',
      label: 'Traventhal',
      provincie: 1,
      slug: 'traventhal',
    },
    {
      code: '010605086093',
      label: 'Wakendorf I',
      provincie: 1,
      slug: 'wakendorf-i',
    },
    {
      code: '010605086096',
      label: 'Weede',
      provincie: 1,
      slug: 'weede',
    },
    {
      code: '010605086097',
      label: 'Wensin',
      provincie: 1,
      slug: 'wensin',
    },
    {
      code: '010605086098',
      label: 'Westerrade',
      provincie: 1,
      slug: 'westerrade',
    },
    {
      code: '010610029029',
      label: 'Glückstadt',
      provincie: 1,
      slug: 'glueckstadt',
    },
    {
      code: '010610046046',
      label: 'Itzehoe',
      provincie: 1,
      slug: 'itzehoe',
    },
    {
      code: '010610113113',
      label: 'Wilster',
      provincie: 1,
      slug: 'wilster',
    },
    {
      code: '010615104005',
      label: 'Auufer',
      provincie: 1,
      slug: 'auufer',
    },
    {
      code: '010615104016',
      label: 'Breitenberg',
      provincie: 1,
      slug: 'breitenberg',
    },
    {
      code: '010615104017',
      label: 'Breitenburg',
      provincie: 1,
      slug: 'breitenburg',
    },
    {
      code: '010615104053',
      label: 'Kollmoor',
      provincie: 1,
      slug: 'kollmoor',
    },
    {
      code: '010615104058',
      label: 'Kronsmoor',
      provincie: 1,
      slug: 'kronsmoor',
    },
    {
      code: '010615104061',
      label: 'Lägerdorf',
      provincie: 1,
      slug: 'laegerdorf',
    },
    {
      code: '010615104068',
      label: 'Moordiek',
      provincie: 1,
      slug: 'moordiek',
    },
    {
      code: '010615104072',
      label: 'Münsterdorf',
      provincie: 1,
      slug: 'muensterdorf',
    },
    {
      code: '010615104079',
      label: 'Oelixdorf',
      provincie: 1,
      slug: 'oelixdorf',
    },
    {
      code: '010615104109',
      label: 'Westermoor',
      provincie: 1,
      slug: 'westermoor',
    },
    {
      code: '010615104115',
      label: 'Wittenbergen',
      provincie: 1,
      slug: 'wittenbergen',
    },
    {
      code: '010615134004',
      label: 'Altenmoor',
      provincie: 1,
      slug: 'altenmoor',
    },
    {
      code: '010615134012',
      label: 'Blomesche Wildnis',
      provincie: 1,
      slug: 'blomesche-wildnis',
    },
    {
      code: '010615134015',
      label: 'Borsfleth',
      provincie: 1,
      slug: 'borsfleth',
    },
    {
      code: '010615134027',
      label: 'Engelbrechtsche Wildnis',
      provincie: 1,
      slug: 'engelbrechtsche-wildnis',
    },
    {
      code: '010615134037',
      label: 'Herzhorn',
      provincie: 1,
      slug: 'herzhorn',
    },
    {
      code: '010615134041',
      label: 'Hohenfelde',
      provincie: 1,
      slug: 'hohenfelde-gemeinde',
    },
    {
      code: '010615134044',
      label: 'Horst (Holstein)',
      provincie: 1,
      slug: 'horst-holstein',
    },
    {
      code: '010615134050',
      label: 'Kiebitzreihe',
      provincie: 1,
      slug: 'kiebitzreihe',
    },
    {
      code: '010615134054',
      label: 'Krempdorf',
      provincie: 1,
      slug: 'krempdorf',
    },
    {
      code: '010615134074',
      label: 'Neuendorf b.Elmshorn',
      provincie: 1,
      slug: 'neuendorf-b-elmshorn',
    },
    {
      code: '010615134101',
      label: 'Sommerland',
      provincie: 1,
      slug: 'sommerland',
    },
    {
      code: '010615134118',
      label: 'Kollmar',
      provincie: 1,
      slug: 'kollmar',
    },
    {
      code: '010615138008',
      label: 'Bekdorf',
      provincie: 1,
      slug: 'bekdorf',
    },
    {
      code: '010615138010',
      label: 'Bekmünde',
      provincie: 1,
      slug: 'bekmuende',
    },
    {
      code: '010615138024',
      label: 'Drage',
      provincie: 1,
      slug: 'drage-gemeinde',
    },
    {
      code: '010615138034',
      label: 'Heiligenstedten',
      provincie: 1,
      slug: 'heiligenstedten',
    },
    {
      code: '010615138035',
      label: 'Heiligenstedtenerkamp',
      provincie: 1,
      slug: 'heiligenstedtenerkamp',
    },
    {
      code: '010615138039',
      label: 'Hodorf',
      provincie: 1,
      slug: 'hodorf',
    },
    {
      code: '010615138040',
      label: 'Hohenaspe',
      provincie: 1,
      slug: 'hohenaspe',
    },
    {
      code: '010615138045',
      label: 'Huje',
      provincie: 1,
      slug: 'huje',
    },
    {
      code: '010615138047',
      label: 'Kaaks',
      provincie: 1,
      slug: 'kaaks',
    },
    {
      code: '010615138052',
      label: 'Kleve',
      provincie: 1,
      slug: 'kleve-gemeinde',
    },
    {
      code: '010615138059',
      label: 'Krummendiek',
      provincie: 1,
      slug: 'krummendiek',
    },
    {
      code: '010615138065',
      label: 'Lohbarbek',
      provincie: 1,
      slug: 'lohbarbek',
    },
    {
      code: '010615138067',
      label: 'Mehlbek',
      provincie: 1,
      slug: 'mehlbek',
    },
    {
      code: '010615138070',
      label: 'Moorhusen',
      provincie: 1,
      slug: 'moorhusen',
    },
    {
      code: '010615138082',
      label: 'Oldendorf',
      provincie: 1,
      slug: 'oldendorf',
    },
    {
      code: '010615138083',
      label: 'Ottenbüttel',
      provincie: 1,
      slug: 'ottenbuettel',
    },
    {
      code: '010615138084',
      label: 'Peissen',
      provincie: 1,
      slug: 'peissen',
    },
    {
      code: '010615138098',
      label: 'Schlotfeld',
      provincie: 1,
      slug: 'schlotfeld',
    },
    {
      code: '010615138100',
      label: 'Silzen',
      provincie: 1,
      slug: 'silzen',
    },
    {
      code: '010615138114',
      label: 'Winseldorf',
      provincie: 1,
      slug: 'winseldorf',
    },
    {
      code: '010615153006',
      label: 'Bahrenfleth',
      provincie: 1,
      slug: 'bahrenfleth',
    },
    {
      code: '010615153022',
      label: 'Dägeling',
      provincie: 1,
      slug: 'daegeling',
    },
    {
      code: '010615153026',
      label: 'Elskop',
      provincie: 1,
      slug: 'elskop',
    },
    {
      code: '010615153030',
      label: 'Grevenkop',
      provincie: 1,
      slug: 'grevenkop',
    },
    {
      code: '010615153055',
      label: 'Krempe',
      provincie: 1,
      slug: 'krempe',
    },
    {
      code: '010615153056',
      label: 'Kremperheide',
      provincie: 1,
      slug: 'kremperheide',
    },
    {
      code: '010615153057',
      label: 'Krempermoor',
      provincie: 1,
      slug: 'krempermoor',
    },
    {
      code: '010615153073',
      label: 'Neuenbrook',
      provincie: 1,
      slug: 'neuenbrook',
    },
    {
      code: '010615153092',
      label: 'Rethwisch',
      provincie: 1,
      slug: 'rethwisch',
    },
    {
      code: '010615153104',
      label: 'Süderau',
      provincie: 1,
      slug: 'suederau',
    },
    {
      code: '010615168001',
      label: 'Aasbüttel',
      provincie: 1,
      slug: 'aasbuettel',
    },
    {
      code: '010615168003',
      label: 'Agethorst',
      provincie: 1,
      slug: 'agethorst',
    },
    {
      code: '010615168011',
      label: 'Besdorf',
      provincie: 1,
      slug: 'besdorf',
    },
    {
      code: '010615168013',
      label: 'Bokelrehm',
      provincie: 1,
      slug: 'bokelrehm',
    },
    {
      code: '010615168014',
      label: 'Bokhorst',
      provincie: 1,
      slug: 'bokhorst',
    },
    {
      code: '010615168021',
      label: 'Christinenthal',
      provincie: 1,
      slug: 'christinenthal',
    },
    {
      code: '010615168031',
      label: 'Gribbohm',
      provincie: 1,
      slug: 'gribbohm',
    },
    {
      code: '010615168033',
      label: 'Hadenfeld',
      provincie: 1,
      slug: 'hadenfeld',
    },
    {
      code: '010615168043',
      label: 'Holstenniendorf',
      provincie: 1,
      slug: 'holstenniendorf',
    },
    {
      code: '010615168048',
      label: 'Kaisborstel',
      provincie: 1,
      slug: 'kaisborstel',
    },
    {
      code: '010615168066',
      label: 'Looft',
      provincie: 1,
      slug: 'looft',
    },
    {
      code: '010615168076',
      label: 'Nienbüttel',
      provincie: 1,
      slug: 'nienbuettel',
    },
    {
      code: '010615168078',
      label: 'Nutteln',
      provincie: 1,
      slug: 'nutteln',
    },
    {
      code: '010615168081',
      label: 'Oldenborstel',
      provincie: 1,
      slug: 'oldenborstel',
    },
    {
      code: '010615168085',
      label: 'Pöschendorf',
      provincie: 1,
      slug: 'poeschendorf',
    },
    {
      code: '010615168087',
      label: 'Puls',
      provincie: 1,
      slug: 'puls',
    },
    {
      code: '010615168091',
      label: 'Reher',
      provincie: 1,
      slug: 'reher',
    },
    {
      code: '010615168097',
      label: 'Schenefeld',
      provincie: 1,
      slug: 'schenefeld-gemeinde',
    },
    {
      code: '010615168105',
      label: 'Vaale',
      provincie: 1,
      slug: 'vaale',
    },
    {
      code: '010615168106',
      label: 'Vaalermoor',
      provincie: 1,
      slug: 'vaalermoor',
    },
    {
      code: '010615168107',
      label: 'Wacken',
      provincie: 1,
      slug: 'wacken',
    },
    {
      code: '010615168108',
      label: 'Warringholz',
      provincie: 1,
      slug: 'warringholz',
    },
    {
      code: '010615179002',
      label: 'Aebtissinwisch',
      provincie: 1,
      slug: 'aebtissinwisch',
    },
    {
      code: '010615179007',
      label: 'Beidenfleth',
      provincie: 1,
      slug: 'beidenfleth',
    },
    {
      code: '010615179018',
      label: 'Brokdorf',
      provincie: 1,
      slug: 'brokdorf',
    },
    {
      code: '010615179020',
      label: 'Büttel',
      provincie: 1,
      slug: 'buettel',
    },
    {
      code: '010615179023',
      label: 'Dammfleth',
      provincie: 1,
      slug: 'dammfleth',
    },
    {
      code: '010615179025',
      label: 'Ecklak',
      provincie: 1,
      slug: 'ecklak',
    },
    {
      code: '010615179060',
      label: 'Kudensee',
      provincie: 1,
      slug: 'kudensee',
    },
    {
      code: '010615179062',
      label: 'Landrecht',
      provincie: 1,
      slug: 'landrecht',
    },
    {
      code: '010615179063',
      label: 'Landscheide',
      provincie: 1,
      slug: 'landscheide',
    },
    {
      code: '010615179077',
      label: 'Nortorf',
      provincie: 1,
      slug: 'nortorf-gemeinde',
    },
    {
      code: '010615179095',
      label: 'Sankt Margarethen',
      provincie: 1,
      slug: 'sankt-margarethen',
    },
    {
      code: '010615179102',
      label: 'Stördorf',
      provincie: 1,
      slug: 'stoerdorf',
    },
    {
      code: '010615179110',
      label: 'Wewelsfleth',
      provincie: 1,
      slug: 'wewelsfleth',
    },
    {
      code: '010615179119',
      label: 'Neuendorf-Sachsenbande',
      provincie: 1,
      slug: 'neuendorf-sachsenbande',
    },
    {
      code: '010615189019',
      label: 'Brokstedt',
      provincie: 1,
      slug: 'brokstedt',
    },
    {
      code: '010615189028',
      label: 'Fitzbek',
      provincie: 1,
      slug: 'fitzbek',
    },
    {
      code: '010615189036',
      label: 'Hennstedt',
      provincie: 1,
      slug: 'hennstedt-gemeinde',
    },
    {
      code: '010615189038',
      label: 'Hingstheide',
      provincie: 1,
      slug: 'hingstheide',
    },
    {
      code: '010615189042',
      label: 'Hohenlockstedt',
      provincie: 1,
      slug: 'hohenlockstedt',
    },
    {
      code: '010615189049',
      label: 'Kellinghusen',
      provincie: 1,
      slug: 'kellinghusen',
    },
    {
      code: '010615189064',
      label: 'Lockstedt',
      provincie: 1,
      slug: 'lockstedt',
    },
    {
      code: '010615189071',
      label: 'Mühlenbarbek',
      provincie: 1,
      slug: 'muehlenbarbek',
    },
    {
      code: '010615189080',
      label: 'Oeschebüttel',
      provincie: 1,
      slug: 'oeschebuettel',
    },
    {
      code: '010615189086',
      label: 'Poyenberg',
      provincie: 1,
      slug: 'poyenberg',
    },
    {
      code: '010615189088',
      label: 'Quarnstedt',
      provincie: 1,
      slug: 'quarnstedt',
    },
    {
      code: '010615189089',
      label: 'Rade',
      provincie: 1,
      slug: 'rade',
    },
    {
      code: '010615189093',
      label: 'Rosdorf',
      provincie: 1,
      slug: 'rosdorf',
    },
    {
      code: '010615189096',
      label: 'Sarlhusen',
      provincie: 1,
      slug: 'sarlhusen',
    },
    {
      code: '010615189103',
      label: 'Störkathen',
      provincie: 1,
      slug: 'stoerkathen',
    },
    {
      code: '010615189111',
      label: 'Wiedenborstel',
      provincie: 1,
      slug: 'wiedenborstel',
    },
    {
      code: '010615189112',
      label: 'Willenscharen',
      provincie: 1,
      slug: 'willenscharen',
    },
    {
      code: '010615189116',
      label: 'Wrist',
      provincie: 1,
      slug: 'wrist',
    },
    {
      code: '010615189117',
      label: 'Wulfsmoor',
      provincie: 1,
      slug: 'wulfsmoor',
    },
    {
      code: '010620001001',
      label: 'Ahrensburg',
      provincie: 1,
      slug: 'ahrensburg',
    },
    {
      code: '010620004004',
      label: 'Bad Oldesloe',
      provincie: 1,
      slug: 'bad-oldesloe',
    },
    {
      code: '010620006006',
      label: 'Bargteheide',
      provincie: 1,
      slug: 'bargteheide',
    },
    {
      code: '010620009009',
      label: 'Barsbüttel',
      provincie: 1,
      slug: 'barsbuettel',
    },
    {
      code: '010620018018',
      label: 'Glinde',
      provincie: 1,
      slug: 'glinde',
    },
    {
      code: '010620023023',
      label: 'Großhansdorf',
      provincie: 1,
      slug: 'grosshansdorf',
    },
    {
      code: '010620053053',
      label: 'Oststeinbek',
      provincie: 1,
      slug: 'oststeinbek',
    },
    {
      code: '010620060060',
      label: 'Reinbek',
      provincie: 1,
      slug: 'reinbek',
    },
    {
      code: '010620061061',
      label: 'Reinfeld (Holstein)',
      provincie: 1,
      slug: 'reinfeld-holstein',
    },
    {
      code: '010620076076',
      label: 'Tangstedt',
      provincie: 1,
      slug: 'tangstedt-gemeinde',
    },
    {
      code: '010620090090',
      label: 'Ammersbek',
      provincie: 1,
      slug: 'ammersbek',
    },
    {
      code: '010625207019',
      label: 'Grabau',
      provincie: 1,
      slug: 'grabau-gemeinde',
    },
    {
      code: '010625207046',
      label: 'Meddewade',
      provincie: 1,
      slug: 'meddewade',
    },
    {
      code: '010625207050',
      label: 'Neritz',
      provincie: 1,
      slug: 'neritz',
    },
    {
      code: '010625207056',
      label: 'Pölitz',
      provincie: 1,
      slug: 'poelitz',
    },
    {
      code: '010625207062',
      label: 'Rethwisch',
      provincie: 1,
      slug: 'rethwisch-gemeinde',
    },
    {
      code: '010625207065',
      label: 'Rümpel',
      provincie: 1,
      slug: 'ruempel',
    },
    {
      code: '010625207089',
      label: 'Lasbek',
      provincie: 1,
      slug: 'lasbek',
    },
    {
      code: '010625207091',
      label: 'Steinburg',
      provincie: 1,
      slug: 'steinburg',
    },
    {
      code: '010625207092',
      label: 'Travenbrück',
      provincie: 1,
      slug: 'travenbrueck',
    },
    {
      code: '010625218005',
      label: 'Bargfeld-Stegen',
      provincie: 1,
      slug: 'bargfeld-stegen',
    },
    {
      code: '010625218014',
      label: 'Delingsdorf',
      provincie: 1,
      slug: 'delingsdorf',
    },
    {
      code: '010625218016',
      label: 'Elmenhorst',
      provincie: 1,
      slug: 'elmenhorst-gemeinde',
    },
    {
      code: '010625218027',
      label: 'Hammoor',
      provincie: 1,
      slug: 'hammoor',
    },
    {
      code: '010625218036',
      label: 'Jersbek',
      provincie: 1,
      slug: 'jersbek',
    },
    {
      code: '010625218051',
      label: 'Nienwohld',
      provincie: 1,
      slug: 'nienwohld',
    },
    {
      code: '010625218078',
      label: 'Todendorf',
      provincie: 1,
      slug: 'todendorf',
    },
    {
      code: '010625218081',
      label: 'Tremsbüttel',
      provincie: 1,
      slug: 'tremsbuettel',
    },
    {
      code: '010625244003',
      label: 'Badendorf',
      provincie: 1,
      slug: 'badendorf',
    },
    {
      code: '010625244008',
      label: 'Barnitz',
      provincie: 1,
      slug: 'barnitz',
    },
    {
      code: '010625244025',
      label: 'Hamberge',
      provincie: 1,
      slug: 'hamberge',
    },
    {
      code: '010625244031',
      label: 'Heidekamp',
      provincie: 1,
      slug: 'heidekamp',
    },
    {
      code: '010625244032',
      label: 'Heilshoop',
      provincie: 1,
      slug: 'heilshoop',
    },
    {
      code: '010625244039',
      label: 'Klein Wesenberg',
      provincie: 1,
      slug: 'klein-wesenberg',
    },
    {
      code: '010625244048',
      label: 'Mönkhagen',
      provincie: 1,
      slug: 'moenkhagen',
    },
    {
      code: '010625244059',
      label: 'Rehhorst',
      provincie: 1,
      slug: 'rehhorst',
    },
    {
      code: '010625244083',
      label: 'Westerau',
      provincie: 1,
      slug: 'westerau',
    },
    {
      code: '010625244087',
      label: 'Zarpen',
      provincie: 1,
      slug: 'zarpen',
    },
    {
      code: '010625244093',
      label: 'Feldhorst',
      provincie: 1,
      slug: 'feldhorst',
    },
    {
      code: '010625244094',
      label: 'Wesenberg',
      provincie: 1,
      slug: 'wesenberg',
    },
    {
      code: '010625262011',
      label: 'Braak',
      provincie: 1,
      slug: 'braak',
    },
    {
      code: '010625262035',
      label: 'Hoisdorf',
      provincie: 1,
      slug: 'hoisdorf',
    },
    {
      code: '010625262069',
      label: 'Siek',
      provincie: 1,
      slug: 'siek',
    },
    {
      code: '010625262071',
      label: 'Stapelfeld',
      provincie: 1,
      slug: 'stapelfeld',
    },
    {
      code: '010625262088',
      label: 'Brunsbek',
      provincie: 1,
      slug: 'brunsbek',
    },
    {
      code: '010625270020',
      label: 'Grande',
      provincie: 1,
      slug: 'grande',
    },
    {
      code: '010625270021',
      label: 'Grönwohld',
      provincie: 1,
      slug: 'groenwohld',
    },
    {
      code: '010625270022',
      label: 'Großensee',
      provincie: 1,
      slug: 'grossensee',
    },
    {
      code: '010625270026',
      label: 'Hamfelde',
      provincie: 1,
      slug: 'hamfelde-gemeinde',
    },
    {
      code: '010625270033',
      label: 'Hohenfelde',
      provincie: 1,
      slug: 'hohenfelde-gemeinde',
    },
    {
      code: '010625270040',
      label: 'Köthel',
      provincie: 1,
      slug: 'koethel-gemeinde',
    },
    {
      code: '010625270045',
      label: 'Lütjensee',
      provincie: 1,
      slug: 'luetjensee',
    },
    {
      code: '010625270058',
      label: 'Rausdorf',
      provincie: 1,
      slug: 'rausdorf',
    },
    {
      code: '010625270082',
      label: 'Trittau',
      provincie: 1,
      slug: 'trittau',
    },
    {
      code: '010625270086',
      label: 'Witzhave',
      provincie: 1,
      slug: 'witzhave',
    },
    {
      code: '020000000000',
      label: 'Hamburg',
      provincie: 2,
      slug: 'hamburg',
    },
    {
      code: '031010000000',
      label: 'Braunschweig',
      provincie: 3,
      slug: 'braunschweig',
    },
    {
      code: '031020000000',
      label: 'Salzgitter',
      provincie: 3,
      slug: 'salzgitter',
    },
    {
      code: '031030000000',
      label: 'Wolfsburg',
      provincie: 3,
      slug: 'wolfsburg',
    },
    {
      code: '031510009009',
      label: 'Gifhorn',
      provincie: 3,
      slug: 'gifhorn',
    },
    {
      code: '031510025025',
      label: 'Sassenburg',
      provincie: 3,
      slug: 'sassenburg',
    },
    {
      code: '031510040040',
      label: 'Wittingen',
      provincie: 3,
      slug: 'wittingen',
    },
    {
      code: '031515401002',
      label: 'Barwedel',
      provincie: 3,
      slug: 'barwedel',
    },
    {
      code: '031515401004',
      label: 'Bokensdorf',
      provincie: 3,
      slug: 'bokensdorf',
    },
    {
      code: '031515401014',
      label: 'Jembke',
      provincie: 3,
      slug: 'jembke',
    },
    {
      code: '031515401020',
      label: 'Osloß',
      provincie: 3,
      slug: 'osloss',
    },
    {
      code: '031515401030',
      label: 'Tappenbeck',
      provincie: 3,
      slug: 'tappenbeck',
    },
    {
      code: '031515401039',
      label: 'Weyhausen',
      provincie: 3,
      slug: 'weyhausen',
    },
    {
      code: '031515402003',
      label: 'Bergfeld',
      provincie: 3,
      slug: 'bergfeld',
    },
    {
      code: '031515402005',
      label: 'Brome',
      provincie: 3,
      slug: 'brome',
    },
    {
      code: '031515402008',
      label: 'Ehra-Lessien',
      provincie: 3,
      slug: 'ehra-lessien',
    },
    {
      code: '031515402021',
      label: 'Parsau',
      provincie: 3,
      slug: 'parsau',
    },
    {
      code: '031515402024',
      label: 'Rühen',
      provincie: 3,
      slug: 'ruehen',
    },
    {
      code: '031515402031',
      label: 'Tiddische',
      provincie: 3,
      slug: 'tiddische',
    },
    {
      code: '031515402032',
      label: 'Tülau',
      provincie: 3,
      slug: 'tuelau',
    },
    {
      code: '031515403007',
      label: 'Dedelstorf',
      provincie: 3,
      slug: 'dedelstorf',
    },
    {
      code: '031515403011',
      label: 'Hankensbüttel',
      provincie: 3,
      slug: 'hankensbuettel',
    },
    {
      code: '031515403019',
      label: 'Obernholz',
      provincie: 3,
      slug: 'obernholz',
    },
    {
      code: '031515403028',
      label: 'Sprakensehl',
      provincie: 3,
      slug: 'sprakensehl',
    },
    {
      code: '031515403029',
      label: 'Steinhorst',
      provincie: 3,
      slug: 'steinhorst-gemeinde',
    },
    {
      code: '031515404006',
      label: 'Calberlah',
      provincie: 3,
      slug: 'calberlah',
    },
    {
      code: '031515404013',
      label: 'Isenbüttel',
      provincie: 3,
      slug: 'isenbuettel',
    },
    {
      code: '031515404022',
      label: 'Ribbesbüttel',
      provincie: 3,
      slug: 'ribbesbuettel',
    },
    {
      code: '031515404037',
      label: 'Wasbüttel',
      provincie: 3,
      slug: 'wasbuettel',
    },
    {
      code: '031515405012',
      label: 'Hillerse',
      provincie: 3,
      slug: 'hillerse',
    },
    {
      code: '031515405015',
      label: 'Leiferde',
      provincie: 3,
      slug: 'leiferde',
    },
    {
      code: '031515405017',
      label: 'Meinersen',
      provincie: 3,
      slug: 'meinersen',
    },
    {
      code: '031515405018',
      label: 'Müden (Aller)',
      provincie: 3,
      slug: 'mueden-aller',
    },
    {
      code: '031515406001',
      label: 'Adenbüttel',
      provincie: 3,
      slug: 'adenbuettel',
    },
    {
      code: '031515406016',
      label: 'Meine',
      provincie: 3,
      slug: 'meine',
    },
    {
      code: '031515406023',
      label: 'Rötgesbüttel',
      provincie: 3,
      slug: 'roetgesbuettel',
    },
    {
      code: '031515406027',
      label: 'Schwülper',
      provincie: 3,
      slug: 'schwuelper',
    },
    {
      code: '031515406034',
      label: 'Vordorf',
      provincie: 3,
      slug: 'vordorf',
    },
    {
      code: '031515406041',
      label: 'Didderse',
      provincie: 3,
      slug: 'didderse',
    },
    {
      code: '031515407010',
      label: 'Groß Oesingen',
      provincie: 3,
      slug: 'gross-oesingen',
    },
    {
      code: '031515407026',
      label: 'Schönewörde',
      provincie: 3,
      slug: 'schoenewoerde',
    },
    {
      code: '031515407033',
      label: 'Ummern',
      provincie: 3,
      slug: 'ummern',
    },
    {
      code: '031515407035',
      label: 'Wagenhoff',
      provincie: 3,
      slug: 'wagenhoff',
    },
    {
      code: '031515407036',
      label: 'Wahrenholz',
      provincie: 3,
      slug: 'wahrenholz',
    },
    {
      code: '031515407038',
      label: 'Wesendorf',
      provincie: 3,
      slug: 'wesendorf',
    },
    {
      code: '031530002002',
      label: 'Bad Harzburg',
      provincie: 3,
      slug: 'bad-harzburg',
    },
    {
      code: '031530008008',
      label: 'Liebenburg',
      provincie: 3,
      slug: 'liebenburg',
    },
    {
      code: '031530012012',
      label: 'Seesen',
      provincie: 3,
      slug: 'seesen',
    },
    {
      code: '031530016016',
      label: 'Braunlage',
      provincie: 3,
      slug: 'braunlage',
    },
    {
      code: '031530017017',
      label: 'Goslar',
      provincie: 3,
      slug: 'goslar',
    },
    {
      code: '031530018018',
      label: 'Clausthal-Zellerfeld',
      provincie: 3,
      slug: 'clausthal-zellerfeld',
    },
    {
      code: '031530019019',
      label: 'Langelsheim',
      provincie: 3,
      slug: 'langelsheim',
    },
    {
      code: '031540013013',
      label: 'Königslutter am Elm',
      provincie: 3,
      slug: 'koenigslutter-am-elm',
    },
    {
      code: '031540014014',
      label: 'Lehre',
      provincie: 3,
      slug: 'lehre',
    },
    {
      code: '031540019019',
      label: 'Schöningen',
      provincie: 3,
      slug: 'schoeningen',
    },
    {
      code: '031540028028',
      label: 'Helmstedt',
      provincie: 3,
      slug: 'helmstedt',
    },
    {
      code: '031545401008',
      label: 'Grasleben',
      provincie: 3,
      slug: 'grasleben',
    },
    {
      code: '031545401015',
      label: 'Mariental',
      provincie: 3,
      slug: 'mariental',
    },
    {
      code: '031545401016',
      label: 'Querenhorst',
      provincie: 3,
      slug: 'querenhorst',
    },
    {
      code: '031545401018',
      label: 'Rennau',
      provincie: 3,
      slug: 'rennau',
    },
    {
      code: '031545402002',
      label: 'Beierstedt',
      provincie: 3,
      slug: 'beierstedt',
    },
    {
      code: '031545402006',
      label: 'Gevensleben',
      provincie: 3,
      slug: 'gevensleben',
    },
    {
      code: '031545402012',
      label: 'Jerxheim',
      provincie: 3,
      slug: 'jerxheim',
    },
    {
      code: '031545402027',
      label: 'Söllingen',
      provincie: 3,
      slug: 'soellingen',
    },
    {
      code: '031545403005',
      label: 'Frellstedt',
      provincie: 3,
      slug: 'frellstedt',
    },
    {
      code: '031545403017',
      label: 'Räbke',
      provincie: 3,
      slug: 'raebke',
    },
    {
      code: '031545403021',
      label: 'Süpplingen',
      provincie: 3,
      slug: 'suepplingen',
    },
    {
      code: '031545403022',
      label: 'Süpplingenburg',
      provincie: 3,
      slug: 'suepplingenburg',
    },
    {
      code: '031545403025',
      label: 'Warberg',
      provincie: 3,
      slug: 'warberg',
    },
    {
      code: '031545403026',
      label: 'Wolsdorf',
      provincie: 3,
      slug: 'wolsdorf',
    },
    {
      code: '031545404001',
      label: 'Bahrdorf',
      provincie: 3,
      slug: 'bahrdorf',
    },
    {
      code: '031545404004',
      label: 'Danndorf',
      provincie: 3,
      slug: 'danndorf',
    },
    {
      code: '031545404007',
      label: 'Grafhorst',
      provincie: 3,
      slug: 'grafhorst',
    },
    {
      code: '031545404009',
      label: 'Groß Twülpstedt',
      provincie: 3,
      slug: 'gross-twuelpstedt',
    },
    {
      code: '031545404024',
      label: 'Velpke',
      provincie: 3,
      slug: 'velpke',
    },
    {
      code: '031550001001',
      label: 'Bad Gandersheim',
      provincie: 3,
      slug: 'bad-gandersheim',
    },
    {
      code: '031550002002',
      label: 'Bodenfelde',
      provincie: 3,
      slug: 'bodenfelde',
    },
    {
      code: '031550003003',
      label: 'Dassel',
      provincie: 3,
      slug: 'dassel',
    },
    {
      code: '031550005005',
      label: 'Hardegsen',
      provincie: 3,
      slug: 'hardegsen',
    },
    {
      code: '031550006006',
      label: 'Kalefeld',
      provincie: 3,
      slug: 'kalefeld',
    },
    {
      code: '031550007007',
      label: 'Katlenburg-Lindau',
      provincie: 3,
      slug: 'katlenburg-lindau',
    },
    {
      code: '031550009009',
      label: 'Moringen',
      provincie: 3,
      slug: 'moringen',
    },
    {
      code: '031550010010',
      label: 'Nörten-Hardenberg',
      provincie: 3,
      slug: 'noerten-hardenberg',
    },
    {
      code: '031550011011',
      label: 'Northeim',
      provincie: 3,
      slug: 'northeim',
    },
    {
      code: '031550012012',
      label: 'Uslar',
      provincie: 3,
      slug: 'uslar',
    },
    {
      code: '031550013013',
      label: 'Einbeck',
      provincie: 3,
      slug: 'einbeck',
    },
    {
      code: '031570001001',
      label: 'Edemissen',
      provincie: 3,
      slug: 'edemissen',
    },
    {
      code: '031570002002',
      label: 'Hohenhameln',
      provincie: 3,
      slug: 'hohenhameln',
    },
    {
      code: '031570005005',
      label: 'Lengede',
      provincie: 3,
      slug: 'lengede',
    },
    {
      code: '031570006006',
      label: 'Peine',
      provincie: 3,
      slug: 'peine',
    },
    {
      code: '031570007007',
      label: 'Vechelde',
      provincie: 3,
      slug: 'vechelde',
    },
    {
      code: '031570008008',
      label: 'Wendeburg',
      provincie: 3,
      slug: 'wendeburg',
    },
    {
      code: '031570009009',
      label: 'Ilsede',
      provincie: 3,
      slug: 'ilsede',
    },
    {
      code: '031580006006',
      label: 'Cremlingen',
      provincie: 3,
      slug: 'cremlingen',
    },
    {
      code: '031580037037',
      label: 'Wolfenbüttel',
      provincie: 3,
      slug: 'wolfenbuettel',
    },
    {
      code: '031580039039',
      label: 'Schladen-Werla',
      provincie: 3,
      slug: 'schladen-werla',
    },
    {
      code: '031585402002',
      label: 'Baddeckenstedt',
      provincie: 3,
      slug: 'baddeckenstedt',
    },
    {
      code: '031585402004',
      label: 'Burgdorf',
      provincie: 3,
      slug: 'burgdorf',
    },
    {
      code: '031585402011',
      label: 'Elbe',
      provincie: 3,
      slug: 'elbe',
    },
    {
      code: '031585402016',
      label: 'Haverlah',
      provincie: 3,
      slug: 'haverlah',
    },
    {
      code: '031585402018',
      label: 'Heere',
      provincie: 3,
      slug: 'heere',
    },
    {
      code: '031585402028',
      label: 'Sehlde',
      provincie: 3,
      slug: 'sehlde',
    },
    {
      code: '031585403005',
      label: 'Cramme',
      provincie: 3,
      slug: 'cramme',
    },
    {
      code: '031585403010',
      label: 'Dorstadt',
      provincie: 3,
      slug: 'dorstadt',
    },
    {
      code: '031585403014',
      label: 'Flöthe',
      provincie: 3,
      slug: 'floethe',
    },
    {
      code: '031585403019',
      label: 'Heiningen',
      provincie: 3,
      slug: 'heiningen',
    },
    {
      code: '031585403023',
      label: 'Ohrum',
      provincie: 3,
      slug: 'ohrum',
    },
    {
      code: '031585403038',
      label: 'Börßum',
      provincie: 3,
      slug: 'boerssum',
    },
    {
      code: '031585406009',
      label: 'Dettum',
      provincie: 3,
      slug: 'dettum',
    },
    {
      code: '031585406012',
      label: 'Erkerode',
      provincie: 3,
      slug: 'erkerode',
    },
    {
      code: '031585406013',
      label: 'Evessen',
      provincie: 3,
      slug: 'evessen',
    },
    {
      code: '031585406030',
      label: 'Sickte',
      provincie: 3,
      slug: 'sickte',
    },
    {
      code: '031585406033',
      label: 'Veltheim (Ohe)',
      provincie: 3,
      slug: 'veltheim-ohe',
    },
    {
      code: '031585407007',
      label: 'Dahlum',
      provincie: 3,
      slug: 'dahlum',
    },
    {
      code: '031585407008',
      label: 'Denkte',
      provincie: 3,
      slug: 'denkte',
    },
    {
      code: '031585407017',
      label: 'Hedeper',
      provincie: 3,
      slug: 'hedeper',
    },
    {
      code: '031585407021',
      label: 'Kissenbrück',
      provincie: 3,
      slug: 'kissenbrueck',
    },
    {
      code: '031585407022',
      label: 'Kneitlingen',
      provincie: 3,
      slug: 'kneitlingen',
    },
    {
      code: '031585407025',
      label: 'Roklum',
      provincie: 3,
      slug: 'roklum',
    },
    {
      code: '031585407027',
      label: 'Schöppenstedt',
      provincie: 3,
      slug: 'schoeppenstedt',
    },
    {
      code: '031585407031',
      label: 'Uehrde',
      provincie: 3,
      slug: 'uehrde',
    },
    {
      code: '031585407032',
      label: 'Vahlberg',
      provincie: 3,
      slug: 'vahlberg',
    },
    {
      code: '031585407035',
      label: 'Winnigstedt',
      provincie: 3,
      slug: 'winnigstedt',
    },
    {
      code: '031585407036',
      label: 'Wittmar',
      provincie: 3,
      slug: 'wittmar',
    },
    {
      code: '031585407040',
      label: 'Remlingen-Semmenstedt',
      provincie: 3,
      slug: 'remlingen-semmenstedt',
    },
    {
      code: '031590001001',
      label: 'Adelebsen',
      provincie: 3,
      slug: 'adelebsen',
    },
    {
      code: '031590002002',
      label: 'Bad Grund (Harz)',
      provincie: 3,
      slug: 'bad-grund-harz',
    },
    {
      code: '031590003003',
      label: 'Bad Lauterberg im Harz',
      provincie: 3,
      slug: 'bad-lauterberg-im-harz',
    },
    {
      code: '031590004004',
      label: 'Bad Sachsa',
      provincie: 3,
      slug: 'bad-sachsa',
    },
    {
      code: '031590007007',
      label: 'Bovenden',
      provincie: 3,
      slug: 'bovenden',
    },
    {
      code: '031590010010',
      label: 'Duderstadt',
      provincie: 3,
      slug: 'duderstadt',
    },
    {
      code: '031590013013',
      label: 'Friedland',
      provincie: 3,
      slug: 'friedland',
    },
    {
      code: '031590015015',
      label: 'Gleichen',
      provincie: 3,
      slug: 'gleichen',
    },
    {
      code: '031590016016',
      label: 'Göttingen',
      provincie: 3,
      slug: 'goettingen',
    },
    {
      code: '031590017017',
      label: 'Hann.Münden',
      provincie: 3,
      slug: 'hann-muenden',
    },
    {
      code: '031590019019',
      label: 'Herzberg am Harz',
      provincie: 3,
      slug: 'herzberg-am-harz',
    },
    {
      code: '031590026026',
      label: 'Osterode am Harz',
      provincie: 3,
      slug: 'osterode-am-harz',
    },
    {
      code: '031590029029',
      label: 'Rosdorf',
      provincie: 3,
      slug: 'rosdorf-gemeinde',
    },
    {
      code: '031590034034',
      label: 'Staufenberg',
      provincie: 3,
      slug: 'staufenberg',
    },
    {
      code: '031590036036',
      label: 'Walkenried',
      provincie: 3,
      slug: 'walkenried',
    },
    {
      code: '031595401008',
      label: 'Bühren',
      provincie: 3,
      slug: 'buehren',
    },
    {
      code: '031595401009',
      label: 'Dransfeld',
      provincie: 3,
      slug: 'dransfeld',
    },
    {
      code: '031595401021',
      label: 'Jühnde',
      provincie: 3,
      slug: 'juehnde',
    },
    {
      code: '031595401024',
      label: 'Niemetal',
      provincie: 3,
      slug: 'niemetal',
    },
    {
      code: '031595401031',
      label: 'Scheden',
      provincie: 3,
      slug: 'scheden',
    },
    {
      code: '031595402005',
      label: 'Bilshausen',
      provincie: 3,
      slug: 'bilshausen',
    },
    {
      code: '031595402006',
      label: 'Bodensee',
      provincie: 3,
      slug: 'bodensee',
    },
    {
      code: '031595402014',
      label: 'Gieboldehausen',
      provincie: 3,
      slug: 'gieboldehausen',
    },
    {
      code: '031595402022',
      label: 'Krebeck',
      provincie: 3,
      slug: 'krebeck',
    },
    {
      code: '031595402025',
      label: 'Obernfeld',
      provincie: 3,
      slug: 'obernfeld',
    },
    {
      code: '031595402027',
      label: 'Rhumspringe',
      provincie: 3,
      slug: 'rhumspringe',
    },
    {
      code: '031595402028',
      label: 'Rollshausen',
      provincie: 3,
      slug: 'rollshausen',
    },
    {
      code: '031595402030',
      label: 'Rüdershausen',
      provincie: 3,
      slug: 'ruedershausen',
    },
    {
      code: '031595402037',
      label: 'Wollbrandshausen',
      provincie: 3,
      slug: 'wollbrandshausen',
    },
    {
      code: '031595402038',
      label: 'Wollershausen',
      provincie: 3,
      slug: 'wollershausen',
    },
    {
      code: '031595403012',
      label: 'Elbingerode',
      provincie: 3,
      slug: 'elbingerode',
    },
    {
      code: '031595403018',
      label: 'Hattorf am Harz',
      provincie: 3,
      slug: 'hattorf-am-harz',
    },
    {
      code: '031595403020',
      label: 'Hörden am Harz',
      provincie: 3,
      slug: 'hoerden-am-harz',
    },
    {
      code: '031595403039',
      label: 'Wulften am Harz',
      provincie: 3,
      slug: 'wulften-am-harz',
    },
    {
      code: '031595404011',
      label: 'Ebergötzen',
      provincie: 3,
      slug: 'ebergoetzen',
    },
    {
      code: '031595404023',
      label: 'Landolfshausen',
      provincie: 3,
      slug: 'landolfshausen',
    },
    {
      code: '031595404032',
      label: 'Seeburg',
      provincie: 3,
      slug: 'seeburg',
    },
    {
      code: '031595404033',
      label: 'Seulingen',
      provincie: 3,
      slug: 'seulingen',
    },
    {
      code: '031595404035',
      label: 'Waake',
      provincie: 3,
      slug: 'waake',
    },
    {
      code: '032410001001',
      label: 'Hannover',
      provincie: 3,
      slug: 'hannover',
    },
    {
      code: '032410002002',
      label: 'Barsinghausen',
      provincie: 3,
      slug: 'barsinghausen',
    },
    {
      code: '032410003003',
      label: 'Burgdorf',
      provincie: 3,
      slug: 'burgdorf-stadt',
    },
    {
      code: '032410004004',
      label: 'Burgwedel',
      provincie: 3,
      slug: 'burgwedel',
    },
    {
      code: '032410005005',
      label: 'Garbsen',
      provincie: 3,
      slug: 'garbsen',
    },
    {
      code: '032410006006',
      label: 'Gehrden',
      provincie: 3,
      slug: 'gehrden',
    },
    {
      code: '032410007007',
      label: 'Hemmingen',
      provincie: 3,
      slug: 'hemmingen',
    },
    {
      code: '032410008008',
      label: 'Isernhagen',
      provincie: 3,
      slug: 'isernhagen',
    },
    {
      code: '032410009009',
      label: 'Laatzen',
      provincie: 3,
      slug: 'laatzen',
    },
    {
      code: '032410010010',
      label: 'Langenhagen',
      provincie: 3,
      slug: 'langenhagen',
    },
    {
      code: '032410011011',
      label: 'Lehrte',
      provincie: 3,
      slug: 'lehrte',
    },
    {
      code: '032410012012',
      label: 'Neustadt am Rübenberge',
      provincie: 3,
      slug: 'neustadt-am-ruebenberge',
    },
    {
      code: '032410013013',
      label: 'Pattensen',
      provincie: 3,
      slug: 'pattensen',
    },
    {
      code: '032410014014',
      label: 'Ronnenberg',
      provincie: 3,
      slug: 'ronnenberg',
    },
    {
      code: '032410015015',
      label: 'Seelze',
      provincie: 3,
      slug: 'seelze',
    },
    {
      code: '032410016016',
      label: 'Sehnde',
      provincie: 3,
      slug: 'sehnde',
    },
    {
      code: '032410017017',
      label: 'Springe',
      provincie: 3,
      slug: 'springe',
    },
    {
      code: '032410018018',
      label: 'Uetze',
      provincie: 3,
      slug: 'uetze',
    },
    {
      code: '032410019019',
      label: 'Wedemark',
      provincie: 3,
      slug: 'wedemark',
    },
    {
      code: '032410020020',
      label: 'Wennigsen (Deister)',
      provincie: 3,
      slug: 'wennigsen-deister',
    },
    {
      code: '032410021021',
      label: 'Wunstorf',
      provincie: 3,
      slug: 'wunstorf',
    },
    {
      code: '032510007007',
      label: 'Bassum',
      provincie: 3,
      slug: 'bassum',
    },
    {
      code: '032510012012',
      label: 'Diepholz',
      provincie: 3,
      slug: 'diepholz',
    },
    {
      code: '032510037037',
      label: 'Stuhr',
      provincie: 3,
      slug: 'stuhr',
    },
    {
      code: '032510040040',
      label: 'Sulingen',
      provincie: 3,
      slug: 'sulingen',
    },
    {
      code: '032510041041',
      label: 'Syke',
      provincie: 3,
      slug: 'syke',
    },
    {
      code: '032510042042',
      label: 'Twistringen',
      provincie: 3,
      slug: 'twistringen',
    },
    {
      code: '032510044044',
      label: 'Wagenfeld',
      provincie: 3,
      slug: 'wagenfeld',
    },
    {
      code: '032510047047',
      label: 'Weyhe',
      provincie: 3,
      slug: 'weyhe',
    },
    {
      code: '032515401009',
      label: 'Brockum',
      provincie: 3,
      slug: 'brockum',
    },
    {
      code: '032515401020',
      label: 'Hüde',
      provincie: 3,
      slug: 'huede',
    },
    {
      code: '032515401022',
      label: 'Lembruch',
      provincie: 3,
      slug: 'lembruch',
    },
    {
      code: '032515401023',
      label: 'Lemförde',
      provincie: 3,
      slug: 'lemfoerde',
    },
    {
      code: '032515401025',
      label: 'Marl',
      provincie: 3,
      slug: 'marl',
    },
    {
      code: '032515401029',
      label: 'Quernheim',
      provincie: 3,
      slug: 'quernheim',
    },
    {
      code: '032515401036',
      label: 'Stemshorn',
      provincie: 3,
      slug: 'stemshorn',
    },
    {
      code: '032515402005',
      label: 'Barnstorf',
      provincie: 3,
      slug: 'barnstorf',
    },
    {
      code: '032515402013',
      label: 'Drebber',
      provincie: 3,
      slug: 'drebber',
    },
    {
      code: '032515402014',
      label: 'Drentwede',
      provincie: 3,
      slug: 'drentwede',
    },
    {
      code: '032515402017',
      label: 'Eydelstedt',
      provincie: 3,
      slug: 'eydelstedt',
    },
    {
      code: '032515403002',
      label: 'Asendorf',
      provincie: 3,
      slug: 'asendorf',
    },
    {
      code: '032515403026',
      label: 'Martfeld',
      provincie: 3,
      slug: 'martfeld',
    },
    {
      code: '032515403033',
      label: 'Schwarme',
      provincie: 3,
      slug: 'schwarme',
    },
    {
      code: '032515403049',
      label: 'Bruchhausen-Vilsen',
      provincie: 3,
      slug: 'bruchhausen-vilsen',
    },
    {
      code: '032515404003',
      label: 'Bahrenborstel',
      provincie: 3,
      slug: 'bahrenborstel',
    },
    {
      code: '032515404004',
      label: 'Barenburg',
      provincie: 3,
      slug: 'barenburg',
    },
    {
      code: '032515404018',
      label: 'Freistatt',
      provincie: 3,
      slug: 'freistatt',
    },
    {
      code: '032515404021',
      label: 'Kirchdorf',
      provincie: 3,
      slug: 'kirchdorf',
    },
    {
      code: '032515404043',
      label: 'Varrel',
      provincie: 3,
      slug: 'varrel',
    },
    {
      code: '032515404045',
      label: 'Wehrbleck',
      provincie: 3,
      slug: 'wehrbleck',
    },
    {
      code: '032515405006',
      label: 'Barver',
      provincie: 3,
      slug: 'barver',
    },
    {
      code: '032515405011',
      label: 'Dickel',
      provincie: 3,
      slug: 'dickel',
    },
    {
      code: '032515405019',
      label: 'Hemsloh',
      provincie: 3,
      slug: 'hemsloh',
    },
    {
      code: '032515405030',
      label: 'Rehden',
      provincie: 3,
      slug: 'rehden',
    },
    {
      code: '032515405046',
      label: 'Wetschen',
      provincie: 3,
      slug: 'wetschen',
    },
    {
      code: '032515406001',
      label: 'Affinghausen',
      provincie: 3,
      slug: 'affinghausen',
    },
    {
      code: '032515406015',
      label: 'Ehrenburg',
      provincie: 3,
      slug: 'ehrenburg',
    },
    {
      code: '032515406028',
      label: 'Neuenkirchen',
      provincie: 3,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '032515406031',
      label: 'Scholen',
      provincie: 3,
      slug: 'scholen',
    },
    {
      code: '032515406032',
      label: 'Schwaförden',
      provincie: 3,
      slug: 'schwafoerden',
    },
    {
      code: '032515406038',
      label: 'Sudwalde',
      provincie: 3,
      slug: 'sudwalde',
    },
    {
      code: '032515407008',
      label: 'Borstel',
      provincie: 3,
      slug: 'borstel-gemeinde',
    },
    {
      code: '032515407024',
      label: 'Maasen',
      provincie: 3,
      slug: 'maasen',
    },
    {
      code: '032515407027',
      label: 'Mellinghausen',
      provincie: 3,
      slug: 'mellinghausen',
    },
    {
      code: '032515407034',
      label: 'Siedenburg',
      provincie: 3,
      slug: 'siedenburg',
    },
    {
      code: '032515407035',
      label: 'Staffhorst',
      provincie: 3,
      slug: 'staffhorst',
    },
    {
      code: '032520001001',
      label: 'Aerzen',
      provincie: 3,
      slug: 'aerzen',
    },
    {
      code: '032520002002',
      label: 'Bad Münder am Deister',
      provincie: 3,
      slug: 'bad-muender-am-deister',
    },
    {
      code: '032520003003',
      label: 'Bad Pyrmont',
      provincie: 3,
      slug: 'bad-pyrmont',
    },
    {
      code: '032520004004',
      label: 'Coppenbrügge',
      provincie: 3,
      slug: 'coppenbruegge',
    },
    {
      code: '032520005005',
      label: 'Emmerthal',
      provincie: 3,
      slug: 'emmerthal',
    },
    {
      code: '032520006006',
      label: 'Hameln',
      provincie: 3,
      slug: 'hameln',
    },
    {
      code: '032520007007',
      label: 'Hessisch Oldendorf',
      provincie: 3,
      slug: 'hessisch-oldendorf',
    },
    {
      code: '032520008008',
      label: 'Salzhemmendorf',
      provincie: 3,
      slug: 'salzhemmendorf',
    },
    {
      code: '032540002002',
      label: 'Alfeld (Leine)',
      provincie: 3,
      slug: 'alfeld-leine',
    },
    {
      code: '032540003003',
      label: 'Algermissen',
      provincie: 3,
      slug: 'algermissen',
    },
    {
      code: '032540005005',
      label: 'Bad Salzdetfurth',
      provincie: 3,
      slug: 'bad-salzdetfurth',
    },
    {
      code: '032540008008',
      label: 'Bockenem',
      provincie: 3,
      slug: 'bockenem',
    },
    {
      code: '032540011011',
      label: 'Diekholzen',
      provincie: 3,
      slug: 'diekholzen',
    },
    {
      code: '032540014014',
      label: 'Elze',
      provincie: 3,
      slug: 'elze',
    },
    {
      code: '032540017017',
      label: 'Giesen',
      provincie: 3,
      slug: 'giesen',
    },
    {
      code: '032540020020',
      label: 'Harsum',
      provincie: 3,
      slug: 'harsum',
    },
    {
      code: '032540021021',
      label: 'Hildesheim',
      provincie: 3,
      slug: 'hildesheim',
    },
    {
      code: '032540022022',
      label: 'Holle',
      provincie: 3,
      slug: 'holle',
    },
    {
      code: '032540026026',
      label: 'Nordstemmen',
      provincie: 3,
      slug: 'nordstemmen',
    },
    {
      code: '032540028028',
      label: 'Sarstedt',
      provincie: 3,
      slug: 'sarstedt',
    },
    {
      code: '032540029029',
      label: 'Schellerten',
      provincie: 3,
      slug: 'schellerten',
    },
    {
      code: '032540032032',
      label: 'Söhlde',
      provincie: 3,
      slug: 'soehlde',
    },
    {
      code: '032540042042',
      label: 'Freden (Leine)',
      provincie: 3,
      slug: 'freden-leine',
    },
    {
      code: '032540044044',
      label: 'Lamspringe',
      provincie: 3,
      slug: 'lamspringe',
    },
    {
      code: '032540045045',
      label: 'Sibbesse',
      provincie: 3,
      slug: 'sibbesse',
    },
    {
      code: '032545406013',
      label: 'Eime',
      provincie: 3,
      slug: 'eime',
    },
    {
      code: '032545406041',
      label: 'Duingen',
      provincie: 3,
      slug: 'duingen',
    },
    {
      code: '032545406043',
      label: 'Gronau (Leine)',
      provincie: 3,
      slug: 'gronau-leine',
    },
    {
      code: '032550008008',
      label: 'Delligsen',
      provincie: 3,
      slug: 'delligsen',
    },
    {
      code: '032550023023',
      label: 'Holzminden',
      provincie: 3,
      slug: 'holzminden',
    },
    {
      code: '032555401002',
      label: 'Bevern',
      provincie: 3,
      slug: 'bevern-gemeinde',
    },
    {
      code: '032555401015',
      label: 'Golmbach',
      provincie: 3,
      slug: 'golmbach',
    },
    {
      code: '032555401021',
      label: 'Holenberg',
      provincie: 3,
      slug: 'holenberg',
    },
    {
      code: '032555401030',
      label: 'Negenborn',
      provincie: 3,
      slug: 'negenborn',
    },
    {
      code: '032555403004',
      label: 'Boffzen',
      provincie: 3,
      slug: 'boffzen',
    },
    {
      code: '032555403009',
      label: 'Derental',
      provincie: 3,
      slug: 'derental',
    },
    {
      code: '032555403014',
      label: 'Fürstenberg',
      provincie: 3,
      slug: 'fuerstenberg',
    },
    {
      code: '032555403026',
      label: 'Lauenförde',
      provincie: 3,
      slug: 'lauenfoerde',
    },
    {
      code: '032555408003',
      label: 'Bodenwerder',
      provincie: 3,
      slug: 'bodenwerder',
    },
    {
      code: '032555408005',
      label: 'Brevörde',
      provincie: 3,
      slug: 'brevoerde',
    },
    {
      code: '032555408016',
      label: 'Halle',
      provincie: 3,
      slug: 'halle',
    },
    {
      code: '032555408017',
      label: 'Hehlen',
      provincie: 3,
      slug: 'hehlen',
    },
    {
      code: '032555408019',
      label: 'Heinsen',
      provincie: 3,
      slug: 'heinsen',
    },
    {
      code: '032555408020',
      label: 'Heyen',
      provincie: 3,
      slug: 'heyen',
    },
    {
      code: '032555408025',
      label: 'Kirchbrak',
      provincie: 3,
      slug: 'kirchbrak',
    },
    {
      code: '032555408031',
      label: 'Ottenstein',
      provincie: 3,
      slug: 'ottenstein',
    },
    {
      code: '032555408032',
      label: 'Pegestorf',
      provincie: 3,
      slug: 'pegestorf',
    },
    {
      code: '032555408033',
      label: 'Polle',
      provincie: 3,
      slug: 'polle',
    },
    {
      code: '032555408035',
      label: 'Vahlbruch',
      provincie: 3,
      slug: 'vahlbruch',
    },
    {
      code: '032555409001',
      label: 'Arholzen',
      provincie: 3,
      slug: 'arholzen',
    },
    {
      code: '032555409007',
      label: 'Deensen',
      provincie: 3,
      slug: 'deensen',
    },
    {
      code: '032555409010',
      label: 'Dielmissen',
      provincie: 3,
      slug: 'dielmissen',
    },
    {
      code: '032555409012',
      label: 'Eimen',
      provincie: 3,
      slug: 'eimen',
    },
    {
      code: '032555409013',
      label: 'Eschershausen',
      provincie: 3,
      slug: 'eschershausen',
    },
    {
      code: '032555409018',
      label: 'Heinade',
      provincie: 3,
      slug: 'heinade',
    },
    {
      code: '032555409022',
      label: 'Holzen',
      provincie: 3,
      slug: 'holzen',
    },
    {
      code: '032555409027',
      label: 'Lenne',
      provincie: 3,
      slug: 'lenne',
    },
    {
      code: '032555409028',
      label: 'Lüerdissen',
      provincie: 3,
      slug: 'lueerdissen',
    },
    {
      code: '032555409034',
      label: 'Stadtoldendorf',
      provincie: 3,
      slug: 'stadtoldendorf',
    },
    {
      code: '032555409036',
      label: 'Wangelnstedt',
      provincie: 3,
      slug: 'wangelnstedt',
    },
    {
      code: '032560022022',
      label: 'Nienburg (Weser)',
      provincie: 3,
      slug: 'nienburg-weser',
    },
    {
      code: '032560025025',
      label: 'Rehburg-Loccum',
      provincie: 3,
      slug: 'rehburg-loccum',
    },
    {
      code: '032560030030',
      label: 'Steyerberg',
      provincie: 3,
      slug: 'steyerberg',
    },
    {
      code: '032565402005',
      label: 'Drakenburg',
      provincie: 3,
      slug: 'drakenburg',
    },
    {
      code: '032565402011',
      label: 'Haßbergen',
      provincie: 3,
      slug: 'hassbergen',
    },
    {
      code: '032565402012',
      label: 'Heemsen',
      provincie: 3,
      slug: 'heemsen',
    },
    {
      code: '032565402027',
      label: 'Rohrsen',
      provincie: 3,
      slug: 'rohrsen',
    },
    {
      code: '032565407020',
      label: 'Linsburg',
      provincie: 3,
      slug: 'linsburg',
    },
    {
      code: '032565407026',
      label: 'Rodewald',
      provincie: 3,
      slug: 'rodewald',
    },
    {
      code: '032565407029',
      label: 'Steimbke',
      provincie: 3,
      slug: 'steimbke',
    },
    {
      code: '032565407031',
      label: 'Stöckse',
      provincie: 3,
      slug: 'stoeckse',
    },
    {
      code: '032565408004',
      label: 'Diepenau',
      provincie: 3,
      slug: 'diepenau',
    },
    {
      code: '032565408024',
      label: 'Raddestorf',
      provincie: 3,
      slug: 'raddestorf',
    },
    {
      code: '032565408033',
      label: 'Uchte',
      provincie: 3,
      slug: 'uchte',
    },
    {
      code: '032565408034',
      label: 'Warmsen',
      provincie: 3,
      slug: 'warmsen',
    },
    {
      code: '032565409003',
      label: 'Bücken',
      provincie: 3,
      slug: 'buecken',
    },
    {
      code: '032565409007',
      label: 'Eystrup',
      provincie: 3,
      slug: 'eystrup',
    },
    {
      code: '032565409008',
      label: 'Gandesbergen',
      provincie: 3,
      slug: 'gandesbergen',
    },
    {
      code: '032565409009',
      label: 'Hämelhausen',
      provincie: 3,
      slug: 'haemelhausen',
    },
    {
      code: '032565409010',
      label: 'Hassel (Weser)',
      provincie: 3,
      slug: 'hassel-weser',
    },
    {
      code: '032565409013',
      label: 'Hilgermissen',
      provincie: 3,
      slug: 'hilgermissen',
    },
    {
      code: '032565409014',
      label: 'Hoya',
      provincie: 3,
      slug: 'hoya',
    },
    {
      code: '032565409015',
      label: 'Hoyerhagen',
      provincie: 3,
      slug: 'hoyerhagen',
    },
    {
      code: '032565409028',
      label: 'Schweringen',
      provincie: 3,
      slug: 'schweringen',
    },
    {
      code: '032565409035',
      label: 'Warpe',
      provincie: 3,
      slug: 'warpe',
    },
    {
      code: '032565410006',
      label: 'Estorf',
      provincie: 3,
      slug: 'estorf',
    },
    {
      code: '032565410016',
      label: 'Husum',
      provincie: 3,
      slug: 'husum-gemeinde',
    },
    {
      code: '032565410017',
      label: 'Landesbergen',
      provincie: 3,
      slug: 'landesbergen',
    },
    {
      code: '032565410018',
      label: 'Leese',
      provincie: 3,
      slug: 'leese',
    },
    {
      code: '032565410032',
      label: 'Stolzenau',
      provincie: 3,
      slug: 'stolzenau',
    },
    {
      code: '032565411001',
      label: 'Balge',
      provincie: 3,
      slug: 'balge',
    },
    {
      code: '032565411002',
      label: 'Binnen',
      provincie: 3,
      slug: 'binnen',
    },
    {
      code: '032565411019',
      label: 'Liebenau',
      provincie: 3,
      slug: 'liebenau',
    },
    {
      code: '032565411021',
      label: 'Marklohe',
      provincie: 3,
      slug: 'marklohe',
    },
    {
      code: '032565411023',
      label: 'Pennigsehl',
      provincie: 3,
      slug: 'pennigsehl',
    },
    {
      code: '032565411036',
      label: 'Wietzen',
      provincie: 3,
      slug: 'wietzen',
    },
    {
      code: '032570003003',
      label: 'Auetal',
      provincie: 3,
      slug: 'auetal',
    },
    {
      code: '032570009009',
      label: 'Bückeburg',
      provincie: 3,
      slug: 'bueckeburg',
    },
    {
      code: '032570028028',
      label: 'Obernkirchen',
      provincie: 3,
      slug: 'obernkirchen',
    },
    {
      code: '032570031031',
      label: 'Rinteln',
      provincie: 3,
      slug: 'rinteln',
    },
    {
      code: '032570035035',
      label: 'Stadthagen',
      provincie: 3,
      slug: 'stadthagen',
    },
    {
      code: '032575401001',
      label: 'Ahnsen',
      provincie: 3,
      slug: 'ahnsen',
    },
    {
      code: '032575401005',
      label: 'Bad Eilsen',
      provincie: 3,
      slug: 'bad-eilsen',
    },
    {
      code: '032575401008',
      label: 'Buchholz',
      provincie: 3,
      slug: 'buchholz-gemeinde',
    },
    {
      code: '032575401012',
      label: 'Heeßen',
      provincie: 3,
      slug: 'heessen',
    },
    {
      code: '032575401022',
      label: 'Luhden',
      provincie: 3,
      slug: 'luhden',
    },
    {
      code: '032575402007',
      label: 'Beckedorf',
      provincie: 3,
      slug: 'beckedorf',
    },
    {
      code: '032575402015',
      label: 'Heuerßen',
      provincie: 3,
      slug: 'heuerssen',
    },
    {
      code: '032575402020',
      label: 'Lindhorst',
      provincie: 3,
      slug: 'lindhorst',
    },
    {
      code: '032575402021',
      label: 'Lüdersfeld',
      provincie: 3,
      slug: 'luedersfeld',
    },
    {
      code: '032575403006',
      label: 'Bad Nenndorf',
      provincie: 3,
      slug: 'bad-nenndorf',
    },
    {
      code: '032575403011',
      label: 'Haste',
      provincie: 3,
      slug: 'haste',
    },
    {
      code: '032575403016',
      label: 'Hohnhorst',
      provincie: 3,
      slug: 'hohnhorst',
    },
    {
      code: '032575403036',
      label: 'Suthfeld',
      provincie: 3,
      slug: 'suthfeld',
    },
    {
      code: '032575404019',
      label: 'Lauenhagen',
      provincie: 3,
      slug: 'lauenhagen',
    },
    {
      code: '032575404023',
      label: 'Meerbeck',
      provincie: 3,
      slug: 'meerbeck',
    },
    {
      code: '032575404025',
      label: 'Niedernwöhren',
      provincie: 3,
      slug: 'niedernwoehren',
    },
    {
      code: '032575404027',
      label: 'Nordsehl',
      provincie: 3,
      slug: 'nordsehl',
    },
    {
      code: '032575404030',
      label: 'Pollhagen',
      provincie: 3,
      slug: 'pollhagen',
    },
    {
      code: '032575404037',
      label: 'Wiedensahl',
      provincie: 3,
      slug: 'wiedensahl',
    },
    {
      code: '032575405013',
      label: 'Helpsen',
      provincie: 3,
      slug: 'helpsen',
    },
    {
      code: '032575405014',
      label: 'Hespe',
      provincie: 3,
      slug: 'hespe',
    },
    {
      code: '032575405026',
      label: 'Nienstädt',
      provincie: 3,
      slug: 'nienstaedt',
    },
    {
      code: '032575405034',
      label: 'Seggebruch',
      provincie: 3,
      slug: 'seggebruch',
    },
    {
      code: '032575406002',
      label: 'Apelern',
      provincie: 3,
      slug: 'apelern',
    },
    {
      code: '032575406017',
      label: 'Hülsede',
      provincie: 3,
      slug: 'huelsede',
    },
    {
      code: '032575406018',
      label: 'Lauenau',
      provincie: 3,
      slug: 'lauenau',
    },
    {
      code: '032575406024',
      label: 'Messenkamp',
      provincie: 3,
      slug: 'messenkamp',
    },
    {
      code: '032575406029',
      label: 'Pohle',
      provincie: 3,
      slug: 'pohle',
    },
    {
      code: '032575406032',
      label: 'Rodenberg',
      provincie: 3,
      slug: 'rodenberg',
    },
    {
      code: '032575407004',
      label: 'Auhagen',
      provincie: 3,
      slug: 'auhagen',
    },
    {
      code: '032575407010',
      label: 'Hagenburg',
      provincie: 3,
      slug: 'hagenburg',
    },
    {
      code: '032575407033',
      label: 'Sachsenhagen',
      provincie: 3,
      slug: 'sachsenhagen',
    },
    {
      code: '032575407038',
      label: 'Wölpinghausen',
      provincie: 3,
      slug: 'woelpinghausen',
    },
    {
      code: '033510004004',
      label: 'Bergen',
      provincie: 3,
      slug: 'bergen',
    },
    {
      code: '033510006006',
      label: 'Celle',
      provincie: 3,
      slug: 'celle',
    },
    {
      code: '033510010010',
      label: 'Faßberg',
      provincie: 3,
      slug: 'fassberg',
    },
    {
      code: '033510012012',
      label: 'Hambühren',
      provincie: 3,
      slug: 'hambuehren',
    },
    {
      code: '033510023023',
      label: 'Wietze',
      provincie: 3,
      slug: 'wietze',
    },
    {
      code: '033510024024',
      label: 'Winsen (Aller)',
      provincie: 3,
      slug: 'winsen-aller',
    },
    {
      code: '033510025025',
      label: 'Eschede',
      provincie: 3,
      slug: 'eschede',
    },
    {
      code: '033510026026',
      label: 'Südheide',
      provincie: 3,
      slug: 'suedheide',
    },
    {
      code: '033515402005',
      label: 'Bröckel',
      provincie: 3,
      slug: 'broeckel',
    },
    {
      code: '033515402007',
      label: 'Eicklingen',
      provincie: 3,
      slug: 'eicklingen',
    },
    {
      code: '033515402017',
      label: 'Langlingen',
      provincie: 3,
      slug: 'langlingen',
    },
    {
      code: '033515402022',
      label: 'Wienhausen',
      provincie: 3,
      slug: 'wienhausen',
    },
    {
      code: '033515403002',
      label: 'Ahnsbeck',
      provincie: 3,
      slug: 'ahnsbeck',
    },
    {
      code: '033515403003',
      label: 'Beedenbostel',
      provincie: 3,
      slug: 'beedenbostel',
    },
    {
      code: '033515403008',
      label: 'Eldingen',
      provincie: 3,
      slug: 'eldingen',
    },
    {
      code: '033515403015',
      label: 'Hohne',
      provincie: 3,
      slug: 'hohne',
    },
    {
      code: '033515403016',
      label: 'Lachendorf',
      provincie: 3,
      slug: 'lachendorf',
    },
    {
      code: '033515404001',
      label: 'Adelheidsdorf',
      provincie: 3,
      slug: 'adelheidsdorf',
    },
    {
      code: '033515404018',
      label: 'Nienhagen',
      provincie: 3,
      slug: 'nienhagen',
    },
    {
      code: '033515404021',
      label: 'Wathlingen',
      provincie: 3,
      slug: 'wathlingen',
    },
    {
      code: '033520011011',
      label: 'Cuxhaven',
      provincie: 3,
      slug: 'cuxhaven',
    },
    {
      code: '033520032032',
      label: 'Loxstedt',
      provincie: 3,
      slug: 'loxstedt',
    },
    {
      code: '033520050050',
      label: 'Schiffdorf',
      provincie: 3,
      slug: 'schiffdorf',
    },
    {
      code: '033520059059',
      label: 'Beverstedt',
      provincie: 3,
      slug: 'beverstedt',
    },
    {
      code: '033520060060',
      label: 'Hagen im Bremischen',
      provincie: 3,
      slug: 'hagen-im-bremischen',
    },
    {
      code: '033520061061',
      label: 'Wurster Nordseeküste',
      provincie: 3,
      slug: 'wurster-nordseekueste',
    },
    {
      code: '033520062062',
      label: 'Geestland',
      provincie: 3,
      slug: 'geestland',
    },
    {
      code: '033525404002',
      label: 'Armstorf',
      provincie: 3,
      slug: 'armstorf',
    },
    {
      code: '033525404024',
      label: 'Hollnseth',
      provincie: 3,
      slug: 'hollnseth',
    },
    {
      code: '033525404029',
      label: 'Lamstedt',
      provincie: 3,
      slug: 'lamstedt',
    },
    {
      code: '033525404036',
      label: 'Mittelstenahe',
      provincie: 3,
      slug: 'mittelstenahe',
    },
    {
      code: '033525404052',
      label: 'Stinstedt',
      provincie: 3,
      slug: 'stinstedt',
    },
    {
      code: '033525407020',
      label: 'Hechthausen',
      provincie: 3,
      slug: 'hechthausen',
    },
    {
      code: '033525407022',
      label: 'Hemmoor',
      provincie: 3,
      slug: 'hemmoor',
    },
    {
      code: '033525407044',
      label: 'Osten',
      provincie: 3,
      slug: 'osten',
    },
    {
      code: '033525411004',
      label: 'Belum',
      provincie: 3,
      slug: 'belum',
    },
    {
      code: '033525411008',
      label: 'Bülkau',
      provincie: 3,
      slug: 'buelkau',
    },
    {
      code: '033525411025',
      label: 'Ihlienworth',
      provincie: 3,
      slug: 'ihlienworth',
    },
    {
      code: '033525411038',
      label: 'Neuenkirchen',
      provincie: 3,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '033525411039',
      label: 'Neuhaus (Oste)',
      provincie: 3,
      slug: 'neuhaus-oste',
    },
    {
      code: '033525411041',
      label: 'Nordleda',
      provincie: 3,
      slug: 'nordleda',
    },
    {
      code: '033525411042',
      label: 'Oberndorf',
      provincie: 3,
      slug: 'oberndorf',
    },
    {
      code: '033525411043',
      label: 'Odisheim',
      provincie: 3,
      slug: 'odisheim',
    },
    {
      code: '033525411045',
      label: 'Osterbruch',
      provincie: 3,
      slug: 'osterbruch',
    },
    {
      code: '033525411046',
      label: 'Otterndorf',
      provincie: 3,
      slug: 'otterndorf',
    },
    {
      code: '033525411051',
      label: 'Steinau',
      provincie: 3,
      slug: 'steinau',
    },
    {
      code: '033525411055',
      label: 'Wanna',
      provincie: 3,
      slug: 'wanna',
    },
    {
      code: '033525411056',
      label: 'Wingst',
      provincie: 3,
      slug: 'wingst',
    },
    {
      code: '033525411063',
      label: 'Cadenberge',
      provincie: 3,
      slug: 'cadenberge',
    },
    {
      code: '033530005005',
      label: 'Buchholz in der Nordheide',
      provincie: 3,
      slug: 'buchholz-in-der-nordheide',
    },
    {
      code: '033530026026',
      label: 'Neu Wulmstorf',
      provincie: 3,
      slug: 'neu-wulmstorf',
    },
    {
      code: '033530029029',
      label: 'Rosengarten',
      provincie: 3,
      slug: 'rosengarten',
    },
    {
      code: '033530031031',
      label: 'Seevetal',
      provincie: 3,
      slug: 'seevetal',
    },
    {
      code: '033530032032',
      label: 'Stelle',
      provincie: 3,
      slug: 'stelle',
    },
    {
      code: '033530040040',
      label: 'Winsen (Luhe)',
      provincie: 3,
      slug: 'winsen-luhe',
    },
    {
      code: '033535401007',
      label: 'Drage',
      provincie: 3,
      slug: 'drage-gemeinde',
    },
    {
      code: '033535401023',
      label: 'Marschacht',
      provincie: 3,
      slug: 'marschacht',
    },
    {
      code: '033535401033',
      label: 'Tespe',
      provincie: 3,
      slug: 'tespe',
    },
    {
      code: '033535402002',
      label: 'Asendorf',
      provincie: 3,
      slug: 'asendorf-gemeinde',
    },
    {
      code: '033535402004',
      label: 'Brackel',
      provincie: 3,
      slug: 'brackel',
    },
    {
      code: '033535402009',
      label: 'Egestorf',
      provincie: 3,
      slug: 'egestorf',
    },
    {
      code: '033535402016',
      label: 'Hanstedt',
      provincie: 3,
      slug: 'hanstedt',
    },
    {
      code: '033535402024',
      label: 'Marxen',
      provincie: 3,
      slug: 'marxen',
    },
    {
      code: '033535402036',
      label: 'Undeloh',
      provincie: 3,
      slug: 'undeloh',
    },
    {
      code: '033535403001',
      label: 'Appel',
      provincie: 3,
      slug: 'appel',
    },
    {
      code: '033535403008',
      label: 'Drestedt',
      provincie: 3,
      slug: 'drestedt',
    },
    {
      code: '033535403014',
      label: 'Halvesbostel',
      provincie: 3,
      slug: 'halvesbostel',
    },
    {
      code: '033535403019',
      label: 'Hollenstedt',
      provincie: 3,
      slug: 'hollenstedt',
    },
    {
      code: '033535403025',
      label: 'Moisburg',
      provincie: 3,
      slug: 'moisburg',
    },
    {
      code: '033535403028',
      label: 'Regesbostel',
      provincie: 3,
      slug: 'regesbostel',
    },
    {
      code: '033535403039',
      label: 'Wenzendorf',
      provincie: 3,
      slug: 'wenzendorf',
    },
    {
      code: '033535404003',
      label: 'Bendestorf',
      provincie: 3,
      slug: 'bendestorf',
    },
    {
      code: '033535404017',
      label: 'Harmstorf',
      provincie: 3,
      slug: 'harmstorf',
    },
    {
      code: '033535404020',
      label: 'Jesteburg',
      provincie: 3,
      slug: 'jesteburg',
    },
    {
      code: '033535405010',
      label: 'Eyendorf',
      provincie: 3,
      slug: 'eyendorf',
    },
    {
      code: '033535405011',
      label: 'Garlstorf',
      provincie: 3,
      slug: 'garlstorf',
    },
    {
      code: '033535405012',
      label: 'Garstedt',
      provincie: 3,
      slug: 'garstedt',
    },
    {
      code: '033535405013',
      label: 'Gödenstorf',
      provincie: 3,
      slug: 'goedenstorf',
    },
    {
      code: '033535405030',
      label: 'Salzhausen',
      provincie: 3,
      slug: 'salzhausen',
    },
    {
      code: '033535405034',
      label: 'Toppenstedt',
      provincie: 3,
      slug: 'toppenstedt',
    },
    {
      code: '033535405037',
      label: 'Vierhöfen',
      provincie: 3,
      slug: 'vierhoefen',
    },
    {
      code: '033535405042',
      label: 'Wulfsen',
      provincie: 3,
      slug: 'wulfsen',
    },
    {
      code: '033535406006',
      label: 'Dohren',
      provincie: 3,
      slug: 'dohren',
    },
    {
      code: '033535406015',
      label: 'Handeloh',
      provincie: 3,
      slug: 'handeloh',
    },
    {
      code: '033535406018',
      label: 'Heidenau',
      provincie: 3,
      slug: 'heidenau',
    },
    {
      code: '033535406021',
      label: 'Kakenstorf',
      provincie: 3,
      slug: 'kakenstorf',
    },
    {
      code: '033535406022',
      label: 'Königsmoor',
      provincie: 3,
      slug: 'koenigsmoor',
    },
    {
      code: '033535406027',
      label: 'Otter',
      provincie: 3,
      slug: 'otter',
    },
    {
      code: '033535406035',
      label: 'Tostedt',
      provincie: 3,
      slug: 'tostedt',
    },
    {
      code: '033535406038',
      label: 'Welle',
      provincie: 3,
      slug: 'welle',
    },
    {
      code: '033535406041',
      label: 'Wistedt',
      provincie: 3,
      slug: 'wistedt',
    },
    {
      code: '033545403005',
      label: 'Gartow',
      provincie: 3,
      slug: 'gartow',
    },
    {
      code: '033545403007',
      label: 'Gorleben',
      provincie: 3,
      slug: 'gorleben',
    },
    {
      code: '033545403010',
      label: 'Höhbeck',
      provincie: 3,
      slug: 'hoehbeck',
    },
    {
      code: '033545403020',
      label: 'Prezelle',
      provincie: 3,
      slug: 'prezelle',
    },
    {
      code: '033545403021',
      label: 'Schnackenburg',
      provincie: 3,
      slug: 'schnackenburg',
    },
    {
      code: '033545406003',
      label: 'Damnatz',
      provincie: 3,
      slug: 'damnatz',
    },
    {
      code: '033545406004',
      label: 'Dannenberg (Elbe)',
      provincie: 3,
      slug: 'dannenberg-elbe',
    },
    {
      code: '033545406006',
      label: 'Göhrde',
      provincie: 3,
      slug: 'goehrde',
    },
    {
      code: '033545406008',
      label: 'Gusborn',
      provincie: 3,
      slug: 'gusborn',
    },
    {
      code: '033545406009',
      label: 'Hitzacker (Elbe)',
      provincie: 3,
      slug: 'hitzacker-elbe',
    },
    {
      code: '033545406011',
      label: 'Jameln',
      provincie: 3,
      slug: 'jameln',
    },
    {
      code: '033545406012',
      label: 'Karwitz',
      provincie: 3,
      slug: 'karwitz',
    },
    {
      code: '033545406014',
      label: 'Langendorf',
      provincie: 3,
      slug: 'langendorf',
    },
    {
      code: '033545406019',
      label: 'Neu Darchau',
      provincie: 3,
      slug: 'neu-darchau',
    },
    {
      code: '033545406027',
      label: 'Zernien',
      provincie: 3,
      slug: 'zernien',
    },
    {
      code: '033545407001',
      label: 'Bergen an der Dumme',
      provincie: 3,
      slug: 'bergen-an-der-dumme',
    },
    {
      code: '033545407002',
      label: 'Clenze',
      provincie: 3,
      slug: 'clenze',
    },
    {
      code: '033545407013',
      label: 'Küsten',
      provincie: 3,
      slug: 'kuesten',
    },
    {
      code: '033545407015',
      label: 'Lemgow',
      provincie: 3,
      slug: 'lemgow',
    },
    {
      code: '033545407016',
      label: 'Luckau (Wendland)',
      provincie: 3,
      slug: 'luckau-wendland',
    },
    {
      code: '033545407017',
      label: 'Lübbow',
      provincie: 3,
      slug: 'luebbow',
    },
    {
      code: '033545407018',
      label: 'Lüchow (Wendland)',
      provincie: 3,
      slug: 'luechow-wendland',
    },
    {
      code: '033545407022',
      label: 'Schnega',
      provincie: 3,
      slug: 'schnega',
    },
    {
      code: '033545407023',
      label: 'Trebel',
      provincie: 3,
      slug: 'trebel',
    },
    {
      code: '033545407024',
      label: 'Waddeweitz',
      provincie: 3,
      slug: 'waddeweitz',
    },
    {
      code: '033545407025',
      label: 'Woltersdorf',
      provincie: 3,
      slug: 'woltersdorf-gemeinde',
    },
    {
      code: '033545407026',
      label: 'Wustrow (Wendland)',
      provincie: 3,
      slug: 'wustrow-wendland',
    },
    {
      code: '033550001001',
      label: 'Adendorf',
      provincie: 3,
      slug: 'adendorf',
    },
    {
      code: '033550009009',
      label: 'Bleckede',
      provincie: 3,
      slug: 'bleckede',
    },
    {
      code: '033550022022',
      label: 'Lüneburg',
      provincie: 3,
      slug: 'lueneburg',
    },
    {
      code: '033550049049',
      label: 'Amt Neuhaus',
      provincie: 3,
      slug: 'amt-neuhaus',
    },
    {
      code: '033555401002',
      label: 'Amelinghausen',
      provincie: 3,
      slug: 'amelinghausen',
    },
    {
      code: '033555401008',
      label: 'Betzendorf',
      provincie: 3,
      slug: 'betzendorf',
    },
    {
      code: '033555401027',
      label: 'Oldendorf (Luhe)',
      provincie: 3,
      slug: 'oldendorf-luhe',
    },
    {
      code: '033555401029',
      label: 'Rehlingen',
      provincie: 3,
      slug: 'rehlingen',
    },
    {
      code: '033555401034',
      label: 'Soderstorf',
      provincie: 3,
      slug: 'soderstorf',
    },
    {
      code: '033555402004',
      label: 'Bardowick',
      provincie: 3,
      slug: 'bardowick',
    },
    {
      code: '033555402007',
      label: 'Barum',
      provincie: 3,
      slug: 'barum',
    },
    {
      code: '033555402017',
      label: 'Handorf',
      provincie: 3,
      slug: 'handorf',
    },
    {
      code: '033555402023',
      label: 'Mechtersen',
      provincie: 3,
      slug: 'mechtersen',
    },
    {
      code: '033555402028',
      label: 'Radbruch',
      provincie: 3,
      slug: 'radbruch',
    },
    {
      code: '033555402039',
      label: 'Vögelsen',
      provincie: 3,
      slug: 'voegelsen',
    },
    {
      code: '033555402042',
      label: 'Wittorf',
      provincie: 3,
      slug: 'wittorf',
    },
    {
      code: '033555403010',
      label: 'Boitze',
      provincie: 3,
      slug: 'boitze',
    },
    {
      code: '033555403012',
      label: 'Dahlem',
      provincie: 3,
      slug: 'dahlem',
    },
    {
      code: '033555403013',
      label: 'Dahlenburg',
      provincie: 3,
      slug: 'dahlenburg',
    },
    {
      code: '033555403025',
      label: 'Nahrendorf',
      provincie: 3,
      slug: 'nahrendorf',
    },
    {
      code: '033555403037',
      label: 'Tosterglope',
      provincie: 3,
      slug: 'tosterglope',
    },
    {
      code: '033555404020',
      label: 'Kirchgellersen',
      provincie: 3,
      slug: 'kirchgellersen',
    },
    {
      code: '033555404031',
      label: 'Reppenstedt',
      provincie: 3,
      slug: 'reppenstedt',
    },
    {
      code: '033555404035',
      label: 'Südergellersen',
      provincie: 3,
      slug: 'suedergellersen',
    },
    {
      code: '033555404041',
      label: 'Westergellersen',
      provincie: 3,
      slug: 'westergellersen',
    },
    {
      code: '033555405006',
      label: 'Barnstedt',
      provincie: 3,
      slug: 'barnstedt',
    },
    {
      code: '033555405014',
      label: 'Deutsch Evern',
      provincie: 3,
      slug: 'deutsch-evern',
    },
    {
      code: '033555405016',
      label: 'Embsen',
      provincie: 3,
      slug: 'embsen',
    },
    {
      code: '033555405024',
      label: 'Melbeck',
      provincie: 3,
      slug: 'melbeck',
    },
    {
      code: '033555406005',
      label: 'Barendorf',
      provincie: 3,
      slug: 'barendorf',
    },
    {
      code: '033555406026',
      label: 'Neetze',
      provincie: 3,
      slug: 'neetze',
    },
    {
      code: '033555406030',
      label: 'Reinstorf',
      provincie: 3,
      slug: 'reinstorf',
    },
    {
      code: '033555406036',
      label: 'Thomasburg',
      provincie: 3,
      slug: 'thomasburg',
    },
    {
      code: '033555406038',
      label: 'Vastorf',
      provincie: 3,
      slug: 'vastorf',
    },
    {
      code: '033555406040',
      label: 'Wendisch Evern',
      provincie: 3,
      slug: 'wendisch-evern',
    },
    {
      code: '033555407003',
      label: 'Artlenburg',
      provincie: 3,
      slug: 'artlenburg',
    },
    {
      code: '033555407011',
      label: 'Brietlingen',
      provincie: 3,
      slug: 'brietlingen',
    },
    {
      code: '033555407015',
      label: 'Echem',
      provincie: 3,
      slug: 'echem',
    },
    {
      code: '033555407018',
      label: 'Hittbergen',
      provincie: 3,
      slug: 'hittbergen',
    },
    {
      code: '033555407019',
      label: 'Hohnstorf (Elbe)',
      provincie: 3,
      slug: 'hohnstorf-elbe',
    },
    {
      code: '033555407021',
      label: 'Lüdersburg',
      provincie: 3,
      slug: 'luedersburg',
    },
    {
      code: '033555407032',
      label: 'Rullstorf',
      provincie: 3,
      slug: 'rullstorf',
    },
    {
      code: '033555407033',
      label: 'Scharnebeck',
      provincie: 3,
      slug: 'scharnebeck',
    },
    {
      code: '033560002002',
      label: 'Grasberg',
      provincie: 3,
      slug: 'grasberg',
    },
    {
      code: '033560005005',
      label: 'Lilienthal',
      provincie: 3,
      slug: 'lilienthal',
    },
    {
      code: '033560007007',
      label: 'Osterholz-Scharmbeck',
      provincie: 3,
      slug: 'osterholz-scharmbeck',
    },
    {
      code: '033560008008',
      label: 'Ritterhude',
      provincie: 3,
      slug: 'ritterhude',
    },
    {
      code: '033560009009',
      label: 'Schwanewede',
      provincie: 3,
      slug: 'schwanewede',
    },
    {
      code: '033560011011',
      label: 'Worpswede',
      provincie: 3,
      slug: 'worpswede',
    },
    {
      code: '033565401001',
      label: 'Axstedt',
      provincie: 3,
      slug: 'axstedt',
    },
    {
      code: '033565401003',
      label: 'Hambergen',
      provincie: 3,
      slug: 'hambergen',
    },
    {
      code: '033565401004',
      label: 'Holste',
      provincie: 3,
      slug: 'holste',
    },
    {
      code: '033565401006',
      label: 'Lübberstedt',
      provincie: 3,
      slug: 'luebberstedt',
    },
    {
      code: '033565401010',
      label: 'Vollersode',
      provincie: 3,
      slug: 'vollersode',
    },
    {
      code: '033570008008',
      label: 'Bremervörde',
      provincie: 3,
      slug: 'bremervoerde',
    },
    {
      code: '033570016016',
      label: 'Gnarrenburg',
      provincie: 3,
      slug: 'gnarrenburg',
    },
    {
      code: '033570039039',
      label: 'Rotenburg (Wümme)',
      provincie: 3,
      slug: 'rotenburg-wuemme',
    },
    {
      code: '033570041041',
      label: 'Scheeßel',
      provincie: 3,
      slug: 'scheessel',
    },
    {
      code: '033570051051',
      label: 'Visselhövede',
      provincie: 3,
      slug: 'visselhoevede',
    },
    {
      code: '033575401006',
      label: 'Bothel',
      provincie: 3,
      slug: 'bothel',
    },
    {
      code: '033575401009',
      label: 'Brockel',
      provincie: 3,
      slug: 'brockel',
    },
    {
      code: '033575401024',
      label: 'Hemsbünde',
      provincie: 3,
      slug: 'hemsbuende',
    },
    {
      code: '033575401025',
      label: 'Hemslingen',
      provincie: 3,
      slug: 'hemslingen',
    },
    {
      code: '033575401031',
      label: 'Kirchwalsede',
      provincie: 3,
      slug: 'kirchwalsede',
    },
    {
      code: '033575401054',
      label: 'Westerwalsede',
      provincie: 3,
      slug: 'westerwalsede',
    },
    {
      code: '033575402015',
      label: 'Fintel',
      provincie: 3,
      slug: 'fintel',
    },
    {
      code: '033575402023',
      label: 'Helvesiek',
      provincie: 3,
      slug: 'helvesiek',
    },
    {
      code: '033575402033',
      label: 'Lauenbrück',
      provincie: 3,
      slug: 'lauenbrueck',
    },
    {
      code: '033575402046',
      label: 'Stemmen',
      provincie: 3,
      slug: 'stemmen',
    },
    {
      code: '033575402049',
      label: 'Vahlde',
      provincie: 3,
      slug: 'vahlde',
    },
    {
      code: '033575403002',
      label: 'Alfstedt',
      provincie: 3,
      slug: 'alfstedt',
    },
    {
      code: '033575403004',
      label: 'Basdahl',
      provincie: 3,
      slug: 'basdahl',
    },
    {
      code: '033575403012',
      label: 'Ebersdorf',
      provincie: 3,
      slug: 'ebersdorf',
    },
    {
      code: '033575403027',
      label: 'Hipstedt',
      provincie: 3,
      slug: 'hipstedt',
    },
    {
      code: '033575403035',
      label: 'Oerel',
      provincie: 3,
      slug: 'oerel',
    },
    {
      code: '033575404003',
      label: 'Anderlingen',
      provincie: 3,
      slug: 'anderlingen',
    },
    {
      code: '033575404011',
      label: 'Deinstedt',
      provincie: 3,
      slug: 'deinstedt',
    },
    {
      code: '033575404014',
      label: 'Farven',
      provincie: 3,
      slug: 'farven',
    },
    {
      code: '033575404036',
      label: 'Ostereistedt',
      provincie: 3,
      slug: 'ostereistedt',
    },
    {
      code: '033575404038',
      label: 'Rhade',
      provincie: 3,
      slug: 'rhade',
    },
    {
      code: '033575404040',
      label: 'Sandbostel',
      provincie: 3,
      slug: 'sandbostel',
    },
    {
      code: '033575404042',
      label: 'Seedorf',
      provincie: 3,
      slug: 'seedorf-gemeinde',
    },
    {
      code: '033575404043',
      label: 'Selsingen',
      provincie: 3,
      slug: 'selsingen',
    },
    {
      code: '033575405017',
      label: 'Groß Meckelsen',
      provincie: 3,
      slug: 'gross-meckelsen',
    },
    {
      code: '033575405019',
      label: 'Hamersen',
      provincie: 3,
      slug: 'hamersen',
    },
    {
      code: '033575405029',
      label: 'Kalbe',
      provincie: 3,
      slug: 'kalbe',
    },
    {
      code: '033575405032',
      label: 'Klein Meckelsen',
      provincie: 3,
      slug: 'klein-meckelsen',
    },
    {
      code: '033575405034',
      label: 'Lengenbostel',
      provincie: 3,
      slug: 'lengenbostel',
    },
    {
      code: '033575405044',
      label: 'Sittensen',
      provincie: 3,
      slug: 'sittensen',
    },
    {
      code: '033575405048',
      label: 'Tiste',
      provincie: 3,
      slug: 'tiste',
    },
    {
      code: '033575405050',
      label: 'Vierden',
      provincie: 3,
      slug: 'vierden',
    },
    {
      code: '033575405056',
      label: 'Wohnste',
      provincie: 3,
      slug: 'wohnste',
    },
    {
      code: '033575406001',
      label: 'Ahausen',
      provincie: 3,
      slug: 'ahausen',
    },
    {
      code: '033575406005',
      label: 'Bötersen',
      provincie: 3,
      slug: 'boetersen',
    },
    {
      code: '033575406020',
      label: 'Hassendorf',
      provincie: 3,
      slug: 'hassendorf',
    },
    {
      code: '033575406022',
      label: 'Hellwege',
      provincie: 3,
      slug: 'hellwege',
    },
    {
      code: '033575406028',
      label: 'Horstedt',
      provincie: 3,
      slug: 'horstedt-gemeinde',
    },
    {
      code: '033575406037',
      label: 'Reeßum',
      provincie: 3,
      slug: 'reessum',
    },
    {
      code: '033575406045',
      label: 'Sottrum',
      provincie: 3,
      slug: 'sottrum',
    },
    {
      code: '033575407007',
      label: 'Breddorf',
      provincie: 3,
      slug: 'breddorf',
    },
    {
      code: '033575407010',
      label: 'Bülstedt',
      provincie: 3,
      slug: 'buelstedt',
    },
    {
      code: '033575407026',
      label: 'Hepstedt',
      provincie: 3,
      slug: 'hepstedt',
    },
    {
      code: '033575407030',
      label: 'Kirchtimke',
      provincie: 3,
      slug: 'kirchtimke',
    },
    {
      code: '033575407047',
      label: 'Tarmstedt',
      provincie: 3,
      slug: 'tarmstedt',
    },
    {
      code: '033575407052',
      label: 'Vorwerk',
      provincie: 3,
      slug: 'vorwerk',
    },
    {
      code: '033575407053',
      label: 'Westertimke',
      provincie: 3,
      slug: 'westertimke',
    },
    {
      code: '033575407055',
      label: 'Wilstedt',
      provincie: 3,
      slug: 'wilstedt',
    },
    {
      code: '033575408013',
      label: 'Elsdorf',
      provincie: 3,
      slug: 'elsdorf',
    },
    {
      code: '033575408018',
      label: 'Gyhum',
      provincie: 3,
      slug: 'gyhum',
    },
    {
      code: '033575408021',
      label: 'Heeslingen',
      provincie: 3,
      slug: 'heeslingen',
    },
    {
      code: '033575408057',
      label: 'Zeven',
      provincie: 3,
      slug: 'zeven',
    },
    {
      code: '033580002002',
      label: 'Bispingen',
      provincie: 3,
      slug: 'bispingen',
    },
    {
      code: '033580008008',
      label: 'Bad Fallingbostel',
      provincie: 3,
      slug: 'bad-fallingbostel',
    },
    {
      code: '033580016016',
      label: 'Munster',
      provincie: 3,
      slug: 'munster',
    },
    {
      code: '033580017017',
      label: 'Neuenkirchen',
      provincie: 3,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '033580019019',
      label: 'Schneverdingen',
      provincie: 3,
      slug: 'schneverdingen',
    },
    {
      code: '033580021021',
      label: 'Soltau',
      provincie: 3,
      slug: 'soltau',
    },
    {
      code: '033580023023',
      label: 'Wietzendorf',
      provincie: 3,
      slug: 'wietzendorf',
    },
    {
      code: '033580024024',
      label: 'Walsrode',
      provincie: 3,
      slug: 'walsrode',
    },
    {
      code: '033585401001',
      label: 'Ahlden (Aller)',
      provincie: 3,
      slug: 'ahlden-aller',
    },
    {
      code: '033585401006',
      label: 'Eickeloh',
      provincie: 3,
      slug: 'eickeloh',
    },
    {
      code: '033585401011',
      label: 'Grethem',
      provincie: 3,
      slug: 'grethem',
    },
    {
      code: '033585401012',
      label: 'Hademstorf',
      provincie: 3,
      slug: 'hademstorf',
    },
    {
      code: '033585401014',
      label: 'Hodenhagen',
      provincie: 3,
      slug: 'hodenhagen',
    },
    {
      code: '033585402003',
      label: 'Böhme',
      provincie: 3,
      slug: 'boehme',
    },
    {
      code: '033585402009',
      label: 'Frankenfeld',
      provincie: 3,
      slug: 'frankenfeld',
    },
    {
      code: '033585402013',
      label: 'Häuslingen',
      provincie: 3,
      slug: 'haeuslingen',
    },
    {
      code: '033585402018',
      label: 'Rethem (Aller)',
      provincie: 3,
      slug: 'rethem-aller',
    },
    {
      code: '033585403005',
      label: 'Buchholz (Aller)',
      provincie: 3,
      slug: 'buchholz-aller',
    },
    {
      code: '033585403007',
      label: 'Essel',
      provincie: 3,
      slug: 'essel',
    },
    {
      code: '033585403010',
      label: 'Gilten',
      provincie: 3,
      slug: 'gilten',
    },
    {
      code: '033585403015',
      label: 'Lindwedel',
      provincie: 3,
      slug: 'lindwedel',
    },
    {
      code: '033585403020',
      label: 'Schwarmstedt',
      provincie: 3,
      slug: 'schwarmstedt',
    },
    {
      code: '033590010010',
      label: 'Buxtehude',
      provincie: 3,
      slug: 'buxtehude',
    },
    {
      code: '033590013013',
      label: 'Drochtersen',
      provincie: 3,
      slug: 'drochtersen',
    },
    {
      code: '033590028028',
      label: 'Jork',
      provincie: 3,
      slug: 'jork',
    },
    {
      code: '033590038038',
      label: 'Stade',
      provincie: 3,
      slug: 'stade',
    },
    {
      code: '033595401003',
      label: 'Apensen',
      provincie: 3,
      slug: 'apensen',
    },
    {
      code: '033595401006',
      label: 'Beckdorf',
      provincie: 3,
      slug: 'beckdorf',
    },
    {
      code: '033595401037',
      label: 'Sauensiek',
      provincie: 3,
      slug: 'sauensiek',
    },
    {
      code: '033595402011',
      label: 'Deinste',
      provincie: 3,
      slug: 'deinste',
    },
    {
      code: '033595402017',
      label: 'Fredenbeck',
      provincie: 3,
      slug: 'fredenbeck',
    },
    {
      code: '033595402031',
      label: 'Kutenholz',
      provincie: 3,
      slug: 'kutenholz',
    },
    {
      code: '033595403002',
      label: 'Ahlerstedt',
      provincie: 3,
      slug: 'ahlerstedt',
    },
    {
      code: '033595403005',
      label: 'Bargstedt',
      provincie: 3,
      slug: 'bargstedt-gemeinde',
    },
    {
      code: '033595403008',
      label: 'Brest',
      provincie: 3,
      slug: 'brest',
    },
    {
      code: '033595403023',
      label: 'Harsefeld',
      provincie: 3,
      slug: 'harsefeld',
    },
    {
      code: '033595405001',
      label: 'Agathenburg',
      provincie: 3,
      slug: 'agathenburg',
    },
    {
      code: '033595405007',
      label: 'Bliedersdorf',
      provincie: 3,
      slug: 'bliedersdorf',
    },
    {
      code: '033595405012',
      label: 'Dollern',
      provincie: 3,
      slug: 'dollern',
    },
    {
      code: '033595405027',
      label: 'Horneburg',
      provincie: 3,
      slug: 'horneburg',
    },
    {
      code: '033595405034',
      label: 'Nottensdorf',
      provincie: 3,
      slug: 'nottensdorf',
    },
    {
      code: '033595406020',
      label: 'Grünendeich',
      provincie: 3,
      slug: 'gruenendeich',
    },
    {
      code: '033595406021',
      label: 'Guderhandviertel',
      provincie: 3,
      slug: 'guderhandviertel',
    },
    {
      code: '033595406026',
      label: 'Hollern-Twielenfleth',
      provincie: 3,
      slug: 'hollern-twielenfleth',
    },
    {
      code: '033595406032',
      label: 'Mittelnkirchen',
      provincie: 3,
      slug: 'mittelnkirchen',
    },
    {
      code: '033595406033',
      label: 'Neuenkirchen',
      provincie: 3,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '033595406039',
      label: 'Steinkirchen',
      provincie: 3,
      slug: 'steinkirchen',
    },
    {
      code: '033595407004',
      label: 'Balje',
      provincie: 3,
      slug: 'balje',
    },
    {
      code: '033595407018',
      label: 'Freiburg (Elbe)',
      provincie: 3,
      slug: 'freiburg-elbe',
    },
    {
      code: '033595407030',
      label: 'Krummendeich',
      provincie: 3,
      slug: 'krummendeich',
    },
    {
      code: '033595407035',
      label: 'Oederquart',
      provincie: 3,
      slug: 'oederquart',
    },
    {
      code: '033595407040',
      label: 'Wischhafen',
      provincie: 3,
      slug: 'wischhafen',
    },
    {
      code: '033595409009',
      label: 'Burweg',
      provincie: 3,
      slug: 'burweg',
    },
    {
      code: '033595409014',
      label: 'Düdenbüttel',
      provincie: 3,
      slug: 'duedenbuettel',
    },
    {
      code: '033595409015',
      label: 'Engelschoff',
      provincie: 3,
      slug: 'engelschoff',
    },
    {
      code: '033595409016',
      label: 'Estorf',
      provincie: 3,
      slug: 'estorf-gemeinde',
    },
    {
      code: '033595409019',
      label: 'Großenwörden',
      provincie: 3,
      slug: 'grossenwoerden',
    },
    {
      code: '033595409022',
      label: 'Hammah',
      provincie: 3,
      slug: 'hammah',
    },
    {
      code: '033595409024',
      label: 'Heinbockel',
      provincie: 3,
      slug: 'heinbockel',
    },
    {
      code: '033595409025',
      label: 'Himmelpforten',
      provincie: 3,
      slug: 'himmelpforten',
    },
    {
      code: '033595409029',
      label: 'Kranenburg',
      provincie: 3,
      slug: 'kranenburg',
    },
    {
      code: '033595409036',
      label: 'Oldendorf',
      provincie: 3,
      slug: 'oldendorf-gemeinde',
    },
    {
      code: '033600004004',
      label: 'Bienenbüttel',
      provincie: 3,
      slug: 'bienenbuettel',
    },
    {
      code: '033600025025',
      label: 'Uelzen',
      provincie: 3,
      slug: 'uelzen',
    },
    {
      code: '033605404015',
      label: 'Oetzen',
      provincie: 3,
      slug: 'oetzen',
    },
    {
      code: '033605404016',
      label: 'Rätzlingen',
      provincie: 3,
      slug: 'raetzlingen',
    },
    {
      code: '033605404018',
      label: 'Rosche',
      provincie: 3,
      slug: 'rosche',
    },
    {
      code: '033605404022',
      label: 'Stoetze',
      provincie: 3,
      slug: 'stoetze',
    },
    {
      code: '033605404024',
      label: 'Suhlendorf',
      provincie: 3,
      slug: 'suhlendorf',
    },
    {
      code: '033605405007',
      label: 'Eimke',
      provincie: 3,
      slug: 'eimke',
    },
    {
      code: '033605405009',
      label: 'Gerdau',
      provincie: 3,
      slug: 'gerdau',
    },
    {
      code: '033605405023',
      label: 'Suderburg',
      provincie: 3,
      slug: 'suderburg',
    },
    {
      code: '033605407001',
      label: 'Altenmedingen',
      provincie: 3,
      slug: 'altenmedingen',
    },
    {
      code: '033605407002',
      label: 'Bad Bevensen',
      provincie: 3,
      slug: 'bad-bevensen',
    },
    {
      code: '033605407003',
      label: 'Barum',
      provincie: 3,
      slug: 'barum-gemeinde',
    },
    {
      code: '033605407006',
      label: 'Ebstorf',
      provincie: 3,
      slug: 'ebstorf',
    },
    {
      code: '033605407008',
      label: 'Emmendorf',
      provincie: 3,
      slug: 'emmendorf',
    },
    {
      code: '033605407010',
      label: 'Hanstedt',
      provincie: 3,
      slug: 'hanstedt-gemeinde',
    },
    {
      code: '033605407011',
      label: 'Himbergen',
      provincie: 3,
      slug: 'himbergen',
    },
    {
      code: '033605407012',
      label: 'Jelmstorf',
      provincie: 3,
      slug: 'jelmstorf',
    },
    {
      code: '033605407014',
      label: 'Natendorf',
      provincie: 3,
      slug: 'natendorf',
    },
    {
      code: '033605407017',
      label: 'Römstedt',
      provincie: 3,
      slug: 'roemstedt',
    },
    {
      code: '033605407019',
      label: 'Schwienau',
      provincie: 3,
      slug: 'schwienau',
    },
    {
      code: '033605407026',
      label: 'Weste',
      provincie: 3,
      slug: 'weste',
    },
    {
      code: '033605407029',
      label: 'Wriedel',
      provincie: 3,
      slug: 'wriedel',
    },
    {
      code: '033605408005',
      label: 'Bad Bodenteich',
      provincie: 3,
      slug: 'bad-bodenteich',
    },
    {
      code: '033605408013',
      label: 'Lüder',
      provincie: 3,
      slug: 'lueder',
    },
    {
      code: '033605408020',
      label: 'Soltendieck',
      provincie: 3,
      slug: 'soltendieck',
    },
    {
      code: '033605408030',
      label: 'Wrestedt',
      provincie: 3,
      slug: 'wrestedt',
    },
    {
      code: '033610001001',
      label: 'Achim',
      provincie: 3,
      slug: 'achim',
    },
    {
      code: '033610003003',
      label: 'Dörverden',
      provincie: 3,
      slug: 'doerverden',
    },
    {
      code: '033610005005',
      label: 'Kirchlinteln',
      provincie: 3,
      slug: 'kirchlinteln',
    },
    {
      code: '033610006006',
      label: 'Langwedel',
      provincie: 3,
      slug: 'langwedel-gemeinde',
    },
    {
      code: '033610008008',
      label: 'Ottersberg',
      provincie: 3,
      slug: 'ottersberg',
    },
    {
      code: '033610009009',
      label: 'Oyten',
      provincie: 3,
      slug: 'oyten',
    },
    {
      code: '033610012012',
      label: 'Verden (Aller)',
      provincie: 3,
      slug: 'verden-aller',
    },
    {
      code: '033615401002',
      label: 'Blender',
      provincie: 3,
      slug: 'blender',
    },
    {
      code: '033615401004',
      label: 'Emtinghausen',
      provincie: 3,
      slug: 'emtinghausen',
    },
    {
      code: '033615401010',
      label: 'Riede',
      provincie: 3,
      slug: 'riede',
    },
    {
      code: '033615401013',
      label: 'Thedinghausen',
      provincie: 3,
      slug: 'thedinghausen',
    },
    {
      code: '034010000000',
      label: 'Delmenhorst',
      provincie: 3,
      slug: 'delmenhorst',
    },
    {
      code: '034020000000',
      label: 'Emden',
      provincie: 3,
      slug: 'emden',
    },
    {
      code: '034030000000',
      label: 'Oldenburg (Oldb)',
      provincie: 3,
      slug: 'oldenburg-oldb',
    },
    {
      code: '034040000000',
      label: 'Osnabrück',
      provincie: 3,
      slug: 'osnabrueck',
    },
    {
      code: '034050000000',
      label: 'Wilhelmshaven',
      provincie: 3,
      slug: 'wilhelmshaven',
    },
    {
      code: '034510001001',
      label: 'Apen',
      provincie: 3,
      slug: 'apen',
    },
    {
      code: '034510002002',
      label: 'Bad Zwischenahn',
      provincie: 3,
      slug: 'bad-zwischenahn',
    },
    {
      code: '034510004004',
      label: 'Edewecht',
      provincie: 3,
      slug: 'edewecht',
    },
    {
      code: '034510005005',
      label: 'Rastede',
      provincie: 3,
      slug: 'rastede',
    },
    {
      code: '034510007007',
      label: 'Westerstede',
      provincie: 3,
      slug: 'westerstede',
    },
    {
      code: '034510008008',
      label: 'Wiefelstede',
      provincie: 3,
      slug: 'wiefelstede',
    },
    {
      code: '034520001001',
      label: 'Aurich',
      provincie: 3,
      slug: 'aurich',
    },
    {
      code: '034520002002',
      label: 'Baltrum',
      provincie: 3,
      slug: 'baltrum',
    },
    {
      code: '034520006006',
      label: 'Großefehn',
      provincie: 3,
      slug: 'grossefehn',
    },
    {
      code: '034520007007',
      label: 'Großheide',
      provincie: 3,
      slug: 'grossheide',
    },
    {
      code: '034520011011',
      label: 'Hinte',
      provincie: 3,
      slug: 'hinte',
    },
    {
      code: '034520012012',
      label: 'Ihlow',
      provincie: 3,
      slug: 'ihlow',
    },
    {
      code: '034520013013',
      label: 'Juist',
      provincie: 3,
      slug: 'juist',
    },
    {
      code: '034520014014',
      label: 'Krummhörn',
      provincie: 3,
      slug: 'krummhoern',
    },
    {
      code: '034520019019',
      label: 'Norden',
      provincie: 3,
      slug: 'norden',
    },
    {
      code: '034520020020',
      label: 'Norderney',
      provincie: 3,
      slug: 'norderney',
    },
    {
      code: '034520023023',
      label: 'Südbrookmerland',
      provincie: 3,
      slug: 'suedbrookmerland',
    },
    {
      code: '034520025025',
      label: 'Wiesmoor',
      provincie: 3,
      slug: 'wiesmoor',
    },
    {
      code: '034520027027',
      label: 'Dornum',
      provincie: 3,
      slug: 'dornum',
    },
    {
      code: '034525401015',
      label: 'Leezdorf',
      provincie: 3,
      slug: 'leezdorf',
    },
    {
      code: '034525401017',
      label: 'Marienhafe',
      provincie: 3,
      slug: 'marienhafe',
    },
    {
      code: '034525401021',
      label: 'Osteel',
      provincie: 3,
      slug: 'osteel',
    },
    {
      code: '034525401022',
      label: 'Rechtsupweg',
      provincie: 3,
      slug: 'rechtsupweg',
    },
    {
      code: '034525401024',
      label: 'Upgant-Schott',
      provincie: 3,
      slug: 'upgant-schott',
    },
    {
      code: '034525401026',
      label: 'Wirdum',
      provincie: 3,
      slug: 'wirdum',
    },
    {
      code: '034525403003',
      label: 'Berumbur',
      provincie: 3,
      slug: 'berumbur',
    },
    {
      code: '034525403008',
      label: 'Hage',
      provincie: 3,
      slug: 'hage',
    },
    {
      code: '034525403009',
      label: 'Hagermarsch',
      provincie: 3,
      slug: 'hagermarsch',
    },
    {
      code: '034525403010',
      label: 'Halbemond',
      provincie: 3,
      slug: 'halbemond',
    },
    {
      code: '034525403016',
      label: 'Lütetsburg',
      provincie: 3,
      slug: 'luetetsburg',
    },
    {
      code: '034530001001',
      label: 'Barßel',
      provincie: 3,
      slug: 'barssel',
    },
    {
      code: '034530002002',
      label: 'Bösel',
      provincie: 3,
      slug: 'boesel',
    },
    {
      code: '034530003003',
      label: 'Cappeln (Oldenburg)',
      provincie: 3,
      slug: 'cappeln-oldenburg',
    },
    {
      code: '034530004004',
      label: 'Cloppenburg',
      provincie: 3,
      slug: 'cloppenburg',
    },
    {
      code: '034530005005',
      label: 'Emstek',
      provincie: 3,
      slug: 'emstek',
    },
    {
      code: '034530006006',
      label: 'Essen (Oldenburg)',
      provincie: 3,
      slug: 'essen-oldenburg',
    },
    {
      code: '034530007007',
      label: 'Friesoythe',
      provincie: 3,
      slug: 'friesoythe',
    },
    {
      code: '034530008008',
      label: 'Garrel',
      provincie: 3,
      slug: 'garrel',
    },
    {
      code: '034530009009',
      label: 'Lastrup',
      provincie: 3,
      slug: 'lastrup',
    },
    {
      code: '034530010010',
      label: 'Lindern (Oldenburg)',
      provincie: 3,
      slug: 'lindern-oldenburg',
    },
    {
      code: '034530011011',
      label: 'Löningen',
      provincie: 3,
      slug: 'loeningen',
    },
    {
      code: '034530012012',
      label: 'Molbergen',
      provincie: 3,
      slug: 'molbergen',
    },
    {
      code: '034530013013',
      label: 'Saterland',
      provincie: 3,
      slug: 'saterland',
    },
    {
      code: '034540010010',
      label: 'Emsbüren',
      provincie: 3,
      slug: 'emsbueren',
    },
    {
      code: '034540014014',
      label: 'Geeste',
      provincie: 3,
      slug: 'geeste',
    },
    {
      code: '034540018018',
      label: 'Haren (Ems)',
      provincie: 3,
      slug: 'haren-ems',
    },
    {
      code: '034540019019',
      label: 'Haselünne',
      provincie: 3,
      slug: 'haseluenne',
    },
    {
      code: '034540032032',
      label: 'Lingen (Ems)',
      provincie: 3,
      slug: 'lingen-ems',
    },
    {
      code: '034540035035',
      label: 'Meppen',
      provincie: 3,
      slug: 'meppen',
    },
    {
      code: '034540041041',
      label: 'Papenburg',
      provincie: 3,
      slug: 'papenburg',
    },
    {
      code: '034540044044',
      label: 'Rhede (Ems)',
      provincie: 3,
      slug: 'rhede-ems',
    },
    {
      code: '034540045045',
      label: 'Salzbergen',
      provincie: 3,
      slug: 'salzbergen',
    },
    {
      code: '034540054054',
      label: 'Twist',
      provincie: 3,
      slug: 'twist',
    },
    {
      code: '034545401007',
      label: 'Dersum',
      provincie: 3,
      slug: 'dersum',
    },
    {
      code: '034545401008',
      label: 'Dörpen',
      provincie: 3,
      slug: 'doerpen',
    },
    {
      code: '034545401020',
      label: 'Heede',
      provincie: 3,
      slug: 'heede-gemeinde',
    },
    {
      code: '034545401025',
      label: 'Kluse',
      provincie: 3,
      slug: 'kluse',
    },
    {
      code: '034545401030',
      label: 'Lehe',
      provincie: 3,
      slug: 'lehe-gemeinde',
    },
    {
      code: '034545401037',
      label: 'Neubörger',
      provincie: 3,
      slug: 'neuboerger',
    },
    {
      code: '034545401038',
      label: 'Neulehe',
      provincie: 3,
      slug: 'neulehe',
    },
    {
      code: '034545401056',
      label: 'Walchum',
      provincie: 3,
      slug: 'walchum',
    },
    {
      code: '034545401060',
      label: 'Wippingen',
      provincie: 3,
      slug: 'wippingen',
    },
    {
      code: '034545402001',
      label: 'Andervenne',
      provincie: 3,
      slug: 'andervenne',
    },
    {
      code: '034545402003',
      label: 'Beesten',
      provincie: 3,
      slug: 'beesten',
    },
    {
      code: '034545402012',
      label: 'Freren',
      provincie: 3,
      slug: 'freren',
    },
    {
      code: '034545402036',
      label: 'Messingen',
      provincie: 3,
      slug: 'messingen',
    },
    {
      code: '034545402053',
      label: 'Thuine',
      provincie: 3,
      slug: 'thuine',
    },
    {
      code: '034545403009',
      label: 'Dohren',
      provincie: 3,
      slug: 'dohren-gemeinde',
    },
    {
      code: '034545403021',
      label: 'Herzlake',
      provincie: 3,
      slug: 'herzlake',
    },
    {
      code: '034545403026',
      label: 'Lähden',
      provincie: 3,
      slug: 'laehden',
    },
    {
      code: '034545404013',
      label: 'Fresenburg',
      provincie: 3,
      slug: 'fresenburg',
    },
    {
      code: '034545404029',
      label: 'Lathen',
      provincie: 3,
      slug: 'lathen',
    },
    {
      code: '034545404039',
      label: 'Niederlangen',
      provincie: 3,
      slug: 'niederlangen',
    },
    {
      code: '034545404040',
      label: 'Oberlangen',
      provincie: 3,
      slug: 'oberlangen',
    },
    {
      code: '034545404043',
      label: 'Renkenberge',
      provincie: 3,
      slug: 'renkenberge',
    },
    {
      code: '034545404052',
      label: 'Sustrum',
      provincie: 3,
      slug: 'sustrum',
    },
    {
      code: '034545405002',
      label: 'Bawinkel',
      provincie: 3,
      slug: 'bawinkel',
    },
    {
      code: '034545405015',
      label: 'Gersten',
      provincie: 3,
      slug: 'gersten',
    },
    {
      code: '034545405017',
      label: 'Handrup',
      provincie: 3,
      slug: 'handrup',
    },
    {
      code: '034545405028',
      label: 'Langen',
      provincie: 3,
      slug: 'langen',
    },
    {
      code: '034545405031',
      label: 'Lengerich',
      provincie: 3,
      slug: 'lengerich',
    },
    {
      code: '034545405059',
      label: 'Wettrup',
      provincie: 3,
      slug: 'wettrup',
    },
    {
      code: '034545406004',
      label: 'Bockhorst',
      provincie: 3,
      slug: 'bockhorst',
    },
    {
      code: '034545406006',
      label: 'Breddenberg',
      provincie: 3,
      slug: 'breddenberg',
    },
    {
      code: '034545406011',
      label: 'Esterwegen',
      provincie: 3,
      slug: 'esterwegen',
    },
    {
      code: '034545406022',
      label: 'Hilkenbrook',
      provincie: 3,
      slug: 'hilkenbrook',
    },
    {
      code: '034545406051',
      label: 'Surwold',
      provincie: 3,
      slug: 'surwold',
    },
    {
      code: '034545407005',
      label: 'Börger',
      provincie: 3,
      slug: 'boerger',
    },
    {
      code: '034545407016',
      label: 'Groß Berßen',
      provincie: 3,
      slug: 'gross-berssen',
    },
    {
      code: '034545407023',
      label: 'Hüven',
      provincie: 3,
      slug: 'hueven',
    },
    {
      code: '034545407024',
      label: 'Klein Berßen',
      provincie: 3,
      slug: 'klein-berssen',
    },
    {
      code: '034545407047',
      label: 'Sögel',
      provincie: 3,
      slug: 'soegel',
    },
    {
      code: '034545407048',
      label: 'Spahnharrenstätte',
      provincie: 3,
      slug: 'spahnharrenstaette',
    },
    {
      code: '034545407050',
      label: 'Stavern',
      provincie: 3,
      slug: 'stavern',
    },
    {
      code: '034545407058',
      label: 'Werpeloh',
      provincie: 3,
      slug: 'werpeloh',
    },
    {
      code: '034545408034',
      label: 'Lünne',
      provincie: 3,
      slug: 'luenne',
    },
    {
      code: '034545408046',
      label: 'Schapen',
      provincie: 3,
      slug: 'schapen',
    },
    {
      code: '034545408049',
      label: 'Spelle',
      provincie: 3,
      slug: 'spelle',
    },
    {
      code: '034545409027',
      label: 'Lahn',
      provincie: 3,
      slug: 'lahn',
    },
    {
      code: '034545409033',
      label: 'Lorup',
      provincie: 3,
      slug: 'lorup',
    },
    {
      code: '034545409042',
      label: 'Rastdorf',
      provincie: 3,
      slug: 'rastdorf',
    },
    {
      code: '034545409055',
      label: 'Vrees',
      provincie: 3,
      slug: 'vrees',
    },
    {
      code: '034545409057',
      label: 'Werlte',
      provincie: 3,
      slug: 'werlte',
    },
    {
      code: '034550007007',
      label: 'Jever',
      provincie: 3,
      slug: 'jever',
    },
    {
      code: '034550014014',
      label: 'Sande',
      provincie: 3,
      slug: 'sande',
    },
    {
      code: '034550015015',
      label: 'Schortens',
      provincie: 3,
      slug: 'schortens',
    },
    {
      code: '034550020020',
      label: 'Wangerland',
      provincie: 3,
      slug: 'wangerland',
    },
    {
      code: '034550021021',
      label: 'Wangerooge',
      provincie: 3,
      slug: 'wangerooge',
    },
    {
      code: '034550025025',
      label: 'Bockhorn',
      provincie: 3,
      slug: 'bockhorn',
    },
    {
      code: '034550026026',
      label: 'Varel',
      provincie: 3,
      slug: 'varel',
    },
    {
      code: '034550027027',
      label: 'Zetel',
      provincie: 3,
      slug: 'zetel',
    },
    {
      code: '034560001001',
      label: 'Bad Bentheim',
      provincie: 3,
      slug: 'bad-bentheim',
    },
    {
      code: '034560015015',
      label: 'Nordhorn',
      provincie: 3,
      slug: 'nordhorn',
    },
    {
      code: '034560025025',
      label: 'Wietmarschen',
      provincie: 3,
      slug: 'wietmarschen',
    },
    {
      code: '034565401002',
      label: 'Emlichheim',
      provincie: 3,
      slug: 'emlichheim',
    },
    {
      code: '034565401009',
      label: 'Hoogstede',
      provincie: 3,
      slug: 'hoogstede',
    },
    {
      code: '034565401012',
      label: 'Laar',
      provincie: 3,
      slug: 'laar',
    },
    {
      code: '034565401019',
      label: 'Ringe',
      provincie: 3,
      slug: 'ringe',
    },
    {
      code: '034565402004',
      label: 'Esche',
      provincie: 3,
      slug: 'esche',
    },
    {
      code: '034565402005',
      label: 'Georgsdorf',
      provincie: 3,
      slug: 'georgsdorf',
    },
    {
      code: '034565402013',
      label: 'Lage',
      provincie: 3,
      slug: 'lage',
    },
    {
      code: '034565402014',
      label: 'Neuenhaus',
      provincie: 3,
      slug: 'neuenhaus',
    },
    {
      code: '034565402017',
      label: 'Osterwald',
      provincie: 3,
      slug: 'osterwald',
    },
    {
      code: '034565403003',
      label: 'Engden',
      provincie: 3,
      slug: 'engden',
    },
    {
      code: '034565403010',
      label: 'Isterberg',
      provincie: 3,
      slug: 'isterberg',
    },
    {
      code: '034565403016',
      label: 'Ohne',
      provincie: 3,
      slug: 'ohne',
    },
    {
      code: '034565403018',
      label: 'Quendorf',
      provincie: 3,
      slug: 'quendorf',
    },
    {
      code: '034565403020',
      label: 'Samern',
      provincie: 3,
      slug: 'samern',
    },
    {
      code: '034565403027',
      label: 'Schüttorf',
      provincie: 3,
      slug: 'schuettorf',
    },
    {
      code: '034565404006',
      label: 'Getelo',
      provincie: 3,
      slug: 'getelo',
    },
    {
      code: '034565404007',
      label: 'Gölenkamp',
      provincie: 3,
      slug: 'goelenkamp',
    },
    {
      code: '034565404008',
      label: 'Halle',
      provincie: 3,
      slug: 'halle-gemeinde',
    },
    {
      code: '034565404011',
      label: 'Itterbeck',
      provincie: 3,
      slug: 'itterbeck',
    },
    {
      code: '034565404023',
      label: 'Uelsen',
      provincie: 3,
      slug: 'uelsen',
    },
    {
      code: '034565404024',
      label: 'Wielen',
      provincie: 3,
      slug: 'wielen',
    },
    {
      code: '034565404026',
      label: 'Wilsum',
      provincie: 3,
      slug: 'wilsum',
    },
    {
      code: '034570002002',
      label: 'Borkum',
      provincie: 3,
      slug: 'borkum',
    },
    {
      code: '034570012012',
      label: 'Jemgum',
      provincie: 3,
      slug: 'jemgum',
    },
    {
      code: '034570013013',
      label: 'Leer (Ostfriesland)',
      provincie: 3,
      slug: 'leer-ostfriesland',
    },
    {
      code: '034570014014',
      label: 'Moormerland',
      provincie: 3,
      slug: 'moormerland',
    },
    {
      code: '034570017017',
      label: 'Ostrhauderfehn',
      provincie: 3,
      slug: 'ostrhauderfehn',
    },
    {
      code: '034570018018',
      label: 'Rhauderfehn',
      provincie: 3,
      slug: 'rhauderfehn',
    },
    {
      code: '034570020020',
      label: 'Uplengen',
      provincie: 3,
      slug: 'uplengen',
    },
    {
      code: '034570021021',
      label: 'Weener',
      provincie: 3,
      slug: 'weener',
    },
    {
      code: '034570022022',
      label: 'Westoverledingen',
      provincie: 3,
      slug: 'westoverledingen',
    },
    {
      code: '034570024024',
      label: 'Bunde',
      provincie: 3,
      slug: 'bunde',
    },
    {
      code: '034575402003',
      label: 'Brinkum',
      provincie: 3,
      slug: 'brinkum',
    },
    {
      code: '034575402009',
      label: 'Firrel',
      provincie: 3,
      slug: 'firrel',
    },
    {
      code: '034575402010',
      label: 'Hesel',
      provincie: 3,
      slug: 'hesel',
    },
    {
      code: '034575402011',
      label: 'Holtland',
      provincie: 3,
      slug: 'holtland',
    },
    {
      code: '034575402015',
      label: 'Neukamperfehn',
      provincie: 3,
      slug: 'neukamperfehn',
    },
    {
      code: '034575402019',
      label: 'Schwerinsdorf',
      provincie: 3,
      slug: 'schwerinsdorf',
    },
    {
      code: '034575403006',
      label: 'Detern',
      provincie: 3,
      slug: 'detern',
    },
    {
      code: '034575403008',
      label: 'Filsum',
      provincie: 3,
      slug: 'filsum',
    },
    {
      code: '034575403016',
      label: 'Nortmoor',
      provincie: 3,
      slug: 'nortmoor',
    },
    {
      code: '034580003003',
      label: 'Dötlingen',
      provincie: 3,
      slug: 'doetlingen',
    },
    {
      code: '034580005005',
      label: 'Ganderkesee',
      provincie: 3,
      slug: 'ganderkesee',
    },
    {
      code: '034580007007',
      label: 'Großenkneten',
      provincie: 3,
      slug: 'grossenkneten',
    },
    {
      code: '034580009009',
      label: 'Hatten',
      provincie: 3,
      slug: 'hatten',
    },
    {
      code: '034580010010',
      label: 'Hude (Oldb)',
      provincie: 3,
      slug: 'hude-oldb',
    },
    {
      code: '034580013013',
      label: 'Wardenburg',
      provincie: 3,
      slug: 'wardenburg',
    },
    {
      code: '034580014014',
      label: 'Wildeshausen',
      provincie: 3,
      slug: 'wildeshausen',
    },
    {
      code: '034585401001',
      label: 'Beckeln',
      provincie: 3,
      slug: 'beckeln',
    },
    {
      code: '034585401002',
      label: 'Colnrade',
      provincie: 3,
      slug: 'colnrade',
    },
    {
      code: '034585401004',
      label: 'Dünsen',
      provincie: 3,
      slug: 'duensen',
    },
    {
      code: '034585401006',
      label: 'Groß Ippener',
      provincie: 3,
      slug: 'gross-ippener',
    },
    {
      code: '034585401008',
      label: 'Harpstedt',
      provincie: 3,
      slug: 'harpstedt',
    },
    {
      code: '034585401011',
      label: 'Kirchseelte',
      provincie: 3,
      slug: 'kirchseelte',
    },
    {
      code: '034585401012',
      label: 'Prinzhöfte',
      provincie: 3,
      slug: 'prinzhoefte',
    },
    {
      code: '034585401015',
      label: 'Winkelsett',
      provincie: 3,
      slug: 'winkelsett',
    },
    {
      code: '034590003003',
      label: 'Bad Essen',
      provincie: 3,
      slug: 'bad-essen',
    },
    {
      code: '034590004004',
      label: 'Bad Iburg',
      provincie: 3,
      slug: 'bad-iburg',
    },
    {
      code: '034590005005',
      label: 'Bad Laer',
      provincie: 3,
      slug: 'bad-laer',
    },
    {
      code: '034590006006',
      label: 'Bad Rothenfelde',
      provincie: 3,
      slug: 'bad-rothenfelde',
    },
    {
      code: '034590008008',
      label: 'Belm',
      provincie: 3,
      slug: 'belm',
    },
    {
      code: '034590012012',
      label: 'Bissendorf',
      provincie: 3,
      slug: 'bissendorf',
    },
    {
      code: '034590013013',
      label: 'Bohmte',
      provincie: 3,
      slug: 'bohmte',
    },
    {
      code: '034590014014',
      label: 'Bramsche',
      provincie: 3,
      slug: 'bramsche',
    },
    {
      code: '034590015015',
      label: 'Dissen am Teutoburger Wald',
      provincie: 3,
      slug: 'dissen-am-teutoburger-wald',
    },
    {
      code: '034590019019',
      label: 'Georgsmarienhütte',
      provincie: 3,
      slug: 'georgsmarienhuette',
    },
    {
      code: '034590020020',
      label: 'Hagen am Teutoburger Wald',
      provincie: 3,
      slug: 'hagen-am-teutoburger-wald',
    },
    {
      code: '034590021021',
      label: 'Hasbergen',
      provincie: 3,
      slug: 'hasbergen',
    },
    {
      code: '034590022022',
      label: 'Hilter am Teutoburger Wald',
      provincie: 3,
      slug: 'hilter-am-teutoburger-wald',
    },
    {
      code: '034590024024',
      label: 'Melle',
      provincie: 3,
      slug: 'melle',
    },
    {
      code: '034590029029',
      label: 'Ostercappeln',
      provincie: 3,
      slug: 'ostercappeln',
    },
    {
      code: '034590033033',
      label: 'Wallenhorst',
      provincie: 3,
      slug: 'wallenhorst',
    },
    {
      code: '034590034034',
      label: 'Glandorf',
      provincie: 3,
      slug: 'glandorf',
    },
    {
      code: '034595401007',
      label: 'Badbergen',
      provincie: 3,
      slug: 'badbergen',
    },
    {
      code: '034595401025',
      label: 'Menslage',
      provincie: 3,
      slug: 'menslage',
    },
    {
      code: '034595401028',
      label: 'Nortrup',
      provincie: 3,
      slug: 'nortrup',
    },
    {
      code: '034595401030',
      label: 'Quakenbrück',
      provincie: 3,
      slug: 'quakenbrueck',
    },
    {
      code: '034595402001',
      label: 'Alfhausen',
      provincie: 3,
      slug: 'alfhausen',
    },
    {
      code: '034595402002',
      label: 'Ankum',
      provincie: 3,
      slug: 'ankum',
    },
    {
      code: '034595402010',
      label: 'Bersenbrück',
      provincie: 3,
      slug: 'bersenbrueck',
    },
    {
      code: '034595402016',
      label: 'Eggermühlen',
      provincie: 3,
      slug: 'eggermuehlen',
    },
    {
      code: '034595402018',
      label: 'Gehrde',
      provincie: 3,
      slug: 'gehrde',
    },
    {
      code: '034595402023',
      label: 'Kettenkamp',
      provincie: 3,
      slug: 'kettenkamp',
    },
    {
      code: '034595402031',
      label: 'Rieste',
      provincie: 3,
      slug: 'rieste',
    },
    {
      code: '034595403009',
      label: 'Berge',
      provincie: 3,
      slug: 'berge',
    },
    {
      code: '034595403011',
      label: 'Bippen',
      provincie: 3,
      slug: 'bippen',
    },
    {
      code: '034595403017',
      label: 'Fürstenau',
      provincie: 3,
      slug: 'fuerstenau',
    },
    {
      code: '034595404026',
      label: 'Merzen',
      provincie: 3,
      slug: 'merzen',
    },
    {
      code: '034595404027',
      label: 'Neuenkirchen',
      provincie: 3,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '034595404032',
      label: 'Voltlage',
      provincie: 3,
      slug: 'voltlage',
    },
    {
      code: '034600001001',
      label: 'Bakum',
      provincie: 3,
      slug: 'bakum',
    },
    {
      code: '034600002002',
      label: 'Damme',
      provincie: 3,
      slug: 'damme',
    },
    {
      code: '034600003003',
      label: 'Dinklage',
      provincie: 3,
      slug: 'dinklage',
    },
    {
      code: '034600004004',
      label: 'Goldenstedt',
      provincie: 3,
      slug: 'goldenstedt',
    },
    {
      code: '034600005005',
      label: 'Holdorf',
      provincie: 3,
      slug: 'holdorf',
    },
    {
      code: '034600006006',
      label: 'Lohne (Oldenburg)',
      provincie: 3,
      slug: 'lohne-oldenburg',
    },
    {
      code: '034600007007',
      label: 'Neuenkirchen-Vörden',
      provincie: 3,
      slug: 'neuenkirchen-voerden',
    },
    {
      code: '034600008008',
      label: 'Steinfeld (Oldenburg)',
      provincie: 3,
      slug: 'steinfeld-oldenburg',
    },
    {
      code: '034600009009',
      label: 'Vechta',
      provincie: 3,
      slug: 'vechta',
    },
    {
      code: '034600010010',
      label: 'Visbek',
      provincie: 3,
      slug: 'visbek',
    },
    {
      code: '034610001001',
      label: 'Berne',
      provincie: 3,
      slug: 'berne',
    },
    {
      code: '034610002002',
      label: 'Brake (Unterweser)',
      provincie: 3,
      slug: 'brake-unterweser',
    },
    {
      code: '034610003003',
      label: 'Butjadingen',
      provincie: 3,
      slug: 'butjadingen',
    },
    {
      code: '034610004004',
      label: 'Elsfleth',
      provincie: 3,
      slug: 'elsfleth',
    },
    {
      code: '034610005005',
      label: 'Jade',
      provincie: 3,
      slug: 'jade',
    },
    {
      code: '034610006006',
      label: 'Lemwerder',
      provincie: 3,
      slug: 'lemwerder',
    },
    {
      code: '034610007007',
      label: 'Nordenham',
      provincie: 3,
      slug: 'nordenham',
    },
    {
      code: '034610008008',
      label: 'Ovelgönne',
      provincie: 3,
      slug: 'ovelgoenne',
    },
    {
      code: '034610009009',
      label: 'Stadland',
      provincie: 3,
      slug: 'stadland',
    },
    {
      code: '034620005005',
      label: 'Friedeburg',
      provincie: 3,
      slug: 'friedeburg',
    },
    {
      code: '034620007007',
      label: 'Langeoog',
      provincie: 3,
      slug: 'langeoog',
    },
    {
      code: '034620014014',
      label: 'Spiekeroog',
      provincie: 3,
      slug: 'spiekeroog',
    },
    {
      code: '034620019019',
      label: 'Wittmund',
      provincie: 3,
      slug: 'wittmund',
    },
    {
      code: '034625401002',
      label: 'Dunum',
      provincie: 3,
      slug: 'dunum',
    },
    {
      code: '034625401003',
      label: 'Esens',
      provincie: 3,
      slug: 'esens',
    },
    {
      code: '034625401006',
      label: 'Holtgast',
      provincie: 3,
      slug: 'holtgast',
    },
    {
      code: '034625401008',
      label: 'Moorweg',
      provincie: 3,
      slug: 'moorweg',
    },
    {
      code: '034625401010',
      label: 'Neuharlingersiel',
      provincie: 3,
      slug: 'neuharlingersiel',
    },
    {
      code: '034625401015',
      label: 'Stedesdorf',
      provincie: 3,
      slug: 'stedesdorf',
    },
    {
      code: '034625401017',
      label: 'Werdum',
      provincie: 3,
      slug: 'werdum',
    },
    {
      code: '034625402001',
      label: 'Blomberg',
      provincie: 3,
      slug: 'blomberg',
    },
    {
      code: '034625402004',
      label: 'Eversmeer',
      provincie: 3,
      slug: 'eversmeer',
    },
    {
      code: '034625402009',
      label: 'Nenndorf',
      provincie: 3,
      slug: 'nenndorf',
    },
    {
      code: '034625402011',
      label: 'Neuschoo',
      provincie: 3,
      slug: 'neuschoo',
    },
    {
      code: '034625402012',
      label: 'Ochtersum',
      provincie: 3,
      slug: 'ochtersum',
    },
    {
      code: '034625402013',
      label: 'Schweindorf',
      provincie: 3,
      slug: 'schweindorf',
    },
    {
      code: '034625402016',
      label: 'Utarp',
      provincie: 3,
      slug: 'utarp',
    },
    {
      code: '034625402018',
      label: 'Westerholt',
      provincie: 3,
      slug: 'westerholt',
    },
    {
      code: '040110000000',
      label: 'Bremen',
      provincie: 4,
      slug: 'bremen',
    },
    {
      code: '040120000000',
      label: 'Bremerhaven',
      provincie: 4,
      slug: 'bremerhaven',
    },
    {
      code: '051110000000',
      label: 'Düsseldorf',
      provincie: 5,
      slug: 'duesseldorf',
    },
    {
      code: '051120000000',
      label: 'Duisburg',
      provincie: 5,
      slug: 'duisburg',
    },
    {
      code: '051130000000',
      label: 'Essen',
      provincie: 5,
      slug: 'essen',
    },
    {
      code: '051140000000',
      label: 'Krefeld',
      provincie: 5,
      slug: 'krefeld',
    },
    {
      code: '051160000000',
      label: 'Mönchengladbach',
      provincie: 5,
      slug: 'moenchengladbach',
    },
    {
      code: '051170000000',
      label: 'Mülheim an der Ruhr',
      provincie: 5,
      slug: 'muelheim-an-der-ruhr',
    },
    {
      code: '051190000000',
      label: 'Oberhausen',
      provincie: 5,
      slug: 'oberhausen',
    },
    {
      code: '051200000000',
      label: 'Remscheid',
      provincie: 5,
      slug: 'remscheid',
    },
    {
      code: '051220000000',
      label: 'Solingen',
      provincie: 5,
      slug: 'solingen',
    },
    {
      code: '051240000000',
      label: 'Wuppertal',
      provincie: 5,
      slug: 'wuppertal',
    },
    {
      code: '051540004004',
      label: 'Bedburg-Hau',
      provincie: 5,
      slug: 'bedburg-hau',
    },
    {
      code: '051540008008',
      label: 'Emmerich am Rhein',
      provincie: 5,
      slug: 'emmerich-am-rhein',
    },
    {
      code: '051540012012',
      label: 'Geldern',
      provincie: 5,
      slug: 'geldern',
    },
    {
      code: '051540016016',
      label: 'Goch',
      provincie: 5,
      slug: 'goch',
    },
    {
      code: '051540020020',
      label: 'Issum',
      provincie: 5,
      slug: 'issum',
    },
    {
      code: '051540024024',
      label: 'Kalkar',
      provincie: 5,
      slug: 'kalkar',
    },
    {
      code: '051540028028',
      label: 'Kerken',
      provincie: 5,
      slug: 'kerken',
    },
    {
      code: '051540032032',
      label: 'Kevelaer',
      provincie: 5,
      slug: 'kevelaer',
    },
    {
      code: '051540036036',
      label: 'Kleve',
      provincie: 5,
      slug: 'kleve-stadt',
    },
    {
      code: '051540040040',
      label: 'Kranenburg',
      provincie: 5,
      slug: 'kranenburg-gemeinde',
    },
    {
      code: '051540044044',
      label: 'Rees',
      provincie: 5,
      slug: 'rees',
    },
    {
      code: '051540048048',
      label: 'Rheurdt',
      provincie: 5,
      slug: 'rheurdt',
    },
    {
      code: '051540052052',
      label: 'Straelen',
      provincie: 5,
      slug: 'straelen',
    },
    {
      code: '051540056056',
      label: 'Uedem',
      provincie: 5,
      slug: 'uedem',
    },
    {
      code: '051540060060',
      label: 'Wachtendonk',
      provincie: 5,
      slug: 'wachtendonk',
    },
    {
      code: '051540064064',
      label: 'Weeze',
      provincie: 5,
      slug: 'weeze',
    },
    {
      code: '051580004004',
      label: 'Erkrath',
      provincie: 5,
      slug: 'erkrath',
    },
    {
      code: '051580008008',
      label: 'Haan',
      provincie: 5,
      slug: 'haan',
    },
    {
      code: '051580012012',
      label: 'Heiligenhaus',
      provincie: 5,
      slug: 'heiligenhaus',
    },
    {
      code: '051580016016',
      label: 'Hilden',
      provincie: 5,
      slug: 'hilden',
    },
    {
      code: '051580020020',
      label: 'Langenfeld (Rhld.)',
      provincie: 5,
      slug: 'langenfeld-rhld',
    },
    {
      code: '051580024024',
      label: 'Mettmann',
      provincie: 5,
      slug: 'mettmann',
    },
    {
      code: '051580026026',
      label: 'Monheim am Rhein',
      provincie: 5,
      slug: 'monheim-am-rhein',
    },
    {
      code: '051580028028',
      label: 'Ratingen',
      provincie: 5,
      slug: 'ratingen',
    },
    {
      code: '051580032032',
      label: 'Velbert',
      provincie: 5,
      slug: 'velbert',
    },
    {
      code: '051580036036',
      label: 'Wülfrath',
      provincie: 5,
      slug: 'wuelfrath',
    },
    {
      code: '051620004004',
      label: 'Dormagen',
      provincie: 5,
      slug: 'dormagen',
    },
    {
      code: '051620008008',
      label: 'Grevenbroich',
      provincie: 5,
      slug: 'grevenbroich',
    },
    {
      code: '051620012012',
      label: 'Jüchen',
      provincie: 5,
      slug: 'juechen',
    },
    {
      code: '051620016016',
      label: 'Kaarst',
      provincie: 5,
      slug: 'kaarst',
    },
    {
      code: '051620020020',
      label: 'Korschenbroich',
      provincie: 5,
      slug: 'korschenbroich',
    },
    {
      code: '051620022022',
      label: 'Meerbusch',
      provincie: 5,
      slug: 'meerbusch',
    },
    {
      code: '051620024024',
      label: 'Neuss',
      provincie: 5,
      slug: 'neuss',
    },
    {
      code: '051620028028',
      label: 'Rommerskirchen',
      provincie: 5,
      slug: 'rommerskirchen',
    },
    {
      code: '051660004004',
      label: 'Brüggen',
      provincie: 5,
      slug: 'brueggen',
    },
    {
      code: '051660008008',
      label: 'Grefrath',
      provincie: 5,
      slug: 'grefrath',
    },
    {
      code: '051660012012',
      label: 'Kempen',
      provincie: 5,
      slug: 'kempen',
    },
    {
      code: '051660016016',
      label: 'Nettetal',
      provincie: 5,
      slug: 'nettetal',
    },
    {
      code: '051660020020',
      label: 'Niederkrüchten',
      provincie: 5,
      slug: 'niederkruechten',
    },
    {
      code: '051660024024',
      label: 'Schwalmtal',
      provincie: 5,
      slug: 'schwalmtal',
    },
    {
      code: '051660028028',
      label: 'Tönisvorst',
      provincie: 5,
      slug: 'toenisvorst',
    },
    {
      code: '051660032032',
      label: 'Viersen',
      provincie: 5,
      slug: 'viersen',
    },
    {
      code: '051660036036',
      label: 'Willich',
      provincie: 5,
      slug: 'willich',
    },
    {
      code: '051700004004',
      label: 'Alpen',
      provincie: 5,
      slug: 'alpen',
    },
    {
      code: '051700008008',
      label: 'Dinslaken',
      provincie: 5,
      slug: 'dinslaken',
    },
    {
      code: '051700012012',
      label: 'Hamminkeln',
      provincie: 5,
      slug: 'hamminkeln',
    },
    {
      code: '051700016016',
      label: 'Hünxe',
      provincie: 5,
      slug: 'huenxe',
    },
    {
      code: '051700020020',
      label: 'Kamp-Lintfort',
      provincie: 5,
      slug: 'kamp-lintfort',
    },
    {
      code: '051700024024',
      label: 'Moers',
      provincie: 5,
      slug: 'moers',
    },
    {
      code: '051700028028',
      label: 'Neukirchen-Vluyn',
      provincie: 5,
      slug: 'neukirchen-vluyn',
    },
    {
      code: '051700032032',
      label: 'Rheinberg',
      provincie: 5,
      slug: 'rheinberg',
    },
    {
      code: '051700036036',
      label: 'Schermbeck',
      provincie: 5,
      slug: 'schermbeck',
    },
    {
      code: '051700040040',
      label: 'Sonsbeck',
      provincie: 5,
      slug: 'sonsbeck',
    },
    {
      code: '051700044044',
      label: 'Voerde (Niederrhein)',
      provincie: 5,
      slug: 'voerde-niederrhein',
    },
    {
      code: '051700048048',
      label: 'Wesel',
      provincie: 5,
      slug: 'wesel',
    },
    {
      code: '051700052052',
      label: 'Xanten',
      provincie: 5,
      slug: 'xanten',
    },
    {
      code: '053140000000',
      label: 'Bonn',
      provincie: 5,
      slug: 'bonn',
    },
    {
      code: '053150000000',
      label: 'Köln',
      provincie: 5,
      slug: 'koeln',
    },
    {
      code: '053160000000',
      label: 'Leverkusen',
      provincie: 5,
      slug: 'leverkusen',
    },
    {
      code: '053340002002',
      label: 'Aachen',
      provincie: 5,
      slug: 'aachen',
    },
    {
      code: '053340004004',
      label: 'Alsdorf',
      provincie: 5,
      slug: 'alsdorf',
    },
    {
      code: '053340008008',
      label: 'Baesweiler',
      provincie: 5,
      slug: 'baesweiler',
    },
    {
      code: '053340012012',
      label: 'Eschweiler',
      provincie: 5,
      slug: 'eschweiler',
    },
    {
      code: '053340016016',
      label: 'Herzogenrath',
      provincie: 5,
      slug: 'herzogenrath',
    },
    {
      code: '053340020020',
      label: 'Monschau',
      provincie: 5,
      slug: 'monschau',
    },
    {
      code: '053340024024',
      label: 'Roetgen',
      provincie: 5,
      slug: 'roetgen',
    },
    {
      code: '053340028028',
      label: 'Simmerath',
      provincie: 5,
      slug: 'simmerath',
    },
    {
      code: '053340032032',
      label: 'Stolberg (Rhld.)',
      provincie: 5,
      slug: 'stolberg-rhld',
    },
    {
      code: '053340036036',
      label: 'Würselen',
      provincie: 5,
      slug: 'wuerselen',
    },
    {
      code: '053580004004',
      label: 'Aldenhoven',
      provincie: 5,
      slug: 'aldenhoven',
    },
    {
      code: '053580008008',
      label: 'Düren',
      provincie: 5,
      slug: 'dueren',
    },
    {
      code: '053580012012',
      label: 'Heimbach',
      provincie: 5,
      slug: 'heimbach',
    },
    {
      code: '053580016016',
      label: 'Hürtgenwald',
      provincie: 5,
      slug: 'huertgenwald',
    },
    {
      code: '053580020020',
      label: 'Inden',
      provincie: 5,
      slug: 'inden',
    },
    {
      code: '053580024024',
      label: 'Jülich',
      provincie: 5,
      slug: 'juelich',
    },
    {
      code: '053580028028',
      label: 'Kreuzau',
      provincie: 5,
      slug: 'kreuzau',
    },
    {
      code: '053580032032',
      label: 'Langerwehe',
      provincie: 5,
      slug: 'langerwehe',
    },
    {
      code: '053580036036',
      label: 'Linnich',
      provincie: 5,
      slug: 'linnich',
    },
    {
      code: '053580040040',
      label: 'Merzenich',
      provincie: 5,
      slug: 'merzenich',
    },
    {
      code: '053580044044',
      label: 'Nideggen',
      provincie: 5,
      slug: 'nideggen',
    },
    {
      code: '053580048048',
      label: 'Niederzier',
      provincie: 5,
      slug: 'niederzier',
    },
    {
      code: '053580052052',
      label: 'Nörvenich',
      provincie: 5,
      slug: 'noervenich',
    },
    {
      code: '053580056056',
      label: 'Titz',
      provincie: 5,
      slug: 'titz',
    },
    {
      code: '053580060060',
      label: 'Vettweiß',
      provincie: 5,
      slug: 'vettweiss',
    },
    {
      code: '053620004004',
      label: 'Bedburg',
      provincie: 5,
      slug: 'bedburg',
    },
    {
      code: '053620008008',
      label: 'Bergheim',
      provincie: 5,
      slug: 'bergheim',
    },
    {
      code: '053620012012',
      label: 'Brühl',
      provincie: 5,
      slug: 'bruehl',
    },
    {
      code: '053620016016',
      label: 'Elsdorf',
      provincie: 5,
      slug: 'elsdorf-stadt',
    },
    {
      code: '053620020020',
      label: 'Erftstadt',
      provincie: 5,
      slug: 'erftstadt',
    },
    {
      code: '053620024024',
      label: 'Frechen',
      provincie: 5,
      slug: 'frechen',
    },
    {
      code: '053620028028',
      label: 'Hürth',
      provincie: 5,
      slug: 'huerth',
    },
    {
      code: '053620032032',
      label: 'Kerpen',
      provincie: 5,
      slug: 'kerpen',
    },
    {
      code: '053620036036',
      label: 'Pulheim',
      provincie: 5,
      slug: 'pulheim',
    },
    {
      code: '053620040040',
      label: 'Wesseling',
      provincie: 5,
      slug: 'wesseling',
    },
    {
      code: '053660004004',
      label: 'Bad Münstereifel',
      provincie: 5,
      slug: 'bad-muenstereifel',
    },
    {
      code: '053660008008',
      label: 'Blankenheim',
      provincie: 5,
      slug: 'blankenheim',
    },
    {
      code: '053660012012',
      label: 'Dahlem',
      provincie: 5,
      slug: 'dahlem-gemeinde',
    },
    {
      code: '053660016016',
      label: 'Euskirchen',
      provincie: 5,
      slug: 'euskirchen',
    },
    {
      code: '053660020020',
      label: 'Hellenthal',
      provincie: 5,
      slug: 'hellenthal',
    },
    {
      code: '053660024024',
      label: 'Kall',
      provincie: 5,
      slug: 'kall',
    },
    {
      code: '053660028028',
      label: 'Mechernich',
      provincie: 5,
      slug: 'mechernich',
    },
    {
      code: '053660032032',
      label: 'Nettersheim',
      provincie: 5,
      slug: 'nettersheim',
    },
    {
      code: '053660036036',
      label: 'Schleiden',
      provincie: 5,
      slug: 'schleiden',
    },
    {
      code: '053660040040',
      label: 'Weilerswist',
      provincie: 5,
      slug: 'weilerswist',
    },
    {
      code: '053660044044',
      label: 'Zülpich',
      provincie: 5,
      slug: 'zuelpich',
    },
    {
      code: '053700004004',
      label: 'Erkelenz',
      provincie: 5,
      slug: 'erkelenz',
    },
    {
      code: '053700008008',
      label: 'Gangelt',
      provincie: 5,
      slug: 'gangelt',
    },
    {
      code: '053700012012',
      label: 'Geilenkirchen',
      provincie: 5,
      slug: 'geilenkirchen',
    },
    {
      code: '053700016016',
      label: 'Heinsberg',
      provincie: 5,
      slug: 'heinsberg',
    },
    {
      code: '053700020020',
      label: 'Hückelhoven',
      provincie: 5,
      slug: 'hueckelhoven',
    },
    {
      code: '053700024024',
      label: 'Selfkant',
      provincie: 5,
      slug: 'selfkant',
    },
    {
      code: '053700028028',
      label: 'Übach-Palenberg',
      provincie: 5,
      slug: 'uebach-palenberg',
    },
    {
      code: '053700032032',
      label: 'Waldfeucht',
      provincie: 5,
      slug: 'waldfeucht',
    },
    {
      code: '053700036036',
      label: 'Wassenberg',
      provincie: 5,
      slug: 'wassenberg',
    },
    {
      code: '053700040040',
      label: 'Wegberg',
      provincie: 5,
      slug: 'wegberg',
    },
    {
      code: '053740004004',
      label: 'Bergneustadt',
      provincie: 5,
      slug: 'bergneustadt',
    },
    {
      code: '053740008008',
      label: 'Engelskirchen',
      provincie: 5,
      slug: 'engelskirchen',
    },
    {
      code: '053740012012',
      label: 'Gummersbach',
      provincie: 5,
      slug: 'gummersbach',
    },
    {
      code: '053740016016',
      label: 'Hückeswagen',
      provincie: 5,
      slug: 'hueckeswagen',
    },
    {
      code: '053740020020',
      label: 'Lindlar',
      provincie: 5,
      slug: 'lindlar',
    },
    {
      code: '053740024024',
      label: 'Marienheide',
      provincie: 5,
      slug: 'marienheide',
    },
    {
      code: '053740028028',
      label: 'Morsbach',
      provincie: 5,
      slug: 'morsbach',
    },
    {
      code: '053740032032',
      label: 'Nümbrecht',
      provincie: 5,
      slug: 'nuembrecht',
    },
    {
      code: '053740036036',
      label: 'Radevormwald',
      provincie: 5,
      slug: 'radevormwald',
    },
    {
      code: '053740040040',
      label: 'Reichshof',
      provincie: 5,
      slug: 'reichshof',
    },
    {
      code: '053740044044',
      label: 'Waldbröl',
      provincie: 5,
      slug: 'waldbroel',
    },
    {
      code: '053740048048',
      label: 'Wiehl',
      provincie: 5,
      slug: 'wiehl',
    },
    {
      code: '053740052052',
      label: 'Wipperfürth',
      provincie: 5,
      slug: 'wipperfuerth',
    },
    {
      code: '053780004004',
      label: 'Bergisch Gladbach',
      provincie: 5,
      slug: 'bergisch-gladbach',
    },
    {
      code: '053780008008',
      label: 'Burscheid',
      provincie: 5,
      slug: 'burscheid',
    },
    {
      code: '053780012012',
      label: 'Kürten',
      provincie: 5,
      slug: 'kuerten',
    },
    {
      code: '053780016016',
      label: 'Leichlingen (Rhld.)',
      provincie: 5,
      slug: 'leichlingen-rhld',
    },
    {
      code: '053780020020',
      label: 'Odenthal',
      provincie: 5,
      slug: 'odenthal',
    },
    {
      code: '053780024024',
      label: 'Overath',
      provincie: 5,
      slug: 'overath',
    },
    {
      code: '053780028028',
      label: 'Rösrath',
      provincie: 5,
      slug: 'roesrath',
    },
    {
      code: '053780032032',
      label: 'Wermelskirchen',
      provincie: 5,
      slug: 'wermelskirchen',
    },
    {
      code: '053820004004',
      label: 'Alfter',
      provincie: 5,
      slug: 'alfter',
    },
    {
      code: '053820008008',
      label: 'Bad Honnef',
      provincie: 5,
      slug: 'bad-honnef',
    },
    {
      code: '053820012012',
      label: 'Bornheim',
      provincie: 5,
      slug: 'bornheim',
    },
    {
      code: '053820016016',
      label: 'Eitorf',
      provincie: 5,
      slug: 'eitorf',
    },
    {
      code: '053820020020',
      label: 'Hennef (Sieg)',
      provincie: 5,
      slug: 'hennef-sieg',
    },
    {
      code: '053820024024',
      label: 'Königswinter',
      provincie: 5,
      slug: 'koenigswinter',
    },
    {
      code: '053820028028',
      label: 'Lohmar',
      provincie: 5,
      slug: 'lohmar',
    },
    {
      code: '053820032032',
      label: 'Meckenheim',
      provincie: 5,
      slug: 'meckenheim',
    },
    {
      code: '053820036036',
      label: 'Much',
      provincie: 5,
      slug: 'much',
    },
    {
      code: '053820040040',
      label: 'Neunkirchen-Seelscheid',
      provincie: 5,
      slug: 'neunkirchen-seelscheid',
    },
    {
      code: '053820044044',
      label: 'Niederkassel',
      provincie: 5,
      slug: 'niederkassel',
    },
    {
      code: '053820048048',
      label: 'Rheinbach',
      provincie: 5,
      slug: 'rheinbach',
    },
    {
      code: '053820052052',
      label: 'Ruppichteroth',
      provincie: 5,
      slug: 'ruppichteroth',
    },
    {
      code: '053820056056',
      label: 'Sankt Augustin',
      provincie: 5,
      slug: 'sankt-augustin',
    },
    {
      code: '053820060060',
      label: 'Siegburg',
      provincie: 5,
      slug: 'siegburg',
    },
    {
      code: '053820064064',
      label: 'Swisttal',
      provincie: 5,
      slug: 'swisttal',
    },
    {
      code: '053820068068',
      label: 'Troisdorf',
      provincie: 5,
      slug: 'troisdorf',
    },
    {
      code: '053820072072',
      label: 'Wachtberg',
      provincie: 5,
      slug: 'wachtberg',
    },
    {
      code: '053820076076',
      label: 'Windeck',
      provincie: 5,
      slug: 'windeck',
    },
    {
      code: '055120000000',
      label: 'Bottrop',
      provincie: 5,
      slug: 'bottrop',
    },
    {
      code: '055130000000',
      label: 'Gelsenkirchen',
      provincie: 5,
      slug: 'gelsenkirchen',
    },
    {
      code: '055150000000',
      label: 'Münster',
      provincie: 5,
      slug: 'muenster',
    },
    {
      code: '055540004004',
      label: 'Ahaus',
      provincie: 5,
      slug: 'ahaus',
    },
    {
      code: '055540008008',
      label: 'Bocholt',
      provincie: 5,
      slug: 'bocholt',
    },
    {
      code: '055540012012',
      label: 'Borken',
      provincie: 5,
      slug: 'borken',
    },
    {
      code: '055540016016',
      label: 'Gescher',
      provincie: 5,
      slug: 'gescher',
    },
    {
      code: '055540020020',
      label: 'Gronau (Westf.)',
      provincie: 5,
      slug: 'gronau-westf',
    },
    {
      code: '055540024024',
      label: 'Heek',
      provincie: 5,
      slug: 'heek',
    },
    {
      code: '055540028028',
      label: 'Heiden',
      provincie: 5,
      slug: 'heiden',
    },
    {
      code: '055540032032',
      label: 'Isselburg',
      provincie: 5,
      slug: 'isselburg',
    },
    {
      code: '055540036036',
      label: 'Legden',
      provincie: 5,
      slug: 'legden',
    },
    {
      code: '055540040040',
      label: 'Raesfeld',
      provincie: 5,
      slug: 'raesfeld',
    },
    {
      code: '055540044044',
      label: 'Reken',
      provincie: 5,
      slug: 'reken',
    },
    {
      code: '055540048048',
      label: 'Rhede',
      provincie: 5,
      slug: 'rhede',
    },
    {
      code: '055540052052',
      label: 'Schöppingen',
      provincie: 5,
      slug: 'schoeppingen',
    },
    {
      code: '055540056056',
      label: 'Stadtlohn',
      provincie: 5,
      slug: 'stadtlohn',
    },
    {
      code: '055540060060',
      label: 'Südlohn',
      provincie: 5,
      slug: 'suedlohn',
    },
    {
      code: '055540064064',
      label: 'Velen',
      provincie: 5,
      slug: 'velen',
    },
    {
      code: '055540068068',
      label: 'Vreden',
      provincie: 5,
      slug: 'vreden',
    },
    {
      code: '055580004004',
      label: 'Ascheberg',
      provincie: 5,
      slug: 'ascheberg',
    },
    {
      code: '055580008008',
      label: 'Billerbeck',
      provincie: 5,
      slug: 'billerbeck',
    },
    {
      code: '055580012012',
      label: 'Coesfeld',
      provincie: 5,
      slug: 'coesfeld',
    },
    {
      code: '055580016016',
      label: 'Dülmen',
      provincie: 5,
      slug: 'duelmen',
    },
    {
      code: '055580020020',
      label: 'Havixbeck',
      provincie: 5,
      slug: 'havixbeck',
    },
    {
      code: '055580024024',
      label: 'Lüdinghausen',
      provincie: 5,
      slug: 'luedinghausen',
    },
    {
      code: '055580028028',
      label: 'Nordkirchen',
      provincie: 5,
      slug: 'nordkirchen',
    },
    {
      code: '055580032032',
      label: 'Nottuln',
      provincie: 5,
      slug: 'nottuln',
    },
    {
      code: '055580036036',
      label: 'Olfen',
      provincie: 5,
      slug: 'olfen',
    },
    {
      code: '055580040040',
      label: 'Rosendahl',
      provincie: 5,
      slug: 'rosendahl',
    },
    {
      code: '055580044044',
      label: 'Senden',
      provincie: 5,
      slug: 'senden',
    },
    {
      code: '055620004004',
      label: 'Castrop-Rauxel',
      provincie: 5,
      slug: 'castrop-rauxel',
    },
    {
      code: '055620008008',
      label: 'Datteln',
      provincie: 5,
      slug: 'datteln',
    },
    {
      code: '055620012012',
      label: 'Dorsten',
      provincie: 5,
      slug: 'dorsten',
    },
    {
      code: '055620014014',
      label: 'Gladbeck',
      provincie: 5,
      slug: 'gladbeck',
    },
    {
      code: '055620016016',
      label: 'Haltern am See',
      provincie: 5,
      slug: 'haltern-am-see',
    },
    {
      code: '055620020020',
      label: 'Herten',
      provincie: 5,
      slug: 'herten',
    },
    {
      code: '055620024024',
      label: 'Marl',
      provincie: 5,
      slug: 'marl-stadt',
    },
    {
      code: '055620028028',
      label: 'Oer-Erkenschwick',
      provincie: 5,
      slug: 'oer-erkenschwick',
    },
    {
      code: '055620032032',
      label: 'Recklinghausen',
      provincie: 5,
      slug: 'recklinghausen',
    },
    {
      code: '055620036036',
      label: 'Waltrop',
      provincie: 5,
      slug: 'waltrop',
    },
    {
      code: '055660004004',
      label: 'Altenberge',
      provincie: 5,
      slug: 'altenberge',
    },
    {
      code: '055660008008',
      label: 'Emsdetten',
      provincie: 5,
      slug: 'emsdetten',
    },
    {
      code: '055660012012',
      label: 'Greven',
      provincie: 5,
      slug: 'greven',
    },
    {
      code: '055660016016',
      label: 'Hörstel',
      provincie: 5,
      slug: 'hoerstel',
    },
    {
      code: '055660020020',
      label: 'Hopsten',
      provincie: 5,
      slug: 'hopsten',
    },
    {
      code: '055660024024',
      label: 'Horstmar',
      provincie: 5,
      slug: 'horstmar',
    },
    {
      code: '055660028028',
      label: 'Ibbenbüren',
      provincie: 5,
      slug: 'ibbenbueren',
    },
    {
      code: '055660032032',
      label: 'Ladbergen',
      provincie: 5,
      slug: 'ladbergen',
    },
    {
      code: '055660036036',
      label: 'Laer',
      provincie: 5,
      slug: 'laer',
    },
    {
      code: '055660040040',
      label: 'Lengerich',
      provincie: 5,
      slug: 'lengerich-stadt',
    },
    {
      code: '055660044044',
      label: 'Lienen',
      provincie: 5,
      slug: 'lienen',
    },
    {
      code: '055660048048',
      label: 'Lotte',
      provincie: 5,
      slug: 'lotte',
    },
    {
      code: '055660052052',
      label: 'Metelen',
      provincie: 5,
      slug: 'metelen',
    },
    {
      code: '055660056056',
      label: 'Mettingen',
      provincie: 5,
      slug: 'mettingen',
    },
    {
      code: '055660060060',
      label: 'Neuenkirchen',
      provincie: 5,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '055660064064',
      label: 'Nordwalde',
      provincie: 5,
      slug: 'nordwalde',
    },
    {
      code: '055660068068',
      label: 'Ochtrup',
      provincie: 5,
      slug: 'ochtrup',
    },
    {
      code: '055660072072',
      label: 'Recke',
      provincie: 5,
      slug: 'recke',
    },
    {
      code: '055660076076',
      label: 'Rheine',
      provincie: 5,
      slug: 'rheine',
    },
    {
      code: '055660080080',
      label: 'Saerbeck',
      provincie: 5,
      slug: 'saerbeck',
    },
    {
      code: '055660084084',
      label: 'Steinfurt',
      provincie: 5,
      slug: 'steinfurt',
    },
    {
      code: '055660088088',
      label: 'Tecklenburg',
      provincie: 5,
      slug: 'tecklenburg',
    },
    {
      code: '055660092092',
      label: 'Westerkappeln',
      provincie: 5,
      slug: 'westerkappeln',
    },
    {
      code: '055660096096',
      label: 'Wettringen',
      provincie: 5,
      slug: 'wettringen',
    },
    {
      code: '055700004004',
      label: 'Ahlen',
      provincie: 5,
      slug: 'ahlen',
    },
    {
      code: '055700008008',
      label: 'Beckum',
      provincie: 5,
      slug: 'beckum',
    },
    {
      code: '055700012012',
      label: 'Beelen',
      provincie: 5,
      slug: 'beelen',
    },
    {
      code: '055700016016',
      label: 'Drensteinfurt',
      provincie: 5,
      slug: 'drensteinfurt',
    },
    {
      code: '055700020020',
      label: 'Ennigerloh',
      provincie: 5,
      slug: 'ennigerloh',
    },
    {
      code: '055700024024',
      label: 'Everswinkel',
      provincie: 5,
      slug: 'everswinkel',
    },
    {
      code: '055700028028',
      label: 'Oelde',
      provincie: 5,
      slug: 'oelde',
    },
    {
      code: '055700032032',
      label: 'Ostbevern',
      provincie: 5,
      slug: 'ostbevern',
    },
    {
      code: '055700036036',
      label: 'Sassenberg',
      provincie: 5,
      slug: 'sassenberg',
    },
    {
      code: '055700040040',
      label: 'Sendenhorst',
      provincie: 5,
      slug: 'sendenhorst',
    },
    {
      code: '055700044044',
      label: 'Telgte',
      provincie: 5,
      slug: 'telgte',
    },
    {
      code: '055700048048',
      label: 'Wadersloh',
      provincie: 5,
      slug: 'wadersloh',
    },
    {
      code: '055700052052',
      label: 'Warendorf',
      provincie: 5,
      slug: 'warendorf',
    },
    {
      code: '057110000000',
      label: 'Bielefeld',
      provincie: 5,
      slug: 'bielefeld',
    },
    {
      code: '057540004004',
      label: 'Borgholzhausen',
      provincie: 5,
      slug: 'borgholzhausen',
    },
    {
      code: '057540008008',
      label: 'Gütersloh',
      provincie: 5,
      slug: 'guetersloh',
    },
    {
      code: '057540012012',
      label: 'Halle (Westf.)',
      provincie: 5,
      slug: 'halle-westf',
    },
    {
      code: '057540016016',
      label: 'Harsewinkel',
      provincie: 5,
      slug: 'harsewinkel',
    },
    {
      code: '057540020020',
      label: 'Herzebrock-Clarholz',
      provincie: 5,
      slug: 'herzebrock-clarholz',
    },
    {
      code: '057540024024',
      label: 'Langenberg',
      provincie: 5,
      slug: 'langenberg',
    },
    {
      code: '057540028028',
      label: 'Rheda-Wiedenbrück',
      provincie: 5,
      slug: 'rheda-wiedenbrueck',
    },
    {
      code: '057540032032',
      label: 'Rietberg',
      provincie: 5,
      slug: 'rietberg',
    },
    {
      code: '057540036036',
      label: 'Schloß Holte-Stukenbrock',
      provincie: 5,
      slug: 'schloss-holte-stukenbrock',
    },
    {
      code: '057540040040',
      label: 'Steinhagen',
      provincie: 5,
      slug: 'steinhagen',
    },
    {
      code: '057540044044',
      label: 'Verl',
      provincie: 5,
      slug: 'verl',
    },
    {
      code: '057540048048',
      label: 'Versmold',
      provincie: 5,
      slug: 'versmold',
    },
    {
      code: '057540052052',
      label: 'Werther (Westf.)',
      provincie: 5,
      slug: 'werther-westf',
    },
    {
      code: '057580004004',
      label: 'Bünde',
      provincie: 5,
      slug: 'buende',
    },
    {
      code: '057580008008',
      label: 'Enger',
      provincie: 5,
      slug: 'enger',
    },
    {
      code: '057580012012',
      label: 'Herford',
      provincie: 5,
      slug: 'herford',
    },
    {
      code: '057580016016',
      label: 'Hiddenhausen',
      provincie: 5,
      slug: 'hiddenhausen',
    },
    {
      code: '057580020020',
      label: 'Kirchlengern',
      provincie: 5,
      slug: 'kirchlengern',
    },
    {
      code: '057580024024',
      label: 'Löhne',
      provincie: 5,
      slug: 'loehne',
    },
    {
      code: '057580028028',
      label: 'Rödinghausen',
      provincie: 5,
      slug: 'roedinghausen',
    },
    {
      code: '057580032032',
      label: 'Spenge',
      provincie: 5,
      slug: 'spenge',
    },
    {
      code: '057580036036',
      label: 'Vlotho',
      provincie: 5,
      slug: 'vlotho',
    },
    {
      code: '057620004004',
      label: 'Bad Driburg',
      provincie: 5,
      slug: 'bad-driburg',
    },
    {
      code: '057620008008',
      label: 'Beverungen',
      provincie: 5,
      slug: 'beverungen',
    },
    {
      code: '057620012012',
      label: 'Borgentreich',
      provincie: 5,
      slug: 'borgentreich',
    },
    {
      code: '057620016016',
      label: 'Brakel',
      provincie: 5,
      slug: 'brakel',
    },
    {
      code: '057620020020',
      label: 'Höxter',
      provincie: 5,
      slug: 'hoexter',
    },
    {
      code: '057620024024',
      label: 'Marienmünster',
      provincie: 5,
      slug: 'marienmuenster',
    },
    {
      code: '057620028028',
      label: 'Nieheim',
      provincie: 5,
      slug: 'nieheim',
    },
    {
      code: '057620032032',
      label: 'Steinheim',
      provincie: 5,
      slug: 'steinheim',
    },
    {
      code: '057620036036',
      label: 'Warburg',
      provincie: 5,
      slug: 'warburg',
    },
    {
      code: '057620040040',
      label: 'Willebadessen',
      provincie: 5,
      slug: 'willebadessen',
    },
    {
      code: '057660004004',
      label: 'Augustdorf',
      provincie: 5,
      slug: 'augustdorf',
    },
    {
      code: '057660008008',
      label: 'Bad Salzuflen',
      provincie: 5,
      slug: 'bad-salzuflen',
    },
    {
      code: '057660012012',
      label: 'Barntrup',
      provincie: 5,
      slug: 'barntrup',
    },
    {
      code: '057660016016',
      label: 'Blomberg',
      provincie: 5,
      slug: 'blomberg-stadt',
    },
    {
      code: '057660020020',
      label: 'Detmold',
      provincie: 5,
      slug: 'detmold',
    },
    {
      code: '057660024024',
      label: 'Dörentrup',
      provincie: 5,
      slug: 'doerentrup',
    },
    {
      code: '057660028028',
      label: 'Extertal',
      provincie: 5,
      slug: 'extertal',
    },
    {
      code: '057660032032',
      label: 'Horn-Bad Meinberg',
      provincie: 5,
      slug: 'horn-bad-meinberg',
    },
    {
      code: '057660036036',
      label: 'Kalletal',
      provincie: 5,
      slug: 'kalletal',
    },
    {
      code: '057660040040',
      label: 'Lage',
      provincie: 5,
      slug: 'lage-stadt',
    },
    {
      code: '057660044044',
      label: 'Lemgo',
      provincie: 5,
      slug: 'lemgo',
    },
    {
      code: '057660048048',
      label: 'Leopoldshöhe',
      provincie: 5,
      slug: 'leopoldshoehe',
    },
    {
      code: '057660052052',
      label: 'Lügde',
      provincie: 5,
      slug: 'luegde',
    },
    {
      code: '057660056056',
      label: 'Oerlinghausen',
      provincie: 5,
      slug: 'oerlinghausen',
    },
    {
      code: '057660060060',
      label: 'Schieder-Schwalenberg',
      provincie: 5,
      slug: 'schieder-schwalenberg',
    },
    {
      code: '057660064064',
      label: 'Schlangen',
      provincie: 5,
      slug: 'schlangen',
    },
    {
      code: '057700004004',
      label: 'Bad Oeynhausen',
      provincie: 5,
      slug: 'bad-oeynhausen',
    },
    {
      code: '057700008008',
      label: 'Espelkamp',
      provincie: 5,
      slug: 'espelkamp',
    },
    {
      code: '057700012012',
      label: 'Hille',
      provincie: 5,
      slug: 'hille',
    },
    {
      code: '057700016016',
      label: 'Hüllhorst',
      provincie: 5,
      slug: 'huellhorst',
    },
    {
      code: '057700020020',
      label: 'Lübbecke',
      provincie: 5,
      slug: 'luebbecke',
    },
    {
      code: '057700024024',
      label: 'Minden',
      provincie: 5,
      slug: 'minden',
    },
    {
      code: '057700028028',
      label: 'Petershagen',
      provincie: 5,
      slug: 'petershagen',
    },
    {
      code: '057700032032',
      label: 'Porta Westfalica',
      provincie: 5,
      slug: 'porta-westfalica',
    },
    {
      code: '057700036036',
      label: 'Preußisch Oldendorf',
      provincie: 5,
      slug: 'preussisch-oldendorf',
    },
    {
      code: '057700040040',
      label: 'Rahden',
      provincie: 5,
      slug: 'rahden',
    },
    {
      code: '057700044044',
      label: 'Stemwede',
      provincie: 5,
      slug: 'stemwede',
    },
    {
      code: '057740004004',
      label: 'Altenbeken',
      provincie: 5,
      slug: 'altenbeken',
    },
    {
      code: '057740008008',
      label: 'Bad Lippspringe',
      provincie: 5,
      slug: 'bad-lippspringe',
    },
    {
      code: '057740012012',
      label: 'Borchen',
      provincie: 5,
      slug: 'borchen',
    },
    {
      code: '057740016016',
      label: 'Büren',
      provincie: 5,
      slug: 'bueren',
    },
    {
      code: '057740020020',
      label: 'Delbrück',
      provincie: 5,
      slug: 'delbrueck',
    },
    {
      code: '057740024024',
      label: 'Hövelhof',
      provincie: 5,
      slug: 'hoevelhof',
    },
    {
      code: '057740028028',
      label: 'Lichtenau',
      provincie: 5,
      slug: 'lichtenau',
    },
    {
      code: '057740032032',
      label: 'Paderborn',
      provincie: 5,
      slug: 'paderborn',
    },
    {
      code: '057740036036',
      label: 'Salzkotten',
      provincie: 5,
      slug: 'salzkotten',
    },
    {
      code: '057740040040',
      label: 'Bad Wünnenberg',
      provincie: 5,
      slug: 'bad-wuennenberg',
    },
    {
      code: '059110000000',
      label: 'Bochum',
      provincie: 5,
      slug: 'bochum',
    },
    {
      code: '059130000000',
      label: 'Dortmund',
      provincie: 5,
      slug: 'dortmund',
    },
    {
      code: '059140000000',
      label: 'Hagen',
      provincie: 5,
      slug: 'hagen-stadt',
    },
    {
      code: '059150000000',
      label: 'Hamm',
      provincie: 5,
      slug: 'hamm',
    },
    {
      code: '059160000000',
      label: 'Herne',
      provincie: 5,
      slug: 'herne',
    },
    {
      code: '059540004004',
      label: 'Breckerfeld',
      provincie: 5,
      slug: 'breckerfeld',
    },
    {
      code: '059540008008',
      label: 'Ennepetal',
      provincie: 5,
      slug: 'ennepetal',
    },
    {
      code: '059540012012',
      label: 'Gevelsberg',
      provincie: 5,
      slug: 'gevelsberg',
    },
    {
      code: '059540016016',
      label: 'Hattingen',
      provincie: 5,
      slug: 'hattingen',
    },
    {
      code: '059540020020',
      label: 'Herdecke',
      provincie: 5,
      slug: 'herdecke',
    },
    {
      code: '059540024024',
      label: 'Schwelm',
      provincie: 5,
      slug: 'schwelm',
    },
    {
      code: '059540028028',
      label: 'Sprockhövel',
      provincie: 5,
      slug: 'sprockhoevel',
    },
    {
      code: '059540032032',
      label: 'Wetter (Ruhr)',
      provincie: 5,
      slug: 'wetter-ruhr',
    },
    {
      code: '059540036036',
      label: 'Witten',
      provincie: 5,
      slug: 'witten',
    },
    {
      code: '059580004004',
      label: 'Arnsberg',
      provincie: 5,
      slug: 'arnsberg',
    },
    {
      code: '059580008008',
      label: 'Bestwig',
      provincie: 5,
      slug: 'bestwig',
    },
    {
      code: '059580012012',
      label: 'Brilon',
      provincie: 5,
      slug: 'brilon',
    },
    {
      code: '059580016016',
      label: 'Eslohe (Sauerland)',
      provincie: 5,
      slug: 'eslohe-sauerland',
    },
    {
      code: '059580020020',
      label: 'Hallenberg',
      provincie: 5,
      slug: 'hallenberg',
    },
    {
      code: '059580024024',
      label: 'Marsberg',
      provincie: 5,
      slug: 'marsberg',
    },
    {
      code: '059580028028',
      label: 'Medebach',
      provincie: 5,
      slug: 'medebach',
    },
    {
      code: '059580032032',
      label: 'Meschede',
      provincie: 5,
      slug: 'meschede',
    },
    {
      code: '059580036036',
      label: 'Olsberg',
      provincie: 5,
      slug: 'olsberg',
    },
    {
      code: '059580040040',
      label: 'Schmallenberg',
      provincie: 5,
      slug: 'schmallenberg',
    },
    {
      code: '059580044044',
      label: 'Sundern (Sauerland)',
      provincie: 5,
      slug: 'sundern-sauerland',
    },
    {
      code: '059580048048',
      label: 'Winterberg',
      provincie: 5,
      slug: 'winterberg',
    },
    {
      code: '059620004004',
      label: 'Altena',
      provincie: 5,
      slug: 'altena',
    },
    {
      code: '059620008008',
      label: 'Balve',
      provincie: 5,
      slug: 'balve',
    },
    {
      code: '059620012012',
      label: 'Halver',
      provincie: 5,
      slug: 'halver',
    },
    {
      code: '059620016016',
      label: 'Hemer',
      provincie: 5,
      slug: 'hemer',
    },
    {
      code: '059620020020',
      label: 'Herscheid',
      provincie: 5,
      slug: 'herscheid',
    },
    {
      code: '059620024024',
      label: 'Iserlohn',
      provincie: 5,
      slug: 'iserlohn',
    },
    {
      code: '059620028028',
      label: 'Kierspe',
      provincie: 5,
      slug: 'kierspe',
    },
    {
      code: '059620032032',
      label: 'Lüdenscheid',
      provincie: 5,
      slug: 'luedenscheid',
    },
    {
      code: '059620036036',
      label: 'Meinerzhagen',
      provincie: 5,
      slug: 'meinerzhagen',
    },
    {
      code: '059620040040',
      label: 'Menden (Sauerland)',
      provincie: 5,
      slug: 'menden-sauerland',
    },
    {
      code: '059620044044',
      label: 'Nachrodt-Wiblingwerde',
      provincie: 5,
      slug: 'nachrodt-wiblingwerde',
    },
    {
      code: '059620048048',
      label: 'Neuenrade',
      provincie: 5,
      slug: 'neuenrade',
    },
    {
      code: '059620052052',
      label: 'Plettenberg',
      provincie: 5,
      slug: 'plettenberg',
    },
    {
      code: '059620056056',
      label: 'Schalksmühle',
      provincie: 5,
      slug: 'schalksmuehle',
    },
    {
      code: '059620060060',
      label: 'Werdohl',
      provincie: 5,
      slug: 'werdohl',
    },
    {
      code: '059660004004',
      label: 'Attendorn',
      provincie: 5,
      slug: 'attendorn',
    },
    {
      code: '059660008008',
      label: 'Drolshagen',
      provincie: 5,
      slug: 'drolshagen',
    },
    {
      code: '059660012012',
      label: 'Finnentrop',
      provincie: 5,
      slug: 'finnentrop',
    },
    {
      code: '059660016016',
      label: 'Kirchhundem',
      provincie: 5,
      slug: 'kirchhundem',
    },
    {
      code: '059660020020',
      label: 'Lennestadt',
      provincie: 5,
      slug: 'lennestadt',
    },
    {
      code: '059660024024',
      label: 'Olpe',
      provincie: 5,
      slug: 'olpe',
    },
    {
      code: '059660028028',
      label: 'Wenden',
      provincie: 5,
      slug: 'wenden',
    },
    {
      code: '059700004004',
      label: 'Bad Berleburg',
      provincie: 5,
      slug: 'bad-berleburg',
    },
    {
      code: '059700008008',
      label: 'Burbach',
      provincie: 5,
      slug: 'burbach',
    },
    {
      code: '059700012012',
      label: 'Erndtebrück',
      provincie: 5,
      slug: 'erndtebrueck',
    },
    {
      code: '059700016016',
      label: 'Freudenberg',
      provincie: 5,
      slug: 'freudenberg',
    },
    {
      code: '059700020020',
      label: 'Hilchenbach',
      provincie: 5,
      slug: 'hilchenbach',
    },
    {
      code: '059700024024',
      label: 'Kreuztal',
      provincie: 5,
      slug: 'kreuztal',
    },
    {
      code: '059700028028',
      label: 'Bad Laasphe',
      provincie: 5,
      slug: 'bad-laasphe',
    },
    {
      code: '059700032032',
      label: 'Netphen',
      provincie: 5,
      slug: 'netphen',
    },
    {
      code: '059700036036',
      label: 'Neunkirchen',
      provincie: 5,
      slug: 'neunkirchen',
    },
    {
      code: '059700040040',
      label: 'Siegen',
      provincie: 5,
      slug: 'siegen',
    },
    {
      code: '059700044044',
      label: 'Wilnsdorf',
      provincie: 5,
      slug: 'wilnsdorf',
    },
    {
      code: '059740004004',
      label: 'Anröchte',
      provincie: 5,
      slug: 'anroechte',
    },
    {
      code: '059740008008',
      label: 'Bad Sassendorf',
      provincie: 5,
      slug: 'bad-sassendorf',
    },
    {
      code: '059740012012',
      label: 'Ense',
      provincie: 5,
      slug: 'ense',
    },
    {
      code: '059740016016',
      label: 'Erwitte',
      provincie: 5,
      slug: 'erwitte',
    },
    {
      code: '059740020020',
      label: 'Geseke',
      provincie: 5,
      slug: 'geseke',
    },
    {
      code: '059740024024',
      label: 'Lippetal',
      provincie: 5,
      slug: 'lippetal',
    },
    {
      code: '059740028028',
      label: 'Lippstadt',
      provincie: 5,
      slug: 'lippstadt',
    },
    {
      code: '059740032032',
      label: 'Möhnesee',
      provincie: 5,
      slug: 'moehnesee',
    },
    {
      code: '059740036036',
      label: 'Rüthen',
      provincie: 5,
      slug: 'ruethen',
    },
    {
      code: '059740040040',
      label: 'Soest',
      provincie: 5,
      slug: 'soest',
    },
    {
      code: '059740044044',
      label: 'Warstein',
      provincie: 5,
      slug: 'warstein',
    },
    {
      code: '059740048048',
      label: 'Welver',
      provincie: 5,
      slug: 'welver',
    },
    {
      code: '059740052052',
      label: 'Werl',
      provincie: 5,
      slug: 'werl',
    },
    {
      code: '059740056056',
      label: 'Wickede (Ruhr)',
      provincie: 5,
      slug: 'wickede-ruhr',
    },
    {
      code: '059780004004',
      label: 'Bergkamen',
      provincie: 5,
      slug: 'bergkamen',
    },
    {
      code: '059780008008',
      label: 'Bönen',
      provincie: 5,
      slug: 'boenen',
    },
    {
      code: '059780012012',
      label: 'Fröndenberg/Ruhr',
      provincie: 5,
      slug: 'froendenberg-ruhr',
    },
    {
      code: '059780016016',
      label: 'Holzwickede',
      provincie: 5,
      slug: 'holzwickede',
    },
    {
      code: '059780020020',
      label: 'Kamen',
      provincie: 5,
      slug: 'kamen',
    },
    {
      code: '059780024024',
      label: 'Lünen',
      provincie: 5,
      slug: 'luenen',
    },
    {
      code: '059780028028',
      label: 'Schwerte',
      provincie: 5,
      slug: 'schwerte',
    },
    {
      code: '059780032032',
      label: 'Selm',
      provincie: 5,
      slug: 'selm',
    },
    {
      code: '059780036036',
      label: 'Unna',
      provincie: 5,
      slug: 'unna',
    },
    {
      code: '059780040040',
      label: 'Werne',
      provincie: 5,
      slug: 'werne',
    },
    {
      code: '064110000000',
      label: 'Darmstadt',
      provincie: 6,
      slug: 'darmstadt',
    },
    {
      code: '064120000000',
      label: 'Frankfurt am Main',
      provincie: 6,
      slug: 'frankfurt-am-main',
    },
    {
      code: '064130000000',
      label: 'Offenbach am Main',
      provincie: 6,
      slug: 'offenbach-am-main',
    },
    {
      code: '064140000000',
      label: 'Wiesbaden',
      provincie: 6,
      slug: 'wiesbaden',
    },
    {
      code: '064310001001',
      label: 'Abtsteinach',
      provincie: 6,
      slug: 'abtsteinach',
    },
    {
      code: '064310002002',
      label: 'Bensheim',
      provincie: 6,
      slug: 'bensheim',
    },
    {
      code: '064310003003',
      label: 'Biblis',
      provincie: 6,
      slug: 'biblis',
    },
    {
      code: '064310004004',
      label: 'Birkenau',
      provincie: 6,
      slug: 'birkenau',
    },
    {
      code: '064310005005',
      label: 'Bürstadt',
      provincie: 6,
      slug: 'buerstadt',
    },
    {
      code: '064310006006',
      label: 'Einhausen',
      provincie: 6,
      slug: 'einhausen',
    },
    {
      code: '064310007007',
      label: 'Fürth',
      provincie: 6,
      slug: 'fuerth',
    },
    {
      code: '064310008008',
      label: 'Gorxheimertal',
      provincie: 6,
      slug: 'gorxheimertal',
    },
    {
      code: '064310009009',
      label: 'Grasellenbach',
      provincie: 6,
      slug: 'grasellenbach',
    },
    {
      code: '064310010010',
      label: 'Groß-Rohrheim',
      provincie: 6,
      slug: 'gross-rohrheim',
    },
    {
      code: '064310011011',
      label: 'Heppenheim (Bergstraße)',
      provincie: 6,
      slug: 'heppenheim-bergstrasse',
    },
    {
      code: '064310012012',
      label: 'Hirschhorn (Neckar)',
      provincie: 6,
      slug: 'hirschhorn-neckar',
    },
    {
      code: '064310013013',
      label: 'Lampertheim',
      provincie: 6,
      slug: 'lampertheim',
    },
    {
      code: '064310014014',
      label: 'Lautertal (Odenwald)',
      provincie: 6,
      slug: 'lautertal-odenwald',
    },
    {
      code: '064310015015',
      label: 'Lindenfels',
      provincie: 6,
      slug: 'lindenfels',
    },
    {
      code: '064310016016',
      label: 'Lorsch',
      provincie: 6,
      slug: 'lorsch',
    },
    {
      code: '064310017017',
      label: 'Mörlenbach',
      provincie: 6,
      slug: 'moerlenbach',
    },
    {
      code: '064310018018',
      label: 'Neckarsteinach',
      provincie: 6,
      slug: 'neckarsteinach',
    },
    {
      code: '064310019019',
      label: 'Rimbach',
      provincie: 6,
      slug: 'rimbach',
    },
    {
      code: '064310020020',
      label: 'Viernheim',
      provincie: 6,
      slug: 'viernheim',
    },
    {
      code: '064310021021',
      label: 'Wald-Michelbach',
      provincie: 6,
      slug: 'wald-michelbach',
    },
    {
      code: '064310022022',
      label: 'Zwingenberg',
      provincie: 6,
      slug: 'zwingenberg',
    },
    {
      code: '064320001001',
      label: 'Alsbach-Hähnlein',
      provincie: 6,
      slug: 'alsbach-haehnlein',
    },
    {
      code: '064320002002',
      label: 'Babenhausen',
      provincie: 6,
      slug: 'babenhausen',
    },
    {
      code: '064320003003',
      label: 'Bickenbach',
      provincie: 6,
      slug: 'bickenbach',
    },
    {
      code: '064320004004',
      label: 'Dieburg',
      provincie: 6,
      slug: 'dieburg',
    },
    {
      code: '064320005005',
      label: 'Eppertshausen',
      provincie: 6,
      slug: 'eppertshausen',
    },
    {
      code: '064320006006',
      label: 'Erzhausen',
      provincie: 6,
      slug: 'erzhausen',
    },
    {
      code: '064320007007',
      label: 'Fischbachtal',
      provincie: 6,
      slug: 'fischbachtal',
    },
    {
      code: '064320008008',
      label: 'Griesheim',
      provincie: 6,
      slug: 'griesheim',
    },
    {
      code: '064320009009',
      label: 'Groß-Bieberau',
      provincie: 6,
      slug: 'gross-bieberau',
    },
    {
      code: '064320010010',
      label: 'Groß-Umstadt',
      provincie: 6,
      slug: 'gross-umstadt',
    },
    {
      code: '064320011011',
      label: 'Groß-Zimmern',
      provincie: 6,
      slug: 'gross-zimmern',
    },
    {
      code: '064320012012',
      label: 'Messel',
      provincie: 6,
      slug: 'messel',
    },
    {
      code: '064320013013',
      label: 'Modautal',
      provincie: 6,
      slug: 'modautal',
    },
    {
      code: '064320014014',
      label: 'Mühltal',
      provincie: 6,
      slug: 'muehltal',
    },
    {
      code: '064320015015',
      label: 'Münster (Hessen)',
      provincie: 6,
      slug: 'muenster-hessen',
    },
    {
      code: '064320016016',
      label: 'Ober-Ramstadt',
      provincie: 6,
      slug: 'ober-ramstadt',
    },
    {
      code: '064320017017',
      label: 'Otzberg',
      provincie: 6,
      slug: 'otzberg',
    },
    {
      code: '064320018018',
      label: 'Pfungstadt',
      provincie: 6,
      slug: 'pfungstadt',
    },
    {
      code: '064320019019',
      label: 'Reinheim',
      provincie: 6,
      slug: 'reinheim',
    },
    {
      code: '064320020020',
      label: 'Roßdorf',
      provincie: 6,
      slug: 'rossdorf',
    },
    {
      code: '064320021021',
      label: 'Schaafheim',
      provincie: 6,
      slug: 'schaafheim',
    },
    {
      code: '064320022022',
      label: 'Seeheim-Jugenheim',
      provincie: 6,
      slug: 'seeheim-jugenheim',
    },
    {
      code: '064320023023',
      label: 'Weiterstadt',
      provincie: 6,
      slug: 'weiterstadt',
    },
    {
      code: '064330001001',
      label: 'Biebesheim am Rhein',
      provincie: 6,
      slug: 'biebesheim-am-rhein',
    },
    {
      code: '064330002002',
      label: 'Bischofsheim',
      provincie: 6,
      slug: 'bischofsheim',
    },
    {
      code: '064330003003',
      label: 'Büttelborn',
      provincie: 6,
      slug: 'buettelborn',
    },
    {
      code: '064330004004',
      label: 'Gernsheim',
      provincie: 6,
      slug: 'gernsheim',
    },
    {
      code: '064330005005',
      label: 'Ginsheim-Gustavsburg',
      provincie: 6,
      slug: 'ginsheim-gustavsburg',
    },
    {
      code: '064330006006',
      label: 'Groß-Gerau',
      provincie: 6,
      slug: 'gross-gerau',
    },
    {
      code: '064330007007',
      label: 'Kelsterbach',
      provincie: 6,
      slug: 'kelsterbach',
    },
    {
      code: '064330008008',
      label: 'Mörfelden-Walldorf',
      provincie: 6,
      slug: 'moerfelden-walldorf',
    },
    {
      code: '064330009009',
      label: 'Nauheim',
      provincie: 6,
      slug: 'nauheim',
    },
    {
      code: '064330010010',
      label: 'Raunheim',
      provincie: 6,
      slug: 'raunheim',
    },
    {
      code: '064330011011',
      label: 'Riedstadt',
      provincie: 6,
      slug: 'riedstadt',
    },
    {
      code: '064330012012',
      label: 'Rüsselsheim am Main',
      provincie: 6,
      slug: 'ruesselsheim-am-main',
    },
    {
      code: '064330013013',
      label: 'Stockstadt am Rhein',
      provincie: 6,
      slug: 'stockstadt-am-rhein',
    },
    {
      code: '064330014014',
      label: 'Trebur',
      provincie: 6,
      slug: 'trebur',
    },
    {
      code: '064340001001',
      label: 'Bad Homburg v.d.Höhe',
      provincie: 6,
      slug: 'bad-homburg-v-d-hoehe',
    },
    {
      code: '064340002002',
      label: 'Friedrichsdorf',
      provincie: 6,
      slug: 'friedrichsdorf',
    },
    {
      code: '064340003003',
      label: 'Glashütten',
      provincie: 6,
      slug: 'glashuetten',
    },
    {
      code: '064340004004',
      label: 'Grävenwiesbach',
      provincie: 6,
      slug: 'graevenwiesbach',
    },
    {
      code: '064340005005',
      label: 'Königstein im Taunus',
      provincie: 6,
      slug: 'koenigstein-im-taunus',
    },
    {
      code: '064340006006',
      label: 'Kronberg im Taunus',
      provincie: 6,
      slug: 'kronberg-im-taunus',
    },
    {
      code: '064340007007',
      label: 'Neu-Anspach',
      provincie: 6,
      slug: 'neu-anspach',
    },
    {
      code: '064340008008',
      label: 'Oberursel (Taunus)',
      provincie: 6,
      slug: 'oberursel-taunus',
    },
    {
      code: '064340009009',
      label: 'Schmitten im Taunus',
      provincie: 6,
      slug: 'schmitten-im-taunus',
    },
    {
      code: '064340010010',
      label: 'Steinbach (Taunus)',
      provincie: 6,
      slug: 'steinbach-taunus',
    },
    {
      code: '064340011011',
      label: 'Usingen',
      provincie: 6,
      slug: 'usingen',
    },
    {
      code: '064340012012',
      label: 'Wehrheim',
      provincie: 6,
      slug: 'wehrheim',
    },
    {
      code: '064340013013',
      label: 'Weilrod',
      provincie: 6,
      slug: 'weilrod',
    },
    {
      code: '064350001001',
      label: 'Bad Orb',
      provincie: 6,
      slug: 'bad-orb',
    },
    {
      code: '064350002002',
      label: 'Bad Soden-Salmünster',
      provincie: 6,
      slug: 'bad-soden-salmuenster',
    },
    {
      code: '064350003003',
      label: 'Biebergemünd',
      provincie: 6,
      slug: 'biebergemuend',
    },
    {
      code: '064350004004',
      label: 'Birstein',
      provincie: 6,
      slug: 'birstein',
    },
    {
      code: '064350005005',
      label: 'Brachttal',
      provincie: 6,
      slug: 'brachttal',
    },
    {
      code: '064350006006',
      label: 'Bruchköbel',
      provincie: 6,
      slug: 'bruchkoebel',
    },
    {
      code: '064350007007',
      label: 'Erlensee',
      provincie: 6,
      slug: 'erlensee',
    },
    {
      code: '064350008008',
      label: 'Flörsbachtal',
      provincie: 6,
      slug: 'floersbachtal',
    },
    {
      code: '064350009009',
      label: 'Freigericht',
      provincie: 6,
      slug: 'freigericht',
    },
    {
      code: '064350010010',
      label: 'Gelnhausen',
      provincie: 6,
      slug: 'gelnhausen',
    },
    {
      code: '064350011011',
      label: 'Großkrotzenburg',
      provincie: 6,
      slug: 'grosskrotzenburg',
    },
    {
      code: '064350012012',
      label: 'Gründau',
      provincie: 6,
      slug: 'gruendau',
    },
    {
      code: '064350013013',
      label: 'Hammersbach',
      provincie: 6,
      slug: 'hammersbach',
    },
    {
      code: '064350014014',
      label: 'Hanau',
      provincie: 6,
      slug: 'hanau',
    },
    {
      code: '064350015015',
      label: 'Hasselroth',
      provincie: 6,
      slug: 'hasselroth',
    },
    {
      code: '064350016016',
      label: 'Jossgrund',
      provincie: 6,
      slug: 'jossgrund',
    },
    {
      code: '064350017017',
      label: 'Langenselbold',
      provincie: 6,
      slug: 'langenselbold',
    },
    {
      code: '064350018018',
      label: 'Linsengericht',
      provincie: 6,
      slug: 'linsengericht',
    },
    {
      code: '064350019019',
      label: 'Maintal',
      provincie: 6,
      slug: 'maintal',
    },
    {
      code: '064350020020',
      label: 'Neuberg',
      provincie: 6,
      slug: 'neuberg',
    },
    {
      code: '064350021021',
      label: 'Nidderau',
      provincie: 6,
      slug: 'nidderau',
    },
    {
      code: '064350022022',
      label: 'Niederdorfelden',
      provincie: 6,
      slug: 'niederdorfelden',
    },
    {
      code: '064350023023',
      label: 'Rodenbach',
      provincie: 6,
      slug: 'rodenbach',
    },
    {
      code: '064350024024',
      label: 'Ronneburg',
      provincie: 6,
      slug: 'ronneburg',
    },
    {
      code: '064350025025',
      label: 'Schlüchtern',
      provincie: 6,
      slug: 'schluechtern',
    },
    {
      code: '064350026026',
      label: 'Schöneck',
      provincie: 6,
      slug: 'schoeneck',
    },
    {
      code: '064350027027',
      label: 'Sinntal',
      provincie: 6,
      slug: 'sinntal',
    },
    {
      code: '064350028028',
      label: 'Steinau an der Straße',
      provincie: 6,
      slug: 'steinau-an-der-strasse',
    },
    {
      code: '064350029029',
      label: 'Wächtersbach',
      provincie: 6,
      slug: 'waechtersbach',
    },
    {
      code: '064360001001',
      label: 'Bad Soden am Taunus',
      provincie: 6,
      slug: 'bad-soden-am-taunus',
    },
    {
      code: '064360002002',
      label: 'Eppstein',
      provincie: 6,
      slug: 'eppstein',
    },
    {
      code: '064360003003',
      label: 'Eschborn',
      provincie: 6,
      slug: 'eschborn',
    },
    {
      code: '064360004004',
      label: 'Flörsheim am Main',
      provincie: 6,
      slug: 'floersheim-am-main',
    },
    {
      code: '064360005005',
      label: 'Hattersheim am Main',
      provincie: 6,
      slug: 'hattersheim-am-main',
    },
    {
      code: '064360006006',
      label: 'Hochheim am Main',
      provincie: 6,
      slug: 'hochheim-am-main',
    },
    {
      code: '064360007007',
      label: 'Hofheim am Taunus',
      provincie: 6,
      slug: 'hofheim-am-taunus',
    },
    {
      code: '064360008008',
      label: 'Kelkheim (Taunus)',
      provincie: 6,
      slug: 'kelkheim-taunus',
    },
    {
      code: '064360009009',
      label: 'Kriftel',
      provincie: 6,
      slug: 'kriftel',
    },
    {
      code: '064360010010',
      label: 'Liederbach am Taunus',
      provincie: 6,
      slug: 'liederbach-am-taunus',
    },
    {
      code: '064360011011',
      label: 'Schwalbach am Taunus',
      provincie: 6,
      slug: 'schwalbach-am-taunus',
    },
    {
      code: '064360012012',
      label: 'Sulzbach (Taunus)',
      provincie: 6,
      slug: 'sulzbach-taunus',
    },
    {
      code: '064370001001',
      label: 'Bad König',
      provincie: 6,
      slug: 'bad-koenig',
    },
    {
      code: '064370003003',
      label: 'Brensbach',
      provincie: 6,
      slug: 'brensbach',
    },
    {
      code: '064370004004',
      label: 'Breuberg',
      provincie: 6,
      slug: 'breuberg',
    },
    {
      code: '064370005005',
      label: 'Brombachtal',
      provincie: 6,
      slug: 'brombachtal',
    },
    {
      code: '064370006006',
      label: 'Erbach',
      provincie: 6,
      slug: 'erbach',
    },
    {
      code: '064370007007',
      label: 'Fränkisch-Crumbach',
      provincie: 6,
      slug: 'fraenkisch-crumbach',
    },
    {
      code: '064370009009',
      label: 'Höchst i.Odw.',
      provincie: 6,
      slug: 'hoechst-i-odw',
    },
    {
      code: '064370010010',
      label: 'Lützelbach',
      provincie: 6,
      slug: 'luetzelbach',
    },
    {
      code: '064370011011',
      label: 'Michelstadt',
      provincie: 6,
      slug: 'michelstadt',
    },
    {
      code: '064370012012',
      label: 'Mossautal',
      provincie: 6,
      slug: 'mossautal',
    },
    {
      code: '064370013013',
      label: 'Reichelsheim (Odenwald)',
      provincie: 6,
      slug: 'reichelsheim-odenwald',
    },
    {
      code: '064370016016',
      label: 'Oberzent',
      provincie: 6,
      slug: 'oberzent',
    },
    {
      code: '064380001001',
      label: 'Dietzenbach',
      provincie: 6,
      slug: 'dietzenbach',
    },
    {
      code: '064380002002',
      label: 'Dreieich',
      provincie: 6,
      slug: 'dreieich',
    },
    {
      code: '064380003003',
      label: 'Egelsbach',
      provincie: 6,
      slug: 'egelsbach',
    },
    {
      code: '064380004004',
      label: 'Hainburg',
      provincie: 6,
      slug: 'hainburg',
    },
    {
      code: '064380005005',
      label: 'Heusenstamm',
      provincie: 6,
      slug: 'heusenstamm',
    },
    {
      code: '064380006006',
      label: 'Langen (Hessen)',
      provincie: 6,
      slug: 'langen-hessen',
    },
    {
      code: '064380007007',
      label: 'Mainhausen',
      provincie: 6,
      slug: 'mainhausen',
    },
    {
      code: '064380008008',
      label: 'Mühlheim am Main',
      provincie: 6,
      slug: 'muehlheim-am-main',
    },
    {
      code: '064380009009',
      label: 'Neu-Isenburg',
      provincie: 6,
      slug: 'neu-isenburg',
    },
    {
      code: '064380010010',
      label: 'Obertshausen',
      provincie: 6,
      slug: 'obertshausen',
    },
    {
      code: '064380011011',
      label: 'Rodgau',
      provincie: 6,
      slug: 'rodgau',
    },
    {
      code: '064380012012',
      label: 'Rödermark',
      provincie: 6,
      slug: 'roedermark',
    },
    {
      code: '064380013013',
      label: 'Seligenstadt',
      provincie: 6,
      slug: 'seligenstadt',
    },
    {
      code: '064390001001',
      label: 'Aarbergen',
      provincie: 6,
      slug: 'aarbergen',
    },
    {
      code: '064390002002',
      label: 'Bad Schwalbach',
      provincie: 6,
      slug: 'bad-schwalbach',
    },
    {
      code: '064390003003',
      label: 'Eltville am Rhein',
      provincie: 6,
      slug: 'eltville-am-rhein',
    },
    {
      code: '064390004004',
      label: 'Geisenheim',
      provincie: 6,
      slug: 'geisenheim',
    },
    {
      code: '064390005005',
      label: 'Heidenrod',
      provincie: 6,
      slug: 'heidenrod',
    },
    {
      code: '064390006006',
      label: 'Hohenstein',
      provincie: 6,
      slug: 'hohenstein',
    },
    {
      code: '064390007007',
      label: 'Hünstetten',
      provincie: 6,
      slug: 'huenstetten',
    },
    {
      code: '064390008008',
      label: 'Idstein',
      provincie: 6,
      slug: 'idstein',
    },
    {
      code: '064390009009',
      label: 'Kiedrich',
      provincie: 6,
      slug: 'kiedrich',
    },
    {
      code: '064390010010',
      label: 'Lorch',
      provincie: 6,
      slug: 'lorch',
    },
    {
      code: '064390011011',
      label: 'Niedernhausen',
      provincie: 6,
      slug: 'niedernhausen',
    },
    {
      code: '064390012012',
      label: 'Oestrich-Winkel',
      provincie: 6,
      slug: 'oestrich-winkel',
    },
    {
      code: '064390013013',
      label: 'Rüdesheim am Rhein',
      provincie: 6,
      slug: 'ruedesheim-am-rhein',
    },
    {
      code: '064390014014',
      label: 'Schlangenbad',
      provincie: 6,
      slug: 'schlangenbad',
    },
    {
      code: '064390015015',
      label: 'Taunusstein',
      provincie: 6,
      slug: 'taunusstein',
    },
    {
      code: '064390016016',
      label: 'Waldems',
      provincie: 6,
      slug: 'waldems',
    },
    {
      code: '064390017017',
      label: 'Walluf',
      provincie: 6,
      slug: 'walluf',
    },
    {
      code: '064400001001',
      label: 'Altenstadt',
      provincie: 6,
      slug: 'altenstadt',
    },
    {
      code: '064400002002',
      label: 'Bad Nauheim',
      provincie: 6,
      slug: 'bad-nauheim',
    },
    {
      code: '064400003003',
      label: 'Bad Vilbel',
      provincie: 6,
      slug: 'bad-vilbel',
    },
    {
      code: '064400004004',
      label: 'Büdingen',
      provincie: 6,
      slug: 'buedingen',
    },
    {
      code: '064400005005',
      label: 'Butzbach',
      provincie: 6,
      slug: 'butzbach',
    },
    {
      code: '064400006006',
      label: 'Echzell',
      provincie: 6,
      slug: 'echzell',
    },
    {
      code: '064400007007',
      label: 'Florstadt',
      provincie: 6,
      slug: 'florstadt',
    },
    {
      code: '064400008008',
      label: 'Friedberg (Hessen)',
      provincie: 6,
      slug: 'friedberg-hessen',
    },
    {
      code: '064400009009',
      label: 'Gedern',
      provincie: 6,
      slug: 'gedern',
    },
    {
      code: '064400010010',
      label: 'Glauburg',
      provincie: 6,
      slug: 'glauburg',
    },
    {
      code: '064400011011',
      label: 'Hirzenhain',
      provincie: 6,
      slug: 'hirzenhain',
    },
    {
      code: '064400012012',
      label: 'Karben',
      provincie: 6,
      slug: 'karben',
    },
    {
      code: '064400013013',
      label: 'Kefenrod',
      provincie: 6,
      slug: 'kefenrod',
    },
    {
      code: '064400014014',
      label: 'Limeshain',
      provincie: 6,
      slug: 'limeshain',
    },
    {
      code: '064400015015',
      label: 'Münzenberg',
      provincie: 6,
      slug: 'muenzenberg',
    },
    {
      code: '064400016016',
      label: 'Nidda',
      provincie: 6,
      slug: 'nidda',
    },
    {
      code: '064400017017',
      label: 'Niddatal',
      provincie: 6,
      slug: 'niddatal',
    },
    {
      code: '064400018018',
      label: 'Ober-Mörlen',
      provincie: 6,
      slug: 'ober-moerlen',
    },
    {
      code: '064400019019',
      label: 'Ortenberg',
      provincie: 6,
      slug: 'ortenberg',
    },
    {
      code: '064400020020',
      label: 'Ranstadt',
      provincie: 6,
      slug: 'ranstadt',
    },
    {
      code: '064400021021',
      label: 'Reichelsheim (Wetterau)',
      provincie: 6,
      slug: 'reichelsheim-wetterau',
    },
    {
      code: '064400022022',
      label: 'Rockenberg',
      provincie: 6,
      slug: 'rockenberg',
    },
    {
      code: '064400023023',
      label: 'Rosbach v.d.Höhe',
      provincie: 6,
      slug: 'rosbach-v-d-hoehe',
    },
    {
      code: '064400024024',
      label: 'Wölfersheim',
      provincie: 6,
      slug: 'woelfersheim',
    },
    {
      code: '064400025025',
      label: 'Wöllstadt',
      provincie: 6,
      slug: 'woellstadt',
    },
    {
      code: '065310001001',
      label: 'Allendorf (Lumda)',
      provincie: 6,
      slug: 'allendorf-lumda',
    },
    {
      code: '065310002002',
      label: 'Biebertal',
      provincie: 6,
      slug: 'biebertal',
    },
    {
      code: '065310003003',
      label: 'Buseck',
      provincie: 6,
      slug: 'buseck',
    },
    {
      code: '065310004004',
      label: 'Fernwald',
      provincie: 6,
      slug: 'fernwald',
    },
    {
      code: '065310005005',
      label: 'Gießen',
      provincie: 6,
      slug: 'giessen',
    },
    {
      code: '065310006006',
      label: 'Grünberg',
      provincie: 6,
      slug: 'gruenberg',
    },
    {
      code: '065310007007',
      label: 'Heuchelheim a.d.Lahn',
      provincie: 6,
      slug: 'heuchelheim-a-d-lahn',
    },
    {
      code: '065310008008',
      label: 'Hungen',
      provincie: 6,
      slug: 'hungen',
    },
    {
      code: '065310009009',
      label: 'Langgöns',
      provincie: 6,
      slug: 'langgoens',
    },
    {
      code: '065310010010',
      label: 'Laubach',
      provincie: 6,
      slug: 'laubach',
    },
    {
      code: '065310011011',
      label: 'Lich',
      provincie: 6,
      slug: 'lich',
    },
    {
      code: '065310012012',
      label: 'Linden',
      provincie: 6,
      slug: 'linden-stadt',
    },
    {
      code: '065310013013',
      label: 'Lollar',
      provincie: 6,
      slug: 'lollar',
    },
    {
      code: '065310014014',
      label: 'Pohlheim',
      provincie: 6,
      slug: 'pohlheim',
    },
    {
      code: '065310015015',
      label: 'Rabenau',
      provincie: 6,
      slug: 'rabenau',
    },
    {
      code: '065310016016',
      label: 'Reiskirchen',
      provincie: 6,
      slug: 'reiskirchen',
    },
    {
      code: '065310017017',
      label: 'Staufenberg',
      provincie: 6,
      slug: 'staufenberg-stadt',
    },
    {
      code: '065310018018',
      label: 'Wettenberg',
      provincie: 6,
      slug: 'wettenberg',
    },
    {
      code: '065320001001',
      label: 'Aßlar',
      provincie: 6,
      slug: 'asslar',
    },
    {
      code: '065320002002',
      label: 'Bischoffen',
      provincie: 6,
      slug: 'bischoffen',
    },
    {
      code: '065320003003',
      label: 'Braunfels',
      provincie: 6,
      slug: 'braunfels',
    },
    {
      code: '065320004004',
      label: 'Breitscheid',
      provincie: 6,
      slug: 'breitscheid',
    },
    {
      code: '065320005005',
      label: 'Dietzhölztal',
      provincie: 6,
      slug: 'dietzhoelztal',
    },
    {
      code: '065320006006',
      label: 'Dillenburg',
      provincie: 6,
      slug: 'dillenburg',
    },
    {
      code: '065320007007',
      label: 'Driedorf',
      provincie: 6,
      slug: 'driedorf',
    },
    {
      code: '065320008008',
      label: 'Ehringshausen',
      provincie: 6,
      slug: 'ehringshausen',
    },
    {
      code: '065320009009',
      label: 'Eschenburg',
      provincie: 6,
      slug: 'eschenburg',
    },
    {
      code: '065320010010',
      label: 'Greifenstein',
      provincie: 6,
      slug: 'greifenstein',
    },
    {
      code: '065320011011',
      label: 'Haiger',
      provincie: 6,
      slug: 'haiger',
    },
    {
      code: '065320012012',
      label: 'Herborn',
      provincie: 6,
      slug: 'herborn',
    },
    {
      code: '065320013013',
      label: 'Hohenahr',
      provincie: 6,
      slug: 'hohenahr',
    },
    {
      code: '065320014014',
      label: 'Hüttenberg',
      provincie: 6,
      slug: 'huettenberg',
    },
    {
      code: '065320015015',
      label: 'Lahnau',
      provincie: 6,
      slug: 'lahnau',
    },
    {
      code: '065320016016',
      label: 'Leun',
      provincie: 6,
      slug: 'leun',
    },
    {
      code: '065320017017',
      label: 'Mittenaar',
      provincie: 6,
      slug: 'mittenaar',
    },
    {
      code: '065320018018',
      label: 'Schöffengrund',
      provincie: 6,
      slug: 'schoeffengrund',
    },
    {
      code: '065320019019',
      label: 'Siegbach',
      provincie: 6,
      slug: 'siegbach',
    },
    {
      code: '065320020020',
      label: 'Sinn',
      provincie: 6,
      slug: 'sinn',
    },
    {
      code: '065320021021',
      label: 'Solms',
      provincie: 6,
      slug: 'solms',
    },
    {
      code: '065320022022',
      label: 'Waldsolms',
      provincie: 6,
      slug: 'waldsolms',
    },
    {
      code: '065320023023',
      label: 'Wetzlar',
      provincie: 6,
      slug: 'wetzlar',
    },
    {
      code: '065330001001',
      label: 'Beselich',
      provincie: 6,
      slug: 'beselich',
    },
    {
      code: '065330002002',
      label: 'Brechen',
      provincie: 6,
      slug: 'brechen',
    },
    {
      code: '065330003003',
      label: 'Bad Camberg',
      provincie: 6,
      slug: 'bad-camberg',
    },
    {
      code: '065330004004',
      label: 'Dornburg',
      provincie: 6,
      slug: 'dornburg',
    },
    {
      code: '065330005005',
      label: 'Elbtal',
      provincie: 6,
      slug: 'elbtal',
    },
    {
      code: '065330006006',
      label: 'Elz',
      provincie: 6,
      slug: 'elz',
    },
    {
      code: '065330007007',
      label: 'Hadamar',
      provincie: 6,
      slug: 'hadamar',
    },
    {
      code: '065330008008',
      label: 'Hünfelden',
      provincie: 6,
      slug: 'huenfelden',
    },
    {
      code: '065330009009',
      label: 'Limburg a.d.Lahn',
      provincie: 6,
      slug: 'limburg-a-d-lahn',
    },
    {
      code: '065330010010',
      label: 'Löhnberg',
      provincie: 6,
      slug: 'loehnberg',
    },
    {
      code: '065330011011',
      label: 'Mengerskirchen',
      provincie: 6,
      slug: 'mengerskirchen',
    },
    {
      code: '065330012012',
      label: 'Merenberg',
      provincie: 6,
      slug: 'merenberg',
    },
    {
      code: '065330013013',
      label: 'Runkel',
      provincie: 6,
      slug: 'runkel',
    },
    {
      code: '065330014014',
      label: 'Selters (Taunus)',
      provincie: 6,
      slug: 'selters-taunus',
    },
    {
      code: '065330015015',
      label: 'Villmar',
      provincie: 6,
      slug: 'villmar',
    },
    {
      code: '065330016016',
      label: 'Waldbrunn (Westerwald)',
      provincie: 6,
      slug: 'waldbrunn-westerwald',
    },
    {
      code: '065330017017',
      label: 'Weilburg',
      provincie: 6,
      slug: 'weilburg',
    },
    {
      code: '065330018018',
      label: 'Weilmünster',
      provincie: 6,
      slug: 'weilmuenster',
    },
    {
      code: '065330019019',
      label: 'Weinbach',
      provincie: 6,
      slug: 'weinbach',
    },
    {
      code: '065340001001',
      label: 'Amöneburg',
      provincie: 6,
      slug: 'amoeneburg',
    },
    {
      code: '065340002002',
      label: 'Angelburg',
      provincie: 6,
      slug: 'angelburg',
    },
    {
      code: '065340003003',
      label: 'Bad Endbach',
      provincie: 6,
      slug: 'bad-endbach',
    },
    {
      code: '065340004004',
      label: 'Biedenkopf',
      provincie: 6,
      slug: 'biedenkopf',
    },
    {
      code: '065340005005',
      label: 'Breidenbach',
      provincie: 6,
      slug: 'breidenbach',
    },
    {
      code: '065340006006',
      label: 'Cölbe',
      provincie: 6,
      slug: 'coelbe',
    },
    {
      code: '065340007007',
      label: 'Dautphetal',
      provincie: 6,
      slug: 'dautphetal',
    },
    {
      code: '065340008008',
      label: 'Ebsdorfergrund',
      provincie: 6,
      slug: 'ebsdorfergrund',
    },
    {
      code: '065340009009',
      label: 'Fronhausen',
      provincie: 6,
      slug: 'fronhausen',
    },
    {
      code: '065340010010',
      label: 'Gladenbach',
      provincie: 6,
      slug: 'gladenbach',
    },
    {
      code: '065340011011',
      label: 'Kirchhain',
      provincie: 6,
      slug: 'kirchhain',
    },
    {
      code: '065340012012',
      label: 'Lahntal',
      provincie: 6,
      slug: 'lahntal',
    },
    {
      code: '065340013013',
      label: 'Lohra',
      provincie: 6,
      slug: 'lohra',
    },
    {
      code: '065340014014',
      label: 'Marburg',
      provincie: 6,
      slug: 'marburg',
    },
    {
      code: '065340015015',
      label: 'Münchhausen',
      provincie: 6,
      slug: 'muenchhausen',
    },
    {
      code: '065340016016',
      label: 'Neustadt (Hessen)',
      provincie: 6,
      slug: 'neustadt-hessen',
    },
    {
      code: '065340017017',
      label: 'Rauschenberg',
      provincie: 6,
      slug: 'rauschenberg',
    },
    {
      code: '065340018018',
      label: 'Stadtallendorf',
      provincie: 6,
      slug: 'stadtallendorf',
    },
    {
      code: '065340019019',
      label: 'Steffenberg',
      provincie: 6,
      slug: 'steffenberg',
    },
    {
      code: '065340020020',
      label: 'Weimar (Lahn)',
      provincie: 6,
      slug: 'weimar-lahn',
    },
    {
      code: '065340021021',
      label: 'Wetter (Hessen)',
      provincie: 6,
      slug: 'wetter-hessen',
    },
    {
      code: '065340022022',
      label: 'Wohratal',
      provincie: 6,
      slug: 'wohratal',
    },
    {
      code: '065350001001',
      label: 'Alsfeld',
      provincie: 6,
      slug: 'alsfeld',
    },
    {
      code: '065350002002',
      label: 'Antrifttal',
      provincie: 6,
      slug: 'antrifttal',
    },
    {
      code: '065350003003',
      label: 'Feldatal',
      provincie: 6,
      slug: 'feldatal',
    },
    {
      code: '065350004004',
      label: 'Freiensteinau',
      provincie: 6,
      slug: 'freiensteinau',
    },
    {
      code: '065350005005',
      label: 'Gemünden (Felda)',
      provincie: 6,
      slug: 'gemuenden-felda',
    },
    {
      code: '065350006006',
      label: 'Grebenau',
      provincie: 6,
      slug: 'grebenau',
    },
    {
      code: '065350007007',
      label: 'Grebenhain',
      provincie: 6,
      slug: 'grebenhain',
    },
    {
      code: '065350008008',
      label: 'Herbstein',
      provincie: 6,
      slug: 'herbstein',
    },
    {
      code: '065350009009',
      label: 'Homberg (Ohm)',
      provincie: 6,
      slug: 'homberg-ohm',
    },
    {
      code: '065350010010',
      label: 'Kirtorf',
      provincie: 6,
      slug: 'kirtorf',
    },
    {
      code: '065350011011',
      label: 'Lauterbach (Hessen)',
      provincie: 6,
      slug: 'lauterbach-hessen',
    },
    {
      code: '065350012012',
      label: 'Lautertal (Vogelsberg)',
      provincie: 6,
      slug: 'lautertal-vogelsberg',
    },
    {
      code: '065350013013',
      label: 'Mücke',
      provincie: 6,
      slug: 'muecke',
    },
    {
      code: '065350014014',
      label: 'Romrod',
      provincie: 6,
      slug: 'romrod',
    },
    {
      code: '065350015015',
      label: 'Schlitz',
      provincie: 6,
      slug: 'schlitz',
    },
    {
      code: '065350016016',
      label: 'Schotten',
      provincie: 6,
      slug: 'schotten',
    },
    {
      code: '065350017017',
      label: 'Schwalmtal',
      provincie: 6,
      slug: 'schwalmtal-gemeinde',
    },
    {
      code: '065350018018',
      label: 'Ulrichstein',
      provincie: 6,
      slug: 'ulrichstein',
    },
    {
      code: '065350019019',
      label: 'Wartenberg',
      provincie: 6,
      slug: 'wartenberg',
    },
    {
      code: '066110000000',
      label: 'Kassel',
      provincie: 6,
      slug: 'kassel',
    },
    {
      code: '066310001001',
      label: 'Bad Salzschlirf',
      provincie: 6,
      slug: 'bad-salzschlirf',
    },
    {
      code: '066310002002',
      label: 'Burghaun',
      provincie: 6,
      slug: 'burghaun',
    },
    {
      code: '066310003003',
      label: 'Dipperz',
      provincie: 6,
      slug: 'dipperz',
    },
    {
      code: '066310004004',
      label: 'Ebersburg',
      provincie: 6,
      slug: 'ebersburg',
    },
    {
      code: '066310005005',
      label: 'Ehrenberg (Rhön)',
      provincie: 6,
      slug: 'ehrenberg-rhoen',
    },
    {
      code: '066310006006',
      label: 'Eichenzell',
      provincie: 6,
      slug: 'eichenzell',
    },
    {
      code: '066310007007',
      label: 'Eiterfeld',
      provincie: 6,
      slug: 'eiterfeld',
    },
    {
      code: '066310008008',
      label: 'Flieden',
      provincie: 6,
      slug: 'flieden',
    },
    {
      code: '066310009009',
      label: 'Fulda',
      provincie: 6,
      slug: 'fulda',
    },
    {
      code: '066310010010',
      label: 'Gersfeld (Rhön)',
      provincie: 6,
      slug: 'gersfeld-rhoen',
    },
    {
      code: '066310011011',
      label: 'Großenlüder',
      provincie: 6,
      slug: 'grossenlueder',
    },
    {
      code: '066310012012',
      label: 'Hilders',
      provincie: 6,
      slug: 'hilders',
    },
    {
      code: '066310013013',
      label: 'Hofbieber',
      provincie: 6,
      slug: 'hofbieber',
    },
    {
      code: '066310014014',
      label: 'Hosenfeld',
      provincie: 6,
      slug: 'hosenfeld',
    },
    {
      code: '066310015015',
      label: 'Hünfeld',
      provincie: 6,
      slug: 'huenfeld',
    },
    {
      code: '066310016016',
      label: 'Kalbach',
      provincie: 6,
      slug: 'kalbach',
    },
    {
      code: '066310017017',
      label: 'Künzell',
      provincie: 6,
      slug: 'kuenzell',
    },
    {
      code: '066310018018',
      label: 'Neuhof',
      provincie: 6,
      slug: 'neuhof',
    },
    {
      code: '066310019019',
      label: 'Nüsttal',
      provincie: 6,
      slug: 'nuesttal',
    },
    {
      code: '066310020020',
      label: 'Petersberg',
      provincie: 6,
      slug: 'petersberg',
    },
    {
      code: '066310021021',
      label: 'Poppenhausen (Wasserkuppe)',
      provincie: 6,
      slug: 'poppenhausen-wasserkuppe',
    },
    {
      code: '066310022022',
      label: 'Rasdorf',
      provincie: 6,
      slug: 'rasdorf',
    },
    {
      code: '066310023023',
      label: 'Tann (Rhön)',
      provincie: 6,
      slug: 'tann-rhoen',
    },
    {
      code: '066320001001',
      label: 'Alheim',
      provincie: 6,
      slug: 'alheim',
    },
    {
      code: '066320002002',
      label: 'Bad Hersfeld',
      provincie: 6,
      slug: 'bad-hersfeld',
    },
    {
      code: '066320003003',
      label: 'Bebra',
      provincie: 6,
      slug: 'bebra',
    },
    {
      code: '066320004004',
      label: 'Breitenbach a.Herzberg',
      provincie: 6,
      slug: 'breitenbach-a-herzberg',
    },
    {
      code: '066320005005',
      label: 'Cornberg',
      provincie: 6,
      slug: 'cornberg',
    },
    {
      code: '066320006006',
      label: 'Friedewald',
      provincie: 6,
      slug: 'friedewald',
    },
    {
      code: '066320007007',
      label: 'Hauneck',
      provincie: 6,
      slug: 'hauneck',
    },
    {
      code: '066320008008',
      label: 'Haunetal',
      provincie: 6,
      slug: 'haunetal',
    },
    {
      code: '066320009009',
      label: 'Heringen (Werra)',
      provincie: 6,
      slug: 'heringen-werra',
    },
    {
      code: '066320010010',
      label: 'Hohenroda',
      provincie: 6,
      slug: 'hohenroda',
    },
    {
      code: '066320011011',
      label: 'Kirchheim',
      provincie: 6,
      slug: 'kirchheim',
    },
    {
      code: '066320012012',
      label: 'Ludwigsau',
      provincie: 6,
      slug: 'ludwigsau',
    },
    {
      code: '066320013013',
      label: 'Nentershausen',
      provincie: 6,
      slug: 'nentershausen',
    },
    {
      code: '066320014014',
      label: 'Neuenstein',
      provincie: 6,
      slug: 'neuenstein',
    },
    {
      code: '066320015015',
      label: 'Niederaula',
      provincie: 6,
      slug: 'niederaula',
    },
    {
      code: '066320016016',
      label: 'Philippsthal (Werra)',
      provincie: 6,
      slug: 'philippsthal-werra',
    },
    {
      code: '066320017017',
      label: 'Ronshausen',
      provincie: 6,
      slug: 'ronshausen',
    },
    {
      code: '066320018018',
      label: 'Rotenburg a.d.Fulda',
      provincie: 6,
      slug: 'rotenburg-a-d-fulda',
    },
    {
      code: '066320019019',
      label: 'Schenklengsfeld',
      provincie: 6,
      slug: 'schenklengsfeld',
    },
    {
      code: '066320020020',
      label: 'Wildeck',
      provincie: 6,
      slug: 'wildeck',
    },
    {
      code: '066330001001',
      label: 'Ahnatal',
      provincie: 6,
      slug: 'ahnatal',
    },
    {
      code: '066330002002',
      label: 'Bad Karlshafen',
      provincie: 6,
      slug: 'bad-karlshafen',
    },
    {
      code: '066330003003',
      label: 'Baunatal',
      provincie: 6,
      slug: 'baunatal',
    },
    {
      code: '066330004004',
      label: 'Breuna',
      provincie: 6,
      slug: 'breuna',
    },
    {
      code: '066330005005',
      label: 'Calden',
      provincie: 6,
      slug: 'calden',
    },
    {
      code: '066330006006',
      label: 'Bad Emstal',
      provincie: 6,
      slug: 'bad-emstal',
    },
    {
      code: '066330007007',
      label: 'Espenau',
      provincie: 6,
      slug: 'espenau',
    },
    {
      code: '066330008008',
      label: 'Fuldabrück',
      provincie: 6,
      slug: 'fuldabrueck',
    },
    {
      code: '066330009009',
      label: 'Fuldatal',
      provincie: 6,
      slug: 'fuldatal',
    },
    {
      code: '066330010010',
      label: 'Grebenstein',
      provincie: 6,
      slug: 'grebenstein',
    },
    {
      code: '066330011011',
      label: 'Habichtswald',
      provincie: 6,
      slug: 'habichtswald',
    },
    {
      code: '066330012012',
      label: 'Helsa',
      provincie: 6,
      slug: 'helsa',
    },
    {
      code: '066330013013',
      label: 'Hofgeismar',
      provincie: 6,
      slug: 'hofgeismar',
    },
    {
      code: '066330014014',
      label: 'Immenhausen',
      provincie: 6,
      slug: 'immenhausen',
    },
    {
      code: '066330015015',
      label: 'Kaufungen',
      provincie: 6,
      slug: 'kaufungen',
    },
    {
      code: '066330016016',
      label: 'Liebenau',
      provincie: 6,
      slug: 'liebenau-stadt',
    },
    {
      code: '066330017017',
      label: 'Lohfelden',
      provincie: 6,
      slug: 'lohfelden',
    },
    {
      code: '066330018018',
      label: 'Naumburg',
      provincie: 6,
      slug: 'naumburg',
    },
    {
      code: '066330019019',
      label: 'Nieste',
      provincie: 6,
      slug: 'nieste',
    },
    {
      code: '066330020020',
      label: 'Niestetal',
      provincie: 6,
      slug: 'niestetal',
    },
    {
      code: '066330022022',
      label: 'Reinhardshagen',
      provincie: 6,
      slug: 'reinhardshagen',
    },
    {
      code: '066330023023',
      label: 'Schauenburg',
      provincie: 6,
      slug: 'schauenburg',
    },
    {
      code: '066330024024',
      label: 'Söhrewald',
      provincie: 6,
      slug: 'soehrewald',
    },
    {
      code: '066330025025',
      label: 'Trendelburg',
      provincie: 6,
      slug: 'trendelburg',
    },
    {
      code: '066330026026',
      label: 'Vellmar',
      provincie: 6,
      slug: 'vellmar',
    },
    {
      code: '066330028028',
      label: 'Wolfhagen',
      provincie: 6,
      slug: 'wolfhagen',
    },
    {
      code: '066330029029',
      label: 'Zierenberg',
      provincie: 6,
      slug: 'zierenberg',
    },
    {
      code: '066330030030',
      label: 'Wesertal',
      provincie: 6,
      slug: 'wesertal',
    },
    {
      code: '066340001001',
      label: 'Borken (Hessen)',
      provincie: 6,
      slug: 'borken-hessen',
    },
    {
      code: '066340002002',
      label: 'Edermünde',
      provincie: 6,
      slug: 'edermuende',
    },
    {
      code: '066340003003',
      label: 'Felsberg',
      provincie: 6,
      slug: 'felsberg',
    },
    {
      code: '066340004004',
      label: 'Frielendorf',
      provincie: 6,
      slug: 'frielendorf',
    },
    {
      code: '066340005005',
      label: 'Fritzlar',
      provincie: 6,
      slug: 'fritzlar',
    },
    {
      code: '066340006006',
      label: 'Gilserberg',
      provincie: 6,
      slug: 'gilserberg',
    },
    {
      code: '066340007007',
      label: 'Gudensberg',
      provincie: 6,
      slug: 'gudensberg',
    },
    {
      code: '066340008008',
      label: 'Guxhagen',
      provincie: 6,
      slug: 'guxhagen',
    },
    {
      code: '066340009009',
      label: 'Homberg (Efze)',
      provincie: 6,
      slug: 'homberg-efze',
    },
    {
      code: '066340010010',
      label: 'Jesberg',
      provincie: 6,
      slug: 'jesberg',
    },
    {
      code: '066340011011',
      label: 'Knüllwald',
      provincie: 6,
      slug: 'knuellwald',
    },
    {
      code: '066340012012',
      label: 'Körle',
      provincie: 6,
      slug: 'koerle',
    },
    {
      code: '066340013013',
      label: 'Malsfeld',
      provincie: 6,
      slug: 'malsfeld',
    },
    {
      code: '066340014014',
      label: 'Melsungen',
      provincie: 6,
      slug: 'melsungen',
    },
    {
      code: '066340015015',
      label: 'Morschen',
      provincie: 6,
      slug: 'morschen',
    },
    {
      code: '066340016016',
      label: 'Neuental',
      provincie: 6,
      slug: 'neuental',
    },
    {
      code: '066340017017',
      label: 'Neukirchen',
      provincie: 6,
      slug: 'neukirchen-stadt',
    },
    {
      code: '066340018018',
      label: 'Niedenstein',
      provincie: 6,
      slug: 'niedenstein',
    },
    {
      code: '066340019019',
      label: 'Oberaula',
      provincie: 6,
      slug: 'oberaula',
    },
    {
      code: '066340020020',
      label: 'Ottrau',
      provincie: 6,
      slug: 'ottrau',
    },
    {
      code: '066340021021',
      label: 'Schrecksbach',
      provincie: 6,
      slug: 'schrecksbach',
    },
    {
      code: '066340022022',
      label: 'Schwalmstadt',
      provincie: 6,
      slug: 'schwalmstadt',
    },
    {
      code: '066340023023',
      label: 'Schwarzenborn',
      provincie: 6,
      slug: 'schwarzenborn',
    },
    {
      code: '066340024024',
      label: 'Spangenberg',
      provincie: 6,
      slug: 'spangenberg',
    },
    {
      code: '066340025025',
      label: 'Wabern',
      provincie: 6,
      slug: 'wabern',
    },
    {
      code: '066340026026',
      label: 'Willingshausen',
      provincie: 6,
      slug: 'willingshausen',
    },
    {
      code: '066340027027',
      label: 'Bad Zwesten',
      provincie: 6,
      slug: 'bad-zwesten',
    },
    {
      code: '066350001001',
      label: 'Allendorf (Eder)',
      provincie: 6,
      slug: 'allendorf-eder',
    },
    {
      code: '066350002002',
      label: 'Bad Arolsen',
      provincie: 6,
      slug: 'bad-arolsen',
    },
    {
      code: '066350003003',
      label: 'Bad Wildungen',
      provincie: 6,
      slug: 'bad-wildungen',
    },
    {
      code: '066350004004',
      label: 'Battenberg (Eder)',
      provincie: 6,
      slug: 'battenberg-eder',
    },
    {
      code: '066350006006',
      label: 'Burgwald',
      provincie: 6,
      slug: 'burgwald',
    },
    {
      code: '066350007007',
      label: 'Diemelsee',
      provincie: 6,
      slug: 'diemelsee',
    },
    {
      code: '066350008008',
      label: 'Diemelstadt',
      provincie: 6,
      slug: 'diemelstadt',
    },
    {
      code: '066350009009',
      label: 'Edertal',
      provincie: 6,
      slug: 'edertal',
    },
    {
      code: '066350010010',
      label: 'Frankenau',
      provincie: 6,
      slug: 'frankenau',
    },
    {
      code: '066350011011',
      label: 'Frankenberg (Eder)',
      provincie: 6,
      slug: 'frankenberg-eder',
    },
    {
      code: '066350012012',
      label: 'Gemünden (Wohra)',
      provincie: 6,
      slug: 'gemuenden-wohra',
    },
    {
      code: '066350013013',
      label: 'Haina (Kloster)',
      provincie: 6,
      slug: 'haina-kloster',
    },
    {
      code: '066350014014',
      label: 'Hatzfeld (Eder)',
      provincie: 6,
      slug: 'hatzfeld-eder',
    },
    {
      code: '066350015015',
      label: 'Korbach',
      provincie: 6,
      slug: 'korbach',
    },
    {
      code: '066350016016',
      label: 'Lichtenfels',
      provincie: 6,
      slug: 'lichtenfels',
    },
    {
      code: '066350017017',
      label: 'Rosenthal',
      provincie: 6,
      slug: 'rosenthal',
    },
    {
      code: '066350018018',
      label: 'Twistetal',
      provincie: 6,
      slug: 'twistetal',
    },
    {
      code: '066350019019',
      label: 'Vöhl',
      provincie: 6,
      slug: 'voehl',
    },
    {
      code: '066350020020',
      label: 'Volkmarsen',
      provincie: 6,
      slug: 'volkmarsen',
    },
    {
      code: '066350021021',
      label: 'Waldeck',
      provincie: 6,
      slug: 'waldeck',
    },
    {
      code: '066350022022',
      label: 'Willingen (Upland)',
      provincie: 6,
      slug: 'willingen-upland',
    },
    {
      code: '066360001001',
      label: 'Bad Sooden-Allendorf',
      provincie: 6,
      slug: 'bad-sooden-allendorf',
    },
    {
      code: '066360002002',
      label: 'Berkatal',
      provincie: 6,
      slug: 'berkatal',
    },
    {
      code: '066360003003',
      label: 'Eschwege',
      provincie: 6,
      slug: 'eschwege',
    },
    {
      code: '066360004004',
      label: 'Großalmerode',
      provincie: 6,
      slug: 'grossalmerode',
    },
    {
      code: '066360005005',
      label: 'Herleshausen',
      provincie: 6,
      slug: 'herleshausen',
    },
    {
      code: '066360006006',
      label: 'Hessisch Lichtenau',
      provincie: 6,
      slug: 'hessisch-lichtenau',
    },
    {
      code: '066360007007',
      label: 'Meinhard',
      provincie: 6,
      slug: 'meinhard',
    },
    {
      code: '066360008008',
      label: 'Meißner',
      provincie: 6,
      slug: 'meissner',
    },
    {
      code: '066360009009',
      label: 'Neu-Eichenberg',
      provincie: 6,
      slug: 'neu-eichenberg',
    },
    {
      code: '066360010010',
      label: 'Ringgau',
      provincie: 6,
      slug: 'ringgau',
    },
    {
      code: '066360011011',
      label: 'Sontra',
      provincie: 6,
      slug: 'sontra',
    },
    {
      code: '066360012012',
      label: 'Waldkappel',
      provincie: 6,
      slug: 'waldkappel',
    },
    {
      code: '066360013013',
      label: 'Wanfried',
      provincie: 6,
      slug: 'wanfried',
    },
    {
      code: '066360014014',
      label: 'Wehretal',
      provincie: 6,
      slug: 'wehretal',
    },
    {
      code: '066360015015',
      label: 'Weißenborn',
      provincie: 6,
      slug: 'weissenborn',
    },
    {
      code: '066360016016',
      label: 'Witzenhausen',
      provincie: 6,
      slug: 'witzenhausen',
    },
    {
      code: '071110000000',
      label: 'Koblenz',
      provincie: 7,
      slug: 'koblenz',
    },
    {
      code: '071310007007',
      label: 'Bad Neuenahr-Ahrweiler',
      provincie: 7,
      slug: 'bad-neuenahr-ahrweiler',
    },
    {
      code: '071310070070',
      label: 'Remagen',
      provincie: 7,
      slug: 'remagen',
    },
    {
      code: '071310077077',
      label: 'Sinzig',
      provincie: 7,
      slug: 'sinzig',
    },
    {
      code: '071310090090',
      label: 'Grafschaft',
      provincie: 7,
      slug: 'grafschaft',
    },
    {
      code: '071315001001',
      label: 'Adenau',
      provincie: 7,
      slug: 'adenau',
    },
    {
      code: '071315001004',
      label: 'Antweiler',
      provincie: 7,
      slug: 'antweiler',
    },
    {
      code: '071315001005',
      label: 'Aremberg',
      provincie: 7,
      slug: 'aremberg',
    },
    {
      code: '071315001008',
      label: 'Barweiler',
      provincie: 7,
      slug: 'barweiler',
    },
    {
      code: '071315001009',
      label: 'Bauler',
      provincie: 7,
      slug: 'bauler',
    },
    {
      code: '071315001015',
      label: 'Dankerath',
      provincie: 7,
      slug: 'dankerath',
    },
    {
      code: '071315001018',
      label: 'Dorsel',
      provincie: 7,
      slug: 'dorsel',
    },
    {
      code: '071315001021',
      label: 'Eichenbach',
      provincie: 7,
      slug: 'eichenbach',
    },
    {
      code: '071315001022',
      label: 'Fuchshofen',
      provincie: 7,
      slug: 'fuchshofen',
    },
    {
      code: '071315001026',
      label: 'Harscheid',
      provincie: 7,
      slug: 'harscheid',
    },
    {
      code: '071315001028',
      label: 'Herschbroich',
      provincie: 7,
      slug: 'herschbroich',
    },
    {
      code: '071315001030',
      label: 'Hoffeld',
      provincie: 7,
      slug: 'hoffeld-gemeinde',
    },
    {
      code: '071315001032',
      label: 'Honerath',
      provincie: 7,
      slug: 'honerath',
    },
    {
      code: '071315001033',
      label: 'Hümmel',
      provincie: 7,
      slug: 'huemmel',
    },
    {
      code: '071315001034',
      label: 'Insul',
      provincie: 7,
      slug: 'insul',
    },
    {
      code: '071315001037',
      label: 'Kaltenborn',
      provincie: 7,
      slug: 'kaltenborn',
    },
    {
      code: '071315001042',
      label: 'Kottenborn',
      provincie: 7,
      slug: 'kottenborn',
    },
    {
      code: '071315001044',
      label: 'Leimbach',
      provincie: 7,
      slug: 'leimbach',
    },
    {
      code: '071315001050',
      label: 'Meuspath',
      provincie: 7,
      slug: 'meuspath',
    },
    {
      code: '071315001051',
      label: 'Müllenbach',
      provincie: 7,
      slug: 'muellenbach',
    },
    {
      code: '071315001052',
      label: 'Müsch',
      provincie: 7,
      slug: 'muesch',
    },
    {
      code: '071315001058',
      label: 'Nürburg',
      provincie: 7,
      slug: 'nuerburg',
    },
    {
      code: '071315001062',
      label: 'Ohlenhard',
      provincie: 7,
      slug: 'ohlenhard',
    },
    {
      code: '071315001065',
      label: 'Pomster',
      provincie: 7,
      slug: 'pomster',
    },
    {
      code: '071315001066',
      label: 'Quiddelbach',
      provincie: 7,
      slug: 'quiddelbach',
    },
    {
      code: '071315001069',
      label: 'Reifferscheid',
      provincie: 7,
      slug: 'reifferscheid',
    },
    {
      code: '071315001072',
      label: 'Rodder',
      provincie: 7,
      slug: 'rodder',
    },
    {
      code: '071315001074',
      label: 'Schuld',
      provincie: 7,
      slug: 'schuld',
    },
    {
      code: '071315001075',
      label: 'Senscheid',
      provincie: 7,
      slug: 'senscheid',
    },
    {
      code: '071315001076',
      label: 'Sierscheid',
      provincie: 7,
      slug: 'sierscheid',
    },
    {
      code: '071315001079',
      label: 'Trierscheid',
      provincie: 7,
      slug: 'trierscheid',
    },
    {
      code: '071315001082',
      label: 'Wershofen',
      provincie: 7,
      slug: 'wershofen',
    },
    {
      code: '071315001083',
      label: 'Wiesemscheid',
      provincie: 7,
      slug: 'wiesemscheid',
    },
    {
      code: '071315001084',
      label: 'Wimbach',
      provincie: 7,
      slug: 'wimbach',
    },
    {
      code: '071315001085',
      label: 'Winnerath',
      provincie: 7,
      slug: 'winnerath',
    },
    {
      code: '071315001086',
      label: 'Wirft',
      provincie: 7,
      slug: 'wirft',
    },
    {
      code: '071315001501',
      label: 'Dümpelfeld',
      provincie: 7,
      slug: 'duempelfeld',
    },
    {
      code: '071315002002',
      label: 'Ahrbrück',
      provincie: 7,
      slug: 'ahrbrueck',
    },
    {
      code: '071315002003',
      label: 'Altenahr',
      provincie: 7,
      slug: 'altenahr',
    },
    {
      code: '071315002011',
      label: 'Berg',
      provincie: 7,
      slug: 'berg',
    },
    {
      code: '071315002017',
      label: 'Dernau',
      provincie: 7,
      slug: 'dernau',
    },
    {
      code: '071315002027',
      label: 'Heckenbach',
      provincie: 7,
      slug: 'heckenbach',
    },
    {
      code: '071315002029',
      label: 'Hönningen',
      provincie: 7,
      slug: 'hoenningen',
    },
    {
      code: '071315002036',
      label: 'Kalenborn',
      provincie: 7,
      slug: 'kalenborn',
    },
    {
      code: '071315002039',
      label: 'Kesseling',
      provincie: 7,
      slug: 'kesseling',
    },
    {
      code: '071315002040',
      label: 'Kirchsahr',
      provincie: 7,
      slug: 'kirchsahr',
    },
    {
      code: '071315002047',
      label: 'Lind',
      provincie: 7,
      slug: 'lind',
    },
    {
      code: '071315002049',
      label: 'Mayschoß',
      provincie: 7,
      slug: 'mayschoss',
    },
    {
      code: '071315002068',
      label: 'Rech',
      provincie: 7,
      slug: 'rech',
    },
    {
      code: '071315003006',
      label: 'Bad Breisig',
      provincie: 7,
      slug: 'bad-breisig',
    },
    {
      code: '071315003014',
      label: 'Brohl-Lützing',
      provincie: 7,
      slug: 'brohl-luetzing',
    },
    {
      code: '071315003025',
      label: 'Gönnersdorf',
      provincie: 7,
      slug: 'goennersdorf',
    },
    {
      code: '071315003081',
      label: 'Waldorf',
      provincie: 7,
      slug: 'waldorf',
    },
    {
      code: '071315004016',
      label: 'Dedenbach',
      provincie: 7,
      slug: 'dedenbach',
    },
    {
      code: '071315004041',
      label: 'Königsfeld',
      provincie: 7,
      slug: 'koenigsfeld',
    },
    {
      code: '071315004054',
      label: 'Niederdürenbach',
      provincie: 7,
      slug: 'niederduerenbach',
    },
    {
      code: '071315004055',
      label: 'Niederzissen',
      provincie: 7,
      slug: 'niederzissen',
    },
    {
      code: '071315004059',
      label: 'Oberdürenbach',
      provincie: 7,
      slug: 'oberduerenbach',
    },
    {
      code: '071315004060',
      label: 'Oberzissen',
      provincie: 7,
      slug: 'oberzissen',
    },
    {
      code: '071315004073',
      label: 'Schalkenbach',
      provincie: 7,
      slug: 'schalkenbach',
    },
    {
      code: '071315004201',
      label: 'Brenk',
      provincie: 7,
      slug: 'brenk',
    },
    {
      code: '071315004202',
      label: 'Burgbrohl',
      provincie: 7,
      slug: 'burgbrohl',
    },
    {
      code: '071315004204',
      label: 'Galenberg',
      provincie: 7,
      slug: 'galenberg',
    },
    {
      code: '071315004205',
      label: 'Glees',
      provincie: 7,
      slug: 'glees',
    },
    {
      code: '071315004206',
      label: 'Hohenleimbach',
      provincie: 7,
      slug: 'hohenleimbach',
    },
    {
      code: '071315004208',
      label: 'Spessart',
      provincie: 7,
      slug: 'spessart',
    },
    {
      code: '071315004209',
      label: 'Wassenach',
      provincie: 7,
      slug: 'wassenach',
    },
    {
      code: '071315004210',
      label: 'Wehr',
      provincie: 7,
      slug: 'wehr',
    },
    {
      code: '071315004211',
      label: 'Weibern',
      provincie: 7,
      slug: 'weibern',
    },
    {
      code: '071315004502',
      label: 'Kempenich',
      provincie: 7,
      slug: 'kempenich',
    },
    {
      code: '071325003018',
      label: 'Daaden',
      provincie: 7,
      slug: 'daaden',
    },
    {
      code: '071325003019',
      label: 'Derschen',
      provincie: 7,
      slug: 'derschen',
    },
    {
      code: '071325003026',
      label: 'Emmerzhausen',
      provincie: 7,
      slug: 'emmerzhausen',
    },
    {
      code: '071325003036',
      label: 'Friedewald',
      provincie: 7,
      slug: 'friedewald-gemeinde',
    },
    {
      code: '071325003050',
      label: 'Herdorf',
      provincie: 7,
      slug: 'herdorf',
    },
    {
      code: '071325003068',
      label: 'Mauden',
      provincie: 7,
      slug: 'mauden',
    },
    {
      code: '071325003075',
      label: 'Niederdreisbach',
      provincie: 7,
      slug: 'niederdreisbach',
    },
    {
      code: '071325003079',
      label: 'Nisterberg',
      provincie: 7,
      slug: 'nisterberg',
    },
    {
      code: '071325003101',
      label: 'Schutzbach',
      provincie: 7,
      slug: 'schutzbach',
    },
    {
      code: '071325003113',
      label: 'Weitefeld',
      provincie: 7,
      slug: 'weitefeld',
    },
    {
      code: '071325006007',
      label: 'Birkenbeul',
      provincie: 7,
      slug: 'birkenbeul',
    },
    {
      code: '071325006010',
      label: 'Bitzen',
      provincie: 7,
      slug: 'bitzen',
    },
    {
      code: '071325006013',
      label: 'Breitscheidt',
      provincie: 7,
      slug: 'breitscheidt',
    },
    {
      code: '071325006014',
      label: 'Bruchertseifen',
      provincie: 7,
      slug: 'bruchertseifen',
    },
    {
      code: '071325006028',
      label: 'Etzbach',
      provincie: 7,
      slug: 'etzbach',
    },
    {
      code: '071325006034',
      label: 'Forst',
      provincie: 7,
      slug: 'forst',
    },
    {
      code: '071325006038',
      label: 'Fürthen',
      provincie: 7,
      slug: 'fuerthen',
    },
    {
      code: '071325006044',
      label: 'Hamm (Sieg)',
      provincie: 7,
      slug: 'hamm-sieg',
    },
    {
      code: '071325006077',
      label: 'Niederirsen',
      provincie: 7,
      slug: 'niederirsen',
    },
    {
      code: '071325006091',
      label: 'Pracht',
      provincie: 7,
      slug: 'pracht',
    },
    {
      code: '071325006096',
      label: 'Roth',
      provincie: 7,
      slug: 'roth',
    },
    {
      code: '071325006102',
      label: 'Seelbach bei Hamm (Sieg)',
      provincie: 7,
      slug: 'seelbach-bei-hamm-sieg',
    },
    {
      code: '071325007012',
      label: 'Brachbach',
      provincie: 7,
      slug: 'brachbach',
    },
    {
      code: '071325007037',
      label: 'Friesenhagen',
      provincie: 7,
      slug: 'friesenhagen',
    },
    {
      code: '071325007045',
      label: 'Harbach',
      provincie: 7,
      slug: 'harbach',
    },
    {
      code: '071325007063',
      label: 'Kirchen (Sieg)',
      provincie: 7,
      slug: 'kirchen-sieg',
    },
    {
      code: '071325007072',
      label: 'Mudersbach',
      provincie: 7,
      slug: 'mudersbach',
    },
    {
      code: '071325007076',
      label: 'Niederfischbach',
      provincie: 7,
      slug: 'niederfischbach',
    },
    {
      code: '071325008008',
      label: 'Birken-Honigsessen',
      provincie: 7,
      slug: 'birken-honigsessen',
    },
    {
      code: '071325008011',
      label: 'Mittelhof',
      provincie: 7,
      slug: 'mittelhof',
    },
    {
      code: '071325008054',
      label: 'Hövels',
      provincie: 7,
      slug: 'hoevels',
    },
    {
      code: '071325008080',
      label: 'Katzwinkel (Sieg)',
      provincie: 7,
      slug: 'katzwinkel-sieg',
    },
    {
      code: '071325008105',
      label: 'Selbach (Sieg)',
      provincie: 7,
      slug: 'selbach-sieg',
    },
    {
      code: '071325008117',
      label: 'Wissen',
      provincie: 7,
      slug: 'wissen',
    },
    {
      code: '071325009002',
      label: 'Alsdorf',
      provincie: 7,
      slug: 'alsdorf-gemeinde',
    },
    {
      code: '071325009006',
      label: 'Betzdorf',
      provincie: 7,
      slug: 'betzdorf',
    },
    {
      code: '071325009020',
      label: 'Dickendorf',
      provincie: 7,
      slug: 'dickendorf',
    },
    {
      code: '071325009024',
      label: 'Elben',
      provincie: 7,
      slug: 'elben',
    },
    {
      code: '071325009025',
      label: 'Elkenroth',
      provincie: 7,
      slug: 'elkenroth',
    },
    {
      code: '071325009030',
      label: 'Fensdorf',
      provincie: 7,
      slug: 'fensdorf',
    },
    {
      code: '071325009039',
      label: 'Gebhardshain',
      provincie: 7,
      slug: 'gebhardshain',
    },
    {
      code: '071325009042',
      label: 'Grünebach',
      provincie: 7,
      slug: 'gruenebach',
    },
    {
      code: '071325009059',
      label: 'Kausen',
      provincie: 7,
      slug: 'kausen',
    },
    {
      code: '071325009066',
      label: 'Malberg',
      provincie: 7,
      slug: 'malberg',
    },
    {
      code: '071325009071',
      label: 'Molzhain',
      provincie: 7,
      slug: 'molzhain',
    },
    {
      code: '071325009073',
      label: 'Nauroth',
      provincie: 7,
      slug: 'nauroth',
    },
    {
      code: '071325009095',
      label: 'Rosenheim (Landkreis Altenkirchen)',
      provincie: 7,
      slug: 'rosenheim-landkreis-altenkirchen',
    },
    {
      code: '071325009098',
      label: 'Scheuerfeld',
      provincie: 7,
      slug: 'scheuerfeld',
    },
    {
      code: '071325009107',
      label: 'Steinebach/Sieg',
      provincie: 7,
      slug: 'steinebach-sieg',
    },
    {
      code: '071325009108',
      label: 'Steineroth',
      provincie: 7,
      slug: 'steineroth',
    },
    {
      code: '071325009111',
      label: 'Wallmenroth',
      provincie: 7,
      slug: 'wallmenroth',
    },
    {
      code: '071325010001',
      label: 'Almersbach',
      provincie: 7,
      slug: 'almersbach',
    },
    {
      code: '071325010004',
      label: 'Bachenberg',
      provincie: 7,
      slug: 'bachenberg',
    },
    {
      code: '071325010005',
      label: 'Berzhausen',
      provincie: 7,
      slug: 'berzhausen',
    },
    {
      code: '071325010009',
      label: 'Birnbach',
      provincie: 7,
      slug: 'birnbach',
    },
    {
      code: '071325010015',
      label: 'Bürdenbach',
      provincie: 7,
      slug: 'buerdenbach',
    },
    {
      code: '071325010016',
      label: 'Burglahr',
      provincie: 7,
      slug: 'burglahr',
    },
    {
      code: '071325010017',
      label: 'Busenhausen',
      provincie: 7,
      slug: 'busenhausen',
    },
    {
      code: '071325010022',
      label: 'Eichelhardt',
      provincie: 7,
      slug: 'eichelhardt',
    },
    {
      code: '071325010023',
      label: 'Eichen',
      provincie: 7,
      slug: 'eichen',
    },
    {
      code: '071325010027',
      label: 'Ersfeld',
      provincie: 7,
      slug: 'ersfeld',
    },
    {
      code: '071325010029',
      label: 'Eulenberg',
      provincie: 7,
      slug: 'eulenberg',
    },
    {
      code: '071325010031',
      label: 'Fiersbach',
      provincie: 7,
      slug: 'fiersbach',
    },
    {
      code: '071325010032',
      label: 'Flammersfeld',
      provincie: 7,
      slug: 'flammersfeld',
    },
    {
      code: '071325010033',
      label: 'Fluterschen',
      provincie: 7,
      slug: 'fluterschen',
    },
    {
      code: '071325010035',
      label: 'Forstmehren',
      provincie: 7,
      slug: 'forstmehren',
    },
    {
      code: '071325010040',
      label: 'Gieleroth',
      provincie: 7,
      slug: 'gieleroth',
    },
    {
      code: '071325010041',
      label: 'Giershausen',
      provincie: 7,
      slug: 'giershausen',
    },
    {
      code: '071325010043',
      label: 'Güllesheim',
      provincie: 7,
      slug: 'guellesheim',
    },
    {
      code: '071325010046',
      label: 'Hasselbach',
      provincie: 7,
      slug: 'hasselbach',
    },
    {
      code: '071325010047',
      label: 'Helmenzen',
      provincie: 7,
      slug: 'helmenzen',
    },
    {
      code: '071325010048',
      label: 'Helmeroth',
      provincie: 7,
      slug: 'helmeroth',
    },
    {
      code: '071325010049',
      label: 'Hemmelzen',
      provincie: 7,
      slug: 'hemmelzen',
    },
    {
      code: '071325010051',
      label: 'Heupelzen',
      provincie: 7,
      slug: 'heupelzen',
    },
    {
      code: '071325010052',
      label: 'Hilgenroth',
      provincie: 7,
      slug: 'hilgenroth',
    },
    {
      code: '071325010053',
      label: 'Hirz-Maulsbach',
      provincie: 7,
      slug: 'hirz-maulsbach',
    },
    {
      code: '071325010055',
      label: 'Horhausen (Westerwald)',
      provincie: 7,
      slug: 'horhausen-westerwald',
    },
    {
      code: '071325010056',
      label: 'Idelberg',
      provincie: 7,
      slug: 'idelberg',
    },
    {
      code: '071325010057',
      label: 'Ingelbach',
      provincie: 7,
      slug: 'ingelbach',
    },
    {
      code: '071325010058',
      label: 'Isert',
      provincie: 7,
      slug: 'isert',
    },
    {
      code: '071325010060',
      label: 'Kescheid',
      provincie: 7,
      slug: 'kescheid',
    },
    {
      code: '071325010061',
      label: 'Kettenhausen',
      provincie: 7,
      slug: 'kettenhausen',
    },
    {
      code: '071325010062',
      label: 'Kircheib',
      provincie: 7,
      slug: 'kircheib',
    },
    {
      code: '071325010064',
      label: 'Kraam',
      provincie: 7,
      slug: 'kraam',
    },
    {
      code: '071325010065',
      label: 'Krunkel',
      provincie: 7,
      slug: 'krunkel',
    },
    {
      code: '071325010067',
      label: 'Mammelzen',
      provincie: 7,
      slug: 'mammelzen',
    },
    {
      code: '071325010069',
      label: 'Mehren',
      provincie: 7,
      slug: 'mehren',
    },
    {
      code: '071325010070',
      label: 'Michelbach (Westerwald)',
      provincie: 7,
      slug: 'michelbach-westerwald',
    },
    {
      code: '071325010078',
      label: 'Niedersteinebach',
      provincie: 7,
      slug: 'niedersteinebach',
    },
    {
      code: '071325010081',
      label: 'Obererbach (Westerwald)',
      provincie: 7,
      slug: 'obererbach-westerwald',
    },
    {
      code: '071325010082',
      label: 'Oberirsen',
      provincie: 7,
      slug: 'oberirsen',
    },
    {
      code: '071325010083',
      label: 'Oberlahr',
      provincie: 7,
      slug: 'oberlahr',
    },
    {
      code: '071325010085',
      label: 'Obersteinebach',
      provincie: 7,
      slug: 'obersteinebach',
    },
    {
      code: '071325010086',
      label: 'Oberwambach',
      provincie: 7,
      slug: 'oberwambach',
    },
    {
      code: '071325010087',
      label: 'Ölsen',
      provincie: 7,
      slug: 'oelsen',
    },
    {
      code: '071325010088',
      label: 'Orfgen',
      provincie: 7,
      slug: 'orfgen',
    },
    {
      code: '071325010089',
      label: 'Peterslahr',
      provincie: 7,
      slug: 'peterslahr',
    },
    {
      code: '071325010090',
      label: 'Pleckhausen',
      provincie: 7,
      slug: 'pleckhausen',
    },
    {
      code: '071325010092',
      label: 'Racksen',
      provincie: 7,
      slug: 'racksen',
    },
    {
      code: '071325010093',
      label: 'Reiferscheid',
      provincie: 7,
      slug: 'reiferscheid',
    },
    {
      code: '071325010094',
      label: 'Rettersen',
      provincie: 7,
      slug: 'rettersen',
    },
    {
      code: '071325010097',
      label: 'Rott',
      provincie: 7,
      slug: 'rott',
    },
    {
      code: '071325010099',
      label: 'Schöneberg',
      provincie: 7,
      slug: 'schoeneberg',
    },
    {
      code: '071325010100',
      label: 'Schürdt',
      provincie: 7,
      slug: 'schuerdt',
    },
    {
      code: '071325010103',
      label: 'Seelbach (Westerwald)',
      provincie: 7,
      slug: 'seelbach-westerwald',
    },
    {
      code: '071325010104',
      label: 'Seifen',
      provincie: 7,
      slug: 'seifen',
    },
    {
      code: '071325010106',
      label: 'Sörth',
      provincie: 7,
      slug: 'soerth',
    },
    {
      code: '071325010109',
      label: 'Stürzelbach',
      provincie: 7,
      slug: 'stuerzelbach',
    },
    {
      code: '071325010110',
      label: 'Volkerzen',
      provincie: 7,
      slug: 'volkerzen',
    },
    {
      code: '071325010112',
      label: 'Walterschen',
      provincie: 7,
      slug: 'walterschen',
    },
    {
      code: '071325010114',
      label: 'Werkhausen',
      provincie: 7,
      slug: 'werkhausen',
    },
    {
      code: '071325010115',
      label: 'Weyerbusch',
      provincie: 7,
      slug: 'weyerbusch',
    },
    {
      code: '071325010116',
      label: 'Willroth',
      provincie: 7,
      slug: 'willroth',
    },
    {
      code: '071325010118',
      label: 'Wölmersen',
      provincie: 7,
      slug: 'woelmersen',
    },
    {
      code: '071325010119',
      label: 'Ziegenhain',
      provincie: 7,
      slug: 'ziegenhain',
    },
    {
      code: '071325010201',
      label: 'Berod bei Hachenburg',
      provincie: 7,
      slug: 'berod-bei-hachenburg',
    },
    {
      code: '071325010501',
      label: 'Altenkirchen (Westerwald)',
      provincie: 7,
      slug: 'altenkirchen-westerwald',
    },
    {
      code: '071325010502',
      label: 'Neitersen',
      provincie: 7,
      slug: 'neitersen',
    },
    {
      code: '071330006006',
      label: 'Bad Kreuznach',
      provincie: 7,
      slug: 'bad-kreuznach',
    },
    {
      code: '071335001003',
      label: 'Altenbamberg',
      provincie: 7,
      slug: 'altenbamberg',
    },
    {
      code: '071335001012',
      label: 'Biebelsheim',
      provincie: 7,
      slug: 'biebelsheim',
    },
    {
      code: '071335001030',
      label: 'Feilbingert',
      provincie: 7,
      slug: 'feilbingert',
    },
    {
      code: '071335001031',
      label: 'Frei-Laubersheim',
      provincie: 7,
      slug: 'frei-laubersheim',
    },
    {
      code: '071335001032',
      label: 'Fürfeld',
      provincie: 7,
      slug: 'fuerfeld',
    },
    {
      code: '071335001037',
      label: 'Hackenheim',
      provincie: 7,
      slug: 'hackenheim',
    },
    {
      code: '071335001039',
      label: 'Hallgarten',
      provincie: 7,
      slug: 'hallgarten',
    },
    {
      code: '071335001045',
      label: 'Hochstätten',
      provincie: 7,
      slug: 'hochstaetten',
    },
    {
      code: '071335001069',
      label: 'Neu-Bamberg',
      provincie: 7,
      slug: 'neu-bamberg',
    },
    {
      code: '071335001078',
      label: 'Pfaffen-Schwabenheim',
      provincie: 7,
      slug: 'pfaffen-schwabenheim',
    },
    {
      code: '071335001080',
      label: 'Pleitersheim',
      provincie: 7,
      slug: 'pleitersheim',
    },
    {
      code: '071335001104',
      label: 'Tiefenthal',
      provincie: 7,
      slug: 'tiefenthal',
    },
    {
      code: '071335001106',
      label: 'Volxheim',
      provincie: 7,
      slug: 'volxheim',
    },
    {
      code: '071335006002',
      label: 'Allenfeld',
      provincie: 7,
      slug: 'allenfeld',
    },
    {
      code: '071335006004',
      label: 'Argenschwang',
      provincie: 7,
      slug: 'argenschwang',
    },
    {
      code: '071335006013',
      label: 'Bockenau',
      provincie: 7,
      slug: 'bockenau',
    },
    {
      code: '071335006014',
      label: 'Boos',
      provincie: 7,
      slug: 'boos',
    },
    {
      code: '071335006015',
      label: 'Braunweiler',
      provincie: 7,
      slug: 'braunweiler',
    },
    {
      code: '071335006019',
      label: 'Burgsponheim',
      provincie: 7,
      slug: 'burgsponheim',
    },
    {
      code: '071335006021',
      label: 'Dalberg',
      provincie: 7,
      slug: 'dalberg',
    },
    {
      code: '071335006027',
      label: 'Duchroth',
      provincie: 7,
      slug: 'duchroth',
    },
    {
      code: '071335006033',
      label: 'Gebroth',
      provincie: 7,
      slug: 'gebroth',
    },
    {
      code: '071335006036',
      label: 'Gutenberg',
      provincie: 7,
      slug: 'gutenberg',
    },
    {
      code: '071335006040',
      label: 'Hargesheim',
      provincie: 7,
      slug: 'hargesheim',
    },
    {
      code: '071335006044',
      label: 'Hergenfeld',
      provincie: 7,
      slug: 'hergenfeld',
    },
    {
      code: '071335006048',
      label: 'Hüffelsheim',
      provincie: 7,
      slug: 'hueffelsheim',
    },
    {
      code: '071335006061',
      label: 'Mandel',
      provincie: 7,
      slug: 'mandel',
    },
    {
      code: '071335006068',
      label: 'Münchwald',
      provincie: 7,
      slug: 'muenchwald',
    },
    {
      code: '071335006070',
      label: 'Niederhausen',
      provincie: 7,
      slug: 'niederhausen',
    },
    {
      code: '071335006071',
      label: 'Norheim',
      provincie: 7,
      slug: 'norheim',
    },
    {
      code: '071335006074',
      label: 'Oberhausen an der Nahe',
      provincie: 7,
      slug: 'oberhausen-an-der-nahe',
    },
    {
      code: '071335006075',
      label: 'Oberstreit',
      provincie: 7,
      slug: 'oberstreit',
    },
    {
      code: '071335006086',
      label: 'Roxheim',
      provincie: 7,
      slug: 'roxheim',
    },
    {
      code: '071335006088',
      label: 'Sankt Katharinen',
      provincie: 7,
      slug: 'sankt-katharinen',
    },
    {
      code: '071335006089',
      label: 'Schloßböckelheim',
      provincie: 7,
      slug: 'schlossboeckelheim',
    },
    {
      code: '071335006098',
      label: 'Sommerloch',
      provincie: 7,
      slug: 'sommerloch',
    },
    {
      code: '071335006099',
      label: 'Spabrücken',
      provincie: 7,
      slug: 'spabruecken',
    },
    {
      code: '071335006100',
      label: 'Spall',
      provincie: 7,
      slug: 'spall',
    },
    {
      code: '071335006101',
      label: 'Sponheim',
      provincie: 7,
      slug: 'sponheim',
    },
    {
      code: '071335006105',
      label: 'Traisen',
      provincie: 7,
      slug: 'traisen',
    },
    {
      code: '071335006107',
      label: 'Waldböckelheim',
      provincie: 7,
      slug: 'waldboeckelheim',
    },
    {
      code: '071335006109',
      label: 'Wallhausen',
      provincie: 7,
      slug: 'wallhausen',
    },
    {
      code: '071335006112',
      label: 'Weinsheim',
      provincie: 7,
      slug: 'weinsheim',
    },
    {
      code: '071335006115',
      label: 'Winterbach',
      provincie: 7,
      slug: 'winterbach',
    },
    {
      code: '071335006117',
      label: 'Rüdesheim',
      provincie: 7,
      slug: 'ruedesheim',
    },
    {
      code: '071335009008',
      label: 'Bärenbach',
      provincie: 7,
      slug: 'baerenbach',
    },
    {
      code: '071335009010',
      label: 'Becherbach bei Kirn',
      provincie: 7,
      slug: 'becherbach-bei-kirn',
    },
    {
      code: '071335009016',
      label: 'Brauweiler',
      provincie: 7,
      slug: 'brauweiler',
    },
    {
      code: '071335009038',
      label: 'Hahnenbach',
      provincie: 7,
      slug: 'hahnenbach',
    },
    {
      code: '071335009041',
      label: 'Heimweiler',
      provincie: 7,
      slug: 'heimweiler',
    },
    {
      code: '071335009042',
      label: 'Heinzenberg',
      provincie: 7,
      slug: 'heinzenberg',
    },
    {
      code: '071335009043',
      label: 'Hennweiler',
      provincie: 7,
      slug: 'hennweiler',
    },
    {
      code: '071335009046',
      label: 'Hochstetten-Dhaun',
      provincie: 7,
      slug: 'hochstetten-dhaun',
    },
    {
      code: '071335009047',
      label: 'Horbach',
      provincie: 7,
      slug: 'horbach',
    },
    {
      code: '071335009052',
      label: 'Kirn',
      provincie: 7,
      slug: 'kirn',
    },
    {
      code: '071335009059',
      label: 'Limbach',
      provincie: 7,
      slug: 'limbach',
    },
    {
      code: '071335009063',
      label: 'Meckenbach',
      provincie: 7,
      slug: 'meckenbach',
    },
    {
      code: '071335009073',
      label: 'Oberhausen bei Kirn',
      provincie: 7,
      slug: 'oberhausen-bei-kirn',
    },
    {
      code: '071335009077',
      label: 'Otzweiler',
      provincie: 7,
      slug: 'otzweiler',
    },
    {
      code: '071335009096',
      label: 'Simmertal',
      provincie: 7,
      slug: 'simmertal',
    },
    {
      code: '071335009113',
      label: 'Weitersborn',
      provincie: 7,
      slug: 'weitersborn',
    },
    {
      code: '071335009201',
      label: 'Bruschied',
      provincie: 7,
      slug: 'bruschied',
    },
    {
      code: '071335009202',
      label: 'Kellenbach',
      provincie: 7,
      slug: 'kellenbach',
    },
    {
      code: '071335009203',
      label: 'Königsau',
      provincie: 7,
      slug: 'koenigsau',
    },
    {
      code: '071335009204',
      label: 'Schneppenbach',
      provincie: 7,
      slug: 'schneppenbach',
    },
    {
      code: '071335009205',
      label: 'Schwarzerden',
      provincie: 7,
      slug: 'schwarzerden',
    },
    {
      code: '071335010001',
      label: 'Abtweiler',
      provincie: 7,
      slug: 'abtweiler',
    },
    {
      code: '071335010005',
      label: 'Auen',
      provincie: 7,
      slug: 'auen',
    },
    {
      code: '071335010009',
      label: 'Bärweiler',
      provincie: 7,
      slug: 'baerweiler',
    },
    {
      code: '071335010011',
      label: 'Becherbach',
      provincie: 7,
      slug: 'becherbach',
    },
    {
      code: '071335010017',
      label: 'Breitenheim',
      provincie: 7,
      slug: 'breitenheim',
    },
    {
      code: '071335010020',
      label: 'Callbach',
      provincie: 7,
      slug: 'callbach',
    },
    {
      code: '071335010022',
      label: 'Daubach',
      provincie: 7,
      slug: 'daubach',
    },
    {
      code: '071335010024',
      label: 'Desloch',
      provincie: 7,
      slug: 'desloch',
    },
    {
      code: '071335010049',
      label: 'Hundsbach',
      provincie: 7,
      slug: 'hundsbach',
    },
    {
      code: '071335010050',
      label: 'Ippenschied',
      provincie: 7,
      slug: 'ippenschied',
    },
    {
      code: '071335010051',
      label: 'Jeckenbach',
      provincie: 7,
      slug: 'jeckenbach',
    },
    {
      code: '071335010053',
      label: 'Kirschroth',
      provincie: 7,
      slug: 'kirschroth',
    },
    {
      code: '071335010055',
      label: 'Langenthal',
      provincie: 7,
      slug: 'langenthal',
    },
    {
      code: '071335010057',
      label: 'Lauschied',
      provincie: 7,
      slug: 'lauschied',
    },
    {
      code: '071335010058',
      label: 'Lettweiler',
      provincie: 7,
      slug: 'lettweiler',
    },
    {
      code: '071335010060',
      label: 'Löllbach',
      provincie: 7,
      slug: 'loellbach',
    },
    {
      code: '071335010062',
      label: 'Martinstein',
      provincie: 7,
      slug: 'martinstein',
    },
    {
      code: '071335010064',
      label: 'Meddersheim',
      provincie: 7,
      slug: 'meddersheim',
    },
    {
      code: '071335010065',
      label: 'Meisenheim',
      provincie: 7,
      slug: 'meisenheim',
    },
    {
      code: '071335010066',
      label: 'Merxheim',
      provincie: 7,
      slug: 'merxheim',
    },
    {
      code: '071335010067',
      label: 'Monzingen',
      provincie: 7,
      slug: 'monzingen',
    },
    {
      code: '071335010072',
      label: 'Nußbaum',
      provincie: 7,
      slug: 'nussbaum',
    },
    {
      code: '071335010076',
      label: 'Odernheim am Glan',
      provincie: 7,
      slug: 'odernheim-am-glan',
    },
    {
      code: '071335010081',
      label: 'Raumbach',
      provincie: 7,
      slug: 'raumbach',
    },
    {
      code: '071335010082',
      label: 'Rehbach',
      provincie: 7,
      slug: 'rehbach',
    },
    {
      code: '071335010083',
      label: 'Rehborn',
      provincie: 7,
      slug: 'rehborn',
    },
    {
      code: '071335010084',
      label: 'Reiffelbach',
      provincie: 7,
      slug: 'reiffelbach',
    },
    {
      code: '071335010090',
      label: 'Schmittweiler',
      provincie: 7,
      slug: 'schmittweiler',
    },
    {
      code: '071335010092',
      label: 'Schweinschied',
      provincie: 7,
      slug: 'schweinschied',
    },
    {
      code: '071335010094',
      label: 'Seesbach',
      provincie: 7,
      slug: 'seesbach',
    },
    {
      code: '071335010102',
      label: 'Staudernheim',
      provincie: 7,
      slug: 'staudernheim',
    },
    {
      code: '071335010111',
      label: 'Weiler bei Monzingen',
      provincie: 7,
      slug: 'weiler-bei-monzingen',
    },
    {
      code: '071335010116',
      label: 'Winterburg',
      provincie: 7,
      slug: 'winterburg',
    },
    {
      code: '071335010501',
      label: 'Bad Sobernheim',
      provincie: 7,
      slug: 'bad-sobernheim',
    },
    {
      code: '071335011018',
      label: 'Bretzenheim',
      provincie: 7,
      slug: 'bretzenheim',
    },
    {
      code: '071335011023',
      label: 'Daxweiler',
      provincie: 7,
      slug: 'daxweiler',
    },
    {
      code: '071335011025',
      label: 'Dörrebach',
      provincie: 7,
      slug: 'doerrebach',
    },
    {
      code: '071335011026',
      label: 'Dorsheim',
      provincie: 7,
      slug: 'dorsheim',
    },
    {
      code: '071335011028',
      label: 'Eckenroth',
      provincie: 7,
      slug: 'eckenroth',
    },
    {
      code: '071335011035',
      label: 'Guldental',
      provincie: 7,
      slug: 'guldental',
    },
    {
      code: '071335011054',
      label: 'Langenlonsheim',
      provincie: 7,
      slug: 'langenlonsheim',
    },
    {
      code: '071335011056',
      label: 'Laubenheim',
      provincie: 7,
      slug: 'laubenheim',
    },
    {
      code: '071335011085',
      label: 'Roth',
      provincie: 7,
      slug: 'roth-gemeinde',
    },
    {
      code: '071335011087',
      label: 'Rümmelsheim',
      provincie: 7,
      slug: 'ruemmelsheim',
    },
    {
      code: '071335011091',
      label: 'Schöneberg',
      provincie: 7,
      slug: 'schoeneberg-gemeinde',
    },
    {
      code: '071335011093',
      label: 'Schweppenhausen',
      provincie: 7,
      slug: 'schweppenhausen',
    },
    {
      code: '071335011095',
      label: 'Seibersbach',
      provincie: 7,
      slug: 'seibersbach',
    },
    {
      code: '071335011103',
      label: 'Stromberg',
      provincie: 7,
      slug: 'stromberg',
    },
    {
      code: '071335011108',
      label: 'Waldlaubersheim',
      provincie: 7,
      slug: 'waldlaubersheim',
    },
    {
      code: '071335011110',
      label: 'Warmsroth',
      provincie: 7,
      slug: 'warmsroth',
    },
    {
      code: '071335011114',
      label: 'Windesheim',
      provincie: 7,
      slug: 'windesheim',
    },
    {
      code: '071340045045',
      label: 'Idar-Oberstein',
      provincie: 7,
      slug: 'idar-oberstein',
    },
    {
      code: '071345001005',
      label: 'Baumholder',
      provincie: 7,
      slug: 'baumholder',
    },
    {
      code: '071345001007',
      label: 'Berglangenbach',
      provincie: 7,
      slug: 'berglangenbach',
    },
    {
      code: '071345001008',
      label: 'Berschweiler bei Baumholder',
      provincie: 7,
      slug: 'berschweiler-bei-baumholder',
    },
    {
      code: '071345001021',
      label: 'Eckersweiler',
      provincie: 7,
      slug: 'eckersweiler',
    },
    {
      code: '071345001026',
      label: 'Fohren-Linden',
      provincie: 7,
      slug: 'fohren-linden',
    },
    {
      code: '071345001027',
      label: 'Frauenberg',
      provincie: 7,
      slug: 'frauenberg',
    },
    {
      code: '071345001033',
      label: 'Hahnweiler',
      provincie: 7,
      slug: 'hahnweiler',
    },
    {
      code: '071345001036',
      label: 'Heimbach',
      provincie: 7,
      slug: 'heimbach-gemeinde',
    },
    {
      code: '071345001051',
      label: 'Leitzweiler',
      provincie: 7,
      slug: 'leitzweiler',
    },
    {
      code: '071345001054',
      label: 'Mettweiler',
      provincie: 7,
      slug: 'mettweiler',
    },
    {
      code: '071345001068',
      label: 'Reichenbach',
      provincie: 7,
      slug: 'reichenbach',
    },
    {
      code: '071345001073',
      label: 'Rohrbach',
      provincie: 7,
      slug: 'rohrbach',
    },
    {
      code: '071345001074',
      label: 'Rückweiler',
      provincie: 7,
      slug: 'rueckweiler',
    },
    {
      code: '071345001075',
      label: 'Ruschberg',
      provincie: 7,
      slug: 'ruschberg',
    },
    {
      code: '071345002001',
      label: 'Abentheuer',
      provincie: 7,
      slug: 'abentheuer',
    },
    {
      code: '071345002002',
      label: 'Achtelsbach',
      provincie: 7,
      slug: 'achtelsbach',
    },
    {
      code: '071345002010',
      label: 'Birkenfeld',
      provincie: 7,
      slug: 'birkenfeld',
    },
    {
      code: '071345002011',
      label: 'Börfink',
      provincie: 7,
      slug: 'boerfink',
    },
    {
      code: '071345002015',
      label: 'Brücken',
      provincie: 7,
      slug: 'bruecken',
    },
    {
      code: '071345002016',
      label: 'Buhlenberg',
      provincie: 7,
      slug: 'buhlenberg',
    },
    {
      code: '071345002018',
      label: 'Dambach',
      provincie: 7,
      slug: 'dambach',
    },
    {
      code: '071345002020',
      label: 'Dienstweiler',
      provincie: 7,
      slug: 'dienstweiler',
    },
    {
      code: '071345002022',
      label: 'Elchweiler',
      provincie: 7,
      slug: 'elchweiler',
    },
    {
      code: '071345002023',
      label: 'Ellenberg',
      provincie: 7,
      slug: 'ellenberg',
    },
    {
      code: '071345002024',
      label: 'Ellweiler',
      provincie: 7,
      slug: 'ellweiler',
    },
    {
      code: '071345002029',
      label: 'Gimbweiler',
      provincie: 7,
      slug: 'gimbweiler',
    },
    {
      code: '071345002031',
      label: 'Gollenberg',
      provincie: 7,
      slug: 'gollenberg',
    },
    {
      code: '071345002034',
      label: 'Hattgenstein',
      provincie: 7,
      slug: 'hattgenstein',
    },
    {
      code: '071345002042',
      label: 'Hoppstädten-Weiersbach',
      provincie: 7,
      slug: 'hoppstaedten-weiersbach',
    },
    {
      code: '071345002048',
      label: 'Kronweiler',
      provincie: 7,
      slug: 'kronweiler',
    },
    {
      code: '071345002050',
      label: 'Leisel',
      provincie: 7,
      slug: 'leisel',
    },
    {
      code: '071345002053',
      label: 'Meckenbach',
      provincie: 7,
      slug: 'meckenbach-gemeinde',
    },
    {
      code: '071345002057',
      label: 'Niederbrombach',
      provincie: 7,
      slug: 'niederbrombach',
    },
    {
      code: '071345002058',
      label: 'Niederhambach',
      provincie: 7,
      slug: 'niederhambach',
    },
    {
      code: '071345002061',
      label: 'Nohen',
      provincie: 7,
      slug: 'nohen',
    },
    {
      code: '071345002062',
      label: 'Oberbrombach',
      provincie: 7,
      slug: 'oberbrombach',
    },
    {
      code: '071345002063',
      label: 'Oberhambach',
      provincie: 7,
      slug: 'oberhambach',
    },
    {
      code: '071345002070',
      label: 'Rimsberg',
      provincie: 7,
      slug: 'rimsberg',
    },
    {
      code: '071345002071',
      label: 'Rinzenberg',
      provincie: 7,
      slug: 'rinzenberg',
    },
    {
      code: '071345002072',
      label: 'Rötsweiler-Nockenthal',
      provincie: 7,
      slug: 'roetsweiler-nockenthal',
    },
    {
      code: '071345002078',
      label: 'Schmißberg',
      provincie: 7,
      slug: 'schmissberg',
    },
    {
      code: '071345002080',
      label: 'Schwollen',
      provincie: 7,
      slug: 'schwollen',
    },
    {
      code: '071345002084',
      label: 'Siesbach',
      provincie: 7,
      slug: 'siesbach',
    },
    {
      code: '071345002085',
      label: 'Sonnenberg-Winnenberg',
      provincie: 7,
      slug: 'sonnenberg-winnenberg',
    },
    {
      code: '071345002094',
      label: 'Wilzenberg-Hußweiler',
      provincie: 7,
      slug: 'wilzenberg-hussweiler',
    },
    {
      code: '071345005003',
      label: 'Allenbach',
      provincie: 7,
      slug: 'allenbach',
    },
    {
      code: '071345005004',
      label: 'Asbach',
      provincie: 7,
      slug: 'asbach',
    },
    {
      code: '071345005006',
      label: 'Bergen',
      provincie: 7,
      slug: 'bergen-gemeinde',
    },
    {
      code: '071345005009',
      label: 'Berschweiler bei Kirn',
      provincie: 7,
      slug: 'berschweiler-bei-kirn',
    },
    {
      code: '071345005012',
      label: 'Bollenbach',
      provincie: 7,
      slug: 'bollenbach',
    },
    {
      code: '071345005013',
      label: 'Breitenthal',
      provincie: 7,
      slug: 'breitenthal',
    },
    {
      code: '071345005014',
      label: 'Bruchweiler',
      provincie: 7,
      slug: 'bruchweiler',
    },
    {
      code: '071345005017',
      label: 'Bundenbach',
      provincie: 7,
      slug: 'bundenbach',
    },
    {
      code: '071345005019',
      label: 'Dickesbach',
      provincie: 7,
      slug: 'dickesbach',
    },
    {
      code: '071345005025',
      label: 'Fischbach',
      provincie: 7,
      slug: 'fischbach',
    },
    {
      code: '071345005028',
      label: 'Gerach',
      provincie: 7,
      slug: 'gerach',
    },
    {
      code: '071345005030',
      label: 'Gösenroth',
      provincie: 7,
      slug: 'goesenroth',
    },
    {
      code: '071345005032',
      label: 'Griebelschied',
      provincie: 7,
      slug: 'griebelschied',
    },
    {
      code: '071345005035',
      label: 'Hausen',
      provincie: 7,
      slug: 'hausen',
    },
    {
      code: '071345005037',
      label: 'Hellertshausen',
      provincie: 7,
      slug: 'hellertshausen',
    },
    {
      code: '071345005038',
      label: 'Herborn',
      provincie: 7,
      slug: 'herborn-gemeinde',
    },
    {
      code: '071345005039',
      label: 'Herrstein',
      provincie: 7,
      slug: 'herrstein',
    },
    {
      code: '071345005040',
      label: 'Hettenrodt',
      provincie: 7,
      slug: 'hettenrodt',
    },
    {
      code: '071345005041',
      label: 'Hintertiefenbach',
      provincie: 7,
      slug: 'hintertiefenbach',
    },
    {
      code: '071345005043',
      label: 'Horbruch',
      provincie: 7,
      slug: 'horbruch',
    },
    {
      code: '071345005044',
      label: 'Hottenbach',
      provincie: 7,
      slug: 'hottenbach',
    },
    {
      code: '071345005046',
      label: 'Kempfeld',
      provincie: 7,
      slug: 'kempfeld',
    },
    {
      code: '071345005047',
      label: 'Kirschweiler',
      provincie: 7,
      slug: 'kirschweiler',
    },
    {
      code: '071345005049',
      label: 'Krummenau',
      provincie: 7,
      slug: 'krummenau',
    },
    {
      code: '071345005052',
      label: 'Mackenrodt',
      provincie: 7,
      slug: 'mackenrodt',
    },
    {
      code: '071345005055',
      label: 'Mittelreidenbach',
      provincie: 7,
      slug: 'mittelreidenbach',
    },
    {
      code: '071345005056',
      label: 'Mörschied',
      provincie: 7,
      slug: 'moerschied',
    },
    {
      code: '071345005059',
      label: 'Niederhosenbach',
      provincie: 7,
      slug: 'niederhosenbach',
    },
    {
      code: '071345005060',
      label: 'Niederwörresbach',
      provincie: 7,
      slug: 'niederwoerresbach',
    },
    {
      code: '071345005064',
      label: 'Oberhosenbach',
      provincie: 7,
      slug: 'oberhosenbach',
    },
    {
      code: '071345005065',
      label: 'Oberkirn',
      provincie: 7,
      slug: 'oberkirn',
    },
    {
      code: '071345005066',
      label: 'Oberreidenbach',
      provincie: 7,
      slug: 'oberreidenbach',
    },
    {
      code: '071345005067',
      label: 'Oberwörresbach',
      provincie: 7,
      slug: 'oberwoerresbach',
    },
    {
      code: '071345005069',
      label: 'Rhaunen',
      provincie: 7,
      slug: 'rhaunen',
    },
    {
      code: '071345005076',
      label: 'Schauren',
      provincie: 7,
      slug: 'schauren',
    },
    {
      code: '071345005077',
      label: 'Schmidthachenbach',
      provincie: 7,
      slug: 'schmidthachenbach',
    },
    {
      code: '071345005079',
      label: 'Schwerbach',
      provincie: 7,
      slug: 'schwerbach',
    },
    {
      code: '071345005081',
      label: 'Sensweiler',
      provincie: 7,
      slug: 'sensweiler',
    },
    {
      code: '071345005082',
      label: 'Sien',
      provincie: 7,
      slug: 'sien',
    },
    {
      code: '071345005083',
      label: 'Sienhachenbach',
      provincie: 7,
      slug: 'sienhachenbach',
    },
    {
      code: '071345005086',
      label: 'Sonnschied',
      provincie: 7,
      slug: 'sonnschied',
    },
    {
      code: '071345005087',
      label: 'Stipshausen',
      provincie: 7,
      slug: 'stipshausen',
    },
    {
      code: '071345005088',
      label: 'Sulzbach',
      provincie: 7,
      slug: 'sulzbach',
    },
    {
      code: '071345005089',
      label: 'Veitsrodt',
      provincie: 7,
      slug: 'veitsrodt',
    },
    {
      code: '071345005090',
      label: 'Vollmersbach',
      provincie: 7,
      slug: 'vollmersbach',
    },
    {
      code: '071345005091',
      label: 'Weiden',
      provincie: 7,
      slug: 'weiden',
    },
    {
      code: '071345005092',
      label: 'Weitersbach',
      provincie: 7,
      slug: 'weitersbach',
    },
    {
      code: '071345005093',
      label: 'Wickenrodt',
      provincie: 7,
      slug: 'wickenrodt',
    },
    {
      code: '071345005095',
      label: 'Wirschweiler',
      provincie: 7,
      slug: 'wirschweiler',
    },
    {
      code: '071345005502',
      label: 'Langweiler',
      provincie: 7,
      slug: 'langweiler',
    },
    {
      code: '071355001007',
      label: 'Beilstein',
      provincie: 7,
      slug: 'beilstein',
    },
    {
      code: '071355001012',
      label: 'Bremm',
      provincie: 7,
      slug: 'bremm',
    },
    {
      code: '071355001015',
      label: 'Briedern',
      provincie: 7,
      slug: 'briedern',
    },
    {
      code: '071355001017',
      label: 'Bruttig-Fankel',
      provincie: 7,
      slug: 'bruttig-fankel',
    },
    {
      code: '071355001020',
      label: 'Cochem',
      provincie: 7,
      slug: 'cochem',
    },
    {
      code: '071355001021',
      label: 'Dohr',
      provincie: 7,
      slug: 'dohr',
    },
    {
      code: '071355001024',
      label: 'Ediger-Eller',
      provincie: 7,
      slug: 'ediger-eller',
    },
    {
      code: '071355001025',
      label: 'Ellenz-Poltersdorf',
      provincie: 7,
      slug: 'ellenz-poltersdorf',
    },
    {
      code: '071355001027',
      label: 'Ernst',
      provincie: 7,
      slug: 'ernst',
    },
    {
      code: '071355001029',
      label: 'Faid',
      provincie: 7,
      slug: 'faid',
    },
    {
      code: '071355001036',
      label: 'Greimersburg',
      provincie: 7,
      slug: 'greimersburg',
    },
    {
      code: '071355001049',
      label: 'Klotten',
      provincie: 7,
      slug: 'klotten',
    },
    {
      code: '071355001053',
      label: 'Lieg',
      provincie: 7,
      slug: 'lieg',
    },
    {
      code: '071355001056',
      label: 'Lütz',
      provincie: 7,
      slug: 'luetz',
    },
    {
      code: '071355001060',
      label: 'Mesenich',
      provincie: 7,
      slug: 'mesenich',
    },
    {
      code: '071355001065',
      label: 'Moselkern',
      provincie: 7,
      slug: 'moselkern',
    },
    {
      code: '071355001066',
      label: 'Müden (Mosel)',
      provincie: 7,
      slug: 'mueden-mosel',
    },
    {
      code: '071355001069',
      label: 'Nehren',
      provincie: 7,
      slug: 'nehren',
    },
    {
      code: '071355001072',
      label: 'Pommern',
      provincie: 7,
      slug: 'pommern',
    },
    {
      code: '071355001079',
      label: 'Senheim',
      provincie: 7,
      slug: 'senheim',
    },
    {
      code: '071355001082',
      label: 'Treis-Karden',
      provincie: 7,
      slug: 'treis-karden',
    },
    {
      code: '071355001086',
      label: 'Valwig',
      provincie: 7,
      slug: 'valwig',
    },
    {
      code: '071355001090',
      label: 'Wirfus',
      provincie: 7,
      slug: 'wirfus',
    },
    {
      code: '071355002009',
      label: 'Binningen',
      provincie: 7,
      slug: 'binningen',
    },
    {
      code: '071355002011',
      label: 'Brachtendorf',
      provincie: 7,
      slug: 'brachtendorf',
    },
    {
      code: '071355002014',
      label: 'Brieden',
      provincie: 7,
      slug: 'brieden',
    },
    {
      code: '071355002016',
      label: 'Brohl',
      provincie: 7,
      slug: 'brohl',
    },
    {
      code: '071355002022',
      label: 'Dünfus',
      provincie: 7,
      slug: 'duenfus',
    },
    {
      code: '071355002023',
      label: 'Düngenheim',
      provincie: 7,
      slug: 'duengenheim',
    },
    {
      code: '071355002026',
      label: 'Eppenberg',
      provincie: 7,
      slug: 'eppenberg',
    },
    {
      code: '071355002028',
      label: 'Eulgem',
      provincie: 7,
      slug: 'eulgem',
    },
    {
      code: '071355002031',
      label: 'Forst (Eifel)',
      provincie: 7,
      slug: 'forst-eifel',
    },
    {
      code: '071355002033',
      label: 'Gamlen',
      provincie: 7,
      slug: 'gamlen',
    },
    {
      code: '071355002038',
      label: 'Hambuch',
      provincie: 7,
      slug: 'hambuch',
    },
    {
      code: '071355002040',
      label: 'Hauroth',
      provincie: 7,
      slug: 'hauroth',
    },
    {
      code: '071355002042',
      label: 'Illerich',
      provincie: 7,
      slug: 'illerich',
    },
    {
      code: '071355002043',
      label: 'Kaifenheim',
      provincie: 7,
      slug: 'kaifenheim',
    },
    {
      code: '071355002044',
      label: 'Kail',
      provincie: 7,
      slug: 'kail',
    },
    {
      code: '071355002045',
      label: 'Kaisersesch',
      provincie: 7,
      slug: 'kaisersesch',
    },
    {
      code: '071355002046',
      label: 'Kalenborn',
      provincie: 7,
      slug: 'kalenborn-gemeinde',
    },
    {
      code: '071355002051',
      label: 'Landkern',
      provincie: 7,
      slug: 'landkern',
    },
    {
      code: '071355002052',
      label: 'Laubach',
      provincie: 7,
      slug: 'laubach-gemeinde',
    },
    {
      code: '071355002058',
      label: 'Masburg',
      provincie: 7,
      slug: 'masburg',
    },
    {
      code: '071355002062',
      label: 'Möntenich',
      provincie: 7,
      slug: 'moentenich',
    },
    {
      code: '071355002067',
      label: 'Müllenbach',
      provincie: 7,
      slug: 'muellenbach-gemeinde',
    },
    {
      code: '071355002075',
      label: 'Roes',
      provincie: 7,
      slug: 'roes',
    },
    {
      code: '071355002084',
      label: 'Urmersbach',
      provincie: 7,
      slug: 'urmersbach',
    },
    {
      code: '071355002093',
      label: 'Zettingen',
      provincie: 7,
      slug: 'zettingen',
    },
    {
      code: '071355002502',
      label: 'Leienkaul',
      provincie: 7,
      slug: 'leienkaul',
    },
    {
      code: '071355003002',
      label: 'Alflen',
      provincie: 7,
      slug: 'alflen',
    },
    {
      code: '071355003005',
      label: 'Auderath',
      provincie: 7,
      slug: 'auderath',
    },
    {
      code: '071355003008',
      label: 'Beuren',
      provincie: 7,
      slug: 'beuren',
    },
    {
      code: '071355003018',
      label: 'Büchel',
      provincie: 7,
      slug: 'buechel',
    },
    {
      code: '071355003030',
      label: 'Filz',
      provincie: 7,
      slug: 'filz',
    },
    {
      code: '071355003034',
      label: 'Gevenich',
      provincie: 7,
      slug: 'gevenich',
    },
    {
      code: '071355003035',
      label: 'Gillenbeuren',
      provincie: 7,
      slug: 'gillenbeuren',
    },
    {
      code: '071355003048',
      label: 'Kliding',
      provincie: 7,
      slug: 'kliding',
    },
    {
      code: '071355003057',
      label: 'Lutzerath',
      provincie: 7,
      slug: 'lutzerath',
    },
    {
      code: '071355003078',
      label: 'Schmitt',
      provincie: 7,
      slug: 'schmitt',
    },
    {
      code: '071355003083',
      label: 'Ulmen',
      provincie: 7,
      slug: 'ulmen',
    },
    {
      code: '071355003085',
      label: 'Urschmitt',
      provincie: 7,
      slug: 'urschmitt',
    },
    {
      code: '071355003087',
      label: 'Wagenhausen',
      provincie: 7,
      slug: 'wagenhausen',
    },
    {
      code: '071355003089',
      label: 'Weiler',
      provincie: 7,
      slug: 'weiler',
    },
    {
      code: '071355003091',
      label: 'Wollmerath',
      provincie: 7,
      slug: 'wollmerath',
    },
    {
      code: '071355003501',
      label: 'Bad Bertrich',
      provincie: 7,
      slug: 'bad-bertrich',
    },
    {
      code: '071355005001',
      label: 'Alf',
      provincie: 7,
      slug: 'alf',
    },
    {
      code: '071355005003',
      label: 'Altlay',
      provincie: 7,
      slug: 'altlay',
    },
    {
      code: '071355005004',
      label: 'Altstrimmig',
      provincie: 7,
      slug: 'altstrimmig',
    },
    {
      code: '071355005010',
      label: 'Blankenrath',
      provincie: 7,
      slug: 'blankenrath',
    },
    {
      code: '071355005013',
      label: 'Briedel',
      provincie: 7,
      slug: 'briedel',
    },
    {
      code: '071355005019',
      label: 'Bullay',
      provincie: 7,
      slug: 'bullay',
    },
    {
      code: '071355005032',
      label: 'Forst (Hunsrück)',
      provincie: 7,
      slug: 'forst-hunsrueck',
    },
    {
      code: '071355005037',
      label: 'Grenderich',
      provincie: 7,
      slug: 'grenderich',
    },
    {
      code: '071355005039',
      label: 'Haserich',
      provincie: 7,
      slug: 'haserich',
    },
    {
      code: '071355005041',
      label: 'Hesweiler',
      provincie: 7,
      slug: 'hesweiler',
    },
    {
      code: '071355005054',
      label: 'Liesenich',
      provincie: 7,
      slug: 'liesenich',
    },
    {
      code: '071355005061',
      label: 'Mittelstrimmig',
      provincie: 7,
      slug: 'mittelstrimmig',
    },
    {
      code: '071355005064',
      label: 'Moritzheim',
      provincie: 7,
      slug: 'moritzheim',
    },
    {
      code: '071355005068',
      label: 'Neef',
      provincie: 7,
      slug: 'neef',
    },
    {
      code: '071355005070',
      label: 'Panzweiler',
      provincie: 7,
      slug: 'panzweiler',
    },
    {
      code: '071355005071',
      label: 'Peterswald-Löffelscheid',
      provincie: 7,
      slug: 'peterswald-loeffelscheid',
    },
    {
      code: '071355005073',
      label: 'Pünderich',
      provincie: 7,
      slug: 'puenderich',
    },
    {
      code: '071355005074',
      label: 'Reidenhausen',
      provincie: 7,
      slug: 'reidenhausen',
    },
    {
      code: '071355005076',
      label: 'Sankt Aldegund',
      provincie: 7,
      slug: 'sankt-aldegund',
    },
    {
      code: '071355005077',
      label: 'Schauren',
      provincie: 7,
      slug: 'schauren-gemeinde',
    },
    {
      code: '071355005080',
      label: 'Sosberg',
      provincie: 7,
      slug: 'sosberg',
    },
    {
      code: '071355005081',
      label: 'Tellig',
      provincie: 7,
      slug: 'tellig',
    },
    {
      code: '071355005088',
      label: 'Walhausen',
      provincie: 7,
      slug: 'walhausen',
    },
    {
      code: '071355005092',
      label: 'Zell (Mosel)',
      provincie: 7,
      slug: 'zell-mosel',
    },
    {
      code: '071370003003',
      label: 'Andernach',
      provincie: 7,
      slug: 'andernach',
    },
    {
      code: '071370068068',
      label: 'Mayen',
      provincie: 7,
      slug: 'mayen',
    },
    {
      code: '071370203203',
      label: 'Bendorf',
      provincie: 7,
      slug: 'bendorf-stadt',
    },
    {
      code: '071375001056',
      label: 'Kretz',
      provincie: 7,
      slug: 'kretz',
    },
    {
      code: '071375001057',
      label: 'Kruft',
      provincie: 7,
      slug: 'kruft',
    },
    {
      code: '071375001081',
      label: 'Nickenich',
      provincie: 7,
      slug: 'nickenich',
    },
    {
      code: '071375001088',
      label: 'Plaidt',
      provincie: 7,
      slug: 'plaidt',
    },
    {
      code: '071375001096',
      label: 'Saffig',
      provincie: 7,
      slug: 'saffig',
    },
    {
      code: '071375002023',
      label: 'Einig',
      provincie: 7,
      slug: 'einig',
    },
    {
      code: '071375002027',
      label: 'Gappenach',
      provincie: 7,
      slug: 'gappenach',
    },
    {
      code: '071375002029',
      label: 'Gering',
      provincie: 7,
      slug: 'gering',
    },
    {
      code: '071375002030',
      label: 'Gierschnach',
      provincie: 7,
      slug: 'gierschnach',
    },
    {
      code: '071375002041',
      label: 'Kalt',
      provincie: 7,
      slug: 'kalt',
    },
    {
      code: '071375002048',
      label: 'Kerben',
      provincie: 7,
      slug: 'kerben',
    },
    {
      code: '071375002053',
      label: 'Kollig',
      provincie: 7,
      slug: 'kollig',
    },
    {
      code: '071375002065',
      label: 'Lonnig',
      provincie: 7,
      slug: 'lonnig',
    },
    {
      code: '071375002070',
      label: 'Mertloch',
      provincie: 7,
      slug: 'mertloch',
    },
    {
      code: '071375002080',
      label: 'Naunheim',
      provincie: 7,
      slug: 'naunheim',
    },
    {
      code: '071375002086',
      label: 'Ochtendung',
      provincie: 7,
      slug: 'ochtendung',
    },
    {
      code: '071375002087',
      label: 'Pillig',
      provincie: 7,
      slug: 'pillig',
    },
    {
      code: '071375002089',
      label: 'Polch',
      provincie: 7,
      slug: 'polch',
    },
    {
      code: '071375002095',
      label: 'Rüber',
      provincie: 7,
      slug: 'rueber',
    },
    {
      code: '071375002102',
      label: 'Trimbs',
      provincie: 7,
      slug: 'trimbs',
    },
    {
      code: '071375002112',
      label: 'Welling',
      provincie: 7,
      slug: 'welling',
    },
    {
      code: '071375002114',
      label: 'Wierschem',
      provincie: 7,
      slug: 'wierschem',
    },
    {
      code: '071375002501',
      label: 'Münstermaifeld',
      provincie: 7,
      slug: 'muenstermaifeld',
    },
    {
      code: '071375003001',
      label: 'Acht',
      provincie: 7,
      slug: 'acht',
    },
    {
      code: '071375003004',
      label: 'Anschau',
      provincie: 7,
      slug: 'anschau',
    },
    {
      code: '071375003006',
      label: 'Arft',
      provincie: 7,
      slug: 'arft',
    },
    {
      code: '071375003007',
      label: 'Baar',
      provincie: 7,
      slug: 'baar',
    },
    {
      code: '071375003011',
      label: 'Bermel',
      provincie: 7,
      slug: 'bermel',
    },
    {
      code: '071375003014',
      label: 'Boos',
      provincie: 7,
      slug: 'boos-gemeinde',
    },
    {
      code: '071375003019',
      label: 'Ditscheid',
      provincie: 7,
      slug: 'ditscheid',
    },
    {
      code: '071375003025',
      label: 'Ettringen',
      provincie: 7,
      slug: 'ettringen',
    },
    {
      code: '071375003034',
      label: 'Hausten',
      provincie: 7,
      slug: 'hausten',
    },
    {
      code: '071375003035',
      label: 'Herresbach',
      provincie: 7,
      slug: 'herresbach',
    },
    {
      code: '071375003036',
      label: 'Hirten',
      provincie: 7,
      slug: 'hirten',
    },
    {
      code: '071375003043',
      label: 'Kehrig',
      provincie: 7,
      slug: 'kehrig',
    },
    {
      code: '071375003049',
      label: 'Kirchwald',
      provincie: 7,
      slug: 'kirchwald',
    },
    {
      code: '071375003055',
      label: 'Kottenheim',
      provincie: 7,
      slug: 'kottenheim',
    },
    {
      code: '071375003060',
      label: 'Langenfeld',
      provincie: 7,
      slug: 'langenfeld',
    },
    {
      code: '071375003061',
      label: 'Langscheid',
      provincie: 7,
      slug: 'langscheid',
    },
    {
      code: '071375003063',
      label: 'Lind',
      provincie: 7,
      slug: 'lind-gemeinde',
    },
    {
      code: '071375003066',
      label: 'Luxem',
      provincie: 7,
      slug: 'luxem',
    },
    {
      code: '071375003074',
      label: 'Monreal',
      provincie: 7,
      slug: 'monreal',
    },
    {
      code: '071375003077',
      label: 'Münk',
      provincie: 7,
      slug: 'muenk',
    },
    {
      code: '071375003079',
      label: 'Nachtsheim',
      provincie: 7,
      slug: 'nachtsheim',
    },
    {
      code: '071375003092',
      label: 'Reudelsterz',
      provincie: 7,
      slug: 'reudelsterz',
    },
    {
      code: '071375003097',
      label: 'Sankt Johann',
      provincie: 7,
      slug: 'sankt-johann',
    },
    {
      code: '071375003099',
      label: 'Siebenbach',
      provincie: 7,
      slug: 'siebenbach',
    },
    {
      code: '071375003105',
      label: 'Virneburg',
      provincie: 7,
      slug: 'virneburg',
    },
    {
      code: '071375003110',
      label: 'Weiler',
      provincie: 7,
      slug: 'weiler-gemeinde',
    },
    {
      code: '071375003113',
      label: 'Welschenbach',
      provincie: 7,
      slug: 'welschenbach',
    },
    {
      code: '071375004008',
      label: 'Bell',
      provincie: 7,
      slug: 'bell',
    },
    {
      code: '071375004069',
      label: 'Mendig',
      provincie: 7,
      slug: 'mendig',
    },
    {
      code: '071375004093',
      label: 'Rieden',
      provincie: 7,
      slug: 'rieden',
    },
    {
      code: '071375004101',
      label: 'Thür',
      provincie: 7,
      slug: 'thuer',
    },
    {
      code: '071375004106',
      label: 'Volkesfeld',
      provincie: 7,
      slug: 'volkesfeld',
    },
    {
      code: '071375007218',
      label: 'Niederwerth',
      provincie: 7,
      slug: 'niederwerth',
    },
    {
      code: '071375007224',
      label: 'Urbar',
      provincie: 7,
      slug: 'urbar',
    },
    {
      code: '071375007226',
      label: 'Vallendar',
      provincie: 7,
      slug: 'vallendar',
    },
    {
      code: '071375007229',
      label: 'Weitersburg',
      provincie: 7,
      slug: 'weitersburg',
    },
    {
      code: '071375008202',
      label: 'Bassenheim',
      provincie: 7,
      slug: 'bassenheim',
    },
    {
      code: '071375008209',
      label: 'Kaltenengers',
      provincie: 7,
      slug: 'kaltenengers',
    },
    {
      code: '071375008211',
      label: 'Kettig',
      provincie: 7,
      slug: 'kettig',
    },
    {
      code: '071375008216',
      label: 'Mülheim-Kärlich',
      provincie: 7,
      slug: 'muelheim-kaerlich',
    },
    {
      code: '071375008222',
      label: 'Sankt Sebastian',
      provincie: 7,
      slug: 'sankt-sebastian',
    },
    {
      code: '071375008225',
      label: 'Urmitz',
      provincie: 7,
      slug: 'urmitz',
    },
    {
      code: '071375008228',
      label: 'Weißenthurm',
      provincie: 7,
      slug: 'weissenthurm',
    },
    {
      code: '071375009201',
      label: 'Alken',
      provincie: 7,
      slug: 'alken',
    },
    {
      code: '071375009204',
      label: 'Brey',
      provincie: 7,
      slug: 'brey',
    },
    {
      code: '071375009205',
      label: 'Brodenbach',
      provincie: 7,
      slug: 'brodenbach',
    },
    {
      code: '071375009206',
      label: 'Burgen',
      provincie: 7,
      slug: 'burgen',
    },
    {
      code: '071375009207',
      label: 'Dieblich',
      provincie: 7,
      slug: 'dieblich',
    },
    {
      code: '071375009208',
      label: 'Hatzenport',
      provincie: 7,
      slug: 'hatzenport',
    },
    {
      code: '071375009212',
      label: 'Kobern-Gondorf',
      provincie: 7,
      slug: 'kobern-gondorf',
    },
    {
      code: '071375009214',
      label: 'Löf',
      provincie: 7,
      slug: 'loef',
    },
    {
      code: '071375009215',
      label: 'Macken',
      provincie: 7,
      slug: 'macken',
    },
    {
      code: '071375009217',
      label: 'Niederfell',
      provincie: 7,
      slug: 'niederfell',
    },
    {
      code: '071375009219',
      label: 'Nörtershausen',
      provincie: 7,
      slug: 'noertershausen',
    },
    {
      code: '071375009220',
      label: 'Oberfell',
      provincie: 7,
      slug: 'oberfell',
    },
    {
      code: '071375009221',
      label: 'Rhens',
      provincie: 7,
      slug: 'rhens',
    },
    {
      code: '071375009223',
      label: 'Spay',
      provincie: 7,
      slug: 'spay',
    },
    {
      code: '071375009227',
      label: 'Waldesch',
      provincie: 7,
      slug: 'waldesch',
    },
    {
      code: '071375009230',
      label: 'Winningen',
      provincie: 7,
      slug: 'winningen',
    },
    {
      code: '071375009231',
      label: 'Wolken',
      provincie: 7,
      slug: 'wolken',
    },
    {
      code: '071375009504',
      label: 'Lehmen',
      provincie: 7,
      slug: 'lehmen',
    },
    {
      code: '071380045045',
      label: 'Neuwied',
      provincie: 7,
      slug: 'neuwied',
    },
    {
      code: '071385001003',
      label: 'Asbach',
      provincie: 7,
      slug: 'asbach-gemeinde',
    },
    {
      code: '071385001044',
      label: 'Neustadt (Wied)',
      provincie: 7,
      slug: 'neustadt-wied',
    },
    {
      code: '071385001077',
      label: 'Windhagen',
      provincie: 7,
      slug: 'windhagen',
    },
    {
      code: '071385001080',
      label: 'Buchholz (Westerwald)',
      provincie: 7,
      slug: 'buchholz-westerwald',
    },
    {
      code: '071385002004',
      label: 'Bad Hönningen',
      provincie: 7,
      slug: 'bad-hoenningen',
    },
    {
      code: '071385002024',
      label: 'Hammerstein',
      provincie: 7,
      slug: 'hammerstein',
    },
    {
      code: '071385002038',
      label: 'Leutesdorf',
      provincie: 7,
      slug: 'leutesdorf',
    },
    {
      code: '071385002063',
      label: 'Rheinbrohl',
      provincie: 7,
      slug: 'rheinbrohl',
    },
    {
      code: '071385003012',
      label: 'Dierdorf',
      provincie: 7,
      slug: 'dierdorf',
    },
    {
      code: '071385003023',
      label: 'Großmaischeid',
      provincie: 7,
      slug: 'grossmaischeid',
    },
    {
      code: '071385003031',
      label: 'Isenburg',
      provincie: 7,
      slug: 'isenburg',
    },
    {
      code: '071385003034',
      label: 'Kleinmaischeid',
      provincie: 7,
      slug: 'kleinmaischeid',
    },
    {
      code: '071385003069',
      label: 'Stebach',
      provincie: 7,
      slug: 'stebach',
    },
    {
      code: '071385003201',
      label: 'Marienhausen',
      provincie: 7,
      slug: 'marienhausen',
    },
    {
      code: '071385004009',
      label: 'Dattenberg',
      provincie: 7,
      slug: 'dattenberg',
    },
    {
      code: '071385004037',
      label: 'Leubsdorf',
      provincie: 7,
      slug: 'leubsdorf',
    },
    {
      code: '071385004041',
      label: 'Linz am Rhein',
      provincie: 7,
      slug: 'linz-am-rhein',
    },
    {
      code: '071385004055',
      label: 'Ockenfels',
      provincie: 7,
      slug: 'ockenfels',
    },
    {
      code: '071385004068',
      label: 'Sankt Katharinen (Landkreis Neuwied)',
      provincie: 7,
      slug: 'sankt-katharinen-landkreis-neuwied',
    },
    {
      code: '071385004075',
      label: 'Vettelschoß',
      provincie: 7,
      slug: 'vettelschoss',
    },
    {
      code: '071385004501',
      label: 'Kasbach-Ohlenberg',
      provincie: 7,
      slug: 'kasbach-ohlenberg',
    },
    {
      code: '071385005011',
      label: 'Dernbach',
      provincie: 7,
      slug: 'dernbach',
    },
    {
      code: '071385005013',
      label: 'Döttesfeld',
      provincie: 7,
      slug: 'doettesfeld',
    },
    {
      code: '071385005014',
      label: 'Dürrholz',
      provincie: 7,
      slug: 'duerrholz',
    },
    {
      code: '071385005025',
      label: 'Hanroth',
      provincie: 7,
      slug: 'hanroth',
    },
    {
      code: '071385005027',
      label: 'Harschbach',
      provincie: 7,
      slug: 'harschbach',
    },
    {
      code: '071385005040',
      label: 'Linkenbach',
      provincie: 7,
      slug: 'linkenbach',
    },
    {
      code: '071385005048',
      label: 'Niederhofen',
      provincie: 7,
      slug: 'niederhofen',
    },
    {
      code: '071385005050',
      label: 'Niederwambach',
      provincie: 7,
      slug: 'niederwambach',
    },
    {
      code: '071385005052',
      label: 'Oberdreis',
      provincie: 7,
      slug: 'oberdreis',
    },
    {
      code: '071385005057',
      label: 'Puderbach',
      provincie: 7,
      slug: 'puderbach',
    },
    {
      code: '071385005058',
      label: 'Ratzert',
      provincie: 7,
      slug: 'ratzert',
    },
    {
      code: '071385005059',
      label: 'Raubach',
      provincie: 7,
      slug: 'raubach',
    },
    {
      code: '071385005064',
      label: 'Rodenbach bei Puderbach',
      provincie: 7,
      slug: 'rodenbach-bei-puderbach',
    },
    {
      code: '071385005070',
      label: 'Steimel',
      provincie: 7,
      slug: 'steimel',
    },
    {
      code: '071385005074',
      label: 'Urbach',
      provincie: 7,
      slug: 'urbach',
    },
    {
      code: '071385005078',
      label: 'Woldert',
      provincie: 7,
      slug: 'woldert',
    },
    {
      code: '071385007008',
      label: 'Bruchhausen',
      provincie: 7,
      slug: 'bruchhausen',
    },
    {
      code: '071385007019',
      label: 'Erpel',
      provincie: 7,
      slug: 'erpel',
    },
    {
      code: '071385007062',
      label: 'Rheinbreitbach',
      provincie: 7,
      slug: 'rheinbreitbach',
    },
    {
      code: '071385007073',
      label: 'Unkel',
      provincie: 7,
      slug: 'unkel',
    },
    {
      code: '071385009002',
      label: 'Anhausen',
      provincie: 7,
      slug: 'anhausen',
    },
    {
      code: '071385009005',
      label: 'Bonefeld',
      provincie: 7,
      slug: 'bonefeld',
    },
    {
      code: '071385009006',
      label: 'Breitscheid',
      provincie: 7,
      slug: 'breitscheid-gemeinde',
    },
    {
      code: '071385009007',
      label: 'Hausen (Wied)',
      provincie: 7,
      slug: 'hausen-wied',
    },
    {
      code: '071385009010',
      label: 'Datzeroth',
      provincie: 7,
      slug: 'datzeroth',
    },
    {
      code: '071385009015',
      label: 'Ehlscheid',
      provincie: 7,
      slug: 'ehlscheid',
    },
    {
      code: '071385009026',
      label: 'Hardert',
      provincie: 7,
      slug: 'hardert',
    },
    {
      code: '071385009030',
      label: 'Hümmerich',
      provincie: 7,
      slug: 'huemmerich',
    },
    {
      code: '071385009036',
      label: 'Kurtscheid',
      provincie: 7,
      slug: 'kurtscheid',
    },
    {
      code: '071385009042',
      label: 'Meinborn',
      provincie: 7,
      slug: 'meinborn',
    },
    {
      code: '071385009043',
      label: 'Melsbach',
      provincie: 7,
      slug: 'melsbach',
    },
    {
      code: '071385009047',
      label: 'Niederbreitbach',
      provincie: 7,
      slug: 'niederbreitbach',
    },
    {
      code: '071385009053',
      label: 'Oberhonnefeld-Gierend',
      provincie: 7,
      slug: 'oberhonnefeld-gierend',
    },
    {
      code: '071385009054',
      label: 'Oberraden',
      provincie: 7,
      slug: 'oberraden',
    },
    {
      code: '071385009061',
      label: 'Rengsdorf',
      provincie: 7,
      slug: 'rengsdorf',
    },
    {
      code: '071385009065',
      label: 'Roßbach',
      provincie: 7,
      slug: 'rossbach',
    },
    {
      code: '071385009066',
      label: 'Rüscheid',
      provincie: 7,
      slug: 'ruescheid',
    },
    {
      code: '071385009071',
      label: 'Straßenhaus',
      provincie: 7,
      slug: 'strassenhaus',
    },
    {
      code: '071385009072',
      label: 'Thalhausen',
      provincie: 7,
      slug: 'thalhausen',
    },
    {
      code: '071385009076',
      label: 'Waldbreitbach',
      provincie: 7,
      slug: 'waldbreitbach',
    },
    {
      code: '071400501501',
      label: 'Boppard',
      provincie: 7,
      slug: 'boppard',
    },
    {
      code: '071405003001',
      label: 'Alterkülz',
      provincie: 7,
      slug: 'alterkuelz',
    },
    {
      code: '071405003009',
      label: 'Bell (Hunsrück)',
      provincie: 7,
      slug: 'bell-hunsrueck',
    },
    {
      code: '071405003010',
      label: 'Beltheim',
      provincie: 7,
      slug: 'beltheim',
    },
    {
      code: '071405003018',
      label: 'Braunshorn',
      provincie: 7,
      slug: 'braunshorn',
    },
    {
      code: '071405003021',
      label: 'Buch',
      provincie: 7,
      slug: 'buch',
    },
    {
      code: '071405003042',
      label: 'Gödenroth',
      provincie: 7,
      slug: 'goedenroth',
    },
    {
      code: '071405003046',
      label: 'Hasselbach',
      provincie: 7,
      slug: 'hasselbach-gemeinde',
    },
    {
      code: '071405003055',
      label: 'Hollnich',
      provincie: 7,
      slug: 'hollnich',
    },
    {
      code: '071405003064',
      label: 'Kastellaun',
      provincie: 7,
      slug: 'kastellaun',
    },
    {
      code: '071405003073',
      label: 'Korweiler',
      provincie: 7,
      slug: 'korweiler',
    },
    {
      code: '071405003095',
      label: 'Michelbach',
      provincie: 7,
      slug: 'michelbach',
    },
    {
      code: '071405003131',
      label: 'Roth',
      provincie: 7,
      slug: 'roth-gemeinde',
    },
    {
      code: '071405003147',
      label: 'Spesenroth',
      provincie: 7,
      slug: 'spesenroth',
    },
    {
      code: '071405003153',
      label: 'Uhler',
      provincie: 7,
      slug: 'uhler',
    },
    {
      code: '071405003202',
      label: 'Dommershausen',
      provincie: 7,
      slug: 'dommershausen',
    },
    {
      code: '071405003204',
      label: 'Mastershausen',
      provincie: 7,
      slug: 'mastershausen',
    },
    {
      code: '071405003502',
      label: 'Lahr',
      provincie: 7,
      slug: 'lahr',
    },
    {
      code: '071405003503',
      label: 'Mörsdorf',
      provincie: 7,
      slug: 'moersdorf',
    },
    {
      code: '071405003504',
      label: 'Zilshausen',
      provincie: 7,
      slug: 'zilshausen',
    },
    {
      code: '071405004006',
      label: 'Bärenbach',
      provincie: 7,
      slug: 'baerenbach-gemeinde',
    },
    {
      code: '071405004007',
      label: 'Belg',
      provincie: 7,
      slug: 'belg',
    },
    {
      code: '071405004024',
      label: 'Büchenbeuren',
      provincie: 7,
      slug: 'buechenbeuren',
    },
    {
      code: '071405004028',
      label: 'Dickenschied',
      provincie: 7,
      slug: 'dickenschied',
    },
    {
      code: '071405004029',
      label: 'Dill',
      provincie: 7,
      slug: 'dill',
    },
    {
      code: '071405004030',
      label: 'Dillendorf',
      provincie: 7,
      slug: 'dillendorf',
    },
    {
      code: '071405004040',
      label: 'Gehlweiler',
      provincie: 7,
      slug: 'gehlweiler',
    },
    {
      code: '071405004041',
      label: 'Gemünden',
      provincie: 7,
      slug: 'gemuenden',
    },
    {
      code: '071405004044',
      label: 'Hahn',
      provincie: 7,
      slug: 'hahn',
    },
    {
      code: '071405004048',
      label: 'Hecken',
      provincie: 7,
      slug: 'hecken',
    },
    {
      code: '071405004049',
      label: 'Heinzenbach',
      provincie: 7,
      slug: 'heinzenbach',
    },
    {
      code: '071405004050',
      label: 'Henau',
      provincie: 7,
      slug: 'henau',
    },
    {
      code: '071405004053',
      label: 'Hirschfeld (Hunsrück)',
      provincie: 7,
      slug: 'hirschfeld-hunsrueck',
    },
    {
      code: '071405004062',
      label: 'Kappel',
      provincie: 7,
      slug: 'kappel',
    },
    {
      code: '071405004067',
      label: 'Kirchberg (Hunsrück)',
      provincie: 7,
      slug: 'kirchberg-hunsrueck',
    },
    {
      code: '071405004071',
      label: 'Kludenbach',
      provincie: 7,
      slug: 'kludenbach',
    },
    {
      code: '071405004081',
      label: 'Laufersweiler',
      provincie: 7,
      slug: 'laufersweiler',
    },
    {
      code: '071405004082',
      label: 'Lautzenhausen',
      provincie: 7,
      slug: 'lautzenhausen',
    },
    {
      code: '071405004086',
      label: 'Lindenschied',
      provincie: 7,
      slug: 'lindenschied',
    },
    {
      code: '071405004090',
      label: 'Maitzborn',
      provincie: 7,
      slug: 'maitzborn',
    },
    {
      code: '071405004094',
      label: 'Metzenhausen',
      provincie: 7,
      slug: 'metzenhausen',
    },
    {
      code: '071405004105',
      label: 'Nieder Kostenz',
      provincie: 7,
      slug: 'nieder-kostenz',
    },
    {
      code: '071405004107',
      label: 'Niedersohren',
      provincie: 7,
      slug: 'niedersohren',
    },
    {
      code: '071405004109',
      label: 'Niederweiler',
      provincie: 7,
      slug: 'niederweiler',
    },
    {
      code: '071405004111',
      label: 'Ober Kostenz',
      provincie: 7,
      slug: 'ober-kostenz',
    },
    {
      code: '071405004120',
      label: 'Raversbeuren',
      provincie: 7,
      slug: 'raversbeuren',
    },
    {
      code: '071405004122',
      label: 'Reckershausen',
      provincie: 7,
      slug: 'reckershausen',
    },
    {
      code: '071405004128',
      label: 'Rödelhausen',
      provincie: 7,
      slug: 'roedelhausen',
    },
    {
      code: '071405004129',
      label: 'Rödern',
      provincie: 7,
      slug: 'roedern',
    },
    {
      code: '071405004130',
      label: 'Rohrbach',
      provincie: 7,
      slug: 'rohrbach-gemeinde',
    },
    {
      code: '071405004135',
      label: 'Schlierschied',
      provincie: 7,
      slug: 'schlierschied',
    },
    {
      code: '071405004141',
      label: 'Schwarzen',
      provincie: 7,
      slug: 'schwarzen',
    },
    {
      code: '071405004145',
      label: 'Sohren',
      provincie: 7,
      slug: 'sohren',
    },
    {
      code: '071405004146',
      label: 'Sohrschied',
      provincie: 7,
      slug: 'sohrschied',
    },
    {
      code: '071405004151',
      label: 'Todenroth',
      provincie: 7,
      slug: 'todenroth',
    },
    {
      code: '071405004154',
      label: 'Unzenberg',
      provincie: 7,
      slug: 'unzenberg',
    },
    {
      code: '071405004159',
      label: 'Wahlenau',
      provincie: 7,
      slug: 'wahlenau',
    },
    {
      code: '071405004163',
      label: 'Womrath',
      provincie: 7,
      slug: 'womrath',
    },
    {
      code: '071405004164',
      label: 'Woppenroth',
      provincie: 7,
      slug: 'woppenroth',
    },
    {
      code: '071405004165',
      label: 'Würrich',
      provincie: 7,
      slug: 'wuerrich',
    },
    {
      code: '071405008002',
      label: 'Altweidelbach',
      provincie: 7,
      slug: 'altweidelbach',
    },
    {
      code: '071405008003',
      label: 'Argenthal',
      provincie: 7,
      slug: 'argenthal',
    },
    {
      code: '071405008008',
      label: 'Belgweiler',
      provincie: 7,
      slug: 'belgweiler',
    },
    {
      code: '071405008011',
      label: 'Benzweiler',
      provincie: 7,
      slug: 'benzweiler',
    },
    {
      code: '071405008012',
      label: 'Bergenhausen',
      provincie: 7,
      slug: 'bergenhausen',
    },
    {
      code: '071405008015',
      label: 'Biebern',
      provincie: 7,
      slug: 'biebern',
    },
    {
      code: '071405008020',
      label: 'Bubach',
      provincie: 7,
      slug: 'bubach',
    },
    {
      code: '071405008023',
      label: 'Budenbach',
      provincie: 7,
      slug: 'budenbach',
    },
    {
      code: '071405008027',
      label: 'Dichtelbach',
      provincie: 7,
      slug: 'dichtelbach',
    },
    {
      code: '071405008035',
      label: 'Ellern (Hunsrück)',
      provincie: 7,
      slug: 'ellern-hunsrueck',
    },
    {
      code: '071405008037',
      label: 'Erbach',
      provincie: 7,
      slug: 'erbach-gemeinde',
    },
    {
      code: '071405008039',
      label: 'Fronhofen',
      provincie: 7,
      slug: 'fronhofen',
    },
    {
      code: '071405008056',
      label: 'Holzbach',
      provincie: 7,
      slug: 'holzbach',
    },
    {
      code: '071405008058',
      label: 'Horn',
      provincie: 7,
      slug: 'horn',
    },
    {
      code: '071405008065',
      label: 'Keidelheim',
      provincie: 7,
      slug: 'keidelheim',
    },
    {
      code: '071405008068',
      label: 'Kisselbach',
      provincie: 7,
      slug: 'kisselbach',
    },
    {
      code: '071405008070',
      label: 'Klosterkumbd',
      provincie: 7,
      slug: 'klosterkumbd',
    },
    {
      code: '071405008076',
      label: 'Külz (Hunsrück)',
      provincie: 7,
      slug: 'kuelz-hunsrueck',
    },
    {
      code: '071405008077',
      label: 'Kümbdchen',
      provincie: 7,
      slug: 'kuembdchen',
    },
    {
      code: '071405008079',
      label: 'Laubach',
      provincie: 7,
      slug: 'laubach-gemeinde',
    },
    {
      code: '071405008085',
      label: 'Liebshausen',
      provincie: 7,
      slug: 'liebshausen',
    },
    {
      code: '071405008092',
      label: 'Mengerschied',
      provincie: 7,
      slug: 'mengerschied',
    },
    {
      code: '071405008096',
      label: 'Mörschbach',
      provincie: 7,
      slug: 'moerschbach',
    },
    {
      code: '071405008099',
      label: 'Mutterschied',
      provincie: 7,
      slug: 'mutterschied',
    },
    {
      code: '071405008100',
      label: 'Nannhausen',
      provincie: 7,
      slug: 'nannhausen',
    },
    {
      code: '071405008101',
      label: 'Neuerkirch',
      provincie: 7,
      slug: 'neuerkirch',
    },
    {
      code: '071405008106',
      label: 'Niederkumbd',
      provincie: 7,
      slug: 'niederkumbd',
    },
    {
      code: '071405008113',
      label: 'Ohlweiler',
      provincie: 7,
      slug: 'ohlweiler',
    },
    {
      code: '071405008115',
      label: 'Oppertshausen',
      provincie: 7,
      slug: 'oppertshausen',
    },
    {
      code: '071405008118',
      label: 'Pleizenhausen',
      provincie: 7,
      slug: 'pleizenhausen',
    },
    {
      code: '071405008119',
      label: 'Ravengiersburg',
      provincie: 7,
      slug: 'ravengiersburg',
    },
    {
      code: '071405008121',
      label: 'Rayerschied',
      provincie: 7,
      slug: 'rayerschied',
    },
    {
      code: '071405008123',
      label: 'Reich',
      provincie: 7,
      slug: 'reich',
    },
    {
      code: '071405008125',
      label: 'Rheinböllen',
      provincie: 7,
      slug: 'rheinboellen',
    },
    {
      code: '071405008126',
      label: 'Riegenroth',
      provincie: 7,
      slug: 'riegenroth',
    },
    {
      code: '071405008127',
      label: 'Riesweiler',
      provincie: 7,
      slug: 'riesweiler',
    },
    {
      code: '071405008134',
      label: 'Sargenroth',
      provincie: 7,
      slug: 'sargenroth',
    },
    {
      code: '071405008138',
      label: 'Schnorbach',
      provincie: 7,
      slug: 'schnorbach',
    },
    {
      code: '071405008139',
      label: 'Schönborn',
      provincie: 7,
      slug: 'schoenborn',
    },
    {
      code: '071405008144',
      label: 'Simmern/Hunsrück',
      provincie: 7,
      slug: 'simmern-hunsrueck',
    },
    {
      code: '071405008148',
      label: 'Steinbach',
      provincie: 7,
      slug: 'steinbach',
    },
    {
      code: '071405008150',
      label: 'Tiefenbach',
      provincie: 7,
      slug: 'tiefenbach',
    },
    {
      code: '071405008158',
      label: 'Wahlbach',
      provincie: 7,
      slug: 'wahlbach',
    },
    {
      code: '071405008166',
      label: 'Wüschheim',
      provincie: 7,
      slug: 'wueschheim',
    },
    {
      code: '071405009005',
      label: 'Badenhard',
      provincie: 7,
      slug: 'badenhard',
    },
    {
      code: '071405009014',
      label: 'Bickenbach',
      provincie: 7,
      slug: 'bickenbach-gemeinde',
    },
    {
      code: '071405009016',
      label: 'Birkheim',
      provincie: 7,
      slug: 'birkheim',
    },
    {
      code: '071405009025',
      label: 'Damscheid',
      provincie: 7,
      slug: 'damscheid',
    },
    {
      code: '071405009031',
      label: 'Dörth',
      provincie: 7,
      slug: 'doerth',
    },
    {
      code: '071405009036',
      label: 'Emmelshausen',
      provincie: 7,
      slug: 'emmelshausen',
    },
    {
      code: '071405009043',
      label: 'Gondershausen',
      provincie: 7,
      slug: 'gondershausen',
    },
    {
      code: '071405009045',
      label: 'Halsenbach',
      provincie: 7,
      slug: 'halsenbach',
    },
    {
      code: '071405009047',
      label: 'Hausbay',
      provincie: 7,
      slug: 'hausbay',
    },
    {
      code: '071405009060',
      label: 'Hungenroth',
      provincie: 7,
      slug: 'hungenroth',
    },
    {
      code: '071405009063',
      label: 'Karbach',
      provincie: 7,
      slug: 'karbach',
    },
    {
      code: '071405009075',
      label: 'Kratzenburg',
      provincie: 7,
      slug: 'kratzenburg',
    },
    {
      code: '071405009080',
      label: 'Laudert',
      provincie: 7,
      slug: 'laudert',
    },
    {
      code: '071405009084',
      label: 'Leiningen',
      provincie: 7,
      slug: 'leiningen',
    },
    {
      code: '071405009087',
      label: 'Lingerhahn',
      provincie: 7,
      slug: 'lingerhahn',
    },
    {
      code: '071405009089',
      label: 'Maisborn',
      provincie: 7,
      slug: 'maisborn',
    },
    {
      code: '071405009093',
      label: 'Mermuth',
      provincie: 7,
      slug: 'mermuth',
    },
    {
      code: '071405009098',
      label: 'Mühlpfad',
      provincie: 7,
      slug: 'muehlpfad',
    },
    {
      code: '071405009102',
      label: 'Ney',
      provincie: 7,
      slug: 'ney',
    },
    {
      code: '071405009104',
      label: 'Niederburg',
      provincie: 7,
      slug: 'niederburg',
    },
    {
      code: '071405009108',
      label: 'Niedert',
      provincie: 7,
      slug: 'niedert',
    },
    {
      code: '071405009110',
      label: 'Norath',
      provincie: 7,
      slug: 'norath',
    },
    {
      code: '071405009112',
      label: 'Oberwesel',
      provincie: 7,
      slug: 'oberwesel',
    },
    {
      code: '071405009116',
      label: 'Perscheid',
      provincie: 7,
      slug: 'perscheid',
    },
    {
      code: '071405009117',
      label: 'Pfalzfeld',
      provincie: 7,
      slug: 'pfalzfeld',
    },
    {
      code: '071405009133',
      label: 'Sankt Goar',
      provincie: 7,
      slug: 'sankt-goar',
    },
    {
      code: '071405009140',
      label: 'Schwall',
      provincie: 7,
      slug: 'schwall',
    },
    {
      code: '071405009149',
      label: 'Thörlingen',
      provincie: 7,
      slug: 'thoerlingen',
    },
    {
      code: '071405009155',
      label: 'Urbar',
      provincie: 7,
      slug: 'urbar-gemeinde',
    },
    {
      code: '071405009156',
      label: 'Utzenhain',
      provincie: 7,
      slug: 'utzenhain',
    },
    {
      code: '071405009161',
      label: 'Wiebelsheim',
      provincie: 7,
      slug: 'wiebelsheim',
    },
    {
      code: '071405009201',
      label: 'Beulich',
      provincie: 7,
      slug: 'beulich',
    },
    {
      code: '071405009205',
      label: 'Morshausen',
      provincie: 7,
      slug: 'morshausen',
    },
    {
      code: '071410075075',
      label: 'Lahnstein',
      provincie: 7,
      slug: 'lahnstein',
    },
    {
      code: '071415003002',
      label: 'Altendiez',
      provincie: 7,
      slug: 'altendiez',
    },
    {
      code: '071415003005',
      label: 'Aull',
      provincie: 7,
      slug: 'aull',
    },
    {
      code: '071415003014',
      label: 'Birlenbach',
      provincie: 7,
      slug: 'birlenbach',
    },
    {
      code: '071415003021',
      label: 'Charlottenberg',
      provincie: 7,
      slug: 'charlottenberg',
    },
    {
      code: '071415003022',
      label: 'Cramberg',
      provincie: 7,
      slug: 'cramberg',
    },
    {
      code: '071415003029',
      label: 'Diez',
      provincie: 7,
      slug: 'diez',
    },
    {
      code: '071415003030',
      label: 'Dörnberg',
      provincie: 7,
      slug: 'doernberg',
    },
    {
      code: '071415003038',
      label: 'Eppenrod',
      provincie: 7,
      slug: 'eppenrod',
    },
    {
      code: '071415003045',
      label: 'Geilnau',
      provincie: 7,
      slug: 'geilnau',
    },
    {
      code: '071415003049',
      label: 'Gückingen',
      provincie: 7,
      slug: 'gueckingen',
    },
    {
      code: '071415003052',
      label: 'Hambach',
      provincie: 7,
      slug: 'hambach',
    },
    {
      code: '071415003053',
      label: 'Heistenbach',
      provincie: 7,
      slug: 'heistenbach',
    },
    {
      code: '071415003057',
      label: 'Hirschberg',
      provincie: 7,
      slug: 'hirschberg',
    },
    {
      code: '071415003059',
      label: 'Holzappel',
      provincie: 7,
      slug: 'holzappel',
    },
    {
      code: '071415003061',
      label: 'Holzheim',
      provincie: 7,
      slug: 'holzheim',
    },
    {
      code: '071415003062',
      label: 'Horhausen',
      provincie: 7,
      slug: 'horhausen',
    },
    {
      code: '071415003064',
      label: 'Isselbach',
      provincie: 7,
      slug: 'isselbach',
    },
    {
      code: '071415003076',
      label: 'Langenscheid',
      provincie: 7,
      slug: 'langenscheid',
    },
    {
      code: '071415003077',
      label: 'Laurenburg',
      provincie: 7,
      slug: 'laurenburg',
    },
    {
      code: '071415003124',
      label: 'Scheidt',
      provincie: 7,
      slug: 'scheidt',
    },
    {
      code: '071415003130',
      label: 'Steinsberg',
      provincie: 7,
      slug: 'steinsberg',
    },
    {
      code: '071415003133',
      label: 'Wasenbach',
      provincie: 7,
      slug: 'wasenbach',
    },
    {
      code: '071415003503',
      label: 'Balduinstein',
      provincie: 7,
      slug: 'balduinstein',
    },
    {
      code: '071415007009',
      label: 'Berg',
      provincie: 7,
      slug: 'berg-gemeinde',
    },
    {
      code: '071415007012',
      label: 'Bettendorf',
      provincie: 7,
      slug: 'bettendorf',
    },
    {
      code: '071415007015',
      label: 'Bogel',
      provincie: 7,
      slug: 'bogel',
    },
    {
      code: '071415007019',
      label: 'Buch',
      provincie: 7,
      slug: 'buch-gemeinde',
    },
    {
      code: '071415007035',
      label: 'Ehr',
      provincie: 7,
      slug: 'ehr',
    },
    {
      code: '071415007037',
      label: 'Endlichhofen',
      provincie: 7,
      slug: 'endlichhofen',
    },
    {
      code: '071415007040',
      label: 'Eschbach',
      provincie: 7,
      slug: 'eschbach',
    },
    {
      code: '071415007047',
      label: 'Gemmerich',
      provincie: 7,
      slug: 'gemmerich',
    },
    {
      code: '071415007055',
      label: 'Himmighofen',
      provincie: 7,
      slug: 'himmighofen',
    },
    {
      code: '071415007060',
      label: 'Holzhausen an der Haide',
      provincie: 7,
      slug: 'holzhausen-an-der-haide',
    },
    {
      code: '071415007063',
      label: 'Hunzel',
      provincie: 7,
      slug: 'hunzel',
    },
    {
      code: '071415007067',
      label: 'Kasdorf',
      provincie: 7,
      slug: 'kasdorf',
    },
    {
      code: '071415007070',
      label: 'Kehlbach',
      provincie: 7,
      slug: 'kehlbach',
    },
    {
      code: '071415007078',
      label: 'Lautert',
      provincie: 7,
      slug: 'lautert',
    },
    {
      code: '071415007080',
      label: 'Lipporn',
      provincie: 7,
      slug: 'lipporn',
    },
    {
      code: '071415007084',
      label: 'Marienfels',
      provincie: 7,
      slug: 'marienfels',
    },
    {
      code: '071415007085',
      label: 'Miehlen',
      provincie: 7,
      slug: 'miehlen',
    },
    {
      code: '071415007092',
      label: 'Nastätten',
      provincie: 7,
      slug: 'nastaetten',
    },
    {
      code: '071415007094',
      label: 'Niederbachheim',
      provincie: 7,
      slug: 'niederbachheim',
    },
    {
      code: '071415007097',
      label: 'Niederwallmenach',
      provincie: 7,
      slug: 'niederwallmenach',
    },
    {
      code: '071415007100',
      label: 'Oberbachheim',
      provincie: 7,
      slug: 'oberbachheim',
    },
    {
      code: '071415007104',
      label: 'Obertiefenbach',
      provincie: 7,
      slug: 'obertiefenbach',
    },
    {
      code: '071415007105',
      label: 'Oberwallmenach',
      provincie: 7,
      slug: 'oberwallmenach',
    },
    {
      code: '071415007107',
      label: 'Oelsberg',
      provincie: 7,
      slug: 'oelsberg',
    },
    {
      code: '071415007110',
      label: 'Hainau',
      provincie: 7,
      slug: 'hainau',
    },
    {
      code: '071415007116',
      label: 'Rettershain',
      provincie: 7,
      slug: 'rettershain',
    },
    {
      code: '071415007120',
      label: 'Ruppertshofen',
      provincie: 7,
      slug: 'ruppertshofen',
    },
    {
      code: '071415007131',
      label: 'Strüth',
      provincie: 7,
      slug: 'strueth',
    },
    {
      code: '071415007134',
      label: 'Weidenbach',
      provincie: 7,
      slug: 'weidenbach',
    },
    {
      code: '071415007137',
      label: 'Welterod',
      provincie: 7,
      slug: 'welterod',
    },
    {
      code: '071415007140',
      label: 'Winterwerb',
      provincie: 7,
      slug: 'winterwerb',
    },
    {
      code: '071415007502',
      label: 'Diethardt',
      provincie: 7,
      slug: 'diethardt',
    },
    {
      code: '071415009004',
      label: 'Auel',
      provincie: 7,
      slug: 'auel',
    },
    {
      code: '071415009016',
      label: 'Bornich',
      provincie: 7,
      slug: 'bornich',
    },
    {
      code: '071415009023',
      label: 'Dachsenhausen',
      provincie: 7,
      slug: 'dachsenhausen',
    },
    {
      code: '071415009024',
      label: 'Dahlheim',
      provincie: 7,
      slug: 'dahlheim',
    },
    {
      code: '071415009031',
      label: 'Dörscheid',
      provincie: 7,
      slug: 'doerscheid',
    },
    {
      code: '071415009042',
      label: 'Filsen',
      provincie: 7,
      slug: 'filsen',
    },
    {
      code: '071415009066',
      label: 'Kamp-Bornhofen',
      provincie: 7,
      slug: 'kamp-bornhofen',
    },
    {
      code: '071415009069',
      label: 'Kaub',
      provincie: 7,
      slug: 'kaub',
    },
    {
      code: '071415009072',
      label: 'Kestert',
      provincie: 7,
      slug: 'kestert',
    },
    {
      code: '071415009079',
      label: 'Lierschied',
      provincie: 7,
      slug: 'lierschied',
    },
    {
      code: '071415009083',
      label: 'Lykershausen',
      provincie: 7,
      slug: 'lykershausen',
    },
    {
      code: '071415009099',
      label: 'Nochern',
      provincie: 7,
      slug: 'nochern',
    },
    {
      code: '071415009108',
      label: 'Osterspai',
      provincie: 7,
      slug: 'osterspai',
    },
    {
      code: '071415009109',
      label: 'Patersberg',
      provincie: 7,
      slug: 'patersberg',
    },
    {
      code: '071415009112',
      label: 'Prath',
      provincie: 7,
      slug: 'prath',
    },
    {
      code: '071415009114',
      label: 'Reichenberg',
      provincie: 7,
      slug: 'reichenberg',
    },
    {
      code: '071415009115',
      label: 'Reitzenhain',
      provincie: 7,
      slug: 'reitzenhain',
    },
    {
      code: '071415009121',
      label: 'Sankt Goarshausen',
      provincie: 7,
      slug: 'sankt-goarshausen',
    },
    {
      code: '071415009122',
      label: 'Sauerthal',
      provincie: 7,
      slug: 'sauerthal',
    },
    {
      code: '071415009136',
      label: 'Weisel',
      provincie: 7,
      slug: 'weisel',
    },
    {
      code: '071415009138',
      label: 'Weyer',
      provincie: 7,
      slug: 'weyer',
    },
    {
      code: '071415009501',
      label: 'Braubach',
      provincie: 7,
      slug: 'braubach',
    },
    {
      code: '071415010003',
      label: 'Attenhausen',
      provincie: 7,
      slug: 'attenhausen',
    },
    {
      code: '071415010006',
      label: 'Bad Ems',
      provincie: 7,
      slug: 'bad-ems',
    },
    {
      code: '071415010008',
      label: 'Becheln',
      provincie: 7,
      slug: 'becheln',
    },
    {
      code: '071415010025',
      label: 'Dausenau',
      provincie: 7,
      slug: 'dausenau',
    },
    {
      code: '071415010026',
      label: 'Dessighofen',
      provincie: 7,
      slug: 'dessighofen',
    },
    {
      code: '071415010027',
      label: 'Dienethal',
      provincie: 7,
      slug: 'dienethal',
    },
    {
      code: '071415010033',
      label: 'Dornholzhausen',
      provincie: 7,
      slug: 'dornholzhausen',
    },
    {
      code: '071415010041',
      label: 'Fachbach',
      provincie: 7,
      slug: 'fachbach',
    },
    {
      code: '071415010044',
      label: 'Frücht',
      provincie: 7,
      slug: 'fruecht',
    },
    {
      code: '071415010046',
      label: 'Geisig',
      provincie: 7,
      slug: 'geisig',
    },
    {
      code: '071415010058',
      label: 'Hömberg',
      provincie: 7,
      slug: 'hoemberg',
    },
    {
      code: '071415010071',
      label: 'Kemmenau',
      provincie: 7,
      slug: 'kemmenau',
    },
    {
      code: '071415010082',
      label: 'Lollschied',
      provincie: 7,
      slug: 'lollschied',
    },
    {
      code: '071415010086',
      label: 'Miellen',
      provincie: 7,
      slug: 'miellen',
    },
    {
      code: '071415010087',
      label: 'Misselberg',
      provincie: 7,
      slug: 'misselberg',
    },
    {
      code: '071415010091',
      label: 'Nassau',
      provincie: 7,
      slug: 'nassau',
    },
    {
      code: '071415010098',
      label: 'Nievern',
      provincie: 7,
      slug: 'nievern',
    },
    {
      code: '071415010103',
      label: 'Obernhof',
      provincie: 7,
      slug: 'obernhof',
    },
    {
      code: '071415010106',
      label: 'Oberwies',
      provincie: 7,
      slug: 'oberwies',
    },
    {
      code: '071415010111',
      label: 'Pohl',
      provincie: 7,
      slug: 'pohl',
    },
    {
      code: '071415010127',
      label: 'Schweighausen',
      provincie: 7,
      slug: 'schweighausen',
    },
    {
      code: '071415010128',
      label: 'Seelbach',
      provincie: 7,
      slug: 'seelbach',
    },
    {
      code: '071415010129',
      label: 'Singhofen',
      provincie: 7,
      slug: 'singhofen',
    },
    {
      code: '071415010132',
      label: 'Sulzbach',
      provincie: 7,
      slug: 'sulzbach-gemeinde',
    },
    {
      code: '071415010135',
      label: 'Weinähr',
      provincie: 7,
      slug: 'weinaehr',
    },
    {
      code: '071415010139',
      label: 'Winden',
      provincie: 7,
      slug: 'winden',
    },
    {
      code: '071415010141',
      label: 'Zimmerschied',
      provincie: 7,
      slug: 'zimmerschied',
    },
    {
      code: '071415010201',
      label: 'Arzbach',
      provincie: 7,
      slug: 'arzbach',
    },
    {
      code: '071415011001',
      label: 'Allendorf',
      provincie: 7,
      slug: 'allendorf',
    },
    {
      code: '071415011010',
      label: 'Berghausen',
      provincie: 7,
      slug: 'berghausen',
    },
    {
      code: '071415011011',
      label: 'Berndroth',
      provincie: 7,
      slug: 'berndroth',
    },
    {
      code: '071415011013',
      label: 'Biebrich',
      provincie: 7,
      slug: 'biebrich',
    },
    {
      code: '071415011018',
      label: 'Bremberg',
      provincie: 7,
      slug: 'bremberg',
    },
    {
      code: '071415011020',
      label: 'Burgschwalbach',
      provincie: 7,
      slug: 'burgschwalbach',
    },
    {
      code: '071415011032',
      label: 'Dörsdorf',
      provincie: 7,
      slug: 'doersdorf',
    },
    {
      code: '071415011034',
      label: 'Ebertshausen',
      provincie: 7,
      slug: 'ebertshausen',
    },
    {
      code: '071415011036',
      label: 'Eisighofen',
      provincie: 7,
      slug: 'eisighofen',
    },
    {
      code: '071415011039',
      label: 'Ergeshausen',
      provincie: 7,
      slug: 'ergeshausen',
    },
    {
      code: '071415011043',
      label: 'Flacht',
      provincie: 7,
      slug: 'flacht',
    },
    {
      code: '071415011050',
      label: 'Gutenacker',
      provincie: 7,
      slug: 'gutenacker',
    },
    {
      code: '071415011051',
      label: 'Hahnstätten',
      provincie: 7,
      slug: 'hahnstaetten',
    },
    {
      code: '071415011054',
      label: 'Herold',
      provincie: 7,
      slug: 'herold',
    },
    {
      code: '071415011065',
      label: 'Kaltenholzhausen',
      provincie: 7,
      slug: 'kaltenholzhausen',
    },
    {
      code: '071415011068',
      label: 'Katzenelnbogen',
      provincie: 7,
      slug: 'katzenelnbogen',
    },
    {
      code: '071415011073',
      label: 'Klingelbach',
      provincie: 7,
      slug: 'klingelbach',
    },
    {
      code: '071415011074',
      label: 'Kördorf',
      provincie: 7,
      slug: 'koerdorf',
    },
    {
      code: '071415011081',
      label: 'Lohrheim',
      provincie: 7,
      slug: 'lohrheim',
    },
    {
      code: '071415011088',
      label: 'Mittelfischbach',
      provincie: 7,
      slug: 'mittelfischbach',
    },
    {
      code: '071415011089',
      label: 'Mudershausen',
      provincie: 7,
      slug: 'mudershausen',
    },
    {
      code: '071415011093',
      label: 'Netzbach',
      provincie: 7,
      slug: 'netzbach',
    },
    {
      code: '071415011095',
      label: 'Niederneisen',
      provincie: 7,
      slug: 'niederneisen',
    },
    {
      code: '071415011096',
      label: 'Niedertiefenbach',
      provincie: 7,
      slug: 'niedertiefenbach',
    },
    {
      code: '071415011101',
      label: 'Oberfischbach',
      provincie: 7,
      slug: 'oberfischbach',
    },
    {
      code: '071415011102',
      label: 'Oberneisen',
      provincie: 7,
      slug: 'oberneisen',
    },
    {
      code: '071415011113',
      label: 'Reckenroth',
      provincie: 7,
      slug: 'reckenroth',
    },
    {
      code: '071415011117',
      label: 'Rettert',
      provincie: 7,
      slug: 'rettert',
    },
    {
      code: '071415011118',
      label: 'Roth',
      provincie: 7,
      slug: 'roth-gemeinde',
    },
    {
      code: '071415011125',
      label: 'Schiesheim',
      provincie: 7,
      slug: 'schiesheim',
    },
    {
      code: '071415011126',
      label: 'Schönborn',
      provincie: 7,
      slug: 'schoenborn-gemeinde',
    },
    {
      code: '071435001206',
      label: 'Bad Marienberg (Westerwald)',
      provincie: 7,
      slug: 'bad-marienberg-westerwald',
    },
    {
      code: '071435001211',
      label: 'Bölsberg',
      provincie: 7,
      slug: 'boelsberg',
    },
    {
      code: '071435001216',
      label: 'Dreisbach',
      provincie: 7,
      slug: 'dreisbach',
    },
    {
      code: '071435001222',
      label: 'Fehl-Ritzhausen',
      provincie: 7,
      slug: 'fehl-ritzhausen',
    },
    {
      code: '071435001227',
      label: 'Großseifen',
      provincie: 7,
      slug: 'grossseifen',
    },
    {
      code: '071435001231',
      label: 'Hahn bei Marienberg',
      provincie: 7,
      slug: 'hahn-bei-marienberg',
    },
    {
      code: '071435001234',
      label: 'Hardt',
      provincie: 7,
      slug: 'hardt',
    },
    {
      code: '071435001243',
      label: 'Hof',
      provincie: 7,
      slug: 'hof',
    },
    {
      code: '071435001248',
      label: 'Kirburg',
      provincie: 7,
      slug: 'kirburg',
    },
    {
      code: '071435001253',
      label: 'Langenbach bei Kirburg',
      provincie: 7,
      slug: 'langenbach-bei-kirburg',
    },
    {
      code: '071435001255',
      label: 'Lautzenbrücken',
      provincie: 7,
      slug: 'lautzenbruecken',
    },
    {
      code: '071435001264',
      label: 'Mörlen',
      provincie: 7,
      slug: 'moerlen',
    },
    {
      code: '071435001270',
      label: 'Neunkhausen',
      provincie: 7,
      slug: 'neunkhausen',
    },
    {
      code: '071435001277',
      label: 'Nisterau',
      provincie: 7,
      slug: 'nisterau',
    },
    {
      code: '071435001279',
      label: 'Nistertal',
      provincie: 7,
      slug: 'nistertal',
    },
    {
      code: '071435001280',
      label: 'Norken',
      provincie: 7,
      slug: 'norken',
    },
    {
      code: '071435001297',
      label: 'Stockhausen-Illfurth',
      provincie: 7,
      slug: 'stockhausen-illfurth',
    },
    {
      code: '071435001300',
      label: 'Unnau',
      provincie: 7,
      slug: 'unnau',
    },
    {
      code: '071435002202',
      label: 'Alpenrod',
      provincie: 7,
      slug: 'alpenrod',
    },
    {
      code: '071435002204',
      label: 'Astert',
      provincie: 7,
      slug: 'astert',
    },
    {
      code: '071435002205',
      label: 'Atzelgift',
      provincie: 7,
      slug: 'atzelgift',
    },
    {
      code: '071435002212',
      label: 'Borod',
      provincie: 7,
      slug: 'borod',
    },
    {
      code: '071435002215',
      label: 'Dreifelden',
      provincie: 7,
      slug: 'dreifelden',
    },
    {
      code: '071435002223',
      label: 'Gehlert',
      provincie: 7,
      slug: 'gehlert',
    },
    {
      code: '071435002225',
      label: 'Giesenhausen',
      provincie: 7,
      slug: 'giesenhausen',
    },
    {
      code: '071435002229',
      label: 'Hachenburg',
      provincie: 7,
      slug: 'hachenburg',
    },
    {
      code: '071435002235',
      label: 'Hattert',
      provincie: 7,
      slug: 'hattert',
    },
    {
      code: '071435002236',
      label: 'Heimborn',
      provincie: 7,
      slug: 'heimborn',
    },
    {
      code: '071435002240',
      label: 'Heuzert',
      provincie: 7,
      slug: 'heuzert',
    },
    {
      code: '071435002241',
      label: 'Höchstenbach',
      provincie: 7,
      slug: 'hoechstenbach',
    },
    {
      code: '071435002250',
      label: 'Kroppach',
      provincie: 7,
      slug: 'kroppach',
    },
    {
      code: '071435002252',
      label: 'Kundert',
      provincie: 7,
      slug: 'kundert',
    },
    {
      code: '071435002257',
      label: 'Limbach',
      provincie: 7,
      slug: 'limbach-gemeinde',
    },
    {
      code: '071435002258',
      label: 'Linden',
      provincie: 7,
      slug: 'linden-gemeinde',
    },
    {
      code: '071435002259',
      label: 'Lochum',
      provincie: 7,
      slug: 'lochum',
    },
    {
      code: '071435002260',
      label: 'Luckenbach',
      provincie: 7,
      slug: 'luckenbach',
    },
    {
      code: '071435002261',
      label: 'Marzhausen',
      provincie: 7,
      slug: 'marzhausen',
    },
    {
      code: '071435002262',
      label: 'Merkelbach',
      provincie: 7,
      slug: 'merkelbach',
    },
    {
      code: '071435002265',
      label: 'Mörsbach',
      provincie: 7,
      slug: 'moersbach',
    },
    {
      code: '071435002267',
      label: 'Mudenbach',
      provincie: 7,
      slug: 'mudenbach',
    },
    {
      code: '071435002268',
      label: 'Mündersbach',
      provincie: 7,
      slug: 'muendersbach',
    },
    {
      code: '071435002269',
      label: 'Müschenbach',
      provincie: 7,
      slug: 'mueschenbach',
    },
    {
      code: '071435002276',
      label: 'Nister',
      provincie: 7,
      slug: 'nister',
    },
    {
      code: '071435002287',
      label: 'Roßbach',
      provincie: 7,
      slug: 'rossbach-gemeinde',
    },
    {
      code: '071435002294',
      label: 'Steinebach an der Wied',
      provincie: 7,
      slug: 'steinebach-an-der-wied',
    },
    {
      code: '071435002296',
      label: 'Stein-Wingert',
      provincie: 7,
      slug: 'stein-wingert',
    },
    {
      code: '071435002299',
      label: 'Streithausen',
      provincie: 7,
      slug: 'streithausen',
    },
    {
      code: '071435002301',
      label: 'Wahlrod',
      provincie: 7,
      slug: 'wahlrod',
    },
    {
      code: '071435002306',
      label: 'Welkenbach',
      provincie: 7,
      slug: 'welkenbach',
    },
    {
      code: '071435002310',
      label: 'Wied',
      provincie: 7,
      slug: 'wied',
    },
    {
      code: '071435002313',
      label: 'Winkelbach',
      provincie: 7,
      slug: 'winkelbach',
    },
    {
      code: '071435003030',
      label: 'Hilgert',
      provincie: 7,
      slug: 'hilgert',
    },
    {
      code: '071435003031',
      label: 'Hillscheid',
      provincie: 7,
      slug: 'hillscheid',
    },
    {
      code: '071435003032',
      label: 'Höhr-Grenzhausen',
      provincie: 7,
      slug: 'hoehr-grenzhausen',
    },
    {
      code: '071435003040',
      label: 'Kammerforst',
      provincie: 7,
      slug: 'kammerforst',
    },
    {
      code: '071435004005',
      label: 'Boden',
      provincie: 7,
      slug: 'boden',
    },
    {
      code: '071435004008',
      label: 'Daubach',
      provincie: 7,
      slug: 'daubach-gemeinde',
    },
    {
      code: '071435004013',
      label: 'Eitelborn',
      provincie: 7,
      slug: 'eitelborn',
    },
    {
      code: '071435004020',
      label: 'Gackenbach',
      provincie: 7,
      slug: 'gackenbach',
    },
    {
      code: '071435004021',
      label: 'Girod',
      provincie: 7,
      slug: 'girod',
    },
    {
      code: '071435004023',
      label: 'Görgeshausen',
      provincie: 7,
      slug: 'goergeshausen',
    },
    {
      code: '071435004024',
      label: 'Großholbach',
      provincie: 7,
      slug: 'grossholbach',
    },
    {
      code: '071435004026',
      label: 'Heilberscheid',
      provincie: 7,
      slug: 'heilberscheid',
    },
    {
      code: '071435004027',
      label: 'Heiligenroth',
      provincie: 7,
      slug: 'heiligenroth',
    },
    {
      code: '071435004033',
      label: 'Holler',
      provincie: 7,
      slug: 'holler',
    },
    {
      code: '071435004034',
      label: 'Horbach',
      provincie: 7,
      slug: 'horbach-gemeinde',
    },
    {
      code: '071435004036',
      label: 'Hübingen',
      provincie: 7,
      slug: 'huebingen',
    },
    {
      code: '071435004039',
      label: 'Kadenbach',
      provincie: 7,
      slug: 'kadenbach',
    },
    {
      code: '071435004048',
      label: 'Montabaur',
      provincie: 7,
      slug: 'montabaur',
    },
    {
      code: '071435004051',
      label: 'Nentershausen',
      provincie: 7,
      slug: 'nentershausen-gemeinde',
    },
    {
      code: '071435004052',
      label: 'Neuhäusel',
      provincie: 7,
      slug: 'neuhaeusel',
    },
    {
      code: '071435004053',
      label: 'Niederelbert',
      provincie: 7,
      slug: 'niederelbert',
    },
    {
      code: '071435004054',
      label: 'Niedererbach',
      provincie: 7,
      slug: 'niedererbach',
    },
    {
      code: '071435004055',
      label: 'Nomborn',
      provincie: 7,
      slug: 'nomborn',
    },
    {
      code: '071435004057',
      label: 'Oberelbert',
      provincie: 7,
      slug: 'oberelbert',
    },
    {
      code: '071435004065',
      label: 'Ruppach-Goldhausen',
      provincie: 7,
      slug: 'ruppach-goldhausen',
    },
    {
      code: '071435004071',
      label: 'Simmern',
      provincie: 7,
      slug: 'simmern',
    },
    {
      code: '071435004072',
      label: 'Stahlhofen',
      provincie: 7,
      slug: 'stahlhofen',
    },
    {
      code: '071435004077',
      label: 'Untershausen',
      provincie: 7,
      slug: 'untershausen',
    },
    {
      code: '071435004079',
      label: 'Welschneudorf',
      provincie: 7,
      slug: 'welschneudorf',
    },
    {
      code: '071435005001',
      label: 'Alsbach',
      provincie: 7,
      slug: 'alsbach',
    },
    {
      code: '071435005006',
      label: 'Breitenau',
      provincie: 7,
      slug: 'breitenau',
    },
    {
      code: '071435005007',
      label: 'Caan',
      provincie: 7,
      slug: 'caan',
    },
    {
      code: '071435005009',
      label: 'Deesen',
      provincie: 7,
      slug: 'deesen',
    },
    {
      code: '071435005038',
      label: 'Hundsdorf',
      provincie: 7,
      slug: 'hundsdorf',
    },
    {
      code: '071435005050',
      label: 'Nauort',
      provincie: 7,
      slug: 'nauort',
    },
    {
      code: '071435005059',
      label: 'Oberhaid',
      provincie: 7,
      slug: 'oberhaid',
    },
    {
      code: '071435005062',
      label: 'Ransbach-Baumbach',
      provincie: 7,
      slug: 'ransbach-baumbach',
    },
    {
      code: '071435005068',
      label: 'Sessenbach',
      provincie: 7,
      slug: 'sessenbach',
    },
    {
      code: '071435005082',
      label: 'Wirscheid',
      provincie: 7,
      slug: 'wirscheid',
    },
    {
      code: '071435005084',
      label: 'Wittgert',
      provincie: 7,
      slug: 'wittgert',
    },
    {
      code: '071435006214',
      label: 'Bretthausen',
      provincie: 7,
      slug: 'bretthausen',
    },
    {
      code: '071435006218',
      label: 'Elsoff (Westerwald)',
      provincie: 7,
      slug: 'elsoff-westerwald',
    },
    {
      code: '071435006237',
      label: 'Hellenhahn-Schellenberg',
      provincie: 7,
      slug: 'hellenhahn-schellenberg',
    },
    {
      code: '071435006244',
      label: 'Homberg',
      provincie: 7,
      slug: 'homberg',
    },
    {
      code: '071435006245',
      label: 'Hüblingen',
      provincie: 7,
      slug: 'hueblingen',
    },
    {
      code: '071435006246',
      label: 'Irmtraut',
      provincie: 7,
      slug: 'irmtraut',
    },
    {
      code: '071435006256',
      label: 'Liebenscheid',
      provincie: 7,
      slug: 'liebenscheid',
    },
    {
      code: '071435006271',
      label: 'Neunkirchen',
      provincie: 7,
      slug: 'neunkirchen-gemeinde',
    },
    {
      code: '071435006272',
      label: 'Neustadt/Westerwald',
      provincie: 7,
      slug: 'neustadt-westerwald',
    },
    {
      code: '071435006274',
      label: 'Niederroßbach',
      provincie: 7,
      slug: 'niederrossbach',
    },
    {
      code: '071435006278',
      label: 'Nister-Möhrendorf',
      provincie: 7,
      slug: 'nister-moehrendorf',
    },
    {
      code: '071435006282',
      label: 'Oberrod',
      provincie: 7,
      slug: 'oberrod',
    },
    {
      code: '071435006283',
      label: 'Oberroßbach',
      provincie: 7,
      slug: 'oberrossbach',
    },
    {
      code: '071435006285',
      label: 'Rehe',
      provincie: 7,
      slug: 'rehe',
    },
    {
      code: '071435006286',
      label: 'Rennerod',
      provincie: 7,
      slug: 'rennerod',
    },
    {
      code: '071435006291',
      label: 'Salzburg',
      provincie: 7,
      slug: 'salzburg',
    },
    {
      code: '071435006292',
      label: 'Seck',
      provincie: 7,
      slug: 'seck',
    },
    {
      code: '071435006295',
      label: 'Stein-Neukirch',
      provincie: 7,
      slug: 'stein-neukirch',
    },
    {
      code: '071435006302',
      label: 'Waigandshain',
      provincie: 7,
      slug: 'waigandshain',
    },
    {
      code: '071435006303',
      label: 'Waldmühlen',
      provincie: 7,
      slug: 'waldmuehlen',
    },
    {
      code: '071435006309',
      label: 'Westernohe',
      provincie: 7,
      slug: 'westernohe',
    },
    {
      code: '071435006311',
      label: 'Willingen',
      provincie: 7,
      slug: 'willingen',
    },
    {
      code: '071435006315',
      label: 'Zehnhausen bei Rennerod',
      provincie: 7,
      slug: 'zehnhausen-bei-rennerod',
    },
    {
      code: '071435007015',
      label: 'Ellenhausen',
      provincie: 7,
      slug: 'ellenhausen',
    },
    {
      code: '071435007018',
      label: 'Freilingen',
      provincie: 7,
      slug: 'freilingen',
    },
    {
      code: '071435007019',
      label: 'Freirachdorf',
      provincie: 7,
      slug: 'freirachdorf',
    },
    {
      code: '071435007022',
      label: 'Goddert',
      provincie: 7,
      slug: 'goddert',
    },
    {
      code: '071435007025',
      label: 'Hartenfels',
      provincie: 7,
      slug: 'hartenfels',
    },
    {
      code: '071435007029',
      label: 'Herschbach',
      provincie: 7,
      slug: 'herschbach',
    },
    {
      code: '071435007041',
      label: 'Krümmel',
      provincie: 7,
      slug: 'kruemmel',
    },
    {
      code: '071435007044',
      label: 'Marienrachdorf',
      provincie: 7,
      slug: 'marienrachdorf',
    },
    {
      code: '071435007045',
      label: 'Maroth',
      provincie: 7,
      slug: 'maroth',
    },
    {
      code: '071435007046',
      label: 'Maxsain',
      provincie: 7,
      slug: 'maxsain',
    },
    {
      code: '071435007056',
      label: 'Nordhofen',
      provincie: 7,
      slug: 'nordhofen',
    },
    {
      code: '071435007061',
      label: 'Quirnbach',
      provincie: 7,
      slug: 'quirnbach',
    },
    {
      code: '071435007064',
      label: 'Rückeroth',
      provincie: 7,
      slug: 'rueckeroth',
    },
    {
      code: '071435007066',
      label: 'Schenkelberg',
      provincie: 7,
      slug: 'schenkelberg',
    },
    {
      code: '071435007067',
      label: 'Selters (Westerwald)',
      provincie: 7,
      slug: 'selters-westerwald',
    },
    {
      code: '071435007069',
      label: 'Sessenhausen',
      provincie: 7,
      slug: 'sessenhausen',
    },
    {
      code: '071435007075',
      label: 'Steinen',
      provincie: 7,
      slug: 'steinen',
    },
    {
      code: '071435007078',
      label: 'Vielbach',
      provincie: 7,
      slug: 'vielbach',
    },
    {
      code: '071435007085',
      label: 'Wölferlingen',
      provincie: 7,
      slug: 'woelferlingen',
    },
    {
      code: '071435007221',
      label: 'Ewighausen',
      provincie: 7,
      slug: 'ewighausen',
    },
    {
      code: '071435007305',
      label: 'Weidenhahn',
      provincie: 7,
      slug: 'weidenhahn',
    },
    {
      code: '071435008011',
      label: 'Dreikirchen',
      provincie: 7,
      slug: 'dreikirchen',
    },
    {
      code: '071435008037',
      label: 'Hundsangen',
      provincie: 7,
      slug: 'hundsangen',
    },
    {
      code: '071435008058',
      label: 'Obererbach',
      provincie: 7,
      slug: 'obererbach',
    },
    {
      code: '071435008074',
      label: 'Steinefrenz',
      provincie: 7,
      slug: 'steinefrenz',
    },
    {
      code: '071435008080',
      label: 'Weroth',
      provincie: 7,
      slug: 'weroth',
    },
    {
      code: '071435008203',
      label: 'Arnshöfen',
      provincie: 7,
      slug: 'arnshoefen',
    },
    {
      code: '071435008208',
      label: 'Berod bei Wallmerod',
      provincie: 7,
      slug: 'berod-bei-wallmerod',
    },
    {
      code: '071435008210',
      label: 'Bilkheim',
      provincie: 7,
      slug: 'bilkheim',
    },
    {
      code: '071435008220',
      label: 'Ettinghausen',
      provincie: 7,
      slug: 'ettinghausen',
    },
    {
      code: '071435008232',
      label: 'Hahn am See',
      provincie: 7,
      slug: 'hahn-am-see',
    },
    {
      code: '071435008239',
      label: 'Herschbach (Oberwesterwald)',
      provincie: 7,
      slug: 'herschbach-oberwesterwald',
    },
    {
      code: '071435008251',
      label: 'Kuhnhöfen',
      provincie: 7,
      slug: 'kuhnhoefen',
    },
    {
      code: '071435008263',
      label: 'Meudt',
      provincie: 7,
      slug: 'meudt',
    },
    {
      code: '071435008266',
      label: 'Molsberg',
      provincie: 7,
      slug: 'molsberg',
    },
    {
      code: '071435008273',
      label: 'Niederahr',
      provincie: 7,
      slug: 'niederahr',
    },
    {
      code: '071435008281',
      label: 'Oberahr',
      provincie: 7,
      slug: 'oberahr',
    },
    {
      code: '071435008290',
      label: 'Salz',
      provincie: 7,
      slug: 'salz',
    },
    {
      code: '071435008304',
      label: 'Wallmerod',
      provincie: 7,
      slug: 'wallmerod',
    },
    {
      code: '071435008316',
      label: 'Zehnhausen bei Wallmerod',
      provincie: 7,
      slug: 'zehnhausen-bei-wallmerod',
    },
    {
      code: '071435008501',
      label: 'Elbingen',
      provincie: 7,
      slug: 'elbingen',
    },
    {
      code: '071435008502',
      label: 'Mähren',
      provincie: 7,
      slug: 'maehren',
    },
    {
      code: '071435009200',
      label: 'Ailertchen',
      provincie: 7,
      slug: 'ailertchen',
    },
    {
      code: '071435009207',
      label: 'Bellingen',
      provincie: 7,
      slug: 'bellingen',
    },
    {
      code: '071435009209',
      label: 'Berzhahn',
      provincie: 7,
      slug: 'berzhahn',
    },
    {
      code: '071435009213',
      label: 'Brandscheid',
      provincie: 7,
      slug: 'brandscheid',
    },
    {
      code: '071435009219',
      label: 'Enspel',
      provincie: 7,
      slug: 'enspel',
    },
    {
      code: '071435009224',
      label: 'Gemünden',
      provincie: 7,
      slug: 'gemuenden-gemeinde',
    },
    {
      code: '071435009226',
      label: 'Girkenroth',
      provincie: 7,
      slug: 'girkenroth',
    },
    {
      code: '071435009228',
      label: 'Guckheim',
      provincie: 7,
      slug: 'guckheim',
    },
    {
      code: '071435009230',
      label: 'Härtlingen',
      provincie: 7,
      slug: 'haertlingen',
    },
    {
      code: '071435009233',
      label: 'Halbs',
      provincie: 7,
      slug: 'halbs',
    },
    {
      code: '071435009238',
      label: 'Hergenroth',
      provincie: 7,
      slug: 'hergenroth',
    },
    {
      code: '071435009242',
      label: 'Höhn',
      provincie: 7,
      slug: 'hoehn',
    },
    {
      code: '071435009247',
      label: 'Kaden',
      provincie: 7,
      slug: 'kaden',
    },
    {
      code: '071435009249',
      label: 'Kölbingen',
      provincie: 7,
      slug: 'koelbingen',
    },
    {
      code: '071435009254',
      label: 'Langenhahn',
      provincie: 7,
      slug: 'langenhahn',
    },
    {
      code: '071435009284',
      label: 'Pottum',
      provincie: 7,
      slug: 'pottum',
    },
    {
      code: '071435009288',
      label: 'Rotenhain',
      provincie: 7,
      slug: 'rotenhain',
    },
    {
      code: '071435009289',
      label: 'Rothenbach',
      provincie: 7,
      slug: 'rothenbach',
    },
    {
      code: '071435009293',
      label: 'Stahlhofen am Wiesensee',
      provincie: 7,
      slug: 'stahlhofen-am-wiesensee',
    },
    {
      code: '071435009298',
      label: 'Stockum-Püschen',
      provincie: 7,
      slug: 'stockum-pueschen',
    },
    {
      code: '071435009307',
      label: 'Weltersburg',
      provincie: 7,
      slug: 'weltersburg',
    },
    {
      code: '071435009308',
      label: 'Westerburg',
      provincie: 7,
      slug: 'westerburg',
    },
    {
      code: '071435009312',
      label: 'Willmenrod',
      provincie: 7,
      slug: 'willmenrod',
    },
    {
      code: '071435009314',
      label: 'Winnen',
      provincie: 7,
      slug: 'winnen',
    },
    {
      code: '071435010003',
      label: 'Bannberscheid',
      provincie: 7,
      slug: 'bannberscheid',
    },
    {
      code: '071435010010',
      label: 'Dernbach (Westerwald)',
      provincie: 7,
      slug: 'dernbach-westerwald',
    },
    {
      code: '071435010012',
      label: 'Ebernhahn',
      provincie: 7,
      slug: 'ebernhahn',
    },
    {
      code: '071435010028',
      label: 'Helferskirchen',
      provincie: 7,
      slug: 'helferskirchen',
    },
    {
      code: '071435010042',
      label: 'Leuterod',
      provincie: 7,
      slug: 'leuterod',
    },
    {
      code: '071435010047',
      label: 'Mogendorf',
      provincie: 7,
      slug: 'mogendorf',
    },
    {
      code: '071435010049',
      label: 'Moschheim',
      provincie: 7,
      slug: 'moschheim',
    },
    {
      code: '071435010060',
      label: 'Ötzingen',
      provincie: 7,
      slug: 'oetzingen',
    },
    {
      code: '071435010070',
      label: 'Siershahn',
      provincie: 7,
      slug: 'siershahn',
    },
    {
      code: '071435010073',
      label: 'Staudt',
      provincie: 7,
      slug: 'staudt',
    },
    {
      code: '071435010081',
      label: 'Wirges',
      provincie: 7,
      slug: 'wirges',
    },
    {
      code: '071435010275',
      label: 'Niedersayn',
      provincie: 7,
      slug: 'niedersayn',
    },
    {
      code: '072110000000',
      label: 'Trier',
      provincie: 7,
      slug: 'trier',
    },
    {
      code: '072310134134',
      label: 'Wittlich',
      provincie: 7,
      slug: 'wittlich',
    },
    {
      code: '072310502502',
      label: 'Morbach',
      provincie: 7,
      slug: 'morbach',
    },
    {
      code: '072315001008',
      label: 'Bernkastel-Kues',
      provincie: 7,
      slug: 'bernkastel-kues',
    },
    {
      code: '072315001012',
      label: 'Brauneberg',
      provincie: 7,
      slug: 'brauneberg',
    },
    {
      code: '072315001016',
      label: 'Burgen',
      provincie: 7,
      slug: 'burgen-gemeinde',
    },
    {
      code: '072315001030',
      label: 'Erden',
      provincie: 7,
      slug: 'erden',
    },
    {
      code: '072315001040',
      label: 'Gornhausen',
      provincie: 7,
      slug: 'gornhausen',
    },
    {
      code: '072315001041',
      label: 'Graach an der Mosel',
      provincie: 7,
      slug: 'graach-an-der-mosel',
    },
    {
      code: '072315001056',
      label: 'Hochscheid',
      provincie: 7,
      slug: 'hochscheid',
    },
    {
      code: '072315001066',
      label: 'Kesten',
      provincie: 7,
      slug: 'kesten',
    },
    {
      code: '072315001070',
      label: 'Kleinich',
      provincie: 7,
      slug: 'kleinich',
    },
    {
      code: '072315001071',
      label: 'Kommen',
      provincie: 7,
      slug: 'kommen',
    },
    {
      code: '072315001075',
      label: 'Lieser',
      provincie: 7,
      slug: 'lieser',
    },
    {
      code: '072315001076',
      label: 'Lösnich',
      provincie: 7,
      slug: 'loesnich',
    },
    {
      code: '072315001077',
      label: 'Longkamp',
      provincie: 7,
      slug: 'longkamp',
    },
    {
      code: '072315001081',
      label: 'Maring-Noviand',
      provincie: 7,
      slug: 'maring-noviand',
    },
    {
      code: '072315001086',
      label: 'Minheim',
      provincie: 7,
      slug: 'minheim',
    },
    {
      code: '072315001087',
      label: 'Monzelfeld',
      provincie: 7,
      slug: 'monzelfeld',
    },
    {
      code: '072315001090',
      label: 'Mülheim an der Mosel',
      provincie: 7,
      slug: 'muelheim-an-der-mosel',
    },
    {
      code: '072315001092',
      label: 'Neumagen-Dhron',
      provincie: 7,
      slug: 'neumagen-dhron',
    },
    {
      code: '072315001105',
      label: 'Piesport',
      provincie: 7,
      slug: 'piesport',
    },
    {
      code: '072315001125',
      label: 'Ürzig',
      provincie: 7,
      slug: 'uerzig',
    },
    {
      code: '072315001126',
      label: 'Veldenz',
      provincie: 7,
      slug: 'veldenz',
    },
    {
      code: '072315001133',
      label: 'Wintrich',
      provincie: 7,
      slug: 'wintrich',
    },
    {
      code: '072315001136',
      label: 'Zeltingen-Rachtig',
      provincie: 7,
      slug: 'zeltingen-rachtig',
    },
    {
      code: '072315006006',
      label: 'Berglicht',
      provincie: 7,
      slug: 'berglicht',
    },
    {
      code: '072315006017',
      label: 'Burtscheid',
      provincie: 7,
      slug: 'burtscheid',
    },
    {
      code: '072315006018',
      label: 'Deuselbach',
      provincie: 7,
      slug: 'deuselbach',
    },
    {
      code: '072315006019',
      label: 'Dhronecken',
      provincie: 7,
      slug: 'dhronecken',
    },
    {
      code: '072315006032',
      label: 'Etgert',
      provincie: 7,
      slug: 'etgert',
    },
    {
      code: '072315006035',
      label: 'Gielert',
      provincie: 7,
      slug: 'gielert',
    },
    {
      code: '072315006042',
      label: 'Gräfendhron',
      provincie: 7,
      slug: 'graefendhron',
    },
    {
      code: '072315006054',
      label: 'Hilscheid',
      provincie: 7,
      slug: 'hilscheid',
    },
    {
      code: '072315006058',
      label: 'Horath',
      provincie: 7,
      slug: 'horath',
    },
    {
      code: '072315006064',
      label: 'Immert',
      provincie: 7,
      slug: 'immert',
    },
    {
      code: '072315006078',
      label: 'Lückenburg',
      provincie: 7,
      slug: 'lueckenburg',
    },
    {
      code: '072315006079',
      label: 'Malborn',
      provincie: 7,
      slug: 'malborn',
    },
    {
      code: '072315006083',
      label: 'Merschbach',
      provincie: 7,
      slug: 'merschbach',
    },
    {
      code: '072315006093',
      label: 'Neunkirchen',
      provincie: 7,
      slug: 'neunkirchen-gemeinde',
    },
    {
      code: '072315006112',
      label: 'Rorodt',
      provincie: 7,
      slug: 'rorodt',
    },
    {
      code: '072315006115',
      label: 'Schönberg',
      provincie: 7,
      slug: 'schoenberg-gemeinde',
    },
    {
      code: '072315006122',
      label: 'Talling',
      provincie: 7,
      slug: 'talling',
    },
    {
      code: '072315006123',
      label: 'Thalfang',
      provincie: 7,
      slug: 'thalfang',
    },
    {
      code: '072315006202',
      label: 'Breit',
      provincie: 7,
      slug: 'breit',
    },
    {
      code: '072315006203',
      label: 'Büdlich',
      provincie: 7,
      slug: 'buedlich',
    },
    {
      code: '072315006204',
      label: 'Heidenburg',
      provincie: 7,
      slug: 'heidenburg',
    },
    {
      code: '072315008001',
      label: 'Altrich',
      provincie: 7,
      slug: 'altrich',
    },
    {
      code: '072315008003',
      label: 'Arenrath',
      provincie: 7,
      slug: 'arenrath',
    },
    {
      code: '072315008007',
      label: 'Bergweiler',
      provincie: 7,
      slug: 'bergweiler',
    },
    {
      code: '072315008009',
      label: 'Bettenfeld',
      provincie: 7,
      slug: 'bettenfeld',
    },
    {
      code: '072315008010',
      label: 'Binsfeld',
      provincie: 7,
      slug: 'binsfeld',
    },
    {
      code: '072315008013',
      label: 'Bruch',
      provincie: 7,
      slug: 'bruch',
    },
    {
      code: '072315008021',
      label: 'Dierfeld',
      provincie: 7,
      slug: 'dierfeld',
    },
    {
      code: '072315008022',
      label: 'Dierscheid',
      provincie: 7,
      slug: 'dierscheid',
    },
    {
      code: '072315008023',
      label: 'Dodenburg',
      provincie: 7,
      slug: 'dodenburg',
    },
    {
      code: '072315008024',
      label: 'Dreis',
      provincie: 7,
      slug: 'dreis',
    },
    {
      code: '072315008025',
      label: 'Eckfeld',
      provincie: 7,
      slug: 'eckfeld',
    },
    {
      code: '072315008026',
      label: 'Eisenschmitt',
      provincie: 7,
      slug: 'eisenschmitt',
    },
    {
      code: '072315008031',
      label: 'Esch',
      provincie: 7,
      slug: 'esch',
    },
    {
      code: '072315008036',
      label: 'Gipperath',
      provincie: 7,
      slug: 'gipperath',
    },
    {
      code: '072315008037',
      label: 'Gladbach',
      provincie: 7,
      slug: 'gladbach',
    },
    {
      code: '072315008044',
      label: 'Greimerath',
      provincie: 7,
      slug: 'greimerath',
    },
    {
      code: '072315008046',
      label: 'Großlittgen',
      provincie: 7,
      slug: 'grosslittgen',
    },
    {
      code: '072315008049',
      label: 'Hasborn',
      provincie: 7,
      slug: 'hasborn',
    },
    {
      code: '072315008050',
      label: 'Heckenmünster',
      provincie: 7,
      slug: 'heckenmuenster',
    },
    {
      code: '072315008051',
      label: 'Heidweiler',
      provincie: 7,
      slug: 'heidweiler',
    },
    {
      code: '072315008053',
      label: 'Hetzerath',
      provincie: 7,
      slug: 'hetzerath',
    },
    {
      code: '072315008062',
      label: 'Hupperath',
      provincie: 7,
      slug: 'hupperath',
    },
    {
      code: '072315008065',
      label: 'Karl',
      provincie: 7,
      slug: 'karl',
    },
    {
      code: '072315008069',
      label: 'Klausen',
      provincie: 7,
      slug: 'klausen',
    },
    {
      code: '072315008074',
      label: 'Laufeld',
      provincie: 7,
      slug: 'laufeld',
    },
    {
      code: '072315008080',
      label: 'Manderscheid',
      provincie: 7,
      slug: 'manderscheid',
    },
    {
      code: '072315008082',
      label: 'Meerfeld',
      provincie: 7,
      slug: 'meerfeld',
    },
    {
      code: '072315008085',
      label: 'Minderlittgen',
      provincie: 7,
      slug: 'minderlittgen',
    },
    {
      code: '072315008091',
      label: 'Musweiler',
      provincie: 7,
      slug: 'musweiler',
    },
    {
      code: '072315008095',
      label: 'Niederöfflingen',
      provincie: 7,
      slug: 'niederoefflingen',
    },
    {
      code: '072315008096',
      label: 'Niederscheidweiler',
      provincie: 7,
      slug: 'niederscheidweiler',
    },
    {
      code: '072315008100',
      label: 'Oberöfflingen',
      provincie: 7,
      slug: 'oberoefflingen',
    },
    {
      code: '072315008101',
      label: 'Oberscheidweiler',
      provincie: 7,
      slug: 'oberscheidweiler',
    },
    {
      code: '072315008103',
      label: 'Osann-Monzel',
      provincie: 7,
      slug: 'osann-monzel',
    },
    {
      code: '072315008104',
      label: 'Pantenburg',
      provincie: 7,
      slug: 'pantenburg',
    },
    {
      code: '072315008107',
      label: 'Platten',
      provincie: 7,
      slug: 'platten',
    },
    {
      code: '072315008108',
      label: 'Plein',
      provincie: 7,
      slug: 'plein',
    },
    {
      code: '072315008111',
      label: 'Rivenich',
      provincie: 7,
      slug: 'rivenich',
    },
    {
      code: '072315008113',
      label: 'Salmtal',
      provincie: 7,
      slug: 'salmtal',
    },
    {
      code: '072315008114',
      label: 'Schladt',
      provincie: 7,
      slug: 'schladt',
    },
    {
      code: '072315008116',
      label: 'Schwarzenborn',
      provincie: 7,
      slug: 'schwarzenborn-gemeinde',
    },
    {
      code: '072315008117',
      label: 'Sehlem',
      provincie: 7,
      slug: 'sehlem',
    },
    {
      code: '072315008127',
      label: 'Wallscheid',
      provincie: 7,
      slug: 'wallscheid',
    },
    {
      code: '072315008503',
      label: 'Landscheid',
      provincie: 7,
      slug: 'landscheid',
    },
    {
      code: '072315008504',
      label: 'Niersbach',
      provincie: 7,
      slug: 'niersbach',
    },
    {
      code: '072315009004',
      label: 'Bausendorf',
      provincie: 7,
      slug: 'bausendorf',
    },
    {
      code: '072315009005',
      label: 'Bengel',
      provincie: 7,
      slug: 'bengel',
    },
    {
      code: '072315009014',
      label: 'Burg (Mosel)',
      provincie: 7,
      slug: 'burg-mosel',
    },
    {
      code: '072315009020',
      label: 'Diefenbach',
      provincie: 7,
      slug: 'diefenbach',
    },
    {
      code: '072315009029',
      label: 'Enkirch',
      provincie: 7,
      slug: 'enkirch',
    },
    {
      code: '072315009033',
      label: 'Flußbach',
      provincie: 7,
      slug: 'flussbach',
    },
    {
      code: '072315009057',
      label: 'Hontheim',
      provincie: 7,
      slug: 'hontheim',
    },
    {
      code: '072315009067',
      label: 'Kinderbeuern',
      provincie: 7,
      slug: 'kinderbeuern',
    },
    {
      code: '072315009068',
      label: 'Kinheim',
      provincie: 7,
      slug: 'kinheim',
    },
    {
      code: '072315009072',
      label: 'Kröv',
      provincie: 7,
      slug: 'kroev',
    },
    {
      code: '072315009110',
      label: 'Reil',
      provincie: 7,
      slug: 'reil',
    },
    {
      code: '072315009120',
      label: 'Starkenburg',
      provincie: 7,
      slug: 'starkenburg',
    },
    {
      code: '072315009124',
      label: 'Traben-Trarbach',
      provincie: 7,
      slug: 'traben-trarbach',
    },
    {
      code: '072315009132',
      label: 'Willwerscheid',
      provincie: 7,
      slug: 'willwerscheid',
    },
    {
      code: '072315009206',
      label: 'Lötzbeuren',
      provincie: 7,
      slug: 'loetzbeuren',
    },
    {
      code: '072315009501',
      label: 'Irmenach',
      provincie: 7,
      slug: 'irmenach',
    },
    {
      code: '072320018018',
      label: 'Bitburg',
      provincie: 7,
      slug: 'bitburg',
    },
    {
      code: '072325001201',
      label: 'Arzfeld',
      provincie: 7,
      slug: 'arzfeld',
    },
    {
      code: '072325001211',
      label: 'Dackscheid',
      provincie: 7,
      slug: 'dackscheid',
    },
    {
      code: '072325001212',
      label: 'Dahnen',
      provincie: 7,
      slug: 'dahnen',
    },
    {
      code: '072325001213',
      label: 'Daleiden',
      provincie: 7,
      slug: 'daleiden',
    },
    {
      code: '072325001214',
      label: 'Dasburg',
      provincie: 7,
      slug: 'dasburg',
    },
    {
      code: '072325001217',
      label: 'Eilscheid',
      provincie: 7,
      slug: 'eilscheid',
    },
    {
      code: '072325001220',
      label: 'Eschfeld',
      provincie: 7,
      slug: 'eschfeld',
    },
    {
      code: '072325001221',
      label: 'Euscheid',
      provincie: 7,
      slug: 'euscheid',
    },
    {
      code: '072325001229',
      label: 'Großkampenberg',
      provincie: 7,
      slug: 'grosskampenberg',
    },
    {
      code: '072325001233',
      label: 'Hargarten',
      provincie: 7,
      slug: 'hargarten',
    },
    {
      code: '072325001234',
      label: 'Harspelt',
      provincie: 7,
      slug: 'harspelt',
    },
    {
      code: '072325001240',
      label: 'Herzfeld',
      provincie: 7,
      slug: 'herzfeld',
    },
    {
      code: '072325001245',
      label: 'Irrhausen',
      provincie: 7,
      slug: 'irrhausen',
    },
    {
      code: '072325001246',
      label: 'Jucken',
      provincie: 7,
      slug: 'jucken',
    },
    {
      code: '072325001247',
      label: 'Kesfeld',
      provincie: 7,
      slug: 'kesfeld',
    },
    {
      code: '072325001248',
      label: 'Kickeshausen',
      provincie: 7,
      slug: 'kickeshausen',
    },
    {
      code: '072325001249',
      label: 'Kinzenburg',
      provincie: 7,
      slug: 'kinzenburg',
    },
    {
      code: '072325001253',
      label: 'Krautscheid',
      provincie: 7,
      slug: 'krautscheid',
    },
    {
      code: '072325001254',
      label: 'Lambertsberg',
      provincie: 7,
      slug: 'lambertsberg',
    },
    {
      code: '072325001255',
      label: 'Lascheid',
      provincie: 7,
      slug: 'lascheid',
    },
    {
      code: '072325001258',
      label: 'Lauperath',
      provincie: 7,
      slug: 'lauperath',
    },
    {
      code: '072325001259',
      label: 'Leidenborn',
      provincie: 7,
      slug: 'leidenborn',
    },
    {
      code: '072325001260',
      label: 'Lichtenborn',
      provincie: 7,
      slug: 'lichtenborn',
    },
    {
      code: '072325001261',
      label: 'Lierfeld',
      provincie: 7,
      slug: 'lierfeld',
    },
    {
      code: '072325001262',
      label: 'Lünebach',
      provincie: 7,
      slug: 'luenebach',
    },
    {
      code: '072325001263',
      label: 'Lützkampen',
      provincie: 7,
      slug: 'luetzkampen',
    },
    {
      code: '072325001264',
      label: 'Manderscheid',
      provincie: 7,
      slug: 'manderscheid-gemeinde',
    },
    {
      code: '072325001267',
      label: 'Mauel',
      provincie: 7,
      slug: 'mauel',
    },
    {
      code: '072325001270',
      label: 'Merlscheid',
      provincie: 7,
      slug: 'merlscheid',
    },
    {
      code: '072325001277',
      label: 'Niederpierscheid',
      provincie: 7,
      slug: 'niederpierscheid',
    },
    {
      code: '072325001285',
      label: 'Oberpierscheid',
      provincie: 7,
      slug: 'oberpierscheid',
    },
    {
      code: '072325001287',
      label: 'Olmscheid',
      provincie: 7,
      slug: 'olmscheid',
    },
    {
      code: '072325001291',
      label: 'Pintesfeld',
      provincie: 7,
      slug: 'pintesfeld',
    },
    {
      code: '072325001293',
      label: 'Plütscheid',
      provincie: 7,
      slug: 'pluetscheid',
    },
    {
      code: '072325001294',
      label: 'Preischeid',
      provincie: 7,
      slug: 'preischeid',
    },
    {
      code: '072325001297',
      label: 'Reiff',
      provincie: 7,
      slug: 'reiff',
    },
    {
      code: '072325001298',
      label: 'Reipeldingen',
      provincie: 7,
      slug: 'reipeldingen',
    },
    {
      code: '072325001301',
      label: 'Roscheid',
      provincie: 7,
      slug: 'roscheid',
    },
    {
      code: '072325001309',
      label: 'Sengerich',
      provincie: 7,
      slug: 'sengerich',
    },
    {
      code: '072325001310',
      label: 'Sevenig (Our)',
      provincie: 7,
      slug: 'sevenig-our',
    },
    {
      code: '072325001315',
      label: 'Strickscheid',
      provincie: 7,
      slug: 'strickscheid',
    },
    {
      code: '072325001322',
      label: 'Waxweiler',
      provincie: 7,
      slug: 'waxweiler',
    },
    {
      code: '072325001333',
      label: 'Üttfeld',
      provincie: 7,
      slug: 'uettfeld',
    },
    {
      code: '072325005001',
      label: 'Affler',
      provincie: 7,
      slug: 'affler',
    },
    {
      code: '072325005002',
      label: 'Alsdorf',
      provincie: 7,
      slug: 'alsdorf-gemeinde',
    },
    {
      code: '072325005003',
      label: 'Altscheid',
      provincie: 7,
      slug: 'altscheid',
    },
    {
      code: '072325005004',
      label: 'Ammeldingen an der Our',
      provincie: 7,
      slug: 'ammeldingen-an-der-our',
    },
    {
      code: '072325005005',
      label: 'Ammeldingen bei Neuerburg',
      provincie: 7,
      slug: 'ammeldingen-bei-neuerburg',
    },
    {
      code: '072325005008',
      label: 'Bauler',
      provincie: 7,
      slug: 'bauler-gemeinde',
    },
    {
      code: '072325005011',
      label: 'Berkoth',
      provincie: 7,
      slug: 'berkoth',
    },
    {
      code: '072325005012',
      label: 'Berscheid',
      provincie: 7,
      slug: 'berscheid',
    },
    {
      code: '072325005016',
      label: 'Biesdorf',
      provincie: 7,
      slug: 'biesdorf',
    },
    {
      code: '072325005019',
      label: 'Bollendorf',
      provincie: 7,
      slug: 'bollendorf',
    },
    {
      code: '072325005022',
      label: 'Burg',
      provincie: 7,
      slug: 'burg',
    },
    {
      code: '072325005025',
      label: 'Dauwelshausen',
      provincie: 7,
      slug: 'dauwelshausen',
    },
    {
      code: '072325005028',
      label: 'Echternacherbrück',
      provincie: 7,
      slug: 'echternacherbrueck',
    },
    {
      code: '072325005031',
      label: 'Emmelbaum',
      provincie: 7,
      slug: 'emmelbaum',
    },
    {
      code: '072325005033',
      label: 'Ernzen',
      provincie: 7,
      slug: 'ernzen',
    },
    {
      code: '072325005037',
      label: 'Ferschweiler',
      provincie: 7,
      slug: 'ferschweiler',
    },
    {
      code: '072325005038',
      label: 'Fischbach-Oberraden',
      provincie: 7,
      slug: 'fischbach-oberraden',
    },
    {
      code: '072325005040',
      label: 'Geichlingen',
      provincie: 7,
      slug: 'geichlingen',
    },
    {
      code: '072325005041',
      label: 'Gemünd',
      provincie: 7,
      slug: 'gemuend',
    },
    {
      code: '072325005042',
      label: 'Gentingen',
      provincie: 7,
      slug: 'gentingen',
    },
    {
      code: '072325005047',
      label: 'Heilbach',
      provincie: 7,
      slug: 'heilbach',
    },
    {
      code: '072325005049',
      label: 'Herbstmühle',
      provincie: 7,
      slug: 'herbstmuehle',
    },
    {
      code: '072325005053',
      label: 'Holsthum',
      provincie: 7,
      slug: 'holsthum',
    },
    {
      code: '072325005054',
      label: 'Hommerdingen',
      provincie: 7,
      slug: 'hommerdingen',
    },
    {
      code: '072325005056',
      label: 'Hütten',
      provincie: 7,
      slug: 'huetten-gemeinde',
    },
    {
      code: '072325005059',
      label: 'Hüttingen bei Lahr',
      provincie: 7,
      slug: 'huettingen-bei-lahr',
    },
    {
      code: '072325005063',
      label: 'Irrel',
      provincie: 7,
      slug: 'irrel',
    },
    {
      code: '072325005064',
      label: 'Karlshausen',
      provincie: 7,
      slug: 'karlshausen',
    },
    {
      code: '072325005065',
      label: 'Kaschenbach',
      provincie: 7,
      slug: 'kaschenbach',
    },
    {
      code: '072325005066',
      label: 'Keppeshausen',
      provincie: 7,
      slug: 'keppeshausen',
    },
    {
      code: '072325005067',
      label: 'Körperich',
      provincie: 7,
      slug: 'koerperich',
    },
    {
      code: '072325005068',
      label: 'Koxhausen',
      provincie: 7,
      slug: 'koxhausen',
    },
    {
      code: '072325005069',
      label: 'Kruchten',
      provincie: 7,
      slug: 'kruchten',
    },
    {
      code: '072325005072',
      label: 'Lahr',
      provincie: 7,
      slug: 'lahr-gemeinde',
    },
    {
      code: '072325005073',
      label: 'Leimbach',
      provincie: 7,
      slug: 'leimbach-gemeinde',
    },
    {
      code: '072325005078',
      label: 'Menningen',
      provincie: 7,
      slug: 'menningen',
    },
    {
      code: '072325005080',
      label: 'Mettendorf',
      provincie: 7,
      slug: 'mettendorf',
    },
    {
      code: '072325005082',
      label: 'Minden',
      provincie: 7,
      slug: 'minden-gemeinde',
    },
    {
      code: '072325005084',
      label: 'Muxerath',
      provincie: 7,
      slug: 'muxerath',
    },
    {
      code: '072325005085',
      label: 'Nasingen',
      provincie: 7,
      slug: 'nasingen',
    },
    {
      code: '072325005088',
      label: 'Neuerburg',
      provincie: 7,
      slug: 'neuerburg',
    },
    {
      code: '072325005090',
      label: 'Niederraden',
      provincie: 7,
      slug: 'niederraden',
    },
    {
      code: '072325005093',
      label: 'Niederweis',
      provincie: 7,
      slug: 'niederweis',
    },
    {
      code: '072325005094',
      label: 'Niehl',
      provincie: 7,
      slug: 'niehl',
    },
    {
      code: '072325005095',
      label: 'Nusbaum',
      provincie: 7,
      slug: 'nusbaum',
    },
    {
      code: '072325005102',
      label: 'Utscheid',
      provincie: 7,
      slug: 'utscheid',
    },
    {
      code: '072325005103',
      label: 'Peffingen',
      provincie: 7,
      slug: 'peffingen',
    },
    {
      code: '072325005106',
      label: 'Plascheid',
      provincie: 7,
      slug: 'plascheid',
    },
    {
      code: '072325005108',
      label: 'Prümzurlay',
      provincie: 7,
      slug: 'pruemzurlay',
    },
    {
      code: '072325005110',
      label: 'Rodershausen',
      provincie: 7,
      slug: 'rodershausen',
    },
    {
      code: '072325005112',
      label: 'Roth an der Our',
      provincie: 7,
      slug: 'roth-an-der-our',
    },
    {
      code: '072325005114',
      label: 'Schankweiler',
      provincie: 7,
      slug: 'schankweiler',
    },
    {
      code: '072325005116',
      label: 'Scheitenkorb',
      provincie: 7,
      slug: 'scheitenkorb',
    },
    {
      code: '072325005117',
      label: 'Scheuern',
      provincie: 7,
      slug: 'scheuern',
    },
    {
      code: '072325005121',
      label: 'Sevenig bei Neuerburg',
      provincie: 7,
      slug: 'sevenig-bei-neuerburg',
    },
    {
      code: '072325005122',
      label: 'Sinspelt',
      provincie: 7,
      slug: 'sinspelt',
    },
    {
      code: '072325005127',
      label: 'Übereisenbach',
      provincie: 7,
      slug: 'uebereisenbach',
    },
    {
      code: '072325005128',
      label: 'Uppershausen',
      provincie: 7,
      slug: 'uppershausen',
    },
    {
      code: '072325005130',
      label: 'Waldhof-Falkenstein',
      provincie: 7,
      slug: 'waldhof-falkenstein',
    },
    {
      code: '072325005131',
      label: 'Wallendorf',
      provincie: 7,
      slug: 'wallendorf',
    },
    {
      code: '072325005132',
      label: 'Weidingen',
      provincie: 7,
      slug: 'weidingen',
    },
    {
      code: '072325005138',
      label: 'Zweifelscheid',
      provincie: 7,
      slug: 'zweifelscheid',
    },
    {
      code: '072325005218',
      label: 'Eisenach',
      provincie: 7,
      slug: 'eisenach',
    },
    {
      code: '072325005225',
      label: 'Gilzem',
      provincie: 7,
      slug: 'gilzem',
    },
    {
      code: '072325005503',
      label: 'Obergeckler',
      provincie: 7,
      slug: 'obergeckler',
    },
    {
      code: '072325006202',
      label: 'Auw bei Prüm',
      provincie: 7,
      slug: 'auw-bei-pruem',
    },
    {
      code: '072325006206',
      label: 'Bleialf',
      provincie: 7,
      slug: 'bleialf',
    },
    {
      code: '072325006207',
      label: 'Brandscheid',
      provincie: 7,
      slug: 'brandscheid-gemeinde',
    },
    {
      code: '072325006208',
      label: 'Buchet',
      provincie: 7,
      slug: 'buchet',
    },
    {
      code: '072325006209',
      label: 'Büdesheim',
      provincie: 7,
      slug: 'buedesheim',
    },
    {
      code: '072325006216',
      label: 'Dingdorf',
      provincie: 7,
      slug: 'dingdorf',
    },
    {
      code: '072325006222',
      label: 'Feuerscheid',
      provincie: 7,
      slug: 'feuerscheid',
    },
    {
      code: '072325006223',
      label: 'Fleringen',
      provincie: 7,
      slug: 'fleringen',
    },
    {
      code: '072325006224',
      label: 'Giesdorf',
      provincie: 7,
      slug: 'giesdorf',
    },
    {
      code: '072325006226',
      label: 'Weinsheim',
      provincie: 7,
      slug: 'weinsheim-gemeinde',
    },
    {
      code: '072325006227',
      label: 'Gondenbrett',
      provincie: 7,
      slug: 'gondenbrett',
    },
    {
      code: '072325006230',
      label: 'Großlangenfeld',
      provincie: 7,
      slug: 'grosslangenfeld',
    },
    {
      code: '072325006231',
      label: 'Habscheid',
      provincie: 7,
      slug: 'habscheid',
    },
    {
      code: '072325006236',
      label: 'Heckhuscheid',
      provincie: 7,
      slug: 'heckhuscheid',
    },
    {
      code: '072325006238',
      label: 'Heisdorf',
      provincie: 7,
      slug: 'heisdorf',
    },
    {
      code: '072325006250',
      label: 'Kleinlangenfeld',
      provincie: 7,
      slug: 'kleinlangenfeld',
    },
    {
      code: '072325006256',
      label: 'Lasel',
      provincie: 7,
      slug: 'lasel',
    },
    {
      code: '072325006265',
      label: 'Masthorn',
      provincie: 7,
      slug: 'masthorn',
    },
    {
      code: '072325006266',
      label: 'Matzerath',
      provincie: 7,
      slug: 'matzerath',
    },
    {
      code: '072325006271',
      label: 'Mützenich',
      provincie: 7,
      slug: 'muetzenich',
    },
    {
      code: '072325006272',
      label: 'Neuendorf',
      provincie: 7,
      slug: 'neuendorf',
    },
    {
      code: '072325006276',
      label: 'Niederlauch',
      provincie: 7,
      slug: 'niederlauch',
    },
    {
      code: '072325006279',
      label: 'Nimshuscheid',
      provincie: 7,
      slug: 'nimshuscheid',
    },
    {
      code: '072325006280',
      label: 'Nimsreuland',
      provincie: 7,
      slug: 'nimsreuland',
    },
    {
      code: '072325006283',
      label: 'Oberlascheid',
      provincie: 7,
      slug: 'oberlascheid',
    },
    {
      code: '072325006284',
      label: 'Oberlauch',
      provincie: 7,
      slug: 'oberlauch',
    },
    {
      code: '072325006288',
      label: 'Olzheim',
      provincie: 7,
      slug: 'olzheim',
    },
    {
      code: '072325006290',
      label: 'Orlenbach',
      provincie: 7,
      slug: 'orlenbach',
    },
    {
      code: '072325006292',
      label: 'Pittenbach',
      provincie: 7,
      slug: 'pittenbach',
    },
    {
      code: '072325006295',
      label: 'Pronsfeld',
      provincie: 7,
      slug: 'pronsfeld',
    },
    {
      code: '072325006296',
      label: 'Prüm',
      provincie: 7,
      slug: 'pruem',
    },
    {
      code: '072325006300',
      label: 'Rommersheim',
      provincie: 7,
      slug: 'rommersheim',
    },
    {
      code: '072325006302',
      label: 'Roth bei Prüm',
      provincie: 7,
      slug: 'roth-bei-pruem',
    },
    {
      code: '072325006304',
      label: 'Schönecken',
      provincie: 7,
      slug: 'schoenecken',
    },
    {
      code: '072325006305',
      label: 'Schwirzheim',
      provincie: 7,
      slug: 'schwirzheim',
    },
    {
      code: '072325006307',
      label: 'Seiwerath',
      provincie: 7,
      slug: 'seiwerath',
    },
    {
      code: '072325006308',
      label: 'Sellerich',
      provincie: 7,
      slug: 'sellerich',
    },
    {
      code: '072325006318',
      label: 'Wallersheim',
      provincie: 7,
      slug: 'wallersheim',
    },
    {
      code: '072325006320',
      label: 'Watzerath',
      provincie: 7,
      slug: 'watzerath',
    },
    {
      code: '072325006321',
      label: 'Wawern',
      provincie: 7,
      slug: 'wawern',
    },
    {
      code: '072325006327',
      label: 'Winringen',
      provincie: 7,
      slug: 'winringen',
    },
    {
      code: '072325006328',
      label: 'Winterscheid',
      provincie: 7,
      slug: 'winterscheid',
    },
    {
      code: '072325006329',
      label: 'Winterspelt',
      provincie: 7,
      slug: 'winterspelt',
    },
    {
      code: '072325006332',
      label: 'Hersdorf',
      provincie: 7,
      slug: 'hersdorf',
    },
    {
      code: '072325007006',
      label: 'Auw an der Kyll',
      provincie: 7,
      slug: 'auw-an-der-kyll',
    },
    {
      code: '072325007010',
      label: 'Beilingen',
      provincie: 7,
      slug: 'beilingen',
    },
    {
      code: '072325007050',
      label: 'Herforst',
      provincie: 7,
      slug: 'herforst',
    },
    {
      code: '072325007055',
      label: 'Hosten',
      provincie: 7,
      slug: 'hosten',
    },
    {
      code: '072325007104',
      label: 'Philippsheim',
      provincie: 7,
      slug: 'philippsheim',
    },
    {
      code: '072325007107',
      label: 'Preist',
      provincie: 7,
      slug: 'preist',
    },
    {
      code: '072325007123',
      label: 'Speicher',
      provincie: 7,
      slug: 'speicher',
    },
    {
      code: '072325007289',
      label: 'Orenhofen',
      provincie: 7,
      slug: 'orenhofen',
    },
    {
      code: '072325007311',
      label: 'Spangdahlem',
      provincie: 7,
      slug: 'spangdahlem',
    },
    {
      code: '072325008007',
      label: 'Badem',
      provincie: 7,
      slug: 'badem',
    },
    {
      code: '072325008009',
      label: 'Baustert',
      provincie: 7,
      slug: 'baustert',
    },
    {
      code: '072325008013',
      label: 'Bettingen',
      provincie: 7,
      slug: 'bettingen',
    },
    {
      code: '072325008014',
      label: 'Bickendorf',
      provincie: 7,
      slug: 'bickendorf',
    },
    {
      code: '072325008015',
      label: 'Biersdorf am See',
      provincie: 7,
      slug: 'biersdorf-am-see',
    },
    {
      code: '072325008017',
      label: 'Birtlingen',
      provincie: 7,
      slug: 'birtlingen',
    },
    {
      code: '072325008020',
      label: 'Brecht',
      provincie: 7,
      slug: 'brecht',
    },
    {
      code: '072325008024',
      label: 'Dahlem',
      provincie: 7,
      slug: 'dahlem-gemeinde',
    },
    {
      code: '072325008026',
      label: 'Dockendorf',
      provincie: 7,
      slug: 'dockendorf',
    },
    {
      code: '072325008027',
      label: 'Dudeldorf',
      provincie: 7,
      slug: 'dudeldorf',
    },
    {
      code: '072325008029',
      label: 'Echtershausen',
      provincie: 7,
      slug: 'echtershausen',
    },
    {
      code: '072325008030',
      label: 'Ehlenz',
      provincie: 7,
      slug: 'ehlenz',
    },
    {
      code: '072325008032',
      label: 'Enzen',
      provincie: 7,
      slug: 'enzen',
    },
    {
      code: '072325008034',
      label: 'Eßlingen',
      provincie: 7,
      slug: 'esslingen',
    },
    {
      code: '072325008035',
      label: 'Etteldorf',
      provincie: 7,
      slug: 'etteldorf',
    },
    {
      code: '072325008036',
      label: 'Feilsdorf',
      provincie: 7,
      slug: 'feilsdorf',
    },
    {
      code: '072325008039',
      label: 'Fließem',
      provincie: 7,
      slug: 'fliessem',
    },
    {
      code: '072325008043',
      label: 'Gindorf',
      provincie: 7,
      slug: 'gindorf',
    },
    {
      code: '072325008044',
      label: 'Gondorf',
      provincie: 7,
      slug: 'gondorf',
    },
    {
      code: '072325008045',
      label: 'Halsdorf',
      provincie: 7,
      slug: 'halsdorf',
    },
    {
      code: '072325008046',
      label: 'Hamm',
      provincie: 7,
      slug: 'hamm-gemeinde',
    },
    {
      code: '072325008048',
      label: 'Heilenbach',
      provincie: 7,
      slug: 'heilenbach',
    },
    {
      code: '072325008057',
      label: 'Hütterscheid',
      provincie: 7,
      slug: 'huetterscheid',
    },
    {
      code: '072325008058',
      label: 'Hüttingen an der Kyll',
      provincie: 7,
      slug: 'huettingen-an-der-kyll',
    },
    {
      code: '072325008060',
      label: 'Idenheim',
      provincie: 7,
      slug: 'idenheim',
    },
    {
      code: '072325008061',
      label: 'Idesheim',
      provincie: 7,
      slug: 'idesheim',
    },
    {
      code: '072325008062',
      label: 'Ingendorf',
      provincie: 7,
      slug: 'ingendorf',
    },
    {
      code: '072325008070',
      label: 'Kyllburg',
      provincie: 7,
      slug: 'kyllburg',
    },
    {
      code: '072325008071',
      label: 'Kyllburgweiler',
      provincie: 7,
      slug: 'kyllburgweiler',
    },
    {
      code: '072325008074',
      label: 'Ließem',
      provincie: 7,
      slug: 'liessem',
    },
    {
      code: '072325008075',
      label: 'Malberg',
      provincie: 7,
      slug: 'malberg-gemeinde',
    },
    {
      code: '072325008076',
      label: 'Malbergweich',
      provincie: 7,
      slug: 'malbergweich',
    },
    {
      code: '072325008077',
      label: 'Meckel',
      provincie: 7,
      slug: 'meckel',
    },
    {
      code: '072325008079',
      label: 'Messerich',
      provincie: 7,
      slug: 'messerich',
    },
    {
      code: '072325008081',
      label: 'Metterich',
      provincie: 7,
      slug: 'metterich',
    },
    {
      code: '072325008083',
      label: 'Mülbach',
      provincie: 7,
      slug: 'muelbach',
    },
    {
      code: '072325008086',
      label: 'Nattenheim',
      provincie: 7,
      slug: 'nattenheim',
    },
    {
      code: '072325008087',
      label: 'Neidenbach',
      provincie: 7,
      slug: 'neidenbach',
    },
    {
      code: '072325008091',
      label: 'Niederstedem',
      provincie: 7,
      slug: 'niederstedem',
    },
    {
      code: '072325008092',
      label: 'Niederweiler',
      provincie: 7,
      slug: 'niederweiler-gemeinde',
    },
    {
      code: '072325008097',
      label: 'Oberstedem',
      provincie: 7,
      slug: 'oberstedem',
    },
    {
      code: '072325008098',
      label: 'Oberweiler',
      provincie: 7,
      slug: 'oberweiler',
    },
    {
      code: '072325008099',
      label: 'Oberweis',
      provincie: 7,
      slug: 'oberweis',
    },
    {
      code: '072325008100',
      label: 'Olsdorf',
      provincie: 7,
      slug: 'olsdorf',
    },
    {
      code: '072325008101',
      label: 'Orsfeld',
      provincie: 7,
      slug: 'orsfeld',
    },
    {
      code: '072325008105',
      label: 'Pickließem',
      provincie: 7,
      slug: 'pickliessem',
    },
    {
      code: '072325008109',
      label: 'Rittersdorf',
      provincie: 7,
      slug: 'rittersdorf',
    },
    {
      code: '072325008111',
      label: 'Röhl',
      provincie: 7,
      slug: 'roehl',
    },
    {
      code: '072325008113',
      label: 'Sankt Thomas',
      provincie: 7,
      slug: 'sankt-thomas',
    },
    {
      code: '072325008115',
      label: 'Scharfbillig',
      provincie: 7,
      slug: 'scharfbillig',
    },
    {
      code: '072325008118',
      label: 'Schleid',
      provincie: 7,
      slug: 'schleid',
    },
    {
      code: '072325008119',
      label: 'Seffern',
      provincie: 7,
      slug: 'seffern',
    },
    {
      code: '072325008120',
      label: 'Sefferweich',
      provincie: 7,
      slug: 'sefferweich',
    },
    {
      code: '072325008124',
      label: 'Stockem',
      provincie: 7,
      slug: 'stockem',
    },
    {
      code: '072325008125',
      label: 'Sülm',
      provincie: 7,
      slug: 'suelm',
    },
    {
      code: '072325008126',
      label: 'Trimport',
      provincie: 7,
      slug: 'trimport',
    },
    {
      code: '072325008129',
      label: 'Usch',
      provincie: 7,
      slug: 'usch',
    },
    {
      code: '072325008133',
      label: 'Wettlingen',
      provincie: 7,
      slug: 'wettlingen',
    },
    {
      code: '072325008134',
      label: 'Wiersdorf',
      provincie: 7,
      slug: 'wiersdorf',
    },
    {
      code: '072325008135',
      label: 'Wilsecker',
      provincie: 7,
      slug: 'wilsecker',
    },
    {
      code: '072325008137',
      label: 'Wolsfeld',
      provincie: 7,
      slug: 'wolsfeld',
    },
    {
      code: '072325008203',
      label: 'Balesfeld',
      provincie: 7,
      slug: 'balesfeld',
    },
    {
      code: '072325008210',
      label: 'Burbach',
      provincie: 7,
      slug: 'burbach-gemeinde',
    },
    {
      code: '072325008228',
      label: 'Gransdorf',
      provincie: 7,
      slug: 'gransdorf',
    },
    {
      code: '072325008273',
      label: 'Neuheilenbach',
      provincie: 7,
      slug: 'neuheilenbach',
    },
    {
      code: '072325008282',
      label: 'Oberkail',
      provincie: 7,
      slug: 'oberkail',
    },
    {
      code: '072325008306',
      label: 'Seinsfeld',
      provincie: 7,
      slug: 'seinsfeld',
    },
    {
      code: '072325008313',
      label: 'Steinborn',
      provincie: 7,
      slug: 'steinborn',
    },
    {
      code: '072325008331',
      label: 'Zendscheid',
      provincie: 7,
      slug: 'zendscheid',
    },
    {
      code: '072325008501',
      label: 'Wißmannsdorf',
      provincie: 7,
      slug: 'wissmannsdorf',
    },
    {
      code: '072325008502',
      label: 'Brimingen',
      provincie: 7,
      slug: 'brimingen',
    },
    {
      code: '072335001006',
      label: 'Betteldorf',
      provincie: 7,
      slug: 'betteldorf',
    },
    {
      code: '072335001008',
      label: 'Bleckhausen',
      provincie: 7,
      slug: 'bleckhausen',
    },
    {
      code: '072335001011',
      label: 'Brockscheid',
      provincie: 7,
      slug: 'brockscheid',
    },
    {
      code: '072335001014',
      label: 'Darscheid',
      provincie: 7,
      slug: 'darscheid',
    },
    {
      code: '072335001016',
      label: 'Demerath',
      provincie: 7,
      slug: 'demerath',
    },
    {
      code: '072335001017',
      label: 'Deudesfeld',
      provincie: 7,
      slug: 'deudesfeld',
    },
    {
      code: '072335001018',
      label: 'Dockweiler',
      provincie: 7,
      slug: 'dockweiler',
    },
    {
      code: '072335001020',
      label: 'Dreis-Brück',
      provincie: 7,
      slug: 'dreis-brueck',
    },
    {
      code: '072335001021',
      label: 'Ellscheid',
      provincie: 7,
      slug: 'ellscheid',
    },
    {
      code: '072335001025',
      label: 'Gefell',
      provincie: 7,
      slug: 'gefell',
    },
    {
      code: '072335001027',
      label: 'Gillenfeld',
      provincie: 7,
      slug: 'gillenfeld',
    },
    {
      code: '072335001030',
      label: 'Hinterweiler',
      provincie: 7,
      slug: 'hinterweiler',
    },
    {
      code: '072335001031',
      label: 'Hörscheid',
      provincie: 7,
      slug: 'hoerscheid',
    },
    {
      code: '072335001034',
      label: 'Immerath',
      provincie: 7,
      slug: 'immerath',
    },
    {
      code: '072335001039',
      label: 'Kirchweiler',
      provincie: 7,
      slug: 'kirchweiler',
    },
    {
      code: '072335001040',
      label: 'Kradenbach',
      provincie: 7,
      slug: 'kradenbach',
    },
    {
      code: '072335001042',
      label: 'Mehren',
      provincie: 7,
      slug: 'mehren-gemeinde',
    },
    {
      code: '072335001043',
      label: 'Meisburg',
      provincie: 7,
      slug: 'meisburg',
    },
    {
      code: '072335001046',
      label: 'Mückeln',
      provincie: 7,
      slug: 'mueckeln',
    },
    {
      code: '072335001049',
      label: 'Nerdlen',
      provincie: 7,
      slug: 'nerdlen',
    },
    {
      code: '072335001052',
      label: 'Niederstadtfeld',
      provincie: 7,
      slug: 'niederstadtfeld',
    },
    {
      code: '072335001055',
      label: 'Oberstadtfeld',
      provincie: 7,
      slug: 'oberstadtfeld',
    },
    {
      code: '072335001061',
      label: 'Sarmersbach',
      provincie: 7,
      slug: 'sarmersbach',
    },
    {
      code: '072335001062',
      label: 'Saxler',
      provincie: 7,
      slug: 'saxler',
    },
    {
      code: '072335001063',
      label: 'Schalkenmehren',
      provincie: 7,
      slug: 'schalkenmehren',
    },
    {
      code: '072335001064',
      label: 'Schönbach',
      provincie: 7,
      slug: 'schoenbach',
    },
    {
      code: '072335001065',
      label: 'Schutz',
      provincie: 7,
      slug: 'schutz',
    },
    {
      code: '072335001067',
      label: 'Steineberg',
      provincie: 7,
      slug: 'steineberg',
    },
    {
      code: '072335001068',
      label: 'Steiningen',
      provincie: 7,
      slug: 'steiningen',
    },
    {
      code: '072335001070',
      label: 'Strohn',
      provincie: 7,
      slug: 'strohn',
    },
    {
      code: '072335001071',
      label: 'Strotzbüsch',
      provincie: 7,
      slug: 'strotzbuesch',
    },
    {
      code: '072335001074',
      label: 'Udler',
      provincie: 7,
      slug: 'udler',
    },
    {
      code: '072335001075',
      label: 'Üdersdorf',
      provincie: 7,
      slug: 'uedersdorf',
    },
    {
      code: '072335001077',
      label: 'Utzerath',
      provincie: 7,
      slug: 'utzerath',
    },
    {
      code: '072335001079',
      label: 'Wallenborn',
      provincie: 7,
      slug: 'wallenborn',
    },
    {
      code: '072335001081',
      label: 'Weidenbach',
      provincie: 7,
      slug: 'weidenbach-gemeinde',
    },
    {
      code: '072335001084',
      label: 'Winkel (Eifel)',
      provincie: 7,
      slug: 'winkel-eifel',
    },
    {
      code: '072335001501',
      label: 'Daun',
      provincie: 7,
      slug: 'daun',
    },
    {
      code: '072335004003',
      label: 'Beinhausen',
      provincie: 7,
      slug: 'beinhausen',
    },
    {
      code: '072335004010',
      label: 'Boxberg',
      provincie: 7,
      slug: 'boxberg',
    },
    {
      code: '072335004032',
      label: 'Hörschhausen',
      provincie: 7,
      slug: 'hoerschhausen',
    },
    {
      code: '072335004037',
      label: 'Katzwinkel',
      provincie: 7,
      slug: 'katzwinkel',
    },
    {
      code: '072335004048',
      label: 'Neichen',
      provincie: 7,
      slug: 'neichen',
    },
    {
      code: '072335004201',
      label: 'Arbach',
      provincie: 7,
      slug: 'arbach',
    },
    {
      code: '072335004202',
      label: 'Bereborn',
      provincie: 7,
      slug: 'bereborn',
    },
    {
      code: '072335004203',
      label: 'Berenbach',
      provincie: 7,
      slug: 'berenbach',
    },
    {
      code: '072335004205',
      label: 'Bodenbach',
      provincie: 7,
      slug: 'bodenbach',
    },
    {
      code: '072335004206',
      label: 'Bongard',
      provincie: 7,
      slug: 'bongard',
    },
    {
      code: '072335004207',
      label: 'Borler',
      provincie: 7,
      slug: 'borler',
    },
    {
      code: '072335004208',
      label: 'Brücktal',
      provincie: 7,
      slug: 'bruecktal',
    },
    {
      code: '072335004210',
      label: 'Drees',
      provincie: 7,
      slug: 'drees',
    },
    {
      code: '072335004212',
      label: 'Gelenberg',
      provincie: 7,
      slug: 'gelenberg',
    },
    {
      code: '072335004213',
      label: 'Gunderath',
      provincie: 7,
      slug: 'gunderath',
    },
    {
      code: '072335004215',
      label: 'Höchstberg',
      provincie: 7,
      slug: 'hoechstberg',
    },
    {
      code: '072335004216',
      label: 'Horperath',
      provincie: 7,
      slug: 'horperath',
    },
    {
      code: '072335004217',
      label: 'Kaperich',
      provincie: 7,
      slug: 'kaperich',
    },
    {
      code: '072335004218',
      label: 'Kelberg',
      provincie: 7,
      slug: 'kelberg',
    },
    {
      code: '072335004220',
      label: 'Kirsbach',
      provincie: 7,
      slug: 'kirsbach',
    },
    {
      code: '072335004221',
      label: 'Kötterichen',
      provincie: 7,
      slug: 'koetterichen',
    },
    {
      code: '072335004222',
      label: 'Kolverath',
      provincie: 7,
      slug: 'kolverath',
    },
    {
      code: '072335004224',
      label: 'Lirstal',
      provincie: 7,
      slug: 'lirstal',
    },
    {
      code: '072335004225',
      label: 'Mannebach',
      provincie: 7,
      slug: 'mannebach',
    },
    {
      code: '072335004226',
      label: 'Mosbruch',
      provincie: 7,
      slug: 'mosbruch',
    },
    {
      code: '072335004228',
      label: 'Nitz',
      provincie: 7,
      slug: 'nitz',
    },
    {
      code: '072335004230',
      label: 'Oberelz',
      provincie: 7,
      slug: 'oberelz',
    },
    {
      code: '072335004233',
      label: 'Reimerath',
      provincie: 7,
      slug: 'reimerath',
    },
    {
      code: '072335004234',
      label: 'Retterath',
      provincie: 7,
      slug: 'retterath',
    },
    {
      code: '072335004236',
      label: 'Sassen',
      provincie: 7,
      slug: 'sassen',
    },
    {
      code: '072335004242',
      label: 'Uersfeld',
      provincie: 7,
      slug: 'uersfeld',
    },
    {
      code: '072335004243',
      label: 'Ueß',
      provincie: 7,
      slug: 'uess',
    },
    {
      code: '072335004244',
      label: 'Welcherath',
      provincie: 7,
      slug: 'welcherath',
    },
    {
      code: '072335006002',
      label: 'Basberg',
      provincie: 7,
      slug: 'basberg',
    },
    {
      code: '072335006004',
      label: 'Berlingen',
      provincie: 7,
      slug: 'berlingen',
    },
    {
      code: '072335006005',
      label: 'Berndorf',
      provincie: 7,
      slug: 'berndorf',
    },
    {
      code: '072335006007',
      label: 'Birgel',
      provincie: 7,
      slug: 'birgel',
    },
    {
      code: '072335006019',
      label: 'Dohm-Lammersdorf',
      provincie: 7,
      slug: 'dohm-lammersdorf',
    },
    {
      code: '072335006022',
      label: 'Esch',
      provincie: 7,
      slug: 'esch-gemeinde',
    },
    {
      code: '072335006023',
      label: 'Feusdorf',
      provincie: 7,
      slug: 'feusdorf',
    },
    {
      code: '072335006026',
      label: 'Gerolstein',
      provincie: 7,
      slug: 'gerolstein',
    },
    {
      code: '072335006028',
      label: 'Gönnersdorf',
      provincie: 7,
      slug: 'goennersdorf-gemeinde',
    },
    {
      code: '072335006029',
      label: 'Hillesheim',
      provincie: 7,
      slug: 'hillesheim',
    },
    {
      code: '072335006033',
      label: 'Hohenfels-Essingen',
      provincie: 7,
      slug: 'hohenfels-essingen',
    },
    {
      code: '072335006035',
      label: 'Jünkerath',
      provincie: 7,
      slug: 'juenkerath',
    },
    {
      code: '072335006036',
      label: 'Kalenborn-Scheuern',
      provincie: 7,
      slug: 'kalenborn-scheuern',
    },
    {
      code: '072335006038',
      label: 'Kerpen (Eifel)',
      provincie: 7,
      slug: 'kerpen-eifel',
    },
    {
      code: '072335006041',
      label: 'Lissendorf',
      provincie: 7,
      slug: 'lissendorf',
    },
    {
      code: '072335006050',
      label: 'Neroth',
      provincie: 7,
      slug: 'neroth',
    },
    {
      code: '072335006053',
      label: 'Oberbettingen',
      provincie: 7,
      slug: 'oberbettingen',
    },
    {
      code: '072335006054',
      label: 'Oberehe-Stroheich',
      provincie: 7,
      slug: 'oberehe-stroheich',
    },
    {
      code: '072335006056',
      label: 'Pelm',
      provincie: 7,
      slug: 'pelm',
    },
    {
      code: '072335006058',
      label: 'Rockeskyll',
      provincie: 7,
      slug: 'rockeskyll',
    },
    {
      code: '072335006060',
      label: 'Salm',
      provincie: 7,
      slug: 'salm',
    },
    {
      code: '072335006076',
      label: 'Üxheim',
      provincie: 7,
      slug: 'uexheim',
    },
    {
      code: '072335006080',
      label: 'Walsdorf',
      provincie: 7,
      slug: 'walsdorf',
    },
    {
      code: '072335006083',
      label: 'Wiesbaum',
      provincie: 7,
      slug: 'wiesbaum',
    },
    {
      code: '072335006204',
      label: 'Birresborn',
      provincie: 7,
      slug: 'birresborn',
    },
    {
      code: '072335006209',
      label: 'Densborn',
      provincie: 7,
      slug: 'densborn',
    },
    {
      code: '072335006211',
      label: 'Duppach',
      provincie: 7,
      slug: 'duppach',
    },
    {
      code: '072335006214',
      label: 'Hallschlag',
      provincie: 7,
      slug: 'hallschlag',
    },
    {
      code: '072335006219',
      label: 'Kerschenbach',
      provincie: 7,
      slug: 'kerschenbach',
    },
    {
      code: '072335006223',
      label: 'Kopp',
      provincie: 7,
      slug: 'kopp',
    },
    {
      code: '072335006227',
      label: 'Mürlenbach',
      provincie: 7,
      slug: 'muerlenbach',
    },
    {
      code: '072335006229',
      label: 'Nohn',
      provincie: 7,
      slug: 'nohn',
    },
    {
      code: '072335006232',
      label: 'Ormont',
      provincie: 7,
      slug: 'ormont',
    },
    {
      code: '072335006235',
      label: 'Reuth',
      provincie: 7,
      slug: 'reuth',
    },
    {
      code: '072335006237',
      label: 'Scheid',
      provincie: 7,
      slug: 'scheid',
    },
    {
      code: '072335006239',
      label: 'Schüller',
      provincie: 7,
      slug: 'schueller',
    },
    {
      code: '072335006240',
      label: 'Stadtkyll',
      provincie: 7,
      slug: 'stadtkyll',
    },
    {
      code: '072335006241',
      label: 'Steffeln',
      provincie: 7,
      slug: 'steffeln',
    },
    {
      code: '072355001005',
      label: 'Bescheid',
      provincie: 7,
      slug: 'bescheid',
    },
    {
      code: '072355001008',
      label: 'Beuren (Hochwald)',
      provincie: 7,
      slug: 'beuren-hochwald',
    },
    {
      code: '072355001014',
      label: 'Damflos',
      provincie: 7,
      slug: 'damflos',
    },
    {
      code: '072355001030',
      label: 'Geisfeld',
      provincie: 7,
      slug: 'geisfeld',
    },
    {
      code: '072355001035',
      label: 'Grimburg',
      provincie: 7,
      slug: 'grimburg',
    },
    {
      code: '072355001036',
      label: 'Gusenburg',
      provincie: 7,
      slug: 'gusenburg',
    },
    {
      code: '072355001045',
      label: 'Hermeskeil',
      provincie: 7,
      slug: 'hermeskeil',
    },
    {
      code: '072355001047',
      label: 'Hinzert-Pölert',
      provincie: 7,
      slug: 'hinzert-poelert',
    },
    {
      code: '072355001092',
      label: 'Naurath (Wald)',
      provincie: 7,
      slug: 'naurath-wald',
    },
    {
      code: '072355001093',
      label: 'Neuhütten',
      provincie: 7,
      slug: 'neuhuetten',
    },
    {
      code: '072355001112',
      label: 'Rascheid',
      provincie: 7,
      slug: 'rascheid',
    },
    {
      code: '072355001114',
      label: 'Reinsfeld',
      provincie: 7,
      slug: 'reinsfeld',
    },
    {
      code: '072355001153',
      label: 'Züsch',
      provincie: 7,
      slug: 'zuesch',
    },
    {
      code: '072355003055',
      label: 'Kanzem',
      provincie: 7,
      slug: 'kanzem',
    },
    {
      code: '072355003068',
      label: 'Konz',
      provincie: 7,
      slug: 'konz',
    },
    {
      code: '072355003095',
      label: 'Nittel',
      provincie: 7,
      slug: 'nittel',
    },
    {
      code: '072355003096',
      label: 'Oberbillig',
      provincie: 7,
      slug: 'oberbillig',
    },
    {
      code: '072355003101',
      label: 'Onsdorf',
      provincie: 7,
      slug: 'onsdorf',
    },
    {
      code: '072355003106',
      label: 'Pellingen',
      provincie: 7,
      slug: 'pellingen',
    },
    {
      code: '072355003132',
      label: 'Tawern',
      provincie: 7,
      slug: 'tawern',
    },
    {
      code: '072355003133',
      label: 'Temmels',
      provincie: 7,
      slug: 'temmels',
    },
    {
      code: '072355003143',
      label: 'Wasserliesch',
      provincie: 7,
      slug: 'wasserliesch',
    },
    {
      code: '072355003144',
      label: 'Wawern',
      provincie: 7,
      slug: 'wawern-gemeinde',
    },
    {
      code: '072355003146',
      label: 'Wellen',
      provincie: 7,
      slug: 'wellen',
    },
    {
      code: '072355003148',
      label: 'Wiltingen',
      provincie: 7,
      slug: 'wiltingen',
    },
    {
      code: '072355004010',
      label: 'Bonerath',
      provincie: 7,
      slug: 'bonerath',
    },
    {
      code: '072355004021',
      label: 'Farschweiler',
      provincie: 7,
      slug: 'farschweiler',
    },
    {
      code: '072355004037',
      label: 'Gusterath',
      provincie: 7,
      slug: 'gusterath',
    },
    {
      code: '072355004038',
      label: 'Gutweiler',
      provincie: 7,
      slug: 'gutweiler',
    },
    {
      code: '072355004044',
      label: 'Herl',
      provincie: 7,
      slug: 'herl',
    },
    {
      code: '072355004046',
      label: 'Hinzenburg',
      provincie: 7,
      slug: 'hinzenburg',
    },
    {
      code: '072355004050',
      label: 'Holzerath',
      provincie: 7,
      slug: 'holzerath',
    },
    {
      code: '072355004056',
      label: 'Kasel',
      provincie: 7,
      slug: 'kasel',
    },
    {
      code: '072355004070',
      label: 'Korlingen',
      provincie: 7,
      slug: 'korlingen',
    },
    {
      code: '072355004080',
      label: 'Lorscheid',
      provincie: 7,
      slug: 'lorscheid',
    },
    {
      code: '072355004085',
      label: 'Mertesdorf',
      provincie: 7,
      slug: 'mertesdorf',
    },
    {
      code: '072355004090',
      label: 'Morscheid',
      provincie: 7,
      slug: 'morscheid',
    },
    {
      code: '072355004100',
      label: 'Ollmuth',
      provincie: 7,
      slug: 'ollmuth',
    },
    {
      code: '072355004103',
      label: 'Osburg',
      provincie: 7,
      slug: 'osburg',
    },
    {
      code: '072355004107',
      label: 'Pluwig',
      provincie: 7,
      slug: 'pluwig',
    },
    {
      code: '072355004116',
      label: 'Riveris',
      provincie: 7,
      slug: 'riveris',
    },
    {
      code: '072355004124',
      label: 'Schöndorf',
      provincie: 7,
      slug: 'schoendorf',
    },
    {
      code: '072355004129',
      label: 'Sommerau',
      provincie: 7,
      slug: 'sommerau',
    },
    {
      code: '072355004135',
      label: 'Thomm',
      provincie: 7,
      slug: 'thomm',
    },
    {
      code: '072355004141',
      label: 'Waldrach',
      provincie: 7,
      slug: 'waldrach',
    },
    {
      code: '072355006004',
      label: 'Bekond',
      provincie: 7,
      slug: 'bekond',
    },
    {
      code: '072355006015',
      label: 'Detzem',
      provincie: 7,
      slug: 'detzem',
    },
    {
      code: '072355006019',
      label: 'Ensch',
      provincie: 7,
      slug: 'ensch',
    },
    {
      code: '072355006022',
      label: 'Fell',
      provincie: 7,
      slug: 'fell',
    },
    {
      code: '072355006026',
      label: 'Föhren',
      provincie: 7,
      slug: 'foehren',
    },
    {
      code: '072355006060',
      label: 'Kenn',
      provincie: 7,
      slug: 'kenn',
    },
    {
      code: '072355006063',
      label: 'Klüsserath',
      provincie: 7,
      slug: 'kluesserath',
    },
    {
      code: '072355006067',
      label: 'Köwerich',
      provincie: 7,
      slug: 'koewerich',
    },
    {
      code: '072355006074',
      label: 'Leiwen',
      provincie: 7,
      slug: 'leiwen',
    },
    {
      code: '072355006077',
      label: 'Longen',
      provincie: 7,
      slug: 'longen',
    },
    {
      code: '072355006078',
      label: 'Longuich',
      provincie: 7,
      slug: 'longuich',
    },
    {
      code: '072355006083',
      label: 'Mehring',
      provincie: 7,
      slug: 'mehring',
    },
    {
      code: '072355006091',
      label: 'Naurath (Eifel)',
      provincie: 7,
      slug: 'naurath-eifel',
    },
    {
      code: '072355006108',
      label: 'Pölich',
      provincie: 7,
      slug: 'poelich',
    },
    {
      code: '072355006115',
      label: 'Riol',
      provincie: 7,
      slug: 'riol',
    },
    {
      code: '072355006120',
      label: 'Schleich',
      provincie: 7,
      slug: 'schleich',
    },
    {
      code: '072355006125',
      label: 'Schweich',
      provincie: 7,
      slug: 'schweich',
    },
    {
      code: '072355006134',
      label: 'Thörnich',
      provincie: 7,
      slug: 'thoernich',
    },
    {
      code: '072355006207',
      label: 'Trittenheim',
      provincie: 7,
      slug: 'trittenheim',
    },
    {
      code: '072355007001',
      label: 'Aach',
      provincie: 7,
      slug: 'aach',
    },
    {
      code: '072355007027',
      label: 'Franzenheim',
      provincie: 7,
      slug: 'franzenheim',
    },
    {
      code: '072355007048',
      label: 'Hockweiler',
      provincie: 7,
      slug: 'hockweiler',
    },
    {
      code: '072355007051',
      label: 'Igel',
      provincie: 7,
      slug: 'igel',
    },
    {
      code: '072355007069',
      label: 'Kordel',
      provincie: 7,
      slug: 'kordel',
    },
    {
      code: '072355007073',
      label: 'Langsur',
      provincie: 7,
      slug: 'langsur',
    },
    {
      code: '072355007094',
      label: 'Newel',
      provincie: 7,
      slug: 'newel',
    },
    {
      code: '072355007111',
      label: 'Ralingen',
      provincie: 7,
      slug: 'ralingen',
    },
    {
      code: '072355007137',
      label: 'Trierweiler',
      provincie: 7,
      slug: 'trierweiler',
    },
    {
      code: '072355007151',
      label: 'Zemmer',
      provincie: 7,
      slug: 'zemmer',
    },
    {
      code: '072355007501',
      label: 'Welschbillig',
      provincie: 7,
      slug: 'welschbillig',
    },
    {
      code: '072355008002',
      label: 'Ayl',
      provincie: 7,
      slug: 'ayl',
    },
    {
      code: '072355008003',
      label: 'Baldringen',
      provincie: 7,
      slug: 'baldringen',
    },
    {
      code: '072355008025',
      label: 'Fisch',
      provincie: 7,
      slug: 'fisch',
    },
    {
      code: '072355008028',
      label: 'Freudenburg',
      provincie: 7,
      slug: 'freudenburg',
    },
    {
      code: '072355008033',
      label: 'Greimerath',
      provincie: 7,
      slug: 'greimerath-gemeinde',
    },
    {
      code: '072355008040',
      label: 'Heddert',
      provincie: 7,
      slug: 'heddert',
    },
    {
      code: '072355008043',
      label: 'Hentern',
      provincie: 7,
      slug: 'hentern',
    },
    {
      code: '072355008052',
      label: 'Irsch',
      provincie: 7,
      slug: 'irsch',
    },
    {
      code: '072355008057',
      label: 'Kastel-Staadt',
      provincie: 7,
      slug: 'kastel-staadt',
    },
    {
      code: '072355008058',
      label: 'Kell am See',
      provincie: 7,
      slug: 'kell-am-see',
    },
    {
      code: '072355008062',
      label: 'Kirf',
      provincie: 7,
      slug: 'kirf',
    },
    {
      code: '072355008072',
      label: 'Lampaden',
      provincie: 7,
      slug: 'lampaden',
    },
    {
      code: '072355008081',
      label: 'Mandern',
      provincie: 7,
      slug: 'mandern',
    },
    {
      code: '072355008082',
      label: 'Mannebach',
      provincie: 7,
      slug: 'mannebach-gemeinde',
    },
    {
      code: '072355008098',
      label: 'Ockfen',
      provincie: 7,
      slug: 'ockfen',
    },
    {
      code: '072355008104',
      label: 'Palzem',
      provincie: 7,
      slug: 'palzem',
    },
    {
      code: '072355008105',
      label: 'Paschel',
      provincie: 7,
      slug: 'paschel',
    },
    {
      code: '072355008118',
      label: 'Saarburg',
      provincie: 7,
      slug: 'saarburg',
    },
    {
      code: '072355008119',
      label: 'Schillingen',
      provincie: 7,
      slug: 'schillingen',
    },
    {
      code: '072355008122',
      label: 'Schoden',
      provincie: 7,
      slug: 'schoden',
    },
    {
      code: '072355008123',
      label: 'Schömerich',
      provincie: 7,
      slug: 'schoemerich',
    },
    {
      code: '072355008126',
      label: 'Serrig',
      provincie: 7,
      slug: 'serrig',
    },
    {
      code: '072355008131',
      label: 'Taben-Rodt',
      provincie: 7,
      slug: 'taben-rodt',
    },
    {
      code: '072355008136',
      label: 'Trassem',
      provincie: 7,
      slug: 'trassem',
    },
    {
      code: '072355008140',
      label: 'Vierherrenborn',
      provincie: 7,
      slug: 'vierherrenborn',
    },
    {
      code: '072355008142',
      label: 'Waldweiler',
      provincie: 7,
      slug: 'waldweiler',
    },
    {
      code: '072355008149',
      label: 'Wincheringen',
      provincie: 7,
      slug: 'wincheringen',
    },
    {
      code: '072355008152',
      label: 'Zerf',
      provincie: 7,
      slug: 'zerf',
    },
    {
      code: '072355008154',
      label: 'Merzkirchen',
      provincie: 7,
      slug: 'merzkirchen',
    },
    {
      code: '073110000000',
      label: 'Frankenthal (Pfalz)',
      provincie: 7,
      slug: 'frankenthal-pfalz',
    },
    {
      code: '073120000000',
      label: 'Kaiserslautern',
      provincie: 7,
      slug: 'kaiserslautern',
    },
    {
      code: '073130000000',
      label: 'Landau in der Pfalz',
      provincie: 7,
      slug: 'landau-in-der-pfalz',
    },
    {
      code: '073140000000',
      label: 'Ludwigshafen am Rhein',
      provincie: 7,
      slug: 'ludwigshafen-am-rhein',
    },
    {
      code: '073150000000',
      label: 'Mainz',
      provincie: 7,
      slug: 'mainz',
    },
    {
      code: '073160000000',
      label: 'Neustadt an der Weinstraße',
      provincie: 7,
      slug: 'neustadt-an-der-weinstrasse',
    },
    {
      code: '073170000000',
      label: 'Pirmasens',
      provincie: 7,
      slug: 'pirmasens',
    },
    {
      code: '073180000000',
      label: 'Speyer',
      provincie: 7,
      slug: 'speyer',
    },
    {
      code: '073190000000',
      label: 'Worms',
      provincie: 7,
      slug: 'worms',
    },
    {
      code: '073200000000',
      label: 'Zweibrücken',
      provincie: 7,
      slug: 'zweibruecken',
    },
    {
      code: '073310003003',
      label: 'Alzey',
      provincie: 7,
      slug: 'alzey',
    },
    {
      code: '073315001001',
      label: 'Albig',
      provincie: 7,
      slug: 'albig',
    },
    {
      code: '073315001005',
      label: 'Bechenheim',
      provincie: 7,
      slug: 'bechenheim',
    },
    {
      code: '073315001007',
      label: 'Bechtolsheim',
      provincie: 7,
      slug: 'bechtolsheim',
    },
    {
      code: '073315001008',
      label: 'Bermersheim vor der Höhe',
      provincie: 7,
      slug: 'bermersheim-vor-der-hoehe',
    },
    {
      code: '073315001010',
      label: 'Biebelnheim',
      provincie: 7,
      slug: 'biebelnheim',
    },
    {
      code: '073315001012',
      label: 'Bornheim',
      provincie: 7,
      slug: 'bornheim-gemeinde',
    },
    {
      code: '073315001014',
      label: 'Dintesheim',
      provincie: 7,
      slug: 'dintesheim',
    },
    {
      code: '073315001020',
      label: 'Eppelsheim',
      provincie: 7,
      slug: 'eppelsheim',
    },
    {
      code: '073315001021',
      label: 'Erbes-Büdesheim',
      provincie: 7,
      slug: 'erbes-buedesheim',
    },
    {
      code: '073315001022',
      label: 'Esselborn',
      provincie: 7,
      slug: 'esselborn',
    },
    {
      code: '073315001024',
      label: 'Flomborn',
      provincie: 7,
      slug: 'flomborn',
    },
    {
      code: '073315001025',
      label: 'Flonheim',
      provincie: 7,
      slug: 'flonheim',
    },
    {
      code: '073315001026',
      label: 'Framersheim',
      provincie: 7,
      slug: 'framersheim',
    },
    {
      code: '073315001027',
      label: 'Freimersheim',
      provincie: 7,
      slug: 'freimersheim',
    },
    {
      code: '073315001031',
      label: 'Gau-Heppenheim',
      provincie: 7,
      slug: 'gau-heppenheim',
    },
    {
      code: '073315001032',
      label: 'Gau-Odernheim',
      provincie: 7,
      slug: 'gau-odernheim',
    },
    {
      code: '073315001042',
      label: 'Kettenheim',
      provincie: 7,
      slug: 'kettenheim',
    },
    {
      code: '073315001043',
      label: 'Lonsheim',
      provincie: 7,
      slug: 'lonsheim',
    },
    {
      code: '073315001044',
      label: 'Mauchenheim',
      provincie: 7,
      slug: 'mauchenheim',
    },
    {
      code: '073315001050',
      label: 'Nack',
      provincie: 7,
      slug: 'nack',
    },
    {
      code: '073315001051',
      label: 'Nieder-Wiesen',
      provincie: 7,
      slug: 'nieder-wiesen',
    },
    {
      code: '073315001052',
      label: 'Ober-Flörsheim',
      provincie: 7,
      slug: 'ober-floersheim',
    },
    {
      code: '073315001053',
      label: 'Offenheim',
      provincie: 7,
      slug: 'offenheim',
    },
    {
      code: '073315001067',
      label: 'Wahlheim',
      provincie: 7,
      slug: 'wahlheim',
    },
    {
      code: '073315002002',
      label: 'Alsheim',
      provincie: 7,
      slug: 'alsheim',
    },
    {
      code: '073315002018',
      label: 'Eich',
      provincie: 7,
      slug: 'eich',
    },
    {
      code: '073315002034',
      label: 'Gimbsheim',
      provincie: 7,
      slug: 'gimbsheim',
    },
    {
      code: '073315002038',
      label: 'Hamm am Rhein',
      provincie: 7,
      slug: 'hamm-am-rhein',
    },
    {
      code: '073315002045',
      label: 'Mettenheim',
      provincie: 7,
      slug: 'mettenheim',
    },
    {
      code: '073315003023',
      label: 'Flörsheim-Dalsheim',
      provincie: 7,
      slug: 'floersheim-dalsheim',
    },
    {
      code: '073315003041',
      label: 'Hohen-Sülzen',
      provincie: 7,
      slug: 'hohen-suelzen',
    },
    {
      code: '073315003046',
      label: 'Mölsheim',
      provincie: 7,
      slug: 'moelsheim',
    },
    {
      code: '073315003047',
      label: 'Mörstadt',
      provincie: 7,
      slug: 'moerstadt',
    },
    {
      code: '073315003048',
      label: 'Monsheim',
      provincie: 7,
      slug: 'monsheim',
    },
    {
      code: '073315003054',
      label: 'Offstein',
      provincie: 7,
      slug: 'offstein',
    },
    {
      code: '073315003066',
      label: 'Wachenheim',
      provincie: 7,
      slug: 'wachenheim',
    },
    {
      code: '073315005017',
      label: 'Eckelsheim',
      provincie: 7,
      slug: 'eckelsheim',
    },
    {
      code: '073315005030',
      label: 'Gau-Bickelheim',
      provincie: 7,
      slug: 'gau-bickelheim',
    },
    {
      code: '073315005035',
      label: 'Gumbsheim',
      provincie: 7,
      slug: 'gumbsheim',
    },
    {
      code: '073315005060',
      label: 'Siefersheim',
      provincie: 7,
      slug: 'siefersheim',
    },
    {
      code: '073315005062',
      label: 'Stein-Bockenheim',
      provincie: 7,
      slug: 'stein-bockenheim',
    },
    {
      code: '073315005070',
      label: 'Wendelsheim',
      provincie: 7,
      slug: 'wendelsheim',
    },
    {
      code: '073315005072',
      label: 'Wöllstein',
      provincie: 7,
      slug: 'woellstein',
    },
    {
      code: '073315005075',
      label: 'Wonsheim',
      provincie: 7,
      slug: 'wonsheim',
    },
    {
      code: '073315006004',
      label: 'Armsheim',
      provincie: 7,
      slug: 'armsheim',
    },
    {
      code: '073315006019',
      label: 'Ensheim',
      provincie: 7,
      slug: 'ensheim',
    },
    {
      code: '073315006029',
      label: 'Gabsheim',
      provincie: 7,
      slug: 'gabsheim',
    },
    {
      code: '073315006033',
      label: 'Gau-Weinheim',
      provincie: 7,
      slug: 'gau-weinheim',
    },
    {
      code: '073315006056',
      label: 'Partenheim',
      provincie: 7,
      slug: 'partenheim',
    },
    {
      code: '073315006058',
      label: 'Saulheim',
      provincie: 7,
      slug: 'saulheim',
    },
    {
      code: '073315006059',
      label: 'Schornsheim',
      provincie: 7,
      slug: 'schornsheim',
    },
    {
      code: '073315006061',
      label: 'Spiesheim',
      provincie: 7,
      slug: 'spiesheim',
    },
    {
      code: '073315006063',
      label: 'Sulzheim',
      provincie: 7,
      slug: 'sulzheim',
    },
    {
      code: '073315006064',
      label: 'Udenheim',
      provincie: 7,
      slug: 'udenheim',
    },
    {
      code: '073315006065',
      label: 'Vendersheim',
      provincie: 7,
      slug: 'vendersheim',
    },
    {
      code: '073315006068',
      label: 'Wallertheim',
      provincie: 7,
      slug: 'wallertheim',
    },
    {
      code: '073315006073',
      label: 'Wörrstadt',
      provincie: 7,
      slug: 'woerrstadt',
    },
    {
      code: '073315007006',
      label: 'Bechtheim',
      provincie: 7,
      slug: 'bechtheim',
    },
    {
      code: '073315007009',
      label: 'Bermersheim',
      provincie: 7,
      slug: 'bermersheim',
    },
    {
      code: '073315007011',
      label: 'Hochborn',
      provincie: 7,
      slug: 'hochborn',
    },
    {
      code: '073315007015',
      label: 'Dittelsheim-Heßloch',
      provincie: 7,
      slug: 'dittelsheim-hessloch',
    },
    {
      code: '073315007028',
      label: 'Frettenheim',
      provincie: 7,
      slug: 'frettenheim',
    },
    {
      code: '073315007036',
      label: 'Gundersheim',
      provincie: 7,
      slug: 'gundersheim',
    },
    {
      code: '073315007037',
      label: 'Gundheim',
      provincie: 7,
      slug: 'gundheim',
    },
    {
      code: '073315007039',
      label: 'Hangen-Weisheim',
      provincie: 7,
      slug: 'hangen-weisheim',
    },
    {
      code: '073315007049',
      label: 'Monzernheim',
      provincie: 7,
      slug: 'monzernheim',
    },
    {
      code: '073315007055',
      label: 'Osthofen',
      provincie: 7,
      slug: 'osthofen',
    },
    {
      code: '073315007071',
      label: 'Westhofen',
      provincie: 7,
      slug: 'westhofen',
    },
    {
      code: '073320002002',
      label: 'Bad Dürkheim',
      provincie: 7,
      slug: 'bad-duerkheim',
    },
    {
      code: '073320024024',
      label: 'Grünstadt',
      provincie: 7,
      slug: 'gruenstadt',
    },
    {
      code: '073320025025',
      label: 'Haßloch',
      provincie: 7,
      slug: 'hassloch',
    },
    {
      code: '073325001009',
      label: 'Deidesheim',
      provincie: 7,
      slug: 'deidesheim',
    },
    {
      code: '073325001017',
      label: 'Forst an der Weinstraße',
      provincie: 7,
      slug: 'forst-an-der-weinstrasse',
    },
    {
      code: '073325001035',
      label: 'Meckenheim',
      provincie: 7,
      slug: 'meckenheim-gemeinde',
    },
    {
      code: '073325001039',
      label: 'Niederkirchen bei Deidesheim',
      provincie: 7,
      slug: 'niederkirchen-bei-deidesheim',
    },
    {
      code: '073325001043',
      label: 'Ruppertsberg',
      provincie: 7,
      slug: 'ruppertsberg',
    },
    {
      code: '073325002005',
      label: 'Bobenheim am Berg',
      provincie: 7,
      slug: 'bobenheim-am-berg',
    },
    {
      code: '073325002008',
      label: 'Dackenheim',
      provincie: 7,
      slug: 'dackenheim',
    },
    {
      code: '073325002015',
      label: 'Erpolzheim',
      provincie: 7,
      slug: 'erpolzheim',
    },
    {
      code: '073325002019',
      label: 'Freinsheim',
      provincie: 7,
      slug: 'freinsheim',
    },
    {
      code: '073325002026',
      label: 'Herxheim am Berg',
      provincie: 7,
      slug: 'herxheim-am-berg',
    },
    {
      code: '073325002028',
      label: 'Kallstadt',
      provincie: 7,
      slug: 'kallstadt',
    },
    {
      code: '073325002049',
      label: 'Weisenheim am Berg',
      provincie: 7,
      slug: 'weisenheim-am-berg',
    },
    {
      code: '073325002050',
      label: 'Weisenheim am Sand',
      provincie: 7,
      slug: 'weisenheim-am-sand',
    },
    {
      code: '073325005014',
      label: 'Elmstein',
      provincie: 7,
      slug: 'elmstein',
    },
    {
      code: '073325005016',
      label: 'Esthal',
      provincie: 7,
      slug: 'esthal',
    },
    {
      code: '073325005018',
      label: 'Frankeneck',
      provincie: 7,
      slug: 'frankeneck',
    },
    {
      code: '073325005032',
      label: 'Lambrecht (Pfalz)',
      provincie: 7,
      slug: 'lambrecht-pfalz',
    },
    {
      code: '073325005034',
      label: 'Lindenberg',
      provincie: 7,
      slug: 'lindenberg',
    },
    {
      code: '073325005037',
      label: 'Neidenfels',
      provincie: 7,
      slug: 'neidenfels',
    },
    {
      code: '073325005048',
      label: 'Weidenthal',
      provincie: 7,
      slug: 'weidenthal',
    },
    {
      code: '073325006013',
      label: 'Ellerstadt',
      provincie: 7,
      slug: 'ellerstadt',
    },
    {
      code: '073325006020',
      label: 'Friedelsheim',
      provincie: 7,
      slug: 'friedelsheim',
    },
    {
      code: '073325006022',
      label: 'Gönnheim',
      provincie: 7,
      slug: 'goennheim',
    },
    {
      code: '073325006046',
      label: 'Wachenheim an der Weinstraße',
      provincie: 7,
      slug: 'wachenheim-an-der-weinstrasse',
    },
    {
      code: '073325007001',
      label: 'Altleiningen',
      provincie: 7,
      slug: 'altleiningen',
    },
    {
      code: '073325007003',
      label: 'Battenberg (Pfalz)',
      provincie: 7,
      slug: 'battenberg-pfalz',
    },
    {
      code: '073325007004',
      label: 'Bissersheim',
      provincie: 7,
      slug: 'bissersheim',
    },
    {
      code: '073325007006',
      label: 'Bockenheim an der Weinstraße',
      provincie: 7,
      slug: 'bockenheim-an-der-weinstrasse',
    },
    {
      code: '073325007007',
      label: 'Carlsberg',
      provincie: 7,
      slug: 'carlsberg',
    },
    {
      code: '073325007010',
      label: 'Dirmstein',
      provincie: 7,
      slug: 'dirmstein',
    },
    {
      code: '073325007012',
      label: 'Ebertsheim',
      provincie: 7,
      slug: 'ebertsheim',
    },
    {
      code: '073325007021',
      label: 'Gerolsheim',
      provincie: 7,
      slug: 'gerolsheim',
    },
    {
      code: '073325007023',
      label: 'Großkarlbach',
      provincie: 7,
      slug: 'grosskarlbach',
    },
    {
      code: '073325007027',
      label: 'Hettenleidelheim',
      provincie: 7,
      slug: 'hettenleidelheim',
    },
    {
      code: '073325007029',
      label: 'Kindenheim',
      provincie: 7,
      slug: 'kindenheim',
    },
    {
      code: '073325007030',
      label: 'Kirchheim an der Weinstraße',
      provincie: 7,
      slug: 'kirchheim-an-der-weinstrasse',
    },
    {
      code: '073325007031',
      label: 'Kleinkarlbach',
      provincie: 7,
      slug: 'kleinkarlbach',
    },
    {
      code: '073325007033',
      label: 'Laumersheim',
      provincie: 7,
      slug: 'laumersheim',
    },
    {
      code: '073325007036',
      label: 'Mertesheim',
      provincie: 7,
      slug: 'mertesheim',
    },
    {
      code: '073325007038',
      label: 'Neuleiningen',
      provincie: 7,
      slug: 'neuleiningen',
    },
    {
      code: '073325007040',
      label: 'Obersülzen',
      provincie: 7,
      slug: 'obersuelzen',
    },
    {
      code: '073325007041',
      label: 'Obrigheim (Pfalz)',
      provincie: 7,
      slug: 'obrigheim-pfalz',
    },
    {
      code: '073325007042',
      label: 'Quirnheim',
      provincie: 7,
      slug: 'quirnheim',
    },
    {
      code: '073325007044',
      label: 'Tiefenthal',
      provincie: 7,
      slug: 'tiefenthal-gemeinde',
    },
    {
      code: '073325007047',
      label: 'Wattenheim',
      provincie: 7,
      slug: 'wattenheim',
    },
    {
      code: '073335002019',
      label: 'Eisenberg (Pfalz)',
      provincie: 7,
      slug: 'eisenberg-pfalz',
    },
    {
      code: '073335002038',
      label: 'Kerzenheim',
      provincie: 7,
      slug: 'kerzenheim',
    },
    {
      code: '073335002060',
      label: 'Ramsen',
      provincie: 7,
      slug: 'ramsen',
    },
    {
      code: '073335003001',
      label: 'Albisheim (Pfrimm)',
      provincie: 7,
      slug: 'albisheim-pfrimm',
    },
    {
      code: '073335003006',
      label: 'Biedesheim',
      provincie: 7,
      slug: 'biedesheim',
    },
    {
      code: '073335003012',
      label: 'Bubenheim',
      provincie: 7,
      slug: 'bubenheim',
    },
    {
      code: '073335003017',
      label: 'Dreisen',
      provincie: 7,
      slug: 'dreisen',
    },
    {
      code: '073335003018',
      label: 'Einselthum',
      provincie: 7,
      slug: 'einselthum',
    },
    {
      code: '073335003026',
      label: 'Göllheim',
      provincie: 7,
      slug: 'goellheim',
    },
    {
      code: '073335003032',
      label: 'Immesheim',
      provincie: 7,
      slug: 'immesheim',
    },
    {
      code: '073335003041',
      label: 'Lautersheim',
      provincie: 7,
      slug: 'lautersheim',
    },
    {
      code: '073335003058',
      label: 'Ottersheim',
      provincie: 7,
      slug: 'ottersheim',
    },
    {
      code: '073335003064',
      label: 'Rüssingen',
      provincie: 7,
      slug: 'ruessingen',
    },
    {
      code: '073335003074',
      label: 'Standenbühl',
      provincie: 7,
      slug: 'standenbuehl',
    },
    {
      code: '073335003081',
      label: 'Weitersweiler',
      provincie: 7,
      slug: 'weitersweiler',
    },
    {
      code: '073335003501',
      label: 'Zellertal',
      provincie: 7,
      slug: 'zellertal',
    },
    {
      code: '073335004005',
      label: 'Bennhausen',
      provincie: 7,
      slug: 'bennhausen',
    },
    {
      code: '073335004007',
      label: 'Bischheim',
      provincie: 7,
      slug: 'bischheim',
    },
    {
      code: '073335004010',
      label: 'Bolanden',
      provincie: 7,
      slug: 'bolanden',
    },
    {
      code: '073335004013',
      label: 'Dannenfels',
      provincie: 7,
      slug: 'dannenfels',
    },
    {
      code: '073335004022',
      label: 'Gauersheim',
      provincie: 7,
      slug: 'gauersheim',
    },
    {
      code: '073335004031',
      label: 'Ilbesheim',
      provincie: 7,
      slug: 'ilbesheim',
    },
    {
      code: '073335004035',
      label: 'Jakobsweiler',
      provincie: 7,
      slug: 'jakobsweiler',
    },
    {
      code: '073335004039',
      label: 'Kirchheimbolanden',
      provincie: 7,
      slug: 'kirchheimbolanden',
    },
    {
      code: '073335004040',
      label: 'Kriegsfeld',
      provincie: 7,
      slug: 'kriegsfeld',
    },
    {
      code: '073335004045',
      label: 'Marnheim',
      provincie: 7,
      slug: 'marnheim',
    },
    {
      code: '073335004046',
      label: 'Mörsfeld',
      provincie: 7,
      slug: 'moersfeld',
    },
    {
      code: '073335004047',
      label: 'Morschheim',
      provincie: 7,
      slug: 'morschheim',
    },
    {
      code: '073335004056',
      label: 'Oberwiesen',
      provincie: 7,
      slug: 'oberwiesen',
    },
    {
      code: '073335004057',
      label: 'Orbis',
      provincie: 7,
      slug: 'orbis',
    },
    {
      code: '073335004062',
      label: 'Rittersheim',
      provincie: 7,
      slug: 'rittersheim',
    },
    {
      code: '073335004076',
      label: 'Stetten',
      provincie: 7,
      slug: 'stetten',
    },
    {
      code: '073335006009',
      label: 'Börrstadt',
      provincie: 7,
      slug: 'boerrstadt',
    },
    {
      code: '073335006011',
      label: 'Breunigweiler',
      provincie: 7,
      slug: 'breunigweiler',
    },
    {
      code: '073335006020',
      label: 'Falkenstein',
      provincie: 7,
      slug: 'falkenstein',
    },
    {
      code: '073335006027',
      label: 'Gonbach',
      provincie: 7,
      slug: 'gonbach',
    },
    {
      code: '073335006030',
      label: 'Höringen',
      provincie: 7,
      slug: 'hoeringen',
    },
    {
      code: '073335006033',
      label: 'Imsbach',
      provincie: 7,
      slug: 'imsbach',
    },
    {
      code: '073335006042',
      label: 'Lohnsfeld',
      provincie: 7,
      slug: 'lohnsfeld',
    },
    {
      code: '073335006048',
      label: 'Münchweiler an der Alsenz',
      provincie: 7,
      slug: 'muenchweiler-an-der-alsenz',
    },
    {
      code: '073335006069',
      label: 'Schweisweiler',
      provincie: 7,
      slug: 'schweisweiler',
    },
    {
      code: '073335006071',
      label: 'Sippersfeld',
      provincie: 7,
      slug: 'sippersfeld',
    },
    {
      code: '073335006075',
      label: 'Steinbach am Donnersberg',
      provincie: 7,
      slug: 'steinbach-am-donnersberg',
    },
    {
      code: '073335006080',
      label: 'Wartenberg-Rohrbach',
      provincie: 7,
      slug: 'wartenberg-rohrbach',
    },
    {
      code: '073335006503',
      label: 'Winnweiler',
      provincie: 7,
      slug: 'winnweiler',
    },
    {
      code: '073335007003',
      label: 'Alsenz',
      provincie: 7,
      slug: 'alsenz',
    },
    {
      code: '073335007004',
      label: 'Bayerfeld-Steckweiler',
      provincie: 7,
      slug: 'bayerfeld-steckweiler',
    },
    {
      code: '073335007008',
      label: 'Bisterschied',
      provincie: 7,
      slug: 'bisterschied',
    },
    {
      code: '073335007014',
      label: 'Dielkirchen',
      provincie: 7,
      slug: 'dielkirchen',
    },
    {
      code: '073335007016',
      label: 'Dörrmoschel',
      provincie: 7,
      slug: 'doerrmoschel',
    },
    {
      code: '073335007021',
      label: 'Finkenbach-Gersweiler',
      provincie: 7,
      slug: 'finkenbach-gersweiler',
    },
    {
      code: '073335007023',
      label: 'Gaugrehweiler',
      provincie: 7,
      slug: 'gaugrehweiler',
    },
    {
      code: '073335007024',
      label: 'Gehrweiler',
      provincie: 7,
      slug: 'gehrweiler',
    },
    {
      code: '073335007025',
      label: 'Gerbach',
      provincie: 7,
      slug: 'gerbach',
    },
    {
      code: '073335007028',
      label: 'Gundersweiler',
      provincie: 7,
      slug: 'gundersweiler',
    },
    {
      code: '073335007034',
      label: 'Imsweiler',
      provincie: 7,
      slug: 'imsweiler',
    },
    {
      code: '073335007036',
      label: 'Kalkofen',
      provincie: 7,
      slug: 'kalkofen',
    },
    {
      code: '073335007037',
      label: 'Katzenbach',
      provincie: 7,
      slug: 'katzenbach',
    },
    {
      code: '073335007043',
      label: 'Mannweiler-Cölln',
      provincie: 7,
      slug: 'mannweiler-coelln',
    },
    {
      code: '073335007049',
      label: 'Münsterappel',
      provincie: 7,
      slug: 'muensterappel',
    },
    {
      code: '073335007050',
      label: 'Niederhausen an der Appel',
      provincie: 7,
      slug: 'niederhausen-an-der-appel',
    },
    {
      code: '073335007051',
      label: 'Niedermoschel',
      provincie: 7,
      slug: 'niedermoschel',
    },
    {
      code: '073335007053',
      label: 'Oberhausen an der Appel',
      provincie: 7,
      slug: 'oberhausen-an-der-appel',
    },
    {
      code: '073335007054',
      label: 'Obermoschel',
      provincie: 7,
      slug: 'obermoschel',
    },
    {
      code: '073335007055',
      label: 'Oberndorf',
      provincie: 7,
      slug: 'oberndorf-gemeinde',
    },
    {
      code: '073335007061',
      label: 'Ransweiler',
      provincie: 7,
      slug: 'ransweiler',
    },
    {
      code: '073335007065',
      label: 'Ruppertsecken',
      provincie: 7,
      slug: 'ruppertsecken',
    },
    {
      code: '073335007066',
      label: 'Sankt Alban',
      provincie: 7,
      slug: 'sankt-alban',
    },
    {
      code: '073335007067',
      label: 'Schiersfeld',
      provincie: 7,
      slug: 'schiersfeld',
    },
    {
      code: '073335007068',
      label: 'Schönborn',
      provincie: 7,
      slug: 'schoenborn-gemeinde',
    },
    {
      code: '073335007072',
      label: 'Sitters',
      provincie: 7,
      slug: 'sitters',
    },
    {
      code: '073335007073',
      label: 'Stahlberg',
      provincie: 7,
      slug: 'stahlberg',
    },
    {
      code: '073335007077',
      label: 'Teschenmoschel',
      provincie: 7,
      slug: 'teschenmoschel',
    },
    {
      code: '073335007078',
      label: 'Unkenbach',
      provincie: 7,
      slug: 'unkenbach',
    },
    {
      code: '073335007079',
      label: 'Waldgrehweiler',
      provincie: 7,
      slug: 'waldgrehweiler',
    },
    {
      code: '073335007083',
      label: 'Winterborn',
      provincie: 7,
      slug: 'winterborn',
    },
    {
      code: '073335007084',
      label: 'Würzweiler',
      provincie: 7,
      slug: 'wuerzweiler',
    },
    {
      code: '073335007201',
      label: 'Rathskirchen',
      provincie: 7,
      slug: 'rathskirchen',
    },
    {
      code: '073335007202',
      label: 'Reichsthal',
      provincie: 7,
      slug: 'reichsthal',
    },
    {
      code: '073335007203',
      label: 'Seelen',
      provincie: 7,
      slug: 'seelen',
    },
    {
      code: '073335007502',
      label: 'Rockenhausen',
      provincie: 7,
      slug: 'rockenhausen',
    },
    {
      code: '073340007007',
      label: 'Germersheim',
      provincie: 7,
      slug: 'germersheim',
    },
    {
      code: '073340501501',
      label: 'Wörth am Rhein',
      provincie: 7,
      slug: 'woerth-am-rhein',
    },
    {
      code: '073345001001',
      label: 'Bellheim',
      provincie: 7,
      slug: 'bellheim',
    },
    {
      code: '073345001014',
      label: 'Knittelsheim',
      provincie: 7,
      slug: 'knittelsheim',
    },
    {
      code: '073345001023',
      label: 'Ottersheim bei Landau',
      provincie: 7,
      slug: 'ottersheim-bei-landau',
    },
    {
      code: '073345001036',
      label: 'Zeiskam',
      provincie: 7,
      slug: 'zeiskam',
    },
    {
      code: '073345002002',
      label: 'Berg (Pfalz)',
      provincie: 7,
      slug: 'berg-pfalz',
    },
    {
      code: '073345002008',
      label: 'Hagenbach',
      provincie: 7,
      slug: 'hagenbach',
    },
    {
      code: '073345002021',
      label: 'Neuburg am Rhein',
      provincie: 7,
      slug: 'neuburg-am-rhein',
    },
    {
      code: '073345002027',
      label: 'Scheibenhardt',
      provincie: 7,
      slug: 'scheibenhardt',
    },
    {
      code: '073345003009',
      label: 'Hatzenbühl',
      provincie: 7,
      slug: 'hatzenbuehl',
    },
    {
      code: '073345003012',
      label: 'Jockgrim',
      provincie: 7,
      slug: 'jockgrim',
    },
    {
      code: '073345003022',
      label: 'Neupotz',
      provincie: 7,
      slug: 'neupotz',
    },
    {
      code: '073345003024',
      label: 'Rheinzabern',
      provincie: 7,
      slug: 'rheinzabern',
    },
    {
      code: '073345004004',
      label: 'Erlenbach bei Kandel',
      provincie: 7,
      slug: 'erlenbach-bei-kandel',
    },
    {
      code: '073345004005',
      label: 'Freckenfeld',
      provincie: 7,
      slug: 'freckenfeld',
    },
    {
      code: '073345004013',
      label: 'Kandel',
      provincie: 7,
      slug: 'kandel',
    },
    {
      code: '073345004020',
      label: 'Minfeld',
      provincie: 7,
      slug: 'minfeld',
    },
    {
      code: '073345004030',
      label: 'Steinweiler',
      provincie: 7,
      slug: 'steinweiler',
    },
    {
      code: '073345004031',
      label: 'Vollmersweiler',
      provincie: 7,
      slug: 'vollmersweiler',
    },
    {
      code: '073345004034',
      label: 'Winden',
      provincie: 7,
      slug: 'winden-gemeinde',
    },
    {
      code: '073345005006',
      label: 'Freisbach',
      provincie: 7,
      slug: 'freisbach',
    },
    {
      code: '073345005017',
      label: 'Lingenfeld',
      provincie: 7,
      slug: 'lingenfeld',
    },
    {
      code: '073345005018',
      label: 'Lustadt',
      provincie: 7,
      slug: 'lustadt',
    },
    {
      code: '073345005028',
      label: 'Schwegenheim',
      provincie: 7,
      slug: 'schwegenheim',
    },
    {
      code: '073345005032',
      label: 'Weingarten (Pfalz)',
      provincie: 7,
      slug: 'weingarten-pfalz',
    },
    {
      code: '073345005033',
      label: 'Westheim (Pfalz)',
      provincie: 7,
      slug: 'westheim-pfalz',
    },
    {
      code: '073345006011',
      label: 'Hördt',
      provincie: 7,
      slug: 'hoerdt',
    },
    {
      code: '073345006015',
      label: 'Kuhardt',
      provincie: 7,
      slug: 'kuhardt',
    },
    {
      code: '073345006016',
      label: 'Leimersheim',
      provincie: 7,
      slug: 'leimersheim',
    },
    {
      code: '073345006025',
      label: 'Rülzheim',
      provincie: 7,
      slug: 'ruelzheim',
    },
    {
      code: '073355001003',
      label: 'Bruchmühlbach-Miesau',
      provincie: 7,
      slug: 'bruchmuehlbach-miesau',
    },
    {
      code: '073355001011',
      label: 'Gerhardsbrunn',
      provincie: 7,
      slug: 'gerhardsbrunn',
    },
    {
      code: '073355001201',
      label: 'Lambsborn',
      provincie: 7,
      slug: 'lambsborn',
    },
    {
      code: '073355001202',
      label: 'Langwieden',
      provincie: 7,
      slug: 'langwieden',
    },
    {
      code: '073355001203',
      label: 'Martinshöhe',
      provincie: 7,
      slug: 'martinshoehe',
    },
    {
      code: '073355002004',
      label: 'Enkenbach-Alsenborn',
      provincie: 7,
      slug: 'enkenbach-alsenborn',
    },
    {
      code: '073355002007',
      label: 'Fischbach',
      provincie: 7,
      slug: 'fischbach-gemeinde',
    },
    {
      code: '073355002010',
      label: 'Frankenstein',
      provincie: 7,
      slug: 'frankenstein',
    },
    {
      code: '073355002015',
      label: 'Hochspeyer',
      provincie: 7,
      slug: 'hochspeyer',
    },
    {
      code: '073355002026',
      label: 'Mehlingen',
      provincie: 7,
      slug: 'mehlingen',
    },
    {
      code: '073355002028',
      label: 'Neuhemsbach',
      provincie: 7,
      slug: 'neuhemsbach',
    },
    {
      code: '073355002048',
      label: 'Waldleiningen',
      provincie: 7,
      slug: 'waldleiningen',
    },
    {
      code: '073355002205',
      label: 'Sembach',
      provincie: 7,
      slug: 'sembach',
    },
    {
      code: '073355008016',
      label: 'Hütschenhausen',
      provincie: 7,
      slug: 'huetschenhausen',
    },
    {
      code: '073355008020',
      label: 'Kottweiler-Schwanden',
      provincie: 7,
      slug: 'kottweiler-schwanden',
    },
    {
      code: '073355008030',
      label: 'Niedermohr',
      provincie: 7,
      slug: 'niedermohr',
    },
    {
      code: '073355008038',
      label: 'Ramstein-Miesenbach',
      provincie: 7,
      slug: 'ramstein-miesenbach',
    },
    {
      code: '073355008044',
      label: 'Steinwenden',
      provincie: 7,
      slug: 'steinwenden',
    },
    {
      code: '073355009005',
      label: 'Erzenhausen',
      provincie: 7,
      slug: 'erzenhausen',
    },
    {
      code: '073355009006',
      label: 'Eulenbis',
      provincie: 7,
      slug: 'eulenbis',
    },
    {
      code: '073355009019',
      label: 'Kollweiler',
      provincie: 7,
      slug: 'kollweiler',
    },
    {
      code: '073355009024',
      label: 'Mackenbach',
      provincie: 7,
      slug: 'mackenbach',
    },
    {
      code: '073355009040',
      label: 'Rodenbach',
      provincie: 7,
      slug: 'rodenbach-gemeinde',
    },
    {
      code: '073355009043',
      label: 'Schwedelbach',
      provincie: 7,
      slug: 'schwedelbach',
    },
    {
      code: '073355009049',
      label: 'Weilerbach',
      provincie: 7,
      slug: 'weilerbach',
    },
    {
      code: '073355009501',
      label: 'Reichenbach-Steegen',
      provincie: 7,
      slug: 'reichenbach-steegen',
    },
    {
      code: '073355010009',
      label: 'Frankelbach',
      provincie: 7,
      slug: 'frankelbach',
    },
    {
      code: '073355010013',
      label: 'Heiligenmoschel',
      provincie: 7,
      slug: 'heiligenmoschel',
    },
    {
      code: '073355010014',
      label: 'Hirschhorn/Pfalz',
      provincie: 7,
      slug: 'hirschhorn-pfalz',
    },
    {
      code: '073355010017',
      label: 'Katzweiler',
      provincie: 7,
      slug: 'katzweiler',
    },
    {
      code: '073355010025',
      label: 'Mehlbach',
      provincie: 7,
      slug: 'mehlbach',
    },
    {
      code: '073355010029',
      label: 'Niederkirchen',
      provincie: 7,
      slug: 'niederkirchen',
    },
    {
      code: '073355010033',
      label: 'Olsbrücken',
      provincie: 7,
      slug: 'olsbruecken',
    },
    {
      code: '073355010034',
      label: 'Otterbach',
      provincie: 7,
      slug: 'otterbach',
    },
    {
      code: '073355010035',
      label: 'Otterberg',
      provincie: 7,
      slug: 'otterberg',
    },
    {
      code: '073355010041',
      label: 'Schallodenbach',
      provincie: 7,
      slug: 'schallodenbach',
    },
    {
      code: '073355010042',
      label: 'Schneckenhausen',
      provincie: 7,
      slug: 'schneckenhausen',
    },
    {
      code: '073355010046',
      label: 'Sulzbachtal',
      provincie: 7,
      slug: 'sulzbachtal',
    },
    {
      code: '073355011002',
      label: 'Bann',
      provincie: 7,
      slug: 'bann',
    },
    {
      code: '073355011012',
      label: 'Hauptstuhl',
      provincie: 7,
      slug: 'hauptstuhl',
    },
    {
      code: '073355011018',
      label: 'Kindsbach',
      provincie: 7,
      slug: 'kindsbach',
    },
    {
      code: '073355011021',
      label: 'Krickenbach',
      provincie: 7,
      slug: 'krickenbach',
    },
    {
      code: '073355011022',
      label: 'Landstuhl',
      provincie: 7,
      slug: 'landstuhl',
    },
    {
      code: '073355011023',
      label: 'Linden',
      provincie: 7,
      slug: 'linden-gemeinde',
    },
    {
      code: '073355011027',
      label: 'Mittelbrunn',
      provincie: 7,
      slug: 'mittelbrunn',
    },
    {
      code: '073355011031',
      label: 'Oberarnbach',
      provincie: 7,
      slug: 'oberarnbach',
    },
    {
      code: '073355011037',
      label: 'Queidersbach',
      provincie: 7,
      slug: 'queidersbach',
    },
    {
      code: '073355011045',
      label: 'Stelzenberg',
      provincie: 7,
      slug: 'stelzenberg',
    },
    {
      code: '073355011047',
      label: 'Trippstadt',
      provincie: 7,
      slug: 'trippstadt',
    },
    {
      code: '073355011204',
      label: 'Schopp',
      provincie: 7,
      slug: 'schopp',
    },
    {
      code: '073365008001',
      label: 'Adenbach',
      provincie: 7,
      slug: 'adenbach',
    },
    {
      code: '073365008005',
      label: 'Aschbach',
      provincie: 7,
      slug: 'aschbach',
    },
    {
      code: '073365008012',
      label: 'Buborn',
      provincie: 7,
      slug: 'buborn',
    },
    {
      code: '073365008013',
      label: 'Cronenberg',
      provincie: 7,
      slug: 'cronenberg',
    },
    {
      code: '073365008014',
      label: 'Deimberg',
      provincie: 7,
      slug: 'deimberg',
    },
    {
      code: '073365008019',
      label: 'Einöllen',
      provincie: 7,
      slug: 'einoellen',
    },
    {
      code: '073365008023',
      label: 'Eßweiler',
      provincie: 7,
      slug: 'essweiler',
    },
    {
      code: '073365008029',
      label: 'Ginsweiler',
      provincie: 7,
      slug: 'ginsweiler',
    },
    {
      code: '073365008030',
      label: 'Glanbrücken',
      provincie: 7,
      slug: 'glanbruecken',
    },
    {
      code: '073365008033',
      label: 'Grumbach',
      provincie: 7,
      slug: 'grumbach',
    },
    {
      code: '073365008035',
      label: 'Hausweiler',
      provincie: 7,
      slug: 'hausweiler',
    },
    {
      code: '073365008036',
      label: 'Hefersweiler',
      provincie: 7,
      slug: 'hefersweiler',
    },
    {
      code: '073365008038',
      label: 'Heinzenhausen',
      provincie: 7,
      slug: 'heinzenhausen',
    },
    {
      code: '073365008040',
      label: 'Herren-Sulzbach',
      provincie: 7,
      slug: 'herren-sulzbach',
    },
    {
      code: '073365008042',
      label: 'Hinzweiler',
      provincie: 7,
      slug: 'hinzweiler',
    },
    {
      code: '073365008043',
      label: 'Hohenöllen',
      provincie: 7,
      slug: 'hohenoellen',
    },
    {
      code: '073365008044',
      label: 'Homberg',
      provincie: 7,
      slug: 'homberg-gemeinde',
    },
    {
      code: '073365008045',
      label: 'Hoppstädten',
      provincie: 7,
      slug: 'hoppstaedten',
    },
    {
      code: '073365008048',
      label: 'Jettenbach',
      provincie: 7,
      slug: 'jettenbach',
    },
    {
      code: '073365008049',
      label: 'Kappeln',
      provincie: 7,
      slug: 'kappeln-gemeinde',
    },
    {
      code: '073365008050',
      label: 'Kirrweiler',
      provincie: 7,
      slug: 'kirrweiler',
    },
    {
      code: '073365008053',
      label: 'Kreimbach-Kaulbach',
      provincie: 7,
      slug: 'kreimbach-kaulbach',
    },
    {
      code: '073365008057',
      label: 'Langweiler',
      provincie: 7,
      slug: 'langweiler-gemeinde',
    },
    {
      code: '073365008058',
      label: 'Lauterecken',
      provincie: 7,
      slug: 'lauterecken',
    },
    {
      code: '073365008060',
      label: 'Lohnweiler',
      provincie: 7,
      slug: 'lohnweiler',
    },
    {
      code: '073365008061',
      label: 'Medard',
      provincie: 7,
      slug: 'medard',
    },
    {
      code: '073365008062',
      label: 'Merzweiler',
      provincie: 7,
      slug: 'merzweiler',
    },
    {
      code: '073365008065',
      label: 'Nerzweiler',
      provincie: 7,
      slug: 'nerzweiler',
    },
    {
      code: '073365008069',
      label: 'Nußbach',
      provincie: 7,
      slug: 'nussbach',
    },
    {
      code: '073365008072',
      label: 'Oberweiler im Tal',
      provincie: 7,
      slug: 'oberweiler-im-tal',
    },
    {
      code: '073365008073',
      label: 'Oberweiler-Tiefenbach',
      provincie: 7,
      slug: 'oberweiler-tiefenbach',
    },
    {
      code: '073365008074',
      label: 'Odenbach',
      provincie: 7,
      slug: 'odenbach',
    },
    {
      code: '073365008075',
      label: 'Offenbach-Hundheim',
      provincie: 7,
      slug: 'offenbach-hundheim',
    },
    {
      code: '073365008085',
      label: 'Reipoltskirchen',
      provincie: 7,
      slug: 'reipoltskirchen',
    },
    {
      code: '073365008086',
      label: 'Relsberg',
      provincie: 7,
      slug: 'relsberg',
    },
    {
      code: '073365008087',
      label: 'Rothselberg',
      provincie: 7,
      slug: 'rothselberg',
    },
    {
      code: '073365008090',
      label: 'Rutsweiler an der Lauter',
      provincie: 7,
      slug: 'rutsweiler-an-der-lauter',
    },
    {
      code: '073365008095',
      label: 'Sankt Julian',
      provincie: 7,
      slug: 'sankt-julian',
    },
    {
      code: '073365008100',
      label: 'Unterjeckenbach',
      provincie: 7,
      slug: 'unterjeckenbach',
    },
    {
      code: '073365008104',
      label: 'Wiesweiler',
      provincie: 7,
      slug: 'wiesweiler',
    },
    {
      code: '073365008105',
      label: 'Wolfstein',
      provincie: 7,
      slug: 'wolfstein',
    },
    {
      code: '073365009004',
      label: 'Altenkirchen',
      provincie: 7,
      slug: 'altenkirchen',
    },
    {
      code: '073365009008',
      label: 'Börsborn',
      provincie: 7,
      slug: 'boersborn',
    },
    {
      code: '073365009010',
      label: 'Breitenbach',
      provincie: 7,
      slug: 'breitenbach',
    },
    {
      code: '073365009011',
      label: 'Brücken (Pfalz)',
      provincie: 7,
      slug: 'bruecken-pfalz',
    },
    {
      code: '073365009016',
      label: 'Dittweiler',
      provincie: 7,
      slug: 'dittweiler',
    },
    {
      code: '073365009017',
      label: 'Dunzweiler',
      provincie: 7,
      slug: 'dunzweiler',
    },
    {
      code: '073365009027',
      label: 'Frohnhofen',
      provincie: 7,
      slug: 'frohnhofen',
    },
    {
      code: '073365009031',
      label: 'Glan-Münchweiler',
      provincie: 7,
      slug: 'glan-muenchweiler',
    },
    {
      code: '073365009032',
      label: 'Gries',
      provincie: 7,
      slug: 'gries',
    },
    {
      code: '073365009037',
      label: 'Henschtal',
      provincie: 7,
      slug: 'henschtal',
    },
    {
      code: '073365009041',
      label: 'Herschweiler-Pettersheim',
      provincie: 7,
      slug: 'herschweiler-pettersheim',
    },
    {
      code: '073365009047',
      label: 'Hüffler',
      provincie: 7,
      slug: 'hueffler',
    },
    {
      code: '073365009054',
      label: 'Krottelbach',
      provincie: 7,
      slug: 'krottelbach',
    },
    {
      code: '073365009056',
      label: 'Langenbach',
      provincie: 7,
      slug: 'langenbach',
    },
    {
      code: '073365009064',
      label: 'Nanzdietschweiler',
      provincie: 7,
      slug: 'nanzdietschweiler',
    },
    {
      code: '073365009076',
      label: 'Ohmbach',
      provincie: 7,
      slug: 'ohmbach',
    },
    {
      code: '073365009082',
      label: 'Rehweiler',
      provincie: 7,
      slug: 'rehweiler',
    },
    {
      code: '073365009092',
      label: 'Schönenberg-Kübelberg',
      provincie: 7,
      slug: 'schoenenberg-kuebelberg',
    },
    {
      code: '073365009096',
      label: 'Steinbach am Glan',
      provincie: 7,
      slug: 'steinbach-am-glan',
    },
    {
      code: '073365009101',
      label: 'Wahnwegen',
      provincie: 7,
      slug: 'wahnwegen',
    },
    {
      code: '073365009102',
      label: 'Waldmohr',
      provincie: 7,
      slug: 'waldmohr',
    },
    {
      code: '073365009107',
      label: 'Matzenbach',
      provincie: 7,
      slug: 'matzenbach',
    },
    {
      code: '073365009501',
      label: 'Quirnbach/Pfalz',
      provincie: 7,
      slug: 'quirnbach-pfalz',
    },
    {
      code: '073365010002',
      label: 'Albessen',
      provincie: 7,
      slug: 'albessen',
    },
    {
      code: '073365010003',
      label: 'Altenglan',
      provincie: 7,
      slug: 'altenglan',
    },
    {
      code: '073365010006',
      label: 'Blaubach',
      provincie: 7,
      slug: 'blaubach',
    },
    {
      code: '073365010009',
      label: 'Bosenbach',
      provincie: 7,
      slug: 'bosenbach',
    },
    {
      code: '073365010015',
      label: 'Dennweiler-Frohnbach',
      provincie: 7,
      slug: 'dennweiler-frohnbach',
    },
    {
      code: '073365010018',
      label: 'Ehweiler',
      provincie: 7,
      slug: 'ehweiler',
    },
    {
      code: '073365010021',
      label: 'Elzweiler',
      provincie: 7,
      slug: 'elzweiler',
    },
    {
      code: '073365010022',
      label: 'Erdesbach',
      provincie: 7,
      slug: 'erdesbach',
    },
    {
      code: '073365010024',
      label: 'Etschberg',
      provincie: 7,
      slug: 'etschberg',
    },
    {
      code: '073365010025',
      label: 'Föckelberg',
      provincie: 7,
      slug: 'foeckelberg',
    },
    {
      code: '073365010034',
      label: 'Haschbach am Remigiusberg',
      provincie: 7,
      slug: 'haschbach-am-remigiusberg',
    },
    {
      code: '073365010039',
      label: 'Herchweiler',
      provincie: 7,
      slug: 'herchweiler',
    },
    {
      code: '073365010046',
      label: 'Horschbach',
      provincie: 7,
      slug: 'horschbach',
    },
    {
      code: '073365010051',
      label: 'Körborn',
      provincie: 7,
      slug: 'koerborn',
    },
    {
      code: '073365010052',
      label: 'Konken',
      provincie: 7,
      slug: 'konken',
    },
    {
      code: '073365010055',
      label: 'Kusel',
      provincie: 7,
      slug: 'kusel',
    },
    {
      code: '073365010066',
      label: 'Neunkirchen am Potzberg',
      provincie: 7,
      slug: 'neunkirchen-am-potzberg',
    },
    {
      code: '073365010067',
      label: 'Niederalben',
      provincie: 7,
      slug: 'niederalben',
    },
    {
      code: '073365010068',
      label: 'Niederstaufenbach',
      provincie: 7,
      slug: 'niederstaufenbach',
    },
    {
      code: '073365010070',
      label: 'Oberalben',
      provincie: 7,
      slug: 'oberalben',
    },
    {
      code: '073365010071',
      label: 'Oberstaufenbach',
      provincie: 7,
      slug: 'oberstaufenbach',
    },
    {
      code: '073365010077',
      label: 'Pfeffelbach',
      provincie: 7,
      slug: 'pfeffelbach',
    },
    {
      code: '073365010079',
      label: 'Rammelsbach',
      provincie: 7,
      slug: 'rammelsbach',
    },
    {
      code: '073365010081',
      label: 'Rathsweiler',
      provincie: 7,
      slug: 'rathsweiler',
    },
    {
      code: '073365010084',
      label: 'Reichweiler',
      provincie: 7,
      slug: 'reichweiler',
    },
    {
      code: '073365010088',
      label: 'Ruthweiler',
      provincie: 7,
      slug: 'ruthweiler',
    },
    {
      code: '073365010089',
      label: 'Rutsweiler am Glan',
      provincie: 7,
      slug: 'rutsweiler-am-glan',
    },
    {
      code: '073365010091',
      label: 'Schellweiler',
      provincie: 7,
      slug: 'schellweiler',
    },
    {
      code: '073365010094',
      label: 'Selchenbach',
      provincie: 7,
      slug: 'selchenbach',
    },
    {
      code: '073365010097',
      label: 'Thallichtenberg',
      provincie: 7,
      slug: 'thallichtenberg',
    },
    {
      code: '073365010098',
      label: 'Theisbergstegen',
      provincie: 7,
      slug: 'theisbergstegen',
    },
    {
      code: '073365010099',
      label: 'Ulmet',
      provincie: 7,
      slug: 'ulmet',
    },
    {
      code: '073365010103',
      label: 'Welchweiler',
      provincie: 7,
      slug: 'welchweiler',
    },
    {
      code: '073365010106',
      label: 'Bedesbach',
      provincie: 7,
      slug: 'bedesbach',
    },
    {
      code: '073375001001',
      label: 'Albersweiler',
      provincie: 7,
      slug: 'albersweiler',
    },
    {
      code: '073375001017',
      label: 'Dernbach',
      provincie: 7,
      slug: 'dernbach-gemeinde',
    },
    {
      code: '073375001024',
      label: 'Eußerthal',
      provincie: 7,
      slug: 'eusserthal',
    },
    {
      code: '073375001033',
      label: 'Gossersweiler-Stein',
      provincie: 7,
      slug: 'gossersweiler-stein',
    },
    {
      code: '073375001054',
      label: 'Münchweiler am Klingbach',
      provincie: 7,
      slug: 'muenchweiler-am-klingbach',
    },
    {
      code: '073375001064',
      label: 'Ramberg',
      provincie: 7,
      slug: 'ramberg',
    },
    {
      code: '073375001067',
      label: 'Rinnthal',
      provincie: 7,
      slug: 'rinnthal',
    },
    {
      code: '073375001074',
      label: 'Silz',
      provincie: 7,
      slug: 'silz',
    },
    {
      code: '073375001078',
      label: 'Völkersweiler',
      provincie: 7,
      slug: 'voelkersweiler',
    },
    {
      code: '073375001080',
      label: 'Waldhambach',
      provincie: 7,
      slug: 'waldhambach',
    },
    {
      code: '073375001081',
      label: 'Waldrohrbach',
      provincie: 7,
      slug: 'waldrohrbach',
    },
    {
      code: '073375001083',
      label: 'Wernersberg',
      provincie: 7,
      slug: 'wernersberg',
    },
    {
      code: '073375001501',
      label: 'Annweiler am Trifels',
      provincie: 7,
      slug: 'annweiler-am-trifels',
    },
    {
      code: '073375002005',
      label: 'Bad Bergzabern',
      provincie: 7,
      slug: 'bad-bergzabern',
    },
    {
      code: '073375002006',
      label: 'Barbelroth',
      provincie: 7,
      slug: 'barbelroth',
    },
    {
      code: '073375002008',
      label: 'Birkenhördt',
      provincie: 7,
      slug: 'birkenhoerdt',
    },
    {
      code: '073375002013',
      label: 'Böllenborn',
      provincie: 7,
      slug: 'boellenborn',
    },
    {
      code: '073375002018',
      label: 'Dierbach',
      provincie: 7,
      slug: 'dierbach',
    },
    {
      code: '073375002019',
      label: 'Dörrenbach',
      provincie: 7,
      slug: 'doerrenbach',
    },
    {
      code: '073375002029',
      label: 'Gleiszellen-Gleishorbach',
      provincie: 7,
      slug: 'gleiszellen-gleishorbach',
    },
    {
      code: '073375002037',
      label: 'Hergersweiler',
      provincie: 7,
      slug: 'hergersweiler',
    },
    {
      code: '073375002045',
      label: 'Kapellen-Drusweiler',
      provincie: 7,
      slug: 'kapellen-drusweiler',
    },
    {
      code: '073375002046',
      label: 'Kapsweyer',
      provincie: 7,
      slug: 'kapsweyer',
    },
    {
      code: '073375002049',
      label: 'Klingenmünster',
      provincie: 7,
      slug: 'klingenmuenster',
    },
    {
      code: '073375002055',
      label: 'Niederhorbach',
      provincie: 7,
      slug: 'niederhorbach',
    },
    {
      code: '073375002056',
      label: 'Niederotterbach',
      provincie: 7,
      slug: 'niederotterbach',
    },
    {
      code: '073375002058',
      label: 'Oberhausen',
      provincie: 7,
      slug: 'oberhausen-gemeinde',
    },
    {
      code: '073375002059',
      label: 'Oberotterbach',
      provincie: 7,
      slug: 'oberotterbach',
    },
    {
      code: '073375002060',
      label: 'Oberschlettenbach',
      provincie: 7,
      slug: 'oberschlettenbach',
    },
    {
      code: '073375002062',
      label: 'Pleisweiler-Oberhofen',
      provincie: 7,
      slug: 'pleisweiler-oberhofen',
    },
    {
      code: '073375002071',
      label: 'Schweigen-Rechtenbach',
      provincie: 7,
      slug: 'schweigen-rechtenbach',
    },
    {
      code: '073375002072',
      label: 'Schweighofen',
      provincie: 7,
      slug: 'schweighofen',
    },
    {
      code: '073375002076',
      label: 'Steinfeld',
      provincie: 7,
      slug: 'steinfeld-gemeinde',
    },
    {
      code: '073375002079',
      label: 'Vorderweidenthal',
      provincie: 7,
      slug: 'vorderweidenthal',
    },
    {
      code: '073375003002',
      label: 'Altdorf',
      provincie: 7,
      slug: 'altdorf',
    },
    {
      code: '073375003011',
      label: 'Böbingen',
      provincie: 7,
      slug: 'boebingen',
    },
    {
      code: '073375003015',
      label: 'Burrweiler',
      provincie: 7,
      slug: 'burrweiler',
    },
    {
      code: '073375003020',
      label: 'Edenkoben',
      provincie: 7,
      slug: 'edenkoben',
    },
    {
      code: '073375003021',
      label: 'Edesheim',
      provincie: 7,
      slug: 'edesheim',
    },
    {
      code: '073375003025',
      label: 'Flemlingen',
      provincie: 7,
      slug: 'flemlingen',
    },
    {
      code: '073375003027',
      label: 'Freimersheim (Pfalz)',
      provincie: 7,
      slug: 'freimersheim-pfalz',
    },
    {
      code: '073375003028',
      label: 'Gleisweiler',
      provincie: 7,
      slug: 'gleisweiler',
    },
    {
      code: '073375003032',
      label: 'Gommersheim',
      provincie: 7,
      slug: 'gommersheim',
    },
    {
      code: '073375003035',
      label: 'Großfischlingen',
      provincie: 7,
      slug: 'grossfischlingen',
    },
    {
      code: '073375003036',
      label: 'Hainfeld',
      provincie: 7,
      slug: 'hainfeld',
    },
    {
      code: '073375003048',
      label: 'Kleinfischlingen',
      provincie: 7,
      slug: 'kleinfischlingen',
    },
    {
      code: '073375003066',
      label: 'Rhodt unter Rietburg',
      provincie: 7,
      slug: 'rhodt-unter-rietburg',
    },
    {
      code: '073375003069',
      label: 'Roschbach',
      provincie: 7,
      slug: 'roschbach',
    },
    {
      code: '073375003077',
      label: 'Venningen',
      provincie: 7,
      slug: 'venningen',
    },
    {
      code: '073375003084',
      label: 'Weyher in der Pfalz',
      provincie: 7,
      slug: 'weyher-in-der-pfalz',
    },
    {
      code: '073375004038',
      label: 'Herxheim bei Landau/Pfalz',
      provincie: 7,
      slug: 'herxheim-bei-landau-pfalz',
    },
    {
      code: '073375004039',
      label: 'Herxheimweyher',
      provincie: 7,
      slug: 'herxheimweyher',
    },
    {
      code: '073375004044',
      label: 'Insheim',
      provincie: 7,
      slug: 'insheim',
    },
    {
      code: '073375004068',
      label: 'Rohrbach',
      provincie: 7,
      slug: 'rohrbach-gemeinde',
    },
    {
      code: '073375005007',
      label: 'Billigheim-Ingenheim',
      provincie: 7,
      slug: 'billigheim-ingenheim',
    },
    {
      code: '073375005009',
      label: 'Birkweiler',
      provincie: 7,
      slug: 'birkweiler',
    },
    {
      code: '073375005012',
      label: 'Böchingen',
      provincie: 7,
      slug: 'boechingen',
    },
    {
      code: '073375005022',
      label: 'Eschbach',
      provincie: 7,
      slug: 'eschbach-gemeinde',
    },
    {
      code: '073375005026',
      label: 'Frankweiler',
      provincie: 7,
      slug: 'frankweiler',
    },
    {
      code: '073375005031',
      label: 'Göcklingen',
      provincie: 7,
      slug: 'goecklingen',
    },
    {
      code: '073375005040',
      label: 'Heuchelheim-Klingen',
      provincie: 7,
      slug: 'heuchelheim-klingen',
    },
    {
      code: '073375005042',
      label: 'Ilbesheim bei Landau in der Pfalz',
      provincie: 7,
      slug: 'ilbesheim-bei-landau-in-der-pfalz',
    },
    {
      code: '073375005043',
      label: 'Impflingen',
      provincie: 7,
      slug: 'impflingen',
    },
    {
      code: '073375005050',
      label: 'Knöringen',
      provincie: 7,
      slug: 'knoeringen',
    },
    {
      code: '073375005051',
      label: 'Leinsweiler',
      provincie: 7,
      slug: 'leinsweiler',
    },
    {
      code: '073375005065',
      label: 'Ranschbach',
      provincie: 7,
      slug: 'ranschbach',
    },
    {
      code: '073375005073',
      label: 'Siebeldingen',
      provincie: 7,
      slug: 'siebeldingen',
    },
    {
      code: '073375005082',
      label: 'Walsheim',
      provincie: 7,
      slug: 'walsheim',
    },
    {
      code: '073375006047',
      label: 'Kirrweiler (Pfalz)',
      provincie: 7,
      slug: 'kirrweiler-pfalz',
    },
    {
      code: '073375006052',
      label: 'Maikammer',
      provincie: 7,
      slug: 'maikammer',
    },
    {
      code: '073375006070',
      label: 'Sankt Martin',
      provincie: 7,
      slug: 'sankt-martin',
    },
    {
      code: '073375007014',
      label: 'Bornheim',
      provincie: 7,
      slug: 'bornheim-gemeinde',
    },
    {
      code: '073375007023',
      label: 'Essingen',
      provincie: 7,
      slug: 'essingen',
    },
    {
      code: '073375007041',
      label: 'Hochstadt (Pfalz)',
      provincie: 7,
      slug: 'hochstadt-pfalz',
    },
    {
      code: '073375007061',
      label: 'Offenbach an der Queich',
      provincie: 7,
      slug: 'offenbach-an-der-queich',
    },
    {
      code: '073380004004',
      label: 'Bobenheim-Roxheim',
      provincie: 7,
      slug: 'bobenheim-roxheim',
    },
    {
      code: '073380005005',
      label: 'Böhl-Iggelheim',
      provincie: 7,
      slug: 'boehl-iggelheim',
    },
    {
      code: '073380017017',
      label: 'Limburgerhof',
      provincie: 7,
      slug: 'limburgerhof',
    },
    {
      code: '073380019019',
      label: 'Mutterstadt',
      provincie: 7,
      slug: 'mutterstadt',
    },
    {
      code: '073380025025',
      label: 'Schifferstadt',
      provincie: 7,
      slug: 'schifferstadt',
    },
    {
      code: '073385001006',
      label: 'Dannstadt-Schauernheim',
      provincie: 7,
      slug: 'dannstadt-schauernheim',
    },
    {
      code: '073385001014',
      label: 'Hochdorf-Assenheim',
      provincie: 7,
      slug: 'hochdorf-assenheim',
    },
    {
      code: '073385001022',
      label: 'Rödersheim-Gronau',
      provincie: 7,
      slug: 'roedersheim-gronau',
    },
    {
      code: '073385004003',
      label: 'Birkenheide',
      provincie: 7,
      slug: 'birkenheide',
    },
    {
      code: '073385004008',
      label: 'Fußgönheim',
      provincie: 7,
      slug: 'fussgoenheim',
    },
    {
      code: '073385004018',
      label: 'Maxdorf',
      provincie: 7,
      slug: 'maxdorf',
    },
    {
      code: '073385006002',
      label: 'Beindersheim',
      provincie: 7,
      slug: 'beindersheim',
    },
    {
      code: '073385006009',
      label: 'Großniedesheim',
      provincie: 7,
      slug: 'grossniedesheim',
    },
    {
      code: '073385006012',
      label: 'Heßheim',
      provincie: 7,
      slug: 'hessheim',
    },
    {
      code: '073385006013',
      label: 'Heuchelheim bei Frankenthal',
      provincie: 7,
      slug: 'heuchelheim-bei-frankenthal',
    },
    {
      code: '073385006015',
      label: 'Kleinniedesheim',
      provincie: 7,
      slug: 'kleinniedesheim',
    },
    {
      code: '073385006016',
      label: 'Lambsheim',
      provincie: 7,
      slug: 'lambsheim',
    },
    {
      code: '073385007007',
      label: 'Dudenhofen',
      provincie: 7,
      slug: 'dudenhofen',
    },
    {
      code: '073385007010',
      label: 'Hanhofen',
      provincie: 7,
      slug: 'hanhofen',
    },
    {
      code: '073385007011',
      label: 'Harthausen',
      provincie: 7,
      slug: 'harthausen',
    },
    {
      code: '073385007023',
      label: 'Römerberg',
      provincie: 7,
      slug: 'roemerberg',
    },
    {
      code: '073385008001',
      label: 'Altrip',
      provincie: 7,
      slug: 'altrip',
    },
    {
      code: '073385008020',
      label: 'Neuhofen',
      provincie: 7,
      slug: 'neuhofen',
    },
    {
      code: '073385008021',
      label: 'Otterstadt',
      provincie: 7,
      slug: 'otterstadt',
    },
    {
      code: '073385008026',
      label: 'Waldsee',
      provincie: 7,
      slug: 'waldsee',
    },
    {
      code: '073390005005',
      label: 'Bingen am Rhein',
      provincie: 7,
      slug: 'bingen-am-rhein',
    },
    {
      code: '073390009009',
      label: 'Budenheim',
      provincie: 7,
      slug: 'budenheim',
    },
    {
      code: '073390030030',
      label: 'Ingelheim am Rhein',
      provincie: 7,
      slug: 'ingelheim-am-rhein',
    },
    {
      code: '073395001003',
      label: 'Bacharach',
      provincie: 7,
      slug: 'bacharach',
    },
    {
      code: '073395001007',
      label: 'Breitscheid',
      provincie: 7,
      slug: 'breitscheid-gemeinde',
    },
    {
      code: '073395001036',
      label: 'Manubach',
      provincie: 7,
      slug: 'manubach',
    },
    {
      code: '073395001038',
      label: 'Münster-Sarmsheim',
      provincie: 7,
      slug: 'muenster-sarmsheim',
    },
    {
      code: '073395001040',
      label: 'Niederheimbach',
      provincie: 7,
      slug: 'niederheimbach',
    },
    {
      code: '073395001044',
      label: 'Oberdiebach',
      provincie: 7,
      slug: 'oberdiebach',
    },
    {
      code: '073395001045',
      label: 'Oberheimbach',
      provincie: 7,
      slug: 'oberheimbach',
    },
    {
      code: '073395001058',
      label: 'Trechtingshausen',
      provincie: 7,
      slug: 'trechtingshausen',
    },
    {
      code: '073395001062',
      label: 'Waldalgesheim',
      provincie: 7,
      slug: 'waldalgesheim',
    },
    {
      code: '073395001063',
      label: 'Weiler bei Bingen',
      provincie: 7,
      slug: 'weiler-bei-bingen',
    },
    {
      code: '073395002006',
      label: 'Bodenheim',
      provincie: 7,
      slug: 'bodenheim',
    },
    {
      code: '073395002020',
      label: 'Gau-Bischofsheim',
      provincie: 7,
      slug: 'gau-bischofsheim',
    },
    {
      code: '073395002026',
      label: 'Harxheim',
      provincie: 7,
      slug: 'harxheim',
    },
    {
      code: '073395002034',
      label: 'Lörzweiler',
      provincie: 7,
      slug: 'loerzweiler',
    },
    {
      code: '073395002039',
      label: 'Nackenheim',
      provincie: 7,
      slug: 'nackenheim',
    },
    {
      code: '073395003001',
      label: 'Appenheim',
      provincie: 7,
      slug: 'appenheim',
    },
    {
      code: '073395003008',
      label: 'Bubenheim',
      provincie: 7,
      slug: 'bubenheim-gemeinde',
    },
    {
      code: '073395003016',
      label: 'Engelstadt',
      provincie: 7,
      slug: 'engelstadt',
    },
    {
      code: '073395003019',
      label: 'Gau-Algesheim',
      provincie: 7,
      slug: 'gau-algesheim',
    },
    {
      code: '073395003041',
      label: 'Nieder-Hilbersheim',
      provincie: 7,
      slug: 'nieder-hilbersheim',
    },
    {
      code: '073395003046',
      label: 'Ober-Hilbersheim',
      provincie: 7,
      slug: 'ober-hilbersheim',
    },
    {
      code: '073395003048',
      label: 'Ockenheim',
      provincie: 7,
      slug: 'ockenheim',
    },
    {
      code: '073395003051',
      label: 'Schwabenheim an der Selz',
      provincie: 7,
      slug: 'schwabenheim-an-der-selz',
    },
    {
      code: '073395006017',
      label: 'Essenheim',
      provincie: 7,
      slug: 'essenheim',
    },
    {
      code: '073395006031',
      label: 'Jugenheim in Rheinhessen',
      provincie: 7,
      slug: 'jugenheim-in-rheinhessen',
    },
    {
      code: '073395006032',
      label: 'Klein-Winternheim',
      provincie: 7,
      slug: 'klein-winternheim',
    },
    {
      code: '073395006042',
      label: 'Nieder-Olm',
      provincie: 7,
      slug: 'nieder-olm',
    },
    {
      code: '073395006047',
      label: 'Ober-Olm',
      provincie: 7,
      slug: 'ober-olm',
    },
    {
      code: '073395006054',
      label: 'Sörgenloch',
      provincie: 7,
      slug: 'soergenloch',
    },
    {
      code: '073395006057',
      label: 'Stadecken-Elsheim',
      provincie: 7,
      slug: 'stadecken-elsheim',
    },
    {
      code: '073395006067',
      label: 'Zornheim',
      provincie: 7,
      slug: 'zornheim',
    },
    {
      code: '073395007010',
      label: 'Dalheim',
      provincie: 7,
      slug: 'dalheim',
    },
    {
      code: '073395007011',
      label: 'Dexheim',
      provincie: 7,
      slug: 'dexheim',
    },
    {
      code: '073395007012',
      label: 'Dienheim',
      provincie: 7,
      slug: 'dienheim',
    },
    {
      code: '073395007013',
      label: 'Dolgesheim',
      provincie: 7,
      slug: 'dolgesheim',
    },
    {
      code: '073395007015',
      label: 'Eimsheim',
      provincie: 7,
      slug: 'eimsheim',
    },
    {
      code: '073395007018',
      label: 'Friesenheim',
      provincie: 7,
      slug: 'friesenheim',
    },
    {
      code: '073395007024',
      label: 'Guntersblum',
      provincie: 7,
      slug: 'guntersblum',
    },
    {
      code: '073395007025',
      label: 'Hahnheim',
      provincie: 7,
      slug: 'hahnheim',
    },
    {
      code: '073395007028',
      label: 'Hillesheim',
      provincie: 7,
      slug: 'hillesheim-gemeinde',
    },
    {
      code: '073395007033',
      label: 'Köngernheim',
      provincie: 7,
      slug: 'koengernheim',
    },
    {
      code: '073395007035',
      label: 'Ludwigshöhe',
      provincie: 7,
      slug: 'ludwigshoehe',
    },
    {
      code: '073395007037',
      label: 'Mommenheim',
      provincie: 7,
      slug: 'mommenheim',
    },
    {
      code: '073395007043',
      label: 'Nierstein',
      provincie: 7,
      slug: 'nierstein',
    },
    {
      code: '073395007049',
      label: 'Oppenheim',
      provincie: 7,
      slug: 'oppenheim',
    },
    {
      code: '073395007053',
      label: 'Selzen',
      provincie: 7,
      slug: 'selzen',
    },
    {
      code: '073395007059',
      label: 'Uelversheim',
      provincie: 7,
      slug: 'uelversheim',
    },
    {
      code: '073395007060',
      label: 'Undenheim',
      provincie: 7,
      slug: 'undenheim',
    },
    {
      code: '073395007064',
      label: 'Weinolsheim',
      provincie: 7,
      slug: 'weinolsheim',
    },
    {
      code: '073395007066',
      label: 'Wintersheim',
      provincie: 7,
      slug: 'wintersheim',
    },
    {
      code: '073395007201',
      label: 'Dorn-Dürkheim',
      provincie: 7,
      slug: 'dorn-duerkheim',
    },
    {
      code: '073395008002',
      label: 'Aspisheim',
      provincie: 7,
      slug: 'aspisheim',
    },
    {
      code: '073395008004',
      label: 'Badenheim',
      provincie: 7,
      slug: 'badenheim',
    },
    {
      code: '073395008021',
      label: 'Gensingen',
      provincie: 7,
      slug: 'gensingen',
    },
    {
      code: '073395008022',
      label: 'Grolsheim',
      provincie: 7,
      slug: 'grolsheim',
    },
    {
      code: '073395008029',
      label: 'Horrweiler',
      provincie: 7,
      slug: 'horrweiler',
    },
    {
      code: '073395008050',
      label: 'Sankt Johann',
      provincie: 7,
      slug: 'sankt-johann-gemeinde',
    },
    {
      code: '073395008056',
      label: 'Sprendlingen',
      provincie: 7,
      slug: 'sprendlingen',
    },
    {
      code: '073395008065',
      label: 'Welgesheim',
      provincie: 7,
      slug: 'welgesheim',
    },
    {
      code: '073395008068',
      label: 'Zotzenheim',
      provincie: 7,
      slug: 'zotzenheim',
    },
    {
      code: '073395008202',
      label: 'Wolfsheim',
      provincie: 7,
      slug: 'wolfsheim',
    },
    {
      code: '073405001001',
      label: 'Bobenthal',
      provincie: 7,
      slug: 'bobenthal',
    },
    {
      code: '073405001002',
      label: 'Busenberg',
      provincie: 7,
      slug: 'busenberg',
    },
    {
      code: '073405001004',
      label: 'Dahn',
      provincie: 7,
      slug: 'dahn',
    },
    {
      code: '073405001009',
      label: 'Erfweiler',
      provincie: 7,
      slug: 'erfweiler',
    },
    {
      code: '073405001010',
      label: 'Erlenbach bei Dahn',
      provincie: 7,
      slug: 'erlenbach-bei-dahn',
    },
    {
      code: '073405001011',
      label: 'Fischbach bei Dahn',
      provincie: 7,
      slug: 'fischbach-bei-dahn',
    },
    {
      code: '073405001021',
      label: 'Hirschthal',
      provincie: 7,
      slug: 'hirschthal',
    },
    {
      code: '073405001029',
      label: 'Ludwigswinkel',
      provincie: 7,
      slug: 'ludwigswinkel',
    },
    {
      code: '073405001033',
      label: 'Niederschlettenbach',
      provincie: 7,
      slug: 'niederschlettenbach',
    },
    {
      code: '073405001034',
      label: 'Nothweiler',
      provincie: 7,
      slug: 'nothweiler',
    },
    {
      code: '073405001039',
      label: 'Rumbach',
      provincie: 7,
      slug: 'rumbach',
    },
    {
      code: '073405001043',
      label: 'Schindhard',
      provincie: 7,
      slug: 'schindhard',
    },
    {
      code: '073405001045',
      label: 'Schönau (Pfalz)',
      provincie: 7,
      slug: 'schoenau-pfalz',
    },
    {
      code: '073405001501',
      label: 'Bruchweiler-Bärenbach',
      provincie: 7,
      slug: 'bruchweiler-baerenbach',
    },
    {
      code: '073405001502',
      label: 'Bundenthal',
      provincie: 7,
      slug: 'bundenthal',
    },
    {
      code: '073405002005',
      label: 'Darstein',
      provincie: 7,
      slug: 'darstein',
    },
    {
      code: '073405002006',
      label: 'Dimbach',
      provincie: 7,
      slug: 'dimbach',
    },
    {
      code: '073405002014',
      label: 'Hauenstein',
      provincie: 7,
      slug: 'hauenstein',
    },
    {
      code: '073405002020',
      label: 'Hinterweidenthal',
      provincie: 7,
      slug: 'hinterweidenthal',
    },
    {
      code: '073405002030',
      label: 'Lug',
      provincie: 7,
      slug: 'lug',
    },
    {
      code: '073405002047',
      label: 'Schwanheim',
      provincie: 7,
      slug: 'schwanheim',
    },
    {
      code: '073405002049',
      label: 'Spirkelbach',
      provincie: 7,
      slug: 'spirkelbach',
    },
    {
      code: '073405002057',
      label: 'Wilgartswiesen',
      provincie: 7,
      slug: 'wilgartswiesen',
    },
    {
      code: '073405003008',
      label: 'Eppenbrunn',
      provincie: 7,
      slug: 'eppenbrunn',
    },
    {
      code: '073405003019',
      label: 'Hilst',
      provincie: 7,
      slug: 'hilst',
    },
    {
      code: '073405003026',
      label: 'Kröppen',
      provincie: 7,
      slug: 'kroeppen',
    },
    {
      code: '073405003028',
      label: 'Lemberg',
      provincie: 7,
      slug: 'lemberg',
    },
    {
      code: '073405003036',
      label: 'Obersimten',
      provincie: 7,
      slug: 'obersimten',
    },
    {
      code: '073405003040',
      label: 'Ruppertsweiler',
      provincie: 7,
      slug: 'ruppertsweiler',
    },
    {
      code: '073405003048',
      label: 'Schweix',
      provincie: 7,
      slug: 'schweix',
    },
    {
      code: '073405003052',
      label: 'Trulben',
      provincie: 7,
      slug: 'trulben',
    },
    {
      code: '073405003053',
      label: 'Vinningen',
      provincie: 7,
      slug: 'vinningen',
    },
    {
      code: '073405003205',
      label: 'Bottenbach',
      provincie: 7,
      slug: 'bottenbach',
    },
    {
      code: '073405004003',
      label: 'Clausen',
      provincie: 7,
      slug: 'clausen',
    },
    {
      code: '073405004007',
      label: 'Donsieders',
      provincie: 7,
      slug: 'donsieders',
    },
    {
      code: '073405004027',
      label: 'Leimen',
      provincie: 7,
      slug: 'leimen',
    },
    {
      code: '073405004031',
      label: 'Merzalben',
      provincie: 7,
      slug: 'merzalben',
    },
    {
      code: '073405004032',
      label: 'Münchweiler an der Rodalb',
      provincie: 7,
      slug: 'muenchweiler-an-der-rodalb',
    },
    {
      code: '073405004038',
      label: 'Rodalben',
      provincie: 7,
      slug: 'rodalben',
    },
    {
      code: '073405006012',
      label: 'Geiselberg',
      provincie: 7,
      slug: 'geiselberg',
    },
    {
      code: '073405006015',
      label: 'Heltersberg',
      provincie: 7,
      slug: 'heltersberg',
    },
    {
      code: '073405006016',
      label: 'Hermersberg',
      provincie: 7,
      slug: 'hermersberg',
    },
    {
      code: '073405006022',
      label: 'Höheinöd',
      provincie: 7,
      slug: 'hoeheinoed',
    },
    {
      code: '073405006025',
      label: 'Horbach',
      provincie: 7,
      slug: 'horbach-gemeinde',
    },
    {
      code: '073405006044',
      label: 'Schmalenberg',
      provincie: 7,
      slug: 'schmalenberg',
    },
    {
      code: '073405006050',
      label: 'Steinalben',
      provincie: 7,
      slug: 'steinalben',
    },
    {
      code: '073405006054',
      label: 'Waldfischbach-Burgalben',
      provincie: 7,
      slug: 'waldfischbach-burgalben',
    },
    {
      code: '073405008201',
      label: 'Althornbach',
      provincie: 7,
      slug: 'althornbach',
    },
    {
      code: '073405008202',
      label: 'Battweiler',
      provincie: 7,
      slug: 'battweiler',
    },
    {
      code: '073405008203',
      label: 'Bechhofen',
      provincie: 7,
      slug: 'bechhofen',
    },
    {
      code: '073405008206',
      label: 'Contwig',
      provincie: 7,
      slug: 'contwig',
    },
    {
      code: '073405008207',
      label: 'Dellfeld',
      provincie: 7,
      slug: 'dellfeld',
    },
    {
      code: '073405008208',
      label: 'Dietrichingen',
      provincie: 7,
      slug: 'dietrichingen',
    },
    {
      code: '073405008209',
      label: 'Großbundenbach',
      provincie: 7,
      slug: 'grossbundenbach',
    },
    {
      code: '073405008210',
      label: 'Großsteinhausen',
      provincie: 7,
      slug: 'grosssteinhausen',
    },
    {
      code: '073405008211',
      label: 'Hornbach',
      provincie: 7,
      slug: 'hornbach',
    },
    {
      code: '073405008212',
      label: 'Käshofen',
      provincie: 7,
      slug: 'kaeshofen',
    },
    {
      code: '073405008213',
      label: 'Kleinbundenbach',
      provincie: 7,
      slug: 'kleinbundenbach',
    },
    {
      code: '073405008214',
      label: 'Kleinsteinhausen',
      provincie: 7,
      slug: 'kleinsteinhausen',
    },
    {
      code: '073405008218',
      label: 'Mauschbach',
      provincie: 7,
      slug: 'mauschbach',
    },
    {
      code: '073405008221',
      label: 'Riedelberg',
      provincie: 7,
      slug: 'riedelberg',
    },
    {
      code: '073405008223',
      label: 'Rosenkopf',
      provincie: 7,
      slug: 'rosenkopf',
    },
    {
      code: '073405008226',
      label: 'Walshausen',
      provincie: 7,
      slug: 'walshausen',
    },
    {
      code: '073405008227',
      label: 'Wiesbach',
      provincie: 7,
      slug: 'wiesbach',
    },
    {
      code: '073405009017',
      label: 'Herschberg',
      provincie: 7,
      slug: 'herschberg',
    },
    {
      code: '073405009018',
      label: 'Hettenhausen',
      provincie: 7,
      slug: 'hettenhausen',
    },
    {
      code: '073405009023',
      label: 'Höheischweiler',
      provincie: 7,
      slug: 'hoeheischweiler',
    },
    {
      code: '073405009024',
      label: 'Höhfröschen',
      provincie: 7,
      slug: 'hoehfroeschen',
    },
    {
      code: '073405009035',
      label: 'Nünschweiler',
      provincie: 7,
      slug: 'nuenschweiler',
    },
    {
      code: '073405009037',
      label: 'Petersberg',
      provincie: 7,
      slug: 'petersberg-gemeinde',
    },
    {
      code: '073405009041',
      label: 'Saalstadt',
      provincie: 7,
      slug: 'saalstadt',
    },
    {
      code: '073405009042',
      label: 'Schauerberg',
      provincie: 7,
      slug: 'schauerberg',
    },
    {
      code: '073405009051',
      label: 'Thaleischweiler-Fröschen',
      provincie: 7,
      slug: 'thaleischweiler-froeschen',
    },
    {
      code: '073405009055',
      label: 'Weselberg',
      provincie: 7,
      slug: 'weselberg',
    },
    {
      code: '073405009204',
      label: 'Biedershausen',
      provincie: 7,
      slug: 'biedershausen',
    },
    {
      code: '073405009215',
      label: 'Knopp-Labach',
      provincie: 7,
      slug: 'knopp-labach',
    },
    {
      code: '073405009216',
      label: 'Krähenberg',
      provincie: 7,
      slug: 'kraehenberg',
    },
    {
      code: '073405009217',
      label: 'Maßweiler',
      provincie: 7,
      slug: 'massweiler',
    },
    {
      code: '073405009219',
      label: 'Obernheim-Kirchenarnbach',
      provincie: 7,
      slug: 'obernheim-kirchenarnbach',
    },
    {
      code: '073405009220',
      label: 'Reifenberg',
      provincie: 7,
      slug: 'reifenberg',
    },
    {
      code: '073405009222',
      label: 'Rieschweiler-Mühlbach',
      provincie: 7,
      slug: 'rieschweiler-muehlbach',
    },
    {
      code: '073405009224',
      label: 'Schmitshausen',
      provincie: 7,
      slug: 'schmitshausen',
    },
    {
      code: '073405009225',
      label: 'Wallhalben',
      provincie: 7,
      slug: 'wallhalben',
    },
    {
      code: '073405009228',
      label: 'Winterbach (Pfalz)',
      provincie: 7,
      slug: 'winterbach-pfalz',
    },
    {
      code: '081110000000',
      label: 'Stuttgart',
      provincie: 8,
      slug: 'stuttgart',
    },
    {
      code: '081150003003',
      label: 'Böblingen',
      provincie: 8,
      slug: 'boeblingen',
    },
    {
      code: '081150028028',
      label: 'Leonberg',
      provincie: 8,
      slug: 'leonberg',
    },
    {
      code: '081150029029',
      label: 'Magstadt',
      provincie: 8,
      slug: 'magstadt',
    },
    {
      code: '081150041041',
      label: 'Renningen',
      provincie: 8,
      slug: 'renningen',
    },
    {
      code: '081150042042',
      label: 'Rutesheim',
      provincie: 8,
      slug: 'rutesheim',
    },
    {
      code: '081150044044',
      label: 'Schönaich',
      provincie: 8,
      slug: 'schoenaich',
    },
    {
      code: '081150045045',
      label: 'Sindelfingen',
      provincie: 8,
      slug: 'sindelfingen',
    },
    {
      code: '081150050050',
      label: 'Weil der Stadt',
      provincie: 8,
      slug: 'weil-der-stadt',
    },
    {
      code: '081150051051',
      label: 'Weil im Schönbuch',
      provincie: 8,
      slug: 'weil-im-schoenbuch',
    },
    {
      code: '081150052052',
      label: 'Weissach',
      provincie: 8,
      slug: 'weissach',
    },
    {
      code: '081155001001',
      label: 'Aidlingen',
      provincie: 8,
      slug: 'aidlingen',
    },
    {
      code: '081155001054',
      label: 'Grafenau',
      provincie: 8,
      slug: 'grafenau',
    },
    {
      code: '081155002013',
      label: 'Ehningen',
      provincie: 8,
      slug: 'ehningen',
    },
    {
      code: '081155002015',
      label: 'Gärtringen',
      provincie: 8,
      slug: 'gaertringen',
    },
    {
      code: '081155003010',
      label: 'Deckenpfronn',
      provincie: 8,
      slug: 'deckenpfronn',
    },
    {
      code: '081155003021',
      label: 'Herrenberg',
      provincie: 8,
      slug: 'herrenberg',
    },
    {
      code: '081155003037',
      label: 'Nufringen',
      provincie: 8,
      slug: 'nufringen',
    },
    {
      code: '081155004002',
      label: 'Altdorf',
      provincie: 8,
      slug: 'altdorf-gemeinde',
    },
    {
      code: '081155004022',
      label: 'Hildrizhausen',
      provincie: 8,
      slug: 'hildrizhausen',
    },
    {
      code: '081155004024',
      label: 'Holzgerlingen',
      provincie: 8,
      slug: 'holzgerlingen',
    },
    {
      code: '081155005004',
      label: 'Bondorf',
      provincie: 8,
      slug: 'bondorf',
    },
    {
      code: '081155005016',
      label: 'Gäufelden',
      provincie: 8,
      slug: 'gaeufelden',
    },
    {
      code: '081155005034',
      label: 'Mötzingen',
      provincie: 8,
      slug: 'moetzingen',
    },
    {
      code: '081155005053',
      label: 'Jettingen',
      provincie: 8,
      slug: 'jettingen',
    },
    {
      code: '081155006046',
      label: 'Steinenbronn',
      provincie: 8,
      slug: 'steinenbronn',
    },
    {
      code: '081155006048',
      label: 'Waldenbuch',
      provincie: 8,
      slug: 'waldenbuch',
    },
    {
      code: '081160015015',
      label: 'Denkendorf',
      provincie: 8,
      slug: 'denkendorf',
    },
    {
      code: '081160019019',
      label: 'Esslingen am Neckar',
      provincie: 8,
      slug: 'esslingen-am-neckar',
    },
    {
      code: '081160047047',
      label: 'Neuhausen auf den Fildern',
      provincie: 8,
      slug: 'neuhausen-auf-den-fildern',
    },
    {
      code: '081160072072',
      label: 'Wernau (Neckar)',
      provincie: 8,
      slug: 'wernau-neckar',
    },
    {
      code: '081160076076',
      label: 'Aichwald',
      provincie: 8,
      slug: 'aichwald',
    },
    {
      code: '081160077077',
      label: 'Filderstadt',
      provincie: 8,
      slug: 'filderstadt',
    },
    {
      code: '081160078078',
      label: 'Leinfelden-Echterdingen',
      provincie: 8,
      slug: 'leinfelden-echterdingen',
    },
    {
      code: '081160080080',
      label: 'Ostfildern',
      provincie: 8,
      slug: 'ostfildern',
    },
    {
      code: '081160081081',
      label: 'Aichtal',
      provincie: 8,
      slug: 'aichtal',
    },
    {
      code: '081165001016',
      label: 'Dettingen unter Teck',
      provincie: 8,
      slug: 'dettingen-unter-teck',
    },
    {
      code: '081165001033',
      label: 'Kirchheim unter Teck',
      provincie: 8,
      slug: 'kirchheim-unter-teck',
    },
    {
      code: '081165001048',
      label: 'Notzingen',
      provincie: 8,
      slug: 'notzingen',
    },
    {
      code: '081165002018',
      label: 'Erkenbrechtsweiler',
      provincie: 8,
      slug: 'erkenbrechtsweiler',
    },
    {
      code: '081165002054',
      label: 'Owen',
      provincie: 8,
      slug: 'owen',
    },
    {
      code: '081165002079',
      label: 'Lenningen',
      provincie: 8,
      slug: 'lenningen',
    },
    {
      code: '081165003005',
      label: 'Altdorf',
      provincie: 8,
      slug: 'altdorf-gemeinde',
    },
    {
      code: '081165003006',
      label: 'Altenriet',
      provincie: 8,
      slug: 'altenriet',
    },
    {
      code: '081165003008',
      label: 'Bempflingen',
      provincie: 8,
      slug: 'bempflingen',
    },
    {
      code: '081165003041',
      label: 'Neckartailfingen',
      provincie: 8,
      slug: 'neckartailfingen',
    },
    {
      code: '081165003042',
      label: 'Neckartenzlingen',
      provincie: 8,
      slug: 'neckartenzlingen',
    },
    {
      code: '081165003063',
      label: 'Schlaitdorf',
      provincie: 8,
      slug: 'schlaitdorf',
    },
    {
      code: '081165004011',
      label: 'Beuren',
      provincie: 8,
      slug: 'beuren-gemeinde',
    },
    {
      code: '081165004036',
      label: 'Kohlberg',
      provincie: 8,
      slug: 'kohlberg',
    },
    {
      code: '081165004046',
      label: 'Neuffen',
      provincie: 8,
      slug: 'neuffen',
    },
    {
      code: '081165005020',
      label: 'Frickenhausen',
      provincie: 8,
      slug: 'frickenhausen',
    },
    {
      code: '081165005022',
      label: 'Großbettlingen',
      provincie: 8,
      slug: 'grossbettlingen',
    },
    {
      code: '081165005049',
      label: 'Nürtingen',
      provincie: 8,
      slug: 'nuertingen',
    },
    {
      code: '081165005050',
      label: 'Oberboihingen',
      provincie: 8,
      slug: 'oberboihingen',
    },
    {
      code: '081165005068',
      label: 'Unterensingen',
      provincie: 8,
      slug: 'unterensingen',
    },
    {
      code: '081165005073',
      label: 'Wolfschlugen',
      provincie: 8,
      slug: 'wolfschlugen',
    },
    {
      code: '081165006004',
      label: 'Altbach',
      provincie: 8,
      slug: 'altbach',
    },
    {
      code: '081165006014',
      label: 'Deizisau',
      provincie: 8,
      slug: 'deizisau',
    },
    {
      code: '081165006056',
      label: 'Plochingen',
      provincie: 8,
      slug: 'plochingen',
    },
    {
      code: '081165007007',
      label: 'Baltmannsweiler',
      provincie: 8,
      slug: 'baltmannsweiler',
    },
    {
      code: '081165007027',
      label: 'Hochdorf',
      provincie: 8,
      slug: 'hochdorf',
    },
    {
      code: '081165007037',
      label: 'Lichtenwald',
      provincie: 8,
      slug: 'lichtenwald',
    },
    {
      code: '081165007058',
      label: 'Reichenbach an der Fils',
      provincie: 8,
      slug: 'reichenbach-an-der-fils',
    },
    {
      code: '081165008012',
      label: 'Bissingen an der Teck',
      provincie: 8,
      slug: 'bissingen-an-der-teck',
    },
    {
      code: '081165008029',
      label: 'Holzmaden',
      provincie: 8,
      slug: 'holzmaden',
    },
    {
      code: '081165008043',
      label: 'Neidlingen',
      provincie: 8,
      slug: 'neidlingen',
    },
    {
      code: '081165008053',
      label: 'Ohmden',
      provincie: 8,
      slug: 'ohmden',
    },
    {
      code: '081165008070',
      label: 'Weilheim an der Teck',
      provincie: 8,
      slug: 'weilheim-an-der-teck',
    },
    {
      code: '081165009035',
      label: 'Köngen',
      provincie: 8,
      slug: 'koengen',
    },
    {
      code: '081165009071',
      label: 'Wendlingen am Neckar',
      provincie: 8,
      slug: 'wendlingen-am-neckar',
    },
    {
      code: '081170010010',
      label: 'Böhmenkirch',
      provincie: 8,
      slug: 'boehmenkirch',
    },
    {
      code: '081175001006',
      label: 'Bad Ditzenbach',
      provincie: 8,
      slug: 'bad-ditzenbach',
    },
    {
      code: '081175001014',
      label: 'Deggingen',
      provincie: 8,
      slug: 'deggingen',
    },
    {
      code: '081175002018',
      label: 'Ebersbach an der Fils',
      provincie: 8,
      slug: 'ebersbach-an-der-fils',
    },
    {
      code: '081175002044',
      label: 'Schlierbach',
      provincie: 8,
      slug: 'schlierbach',
    },
    {
      code: '081175003019',
      label: 'Eislingen/Fils',
      provincie: 8,
      slug: 'eislingen-fils',
    },
    {
      code: '081175003037',
      label: 'Ottenbach',
      provincie: 8,
      slug: 'ottenbach',
    },
    {
      code: '081175003042',
      label: 'Salach',
      provincie: 8,
      slug: 'salach',
    },
    {
      code: '081175004007',
      label: 'Bad Überkingen',
      provincie: 8,
      slug: 'bad-ueberkingen',
    },
    {
      code: '081175004024',
      label: 'Geislingen an der Steige',
      provincie: 8,
      slug: 'geislingen-an-der-steige',
    },
    {
      code: '081175004033',
      label: 'Kuchen',
      provincie: 8,
      slug: 'kuchen',
    },
    {
      code: '081175005026',
      label: 'Göppingen',
      provincie: 8,
      slug: 'goeppingen',
    },
    {
      code: '081175005043',
      label: 'Schlat',
      provincie: 8,
      slug: 'schlat',
    },
    {
      code: '081175005053',
      label: 'Wäschenbeuren',
      provincie: 8,
      slug: 'waeschenbeuren',
    },
    {
      code: '081175005055',
      label: 'Wangen',
      provincie: 8,
      slug: 'wangen',
    },
    {
      code: '081175006015',
      label: 'Donzdorf',
      provincie: 8,
      slug: 'donzdorf',
    },
    {
      code: '081175006025',
      label: 'Gingen an der Fils',
      provincie: 8,
      slug: 'gingen-an-der-fils',
    },
    {
      code: '081175006049',
      label: 'Süßen',
      provincie: 8,
      slug: 'suessen',
    },
    {
      code: '081175006061',
      label: 'Lauterstein',
      provincie: 8,
      slug: 'lauterstein',
    },
    {
      code: '081175007016',
      label: 'Drackenstein',
      provincie: 8,
      slug: 'drackenstein',
    },
    {
      code: '081175007028',
      label: 'Gruibingen',
      provincie: 8,
      slug: 'gruibingen',
    },
    {
      code: '081175007031',
      label: 'Hohenstadt',
      provincie: 8,
      slug: 'hohenstadt',
    },
    {
      code: '081175007035',
      label: 'Mühlhausen im Täle',
      provincie: 8,
      slug: 'muehlhausen-im-taele',
    },
    {
      code: '081175007058',
      label: 'Wiesensteig',
      provincie: 8,
      slug: 'wiesensteig',
    },
    {
      code: '081175008001',
      label: 'Adelberg',
      provincie: 8,
      slug: 'adelberg',
    },
    {
      code: '081175008009',
      label: 'Birenbach',
      provincie: 8,
      slug: 'birenbach',
    },
    {
      code: '081175008011',
      label: 'Börtlingen',
      provincie: 8,
      slug: 'boertlingen',
    },
    {
      code: '081175008038',
      label: 'Rechberghausen',
      provincie: 8,
      slug: 'rechberghausen',
    },
    {
      code: '081175009002',
      label: 'Aichelberg',
      provincie: 8,
      slug: 'aichelberg',
    },
    {
      code: '081175009012',
      label: 'Bad Boll',
      provincie: 8,
      slug: 'bad-boll',
    },
    {
      code: '081175009017',
      label: 'Dürnau',
      provincie: 8,
      slug: 'duernau',
    },
    {
      code: '081175009023',
      label: 'Gammelshausen',
      provincie: 8,
      slug: 'gammelshausen',
    },
    {
      code: '081175009029',
      label: 'Hattenhofen',
      provincie: 8,
      slug: 'hattenhofen',
    },
    {
      code: '081175009060',
      label: 'Zell unter Aichelberg',
      provincie: 8,
      slug: 'zell-unter-aichelberg',
    },
    {
      code: '081175010003',
      label: 'Albershausen',
      provincie: 8,
      slug: 'albershausen',
    },
    {
      code: '081175010051',
      label: 'Uhingen',
      provincie: 8,
      slug: 'uhingen',
    },
    {
      code: '081175011020',
      label: 'Eschenbach',
      provincie: 8,
      slug: 'eschenbach',
    },
    {
      code: '081175011030',
      label: 'Heiningen',
      provincie: 8,
      slug: 'heiningen-gemeinde',
    },
    {
      code: '081180003003',
      label: 'Asperg',
      provincie: 8,
      slug: 'asperg',
    },
    {
      code: '081180011011',
      label: 'Ditzingen',
      provincie: 8,
      slug: 'ditzingen',
    },
    {
      code: '081180019019',
      label: 'Gerlingen',
      provincie: 8,
      slug: 'gerlingen',
    },
    {
      code: '081180021021',
      label: 'Großbottwar',
      provincie: 8,
      slug: 'grossbottwar',
    },
    {
      code: '081180046046',
      label: 'Kornwestheim',
      provincie: 8,
      slug: 'kornwestheim',
    },
    {
      code: '081180048048',
      label: 'Ludwigsburg',
      provincie: 8,
      slug: 'ludwigsburg',
    },
    {
      code: '081180050050',
      label: 'Markgröningen',
      provincie: 8,
      slug: 'markgroeningen',
    },
    {
      code: '081180051051',
      label: 'Möglingen',
      provincie: 8,
      slug: 'moeglingen',
    },
    {
      code: '081180060060',
      label: 'Oberstenfeld',
      provincie: 8,
      slug: 'oberstenfeld',
    },
    {
      code: '081180076076',
      label: 'Sachsenheim',
      provincie: 8,
      slug: 'sachsenheim',
    },
    {
      code: '081180080080',
      label: 'Korntal-Münchingen',
      provincie: 8,
      slug: 'korntal-muenchingen',
    },
    {
      code: '081180081081',
      label: 'Remseck am Neckar',
      provincie: 8,
      slug: 'remseck-am-neckar',
    },
    {
      code: '081185001007',
      label: 'Besigheim',
      provincie: 8,
      slug: 'besigheim',
    },
    {
      code: '081185001016',
      label: 'Freudental',
      provincie: 8,
      slug: 'freudental',
    },
    {
      code: '081185001018',
      label: 'Gemmrigheim',
      provincie: 8,
      slug: 'gemmrigheim',
    },
    {
      code: '081185001028',
      label: 'Hessigheim',
      provincie: 8,
      slug: 'hessigheim',
    },
    {
      code: '081185001047',
      label: 'Löchgau',
      provincie: 8,
      slug: 'loechgau',
    },
    {
      code: '081185001053',
      label: 'Mundelsheim',
      provincie: 8,
      slug: 'mundelsheim',
    },
    {
      code: '081185001074',
      label: 'Walheim',
      provincie: 8,
      slug: 'walheim',
    },
    {
      code: '081185002071',
      label: 'Tamm',
      provincie: 8,
      slug: 'tamm',
    },
    {
      code: '081185002077',
      label: 'Ingersheim',
      provincie: 8,
      slug: 'ingersheim',
    },
    {
      code: '081185002079',
      label: 'Bietigheim-Bissingen',
      provincie: 8,
      slug: 'bietigheim-bissingen',
    },
    {
      code: '081185003010',
      label: 'Bönnigheim',
      provincie: 8,
      slug: 'boennigheim',
    },
    {
      code: '081185003015',
      label: 'Erligheim',
      provincie: 8,
      slug: 'erligheim',
    },
    {
      code: '081185003040',
      label: 'Kirchheim am Neckar',
      provincie: 8,
      slug: 'kirchheim-am-neckar',
    },
    {
      code: '081185004063',
      label: 'Pleidelsheim',
      provincie: 8,
      slug: 'pleidelsheim',
    },
    {
      code: '081185004078',
      label: 'Freiberg am Neckar',
      provincie: 8,
      slug: 'freiberg-am-neckar',
    },
    {
      code: '081185005001',
      label: 'Affalterbach',
      provincie: 8,
      slug: 'affalterbach',
    },
    {
      code: '081185005006',
      label: 'Benningen am Neckar',
      provincie: 8,
      slug: 'benningen-am-neckar',
    },
    {
      code: '081185005014',
      label: 'Erdmannhausen',
      provincie: 8,
      slug: 'erdmannhausen',
    },
    {
      code: '081185005049',
      label: 'Marbach am Neckar',
      provincie: 8,
      slug: 'marbach-am-neckar',
    },
    {
      code: '081185006027',
      label: 'Hemmingen',
      provincie: 8,
      slug: 'hemmingen-gemeinde',
    },
    {
      code: '081185006067',
      label: 'Schwieberdingen',
      provincie: 8,
      slug: 'schwieberdingen',
    },
    {
      code: '081185007054',
      label: 'Murr',
      provincie: 8,
      slug: 'murr',
    },
    {
      code: '081185007070',
      label: 'Steinheim an der Murr',
      provincie: 8,
      slug: 'steinheim-an-der-murr',
    },
    {
      code: '081185008012',
      label: 'Eberdingen',
      provincie: 8,
      slug: 'eberdingen',
    },
    {
      code: '081185008059',
      label: 'Oberriexingen',
      provincie: 8,
      slug: 'oberriexingen',
    },
    {
      code: '081185008068',
      label: 'Sersheim',
      provincie: 8,
      slug: 'sersheim',
    },
    {
      code: '081185008073',
      label: 'Vaihingen an der Enz',
      provincie: 8,
      slug: 'vaihingen-an-der-enz',
    },
    {
      code: '081190001001',
      label: 'Alfdorf',
      provincie: 8,
      slug: 'alfdorf',
    },
    {
      code: '081190020020',
      label: 'Fellbach',
      provincie: 8,
      slug: 'fellbach',
    },
    {
      code: '081190041041',
      label: 'Korb',
      provincie: 8,
      slug: 'korb',
    },
    {
      code: '081190044044',
      label: 'Murrhardt',
      provincie: 8,
      slug: 'murrhardt',
    },
    {
      code: '081190061061',
      label: 'Rudersberg',
      provincie: 8,
      slug: 'rudersberg',
    },
    {
      code: '081190079079',
      label: 'Waiblingen',
      provincie: 8,
      slug: 'waiblingen',
    },
    {
      code: '081190089089',
      label: 'Berglen',
      provincie: 8,
      slug: 'berglen',
    },
    {
      code: '081190090090',
      label: 'Remshalden',
      provincie: 8,
      slug: 'remshalden',
    },
    {
      code: '081190091091',
      label: 'Weinstadt',
      provincie: 8,
      slug: 'weinstadt',
    },
    {
      code: '081190093093',
      label: 'Kernen im Remstal',
      provincie: 8,
      slug: 'kernen-im-remstal',
    },
    {
      code: '081195001003',
      label: 'Allmersbach im Tal',
      provincie: 8,
      slug: 'allmersbach-im-tal',
    },
    {
      code: '081195001004',
      label: 'Althütte',
      provincie: 8,
      slug: 'althuette',
    },
    {
      code: '081195001006',
      label: 'Auenwald',
      provincie: 8,
      slug: 'auenwald',
    },
    {
      code: '081195001008',
      label: 'Backnang',
      provincie: 8,
      slug: 'backnang',
    },
    {
      code: '081195001018',
      label: 'Burgstetten',
      provincie: 8,
      slug: 'burgstetten',
    },
    {
      code: '081195001038',
      label: 'Kirchberg an der Murr',
      provincie: 8,
      slug: 'kirchberg-an-der-murr',
    },
    {
      code: '081195001053',
      label: 'Oppenweiler',
      provincie: 8,
      slug: 'oppenweiler',
    },
    {
      code: '081195001083',
      label: 'Weissach im Tal',
      provincie: 8,
      slug: 'weissach-im-tal',
    },
    {
      code: '081195001087',
      label: 'Aspach',
      provincie: 8,
      slug: 'aspach',
    },
    {
      code: '081195002055',
      label: 'Plüderhausen',
      provincie: 8,
      slug: 'pluederhausen',
    },
    {
      code: '081195002076',
      label: 'Urbach',
      provincie: 8,
      slug: 'urbach-gemeinde',
    },
    {
      code: '081195003067',
      label: 'Schorndorf',
      provincie: 8,
      slug: 'schorndorf',
    },
    {
      code: '081195003086',
      label: 'Winterbach',
      provincie: 8,
      slug: 'winterbach-gemeinde',
    },
    {
      code: '081195004024',
      label: 'Großerlach',
      provincie: 8,
      slug: 'grosserlach',
    },
    {
      code: '081195004069',
      label: 'Spiegelberg',
      provincie: 8,
      slug: 'spiegelberg',
    },
    {
      code: '081195004075',
      label: 'Sulzbach an der Murr',
      provincie: 8,
      slug: 'sulzbach-an-der-murr',
    },
    {
      code: '081195005037',
      label: 'Kaisersbach',
      provincie: 8,
      slug: 'kaisersbach',
    },
    {
      code: '081195005084',
      label: 'Welzheim',
      provincie: 8,
      slug: 'welzheim',
    },
    {
      code: '081195006042',
      label: 'Leutenbach',
      provincie: 8,
      slug: 'leutenbach',
    },
    {
      code: '081195006068',
      label: 'Schwaikheim',
      provincie: 8,
      slug: 'schwaikheim',
    },
    {
      code: '081195006085',
      label: 'Winnenden',
      provincie: 8,
      slug: 'winnenden',
    },
    {
      code: '081210000000',
      label: 'Heilbronn',
      provincie: 8,
      slug: 'heilbronn',
    },
    {
      code: '081250007007',
      label: 'Bad Wimpfen',
      provincie: 8,
      slug: 'bad-wimpfen',
    },
    {
      code: '081250039039',
      label: 'Gundelsheim',
      provincie: 8,
      slug: 'gundelsheim',
    },
    {
      code: '081250058058',
      label: 'Leingarten',
      provincie: 8,
      slug: 'leingarten',
    },
    {
      code: '081250068068',
      label: 'Neudenau',
      provincie: 8,
      slug: 'neudenau',
    },
    {
      code: '081250107107',
      label: 'Wüstenrot',
      provincie: 8,
      slug: 'wuestenrot',
    },
    {
      code: '081255001005',
      label: 'Bad Friedrichshall',
      provincie: 8,
      slug: 'bad-friedrichshall',
    },
    {
      code: '081255001078',
      label: 'Oedheim',
      provincie: 8,
      slug: 'oedheim',
    },
    {
      code: '081255001079',
      label: 'Offenau',
      provincie: 8,
      slug: 'offenau',
    },
    {
      code: '081255002006',
      label: 'Bad Rappenau',
      provincie: 8,
      slug: 'bad-rappenau',
    },
    {
      code: '081255002049',
      label: 'Kirchardt',
      provincie: 8,
      slug: 'kirchardt',
    },
    {
      code: '081255002087',
      label: 'Siegelsbach',
      provincie: 8,
      slug: 'siegelsbach',
    },
    {
      code: '081255003013',
      label: 'Brackenheim',
      provincie: 8,
      slug: 'brackenheim',
    },
    {
      code: '081255003017',
      label: 'Cleebronn',
      provincie: 8,
      slug: 'cleebronn',
    },
    {
      code: '081255004026',
      label: 'Eppingen',
      provincie: 8,
      slug: 'eppingen',
    },
    {
      code: '081255004034',
      label: 'Gemmingen',
      provincie: 8,
      slug: 'gemmingen',
    },
    {
      code: '081255004047',
      label: 'Ittlingen',
      provincie: 8,
      slug: 'ittlingen',
    },
    {
      code: '081255005030',
      label: 'Flein',
      provincie: 8,
      slug: 'flein',
    },
    {
      code: '081255005094',
      label: 'Talheim',
      provincie: 8,
      slug: 'talheim',
    },
    {
      code: '081255006056',
      label: 'Lauffen am Neckar',
      provincie: 8,
      slug: 'lauffen-am-neckar',
    },
    {
      code: '081255006066',
      label: 'Neckarwestheim',
      provincie: 8,
      slug: 'neckarwestheim',
    },
    {
      code: '081255006074',
      label: 'Nordheim',
      provincie: 8,
      slug: 'nordheim',
    },
    {
      code: '081255007048',
      label: 'Jagsthausen',
      provincie: 8,
      slug: 'jagsthausen',
    },
    {
      code: '081255007063',
      label: 'Möckmühl',
      provincie: 8,
      slug: 'moeckmuehl',
    },
    {
      code: '081255007084',
      label: 'Roigheim',
      provincie: 8,
      slug: 'roigheim',
    },
    {
      code: '081255007103',
      label: 'Widdern',
      provincie: 8,
      slug: 'widdern',
    },
    {
      code: '081255008027',
      label: 'Erlenbach',
      provincie: 8,
      slug: 'erlenbach',
    },
    {
      code: '081255008065',
      label: 'Neckarsulm',
      provincie: 8,
      slug: 'neckarsulm',
    },
    {
      code: '081255008096',
      label: 'Untereisesheim',
      provincie: 8,
      slug: 'untereisesheim',
    },
    {
      code: '081255009069',
      label: 'Neuenstadt am Kocher',
      provincie: 8,
      slug: 'neuenstadt-am-kocher',
    },
    {
      code: '081255009111',
      label: 'Hardthausen am Kocher',
      provincie: 8,
      slug: 'hardthausen-am-kocher',
    },
    {
      code: '081255009113',
      label: 'Langenbrettach',
      provincie: 8,
      slug: 'langenbrettach',
    },
    {
      code: '081255010038',
      label: 'Güglingen',
      provincie: 8,
      slug: 'gueglingen',
    },
    {
      code: '081255010081',
      label: 'Pfaffenhofen',
      provincie: 8,
      slug: 'pfaffenhofen',
    },
    {
      code: '081255010108',
      label: 'Zaberfeld',
      provincie: 8,
      slug: 'zaberfeld',
    },
    {
      code: '081255011059',
      label: 'Löwenstein',
      provincie: 8,
      slug: 'loewenstein',
    },
    {
      code: '081255011110',
      label: 'Obersulm',
      provincie: 8,
      slug: 'obersulm',
    },
    {
      code: '081255012001',
      label: 'Abstatt',
      provincie: 8,
      slug: 'abstatt',
    },
    {
      code: '081255012008',
      label: 'Beilstein',
      provincie: 8,
      slug: 'beilstein-stadt',
    },
    {
      code: '081255012046',
      label: 'Ilsfeld',
      provincie: 8,
      slug: 'ilsfeld',
    },
    {
      code: '081255012098',
      label: 'Untergruppenbach',
      provincie: 8,
      slug: 'untergruppenbach',
    },
    {
      code: '081255013061',
      label: 'Massenbachhausen',
      provincie: 8,
      slug: 'massenbachhausen',
    },
    {
      code: '081255013086',
      label: 'Schwaigern',
      provincie: 8,
      slug: 'schwaigern',
    },
    {
      code: '081255014021',
      label: 'Eberstadt',
      provincie: 8,
      slug: 'eberstadt',
    },
    {
      code: '081255014024',
      label: 'Ellhofen',
      provincie: 8,
      slug: 'ellhofen',
    },
    {
      code: '081255014057',
      label: 'Lehrensteinsfeld',
      provincie: 8,
      slug: 'lehrensteinsfeld',
    },
    {
      code: '081255014102',
      label: 'Weinsberg',
      provincie: 8,
      slug: 'weinsberg',
    },
    {
      code: '081260011011',
      label: 'Bretzfeld',
      provincie: 8,
      slug: 'bretzfeld',
    },
    {
      code: '081260072072',
      label: 'Schöntal',
      provincie: 8,
      slug: 'schoental',
    },
    {
      code: '081265001047',
      label: 'Kupferzell',
      provincie: 8,
      slug: 'kupferzell',
    },
    {
      code: '081265001058',
      label: 'Neuenstein',
      provincie: 8,
      slug: 'neuenstein-stadt',
    },
    {
      code: '081265001085',
      label: 'Waldenburg',
      provincie: 8,
      slug: 'waldenburg',
    },
    {
      code: '081265002020',
      label: 'Dörzbach',
      provincie: 8,
      slug: 'doerzbach',
    },
    {
      code: '081265002045',
      label: 'Krautheim',
      provincie: 8,
      slug: 'krautheim',
    },
    {
      code: '081265002056',
      label: 'Mulfingen',
      provincie: 8,
      slug: 'mulfingen',
    },
    {
      code: '081265003039',
      label: 'Ingelfingen',
      provincie: 8,
      slug: 'ingelfingen',
    },
    {
      code: '081265003046',
      label: 'Künzelsau',
      provincie: 8,
      slug: 'kuenzelsau',
    },
    {
      code: '081265004028',
      label: 'Forchtenberg',
      provincie: 8,
      slug: 'forchtenberg',
    },
    {
      code: '081265004060',
      label: 'Niedernhall',
      provincie: 8,
      slug: 'niedernhall',
    },
    {
      code: '081265004086',
      label: 'Weißbach',
      provincie: 8,
      slug: 'weissbach',
    },
    {
      code: '081265005066',
      label: 'Öhringen',
      provincie: 8,
      slug: 'oehringen',
    },
    {
      code: '081265005069',
      label: 'Pfedelbach',
      provincie: 8,
      slug: 'pfedelbach',
    },
    {
      code: '081265005094',
      label: 'Zweiflingen',
      provincie: 8,
      slug: 'zweiflingen',
    },
    {
      code: '081270008008',
      label: 'Blaufelden',
      provincie: 8,
      slug: 'blaufelden',
    },
    {
      code: '081270052052',
      label: 'Mainhardt',
      provincie: 8,
      slug: 'mainhardt',
    },
    {
      code: '081270075075',
      label: 'Schrozberg',
      provincie: 8,
      slug: 'schrozberg',
    },
    {
      code: '081275001009',
      label: 'Braunsbach',
      provincie: 8,
      slug: 'braunsbach',
    },
    {
      code: '081275001086',
      label: 'Untermünkheim',
      provincie: 8,
      slug: 'untermuenkheim',
    },
    {
      code: '081275002014',
      label: 'Crailsheim',
      provincie: 8,
      slug: 'crailsheim',
    },
    {
      code: '081275002073',
      label: 'Satteldorf',
      provincie: 8,
      slug: 'satteldorf',
    },
    {
      code: '081275002103',
      label: 'Frankenhardt',
      provincie: 8,
      slug: 'frankenhardt',
    },
    {
      code: '081275002104',
      label: 'Stimpfach',
      provincie: 8,
      slug: 'stimpfach',
    },
    {
      code: '081275003101',
      label: 'Kreßberg',
      provincie: 8,
      slug: 'kressberg',
    },
    {
      code: '081275003102',
      label: 'Fichtenau',
      provincie: 8,
      slug: 'fichtenau',
    },
    {
      code: '081275004032',
      label: 'Gerabronn',
      provincie: 8,
      slug: 'gerabronn',
    },
    {
      code: '081275004047',
      label: 'Langenburg',
      provincie: 8,
      slug: 'langenburg',
    },
    {
      code: '081275005043',
      label: 'Ilshofen',
      provincie: 8,
      slug: 'ilshofen',
    },
    {
      code: '081275005089',
      label: 'Vellberg',
      provincie: 8,
      slug: 'vellberg',
    },
    {
      code: '081275005099',
      label: 'Wolpertshausen',
      provincie: 8,
      slug: 'wolpertshausen',
    },
    {
      code: '081275006023',
      label: 'Fichtenberg',
      provincie: 8,
      slug: 'fichtenberg',
    },
    {
      code: '081275006025',
      label: 'Gaildorf',
      provincie: 8,
      slug: 'gaildorf',
    },
    {
      code: '081275006062',
      label: 'Oberrot',
      provincie: 8,
      slug: 'oberrot',
    },
    {
      code: '081275006079',
      label: 'Sulzbach-Laufen',
      provincie: 8,
      slug: 'sulzbach-laufen',
    },
    {
      code: '081275007012',
      label: 'Bühlertann',
      provincie: 8,
      slug: 'buehlertann',
    },
    {
      code: '081275007013',
      label: 'Bühlerzell',
      provincie: 8,
      slug: 'buehlerzell',
    },
    {
      code: '081275007063',
      label: 'Obersontheim',
      provincie: 8,
      slug: 'obersontheim',
    },
    {
      code: '081275008046',
      label: 'Kirchberg an der Jagst',
      provincie: 8,
      slug: 'kirchberg-an-der-jagst',
    },
    {
      code: '081275008071',
      label: 'Rot am See',
      provincie: 8,
      slug: 'rot-am-see',
    },
    {
      code: '081275008091',
      label: 'Wallhausen',
      provincie: 8,
      slug: 'wallhausen-gemeinde',
    },
    {
      code: '081275009056',
      label: 'Michelbach an der Bilz',
      provincie: 8,
      slug: 'michelbach-an-der-bilz',
    },
    {
      code: '081275009059',
      label: 'Michelfeld',
      provincie: 8,
      slug: 'michelfeld',
    },
    {
      code: '081275009076',
      label: 'Schwäbisch Hall',
      provincie: 8,
      slug: 'schwaebisch-hall',
    },
    {
      code: '081275009100',
      label: 'Rosengarten',
      provincie: 8,
      slug: 'rosengarten-gemeinde',
    },
    {
      code: '081280020020',
      label: 'Creglingen',
      provincie: 8,
      slug: 'creglingen',
    },
    {
      code: '081280039039',
      label: 'Freudenberg',
      provincie: 8,
      slug: 'freudenberg-stadt',
    },
    {
      code: '081280064064',
      label: 'Külsheim',
      provincie: 8,
      slug: 'kuelsheim',
    },
    {
      code: '081280082082',
      label: 'Niederstetten',
      provincie: 8,
      slug: 'niederstetten',
    },
    {
      code: '081280126126',
      label: 'Weikersheim',
      provincie: 8,
      slug: 'weikersheim',
    },
    {
      code: '081280131131',
      label: 'Wertheim',
      provincie: 8,
      slug: 'wertheim',
    },
    {
      code: '081280139139',
      label: 'Lauda-Königshofen',
      provincie: 8,
      slug: 'lauda-koenigshofen',
    },
    {
      code: '081285001006',
      label: 'Assamstadt',
      provincie: 8,
      slug: 'assamstadt',
    },
    {
      code: '081285001007',
      label: 'Bad Mergentheim',
      provincie: 8,
      slug: 'bad-mergentheim',
    },
    {
      code: '081285001058',
      label: 'Igersheim',
      provincie: 8,
      slug: 'igersheim',
    },
    {
      code: '081285002014',
      label: 'Boxberg',
      provincie: 8,
      slug: 'boxberg-stadt',
    },
    {
      code: '081285002138',
      label: 'Ahorn',
      provincie: 8,
      slug: 'ahorn',
    },
    {
      code: '081285003047',
      label: 'Grünsfeld',
      provincie: 8,
      slug: 'gruensfeld',
    },
    {
      code: '081285003137',
      label: 'Wittighausen',
      provincie: 8,
      slug: 'wittighausen',
    },
    {
      code: '081285004045',
      label: 'Großrinderfeld',
      provincie: 8,
      slug: 'grossrinderfeld',
    },
    {
      code: '081285004061',
      label: 'Königheim',
      provincie: 8,
      slug: 'koenigheim',
    },
    {
      code: '081285004115',
      label: 'Tauberbischofsheim',
      provincie: 8,
      slug: 'tauberbischofsheim',
    },
    {
      code: '081285004128',
      label: 'Werbach',
      provincie: 8,
      slug: 'werbach',
    },
    {
      code: '081350010010',
      label: 'Dischingen',
      provincie: 8,
      slug: 'dischingen',
    },
    {
      code: '081350015015',
      label: 'Gerstetten',
      provincie: 8,
      slug: 'gerstetten',
    },
    {
      code: '081350020020',
      label: 'Herbrechtingen',
      provincie: 8,
      slug: 'herbrechtingen',
    },
    {
      code: '081350025025',
      label: 'Königsbronn',
      provincie: 8,
      slug: 'koenigsbronn',
    },
    {
      code: '081350032032',
      label: 'Steinheim am Albuch',
      provincie: 8,
      slug: 'steinheim-am-albuch',
    },
    {
      code: '081355001016',
      label: 'Giengen an der Brenz',
      provincie: 8,
      slug: 'giengen-an-der-brenz',
    },
    {
      code: '081355001021',
      label: 'Hermaringen',
      provincie: 8,
      slug: 'hermaringen',
    },
    {
      code: '081355002019',
      label: 'Heidenheim an der Brenz',
      provincie: 8,
      slug: 'heidenheim-an-der-brenz',
    },
    {
      code: '081355002026',
      label: 'Nattheim',
      provincie: 8,
      slug: 'nattheim',
    },
    {
      code: '081355003027',
      label: 'Niederstotzingen',
      provincie: 8,
      slug: 'niederstotzingen',
    },
    {
      code: '081355003031',
      label: 'Sontheim an der Brenz',
      provincie: 8,
      slug: 'sontheim-an-der-brenz',
    },
    {
      code: '081360002002',
      label: 'Abtsgmünd',
      provincie: 8,
      slug: 'abtsgmuend',
    },
    {
      code: '081360027027',
      label: 'Gschwend',
      provincie: 8,
      slug: 'gschwend',
    },
    {
      code: '081360042042',
      label: 'Lorch',
      provincie: 8,
      slug: 'lorch-stadt',
    },
    {
      code: '081360045045',
      label: 'Neresheim',
      provincie: 8,
      slug: 'neresheim',
    },
    {
      code: '081360050050',
      label: 'Oberkochen',
      provincie: 8,
      slug: 'oberkochen',
    },
    {
      code: '081365001021',
      label: 'Essingen',
      provincie: 8,
      slug: 'essingen-gemeinde',
    },
    {
      code: '081365001033',
      label: 'Hüttlingen',
      provincie: 8,
      slug: 'huettlingen',
    },
    {
      code: '081365001088',
      label: 'Aalen',
      provincie: 8,
      slug: 'aalen',
    },
    {
      code: '081365002010',
      label: 'Bopfingen',
      provincie: 8,
      slug: 'bopfingen',
    },
    {
      code: '081365002037',
      label: 'Kirchheim am Ries',
      provincie: 8,
      slug: 'kirchheim-am-ries',
    },
    {
      code: '081365002087',
      label: 'Riesbürg',
      provincie: 8,
      slug: 'riesbuerg',
    },
    {
      code: '081365003003',
      label: 'Adelmannsfelden',
      provincie: 8,
      slug: 'adelmannsfelden',
    },
    {
      code: '081365003018',
      label: 'Ellenberg',
      provincie: 8,
      slug: 'ellenberg-gemeinde',
    },
    {
      code: '081365003019',
      label: 'Ellwangen (Jagst)',
      provincie: 8,
      slug: 'ellwangen-jagst',
    },
    {
      code: '081365003035',
      label: 'Jagstzell',
      provincie: 8,
      slug: 'jagstzell',
    },
    {
      code: '081365003046',
      label: 'Neuler',
      provincie: 8,
      slug: 'neuler',
    },
    {
      code: '081365003060',
      label: 'Rosenberg',
      provincie: 8,
      slug: 'rosenberg',
    },
    {
      code: '081365003084',
      label: 'Wört',
      provincie: 8,
      slug: 'woert',
    },
    {
      code: '081365003089',
      label: 'Rainau',
      provincie: 8,
      slug: 'rainau',
    },
    {
      code: '081365004038',
      label: 'Lauchheim',
      provincie: 8,
      slug: 'lauchheim',
    },
    {
      code: '081365004082',
      label: 'Westhausen',
      provincie: 8,
      slug: 'westhausen',
    },
    {
      code: '081365005020',
      label: 'Eschach',
      provincie: 8,
      slug: 'eschach',
    },
    {
      code: '081365005024',
      label: 'Göggingen',
      provincie: 8,
      slug: 'goeggingen',
    },
    {
      code: '081365005034',
      label: 'Iggingen',
      provincie: 8,
      slug: 'iggingen',
    },
    {
      code: '081365005040',
      label: 'Leinzell',
      provincie: 8,
      slug: 'leinzell',
    },
    {
      code: '081365005049',
      label: 'Obergröningen',
      provincie: 8,
      slug: 'obergroeningen',
    },
    {
      code: '081365005062',
      label: 'Schechingen',
      provincie: 8,
      slug: 'schechingen',
    },
    {
      code: '081365006007',
      label: 'Bartholomä',
      provincie: 8,
      slug: 'bartholomae',
    },
    {
      code: '081365006009',
      label: 'Böbingen an der Rems',
      provincie: 8,
      slug: 'boebingen-an-der-rems',
    },
    {
      code: '081365006028',
      label: 'Heubach',
      provincie: 8,
      slug: 'heubach',
    },
    {
      code: '081365006029',
      label: 'Heuchlingen',
      provincie: 8,
      slug: 'heuchlingen',
    },
    {
      code: '081365006043',
      label: 'Mögglingen',
      provincie: 8,
      slug: 'moegglingen',
    },
    {
      code: '081365007065',
      label: 'Schwäbisch Gmünd',
      provincie: 8,
      slug: 'schwaebisch-gmuend',
    },
    {
      code: '081365007079',
      label: 'Waldstetten',
      provincie: 8,
      slug: 'waldstetten',
    },
    {
      code: '081365008015',
      label: 'Durlangen',
      provincie: 8,
      slug: 'durlangen',
    },
    {
      code: '081365008044',
      label: 'Mutlangen',
      provincie: 8,
      slug: 'mutlangen',
    },
    {
      code: '081365008061',
      label: 'Ruppertshofen',
      provincie: 8,
      slug: 'ruppertshofen-gemeinde',
    },
    {
      code: '081365008066',
      label: 'Spraitbach',
      provincie: 8,
      slug: 'spraitbach',
    },
    {
      code: '081365008070',
      label: 'Täferrot',
      provincie: 8,
      slug: 'taeferrot',
    },
    {
      code: '081365009068',
      label: 'Stödtlen',
      provincie: 8,
      slug: 'stoedtlen',
    },
    {
      code: '081365009071',
      label: 'Tannhausen',
      provincie: 8,
      slug: 'tannhausen',
    },
    {
      code: '081365009075',
      label: 'Unterschneidheim',
      provincie: 8,
      slug: 'unterschneidheim',
    },
    {
      code: '082110000000',
      label: 'Baden-Baden',
      provincie: 8,
      slug: 'baden-baden',
    },
    {
      code: '082120000000',
      label: 'Karlsruhe',
      provincie: 8,
      slug: 'karlsruhe',
    },
    {
      code: '082150017017',
      label: 'Ettlingen',
      provincie: 8,
      slug: 'ettlingen',
    },
    {
      code: '082150046046',
      label: 'Malsch',
      provincie: 8,
      slug: 'malsch',
    },
    {
      code: '082150047047',
      label: 'Marxzell',
      provincie: 8,
      slug: 'marxzell',
    },
    {
      code: '082150064064',
      label: 'Östringen',
      provincie: 8,
      slug: 'oestringen',
    },
    {
      code: '082150084084',
      label: 'Ubstadt-Weiher',
      provincie: 8,
      slug: 'ubstadt-weiher',
    },
    {
      code: '082150089089',
      label: 'Walzbachtal',
      provincie: 8,
      slug: 'walzbachtal',
    },
    {
      code: '082150090090',
      label: 'Weingarten (Baden)',
      provincie: 8,
      slug: 'weingarten-baden',
    },
    {
      code: '082150096096',
      label: 'Karlsbad',
      provincie: 8,
      slug: 'karlsbad',
    },
    {
      code: '082150097097',
      label: 'Kraichtal',
      provincie: 8,
      slug: 'kraichtal',
    },
    {
      code: '082150101101',
      label: 'Pfinztal',
      provincie: 8,
      slug: 'pfinztal',
    },
    {
      code: '082150102102',
      label: 'Eggenstein-Leopoldshafen',
      provincie: 8,
      slug: 'eggenstein-leopoldshafen',
    },
    {
      code: '082150105105',
      label: 'Linkenheim-Hochstetten',
      provincie: 8,
      slug: 'linkenheim-hochstetten',
    },
    {
      code: '082150106106',
      label: 'Waghäusel',
      provincie: 8,
      slug: 'waghaeusel',
    },
    {
      code: '082150108108',
      label: 'Rheinstetten',
      provincie: 8,
      slug: 'rheinstetten',
    },
    {
      code: '082150109109',
      label: 'Stutensee',
      provincie: 8,
      slug: 'stutensee',
    },
    {
      code: '082150110110',
      label: 'Waldbronn',
      provincie: 8,
      slug: 'waldbronn',
    },
    {
      code: '082155001039',
      label: 'Kronau',
      provincie: 8,
      slug: 'kronau',
    },
    {
      code: '082155001100',
      label: 'Bad Schönborn',
      provincie: 8,
      slug: 'bad-schoenborn',
    },
    {
      code: '082155002007',
      label: 'Bretten',
      provincie: 8,
      slug: 'bretten',
    },
    {
      code: '082155002025',
      label: 'Gondelsheim',
      provincie: 8,
      slug: 'gondelsheim',
    },
    {
      code: '082155003009',
      label: 'Bruchsal',
      provincie: 8,
      slug: 'bruchsal',
    },
    {
      code: '082155003021',
      label: 'Forst',
      provincie: 8,
      slug: 'forst-gemeinde',
    },
    {
      code: '082155003029',
      label: 'Hambrücken',
      provincie: 8,
      slug: 'hambruecken',
    },
    {
      code: '082155003103',
      label: 'Karlsdorf-Neuthard',
      provincie: 8,
      slug: 'karlsdorf-neuthard',
    },
    {
      code: '082155004099',
      label: 'Graben-Neudorf',
      provincie: 8,
      slug: 'graben-neudorf',
    },
    {
      code: '082155004111',
      label: 'Dettenheim',
      provincie: 8,
      slug: 'dettenheim',
    },
    {
      code: '082155005040',
      label: 'Kürnbach',
      provincie: 8,
      slug: 'kuernbach',
    },
    {
      code: '082155005059',
      label: 'Oberderdingen',
      provincie: 8,
      slug: 'oberderdingen',
    },
    {
      code: '082155006066',
      label: 'Philippsburg',
      provincie: 8,
      slug: 'philippsburg',
    },
    {
      code: '082155006107',
      label: 'Oberhausen-Rheinhausen',
      provincie: 8,
      slug: 'oberhausen-rheinhausen',
    },
    {
      code: '082155007082',
      label: 'Sulzfeld',
      provincie: 8,
      slug: 'sulzfeld',
    },
    {
      code: '082155007094',
      label: 'Zaisenhausen',
      provincie: 8,
      slug: 'zaisenhausen',
    },
    {
      code: '082160008008',
      label: 'Bühlertal',
      provincie: 8,
      slug: 'buehlertal',
    },
    {
      code: '082160013013',
      label: 'Forbach',
      provincie: 8,
      slug: 'forbach',
    },
    {
      code: '082160015015',
      label: 'Gaggenau',
      provincie: 8,
      slug: 'gaggenau',
    },
    {
      code: '082165001006',
      label: 'Bischweier',
      provincie: 8,
      slug: 'bischweier',
    },
    {
      code: '082165001024',
      label: 'Kuppenheim',
      provincie: 8,
      slug: 'kuppenheim',
    },
    {
      code: '082165002007',
      label: 'Bühl',
      provincie: 8,
      slug: 'buehl',
    },
    {
      code: '082165002041',
      label: 'Ottersweier',
      provincie: 8,
      slug: 'ottersweier',
    },
    {
      code: '082165003002',
      label: 'Au am Rhein',
      provincie: 8,
      slug: 'au-am-rhein',
    },
    {
      code: '082165003005',
      label: 'Bietigheim',
      provincie: 8,
      slug: 'bietigheim',
    },
    {
      code: '082165003009',
      label: 'Durmersheim',
      provincie: 8,
      slug: 'durmersheim',
    },
    {
      code: '082165003012',
      label: 'Elchesheim-Illingen',
      provincie: 8,
      slug: 'elchesheim-illingen',
    },
    {
      code: '082165004017',
      label: 'Gernsbach',
      provincie: 8,
      slug: 'gernsbach',
    },
    {
      code: '082165004029',
      label: 'Loffenau',
      provincie: 8,
      slug: 'loffenau',
    },
    {
      code: '082165004059',
      label: 'Weisenbach',
      provincie: 8,
      slug: 'weisenbach',
    },
    {
      code: '082165005023',
      label: 'Iffezheim',
      provincie: 8,
      slug: 'iffezheim',
    },
    {
      code: '082165005033',
      label: 'Muggensturm',
      provincie: 8,
      slug: 'muggensturm',
    },
    {
      code: '082165005039',
      label: 'Ötigheim',
      provincie: 8,
      slug: 'oetigheim',
    },
    {
      code: '082165005043',
      label: 'Rastatt',
      provincie: 8,
      slug: 'rastatt',
    },
    {
      code: '082165005052',
      label: 'Steinmauern',
      provincie: 8,
      slug: 'steinmauern',
    },
    {
      code: '082165006028',
      label: 'Lichtenau',
      provincie: 8,
      slug: 'lichtenau-stadt',
    },
    {
      code: '082165006063',
      label: 'Rheinmünster',
      provincie: 8,
      slug: 'rheinmuenster',
    },
    {
      code: '082165007022',
      label: 'Hügelsheim',
      provincie: 8,
      slug: 'huegelsheim',
    },
    {
      code: '082165007049',
      label: 'Sinzheim',
      provincie: 8,
      slug: 'sinzheim',
    },
    {
      code: '082210000000',
      label: 'Heidelberg',
      provincie: 8,
      slug: 'heidelberg',
    },
    {
      code: '082220000000',
      label: 'Mannheim',
      provincie: 8,
      slug: 'mannheim',
    },
    {
      code: '082250014014',
      label: 'Buchen (Odenwald)',
      provincie: 8,
      slug: 'buchen-odenwald',
    },
    {
      code: '082250060060',
      label: 'Mudau',
      provincie: 8,
      slug: 'mudau',
    },
    {
      code: '082255001032',
      label: 'Hardheim',
      provincie: 8,
      slug: 'hardheim',
    },
    {
      code: '082255001039',
      label: 'Höpfingen',
      provincie: 8,
      slug: 'hoepfingen',
    },
    {
      code: '082255001109',
      label: 'Walldürn',
      provincie: 8,
      slug: 'wallduern',
    },
    {
      code: '082255002033',
      label: 'Haßmersheim',
      provincie: 8,
      slug: 'hassmersheim',
    },
    {
      code: '082255002042',
      label: 'Hüffenhardt',
      provincie: 8,
      slug: 'hueffenhardt',
    },
    {
      code: '082255003002',
      label: 'Aglasterhausen',
      provincie: 8,
      slug: 'aglasterhausen',
    },
    {
      code: '082255003068',
      label: 'Neunkirchen',
      provincie: 8,
      slug: 'neunkirchen-gemeinde',
    },
    {
      code: '082255003116',
      label: 'Schwarzach',
      provincie: 8,
      slug: 'schwarzach',
    },
    {
      code: '082255004024',
      label: 'Fahrenbach',
      provincie: 8,
      slug: 'fahrenbach',
    },
    {
      code: '082255004052',
      label: 'Limbach',
      provincie: 8,
      slug: 'limbach-gemeinde',
    },
    {
      code: '082255005058',
      label: 'Mosbach',
      provincie: 8,
      slug: 'mosbach',
    },
    {
      code: '082255005067',
      label: 'Neckarzimmern',
      provincie: 8,
      slug: 'neckarzimmern',
    },
    {
      code: '082255005074',
      label: 'Obrigheim',
      provincie: 8,
      slug: 'obrigheim',
    },
    {
      code: '082255005117',
      label: 'Elztal',
      provincie: 8,
      slug: 'elztal',
    },
    {
      code: '082255006010',
      label: 'Binau',
      provincie: 8,
      slug: 'binau',
    },
    {
      code: '082255006064',
      label: 'Neckargerach',
      provincie: 8,
      slug: 'neckargerach',
    },
    {
      code: '082255006113',
      label: 'Zwingenberg',
      provincie: 8,
      slug: 'zwingenberg-gemeinde',
    },
    {
      code: '082255006118',
      label: 'Waldbrunn',
      provincie: 8,
      slug: 'waldbrunn',
    },
    {
      code: '082255007075',
      label: 'Osterburken',
      provincie: 8,
      slug: 'osterburken',
    },
    {
      code: '082255007082',
      label: 'Rosenberg',
      provincie: 8,
      slug: 'rosenberg-gemeinde',
    },
    {
      code: '082255007114',
      label: 'Ravenstein',
      provincie: 8,
      slug: 'ravenstein',
    },
    {
      code: '082255008009',
      label: 'Billigheim',
      provincie: 8,
      slug: 'billigheim',
    },
    {
      code: '082255008115',
      label: 'Schefflenz',
      provincie: 8,
      slug: 'schefflenz',
    },
    {
      code: '082255009001',
      label: 'Adelsheim',
      provincie: 8,
      slug: 'adelsheim',
    },
    {
      code: '082255009091',
      label: 'Seckach',
      provincie: 8,
      slug: 'seckach',
    },
    {
      code: '082260009009',
      label: 'Brühl',
      provincie: 8,
      slug: 'bruehl-gemeinde',
    },
    {
      code: '082260012012',
      label: 'Dossenheim',
      provincie: 8,
      slug: 'dossenheim',
    },
    {
      code: '082260018018',
      label: 'Eppelheim',
      provincie: 8,
      slug: 'eppelheim',
    },
    {
      code: '082260028028',
      label: 'Heddesheim',
      provincie: 8,
      slug: 'heddesheim',
    },
    {
      code: '082260036036',
      label: 'Ilvesheim',
      provincie: 8,
      slug: 'ilvesheim',
    },
    {
      code: '082260037037',
      label: 'Ketsch',
      provincie: 8,
      slug: 'ketsch',
    },
    {
      code: '082260038038',
      label: 'Ladenburg',
      provincie: 8,
      slug: 'ladenburg',
    },
    {
      code: '082260041041',
      label: 'Leimen',
      provincie: 8,
      slug: 'leimen-stadt',
    },
    {
      code: '082260060060',
      label: 'Nußloch',
      provincie: 8,
      slug: 'nussloch',
    },
    {
      code: '082260062062',
      label: 'Oftersheim',
      provincie: 8,
      slug: 'oftersheim',
    },
    {
      code: '082260063063',
      label: 'Plankstadt',
      provincie: 8,
      slug: 'plankstadt',
    },
    {
      code: '082260076076',
      label: 'Sandhausen',
      provincie: 8,
      slug: 'sandhausen',
    },
    {
      code: '082260082082',
      label: 'Schriesheim',
      provincie: 8,
      slug: 'schriesheim',
    },
    {
      code: '082260084084',
      label: 'Schwetzingen',
      provincie: 8,
      slug: 'schwetzingen',
    },
    {
      code: '082260095095',
      label: 'Walldorf',
      provincie: 8,
      slug: 'walldorf',
    },
    {
      code: '082260096096',
      label: 'Weinheim',
      provincie: 8,
      slug: 'weinheim',
    },
    {
      code: '082260103103',
      label: 'St. Leon-Rot',
      provincie: 8,
      slug: 'st-leon-rot',
    },
    {
      code: '082260105105',
      label: 'Edingen-Neckarhausen',
      provincie: 8,
      slug: 'edingen-neckarhausen',
    },
    {
      code: '082260107107',
      label: 'Hirschberg an der Bergstraße',
      provincie: 8,
      slug: 'hirschberg-an-der-bergstrasse',
    },
    {
      code: '082265001013',
      label: 'Eberbach',
      provincie: 8,
      slug: 'eberbach',
    },
    {
      code: '082265001081',
      label: 'Schönbrunn',
      provincie: 8,
      slug: 'schoenbrunn',
    },
    {
      code: '082265002020',
      label: 'Eschelbronn',
      provincie: 8,
      slug: 'eschelbronn',
    },
    {
      code: '082265002048',
      label: 'Mauer',
      provincie: 8,
      slug: 'mauer',
    },
    {
      code: '082265002049',
      label: 'Meckesheim',
      provincie: 8,
      slug: 'meckesheim',
    },
    {
      code: '082265002086',
      label: 'Spechbach',
      provincie: 8,
      slug: 'spechbach',
    },
    {
      code: '082265002104',
      label: 'Lobbach',
      provincie: 8,
      slug: 'lobbach',
    },
    {
      code: '082265003031',
      label: 'Hemsbach',
      provincie: 8,
      slug: 'hemsbach',
    },
    {
      code: '082265003040',
      label: 'Laudenbach',
      provincie: 8,
      slug: 'laudenbach',
    },
    {
      code: '082265004003',
      label: 'Altlußheim',
      provincie: 8,
      slug: 'altlussheim',
    },
    {
      code: '082265004032',
      label: 'Hockenheim',
      provincie: 8,
      slug: 'hockenheim',
    },
    {
      code: '082265004059',
      label: 'Neulußheim',
      provincie: 8,
      slug: 'neulussheim',
    },
    {
      code: '082265004068',
      label: 'Reilingen',
      provincie: 8,
      slug: 'reilingen',
    },
    {
      code: '082265005006',
      label: 'Bammental',
      provincie: 8,
      slug: 'bammental',
    },
    {
      code: '082265005022',
      label: 'Gaiberg',
      provincie: 8,
      slug: 'gaiberg',
    },
    {
      code: '082265005056',
      label: 'Neckargemünd',
      provincie: 8,
      slug: 'neckargemuend',
    },
    {
      code: '082265005097',
      label: 'Wiesenbach',
      provincie: 8,
      slug: 'wiesenbach',
    },
    {
      code: '082265006046',
      label: 'Malsch',
      provincie: 8,
      slug: 'malsch-gemeinde',
    },
    {
      code: '082265006054',
      label: 'Mühlhausen',
      provincie: 8,
      slug: 'muehlhausen',
    },
    {
      code: '082265006065',
      label: 'Rauenberg',
      provincie: 8,
      slug: 'rauenberg',
    },
    {
      code: '082265007027',
      label: 'Heddesbach',
      provincie: 8,
      slug: 'heddesbach',
    },
    {
      code: '082265007029',
      label: 'Heiligkreuzsteinach',
      provincie: 8,
      slug: 'heiligkreuzsteinach',
    },
    {
      code: '082265007080',
      label: 'Schönau',
      provincie: 8,
      slug: 'schoenau',
    },
    {
      code: '082265007099',
      label: 'Wilhelmsfeld',
      provincie: 8,
      slug: 'wilhelmsfeld',
    },
    {
      code: '082265008085',
      label: 'Sinsheim',
      provincie: 8,
      slug: 'sinsheim',
    },
    {
      code: '082265008101',
      label: 'Zuzenhausen',
      provincie: 8,
      slug: 'zuzenhausen',
    },
    {
      code: '082265008102',
      label: 'Angelbachtal',
      provincie: 8,
      slug: 'angelbachtal',
    },
    {
      code: '082265009017',
      label: 'Epfenbach',
      provincie: 8,
      slug: 'epfenbach',
    },
    {
      code: '082265009055',
      label: 'Neckarbischofsheim',
      provincie: 8,
      slug: 'neckarbischofsheim',
    },
    {
      code: '082265009058',
      label: 'Neidenstein',
      provincie: 8,
      slug: 'neidenstein',
    },
    {
      code: '082265009066',
      label: 'Reichartshausen',
      provincie: 8,
      slug: 'reichartshausen',
    },
    {
      code: '082265009091',
      label: 'Waibstadt',
      provincie: 8,
      slug: 'waibstadt',
    },
    {
      code: '082265009106',
      label: 'Helmstadt-Bargen',
      provincie: 8,
      slug: 'helmstadt-bargen',
    },
    {
      code: '082265010010',
      label: 'Dielheim',
      provincie: 8,
      slug: 'dielheim',
    },
    {
      code: '082265010098',
      label: 'Wiesloch',
      provincie: 8,
      slug: 'wiesloch',
    },
    {
      code: '082310000000',
      label: 'Pforzheim',
      provincie: 8,
      slug: 'pforzheim',
    },
    {
      code: '082350065065',
      label: 'Schömberg',
      provincie: 8,
      slug: 'schoemberg',
    },
    {
      code: '082350080080',
      label: 'Wildberg',
      provincie: 8,
      slug: 'wildberg',
    },
    {
      code: '082355001006',
      label: 'Altensteig',
      provincie: 8,
      slug: 'altensteig',
    },
    {
      code: '082355001022',
      label: 'Egenhausen',
      provincie: 8,
      slug: 'egenhausen',
    },
    {
      code: '082355001066',
      label: 'Simmersfeld',
      provincie: 8,
      slug: 'simmersfeld',
    },
    {
      code: '082355002007',
      label: 'Althengstett',
      provincie: 8,
      slug: 'althengstett',
    },
    {
      code: '082355002029',
      label: 'Gechingen',
      provincie: 8,
      slug: 'gechingen',
    },
    {
      code: '082355002057',
      label: 'Ostelsheim',
      provincie: 8,
      slug: 'ostelsheim',
    },
    {
      code: '082355002067',
      label: 'Simmozheim',
      provincie: 8,
      slug: 'simmozheim',
    },
    {
      code: '082355003018',
      label: 'Dobel',
      provincie: 8,
      slug: 'dobel',
    },
    {
      code: '082355003033',
      label: 'Bad Herrenalb',
      provincie: 8,
      slug: 'bad-herrenalb',
    },
    {
      code: '082355004008',
      label: 'Bad Liebenzell',
      provincie: 8,
      slug: 'bad-liebenzell',
    },
    {
      code: '082355004073',
      label: 'Unterreichenbach',
      provincie: 8,
      slug: 'unterreichenbach',
    },
    {
      code: '082355005047',
      label: 'Neubulach',
      provincie: 8,
      slug: 'neubulach',
    },
    {
      code: '082355005050',
      label: 'Neuweiler',
      provincie: 8,
      slug: 'neuweiler',
    },
    {
      code: '082355005084',
      label: 'Bad Teinach-Zavelstein',
      provincie: 8,
      slug: 'bad-teinach-zavelstein',
    },
    {
      code: '082355006055',
      label: 'Oberreichenbach',
      provincie: 8,
      slug: 'oberreichenbach',
    },
    {
      code: '082355006085',
      label: 'Calw',
      provincie: 8,
      slug: 'calw',
    },
    {
      code: '082355007020',
      label: 'Ebhausen',
      provincie: 8,
      slug: 'ebhausen',
    },
    {
      code: '082355007032',
      label: 'Haiterbach',
      provincie: 8,
      slug: 'haiterbach',
    },
    {
      code: '082355007046',
      label: 'Nagold',
      provincie: 8,
      slug: 'nagold',
    },
    {
      code: '082355007060',
      label: 'Rohrdorf',
      provincie: 8,
      slug: 'rohrdorf',
    },
    {
      code: '082355008025',
      label: 'Enzklösterle',
      provincie: 8,
      slug: 'enzkloesterle',
    },
    {
      code: '082355008035',
      label: 'Höfen an der Enz',
      provincie: 8,
      slug: 'hoefen-an-der-enz',
    },
    {
      code: '082355008079',
      label: 'Bad Wildbad',
      provincie: 8,
      slug: 'bad-wildbad',
    },
    {
      code: '082360004004',
      label: 'Birkenfeld',
      provincie: 8,
      slug: 'birkenfeld-gemeinde',
    },
    {
      code: '082360028028',
      label: 'Illingen',
      provincie: 8,
      slug: 'illingen',
    },
    {
      code: '082360030030',
      label: 'Ispringen',
      provincie: 8,
      slug: 'ispringen',
    },
    {
      code: '082360033033',
      label: 'Knittlingen',
      provincie: 8,
      slug: 'knittlingen',
    },
    {
      code: '082360046046',
      label: 'Niefern-Öschelbronn',
      provincie: 8,
      slug: 'niefern-oeschelbronn',
    },
    {
      code: '082360070070',
      label: 'Keltern',
      provincie: 8,
      slug: 'keltern',
    },
    {
      code: '082360071071',
      label: 'Remchingen',
      provincie: 8,
      slug: 'remchingen',
    },
    {
      code: '082360072072',
      label: 'Straubenhardt',
      provincie: 8,
      slug: 'straubenhardt',
    },
    {
      code: '082365001019',
      label: 'Friolzheim',
      provincie: 8,
      slug: 'friolzheim',
    },
    {
      code: '082365001025',
      label: 'Heimsheim',
      provincie: 8,
      slug: 'heimsheim',
    },
    {
      code: '082365001039',
      label: 'Mönsheim',
      provincie: 8,
      slug: 'moensheim',
    },
    {
      code: '082365001065',
      label: 'Wiernsheim',
      provincie: 8,
      slug: 'wiernsheim',
    },
    {
      code: '082365001067',
      label: 'Wimsheim',
      provincie: 8,
      slug: 'wimsheim',
    },
    {
      code: '082365001068',
      label: 'Wurmberg',
      provincie: 8,
      slug: 'wurmberg',
    },
    {
      code: '082365002011',
      label: 'Eisingen',
      provincie: 8,
      slug: 'eisingen',
    },
    {
      code: '082365002074',
      label: 'Kämpfelbach',
      provincie: 8,
      slug: 'kaempfelbach',
    },
    {
      code: '082365002076',
      label: 'Königsbach-Stein',
      provincie: 8,
      slug: 'koenigsbach-stein',
    },
    {
      code: '082365003038',
      label: 'Maulbronn',
      provincie: 8,
      slug: 'maulbronn',
    },
    {
      code: '082365003061',
      label: 'Sternenfels',
      provincie: 8,
      slug: 'sternenfels',
    },
    {
      code: '082365004040',
      label: 'Mühlacker',
      provincie: 8,
      slug: 'muehlacker',
    },
    {
      code: '082365004050',
      label: 'Ötisheim',
      provincie: 8,
      slug: 'oetisheim',
    },
    {
      code: '082365005013',
      label: 'Engelsbrand',
      provincie: 8,
      slug: 'engelsbrand',
    },
    {
      code: '082365005043',
      label: 'Neuenbürg',
      provincie: 8,
      slug: 'neuenbuerg',
    },
    {
      code: '082365006031',
      label: 'Kieselbronn',
      provincie: 8,
      slug: 'kieselbronn',
    },
    {
      code: '082365006073',
      label: 'Neulingen',
      provincie: 8,
      slug: 'neulingen',
    },
    {
      code: '082365006075',
      label: 'Ölbronn-Dürrn',
      provincie: 8,
      slug: 'oelbronn-duerrn',
    },
    {
      code: '082365007044',
      label: 'Neuhausen',
      provincie: 8,
      slug: 'neuhausen',
    },
    {
      code: '082365007062',
      label: 'Tiefenbronn',
      provincie: 8,
      slug: 'tiefenbronn',
    },
    {
      code: '082370002002',
      label: 'Alpirsbach',
      provincie: 8,
      slug: 'alpirsbach',
    },
    {
      code: '082370004004',
      label: 'Baiersbronn',
      provincie: 8,
      slug: 'baiersbronn',
    },
    {
      code: '082370045045',
      label: 'Loßburg',
      provincie: 8,
      slug: 'lossburg',
    },
    {
      code: '082375001019',
      label: 'Dornstetten',
      provincie: 8,
      slug: 'dornstetten',
    },
    {
      code: '082375001030',
      label: 'Glatten',
      provincie: 8,
      slug: 'glatten',
    },
    {
      code: '082375001061',
      label: 'Schopfloch',
      provincie: 8,
      slug: 'schopfloch',
    },
    {
      code: '082375001074',
      label: 'Waldachtal',
      provincie: 8,
      slug: 'waldachtal',
    },
    {
      code: '082375002028',
      label: 'Freudenstadt',
      provincie: 8,
      slug: 'freudenstadt',
    },
    {
      code: '082375002073',
      label: 'Seewald',
      provincie: 8,
      slug: 'seewald',
    },
    {
      code: '082375002075',
      label: 'Bad Rippoldsau-Schapbach',
      provincie: 8,
      slug: 'bad-rippoldsau-schapbach',
    },
    {
      code: '082375003024',
      label: 'Empfingen',
      provincie: 8,
      slug: 'empfingen',
    },
    {
      code: '082375003027',
      label: 'Eutingen im Gäu',
      provincie: 8,
      slug: 'eutingen-im-gaeu',
    },
    {
      code: '082375003040',
      label: 'Horb am Neckar',
      provincie: 8,
      slug: 'horb-am-neckar',
    },
    {
      code: '082375005032',
      label: 'Grömbach',
      provincie: 8,
      slug: 'groembach',
    },
    {
      code: '082375005054',
      label: 'Pfalzgrafenweiler',
      provincie: 8,
      slug: 'pfalzgrafenweiler',
    },
    {
      code: '082375005072',
      label: 'Wörnersberg',
      provincie: 8,
      slug: 'woernersberg',
    },
    {
      code: '083110000000',
      label: 'Freiburg im Breisgau',
      provincie: 8,
      slug: 'freiburg-im-breisgau',
    },
    {
      code: '083150068068',
      label: 'Lenzkirch',
      provincie: 8,
      slug: 'lenzkirch',
    },
    {
      code: '083150076076',
      label: 'Neuenburg am Rhein',
      provincie: 8,
      slug: 'neuenburg-am-rhein',
    },
    {
      code: '083150133133',
      label: 'Vogtsburg im Kaiserstuhl',
      provincie: 8,
      slug: 'vogtsburg-im-kaiserstuhl',
    },
    {
      code: '083155001006',
      label: 'Bad Krozingen',
      provincie: 8,
      slug: 'bad-krozingen',
    },
    {
      code: '083155001048',
      label: 'Hartheim am Rhein',
      provincie: 8,
      slug: 'hartheim-am-rhein',
    },
    {
      code: '083155002015',
      label: 'Breisach am Rhein',
      provincie: 8,
      slug: 'breisach-am-rhein',
    },
    {
      code: '083155002059',
      label: 'Ihringen',
      provincie: 8,
      slug: 'ihringen',
    },
    {
      code: '083155002072',
      label: 'Merdingen',
      provincie: 8,
      slug: 'merdingen',
    },
    {
      code: '083155003020',
      label: 'Buchenbach',
      provincie: 8,
      slug: 'buchenbach',
    },
    {
      code: '083155003064',
      label: 'Kirchzarten',
      provincie: 8,
      slug: 'kirchzarten',
    },
    {
      code: '083155003084',
      label: 'Oberried',
      provincie: 8,
      slug: 'oberried',
    },
    {
      code: '083155003109',
      label: 'Stegen',
      provincie: 8,
      slug: 'stegen',
    },
    {
      code: '083155004014',
      label: 'Bollschweil',
      provincie: 8,
      slug: 'bollschweil',
    },
    {
      code: '083155004131',
      label: 'Ehrenkirchen',
      provincie: 8,
      slug: 'ehrenkirchen',
    },
    {
      code: '083155005047',
      label: 'Gundelfingen',
      provincie: 8,
      slug: 'gundelfingen',
    },
    {
      code: '083155005051',
      label: 'Heuweiler',
      provincie: 8,
      slug: 'heuweiler',
    },
    {
      code: '083155006008',
      label: 'Ballrechten-Dottingen',
      provincie: 8,
      slug: 'ballrechten-dottingen',
    },
    {
      code: '083155006033',
      label: 'Eschbach',
      provincie: 8,
      slug: 'eschbach-gemeinde',
    },
    {
      code: '083155006050',
      label: 'Heitersheim',
      provincie: 8,
      slug: 'heitersheim',
    },
    {
      code: '083155007003',
      label: 'Au',
      provincie: 8,
      slug: 'au',
    },
    {
      code: '083155007056',
      label: 'Horben',
      provincie: 8,
      slug: 'horben',
    },
    {
      code: '083155007073',
      label: 'Merzhausen',
      provincie: 8,
      slug: 'merzhausen',
    },
    {
      code: '083155007107',
      label: 'Sölden',
      provincie: 8,
      slug: 'soelden',
    },
    {
      code: '083155007125',
      label: 'Wittnau',
      provincie: 8,
      slug: 'wittnau',
    },
    {
      code: '083155008016',
      label: 'Breitnau',
      provincie: 8,
      slug: 'breitnau',
    },
    {
      code: '083155008052',
      label: 'Hinterzarten',
      provincie: 8,
      slug: 'hinterzarten',
    },
    {
      code: '083155009013',
      label: 'Bötzingen',
      provincie: 8,
      slug: 'boetzingen',
    },
    {
      code: '083155009030',
      label: 'Eichstetten am Kaiserstuhl',
      provincie: 8,
      slug: 'eichstetten-am-kaiserstuhl',
    },
    {
      code: '083155009043',
      label: 'Gottenheim',
      provincie: 8,
      slug: 'gottenheim',
    },
    {
      code: '083155010039',
      label: 'Friedenweiler',
      provincie: 8,
      slug: 'friedenweiler',
    },
    {
      code: '083155010070',
      label: 'Löffingen',
      provincie: 8,
      slug: 'loeffingen',
    },
    {
      code: '083155011115',
      label: 'Umkirch',
      provincie: 8,
      slug: 'umkirch',
    },
    {
      code: '083155011132',
      label: 'March',
      provincie: 8,
      slug: 'march',
    },
    {
      code: '083155012004',
      label: 'Auggen',
      provincie: 8,
      slug: 'auggen',
    },
    {
      code: '083155012007',
      label: 'Badenweiler',
      provincie: 8,
      slug: 'badenweiler',
    },
    {
      code: '083155012022',
      label: 'Buggingen',
      provincie: 8,
      slug: 'buggingen',
    },
    {
      code: '083155012074',
      label: 'Müllheim im Markgräflerland',
      provincie: 8,
      slug: 'muellheim-im-markgraeflerland',
    },
    {
      code: '083155012111',
      label: 'Sulzburg',
      provincie: 8,
      slug: 'sulzburg',
    },
    {
      code: '083155013041',
      label: 'Glottertal',
      provincie: 8,
      slug: 'glottertal',
    },
    {
      code: '083155013094',
      label: 'St. Märgen',
      provincie: 8,
      slug: 'st-maergen',
    },
    {
      code: '083155013095',
      label: 'St. Peter',
      provincie: 8,
      slug: 'st-peter',
    },
    {
      code: '083155014028',
      label: 'Ebringen',
      provincie: 8,
      slug: 'ebringen',
    },
    {
      code: '083155014089',
      label: 'Pfaffenweiler',
      provincie: 8,
      slug: 'pfaffenweiler',
    },
    {
      code: '083155014098',
      label: 'Schallstadt',
      provincie: 8,
      slug: 'schallstadt',
    },
    {
      code: '083155015037',
      label: 'Feldberg (Schwarzwald)',
      provincie: 8,
      slug: 'feldberg-schwarzwald',
    },
    {
      code: '083155015102',
      label: 'Schluchsee',
      provincie: 8,
      slug: 'schluchsee',
    },
    {
      code: '083155016108',
      label: 'Staufen im Breisgau',
      provincie: 8,
      slug: 'staufen-im-breisgau',
    },
    {
      code: '083155016130',
      label: 'Münstertal/Schwarzwald',
      provincie: 8,
      slug: 'muenstertal-schwarzwald',
    },
    {
      code: '083155017031',
      label: 'Eisenbach (Hochschwarzwald)',
      provincie: 8,
      slug: 'eisenbach-hochschwarzwald',
    },
    {
      code: '083155017113',
      label: 'Titisee-Neustadt',
      provincie: 8,
      slug: 'titisee-neustadt',
    },
    {
      code: '083165001009',
      label: 'Denzlingen',
      provincie: 8,
      slug: 'denzlingen',
    },
    {
      code: '083165001036',
      label: 'Reute',
      provincie: 8,
      slug: 'reute',
    },
    {
      code: '083165001045',
      label: 'Vörstetten',
      provincie: 8,
      slug: 'voerstetten',
    },
    {
      code: '083165002003',
      label: 'Biederbach',
      provincie: 8,
      slug: 'biederbach',
    },
    {
      code: '083165002010',
      label: 'Elzach',
      provincie: 8,
      slug: 'elzach',
    },
    {
      code: '083165002055',
      label: 'Winden im Elztal',
      provincie: 8,
      slug: 'winden-im-elztal',
    },
    {
      code: '083165003011',
      label: 'Emmendingen',
      provincie: 8,
      slug: 'emmendingen',
    },
    {
      code: '083165003024',
      label: 'Malterdingen',
      provincie: 8,
      slug: 'malterdingen',
    },
    {
      code: '083165003039',
      label: 'Sexau',
      provincie: 8,
      slug: 'sexau',
    },
    {
      code: '083165003043',
      label: 'Teningen',
      provincie: 8,
      slug: 'teningen',
    },
    {
      code: '083165003054',
      label: 'Freiamt',
      provincie: 8,
      slug: 'freiamt',
    },
    {
      code: '083165004017',
      label: 'Herbolzheim',
      provincie: 8,
      slug: 'herbolzheim',
    },
    {
      code: '083165004020',
      label: 'Kenzingen',
      provincie: 8,
      slug: 'kenzingen',
    },
    {
      code: '083165004049',
      label: 'Weisweil',
      provincie: 8,
      slug: 'weisweil',
    },
    {
      code: '083165004053',
      label: 'Rheinhausen',
      provincie: 8,
      slug: 'rheinhausen',
    },
    {
      code: '083165005002',
      label: 'Bahlingen am Kaiserstuhl',
      provincie: 8,
      slug: 'bahlingen-am-kaiserstuhl',
    },
    {
      code: '083165005012',
      label: 'Endingen am Kaiserstuhl',
      provincie: 8,
      slug: 'endingen-am-kaiserstuhl',
    },
    {
      code: '083165005013',
      label: 'Forchheim',
      provincie: 8,
      slug: 'forchheim',
    },
    {
      code: '083165005037',
      label: 'Riegel am Kaiserstuhl',
      provincie: 8,
      slug: 'riegel-am-kaiserstuhl',
    },
    {
      code: '083165005038',
      label: 'Sasbach am Kaiserstuhl',
      provincie: 8,
      slug: 'sasbach-am-kaiserstuhl',
    },
    {
      code: '083165005051',
      label: 'Wyhl am Kaiserstuhl',
      provincie: 8,
      slug: 'wyhl-am-kaiserstuhl',
    },
    {
      code: '083165006014',
      label: 'Gutach im Breisgau',
      provincie: 8,
      slug: 'gutach-im-breisgau',
    },
    {
      code: '083165006042',
      label: 'Simonswald',
      provincie: 8,
      slug: 'simonswald',
    },
    {
      code: '083165006056',
      label: 'Waldkirch',
      provincie: 8,
      slug: 'waldkirch',
    },
    {
      code: '083170005005',
      label: 'Appenweier',
      provincie: 8,
      slug: 'appenweier',
    },
    {
      code: '083170031031',
      label: 'Friesenheim',
      provincie: 8,
      slug: 'friesenheim-gemeinde',
    },
    {
      code: '083170051051',
      label: 'Hornberg',
      provincie: 8,
      slug: 'hornberg',
    },
    {
      code: '083170057057',
      label: 'Kehl',
      provincie: 8,
      slug: 'kehl',
    },
    {
      code: '083170141141',
      label: 'Willstätt',
      provincie: 8,
      slug: 'willstaett',
    },
    {
      code: '083170151151',
      label: 'Neuried',
      provincie: 8,
      slug: 'neuried',
    },
    {
      code: '083170153153',
      label: 'Rheinau',
      provincie: 8,
      slug: 'rheinau',
    },
    {
      code: '083175001001',
      label: 'Achern',
      provincie: 8,
      slug: 'achern',
    },
    {
      code: '083175001068',
      label: 'Lauf',
      provincie: 8,
      slug: 'lauf',
    },
    {
      code: '083175001116',
      label: 'Sasbach',
      provincie: 8,
      slug: 'sasbach',
    },
    {
      code: '083175001118',
      label: 'Sasbachwalden',
      provincie: 8,
      slug: 'sasbachwalden',
    },
    {
      code: '083175002026',
      label: 'Ettenheim',
      provincie: 8,
      slug: 'ettenheim',
    },
    {
      code: '083175002073',
      label: 'Mahlberg',
      provincie: 8,
      slug: 'mahlberg',
    },
    {
      code: '083175002113',
      label: 'Ringsheim',
      provincie: 8,
      slug: 'ringsheim',
    },
    {
      code: '083175002114',
      label: 'Rust',
      provincie: 8,
      slug: 'rust',
    },
    {
      code: '083175002152',
      label: 'Kappel-Grafenhausen',
      provincie: 8,
      slug: 'kappel-grafenhausen',
    },
    {
      code: '083175003009',
      label: 'Berghaupten',
      provincie: 8,
      slug: 'berghaupten',
    },
    {
      code: '083175003034',
      label: 'Gengenbach',
      provincie: 8,
      slug: 'gengenbach',
    },
    {
      code: '083175003097',
      label: 'Ohlsbach',
      provincie: 8,
      slug: 'ohlsbach',
    },
    {
      code: '083175004029',
      label: 'Fischerbach',
      provincie: 8,
      slug: 'fischerbach',
    },
    {
      code: '083175004040',
      label: 'Haslach im Kinzigtal',
      provincie: 8,
      slug: 'haslach-im-kinzigtal',
    },
    {
      code: '083175004046',
      label: 'Hofstetten',
      provincie: 8,
      slug: 'hofstetten',
    },
    {
      code: '083175004078',
      label: 'Mühlenbach',
      provincie: 8,
      slug: 'muehlenbach',
    },
    {
      code: '083175004129',
      label: 'Steinach',
      provincie: 8,
      slug: 'steinach',
    },
    {
      code: '083175005039',
      label: 'Gutach (Schwarzwaldbahn)',
      provincie: 8,
      slug: 'gutach-schwarzwaldbahn',
    },
    {
      code: '083175005041',
      label: 'Hausach',
      provincie: 8,
      slug: 'hausach',
    },
    {
      code: '083175006056',
      label: 'Kappelrodeck',
      provincie: 8,
      slug: 'kappelrodeck',
    },
    {
      code: '083175006102',
      label: 'Ottenhöfen im Schwarzwald',
      provincie: 8,
      slug: 'ottenhoefen-im-schwarzwald',
    },
    {
      code: '083175006126',
      label: 'Seebach',
      provincie: 8,
      slug: 'seebach',
    },
    {
      code: '083175007059',
      label: 'Kippenheim',
      provincie: 8,
      slug: 'kippenheim',
    },
    {
      code: '083175007065',
      label: 'Lahr/Schwarzwald',
      provincie: 8,
      slug: 'lahr-schwarzwald',
    },
    {
      code: '083175008008',
      label: 'Bad Peterstal-Griesbach',
      provincie: 8,
      slug: 'bad-peterstal-griesbach',
    },
    {
      code: '083175008098',
      label: 'Oppenau',
      provincie: 8,
      slug: 'oppenau',
    },
    {
      code: '083175009067',
      label: 'Lautenbach',
      provincie: 8,
      slug: 'lautenbach',
    },
    {
      code: '083175009089',
      label: 'Oberkirch',
      provincie: 8,
      slug: 'oberkirch',
    },
    {
      code: '083175009110',
      label: 'Renchen',
      provincie: 8,
      slug: 'renchen',
    },
    {
      code: '083175010021',
      label: 'Durbach',
      provincie: 8,
      slug: 'durbach',
    },
    {
      code: '083175010047',
      label: 'Hohberg',
      provincie: 8,
      slug: 'hohberg',
    },
    {
      code: '083175010096',
      label: 'Offenburg',
      provincie: 8,
      slug: 'offenburg',
    },
    {
      code: '083175010100',
      label: 'Ortenberg',
      provincie: 8,
      slug: 'ortenberg-gemeinde',
    },
    {
      code: '083175010122',
      label: 'Schutterwald',
      provincie: 8,
      slug: 'schutterwald',
    },
    {
      code: '083175011121',
      label: 'Schuttertal',
      provincie: 8,
      slug: 'schuttertal',
    },
    {
      code: '083175011127',
      label: 'Seelbach',
      provincie: 8,
      slug: 'seelbach-gemeinde',
    },
    {
      code: '083175012075',
      label: 'Meißenheim',
      provincie: 8,
      slug: 'meissenheim',
    },
    {
      code: '083175012150',
      label: 'Schwanau',
      provincie: 8,
      slug: 'schwanau',
    },
    {
      code: '083175013093',
      label: 'Oberwolfach',
      provincie: 8,
      slug: 'oberwolfach',
    },
    {
      code: '083175013145',
      label: 'Wolfach',
      provincie: 8,
      slug: 'wolfach',
    },
    {
      code: '083175014011',
      label: 'Biberach',
      provincie: 8,
      slug: 'biberach',
    },
    {
      code: '083175014085',
      label: 'Nordrach',
      provincie: 8,
      slug: 'nordrach',
    },
    {
      code: '083175014088',
      label: 'Oberharmersbach',
      provincie: 8,
      slug: 'oberharmersbach',
    },
    {
      code: '083175014146',
      label: 'Zell am Harmersbach',
      provincie: 8,
      slug: 'zell-am-harmersbach',
    },
    {
      code: '083250012012',
      label: 'Dornhan',
      provincie: 8,
      slug: 'dornhan',
    },
    {
      code: '083255001014',
      label: 'Dunningen',
      provincie: 8,
      slug: 'dunningen',
    },
    {
      code: '083255001071',
      label: 'Eschbronn',
      provincie: 8,
      slug: 'eschbronn',
    },
    {
      code: '083255002015',
      label: 'Epfendorf',
      provincie: 8,
      slug: 'epfendorf',
    },
    {
      code: '083255002045',
      label: 'Oberndorf am Neckar',
      provincie: 8,
      slug: 'oberndorf-am-neckar',
    },
    {
      code: '083255002070',
      label: 'Fluorn-Winzeln',
      provincie: 8,
      slug: 'fluorn-winzeln',
    },
    {
      code: '083255003011',
      label: 'Dietingen',
      provincie: 8,
      slug: 'dietingen',
    },
    {
      code: '083255003049',
      label: 'Rottweil',
      provincie: 8,
      slug: 'rottweil',
    },
    {
      code: '083255003064',
      label: 'Wellendingen',
      provincie: 8,
      slug: 'wellendingen',
    },
    {
      code: '083255003069',
      label: 'Zimmern ob Rottweil',
      provincie: 8,
      slug: 'zimmern-ob-rottweil',
    },
    {
      code: '083255003072',
      label: 'Deißlingen',
      provincie: 8,
      slug: 'deisslingen',
    },
    {
      code: '083255004050',
      label: 'Schenkenzell',
      provincie: 8,
      slug: 'schenkenzell',
    },
    {
      code: '083255004051',
      label: 'Schiltach',
      provincie: 8,
      slug: 'schiltach',
    },
    {
      code: '083255005001',
      label: 'Aichhalden',
      provincie: 8,
      slug: 'aichhalden',
    },
    {
      code: '083255005024',
      label: 'Hardt',
      provincie: 8,
      slug: 'hardt-gemeinde',
    },
    {
      code: '083255005036',
      label: 'Lauterbach',
      provincie: 8,
      slug: 'lauterbach',
    },
    {
      code: '083255005053',
      label: 'Schramberg',
      provincie: 8,
      slug: 'schramberg',
    },
    {
      code: '083255006057',
      label: 'Sulz am Neckar',
      provincie: 8,
      slug: 'sulz-am-neckar',
    },
    {
      code: '083255006061',
      label: 'Vöhringen',
      provincie: 8,
      slug: 'voehringen',
    },
    {
      code: '083255007009',
      label: 'Bösingen',
      provincie: 8,
      slug: 'boesingen',
    },
    {
      code: '083255007060',
      label: 'Villingendorf',
      provincie: 8,
      slug: 'villingendorf',
    },
    {
      code: '083260003003',
      label: 'Bad Dürrheim',
      provincie: 8,
      slug: 'bad-duerrheim',
    },
    {
      code: '083260005005',
      label: 'Blumberg',
      provincie: 8,
      slug: 'blumberg',
    },
    {
      code: '083260031031',
      label: 'Königsfeld im Schwarzwald',
      provincie: 8,
      slug: 'koenigsfeld-im-schwarzwald',
    },
    {
      code: '083260052052',
      label: 'St. Georgen im Schwarzwald',
      provincie: 8,
      slug: 'st-georgen-im-schwarzwald',
    },
    {
      code: '083260068068',
      label: 'Vöhrenbach',
      provincie: 8,
      slug: 'voehrenbach',
    },
    {
      code: '083265001006',
      label: 'Bräunlingen',
      provincie: 8,
      slug: 'braeunlingen',
    },
    {
      code: '083265001012',
      label: 'Donaueschingen',
      provincie: 8,
      slug: 'donaueschingen',
    },
    {
      code: '083265001027',
      label: 'Hüfingen',
      provincie: 8,
      slug: 'huefingen',
    },
    {
      code: '083265002017',
      label: 'Furtwangen im Schwarzwald',
      provincie: 8,
      slug: 'furtwangen-im-schwarzwald',
    },
    {
      code: '083265002020',
      label: 'Gütenbach',
      provincie: 8,
      slug: 'guetenbach',
    },
    {
      code: '083265003054',
      label: 'Schönwald im Schwarzwald',
      provincie: 8,
      slug: 'schoenwald-im-schwarzwald',
    },
    {
      code: '083265003055',
      label: 'Schonach im Schwarzwald',
      provincie: 8,
      slug: 'schonach-im-schwarzwald',
    },
    {
      code: '083265003060',
      label: 'Triberg im Schwarzwald',
      provincie: 8,
      slug: 'triberg-im-schwarzwald',
    },
    {
      code: '083265004010',
      label: 'Dauchingen',
      provincie: 8,
      slug: 'dauchingen',
    },
    {
      code: '083265004037',
      label: 'Mönchweiler',
      provincie: 8,
      slug: 'moenchweiler',
    },
    {
      code: '083265004041',
      label: 'Niedereschach',
      provincie: 8,
      slug: 'niedereschach',
    },
    {
      code: '083265004061',
      label: 'Tuningen',
      provincie: 8,
      slug: 'tuningen',
    },
    {
      code: '083265004065',
      label: 'Unterkirnach',
      provincie: 8,
      slug: 'unterkirnach',
    },
    {
      code: '083265004074',
      label: 'Villingen-Schwenningen',
      provincie: 8,
      slug: 'villingen-schwenningen',
    },
    {
      code: '083265004075',
      label: 'Brigachtal',
      provincie: 8,
      slug: 'brigachtal',
    },
    {
      code: '083275001004',
      label: 'Bärenthal',
      provincie: 8,
      slug: 'baerenthal',
    },
    {
      code: '083275001008',
      label: 'Buchheim',
      provincie: 8,
      slug: 'buchheim',
    },
    {
      code: '083275001016',
      label: 'Fridingen an der Donau',
      provincie: 8,
      slug: 'fridingen-an-der-donau',
    },
    {
      code: '083275001027',
      label: 'Irndorf',
      provincie: 8,
      slug: 'irndorf',
    },
    {
      code: '083275001030',
      label: 'Kolbingen',
      provincie: 8,
      slug: 'kolbingen',
    },
    {
      code: '083275001036',
      label: 'Mühlheim an der Donau',
      provincie: 8,
      slug: 'muehlheim-an-der-donau',
    },
    {
      code: '083275001041',
      label: 'Renquishausen',
      provincie: 8,
      slug: 'renquishausen',
    },
    {
      code: '083275002007',
      label: 'Bubsheim',
      provincie: 8,
      slug: 'bubsheim',
    },
    {
      code: '083275002009',
      label: 'Deilingen',
      provincie: 8,
      slug: 'deilingen',
    },
    {
      code: '083275002013',
      label: 'Egesheim',
      provincie: 8,
      slug: 'egesheim',
    },
    {
      code: '083275002019',
      label: 'Gosheim',
      provincie: 8,
      slug: 'gosheim',
    },
    {
      code: '083275002029',
      label: 'Königsheim',
      provincie: 8,
      slug: 'koenigsheim',
    },
    {
      code: '083275002040',
      label: 'Reichenbach am Heuberg',
      provincie: 8,
      slug: 'reichenbach-am-heuberg',
    },
    {
      code: '083275002051',
      label: 'Wehingen',
      provincie: 8,
      slug: 'wehingen',
    },
    {
      code: '083275003018',
      label: 'Geisingen',
      provincie: 8,
      slug: 'geisingen',
    },
    {
      code: '083275003025',
      label: 'Immendingen',
      provincie: 8,
      slug: 'immendingen',
    },
    {
      code: '083275004002',
      label: 'Aldingen',
      provincie: 8,
      slug: 'aldingen',
    },
    {
      code: '083275004005',
      label: 'Balgheim',
      provincie: 8,
      slug: 'balgheim',
    },
    {
      code: '083275004006',
      label: 'Böttingen',
      provincie: 8,
      slug: 'boettingen',
    },
    {
      code: '083275004010',
      label: 'Denkingen',
      provincie: 8,
      slug: 'denkingen',
    },
    {
      code: '083275004011',
      label: 'Dürbheim',
      provincie: 8,
      slug: 'duerbheim',
    },
    {
      code: '083275004017',
      label: 'Frittlingen',
      provincie: 8,
      slug: 'frittlingen',
    },
    {
      code: '083275004023',
      label: 'Hausen ob Verena',
      provincie: 8,
      slug: 'hausen-ob-verena',
    },
    {
      code: '083275004033',
      label: 'Mahlstetten',
      provincie: 8,
      slug: 'mahlstetten',
    },
    {
      code: '083275004046',
      label: 'Spaichingen',
      provincie: 8,
      slug: 'spaichingen',
    },
    {
      code: '083275005012',
      label: 'Durchhausen',
      provincie: 8,
      slug: 'durchhausen',
    },
    {
      code: '083275005020',
      label: 'Gunningen',
      provincie: 8,
      slug: 'gunningen',
    },
    {
      code: '083275005048',
      label: 'Talheim',
      provincie: 8,
      slug: 'talheim-gemeinde',
    },
    {
      code: '083275005049',
      label: 'Trossingen',
      provincie: 8,
      slug: 'trossingen',
    },
    {
      code: '083275006038',
      label: 'Neuhausen ob Eck',
      provincie: 8,
      slug: 'neuhausen-ob-eck',
    },
    {
      code: '083275006050',
      label: 'Tuttlingen',
      provincie: 8,
      slug: 'tuttlingen',
    },
    {
      code: '083275006054',
      label: 'Wurmlingen',
      provincie: 8,
      slug: 'wurmlingen',
    },
    {
      code: '083275006055',
      label: 'Seitingen-Oberflacht',
      provincie: 8,
      slug: 'seitingen-oberflacht',
    },
    {
      code: '083275006056',
      label: 'Rietheim-Weilheim',
      provincie: 8,
      slug: 'rietheim-weilheim',
    },
    {
      code: '083275006057',
      label: 'Emmingen-Liptingen',
      provincie: 8,
      slug: 'emmingen-liptingen',
    },
    {
      code: '083350035035',
      label: 'Hilzingen',
      provincie: 8,
      slug: 'hilzingen',
    },
    {
      code: '083350063063',
      label: 'Radolfzell am Bodensee',
      provincie: 8,
      slug: 'radolfzell-am-bodensee',
    },
    {
      code: '083350080080',
      label: 'Tengen',
      provincie: 8,
      slug: 'tengen',
    },
    {
      code: '083355001001',
      label: 'Aach',
      provincie: 8,
      slug: 'aach-stadt',
    },
    {
      code: '083355001022',
      label: 'Engen',
      provincie: 8,
      slug: 'engen',
    },
    {
      code: '083355001097',
      label: 'Mühlhausen-Ehingen',
      provincie: 8,
      slug: 'muehlhausen-ehingen',
    },
    {
      code: '083355002015',
      label: 'Büsingen am Hochrhein',
      provincie: 8,
      slug: 'buesingen-am-hochrhein',
    },
    {
      code: '083355002026',
      label: 'Gailingen am Hochrhein',
      provincie: 8,
      slug: 'gailingen-am-hochrhein',
    },
    {
      code: '083355002028',
      label: 'Gottmadingen',
      provincie: 8,
      slug: 'gottmadingen',
    },
    {
      code: '083355003025',
      label: 'Gaienhofen',
      provincie: 8,
      slug: 'gaienhofen',
    },
    {
      code: '083355003055',
      label: 'Moos',
      provincie: 8,
      slug: 'moos',
    },
    {
      code: '083355003061',
      label: 'Öhningen',
      provincie: 8,
      slug: 'oehningen',
    },
    {
      code: '083355004002',
      label: 'Allensbach',
      provincie: 8,
      slug: 'allensbach',
    },
    {
      code: '083355004043',
      label: 'Konstanz',
      provincie: 8,
      slug: 'konstanz',
    },
    {
      code: '083355004066',
      label: 'Reichenau',
      provincie: 8,
      slug: 'reichenau',
    },
    {
      code: '083355005075',
      label: 'Singen (Hohentwiel)',
      provincie: 8,
      slug: 'singen-hohentwiel',
    },
    {
      code: '083355005077',
      label: 'Steißlingen',
      provincie: 8,
      slug: 'steisslingen',
    },
    {
      code: '083355005081',
      label: 'Volkertshausen',
      provincie: 8,
      slug: 'volkertshausen',
    },
    {
      code: '083355005100',
      label: 'Rielasingen-Worblingen',
      provincie: 8,
      slug: 'rielasingen-worblingen',
    },
    {
      code: '083355006021',
      label: 'Eigeltingen',
      provincie: 8,
      slug: 'eigeltingen',
    },
    {
      code: '083355006057',
      label: 'Mühlingen',
      provincie: 8,
      slug: 'muehlingen',
    },
    {
      code: '083355006079',
      label: 'Stockach',
      provincie: 8,
      slug: 'stockach',
    },
    {
      code: '083355006096',
      label: 'Hohenfels',
      provincie: 8,
      slug: 'hohenfels',
    },
    {
      code: '083355006098',
      label: 'Bodman-Ludwigshafen',
      provincie: 8,
      slug: 'bodman-ludwigshafen',
    },
    {
      code: '083355006099',
      label: 'Orsingen-Nenzingen',
      provincie: 8,
      slug: 'orsingen-nenzingen',
    },
    {
      code: '083360014014',
      label: 'Efringen-Kirchen',
      provincie: 8,
      slug: 'efringen-kirchen',
    },
    {
      code: '083360084084',
      label: 'Steinen',
      provincie: 8,
      slug: 'steinen-gemeinde',
    },
    {
      code: '083360087087',
      label: 'Todtnau',
      provincie: 8,
      slug: 'todtnau',
    },
    {
      code: '083360091091',
      label: 'Weil am Rhein',
      provincie: 8,
      slug: 'weil-am-rhein',
    },
    {
      code: '083360105105',
      label: 'Grenzach-Wyhlen',
      provincie: 8,
      slug: 'grenzach-wyhlen',
    },
    {
      code: '083360107107',
      label: 'Kleines Wiesental',
      provincie: 8,
      slug: 'kleines-wiesental',
    },
    {
      code: '083365001045',
      label: 'Kandern',
      provincie: 8,
      slug: 'kandern',
    },
    {
      code: '083365001104',
      label: 'Malsburg-Marzell',
      provincie: 8,
      slug: 'malsburg-marzell',
    },
    {
      code: '083365003043',
      label: 'Inzlingen',
      provincie: 8,
      slug: 'inzlingen',
    },
    {
      code: '083365003050',
      label: 'Lörrach',
      provincie: 8,
      slug: 'loerrach',
    },
    {
      code: '083365004069',
      label: 'Rheinfelden (Baden)',
      provincie: 8,
      slug: 'rheinfelden-baden',
    },
    {
      code: '083365004082',
      label: 'Schwörstadt',
      provincie: 8,
      slug: 'schwoerstadt',
    },
    {
      code: '083365005006',
      label: 'Bad Bellingen',
      provincie: 8,
      slug: 'bad-bellingen',
    },
    {
      code: '083365005078',
      label: 'Schliengen',
      provincie: 8,
      slug: 'schliengen',
    },
    {
      code: '083365006004',
      label: 'Aitern',
      provincie: 8,
      slug: 'aitern',
    },
    {
      code: '083365006010',
      label: 'Böllen',
      provincie: 8,
      slug: 'boellen',
    },
    {
      code: '083365006025',
      label: 'Fröhnd',
      provincie: 8,
      slug: 'froehnd',
    },
    {
      code: '083365006079',
      label: 'Schönau im Schwarzwald',
      provincie: 8,
      slug: 'schoenau-im-schwarzwald',
    },
    {
      code: '083365006080',
      label: 'Schönenberg',
      provincie: 8,
      slug: 'schoenenberg',
    },
    {
      code: '083365006089',
      label: 'Tunau',
      provincie: 8,
      slug: 'tunau',
    },
    {
      code: '083365006090',
      label: 'Utzenfeld',
      provincie: 8,
      slug: 'utzenfeld',
    },
    {
      code: '083365006094',
      label: 'Wembach',
      provincie: 8,
      slug: 'wembach',
    },
    {
      code: '083365006096',
      label: 'Wieden',
      provincie: 8,
      slug: 'wieden',
    },
    {
      code: '083365007034',
      label: 'Hasel',
      provincie: 8,
      slug: 'hasel',
    },
    {
      code: '083365007036',
      label: 'Hausen im Wiesental',
      provincie: 8,
      slug: 'hausen-im-wiesental',
    },
    {
      code: '083365007057',
      label: 'Maulburg',
      provincie: 8,
      slug: 'maulburg',
    },
    {
      code: '083365007081',
      label: 'Schopfheim',
      provincie: 8,
      slug: 'schopfheim',
    },
    {
      code: '083365008008',
      label: 'Binzen',
      provincie: 8,
      slug: 'binzen',
    },
    {
      code: '083365008019',
      label: 'Eimeldingen',
      provincie: 8,
      slug: 'eimeldingen',
    },
    {
      code: '083365008024',
      label: 'Fischingen',
      provincie: 8,
      slug: 'fischingen',
    },
    {
      code: '083365008073',
      label: 'Rümmingen',
      provincie: 8,
      slug: 'ruemmingen',
    },
    {
      code: '083365008075',
      label: 'Schallbach',
      provincie: 8,
      slug: 'schallbach',
    },
    {
      code: '083365008100',
      label: 'Wittlingen',
      provincie: 8,
      slug: 'wittlingen',
    },
    {
      code: '083365009103',
      label: 'Zell im Wiesental',
      provincie: 8,
      slug: 'zell-im-wiesental',
    },
    {
      code: '083365009106',
      label: 'Häg-Ehrsberg',
      provincie: 8,
      slug: 'haeg-ehrsberg',
    },
    {
      code: '083370002002',
      label: 'Albbruck',
      provincie: 8,
      slug: 'albbruck',
    },
    {
      code: '083370038038',
      label: 'Görwihl',
      provincie: 8,
      slug: 'goerwihl',
    },
    {
      code: '083370062062',
      label: 'Klettgau',
      provincie: 8,
      slug: 'klettgau',
    },
    {
      code: '083370066066',
      label: 'Laufenburg (Baden)',
      provincie: 8,
      slug: 'laufenburg-baden',
    },
    {
      code: '083370106106',
      label: 'Stühlingen',
      provincie: 8,
      slug: 'stuehlingen',
    },
    {
      code: '083370116116',
      label: 'Wehr',
      provincie: 8,
      slug: 'wehr-stadt',
    },
    {
      code: '083375001022',
      label: 'Bonndorf im Schwarzwald',
      provincie: 8,
      slug: 'bonndorf-im-schwarzwald',
    },
    {
      code: '083375001127',
      label: 'Wutach',
      provincie: 8,
      slug: 'wutach',
    },
    {
      code: '083375002030',
      label: 'Dettighofen',
      provincie: 8,
      slug: 'dettighofen',
    },
    {
      code: '083375002060',
      label: 'Jestetten',
      provincie: 8,
      slug: 'jestetten',
    },
    {
      code: '083375002070',
      label: 'Lottstetten',
      provincie: 8,
      slug: 'lottstetten',
    },
    {
      code: '083375003053',
      label: 'Hohentengen am Hochrhein',
      provincie: 8,
      slug: 'hohentengen-am-hochrhein',
    },
    {
      code: '083375003125',
      label: 'Küssaberg',
      provincie: 8,
      slug: 'kuessaberg',
    },
    {
      code: '083375004039',
      label: 'Grafenhausen',
      provincie: 8,
      slug: 'grafenhausen',
    },
    {
      code: '083375004128',
      label: 'Ühlingen-Birkendorf',
      provincie: 8,
      slug: 'uehlingen-birkendorf',
    },
    {
      code: '083375005049',
      label: 'Herrischried',
      provincie: 8,
      slug: 'herrischried',
    },
    {
      code: '083375005076',
      label: 'Murg',
      provincie: 8,
      slug: 'murg',
    },
    {
      code: '083375005090',
      label: 'Rickenbach',
      provincie: 8,
      slug: 'rickenbach',
    },
    {
      code: '083375005096',
      label: 'Bad Säckingen',
      provincie: 8,
      slug: 'bad-saeckingen',
    },
    {
      code: '083375006013',
      label: 'Bernau im Schwarzwald',
      provincie: 8,
      slug: 'bernau-im-schwarzwald',
    },
    {
      code: '083375006027',
      label: 'Dachsberg (Südschwarzwald)',
      provincie: 8,
      slug: 'dachsberg-suedschwarzwald',
    },
    {
      code: '083375006045',
      label: 'Häusern',
      provincie: 8,
      slug: 'haeusern',
    },
    {
      code: '083375006051',
      label: 'Höchenschwand',
      provincie: 8,
      slug: 'hoechenschwand',
    },
    {
      code: '083375006059',
      label: 'Ibach',
      provincie: 8,
      slug: 'ibach',
    },
    {
      code: '083375006097',
      label: 'St. Blasien',
      provincie: 8,
      slug: 'st-blasien',
    },
    {
      code: '083375006108',
      label: 'Todtmoos',
      provincie: 8,
      slug: 'todtmoos',
    },
    {
      code: '083375007032',
      label: 'Dogern',
      provincie: 8,
      slug: 'dogern',
    },
    {
      code: '083375007065',
      label: 'Lauchringen',
      provincie: 8,
      slug: 'lauchringen',
    },
    {
      code: '083375007118',
      label: 'Weilheim',
      provincie: 8,
      slug: 'weilheim',
    },
    {
      code: '083375007126',
      label: 'Waldshut-Tiengen',
      provincie: 8,
      slug: 'waldshut-tiengen',
    },
    {
      code: '083375008123',
      label: 'Wutöschingen',
      provincie: 8,
      slug: 'wutoeschingen',
    },
    {
      code: '083375008124',
      label: 'Eggingen',
      provincie: 8,
      slug: 'eggingen',
    },
    {
      code: '084150014014',
      label: 'Dettingen an der Erms',
      provincie: 8,
      slug: 'dettingen-an-der-erms',
    },
    {
      code: '084150019019',
      label: 'Eningen unter Achalm',
      provincie: 8,
      slug: 'eningen-unter-achalm',
    },
    {
      code: '084150059059',
      label: 'Pfullingen',
      provincie: 8,
      slug: 'pfullingen',
    },
    {
      code: '084150061061',
      label: 'Reutlingen',
      provincie: 8,
      slug: 'reutlingen',
    },
    {
      code: '084150073073',
      label: 'Trochtelfingen',
      provincie: 8,
      slug: 'trochtelfingen',
    },
    {
      code: '084150080080',
      label: 'Wannweil',
      provincie: 8,
      slug: 'wannweil',
    },
    {
      code: '084150091091',
      label: 'Sonnenbühl',
      provincie: 8,
      slug: 'sonnenbuehl',
    },
    {
      code: '084150092092',
      label: 'Lichtenstein',
      provincie: 8,
      slug: 'lichtenstein',
    },
    {
      code: '084150093093',
      label: 'St. Johann',
      provincie: 8,
      slug: 'st-johann',
    },
    {
      code: '084155001089',
      label: 'Engstingen',
      provincie: 8,
      slug: 'engstingen',
    },
    {
      code: '084155001090',
      label: 'Hohenstein',
      provincie: 8,
      slug: 'hohenstein-gemeinde',
    },
    {
      code: '084155002029',
      label: 'Grafenberg',
      provincie: 8,
      slug: 'grafenberg',
    },
    {
      code: '084155002050',
      label: 'Metzingen',
      provincie: 8,
      slug: 'metzingen',
    },
    {
      code: '084155002062',
      label: 'Riederich',
      provincie: 8,
      slug: 'riederich',
    },
    {
      code: '084155003027',
      label: 'Gomadingen',
      provincie: 8,
      slug: 'gomadingen',
    },
    {
      code: '084155003048',
      label: 'Mehrstetten',
      provincie: 8,
      slug: 'mehrstetten',
    },
    {
      code: '084155003053',
      label: 'Münsingen',
      provincie: 8,
      slug: 'muensingen',
    },
    {
      code: '084155004060',
      label: 'Pliezhausen',
      provincie: 8,
      slug: 'pliezhausen',
    },
    {
      code: '084155004087',
      label: 'Walddorfhäslach',
      provincie: 8,
      slug: 'walddorfhaeslach',
    },
    {
      code: '084155005028',
      label: 'Grabenstetten',
      provincie: 8,
      slug: 'grabenstetten',
    },
    {
      code: '084155005039',
      label: 'Hülben',
      provincie: 8,
      slug: 'huelben',
    },
    {
      code: '084155005078',
      label: 'Bad Urach',
      provincie: 8,
      slug: 'bad-urach',
    },
    {
      code: '084155005088',
      label: 'Römerstein',
      provincie: 8,
      slug: 'roemerstein',
    },
    {
      code: '084155006034',
      label: 'Hayingen',
      provincie: 8,
      slug: 'hayingen',
    },
    {
      code: '084155006058',
      label: 'Pfronstetten',
      provincie: 8,
      slug: 'pfronstetten',
    },
    {
      code: '084155006085',
      label: 'Zwiefalten',
      provincie: 8,
      slug: 'zwiefalten',
    },
    {
      code: '084160009009',
      label: 'Dettenhausen',
      provincie: 8,
      slug: 'dettenhausen',
    },
    {
      code: '084160022022',
      label: 'Kirchentellinsfurt',
      provincie: 8,
      slug: 'kirchentellinsfurt',
    },
    {
      code: '084160023023',
      label: 'Kusterdingen',
      provincie: 8,
      slug: 'kusterdingen',
    },
    {
      code: '084160041041',
      label: 'Tübingen',
      provincie: 8,
      slug: 'tuebingen',
    },
    {
      code: '084160048048',
      label: 'Ammerbuch',
      provincie: 8,
      slug: 'ammerbuch',
    },
    {
      code: '084165001011',
      label: 'Dußlingen',
      provincie: 8,
      slug: 'dusslingen',
    },
    {
      code: '084165001015',
      label: 'Gomaringen',
      provincie: 8,
      slug: 'gomaringen',
    },
    {
      code: '084165001026',
      label: 'Nehren',
      provincie: 8,
      slug: 'nehren-gemeinde',
    },
    {
      code: '084165002006',
      label: 'Bodelshausen',
      provincie: 8,
      slug: 'bodelshausen',
    },
    {
      code: '084165002025',
      label: 'Mössingen',
      provincie: 8,
      slug: 'moessingen',
    },
    {
      code: '084165002031',
      label: 'Ofterdingen',
      provincie: 8,
      slug: 'ofterdingen',
    },
    {
      code: '084165003018',
      label: 'Hirrlingen',
      provincie: 8,
      slug: 'hirrlingen',
    },
    {
      code: '084165003036',
      label: 'Rottenburg am Neckar',
      provincie: 8,
      slug: 'rottenburg-am-neckar',
    },
    {
      code: '084165003049',
      label: 'Neustetten',
      provincie: 8,
      slug: 'neustetten',
    },
    {
      code: '084165003050',
      label: 'Starzach',
      provincie: 8,
      slug: 'starzach',
    },
    {
      code: '084170013013',
      label: 'Burladingen',
      provincie: 8,
      slug: 'burladingen',
    },
    {
      code: '084170025025',
      label: 'Haigerloch',
      provincie: 8,
      slug: 'haigerloch',
    },
    {
      code: '084170054054',
      label: 'Rosenfeld',
      provincie: 8,
      slug: 'rosenfeld',
    },
    {
      code: '084175001010',
      label: 'Bitz',
      provincie: 8,
      slug: 'bitz',
    },
    {
      code: '084175001079',
      label: 'Albstadt',
      provincie: 8,
      slug: 'albstadt',
    },
    {
      code: '084175002002',
      label: 'Balingen',
      provincie: 8,
      slug: 'balingen',
    },
    {
      code: '084175002022',
      label: 'Geislingen',
      provincie: 8,
      slug: 'geislingen',
    },
    {
      code: '084175003008',
      label: 'Bisingen',
      provincie: 8,
      slug: 'bisingen',
    },
    {
      code: '084175003023',
      label: 'Grosselfingen',
      provincie: 8,
      slug: 'grosselfingen',
    },
    {
      code: '084175004031',
      label: 'Hechingen',
      provincie: 8,
      slug: 'hechingen',
    },
    {
      code: '084175004036',
      label: 'Jungingen',
      provincie: 8,
      slug: 'jungingen',
    },
    {
      code: '084175004051',
      label: 'Rangendingen',
      provincie: 8,
      slug: 'rangendingen',
    },
    {
      code: '084175005044',
      label: 'Meßstetten',
      provincie: 8,
      slug: 'messstetten',
    },
    {
      code: '084175005045',
      label: 'Nusplingen',
      provincie: 8,
      slug: 'nusplingen',
    },
    {
      code: '084175005047',
      label: 'Obernheim',
      provincie: 8,
      slug: 'obernheim',
    },
    {
      code: '084175006014',
      label: 'Dautmergen',
      provincie: 8,
      slug: 'dautmergen',
    },
    {
      code: '084175006015',
      label: 'Dormettingen',
      provincie: 8,
      slug: 'dormettingen',
    },
    {
      code: '084175006016',
      label: 'Dotternhausen',
      provincie: 8,
      slug: 'dotternhausen',
    },
    {
      code: '084175006029',
      label: 'Hausen am Tann',
      provincie: 8,
      slug: 'hausen-am-tann',
    },
    {
      code: '084175006052',
      label: 'Ratshausen',
      provincie: 8,
      slug: 'ratshausen',
    },
    {
      code: '084175006057',
      label: 'Schömberg',
      provincie: 8,
      slug: 'schoemberg-stadt',
    },
    {
      code: '084175006071',
      label: 'Weilen unter den Rinnen',
      provincie: 8,
      slug: 'weilen-unter-den-rinnen',
    },
    {
      code: '084175006078',
      label: 'Zimmern unter der Burg',
      provincie: 8,
      slug: 'zimmern-unter-der-burg',
    },
    {
      code: '084175007063',
      label: 'Straßberg',
      provincie: 8,
      slug: 'strassberg',
    },
    {
      code: '084175007075',
      label: 'Winterlingen',
      provincie: 8,
      slug: 'winterlingen',
    },
    {
      code: '084210000000',
      label: 'Ulm',
      provincie: 8,
      slug: 'ulm',
    },
    {
      code: '084250039039',
      label: 'Erbach',
      provincie: 8,
      slug: 'erbach-stadt',
    },
    {
      code: '084250108108',
      label: 'Schelklingen',
      provincie: 8,
      slug: 'schelklingen',
    },
    {
      code: '084250141141',
      label: 'Blaustein',
      provincie: 8,
      slug: 'blaustein',
    },
    {
      code: '084255001002',
      label: 'Allmendingen',
      provincie: 8,
      slug: 'allmendingen',
    },
    {
      code: '084255001004',
      label: 'Altheim',
      provincie: 8,
      slug: 'altheim',
    },
    {
      code: '084255002017',
      label: 'Berghülen',
      provincie: 8,
      slug: 'berghuelen',
    },
    {
      code: '084255002020',
      label: 'Blaubeuren',
      provincie: 8,
      slug: 'blaubeuren',
    },
    {
      code: '084255003028',
      label: 'Dietenheim',
      provincie: 8,
      slug: 'dietenheim',
    },
    {
      code: '084255003066',
      label: 'Illerrieden',
      provincie: 8,
      slug: 'illerrieden',
    },
    {
      code: '084255003140',
      label: 'Balzheim',
      provincie: 8,
      slug: 'balzheim',
    },
    {
      code: '084255004014',
      label: 'Beimerstetten',
      provincie: 8,
      slug: 'beimerstetten',
    },
    {
      code: '084255004031',
      label: 'Dornstadt',
      provincie: 8,
      slug: 'dornstadt',
    },
    {
      code: '084255004135',
      label: 'Westerstetten',
      provincie: 8,
      slug: 'westerstetten',
    },
    {
      code: '084255005033',
      label: 'Ehingen (Donau)',
      provincie: 8,
      slug: 'ehingen-donau',
    },
    {
      code: '084255005050',
      label: 'Griesingen',
      provincie: 8,
      slug: 'griesingen',
    },
    {
      code: '084255005088',
      label: 'Oberdischingen',
      provincie: 8,
      slug: 'oberdischingen',
    },
    {
      code: '084255005093',
      label: 'Öpfingen',
      provincie: 8,
      slug: 'oepfingen',
    },
    {
      code: '084255006064',
      label: 'Hüttisheim',
      provincie: 8,
      slug: 'huettisheim',
    },
    {
      code: '084255006110',
      label: 'Schnürpflingen',
      provincie: 8,
      slug: 'schnuerpflingen',
    },
    {
      code: '084255006137',
      label: 'Illerkirchberg',
      provincie: 8,
      slug: 'illerkirchberg',
    },
    {
      code: '084255006138',
      label: 'Staig',
      provincie: 8,
      slug: 'staig',
    },
    {
      code: '084255007071',
      label: 'Laichingen',
      provincie: 8,
      slug: 'laichingen',
    },
    {
      code: '084255007079',
      label: 'Merklingen',
      provincie: 8,
      slug: 'merklingen',
    },
    {
      code: '084255007084',
      label: 'Nellingen',
      provincie: 8,
      slug: 'nellingen',
    },
    {
      code: '084255007134',
      label: 'Westerheim',
      provincie: 8,
      slug: 'westerheim',
    },
    {
      code: '084255007139',
      label: 'Heroldstatt',
      provincie: 8,
      slug: 'heroldstatt',
    },
    {
      code: '084255008005',
      label: 'Altheim (Alb)',
      provincie: 8,
      slug: 'altheim-alb',
    },
    {
      code: '084255008011',
      label: 'Asselfingen',
      provincie: 8,
      slug: 'asselfingen',
    },
    {
      code: '084255008013',
      label: 'Ballendorf',
      provincie: 8,
      slug: 'ballendorf',
    },
    {
      code: '084255008019',
      label: 'Bernstadt',
      provincie: 8,
      slug: 'bernstadt',
    },
    {
      code: '084255008022',
      label: 'Börslingen',
      provincie: 8,
      slug: 'boerslingen',
    },
    {
      code: '084255008024',
      label: 'Breitingen',
      provincie: 8,
      slug: 'breitingen',
    },
    {
      code: '084255008062',
      label: 'Holzkirch',
      provincie: 8,
      slug: 'holzkirch',
    },
    {
      code: '084255008072',
      label: 'Langenau',
      provincie: 8,
      slug: 'langenau',
    },
    {
      code: '084255008083',
      label: 'Neenstetten',
      provincie: 8,
      slug: 'neenstetten',
    },
    {
      code: '084255008085',
      label: 'Nerenstetten',
      provincie: 8,
      slug: 'nerenstetten',
    },
    {
      code: '084255008092',
      label: 'Öllingen',
      provincie: 8,
      slug: 'oellingen',
    },
    {
      code: '084255008097',
      label: 'Rammingen',
      provincie: 8,
      slug: 'rammingen',
    },
    {
      code: '084255008112',
      label: 'Setzingen',
      provincie: 8,
      slug: 'setzingen',
    },
    {
      code: '084255008130',
      label: 'Weidenstetten',
      provincie: 8,
      slug: 'weidenstetten',
    },
    {
      code: '084255009008',
      label: 'Amstetten',
      provincie: 8,
      slug: 'amstetten',
    },
    {
      code: '084255009075',
      label: 'Lonsee',
      provincie: 8,
      slug: 'lonsee',
    },
    {
      code: '084255010035',
      label: 'Emeringen',
      provincie: 8,
      slug: 'emeringen',
    },
    {
      code: '084255010036',
      label: 'Emerkingen',
      provincie: 8,
      slug: 'emerkingen',
    },
    {
      code: '084255010052',
      label: 'Grundsheim',
      provincie: 8,
      slug: 'grundsheim',
    },
    {
      code: '084255010055',
      label: 'Hausen am Bussen',
      provincie: 8,
      slug: 'hausen-am-bussen',
    },
    {
      code: '084255010073',
      label: 'Lauterach',
      provincie: 8,
      slug: 'lauterach',
    },
    {
      code: '084255010081',
      label: 'Munderkingen',
      provincie: 8,
      slug: 'munderkingen',
    },
    {
      code: '084255010090',
      label: 'Obermarchtal',
      provincie: 8,
      slug: 'obermarchtal',
    },
    {
      code: '084255010091',
      label: 'Oberstadion',
      provincie: 8,
      slug: 'oberstadion',
    },
    {
      code: '084255010098',
      label: 'Rechtenstein',
      provincie: 8,
      slug: 'rechtenstein',
    },
    {
      code: '084255010104',
      label: 'Rottenacker',
      provincie: 8,
      slug: 'rottenacker',
    },
    {
      code: '084255010123',
      label: 'Untermarchtal',
      provincie: 8,
      slug: 'untermarchtal',
    },
    {
      code: '084255010124',
      label: 'Unterstadion',
      provincie: 8,
      slug: 'unterstadion',
    },
    {
      code: '084255010125',
      label: 'Unterwachingen',
      provincie: 8,
      slug: 'unterwachingen',
    },
    {
      code: '084260134134',
      label: 'Schemmerhofen',
      provincie: 8,
      slug: 'schemmerhofen',
    },
    {
      code: '084265001005',
      label: 'Alleshausen',
      provincie: 8,
      slug: 'alleshausen',
    },
    {
      code: '084265001006',
      label: 'Allmannsweiler',
      provincie: 8,
      slug: 'allmannsweiler',
    },
    {
      code: '084265001013',
      label: 'Bad Buchau',
      provincie: 8,
      slug: 'bad-buchau',
    },
    {
      code: '084265001020',
      label: 'Betzenweiler',
      provincie: 8,
      slug: 'betzenweiler',
    },
    {
      code: '084265001036',
      label: 'Dürnau',
      provincie: 8,
      slug: 'duernau-gemeinde',
    },
    {
      code: '084265001064',
      label: 'Kanzach',
      provincie: 8,
      slug: 'kanzach',
    },
    {
      code: '084265001078',
      label: 'Moosburg',
      provincie: 8,
      slug: 'moosburg',
    },
    {
      code: '084265001090',
      label: 'Oggelshausen',
      provincie: 8,
      slug: 'oggelshausen',
    },
    {
      code: '084265001109',
      label: 'Seekirch',
      provincie: 8,
      slug: 'seekirch',
    },
    {
      code: '084265001118',
      label: 'Tiefenbach',
      provincie: 8,
      slug: 'tiefenbach-gemeinde',
    },
    {
      code: '084265002014',
      label: 'Bad Schussenried',
      provincie: 8,
      slug: 'bad-schussenried',
    },
    {
      code: '084265002062',
      label: 'Ingoldingen',
      provincie: 8,
      slug: 'ingoldingen',
    },
    {
      code: '084265003011',
      label: 'Attenweiler',
      provincie: 8,
      slug: 'attenweiler',
    },
    {
      code: '084265003021',
      label: 'Biberach an der Riß',
      provincie: 8,
      slug: 'biberach-an-der-riss',
    },
    {
      code: '084265003038',
      label: 'Eberhardzell',
      provincie: 8,
      slug: 'eberhardzell',
    },
    {
      code: '084265003058',
      label: 'Hochdorf',
      provincie: 8,
      slug: 'hochdorf-gemeinde',
    },
    {
      code: '084265003071',
      label: 'Maselheim',
      provincie: 8,
      slug: 'maselheim',
    },
    {
      code: '084265003074',
      label: 'Mittelbiberach',
      provincie: 8,
      slug: 'mittelbiberach',
    },
    {
      code: '084265003120',
      label: 'Ummendorf',
      provincie: 8,
      slug: 'ummendorf',
    },
    {
      code: '084265003128',
      label: 'Warthausen',
      provincie: 8,
      slug: 'warthausen',
    },
    {
      code: '084265004019',
      label: 'Berkheim',
      provincie: 8,
      slug: 'berkheim',
    },
    {
      code: '084265004031',
      label: 'Dettingen an der Iller',
      provincie: 8,
      slug: 'dettingen-an-der-iller',
    },
    {
      code: '084265004044',
      label: 'Erolzheim',
      provincie: 8,
      slug: 'erolzheim',
    },
    {
      code: '084265004065',
      label: 'Kirchberg an der Iller',
      provincie: 8,
      slug: 'kirchberg-an-der-iller',
    },
    {
      code: '084265004066',
      label: 'Kirchdorf an der Iller',
      provincie: 8,
      slug: 'kirchdorf-an-der-iller',
    },
    {
      code: '084265005001',
      label: 'Achstetten',
      provincie: 8,
      slug: 'achstetten',
    },
    {
      code: '084265005028',
      label: 'Burgrieden',
      provincie: 8,
      slug: 'burgrieden',
    },
    {
      code: '084265005070',
      label: 'Laupheim',
      provincie: 8,
      slug: 'laupheim',
    },
    {
      code: '084265005073',
      label: 'Mietingen',
      provincie: 8,
      slug: 'mietingen',
    },
    {
      code: '084265006043',
      label: 'Erlenmoos',
      provincie: 8,
      slug: 'erlenmoos',
    },
    {
      code: '084265006087',
      label: 'Ochsenhausen',
      provincie: 8,
      slug: 'ochsenhausen',
    },
    {
      code: '084265006113',
      label: 'Steinhausen an der Rottum',
      provincie: 8,
      slug: 'steinhausen-an-der-rottum',
    },
    {
      code: '084265006135',
      label: 'Gutenzell-Hürbel',
      provincie: 8,
      slug: 'gutenzell-huerbel',
    },
    {
      code: '084265007008',
      label: 'Altheim',
      provincie: 8,
      slug: 'altheim-gemeinde',
    },
    {
      code: '084265007035',
      label: 'Dürmentingen',
      provincie: 8,
      slug: 'duermentingen',
    },
    {
      code: '084265007045',
      label: 'Ertingen',
      provincie: 8,
      slug: 'ertingen',
    },
    {
      code: '084265007067',
      label: 'Langenenslingen',
      provincie: 8,
      slug: 'langenenslingen',
    },
    {
      code: '084265007097',
      label: 'Riedlingen',
      provincie: 8,
      slug: 'riedlingen',
    },
    {
      code: '084265007121',
      label: 'Unlingen',
      provincie: 8,
      slug: 'unlingen',
    },
    {
      code: '084265007124',
      label: 'Uttenweiler',
      provincie: 8,
      slug: 'uttenweiler',
    },
    {
      code: '084265008100',
      label: 'Rot an der Rot',
      provincie: 8,
      slug: 'rot-an-der-rot',
    },
    {
      code: '084265008117',
      label: 'Tannheim',
      provincie: 8,
      slug: 'tannheim',
    },
    {
      code: '084265009108',
      label: 'Schwendi',
      provincie: 8,
      slug: 'schwendi',
    },
    {
      code: '084265009125',
      label: 'Wain',
      provincie: 8,
      slug: 'wain',
    },
    {
      code: '084350035035',
      label: 'Meckenbeuren',
      provincie: 8,
      slug: 'meckenbeuren',
    },
    {
      code: '084355001013',
      label: 'Eriskirch',
      provincie: 8,
      slug: 'eriskirch',
    },
    {
      code: '084355001029',
      label: 'Kressbronn am Bodensee',
      provincie: 8,
      slug: 'kressbronn-am-bodensee',
    },
    {
      code: '084355001030',
      label: 'Langenargen',
      provincie: 8,
      slug: 'langenargen',
    },
    {
      code: '084355002016',
      label: 'Friedrichshafen',
      provincie: 8,
      slug: 'friedrichshafen',
    },
    {
      code: '084355002024',
      label: 'Immenstaad am Bodensee',
      provincie: 8,
      slug: 'immenstaad-am-bodensee',
    },
    {
      code: '084355003005',
      label: 'Bermatingen',
      provincie: 8,
      slug: 'bermatingen',
    },
    {
      code: '084355003034',
      label: 'Markdorf',
      provincie: 8,
      slug: 'markdorf',
    },
    {
      code: '084355003045',
      label: 'Oberteuringen',
      provincie: 8,
      slug: 'oberteuringen',
    },
    {
      code: '084355003067',
      label: 'Deggenhausertal',
      provincie: 8,
      slug: 'deggenhausertal',
    },
    {
      code: '084355004010',
      label: 'Daisendorf',
      provincie: 8,
      slug: 'daisendorf',
    },
    {
      code: '084355004018',
      label: 'Hagnau am Bodensee',
      provincie: 8,
      slug: 'hagnau-am-bodensee',
    },
    {
      code: '084355004036',
      label: 'Meersburg',
      provincie: 8,
      slug: 'meersburg',
    },
    {
      code: '084355004054',
      label: 'Stetten',
      provincie: 8,
      slug: 'stetten-gemeinde',
    },
    {
      code: '084355004066',
      label: 'Uhldingen-Mühlhofen',
      provincie: 8,
      slug: 'uhldingen-muehlhofen',
    },
    {
      code: '084355005015',
      label: 'Frickingen',
      provincie: 8,
      slug: 'frickingen',
    },
    {
      code: '084355005020',
      label: 'Heiligenberg',
      provincie: 8,
      slug: 'heiligenberg',
    },
    {
      code: '084355005052',
      label: 'Salem',
      provincie: 8,
      slug: 'salem-gemeinde',
    },
    {
      code: '084355006042',
      label: 'Neukirch',
      provincie: 8,
      slug: 'neukirch',
    },
    {
      code: '084355006057',
      label: 'Tettnang',
      provincie: 8,
      slug: 'tettnang',
    },
    {
      code: '084355007047',
      label: 'Owingen',
      provincie: 8,
      slug: 'owingen',
    },
    {
      code: '084355007053',
      label: 'Sipplingen',
      provincie: 8,
      slug: 'sipplingen',
    },
    {
      code: '084355007059',
      label: 'Überlingen',
      provincie: 8,
      slug: 'ueberlingen',
    },
    {
      code: '084360008008',
      label: 'Aulendorf',
      provincie: 8,
      slug: 'aulendorf',
    },
    {
      code: '084360010010',
      label: 'Bad Wurzach',
      provincie: 8,
      slug: 'bad-wurzach',
    },
    {
      code: '084360049049',
      label: 'Isny im Allgäu',
      provincie: 8,
      slug: 'isny-im-allgaeu',
    },
    {
      code: '084360052052',
      label: 'Kißlegg',
      provincie: 8,
      slug: 'kisslegg',
    },
    {
      code: '084360094094',
      label: 'Argenbühl',
      provincie: 8,
      slug: 'argenbuehl',
    },
    {
      code: '084365001005',
      label: 'Altshausen',
      provincie: 8,
      slug: 'altshausen',
    },
    {
      code: '084365001019',
      label: 'Boms',
      provincie: 8,
      slug: 'boms',
    },
    {
      code: '084365001024',
      label: 'Ebenweiler',
      provincie: 8,
      slug: 'ebenweiler',
    },
    {
      code: '084365001027',
      label: 'Eichstegen',
      provincie: 8,
      slug: 'eichstegen',
    },
    {
      code: '084365001032',
      label: 'Fleischwangen',
      provincie: 8,
      slug: 'fleischwangen',
    },
    {
      code: '084365001040',
      label: 'Guggenhausen',
      provincie: 8,
      slug: 'guggenhausen',
    },
    {
      code: '084365001047',
      label: 'Hoßkirch',
      provincie: 8,
      slug: 'hosskirch',
    },
    {
      code: '084365001053',
      label: 'Königseggwald',
      provincie: 8,
      slug: 'koenigseggwald',
    },
    {
      code: '084365001067',
      label: 'Riedhausen',
      provincie: 8,
      slug: 'riedhausen',
    },
    {
      code: '084365001077',
      label: 'Unterwaldhausen',
      provincie: 8,
      slug: 'unterwaldhausen',
    },
    {
      code: '084365001093',
      label: 'Ebersbach-Musbach',
      provincie: 8,
      slug: 'ebersbach-musbach',
    },
    {
      code: '084365002009',
      label: 'Bad Waldsee',
      provincie: 8,
      slug: 'bad-waldsee',
    },
    {
      code: '084365002014',
      label: 'Bergatreute',
      provincie: 8,
      slug: 'bergatreute',
    },
    {
      code: '084365003018',
      label: 'Bodnegg',
      provincie: 8,
      slug: 'bodnegg',
    },
    {
      code: '084365003039',
      label: 'Grünkraut',
      provincie: 8,
      slug: 'gruenkraut',
    },
    {
      code: '084365003069',
      label: 'Schlier',
      provincie: 8,
      slug: 'schlier',
    },
    {
      code: '084365003079',
      label: 'Waldburg',
      provincie: 8,
      slug: 'waldburg',
    },
    {
      code: '084365004003',
      label: 'Aichstetten',
      provincie: 8,
      slug: 'aichstetten',
    },
    {
      code: '084365004004',
      label: 'Aitrach',
      provincie: 8,
      slug: 'aitrach',
    },
    {
      code: '084365004055',
      label: 'Leutkirch im Allgäu',
      provincie: 8,
      slug: 'leutkirch-im-allgaeu',
    },
    {
      code: '084365005011',
      label: 'Baienfurt',
      provincie: 8,
      slug: 'baienfurt',
    },
    {
      code: '084365005012',
      label: 'Baindt',
      provincie: 8,
      slug: 'baindt',
    },
    {
      code: '084365005013',
      label: 'Berg',
      provincie: 8,
      slug: 'berg-gemeinde',
    },
    {
      code: '084365005064',
      label: 'Ravensburg',
      provincie: 8,
      slug: 'ravensburg',
    },
    {
      code: '084365005082',
      label: 'Weingarten',
      provincie: 8,
      slug: 'weingarten',
    },
    {
      code: '084365006078',
      label: 'Vogt',
      provincie: 8,
      slug: 'vogt',
    },
    {
      code: '084365006085',
      label: 'Wolfegg',
      provincie: 8,
      slug: 'wolfegg',
    },
    {
      code: '084365007001',
      label: 'Achberg',
      provincie: 8,
      slug: 'achberg',
    },
    {
      code: '084365007006',
      label: 'Amtzell',
      provincie: 8,
      slug: 'amtzell',
    },
    {
      code: '084365007081',
      label: 'Wangen im Allgäu',
      provincie: 8,
      slug: 'wangen-im-allgaeu',
    },
    {
      code: '084365008083',
      label: 'Wilhelmsdorf',
      provincie: 8,
      slug: 'wilhelmsdorf',
    },
    {
      code: '084365008095',
      label: 'Horgenzell',
      provincie: 8,
      slug: 'horgenzell',
    },
    {
      code: '084365009087',
      label: 'Wolpertswende',
      provincie: 8,
      slug: 'wolpertswende',
    },
    {
      code: '084365009096',
      label: 'Fronreute',
      provincie: 8,
      slug: 'fronreute',
    },
    {
      code: '084370086086',
      label: 'Ostrach',
      provincie: 8,
      slug: 'ostrach',
    },
    {
      code: '084375001031',
      label: 'Gammertingen',
      provincie: 8,
      slug: 'gammertingen',
    },
    {
      code: '084375001047',
      label: 'Hettingen',
      provincie: 8,
      slug: 'hettingen',
    },
    {
      code: '084375001082',
      label: 'Neufra',
      provincie: 8,
      slug: 'neufra',
    },
    {
      code: '084375001114',
      label: 'Veringenstadt',
      provincie: 8,
      slug: 'veringenstadt',
    },
    {
      code: '084375002053',
      label: 'Hohentengen',
      provincie: 8,
      slug: 'hohentengen',
    },
    {
      code: '084375002076',
      label: 'Mengen',
      provincie: 8,
      slug: 'mengen',
    },
    {
      code: '084375002101',
      label: 'Scheer',
      provincie: 8,
      slug: 'scheer',
    },
    {
      code: '084375003072',
      label: 'Leibertingen',
      provincie: 8,
      slug: 'leibertingen',
    },
    {
      code: '084375003078',
      label: 'Meßkirch',
      provincie: 8,
      slug: 'messkirch',
    },
    {
      code: '084375003123',
      label: 'Sauldorf',
      provincie: 8,
      slug: 'sauldorf',
    },
    {
      code: '084375004056',
      label: 'Illmensee',
      provincie: 8,
      slug: 'illmensee',
    },
    {
      code: '084375004088',
      label: 'Pfullendorf',
      provincie: 8,
      slug: 'pfullendorf',
    },
    {
      code: '084375004118',
      label: 'Wald',
      provincie: 8,
      slug: 'wald',
    },
    {
      code: '084375004124',
      label: 'Herdwangen-Schönach',
      provincie: 8,
      slug: 'herdwangen-schoenach',
    },
    {
      code: '084375005044',
      label: 'Herbertingen',
      provincie: 8,
      slug: 'herbertingen',
    },
    {
      code: '084375005100',
      label: 'Bad Saulgau',
      provincie: 8,
      slug: 'bad-saulgau',
    },
    {
      code: '084375006005',
      label: 'Beuron',
      provincie: 8,
      slug: 'beuron',
    },
    {
      code: '084375006008',
      label: 'Bingen',
      provincie: 8,
      slug: 'bingen',
    },
    {
      code: '084375006059',
      label: 'Inzigkofen',
      provincie: 8,
      slug: 'inzigkofen',
    },
    {
      code: '084375006065',
      label: 'Krauchenwies',
      provincie: 8,
      slug: 'krauchenwies',
    },
    {
      code: '084375006104',
      label: 'Sigmaringen',
      provincie: 8,
      slug: 'sigmaringen',
    },
    {
      code: '084375006105',
      label: 'Sigmaringendorf',
      provincie: 8,
      slug: 'sigmaringendorf',
    },
    {
      code: '084375007102',
      label: 'Schwenningen',
      provincie: 8,
      slug: 'schwenningen',
    },
    {
      code: '084375007107',
      label: 'Stetten am kalten Markt',
      provincie: 8,
      slug: 'stetten-am-kalten-markt',
    },
    {
      code: '091610000000',
      label: 'Ingolstadt',
      provincie: 9,
      slug: 'ingolstadt',
    },
    {
      code: '091620000000',
      label: 'München',
      provincie: 9,
      slug: 'muenchen',
    },
    {
      code: '091630000000',
      label: 'Rosenheim',
      provincie: 9,
      slug: 'rosenheim',
    },
    {
      code: '091710111111',
      label: 'Altötting',
      provincie: 9,
      slug: 'altoetting',
    },
    {
      code: '091710112112',
      label: 'Burghausen',
      provincie: 9,
      slug: 'burghausen',
    },
    {
      code: '091710113113',
      label: 'Burgkirchen a.d.Alz',
      provincie: 9,
      slug: 'burgkirchen-a-d-alz',
    },
    {
      code: '091710117117',
      label: 'Garching a.d.Alz',
      provincie: 9,
      slug: 'garching-a-d-alz',
    },
    {
      code: '091710118118',
      label: 'Haiming',
      provincie: 9,
      slug: 'haiming',
    },
    {
      code: '091710125125',
      label: 'Neuötting',
      provincie: 9,
      slug: 'neuoetting',
    },
    {
      code: '091710127127',
      label: 'Pleiskirchen',
      provincie: 9,
      slug: 'pleiskirchen',
    },
    {
      code: '091710131131',
      label: 'Teising',
      provincie: 9,
      slug: 'teising',
    },
    {
      code: '091710132132',
      label: 'Töging a.Inn',
      provincie: 9,
      slug: 'toeging-a-inn',
    },
    {
      code: '091710133133',
      label: 'Tüßling',
      provincie: 9,
      slug: 'tuessling',
    },
    {
      code: '091710137137',
      label: 'Winhöring',
      provincie: 9,
      slug: 'winhoering',
    },
    {
      code: '091715101114',
      label: 'Emmerting',
      provincie: 9,
      slug: 'emmerting',
    },
    {
      code: '091715101124',
      label: 'Mehring',
      provincie: 9,
      slug: 'mehring-gemeinde',
    },
    {
      code: '091715102116',
      label: 'Feichten a.d.Alz',
      provincie: 9,
      slug: 'feichten-a-d-alz',
    },
    {
      code: '091715102119',
      label: 'Halsbach',
      provincie: 9,
      slug: 'halsbach',
    },
    {
      code: '091715102122',
      label: 'Kirchweidach',
      provincie: 9,
      slug: 'kirchweidach',
    },
    {
      code: '091715102134',
      label: 'Tyrlaching',
      provincie: 9,
      slug: 'tyrlaching',
    },
    {
      code: '091715103123',
      label: 'Marktl',
      provincie: 9,
      slug: 'marktl',
    },
    {
      code: '091715103130',
      label: 'Stammham',
      provincie: 9,
      slug: 'stammham',
    },
    {
      code: '091715104115',
      label: 'Erlbach',
      provincie: 9,
      slug: 'erlbach',
    },
    {
      code: '091715104126',
      label: 'Perach',
      provincie: 9,
      slug: 'perach',
    },
    {
      code: '091715104129',
      label: 'Reischach',
      provincie: 9,
      slug: 'reischach',
    },
    {
      code: '091715106121',
      label: 'Kastl',
      provincie: 9,
      slug: 'kastl',
    },
    {
      code: '091715106135',
      label: 'Unterneukirchen',
      provincie: 9,
      slug: 'unterneukirchen',
    },
    {
      code: '091720111111',
      label: 'Ainring',
      provincie: 9,
      slug: 'ainring',
    },
    {
      code: '091720112112',
      label: 'Anger',
      provincie: 9,
      slug: 'anger',
    },
    {
      code: '091720114114',
      label: 'Bad Reichenhall',
      provincie: 9,
      slug: 'bad-reichenhall',
    },
    {
      code: '091720115115',
      label: 'Bayerisch Gmain',
      provincie: 9,
      slug: 'bayerisch-gmain',
    },
    {
      code: '091720116116',
      label: 'Berchtesgaden',
      provincie: 9,
      slug: 'berchtesgaden',
    },
    {
      code: '091720117117',
      label: 'Bischofswiesen',
      provincie: 9,
      slug: 'bischofswiesen',
    },
    {
      code: '091720118118',
      label: 'Freilassing',
      provincie: 9,
      slug: 'freilassing',
    },
    {
      code: '091720122122',
      label: 'Laufen',
      provincie: 9,
      slug: 'laufen',
    },
    {
      code: '091720124124',
      label: 'Marktschellenberg',
      provincie: 9,
      slug: 'marktschellenberg',
    },
    {
      code: '091720128128',
      label: 'Piding',
      provincie: 9,
      slug: 'piding',
    },
    {
      code: '091720129129',
      label: 'Ramsau b.Berchtesgaden',
      provincie: 9,
      slug: 'ramsau-b-berchtesgaden',
    },
    {
      code: '091720130130',
      label: 'Saaldorf-Surheim',
      provincie: 9,
      slug: 'saaldorf-surheim',
    },
    {
      code: '091720131131',
      label: 'Schneizlreuth',
      provincie: 9,
      slug: 'schneizlreuth',
    },
    {
      code: '091720132132',
      label: 'Schönau a.Königssee',
      provincie: 9,
      slug: 'schoenau-a-koenigssee',
    },
    {
      code: '091720134134',
      label: 'Teisendorf',
      provincie: 9,
      slug: 'teisendorf',
    },
    {
      code: '091730111111',
      label: 'Bad Heilbrunn',
      provincie: 9,
      slug: 'bad-heilbrunn',
    },
    {
      code: '091730112112',
      label: 'Bad Tölz',
      provincie: 9,
      slug: 'bad-toelz',
    },
    {
      code: '091730118118',
      label: 'Dietramszell',
      provincie: 9,
      slug: 'dietramszell',
    },
    {
      code: '091730120120',
      label: 'Egling',
      provincie: 9,
      slug: 'egling',
    },
    {
      code: '091730123123',
      label: 'Eurasburg',
      provincie: 9,
      slug: 'eurasburg',
    },
    {
      code: '091730124124',
      label: 'Gaißach',
      provincie: 9,
      slug: 'gaissach',
    },
    {
      code: '091730126126',
      label: 'Geretsried',
      provincie: 9,
      slug: 'geretsried',
    },
    {
      code: '091730130130',
      label: 'Icking',
      provincie: 9,
      slug: 'icking',
    },
    {
      code: '091730131131',
      label: 'Jachenau',
      provincie: 9,
      slug: 'jachenau',
    },
    {
      code: '091730134134',
      label: 'Königsdorf',
      provincie: 9,
      slug: 'koenigsdorf',
    },
    {
      code: '091730135135',
      label: 'Lenggries',
      provincie: 9,
      slug: 'lenggries',
    },
    {
      code: '091730137137',
      label: 'Münsing',
      provincie: 9,
      slug: 'muensing',
    },
    {
      code: '091730145145',
      label: 'Wackersberg',
      provincie: 9,
      slug: 'wackersberg',
    },
    {
      code: '091730147147',
      label: 'Wolfratshausen',
      provincie: 9,
      slug: 'wolfratshausen',
    },
    {
      code: '091735107113',
      label: 'Benediktbeuern',
      provincie: 9,
      slug: 'benediktbeuern',
    },
    {
      code: '091735107115',
      label: 'Bichl',
      provincie: 9,
      slug: 'bichl',
    },
    {
      code: '091735108133',
      label: 'Kochel a.See',
      provincie: 9,
      slug: 'kochel-a-see',
    },
    {
      code: '091735108142',
      label: 'Schlehdorf',
      provincie: 9,
      slug: 'schlehdorf',
    },
    {
      code: '091735109127',
      label: 'Greiling',
      provincie: 9,
      slug: 'greiling',
    },
    {
      code: '091735109140',
      label: 'Reichersbeuern',
      provincie: 9,
      slug: 'reichersbeuern',
    },
    {
      code: '091735109141',
      label: 'Sachsenkam',
      provincie: 9,
      slug: 'sachsenkam',
    },
    {
      code: '091740111111',
      label: 'Altomünster',
      provincie: 9,
      slug: 'altomuenster',
    },
    {
      code: '091740113113',
      label: 'Bergkirchen',
      provincie: 9,
      slug: 'bergkirchen',
    },
    {
      code: '091740115115',
      label: 'Dachau',
      provincie: 9,
      slug: 'dachau',
    },
    {
      code: '091740118118',
      label: 'Erdweg',
      provincie: 9,
      slug: 'erdweg',
    },
    {
      code: '091740121121',
      label: 'Haimhausen',
      provincie: 9,
      slug: 'haimhausen',
    },
    {
      code: '091740122122',
      label: 'Hebertshausen',
      provincie: 9,
      slug: 'hebertshausen',
    },
    {
      code: '091740126126',
      label: 'Karlsfeld',
      provincie: 9,
      slug: 'karlsfeld',
    },
    {
      code: '091740131131',
      label: 'Markt Indersdorf',
      provincie: 9,
      slug: 'markt-indersdorf',
    },
    {
      code: '091740135135',
      label: 'Odelzhausen',
      provincie: 9,
      slug: 'odelzhausen',
    },
    {
      code: '091740136136',
      label: 'Petershausen',
      provincie: 9,
      slug: 'petershausen',
    },
    {
      code: '091740137137',
      label: 'Pfaffenhofen a.d.Glonn',
      provincie: 9,
      slug: 'pfaffenhofen-a-d-glonn',
    },
    {
      code: '091740141141',
      label: 'Röhrmoos',
      provincie: 9,
      slug: 'roehrmoos',
    },
    {
      code: '091740143143',
      label: 'Schwabhausen',
      provincie: 9,
      slug: 'schwabhausen',
    },
    {
      code: '091740146146',
      label: 'Sulzemoos',
      provincie: 9,
      slug: 'sulzemoos',
    },
    {
      code: '091740147147',
      label: 'Hilgertshausen-Tandern',
      provincie: 9,
      slug: 'hilgertshausen-tandern',
    },
    {
      code: '091740150150',
      label: 'Vierkirchen',
      provincie: 9,
      slug: 'vierkirchen',
    },
    {
      code: '091740151151',
      label: 'Weichs',
      provincie: 9,
      slug: 'weichs',
    },
    {
      code: '091750111111',
      label: 'Anzing',
      provincie: 9,
      slug: 'anzing',
    },
    {
      code: '091750115115',
      label: 'Ebersberg',
      provincie: 9,
      slug: 'ebersberg',
    },
    {
      code: '091750118118',
      label: 'Forstinning',
      provincie: 9,
      slug: 'forstinning',
    },
    {
      code: '091750122122',
      label: 'Grafing b.München',
      provincie: 9,
      slug: 'grafing-b-muenchen',
    },
    {
      code: '091750123123',
      label: 'Hohenlinden',
      provincie: 9,
      slug: 'hohenlinden',
    },
    {
      code: '091750124124',
      label: 'Kirchseeon',
      provincie: 9,
      slug: 'kirchseeon',
    },
    {
      code: '091750127127',
      label: 'Markt Schwaben',
      provincie: 9,
      slug: 'markt-schwaben',
    },
    {
      code: '091750132132',
      label: 'Vaterstetten',
      provincie: 9,
      slug: 'vaterstetten',
    },
    {
      code: '091750133133',
      label: 'Pliening',
      provincie: 9,
      slug: 'pliening',
    },
    {
      code: '091750135135',
      label: 'Poing',
      provincie: 9,
      slug: 'poing',
    },
    {
      code: '091750137137',
      label: 'Steinhöring',
      provincie: 9,
      slug: 'steinhoering',
    },
    {
      code: '091750139139',
      label: 'Zorneding',
      provincie: 9,
      slug: 'zorneding',
    },
    {
      code: '091755112112',
      label: 'Aßling',
      provincie: 9,
      slug: 'assling',
    },
    {
      code: '091755112119',
      label: 'Frauenneuharting',
      provincie: 9,
      slug: 'frauenneuharting',
    },
    {
      code: '091755112136',
      label: 'Emmering',
      provincie: 9,
      slug: 'emmering',
    },
    {
      code: '091755114113',
      label: 'Baiern',
      provincie: 9,
      slug: 'baiern',
    },
    {
      code: '091755114114',
      label: 'Bruck',
      provincie: 9,
      slug: 'bruck',
    },
    {
      code: '091755114116',
      label: 'Egmating',
      provincie: 9,
      slug: 'egmating',
    },
    {
      code: '091755114121',
      label: 'Glonn',
      provincie: 9,
      slug: 'glonn',
    },
    {
      code: '091755114128',
      label: 'Moosach',
      provincie: 9,
      slug: 'moosach',
    },
    {
      code: '091755114131',
      label: 'Oberpframmern',
      provincie: 9,
      slug: 'oberpframmern',
    },
    {
      code: '091760112112',
      label: 'Altmannstein',
      provincie: 9,
      slug: 'altmannstein',
    },
    {
      code: '091760114114',
      label: 'Beilngries',
      provincie: 9,
      slug: 'beilngries',
    },
    {
      code: '091760118118',
      label: 'Buxheim',
      provincie: 9,
      slug: 'buxheim',
    },
    {
      code: '091760120120',
      label: 'Denkendorf',
      provincie: 9,
      slug: 'denkendorf-gemeinde',
    },
    {
      code: '091760121121',
      label: 'Dollnstein',
      provincie: 9,
      slug: 'dollnstein',
    },
    {
      code: '091760123123',
      label: 'Eichstätt',
      provincie: 9,
      slug: 'eichstaett',
    },
    {
      code: '091760126126',
      label: 'Gaimersheim',
      provincie: 9,
      slug: 'gaimersheim',
    },
    {
      code: '091760129129',
      label: 'Großmehring',
      provincie: 9,
      slug: 'grossmehring',
    },
    {
      code: '091760131131',
      label: 'Hepberg',
      provincie: 9,
      slug: 'hepberg',
    },
    {
      code: '091760132132',
      label: 'Hitzhofen',
      provincie: 9,
      slug: 'hitzhofen',
    },
    {
      code: '091760137137',
      label: 'Kinding',
      provincie: 9,
      slug: 'kinding',
    },
    {
      code: '091760138138',
      label: 'Kipfenberg',
      provincie: 9,
      slug: 'kipfenberg',
    },
    {
      code: '091760139139',
      label: 'Kösching',
      provincie: 9,
      slug: 'koesching',
    },
    {
      code: '091760143143',
      label: 'Lenting',
      provincie: 9,
      slug: 'lenting',
    },
    {
      code: '091760148148',
      label: 'Mörnsheim',
      provincie: 9,
      slug: 'moernsheim',
    },
    {
      code: '091760161161',
      label: 'Stammham',
      provincie: 9,
      slug: 'stammham-gemeinde',
    },
    {
      code: '091760164164',
      label: 'Titting',
      provincie: 9,
      slug: 'titting',
    },
    {
      code: '091760166166',
      label: 'Wellheim',
      provincie: 9,
      slug: 'wellheim',
    },
    {
      code: '091760167167',
      label: 'Wettstetten',
      provincie: 9,
      slug: 'wettstetten',
    },
    {
      code: '091765115155',
      label: 'Pollenfeld',
      provincie: 9,
      slug: 'pollenfeld',
    },
    {
      code: '091765115160',
      label: 'Schernfeld',
      provincie: 9,
      slug: 'schernfeld',
    },
    {
      code: '091765115165',
      label: 'Walting',
      provincie: 9,
      slug: 'walting',
    },
    {
      code: '091765116116',
      label: 'Böhmfeld',
      provincie: 9,
      slug: 'boehmfeld',
    },
    {
      code: '091765116124',
      label: 'Eitensheim',
      provincie: 9,
      slug: 'eitensheim',
    },
    {
      code: '091765118111',
      label: 'Adelschlag',
      provincie: 9,
      slug: 'adelschlag',
    },
    {
      code: '091765118122',
      label: 'Egweil',
      provincie: 9,
      slug: 'egweil',
    },
    {
      code: '091765118149',
      label: 'Nassenfels',
      provincie: 9,
      slug: 'nassenfels',
    },
    {
      code: '091765119147',
      label: 'Mindelstetten',
      provincie: 9,
      slug: 'mindelstetten',
    },
    {
      code: '091765119150',
      label: 'Oberdolling',
      provincie: 9,
      slug: 'oberdolling',
    },
    {
      code: '091765119153',
      label: 'Pförring',
      provincie: 9,
      slug: 'pfoerring',
    },
    {
      code: '091770113113',
      label: 'Bockhorn',
      provincie: 9,
      slug: 'bockhorn-gemeinde',
    },
    {
      code: '091770115115',
      label: 'Dorfen',
      provincie: 9,
      slug: 'dorfen',
    },
    {
      code: '091770117117',
      label: 'Erding',
      provincie: 9,
      slug: 'erding',
    },
    {
      code: '091770118118',
      label: 'Finsing',
      provincie: 9,
      slug: 'finsing',
    },
    {
      code: '091770119119',
      label: 'Forstern',
      provincie: 9,
      slug: 'forstern',
    },
    {
      code: '091770120120',
      label: 'Fraunberg',
      provincie: 9,
      slug: 'fraunberg',
    },
    {
      code: '091770123123',
      label: 'Isen',
      provincie: 9,
      slug: 'isen',
    },
    {
      code: '091770127127',
      label: 'Lengdorf',
      provincie: 9,
      slug: 'lengdorf',
    },
    {
      code: '091770130130',
      label: 'Moosinning',
      provincie: 9,
      slug: 'moosinning',
    },
    {
      code: '091770137137',
      label: 'Sankt Wolfgang',
      provincie: 9,
      slug: 'sankt-wolfgang',
    },
    {
      code: '091770139139',
      label: 'Taufkirchen (Vils)',
      provincie: 9,
      slug: 'taufkirchen-vils',
    },
    {
      code: '091775120114',
      label: 'Buch a.Buchrain',
      provincie: 9,
      slug: 'buch-a-buchrain',
    },
    {
      code: '091775120135',
      label: 'Pastetten',
      provincie: 9,
      slug: 'pastetten',
    },
    {
      code: '091775121142',
      label: 'Walpertskirchen',
      provincie: 9,
      slug: 'walpertskirchen',
    },
    {
      code: '091775121144',
      label: 'Wörth',
      provincie: 9,
      slug: 'woerth',
    },
    {
      code: '091775123116',
      label: 'Eitting',
      provincie: 9,
      slug: 'eitting',
    },
    {
      code: '091775123133',
      label: 'Oberding',
      provincie: 9,
      slug: 'oberding',
    },
    {
      code: '091775124131',
      label: 'Neuching',
      provincie: 9,
      slug: 'neuching',
    },
    {
      code: '091775124134',
      label: 'Ottenhofen',
      provincie: 9,
      slug: 'ottenhofen',
    },
    {
      code: '091775125121',
      label: 'Hohenpolding',
      provincie: 9,
      slug: 'hohenpolding',
    },
    {
      code: '091775125122',
      label: 'Inning a.Holz',
      provincie: 9,
      slug: 'inning-a-holz',
    },
    {
      code: '091775125124',
      label: 'Kirchberg',
      provincie: 9,
      slug: 'kirchberg',
    },
    {
      code: '091775125138',
      label: 'Steinkirchen',
      provincie: 9,
      slug: 'steinkirchen-gemeinde',
    },
    {
      code: '091775126112',
      label: 'Berglern',
      provincie: 9,
      slug: 'berglern',
    },
    {
      code: '091775126126',
      label: 'Langenpreising',
      provincie: 9,
      slug: 'langenpreising',
    },
    {
      code: '091775126143',
      label: 'Wartenberg',
      provincie: 9,
      slug: 'wartenberg-gemeinde',
    },
    {
      code: '091780116116',
      label: 'Au i.d.Hallertau',
      provincie: 9,
      slug: 'au-i-d-hallertau',
    },
    {
      code: '091780120120',
      label: 'Eching',
      provincie: 9,
      slug: 'eching',
    },
    {
      code: '091780122122',
      label: 'Rudelzhausen',
      provincie: 9,
      slug: 'rudelzhausen',
    },
    {
      code: '091780123123',
      label: 'Fahrenzhausen',
      provincie: 9,
      slug: 'fahrenzhausen',
    },
    {
      code: '091780124124',
      label: 'Freising',
      provincie: 9,
      slug: 'freising',
    },
    {
      code: '091780130130',
      label: 'Hallbergmoos',
      provincie: 9,
      slug: 'hallbergmoos',
    },
    {
      code: '091780133133',
      label: 'Hohenkammer',
      provincie: 9,
      slug: 'hohenkammer',
    },
    {
      code: '091780136136',
      label: 'Kirchdorf a.d.Amper',
      provincie: 9,
      slug: 'kirchdorf-a-d-amper',
    },
    {
      code: '091780137137',
      label: 'Kranzberg',
      provincie: 9,
      slug: 'kranzberg',
    },
    {
      code: '091780138138',
      label: 'Langenbach',
      provincie: 9,
      slug: 'langenbach-gemeinde',
    },
    {
      code: '091780140140',
      label: 'Marzling',
      provincie: 9,
      slug: 'marzling',
    },
    {
      code: '091780143143',
      label: 'Moosburg a.d.Isar',
      provincie: 9,
      slug: 'moosburg-a-d-isar',
    },
    {
      code: '091780144144',
      label: 'Nandlstadt',
      provincie: 9,
      slug: 'nandlstadt',
    },
    {
      code: '091780145145',
      label: 'Neufahrn b.Freising',
      provincie: 9,
      slug: 'neufahrn-b-freising',
    },
    {
      code: '091785127113',
      label: 'Allershausen',
      provincie: 9,
      slug: 'allershausen',
    },
    {
      code: '091785127150',
      label: 'Paunzhausen',
      provincie: 9,
      slug: 'paunzhausen',
    },
    {
      code: '091785129125',
      label: 'Gammelsdorf',
      provincie: 9,
      slug: 'gammelsdorf',
    },
    {
      code: '091785129132',
      label: 'Hörgertshausen',
      provincie: 9,
      slug: 'hoergertshausen',
    },
    {
      code: '091785129142',
      label: 'Mauern',
      provincie: 9,
      slug: 'mauern',
    },
    {
      code: '091785129155',
      label: 'Wang',
      provincie: 9,
      slug: 'wang',
    },
    {
      code: '091785130115',
      label: 'Attenkirchen',
      provincie: 9,
      slug: 'attenkirchen',
    },
    {
      code: '091785130129',
      label: 'Haag a.d.Amper',
      provincie: 9,
      slug: 'haag-a-d-amper',
    },
    {
      code: '091785130156',
      label: 'Wolfersdorf',
      provincie: 9,
      slug: 'wolfersdorf',
    },
    {
      code: '091785130157',
      label: 'Zolling',
      provincie: 9,
      slug: 'zolling',
    },
    {
      code: '091790113113',
      label: 'Alling',
      provincie: 9,
      slug: 'alling',
    },
    {
      code: '091790117117',
      label: 'Egenhofen',
      provincie: 9,
      slug: 'egenhofen',
    },
    {
      code: '091790118118',
      label: 'Eichenau',
      provincie: 9,
      slug: 'eichenau',
    },
    {
      code: '091790119119',
      label: 'Emmering',
      provincie: 9,
      slug: 'emmering-gemeinde',
    },
    {
      code: '091790121121',
      label: 'Fürstenfeldbruck',
      provincie: 9,
      slug: 'fuerstenfeldbruck',
    },
    {
      code: '091790123123',
      label: 'Germering',
      provincie: 9,
      slug: 'germering',
    },
    {
      code: '091790126126',
      label: 'Gröbenzell',
      provincie: 9,
      slug: 'groebenzell',
    },
    {
      code: '091790134134',
      label: 'Maisach',
      provincie: 9,
      slug: 'maisach',
    },
    {
      code: '091790138138',
      label: 'Moorenweis',
      provincie: 9,
      slug: 'moorenweis',
    },
    {
      code: '091790142142',
      label: 'Olching',
      provincie: 9,
      slug: 'olching',
    },
    {
      code: '091790145145',
      label: 'Puchheim',
      provincie: 9,
      slug: 'puchheim',
    },
    {
      code: '091790149149',
      label: 'Türkenfeld',
      provincie: 9,
      slug: 'tuerkenfeld',
    },
    {
      code: '091795131111',
      label: 'Adelshofen',
      provincie: 9,
      slug: 'adelshofen',
    },
    {
      code: '091795131114',
      label: 'Althegnenberg',
      provincie: 9,
      slug: 'althegnenberg',
    },
    {
      code: '091795131128',
      label: 'Hattenhofen',
      provincie: 9,
      slug: 'hattenhofen-gemeinde',
    },
    {
      code: '091795131130',
      label: 'Jesenwang',
      provincie: 9,
      slug: 'jesenwang',
    },
    {
      code: '091795131132',
      label: 'Landsberied',
      provincie: 9,
      slug: 'landsberied',
    },
    {
      code: '091795131136',
      label: 'Mammendorf',
      provincie: 9,
      slug: 'mammendorf',
    },
    {
      code: '091795131137',
      label: 'Mittelstetten',
      provincie: 9,
      slug: 'mittelstetten',
    },
    {
      code: '091795131140',
      label: 'Oberschweinbach',
      provincie: 9,
      slug: 'oberschweinbach',
    },
    {
      code: '091795132125',
      label: 'Grafrath',
      provincie: 9,
      slug: 'grafrath',
    },
    {
      code: '091795132131',
      label: 'Kottgeisering',
      provincie: 9,
      slug: 'kottgeisering',
    },
    {
      code: '091795132147',
      label: 'Schöngeising',
      provincie: 9,
      slug: 'schoengeising',
    },
    {
      code: '091800112112',
      label: 'Bad Kohlgrub',
      provincie: 9,
      slug: 'bad-kohlgrub',
    },
    {
      code: '091800116116',
      label: 'Farchant',
      provincie: 9,
      slug: 'farchant',
    },
    {
      code: '091800117117',
      label: 'Garmisch-Partenkirchen',
      provincie: 9,
      slug: 'garmisch-partenkirchen',
    },
    {
      code: '091800118118',
      label: 'Grainau',
      provincie: 9,
      slug: 'grainau',
    },
    {
      code: '091800122122',
      label: 'Krün',
      provincie: 9,
      slug: 'kruen',
    },
    {
      code: '091800123123',
      label: 'Mittenwald',
      provincie: 9,
      slug: 'mittenwald',
    },
    {
      code: '091800124124',
      label: 'Murnau a.Staffelsee',
      provincie: 9,
      slug: 'murnau-a-staffelsee',
    },
    {
      code: '091800125125',
      label: 'Oberammergau',
      provincie: 9,
      slug: 'oberammergau',
    },
    {
      code: '091800126126',
      label: 'Oberau',
      provincie: 9,
      slug: 'oberau',
    },
    {
      code: '091800134134',
      label: 'Uffing a.Staffelsee',
      provincie: 9,
      slug: 'uffing-a-staffelsee',
    },
    {
      code: '091800136136',
      label: 'Wallgau',
      provincie: 9,
      slug: 'wallgau',
    },
    {
      code: '091805133113',
      label: 'Bad Bayersoien',
      provincie: 9,
      slug: 'bad-bayersoien',
    },
    {
      code: '091805133129',
      label: 'Saulgrub',
      provincie: 9,
      slug: 'saulgrub',
    },
    {
      code: '091805135115',
      label: 'Ettal',
      provincie: 9,
      slug: 'ettal',
    },
    {
      code: '091805135135',
      label: 'Unterammergau',
      provincie: 9,
      slug: 'unterammergau',
    },
    {
      code: '091805136114',
      label: 'Eschenlohe',
      provincie: 9,
      slug: 'eschenlohe',
    },
    {
      code: '091805136119',
      label: 'Großweil',
      provincie: 9,
      slug: 'grossweil',
    },
    {
      code: '091805136127',
      label: 'Ohlstadt',
      provincie: 9,
      slug: 'ohlstadt',
    },
    {
      code: '091805136131',
      label: 'Schwaigen',
      provincie: 9,
      slug: 'schwaigen',
    },
    {
      code: '091805137128',
      label: 'Riegsee',
      provincie: 9,
      slug: 'riegsee',
    },
    {
      code: '091805137132',
      label: 'Seehausen a.Staffelsee',
      provincie: 9,
      slug: 'seehausen-a-staffelsee',
    },
    {
      code: '091805137133',
      label: 'Spatzenhausen',
      provincie: 9,
      slug: 'spatzenhausen',
    },
    {
      code: '091810113113',
      label: 'Denklingen',
      provincie: 9,
      slug: 'denklingen',
    },
    {
      code: '091810114114',
      label: 'Dießen am Ammersee',
      provincie: 9,
      slug: 'diessen-am-ammersee',
    },
    {
      code: '091810116116',
      label: 'Egling a.d.Paar',
      provincie: 9,
      slug: 'egling-a-d-paar',
    },
    {
      code: '091810122122',
      label: 'Geltendorf',
      provincie: 9,
      slug: 'geltendorf',
    },
    {
      code: '091810128128',
      label: 'Kaufering',
      provincie: 9,
      slug: 'kaufering',
    },
    {
      code: '091810130130',
      label: 'Landsberg am Lech',
      provincie: 9,
      slug: 'landsberg-am-lech',
    },
    {
      code: '091810132132',
      label: 'Penzing',
      provincie: 9,
      slug: 'penzing',
    },
    {
      code: '091810144144',
      label: 'Utting am Ammersee',
      provincie: 9,
      slug: 'utting-am-ammersee',
    },
    {
      code: '091810145145',
      label: 'Weil',
      provincie: 9,
      slug: 'weil',
    },
    {
      code: '091815138121',
      label: 'Fuchstal',
      provincie: 9,
      slug: 'fuchstal',
    },
    {
      code: '091815138143',
      label: 'Unterdießen',
      provincie: 9,
      slug: 'unterdiessen',
    },
    {
      code: '091815139126',
      label: 'Hurlach',
      provincie: 9,
      slug: 'hurlach',
    },
    {
      code: '091815139127',
      label: 'Igling',
      provincie: 9,
      slug: 'igling',
    },
    {
      code: '091815139131',
      label: 'Obermeitingen',
      provincie: 9,
      slug: 'obermeitingen',
    },
    {
      code: '091815140134',
      label: 'Prittriching',
      provincie: 9,
      slug: 'prittriching',
    },
    {
      code: '091815140138',
      label: 'Scheuring',
      provincie: 9,
      slug: 'scheuring',
    },
    {
      code: '091815141124',
      label: 'Hofstetten',
      provincie: 9,
      slug: 'hofstetten-gemeinde',
    },
    {
      code: '091815141140',
      label: 'Schwifting',
      provincie: 9,
      slug: 'schwifting',
    },
    {
      code: '091815141141',
      label: 'Pürgen',
      provincie: 9,
      slug: 'puergen',
    },
    {
      code: '091815142111',
      label: 'Apfeldorf',
      provincie: 9,
      slug: 'apfeldorf',
    },
    {
      code: '091815142129',
      label: 'Kinsau',
      provincie: 9,
      slug: 'kinsau',
    },
    {
      code: '091815142133',
      label: 'Vilgertshofen',
      provincie: 9,
      slug: 'vilgertshofen',
    },
    {
      code: '091815142135',
      label: 'Reichling',
      provincie: 9,
      slug: 'reichling',
    },
    {
      code: '091815142137',
      label: 'Rott',
      provincie: 9,
      slug: 'rott-gemeinde',
    },
    {
      code: '091815142142',
      label: 'Thaining',
      provincie: 9,
      slug: 'thaining',
    },
    {
      code: '091815143115',
      label: 'Eching am Ammersee',
      provincie: 9,
      slug: 'eching-am-ammersee',
    },
    {
      code: '091815143123',
      label: 'Greifenberg',
      provincie: 9,
      slug: 'greifenberg',
    },
    {
      code: '091815143139',
      label: 'Schondorf am Ammersee',
      provincie: 9,
      slug: 'schondorf-am-ammersee',
    },
    {
      code: '091815144118',
      label: 'Eresing',
      provincie: 9,
      slug: 'eresing',
    },
    {
      code: '091815144120',
      label: 'Finning',
      provincie: 9,
      slug: 'finning',
    },
    {
      code: '091815144146',
      label: 'Windach',
      provincie: 9,
      slug: 'windach',
    },
    {
      code: '091820111111',
      label: 'Bad Wiessee',
      provincie: 9,
      slug: 'bad-wiessee',
    },
    {
      code: '091820112112',
      label: 'Bayrischzell',
      provincie: 9,
      slug: 'bayrischzell',
    },
    {
      code: '091820114114',
      label: 'Fischbachau',
      provincie: 9,
      slug: 'fischbachau',
    },
    {
      code: '091820116116',
      label: 'Gmund a.Tegernsee',
      provincie: 9,
      slug: 'gmund-a-tegernsee',
    },
    {
      code: '091820119119',
      label: 'Hausham',
      provincie: 9,
      slug: 'hausham',
    },
    {
      code: '091820120120',
      label: 'Holzkirchen',
      provincie: 9,
      slug: 'holzkirchen',
    },
    {
      code: '091820123123',
      label: 'Irschenberg',
      provincie: 9,
      slug: 'irschenberg',
    },
    {
      code: '091820124124',
      label: 'Kreuth',
      provincie: 9,
      slug: 'kreuth',
    },
    {
      code: '091820125125',
      label: 'Miesbach',
      provincie: 9,
      slug: 'miesbach',
    },
    {
      code: '091820127127',
      label: 'Otterfing',
      provincie: 9,
      slug: 'otterfing',
    },
    {
      code: '091820129129',
      label: 'Rottach-Egern',
      provincie: 9,
      slug: 'rottach-egern',
    },
    {
      code: '091820131131',
      label: 'Schliersee',
      provincie: 9,
      slug: 'schliersee',
    },
    {
      code: '091820132132',
      label: 'Tegernsee',
      provincie: 9,
      slug: 'tegernsee',
    },
    {
      code: '091820133133',
      label: 'Valley',
      provincie: 9,
      slug: 'valley',
    },
    {
      code: '091820134134',
      label: 'Waakirchen',
      provincie: 9,
      slug: 'waakirchen',
    },
    {
      code: '091820136136',
      label: 'Warngau',
      provincie: 9,
      slug: 'warngau',
    },
    {
      code: '091820137137',
      label: 'Weyarn',
      provincie: 9,
      slug: 'weyarn',
    },
    {
      code: '091830112112',
      label: 'Ampfing',
      provincie: 9,
      slug: 'ampfing',
    },
    {
      code: '091830113113',
      label: 'Aschau a.Inn',
      provincie: 9,
      slug: 'aschau-a-inn',
    },
    {
      code: '091830114114',
      label: 'Buchbach',
      provincie: 9,
      slug: 'buchbach',
    },
    {
      code: '091830119119',
      label: 'Haag i.OB',
      provincie: 9,
      slug: 'haag-i-ob',
    },
    {
      code: '091830127127',
      label: 'Mettenheim',
      provincie: 9,
      slug: 'mettenheim-gemeinde',
    },
    {
      code: '091830128128',
      label: 'Mühldorf a.Inn',
      provincie: 9,
      slug: 'muehldorf-a-inn',
    },
    {
      code: '091830135135',
      label: 'Obertaufkirchen',
      provincie: 9,
      slug: 'obertaufkirchen',
    },
    {
      code: '091830144144',
      label: 'Schwindegg',
      provincie: 9,
      slug: 'schwindegg',
    },
    {
      code: '091830148148',
      label: 'Waldkraiburg',
      provincie: 9,
      slug: 'waldkraiburg',
    },
    {
      code: '091835145120',
      label: 'Heldenstein',
      provincie: 9,
      slug: 'heldenstein',
    },
    {
      code: '091835145138',
      label: 'Rattenkirchen',
      provincie: 9,
      slug: 'rattenkirchen',
    },
    {
      code: '091835146118',
      label: 'Gars a.Inn',
      provincie: 9,
      slug: 'gars-a-inn',
    },
    {
      code: '091835146147',
      label: 'Unterreit',
      provincie: 9,
      slug: 'unterreit',
    },
    {
      code: '091835147123',
      label: 'Kirchdorf',
      provincie: 9,
      slug: 'kirchdorf-gemeinde',
    },
    {
      code: '091835147140',
      label: 'Reichertsheim',
      provincie: 9,
      slug: 'reichertsheim',
    },
    {
      code: '091835148122',
      label: 'Jettenbach',
      provincie: 9,
      slug: 'jettenbach-gemeinde',
    },
    {
      code: '091835148124',
      label: 'Kraiburg a.Inn',
      provincie: 9,
      slug: 'kraiburg-a-inn',
    },
    {
      code: '091835148145',
      label: 'Taufkirchen',
      provincie: 9,
      slug: 'taufkirchen',
    },
    {
      code: '091835149115',
      label: 'Egglkofen',
      provincie: 9,
      slug: 'egglkofen',
    },
    {
      code: '091835149129',
      label: 'Neumarkt-Sankt Veit',
      provincie: 9,
      slug: 'neumarkt-sankt-veit',
    },
    {
      code: '091835150125',
      label: 'Lohkirchen',
      provincie: 9,
      slug: 'lohkirchen',
    },
    {
      code: '091835150132',
      label: 'Oberbergkirchen',
      provincie: 9,
      slug: 'oberbergkirchen',
    },
    {
      code: '091835150143',
      label: 'Schönberg',
      provincie: 9,
      slug: 'schoenberg-gemeinde',
    },
    {
      code: '091835150151',
      label: 'Zangberg',
      provincie: 9,
      slug: 'zangberg',
    },
    {
      code: '091835151134',
      label: 'Oberneukirchen',
      provincie: 9,
      slug: 'oberneukirchen',
    },
    {
      code: '091835151136',
      label: 'Polling',
      provincie: 9,
      slug: 'polling',
    },
    {
      code: '091835152116',
      label: 'Erharting',
      provincie: 9,
      slug: 'erharting',
    },
    {
      code: '091835152130',
      label: 'Niederbergkirchen',
      provincie: 9,
      slug: 'niederbergkirchen',
    },
    {
      code: '091835152131',
      label: 'Niedertaufkirchen',
      provincie: 9,
      slug: 'niedertaufkirchen',
    },
    {
      code: '091835183126',
      label: 'Maitenbeth',
      provincie: 9,
      slug: 'maitenbeth',
    },
    {
      code: '091835183139',
      label: 'Rechtmehring',
      provincie: 9,
      slug: 'rechtmehring',
    },
    {
      code: '091840112112',
      label: 'Aschheim',
      provincie: 9,
      slug: 'aschheim',
    },
    {
      code: '091840113113',
      label: 'Baierbrunn',
      provincie: 9,
      slug: 'baierbrunn',
    },
    {
      code: '091840114114',
      label: 'Brunnthal',
      provincie: 9,
      slug: 'brunnthal',
    },
    {
      code: '091840118118',
      label: 'Feldkirchen',
      provincie: 9,
      slug: 'feldkirchen',
    },
    {
      code: '091840119119',
      label: 'Garching b.München',
      provincie: 9,
      slug: 'garching-b-muenchen',
    },
    {
      code: '091840120120',
      label: 'Gräfelfing',
      provincie: 9,
      slug: 'graefelfing',
    },
    {
      code: '091840121121',
      label: 'Grasbrunn',
      provincie: 9,
      slug: 'grasbrunn',
    },
    {
      code: '091840122122',
      label: 'Grünwald',
      provincie: 9,
      slug: 'gruenwald',
    },
    {
      code: '091840123123',
      label: 'Haar',
      provincie: 9,
      slug: 'haar',
    },
    {
      code: '091840127127',
      label: 'Höhenkirchen-Siegertsbrunn',
      provincie: 9,
      slug: 'hoehenkirchen-siegertsbrunn',
    },
    {
      code: '091840129129',
      label: 'Hohenbrunn',
      provincie: 9,
      slug: 'hohenbrunn',
    },
    {
      code: '091840130130',
      label: 'Ismaning',
      provincie: 9,
      slug: 'ismaning',
    },
    {
      code: '091840131131',
      label: 'Kirchheim b.München',
      provincie: 9,
      slug: 'kirchheim-b-muenchen',
    },
    {
      code: '091840132132',
      label: 'Neuried',
      provincie: 9,
      slug: 'neuried-gemeinde',
    },
    {
      code: '091840134134',
      label: 'Oberhaching',
      provincie: 9,
      slug: 'oberhaching',
    },
    {
      code: '091840135135',
      label: 'Oberschleißheim',
      provincie: 9,
      slug: 'oberschleissheim',
    },
    {
      code: '091840136136',
      label: 'Ottobrunn',
      provincie: 9,
      slug: 'ottobrunn',
    },
    {
      code: '091840137137',
      label: 'Aying',
      provincie: 9,
      slug: 'aying',
    },
    {
      code: '091840138138',
      label: 'Planegg',
      provincie: 9,
      slug: 'planegg',
    },
    {
      code: '091840139139',
      label: 'Pullach i.Isartal',
      provincie: 9,
      slug: 'pullach-i-isartal',
    },
    {
      code: '091840140140',
      label: 'Putzbrunn',
      provincie: 9,
      slug: 'putzbrunn',
    },
    {
      code: '091840141141',
      label: 'Sauerlach',
      provincie: 9,
      slug: 'sauerlach',
    },
    {
      code: '091840142142',
      label: 'Schäftlarn',
      provincie: 9,
      slug: 'schaeftlarn',
    },
    {
      code: '091840144144',
      label: 'Straßlach-Dingharting',
      provincie: 9,
      slug: 'strasslach-dingharting',
    },
    {
      code: '091840145145',
      label: 'Taufkirchen',
      provincie: 9,
      slug: 'taufkirchen-gemeinde',
    },
    {
      code: '091840146146',
      label: 'Neubiberg',
      provincie: 9,
      slug: 'neubiberg',
    },
    {
      code: '091840147147',
      label: 'Unterföhring',
      provincie: 9,
      slug: 'unterfoehring',
    },
    {
      code: '091840148148',
      label: 'Unterhaching',
      provincie: 9,
      slug: 'unterhaching',
    },
    {
      code: '091840149149',
      label: 'Unterschleißheim',
      provincie: 9,
      slug: 'unterschleissheim',
    },
    {
      code: '091850113113',
      label: 'Aresing',
      provincie: 9,
      slug: 'aresing',
    },
    {
      code: '091850125125',
      label: 'Burgheim',
      provincie: 9,
      slug: 'burgheim',
    },
    {
      code: '091850127127',
      label: 'Ehekirchen',
      provincie: 9,
      slug: 'ehekirchen',
    },
    {
      code: '091850139139',
      label: 'Karlshuld',
      provincie: 9,
      slug: 'karlshuld',
    },
    {
      code: '091850140140',
      label: 'Karlskron',
      provincie: 9,
      slug: 'karlskron',
    },
    {
      code: '091850149149',
      label: 'Neuburg a.d.Donau',
      provincie: 9,
      slug: 'neuburg-a-d-donau',
    },
    {
      code: '091850150150',
      label: 'Oberhausen',
      provincie: 9,
      slug: 'oberhausen-gemeinde',
    },
    {
      code: '091850153153',
      label: 'Rennertshofen',
      provincie: 9,
      slug: 'rennertshofen',
    },
    {
      code: '091850158158',
      label: 'Schrobenhausen',
      provincie: 9,
      slug: 'schrobenhausen',
    },
    {
      code: '091850163163',
      label: 'Königsmoos',
      provincie: 9,
      slug: 'koenigsmoos',
    },
    {
      code: '091850168168',
      label: 'Weichering',
      provincie: 9,
      slug: 'weichering',
    },
    {
      code: '091855154118',
      label: 'Bergheim',
      provincie: 9,
      slug: 'bergheim-gemeinde',
    },
    {
      code: '091855154157',
      label: 'Rohrenfels',
      provincie: 9,
      slug: 'rohrenfels',
    },
    {
      code: '091855155116',
      label: 'Berg im Gau',
      provincie: 9,
      slug: 'berg-im-gau',
    },
    {
      code: '091855155123',
      label: 'Brunnen',
      provincie: 9,
      slug: 'brunnen',
    },
    {
      code: '091855155131',
      label: 'Gachenbach',
      provincie: 9,
      slug: 'gachenbach',
    },
    {
      code: '091855155143',
      label: 'Langenmosen',
      provincie: 9,
      slug: 'langenmosen',
    },
    {
      code: '091855155166',
      label: 'Waidhofen',
      provincie: 9,
      slug: 'waidhofen',
    },
    {
      code: '091860113113',
      label: 'Baar-Ebenhausen',
      provincie: 9,
      slug: 'baar-ebenhausen',
    },
    {
      code: '091860125125',
      label: 'Gerolsbach',
      provincie: 9,
      slug: 'gerolsbach',
    },
    {
      code: '091860128128',
      label: 'Hohenwart',
      provincie: 9,
      slug: 'hohenwart',
    },
    {
      code: '091860132132',
      label: 'Jetzendorf',
      provincie: 9,
      slug: 'jetzendorf',
    },
    {
      code: '091860137137',
      label: 'Manching',
      provincie: 9,
      slug: 'manching',
    },
    {
      code: '091860139139',
      label: 'Münchsmünster',
      provincie: 9,
      slug: 'muenchsmuenster',
    },
    {
      code: '091860143143',
      label: 'Pfaffenhofen a.d.Ilm',
      provincie: 9,
      slug: 'pfaffenhofen-a-d-ilm',
    },
    {
      code: '091860146146',
      label: 'Reichertshausen',
      provincie: 9,
      slug: 'reichertshausen',
    },
    {
      code: '091860149149',
      label: 'Rohrbach',
      provincie: 9,
      slug: 'rohrbach-gemeinde',
    },
    {
      code: '091860151151',
      label: 'Scheyern',
      provincie: 9,
      slug: 'scheyern',
    },
    {
      code: '091860152152',
      label: 'Schweitenkirchen',
      provincie: 9,
      slug: 'schweitenkirchen',
    },
    {
      code: '091860158158',
      label: 'Vohburg a.d.Donau',
      provincie: 9,
      slug: 'vohburg-a-d-donau',
    },
    {
      code: '091860162162',
      label: 'Wolnzach',
      provincie: 9,
      slug: 'wolnzach',
    },
    {
      code: '091865156116',
      label: 'Ernsgaden',
      provincie: 9,
      slug: 'ernsgaden',
    },
    {
      code: '091865156122',
      label: 'Geisenfeld',
      provincie: 9,
      slug: 'geisenfeld',
    },
    {
      code: '091865157126',
      label: 'Hettenshausen',
      provincie: 9,
      slug: 'hettenshausen',
    },
    {
      code: '091865157130',
      label: 'Ilmmünster',
      provincie: 9,
      slug: 'ilmmuenster',
    },
    {
      code: '091865158144',
      label: 'Pörnbach',
      provincie: 9,
      slug: 'poernbach',
    },
    {
      code: '091865158147',
      label: 'Reichertshofen',
      provincie: 9,
      slug: 'reichertshofen',
    },
    {
      code: '091870113113',
      label: 'Amerang',
      provincie: 9,
      slug: 'amerang',
    },
    {
      code: '091870114114',
      label: 'Aschau i.Chiemgau',
      provincie: 9,
      slug: 'aschau-i-chiemgau',
    },
    {
      code: '091870116116',
      label: 'Babensham',
      provincie: 9,
      slug: 'babensham',
    },
    {
      code: '091870117117',
      label: 'Bad Aibling',
      provincie: 9,
      slug: 'bad-aibling',
    },
    {
      code: '091870118118',
      label: 'Bernau a.Chiemsee',
      provincie: 9,
      slug: 'bernau-a-chiemsee',
    },
    {
      code: '091870120120',
      label: 'Brannenburg',
      provincie: 9,
      slug: 'brannenburg',
    },
    {
      code: '091870122122',
      label: 'Bruckmühl',
      provincie: 9,
      slug: 'bruckmuehl',
    },
    {
      code: '091870124124',
      label: 'Edling',
      provincie: 9,
      slug: 'edling',
    },
    {
      code: '091870125125',
      label: 'Eggstätt',
      provincie: 9,
      slug: 'eggstaett',
    },
    {
      code: '091870126126',
      label: 'Eiselfing',
      provincie: 9,
      slug: 'eiselfing',
    },
    {
      code: '091870128128',
      label: 'Bad Endorf',
      provincie: 9,
      slug: 'bad-endorf',
    },
    {
      code: '091870129129',
      label: 'Bad Feilnbach',
      provincie: 9,
      slug: 'bad-feilnbach',
    },
    {
      code: '091870130130',
      label: 'Feldkirchen-Westerham',
      provincie: 9,
      slug: 'feldkirchen-westerham',
    },
    {
      code: '091870131131',
      label: 'Flintsbach a.Inn',
      provincie: 9,
      slug: 'flintsbach-a-inn',
    },
    {
      code: '091870132132',
      label: 'Frasdorf',
      provincie: 9,
      slug: 'frasdorf',
    },
    {
      code: '091870134134',
      label: 'Griesstätt',
      provincie: 9,
      slug: 'griesstaett',
    },
    {
      code: '091870137137',
      label: 'Großkarolinenfeld',
      provincie: 9,
      slug: 'grosskarolinenfeld',
    },
    {
      code: '091870142142',
      label: 'Schechen',
      provincie: 9,
      slug: 'schechen',
    },
    {
      code: '091870148148',
      label: 'Kiefersfelden',
      provincie: 9,
      slug: 'kiefersfelden',
    },
    {
      code: '091870150150',
      label: 'Kolbermoor',
      provincie: 9,
      slug: 'kolbermoor',
    },
    {
      code: '091870154154',
      label: 'Neubeuern',
      provincie: 9,
      slug: 'neubeuern',
    },
    {
      code: '091870156156',
      label: 'Nußdorf a.Inn',
      provincie: 9,
      slug: 'nussdorf-a-inn',
    },
    {
      code: '091870157157',
      label: 'Oberaudorf',
      provincie: 9,
      slug: 'oberaudorf',
    },
    {
      code: '091870162162',
      label: 'Prien a.Chiemsee',
      provincie: 9,
      slug: 'prien-a-chiemsee',
    },
    {
      code: '091870163163',
      label: 'Prutting',
      provincie: 9,
      slug: 'prutting',
    },
    {
      code: '091870165165',
      label: 'Raubling',
      provincie: 9,
      slug: 'raubling',
    },
    {
      code: '091870167167',
      label: 'Riedering',
      provincie: 9,
      slug: 'riedering',
    },
    {
      code: '091870168168',
      label: 'Rimsting',
      provincie: 9,
      slug: 'rimsting',
    },
    {
      code: '091870169169',
      label: 'Rohrdorf',
      provincie: 9,
      slug: 'rohrdorf-gemeinde',
    },
    {
      code: '091870172172',
      label: 'Samerberg',
      provincie: 9,
      slug: 'samerberg',
    },
    {
      code: '091870174174',
      label: 'Söchtenau',
      provincie: 9,
      slug: 'soechtenau',
    },
    {
      code: '091870176176',
      label: 'Soyen',
      provincie: 9,
      slug: 'soyen',
    },
    {
      code: '091870177177',
      label: 'Stephanskirchen',
      provincie: 9,
      slug: 'stephanskirchen',
    },
    {
      code: '091870179179',
      label: 'Tuntenhausen',
      provincie: 9,
      slug: 'tuntenhausen',
    },
    {
      code: '091870181181',
      label: 'Vogtareuth',
      provincie: 9,
      slug: 'vogtareuth',
    },
    {
      code: '091870182182',
      label: 'Wasserburg a.Inn',
      provincie: 9,
      slug: 'wasserburg-a-inn',
    },
    {
      code: '091875160121',
      label: 'Breitbrunn a.Chiemsee',
      provincie: 9,
      slug: 'breitbrunn-a-chiemsee',
    },
    {
      code: '091875160123',
      label: 'Chiemsee',
      provincie: 9,
      slug: 'chiemsee',
    },
    {
      code: '091875160138',
      label: 'Gstadt a.Chiemsee',
      provincie: 9,
      slug: 'gstadt-a-chiemsee',
    },
    {
      code: '091875162139',
      label: 'Halfing',
      provincie: 9,
      slug: 'halfing',
    },
    {
      code: '091875162145',
      label: 'Höslwang',
      provincie: 9,
      slug: 'hoeslwang',
    },
    {
      code: '091875162173',
      label: 'Schonstett',
      provincie: 9,
      slug: 'schonstett',
    },
    {
      code: '091875165164',
      label: 'Ramerberg',
      provincie: 9,
      slug: 'ramerberg',
    },
    {
      code: '091875165170',
      label: 'Rott a.Inn',
      provincie: 9,
      slug: 'rott-a-inn',
    },
    {
      code: '091875184159',
      label: 'Pfaffing',
      provincie: 9,
      slug: 'pfaffing',
    },
    {
      code: '091875184186',
      label: 'Albaching',
      provincie: 9,
      slug: 'albaching',
    },
    {
      code: '091880113113',
      label: 'Berg',
      provincie: 9,
      slug: 'berg-gemeinde',
    },
    {
      code: '091880117117',
      label: 'Andechs',
      provincie: 9,
      slug: 'andechs',
    },
    {
      code: '091880118118',
      label: 'Feldafing',
      provincie: 9,
      slug: 'feldafing',
    },
    {
      code: '091880120120',
      label: 'Gauting',
      provincie: 9,
      slug: 'gauting',
    },
    {
      code: '091880121121',
      label: 'Gilching',
      provincie: 9,
      slug: 'gilching',
    },
    {
      code: '091880124124',
      label: 'Herrsching a.Ammersee',
      provincie: 9,
      slug: 'herrsching-a-ammersee',
    },
    {
      code: '091880126126',
      label: 'Inning a.Ammersee',
      provincie: 9,
      slug: 'inning-a-ammersee',
    },
    {
      code: '091880127127',
      label: 'Krailling',
      provincie: 9,
      slug: 'krailling',
    },
    {
      code: '091880132132',
      label: 'Seefeld',
      provincie: 9,
      slug: 'seefeld-gemeinde',
    },
    {
      code: '091880137137',
      label: 'Pöcking',
      provincie: 9,
      slug: 'poecking',
    },
    {
      code: '091880139139',
      label: 'Starnberg',
      provincie: 9,
      slug: 'starnberg',
    },
    {
      code: '091880141141',
      label: 'Tutzing',
      provincie: 9,
      slug: 'tutzing',
    },
    {
      code: '091880144144',
      label: 'Weßling',
      provincie: 9,
      slug: 'wessling',
    },
    {
      code: '091880145145',
      label: 'Wörthsee',
      provincie: 9,
      slug: 'woerthsee',
    },
    {
      code: '091890111111',
      label: 'Altenmarkt a.d.Alz',
      provincie: 9,
      slug: 'altenmarkt-a-d-alz',
    },
    {
      code: '091890114114',
      label: 'Chieming',
      provincie: 9,
      slug: 'chieming',
    },
    {
      code: '091890115115',
      label: 'Engelsberg',
      provincie: 9,
      slug: 'engelsberg',
    },
    {
      code: '091890118118',
      label: 'Fridolfing',
      provincie: 9,
      slug: 'fridolfing',
    },
    {
      code: '091890119119',
      label: 'Grabenstätt',
      provincie: 9,
      slug: 'grabenstaett',
    },
    {
      code: '091890120120',
      label: 'Grassau',
      provincie: 9,
      slug: 'grassau',
    },
    {
      code: '091890124124',
      label: 'Inzell',
      provincie: 9,
      slug: 'inzell',
    },
    {
      code: '091890127127',
      label: 'Kirchanschöring',
      provincie: 9,
      slug: 'kirchanschoering',
    },
    {
      code: '091890130130',
      label: 'Nußdorf',
      provincie: 9,
      slug: 'nussdorf',
    },
    {
      code: '091890134134',
      label: 'Palling',
      provincie: 9,
      slug: 'palling',
    },
    {
      code: '091890135135',
      label: 'Petting',
      provincie: 9,
      slug: 'petting',
    },
    {
      code: '091890139139',
      label: 'Reit im Winkl',
      provincie: 9,
      slug: 'reit-im-winkl',
    },
    {
      code: '091890140140',
      label: 'Ruhpolding',
      provincie: 9,
      slug: 'ruhpolding',
    },
    {
      code: '091890141141',
      label: 'Schleching',
      provincie: 9,
      slug: 'schleching',
    },
    {
      code: '091890142142',
      label: 'Schnaitsee',
      provincie: 9,
      slug: 'schnaitsee',
    },
    {
      code: '091890143143',
      label: 'Seeon-Seebruck',
      provincie: 9,
      slug: 'seeon-seebruck',
    },
    {
      code: '091890145145',
      label: 'Siegsdorf',
      provincie: 9,
      slug: 'siegsdorf',
    },
    {
      code: '091890148148',
      label: 'Surberg',
      provincie: 9,
      slug: 'surberg',
    },
    {
      code: '091890149149',
      label: 'Tacherting',
      provincie: 9,
      slug: 'tacherting',
    },
    {
      code: '091890152152',
      label: 'Tittmoning',
      provincie: 9,
      slug: 'tittmoning',
    },
    {
      code: '091890154154',
      label: 'Traunreut',
      provincie: 9,
      slug: 'traunreut',
    },
    {
      code: '091890155155',
      label: 'Traunstein',
      provincie: 9,
      slug: 'traunstein',
    },
    {
      code: '091890157157',
      label: 'Trostberg',
      provincie: 9,
      slug: 'trostberg',
    },
    {
      code: '091890159159',
      label: 'Übersee',
      provincie: 9,
      slug: 'uebersee',
    },
    {
      code: '091890160160',
      label: 'Unterwössen',
      provincie: 9,
      slug: 'unterwoessen',
    },
    {
      code: '091895166113',
      label: 'Bergen',
      provincie: 9,
      slug: 'bergen-gemeinde',
    },
    {
      code: '091895166161',
      label: 'Vachendorf',
      provincie: 9,
      slug: 'vachendorf',
    },
    {
      code: '091895169129',
      label: 'Marquartstein',
      provincie: 9,
      slug: 'marquartstein',
    },
    {
      code: '091895169146',
      label: 'Staudach-Egerndach',
      provincie: 9,
      slug: 'staudach-egerndach',
    },
    {
      code: '091895170126',
      label: 'Kienberg',
      provincie: 9,
      slug: 'kienberg',
    },
    {
      code: '091895170133',
      label: 'Obing',
      provincie: 9,
      slug: 'obing',
    },
    {
      code: '091895170137',
      label: 'Pittenhart',
      provincie: 9,
      slug: 'pittenhart',
    },
    {
      code: '091895173150',
      label: 'Taching a.See',
      provincie: 9,
      slug: 'taching-a-see',
    },
    {
      code: '091895173162',
      label: 'Waging a.See',
      provincie: 9,
      slug: 'waging-a-see',
    },
    {
      code: '091895173165',
      label: 'Wonneberg',
      provincie: 9,
      slug: 'wonneberg',
    },
    {
      code: '091900115115',
      label: 'Bernried am Starnberger See',
      provincie: 9,
      slug: 'bernried-am-starnberger-see',
    },
    {
      code: '091900130130',
      label: 'Hohenpeißenberg',
      provincie: 9,
      slug: 'hohenpeissenberg',
    },
    {
      code: '091900138138',
      label: 'Pähl',
      provincie: 9,
      slug: 'paehl',
    },
    {
      code: '091900139139',
      label: 'Peißenberg',
      provincie: 9,
      slug: 'peissenberg',
    },
    {
      code: '091900140140',
      label: 'Peiting',
      provincie: 9,
      slug: 'peiting',
    },
    {
      code: '091900141141',
      label: 'Penzberg',
      provincie: 9,
      slug: 'penzberg',
    },
    {
      code: '091900142142',
      label: 'Polling',
      provincie: 9,
      slug: 'polling-gemeinde',
    },
    {
      code: '091900144144',
      label: 'Raisting',
      provincie: 9,
      slug: 'raisting',
    },
    {
      code: '091900148148',
      label: 'Schongau',
      provincie: 9,
      slug: 'schongau',
    },
    {
      code: '091900157157',
      label: 'Weilheim i.OB',
      provincie: 9,
      slug: 'weilheim-i-ob',
    },
    {
      code: '091900158158',
      label: 'Wessobrunn',
      provincie: 9,
      slug: 'wessobrunn',
    },
    {
      code: '091900159159',
      label: 'Wielenbach',
      provincie: 9,
      slug: 'wielenbach',
    },
    {
      code: '091905174111',
      label: 'Altenstadt',
      provincie: 9,
      slug: 'altenstadt-gemeinde',
    },
    {
      code: '091905174129',
      label: 'Hohenfurch',
      provincie: 9,
      slug: 'hohenfurch',
    },
    {
      code: '091905174133',
      label: 'Ingenried',
      provincie: 9,
      slug: 'ingenried',
    },
    {
      code: '091905174149',
      label: 'Schwabbruck',
      provincie: 9,
      slug: 'schwabbruck',
    },
    {
      code: '091905174151',
      label: 'Schwabsoien',
      provincie: 9,
      slug: 'schwabsoien',
    },
    {
      code: '091905175114',
      label: 'Bernbeuren',
      provincie: 9,
      slug: 'bernbeuren',
    },
    {
      code: '091905175118',
      label: 'Burggen',
      provincie: 9,
      slug: 'burggen',
    },
    {
      code: '091905176113',
      label: 'Antdorf',
      provincie: 9,
      slug: 'antdorf',
    },
    {
      code: '091905176126',
      label: 'Habach',
      provincie: 9,
      slug: 'habach',
    },
    {
      code: '091905176136',
      label: 'Obersöchering',
      provincie: 9,
      slug: 'obersoechering',
    },
    {
      code: '091905176153',
      label: 'Sindelsdorf',
      provincie: 9,
      slug: 'sindelsdorf',
    },
    {
      code: '091905177120',
      label: 'Eberfing',
      provincie: 9,
      slug: 'eberfing',
    },
    {
      code: '091905177121',
      label: 'Eglfing',
      provincie: 9,
      slug: 'eglfing',
    },
    {
      code: '091905177131',
      label: 'Huglfing',
      provincie: 9,
      slug: 'huglfing',
    },
    {
      code: '091905177135',
      label: 'Oberhausen',
      provincie: 9,
      slug: 'oberhausen-gemeinde',
    },
    {
      code: '091905178117',
      label: 'Böbing',
      provincie: 9,
      slug: 'boebing',
    },
    {
      code: '091905178145',
      label: 'Rottenbuch',
      provincie: 9,
      slug: 'rottenbuch',
    },
    {
      code: '091905179132',
      label: 'Iffeldorf',
      provincie: 9,
      slug: 'iffeldorf',
    },
    {
      code: '091905179152',
      label: 'Seeshaupt',
      provincie: 9,
      slug: 'seeshaupt',
    },
    {
      code: '091905180143',
      label: 'Prem',
      provincie: 9,
      slug: 'prem',
    },
    {
      code: '091905180154',
      label: 'Steingaden',
      provincie: 9,
      slug: 'steingaden',
    },
    {
      code: '091905180160',
      label: 'Wildsteig',
      provincie: 9,
      slug: 'wildsteig',
    },
    {
      code: '092610000000',
      label: 'Landshut',
      provincie: 9,
      slug: 'landshut',
    },
    {
      code: '092620000000',
      label: 'Passau',
      provincie: 9,
      slug: 'passau',
    },
    {
      code: '092630000000',
      label: 'Straubing',
      provincie: 9,
      slug: 'straubing',
    },
    {
      code: '092710111111',
      label: 'Aholming',
      provincie: 9,
      slug: 'aholming',
    },
    {
      code: '092710113113',
      label: 'Auerbach',
      provincie: 9,
      slug: 'auerbach',
    },
    {
      code: '092710116116',
      label: 'Bernried',
      provincie: 9,
      slug: 'bernried',
    },
    {
      code: '092710119119',
      label: 'Deggendorf',
      provincie: 9,
      slug: 'deggendorf',
    },
    {
      code: '092710122122',
      label: 'Grafling',
      provincie: 9,
      slug: 'grafling',
    },
    {
      code: '092710125125',
      label: 'Hengersberg',
      provincie: 9,
      slug: 'hengersberg',
    },
    {
      code: '092710127127',
      label: 'Iggensbach',
      provincie: 9,
      slug: 'iggensbach',
    },
    {
      code: '092710128128',
      label: 'Künzing',
      provincie: 9,
      slug: 'kuenzing',
    },
    {
      code: '092710132132',
      label: 'Metten',
      provincie: 9,
      slug: 'metten',
    },
    {
      code: '092710138138',
      label: 'Niederalteich',
      provincie: 9,
      slug: 'niederalteich',
    },
    {
      code: '092710140140',
      label: 'Offenberg',
      provincie: 9,
      slug: 'offenberg',
    },
    {
      code: '092710141141',
      label: 'Osterhofen',
      provincie: 9,
      slug: 'osterhofen',
    },
    {
      code: '092710146146',
      label: 'Plattling',
      provincie: 9,
      slug: 'plattling',
    },
    {
      code: '092710151151',
      label: 'Stephansposching',
      provincie: 9,
      slug: 'stephansposching',
    },
    {
      code: '092710153153',
      label: 'Winzer',
      provincie: 9,
      slug: 'winzer',
    },
    {
      code: '092715202123',
      label: 'Grattersdorf',
      provincie: 9,
      slug: 'grattersdorf',
    },
    {
      code: '092715202126',
      label: 'Hunding',
      provincie: 9,
      slug: 'hunding',
    },
    {
      code: '092715202130',
      label: 'Lalling',
      provincie: 9,
      slug: 'lalling',
    },
    {
      code: '092715202148',
      label: 'Schaufling',
      provincie: 9,
      slug: 'schaufling',
    },
    {
      code: '092715204139',
      label: 'Oberpöring',
      provincie: 9,
      slug: 'oberpoering',
    },
    {
      code: '092715204143',
      label: 'Otzing',
      provincie: 9,
      slug: 'otzing',
    },
    {
      code: '092715204152',
      label: 'Wallerfing',
      provincie: 9,
      slug: 'wallerfing',
    },
    {
      code: '092715205118',
      label: 'Buchhofen',
      provincie: 9,
      slug: 'buchhofen',
    },
    {
      code: '092715205135',
      label: 'Moos',
      provincie: 9,
      slug: 'moos-gemeinde',
    },
    {
      code: '092715206114',
      label: 'Außernzell',
      provincie: 9,
      slug: 'aussernzell',
    },
    {
      code: '092715206149',
      label: 'Schöllnach',
      provincie: 9,
      slug: 'schoellnach',
    },
    {
      code: '092720118118',
      label: 'Freyung',
      provincie: 9,
      slug: 'freyung',
    },
    {
      code: '092720120120',
      label: 'Grafenau',
      provincie: 9,
      slug: 'grafenau-stadt',
    },
    {
      code: '092720121121',
      label: 'Grainet',
      provincie: 9,
      slug: 'grainet',
    },
    {
      code: '092720122122',
      label: 'Haidmühle',
      provincie: 9,
      slug: 'haidmuehle',
    },
    {
      code: '092720127127',
      label: 'Hohenau',
      provincie: 9,
      slug: 'hohenau',
    },
    {
      code: '092720129129',
      label: 'Jandelsbrunn',
      provincie: 9,
      slug: 'jandelsbrunn',
    },
    {
      code: '092720134134',
      label: 'Mauth',
      provincie: 9,
      slug: 'mauth',
    },
    {
      code: '092720136136',
      label: 'Neureichenau',
      provincie: 9,
      slug: 'neureichenau',
    },
    {
      code: '092720140140',
      label: 'Ringelai',
      provincie: 9,
      slug: 'ringelai',
    },
    {
      code: '092720141141',
      label: 'Röhrnbach',
      provincie: 9,
      slug: 'roehrnbach',
    },
    {
      code: '092720142142',
      label: 'Saldenburg',
      provincie: 9,
      slug: 'saldenburg',
    },
    {
      code: '092720143143',
      label: 'Sankt Oswald-Riedlhütte',
      provincie: 9,
      slug: 'sankt-oswald-riedlhuette',
    },
    {
      code: '092720146146',
      label: 'Neuschönau',
      provincie: 9,
      slug: 'neuschoenau',
    },
    {
      code: '092720149149',
      label: 'Spiegelau',
      provincie: 9,
      slug: 'spiegelau',
    },
    {
      code: '092720151151',
      label: 'Waldkirchen',
      provincie: 9,
      slug: 'waldkirchen',
    },
    {
      code: '092725211116',
      label: 'Eppenschlag',
      provincie: 9,
      slug: 'eppenschlag',
    },
    {
      code: '092725211128',
      label: 'Innernzell',
      provincie: 9,
      slug: 'innernzell',
    },
    {
      code: '092725211145',
      label: 'Schöfweg',
      provincie: 9,
      slug: 'schoefweg',
    },
    {
      code: '092725211147',
      label: 'Schönberg',
      provincie: 9,
      slug: 'schoenberg-gemeinde',
    },
    {
      code: '092725212126',
      label: 'Hinterschmiding',
      provincie: 9,
      slug: 'hinterschmiding',
    },
    {
      code: '092725212139',
      label: 'Philippsreut',
      provincie: 9,
      slug: 'philippsreut',
    },
    {
      code: '092725213150',
      label: 'Thurmansbang',
      provincie: 9,
      slug: 'thurmansbang',
    },
    {
      code: '092725213152',
      label: 'Zenting',
      provincie: 9,
      slug: 'zenting',
    },
    {
      code: '092725214119',
      label: 'Fürsteneck',
      provincie: 9,
      slug: 'fuersteneck',
    },
    {
      code: '092725214138',
      label: 'Perlesreut',
      provincie: 9,
      slug: 'perlesreut',
    },
    {
      code: '092730111111',
      label: 'Abensberg',
      provincie: 9,
      slug: 'abensberg',
    },
    {
      code: '092730116116',
      label: 'Bad Abbach',
      provincie: 9,
      slug: 'bad-abbach',
    },
    {
      code: '092730137137',
      label: 'Kelheim',
      provincie: 9,
      slug: 'kelheim',
    },
    {
      code: '092730147147',
      label: 'Mainburg',
      provincie: 9,
      slug: 'mainburg',
    },
    {
      code: '092730152152',
      label: 'Neustadt a.d.Donau',
      provincie: 9,
      slug: 'neustadt-a-d-donau',
    },
    {
      code: '092730159159',
      label: 'Painten',
      provincie: 9,
      slug: 'painten',
    },
    {
      code: '092730164164',
      label: 'Riedenburg',
      provincie: 9,
      slug: 'riedenburg',
    },
    {
      code: '092730165165',
      label: 'Rohr i.NB',
      provincie: 9,
      slug: 'rohr-i-nb',
    },
    {
      code: '092735215121',
      label: 'Essing',
      provincie: 9,
      slug: 'essing',
    },
    {
      code: '092735215133',
      label: 'Ihrlerstein',
      provincie: 9,
      slug: 'ihrlerstein',
    },
    {
      code: '092735216166',
      label: 'Saal a.d.Donau',
      provincie: 9,
      slug: 'saal-a-d-donau',
    },
    {
      code: '092735216175',
      label: 'Teugn',
      provincie: 9,
      slug: 'teugn',
    },
    {
      code: '092735217125',
      label: 'Hausen',
      provincie: 9,
      slug: 'hausen-gemeinde',
    },
    {
      code: '092735217127',
      label: 'Herrngiersdorf',
      provincie: 9,
      slug: 'herrngiersdorf',
    },
    {
      code: '092735217141',
      label: 'Langquaid',
      provincie: 9,
      slug: 'langquaid',
    },
    {
      code: '092735218119',
      label: 'Biburg',
      provincie: 9,
      slug: 'biburg',
    },
    {
      code: '092735218139',
      label: 'Kirchdorf',
      provincie: 9,
      slug: 'kirchdorf-gemeinde',
    },
    {
      code: '092735218172',
      label: 'Siegenburg',
      provincie: 9,
      slug: 'siegenburg',
    },
    {
      code: '092735218177',
      label: 'Train',
      provincie: 9,
      slug: 'train',
    },
    {
      code: '092735218181',
      label: 'Wildenberg',
      provincie: 9,
      slug: 'wildenberg',
    },
    {
      code: '092735219113',
      label: 'Aiglsbach',
      provincie: 9,
      slug: 'aiglsbach',
    },
    {
      code: '092735219115',
      label: 'Attenhofen',
      provincie: 9,
      slug: 'attenhofen',
    },
    {
      code: '092735219163',
      label: 'Elsendorf',
      provincie: 9,
      slug: 'elsendorf',
    },
    {
      code: '092735219178',
      label: 'Volkenschwand',
      provincie: 9,
      slug: 'volkenschwand',
    },
    {
      code: '092740111111',
      label: 'Adlkofen',
      provincie: 9,
      slug: 'adlkofen',
    },
    {
      code: '092740113113',
      label: 'Altdorf',
      provincie: 9,
      slug: 'altdorf-gemeinde',
    },
    {
      code: '092740120120',
      label: 'Bodenkirchen',
      provincie: 9,
      slug: 'bodenkirchen',
    },
    {
      code: '092740121121',
      label: 'Buch a.Erlbach',
      provincie: 9,
      slug: 'buch-a-erlbach',
    },
    {
      code: '092740124124',
      label: 'Eching',
      provincie: 9,
      slug: 'eching-gemeinde',
    },
    {
      code: '092740126126',
      label: 'Ergolding',
      provincie: 9,
      slug: 'ergolding',
    },
    {
      code: '092740128128',
      label: 'Essenbach',
      provincie: 9,
      slug: 'essenbach',
    },
    {
      code: '092740134134',
      label: 'Geisenhausen',
      provincie: 9,
      slug: 'geisenhausen',
    },
    {
      code: '092740141141',
      label: 'Hohenthann',
      provincie: 9,
      slug: 'hohenthann',
    },
    {
      code: '092740146146',
      label: 'Kumhausen',
      provincie: 9,
      slug: 'kumhausen',
    },
    {
      code: '092740153153',
      label: 'Neufahrn i.NB',
      provincie: 9,
      slug: 'neufahrn-i-nb',
    },
    {
      code: '092740156156',
      label: 'Niederaichbach',
      provincie: 9,
      slug: 'niederaichbach',
    },
    {
      code: '092740172172',
      label: 'Pfeffenhausen',
      provincie: 9,
      slug: 'pfeffenhausen',
    },
    {
      code: '092740176176',
      label: 'Rottenburg a.d.Laaber',
      provincie: 9,
      slug: 'rottenburg-a-d-laaber',
    },
    {
      code: '092740182182',
      label: 'Tiefenbach',
      provincie: 9,
      slug: 'tiefenbach-gemeinde',
    },
    {
      code: '092740184184',
      label: 'Vilsbiburg',
      provincie: 9,
      slug: 'vilsbiburg',
    },
    {
      code: '092740185185',
      label: 'Vilsheim',
      provincie: 9,
      slug: 'vilsheim',
    },
    {
      code: '092740194194',
      label: 'Bruckberg',
      provincie: 9,
      slug: 'bruckberg',
    },
    {
      code: '092745220119',
      label: 'Bayerbach b.Ergoldsbach',
      provincie: 9,
      slug: 'bayerbach-b-ergoldsbach',
    },
    {
      code: '092745220127',
      label: 'Ergoldsbach',
      provincie: 9,
      slug: 'ergoldsbach',
    },
    {
      code: '092745221132',
      label: 'Furth',
      provincie: 9,
      slug: 'furth',
    },
    {
      code: '092745221165',
      label: 'Obersüßbach',
      provincie: 9,
      slug: 'obersuessbach',
    },
    {
      code: '092745221187',
      label: 'Weihmichl',
      provincie: 9,
      slug: 'weihmichl',
    },
    {
      code: '092745222174',
      label: 'Postau',
      provincie: 9,
      slug: 'postau',
    },
    {
      code: '092745222188',
      label: 'Weng',
      provincie: 9,
      slug: 'weng',
    },
    {
      code: '092745222191',
      label: 'Wörth a.d.Isar',
      provincie: 9,
      slug: 'woerth-a-d-isar',
    },
    {
      code: '092745223112',
      label: 'Aham',
      provincie: 9,
      slug: 'aham',
    },
    {
      code: '092745223135',
      label: 'Gerzen',
      provincie: 9,
      slug: 'gerzen',
    },
    {
      code: '092745223145',
      label: 'Kröning',
      provincie: 9,
      slug: 'kroening',
    },
    {
      code: '092745223179',
      label: 'Schalkham',
      provincie: 9,
      slug: 'schalkham',
    },
    {
      code: '092745226114',
      label: 'Altfraunhofen',
      provincie: 9,
      slug: 'altfraunhofen',
    },
    {
      code: '092745226118',
      label: 'Baierbach',
      provincie: 9,
      slug: 'baierbach',
    },
    {
      code: '092745227154',
      label: 'Neufraunhofen',
      provincie: 9,
      slug: 'neufraunhofen',
    },
    {
      code: '092745227183',
      label: 'Velden',
      provincie: 9,
      slug: 'velden',
    },
    {
      code: '092745227193',
      label: 'Wurmsham',
      provincie: 9,
      slug: 'wurmsham',
    },
    {
      code: '092750111111',
      label: 'Aicha vorm Wald',
      provincie: 9,
      slug: 'aicha-vorm-wald',
    },
    {
      code: '092750114114',
      label: 'Aldersbach',
      provincie: 9,
      slug: 'aldersbach',
    },
    {
      code: '092750116116',
      label: 'Bad Füssing',
      provincie: 9,
      slug: 'bad-fuessing',
    },
    {
      code: '092750118118',
      label: 'Breitenberg',
      provincie: 9,
      slug: 'breitenberg-gemeinde',
    },
    {
      code: '092750119119',
      label: 'Büchlberg',
      provincie: 9,
      slug: 'buechlberg',
    },
    {
      code: '092750120120',
      label: 'Eging a.See',
      provincie: 9,
      slug: 'eging-a-see',
    },
    {
      code: '092750121121',
      label: 'Fürstenstein',
      provincie: 9,
      slug: 'fuerstenstein',
    },
    {
      code: '092750122122',
      label: 'Fürstenzell',
      provincie: 9,
      slug: 'fuerstenzell',
    },
    {
      code: '092750124124',
      label: 'Bad Griesbach i.Rottal',
      provincie: 9,
      slug: 'bad-griesbach-i-rottal',
    },
    {
      code: '092750125125',
      label: 'Haarbach',
      provincie: 9,
      slug: 'haarbach',
    },
    {
      code: '092750126126',
      label: 'Hauzenberg',
      provincie: 9,
      slug: 'hauzenberg',
    },
    {
      code: '092750127127',
      label: 'Hofkirchen',
      provincie: 9,
      slug: 'hofkirchen',
    },
    {
      code: '092750128128',
      label: 'Hutthurm',
      provincie: 9,
      slug: 'hutthurm',
    },
    {
      code: '092750130130',
      label: 'Kirchham',
      provincie: 9,
      slug: 'kirchham',
    },
    {
      code: '092750131131',
      label: 'Kößlarn',
      provincie: 9,
      slug: 'koesslarn',
    },
    {
      code: '092750133133',
      label: 'Neuburg a.Inn',
      provincie: 9,
      slug: 'neuburg-a-inn',
    },
    {
      code: '092750134134',
      label: 'Neuhaus a.Inn',
      provincie: 9,
      slug: 'neuhaus-a-inn',
    },
    {
      code: '092750135135',
      label: 'Neukirchen vorm Wald',
      provincie: 9,
      slug: 'neukirchen-vorm-wald',
    },
    {
      code: '092750137137',
      label: 'Obernzell',
      provincie: 9,
      slug: 'obernzell',
    },
    {
      code: '092750138138',
      label: 'Ortenburg',
      provincie: 9,
      slug: 'ortenburg',
    },
    {
      code: '092750141141',
      label: 'Pocking',
      provincie: 9,
      slug: 'pocking',
    },
    {
      code: '092750144144',
      label: 'Ruderting',
      provincie: 9,
      slug: 'ruderting',
    },
    {
      code: '092750145145',
      label: 'Ruhstorf a.d.Rott',
      provincie: 9,
      slug: 'ruhstorf-a-d-rott',
    },
    {
      code: '092750146146',
      label: 'Salzweg',
      provincie: 9,
      slug: 'salzweg',
    },
    {
      code: '092750148148',
      label: 'Sonnen',
      provincie: 9,
      slug: 'sonnen',
    },
    {
      code: '092750149149',
      label: 'Tettenweis',
      provincie: 9,
      slug: 'tettenweis',
    },
    {
      code: '092750150150',
      label: 'Thyrnau',
      provincie: 9,
      slug: 'thyrnau',
    },
    {
      code: '092750151151',
      label: 'Tiefenbach',
      provincie: 9,
      slug: 'tiefenbach-gemeinde',
    },
    {
      code: '092750153153',
      label: 'Untergriesbach',
      provincie: 9,
      slug: 'untergriesbach',
    },
    {
      code: '092750154154',
      label: 'Vilshofen an der Donau',
      provincie: 9,
      slug: 'vilshofen-an-der-donau',
    },
    {
      code: '092750156156',
      label: 'Wegscheid',
      provincie: 9,
      slug: 'wegscheid',
    },
    {
      code: '092750159159',
      label: 'Windorf',
      provincie: 9,
      slug: 'windorf',
    },
    {
      code: '092755229152',
      label: 'Tittling',
      provincie: 9,
      slug: 'tittling',
    },
    {
      code: '092755229160',
      label: 'Witzmannsberg',
      provincie: 9,
      slug: 'witzmannsberg',
    },
    {
      code: '092755232112',
      label: 'Aidenbach',
      provincie: 9,
      slug: 'aidenbach',
    },
    {
      code: '092755232117',
      label: 'Beutelsbach',
      provincie: 9,
      slug: 'beutelsbach',
    },
    {
      code: '092755234132',
      label: 'Malching',
      provincie: 9,
      slug: 'malching',
    },
    {
      code: '092755234143',
      label: 'Rotthalmünster',
      provincie: 9,
      slug: 'rotthalmuenster',
    },
    {
      code: '092760113113',
      label: 'Arnbruck',
      provincie: 9,
      slug: 'arnbruck',
    },
    {
      code: '092760115115',
      label: 'Bayerisch Eisenstein',
      provincie: 9,
      slug: 'bayerisch-eisenstein',
    },
    {
      code: '092760116116',
      label: 'Bischofsmais',
      provincie: 9,
      slug: 'bischofsmais',
    },
    {
      code: '092760117117',
      label: 'Bodenmais',
      provincie: 9,
      slug: 'bodenmais',
    },
    {
      code: '092760118118',
      label: 'Böbrach',
      provincie: 9,
      slug: 'boebrach',
    },
    {
      code: '092760120120',
      label: 'Drachselsried',
      provincie: 9,
      slug: 'drachselsried',
    },
    {
      code: '092760121121',
      label: 'Frauenau',
      provincie: 9,
      slug: 'frauenau',
    },
    {
      code: '092760122122',
      label: 'Geiersthal',
      provincie: 9,
      slug: 'geiersthal',
    },
    {
      code: '092760126126',
      label: 'Kirchberg i.Wald',
      provincie: 9,
      slug: 'kirchberg-i-wald',
    },
    {
      code: '092760127127',
      label: 'Kirchdorf i.Wald',
      provincie: 9,
      slug: 'kirchdorf-i-wald',
    },
    {
      code: '092760128128',
      label: 'Kollnburg',
      provincie: 9,
      slug: 'kollnburg',
    },
    {
      code: '092760129129',
      label: 'Langdorf',
      provincie: 9,
      slug: 'langdorf',
    },
    {
      code: '092760130130',
      label: 'Lindberg',
      provincie: 9,
      slug: 'lindberg',
    },
    {
      code: '092760134134',
      label: 'Patersdorf',
      provincie: 9,
      slug: 'patersdorf',
    },
    {
      code: '092760135135',
      label: 'Prackenbach',
      provincie: 9,
      slug: 'prackenbach',
    },
    {
      code: '092760138138',
      label: 'Regen',
      provincie: 9,
      slug: 'regen',
    },
    {
      code: '092760139139',
      label: 'Rinchnach',
      provincie: 9,
      slug: 'rinchnach',
    },
    {
      code: '092760143143',
      label: 'Teisnach',
      provincie: 9,
      slug: 'teisnach',
    },
    {
      code: '092760144144',
      label: 'Viechtach',
      provincie: 9,
      slug: 'viechtach',
    },
    {
      code: '092760148148',
      label: 'Zwiesel',
      provincie: 9,
      slug: 'zwiesel',
    },
    {
      code: '092765238111',
      label: 'Achslach',
      provincie: 9,
      slug: 'achslach',
    },
    {
      code: '092765238123',
      label: 'Gotteszell',
      provincie: 9,
      slug: 'gotteszell',
    },
    {
      code: '092765238142',
      label: 'Ruhmannsfelden',
      provincie: 9,
      slug: 'ruhmannsfelden',
    },
    {
      code: '092765238146',
      label: 'Zachenberg',
      provincie: 9,
      slug: 'zachenberg',
    },
    {
      code: '092770111111',
      label: 'Arnstorf',
      provincie: 9,
      slug: 'arnstorf',
    },
    {
      code: '092770114114',
      label: 'Dietersburg',
      provincie: 9,
      slug: 'dietersburg',
    },
    {
      code: '092770116116',
      label: 'Eggenfelden',
      provincie: 9,
      slug: 'eggenfelden',
    },
    {
      code: '092770117117',
      label: 'Egglham',
      provincie: 9,
      slug: 'egglham',
    },
    {
      code: '092770121121',
      label: 'Gangkofen',
      provincie: 9,
      slug: 'gangkofen',
    },
    {
      code: '092770124124',
      label: 'Hebertsfelden',
      provincie: 9,
      slug: 'hebertsfelden',
    },
    {
      code: '092770126126',
      label: 'Johanniskirchen',
      provincie: 9,
      slug: 'johanniskirchen',
    },
    {
      code: '092770127127',
      label: 'Julbach',
      provincie: 9,
      slug: 'julbach',
    },
    {
      code: '092770128128',
      label: 'Kirchdorf a.Inn',
      provincie: 9,
      slug: 'kirchdorf-a-inn',
    },
    {
      code: '092770134134',
      label: 'Mitterskirchen',
      provincie: 9,
      slug: 'mitterskirchen',
    },
    {
      code: '092770138138',
      label: 'Pfarrkirchen',
      provincie: 9,
      slug: 'pfarrkirchen',
    },
    {
      code: '092770139139',
      label: 'Postmünster',
      provincie: 9,
      slug: 'postmuenster',
    },
    {
      code: '092770142142',
      label: 'Roßbach',
      provincie: 9,
      slug: 'rossbach-gemeinde',
    },
    {
      code: '092770144144',
      label: 'Schönau',
      provincie: 9,
      slug: 'schoenau-gemeinde',
    },
    {
      code: '092770145145',
      label: 'Simbach a.Inn',
      provincie: 9,
      slug: 'simbach-a-inn',
    },
    {
      code: '092770149149',
      label: 'Triftern',
      provincie: 9,
      slug: 'triftern',
    },
    {
      code: '092770151151',
      label: 'Unterdietfurt',
      provincie: 9,
      slug: 'unterdietfurt',
    },
    {
      code: '092770152152',
      label: 'Wittibreut',
      provincie: 9,
      slug: 'wittibreut',
    },
    {
      code: '092770153153',
      label: 'Wurmannsquick',
      provincie: 9,
      slug: 'wurmannsquick',
    },
    {
      code: '092770154154',
      label: 'Zeilarn',
      provincie: 9,
      slug: 'zeilarn',
    },
    {
      code: '092775239119',
      label: 'Falkenberg',
      provincie: 9,
      slug: 'falkenberg',
    },
    {
      code: '092775239131',
      label: 'Malgersdorf',
      provincie: 9,
      slug: 'malgersdorf',
    },
    {
      code: '092775239141',
      label: 'Rimbach',
      provincie: 9,
      slug: 'rimbach-gemeinde',
    },
    {
      code: '092775240122',
      label: 'Geratskirchen',
      provincie: 9,
      slug: 'geratskirchen',
    },
    {
      code: '092775240133',
      label: 'Massing',
      provincie: 9,
      slug: 'massing',
    },
    {
      code: '092775241112',
      label: 'Bayerbach',
      provincie: 9,
      slug: 'bayerbach',
    },
    {
      code: '092775241113',
      label: 'Bad Birnbach',
      provincie: 9,
      slug: 'bad-birnbach',
    },
    {
      code: '092775243140',
      label: 'Reut',
      provincie: 9,
      slug: 'reut',
    },
    {
      code: '092775243148',
      label: 'Tann',
      provincie: 9,
      slug: 'tann',
    },
    {
      code: '092775244118',
      label: 'Ering',
      provincie: 9,
      slug: 'ering',
    },
    {
      code: '092775244147',
      label: 'Stubenberg',
      provincie: 9,
      slug: 'stubenberg',
    },
    {
      code: '092780118118',
      label: 'Bogen',
      provincie: 9,
      slug: 'bogen',
    },
    {
      code: '092780121121',
      label: 'Feldkirchen',
      provincie: 9,
      slug: 'feldkirchen-gemeinde',
    },
    {
      code: '092780123123',
      label: 'Geiselhöring',
      provincie: 9,
      slug: 'geiselhoering',
    },
    {
      code: '092780129129',
      label: 'Haibach',
      provincie: 9,
      slug: 'haibach',
    },
    {
      code: '092780141141',
      label: 'Kirchroth',
      provincie: 9,
      slug: 'kirchroth',
    },
    {
      code: '092780143143',
      label: 'Konzell',
      provincie: 9,
      slug: 'konzell',
    },
    {
      code: '092780144144',
      label: 'Laberweinting',
      provincie: 9,
      slug: 'laberweinting',
    },
    {
      code: '092780146146',
      label: 'Leiblfing',
      provincie: 9,
      slug: 'leiblfing',
    },
    {
      code: '092780148148',
      label: 'Mallersdorf-Pfaffenberg',
      provincie: 9,
      slug: 'mallersdorf-pfaffenberg',
    },
    {
      code: '092780167167',
      label: 'Oberschneiding',
      provincie: 9,
      slug: 'oberschneiding',
    },
    {
      code: '092780170170',
      label: 'Parkstetten',
      provincie: 9,
      slug: 'parkstetten',
    },
    {
      code: '092780178178',
      label: 'Rattenberg',
      provincie: 9,
      slug: 'rattenberg',
    },
    {
      code: '092780184184',
      label: 'Sankt Englmar',
      provincie: 9,
      slug: 'sankt-englmar',
    },
    {
      code: '092780190190',
      label: 'Steinach',
      provincie: 9,
      slug: 'steinach-gemeinde',
    },
    {
      code: '092780197197',
      label: 'Wiesenfelden',
      provincie: 9,
      slug: 'wiesenfelden',
    },
    {
      code: '092785246147',
      label: 'Loitzendorf',
      provincie: 9,
      slug: 'loitzendorf',
    },
    {
      code: '092785246179',
      label: 'Rattiszell',
      provincie: 9,
      slug: 'rattiszell',
    },
    {
      code: '092785246189',
      label: 'Stallwang',
      provincie: 9,
      slug: 'stallwang',
    },
    {
      code: '092785248116',
      label: 'Ascha',
      provincie: 9,
      slug: 'ascha',
    },
    {
      code: '092785248120',
      label: 'Falkenfels',
      provincie: 9,
      slug: 'falkenfels',
    },
    {
      code: '092785248134',
      label: 'Haselbach',
      provincie: 9,
      slug: 'haselbach',
    },
    {
      code: '092785248151',
      label: 'Mitterfels',
      provincie: 9,
      slug: 'mitterfels',
    },
    {
      code: '092785249139',
      label: 'Hunderdorf',
      provincie: 9,
      slug: 'hunderdorf',
    },
    {
      code: '092785249154',
      label: 'Neukirchen',
      provincie: 9,
      slug: 'neukirchen-gemeinde',
    },
    {
      code: '092785249198',
      label: 'Windberg',
      provincie: 9,
      slug: 'windberg',
    },
    {
      code: '092785250112',
      label: 'Aholfing',
      provincie: 9,
      slug: 'aholfing',
    },
    {
      code: '092785250117',
      label: 'Atting',
      provincie: 9,
      slug: 'atting',
    },
    {
      code: '092785250172',
      label: 'Perkam',
      provincie: 9,
      slug: 'perkam',
    },
    {
      code: '092785250177',
      label: 'Rain',
      provincie: 9,
      slug: 'rain',
    },
    {
      code: '092785252149',
      label: 'Mariaposching',
      provincie: 9,
      slug: 'mariaposching',
    },
    {
      code: '092785252159',
      label: 'Niederwinkling',
      provincie: 9,
      slug: 'niederwinkling',
    },
    {
      code: '092785252171',
      label: 'Perasdorf',
      provincie: 9,
      slug: 'perasdorf',
    },
    {
      code: '092785252187',
      label: 'Schwarzach',
      provincie: 9,
      slug: 'schwarzach-gemeinde',
    },
    {
      code: '092785256113',
      label: 'Aiterhofen',
      provincie: 9,
      slug: 'aiterhofen',
    },
    {
      code: '092785256182',
      label: 'Salching',
      provincie: 9,
      slug: 'salching',
    },
    {
      code: '092785257140',
      label: 'Irlbach',
      provincie: 9,
      slug: 'irlbach',
    },
    {
      code: '092785257192',
      label: 'Straßkirchen',
      provincie: 9,
      slug: 'strasskirchen',
    },
    {
      code: '092790112112',
      label: 'Dingolfing',
      provincie: 9,
      slug: 'dingolfing',
    },
    {
      code: '092790113113',
      label: 'Eichendorf',
      provincie: 9,
      slug: 'eichendorf',
    },
    {
      code: '092790115115',
      label: 'Frontenhausen',
      provincie: 9,
      slug: 'frontenhausen',
    },
    {
      code: '092790122122',
      label: 'Landau a.d.Isar',
      provincie: 9,
      slug: 'landau-a-d-isar',
    },
    {
      code: '092790124124',
      label: 'Loiching',
      provincie: 9,
      slug: 'loiching',
    },
    {
      code: '092790126126',
      label: 'Marklkofen',
      provincie: 9,
      slug: 'marklkofen',
    },
    {
      code: '092790127127',
      label: 'Mengkofen',
      provincie: 9,
      slug: 'mengkofen',
    },
    {
      code: '092790128128',
      label: 'Moosthenning',
      provincie: 9,
      slug: 'moosthenning',
    },
    {
      code: '092790130130',
      label: 'Niederviehbach',
      provincie: 9,
      slug: 'niederviehbach',
    },
    {
      code: '092790132132',
      label: 'Pilsting',
      provincie: 9,
      slug: 'pilsting',
    },
    {
      code: '092790134134',
      label: 'Reisbach',
      provincie: 9,
      slug: 'reisbach',
    },
    {
      code: '092790135135',
      label: 'Simbach',
      provincie: 9,
      slug: 'simbach',
    },
    {
      code: '092790137137',
      label: 'Wallersdorf',
      provincie: 9,
      slug: 'wallersdorf',
    },
    {
      code: '092795208116',
      label: 'Gottfrieding',
      provincie: 9,
      slug: 'gottfrieding',
    },
    {
      code: '092795208125',
      label: 'Mamming',
      provincie: 9,
      slug: 'mamming',
    },
    {
      code: '093610000000',
      label: 'Amberg',
      provincie: 9,
      slug: 'amberg',
    },
    {
      code: '093620000000',
      label: 'Regensburg',
      provincie: 9,
      slug: 'regensburg',
    },
    {
      code: '093630000000',
      label: 'Weiden i.d.OPf.',
      provincie: 9,
      slug: 'weiden-i-d-opf',
    },
    {
      code: '093710111111',
      label: 'Ammerthal',
      provincie: 9,
      slug: 'ammerthal',
    },
    {
      code: '093710113113',
      label: 'Auerbach i.d.OPf.',
      provincie: 9,
      slug: 'auerbach-i-d-opf',
    },
    {
      code: '093710118118',
      label: 'Ebermannsdorf',
      provincie: 9,
      slug: 'ebermannsdorf',
    },
    {
      code: '093710119119',
      label: 'Edelsfeld',
      provincie: 9,
      slug: 'edelsfeld',
    },
    {
      code: '093710120120',
      label: 'Ensdorf',
      provincie: 9,
      slug: 'ensdorf',
    },
    {
      code: '093710121121',
      label: 'Freihung',
      provincie: 9,
      slug: 'freihung',
    },
    {
      code: '093710122122',
      label: 'Freudenberg',
      provincie: 9,
      slug: 'freudenberg-gemeinde',
    },
    {
      code: '093710127127',
      label: 'Hirschau',
      provincie: 9,
      slug: 'hirschau',
    },
    {
      code: '093710129129',
      label: 'Hohenburg',
      provincie: 9,
      slug: 'hohenburg',
    },
    {
      code: '093710132132',
      label: 'Kastl',
      provincie: 9,
      slug: 'kastl-gemeinde',
    },
    {
      code: '093710136136',
      label: 'Kümmersbruck',
      provincie: 9,
      slug: 'kuemmersbruck',
    },
    {
      code: '093710144144',
      label: 'Poppenricht',
      provincie: 9,
      slug: 'poppenricht',
    },
    {
      code: '093710146146',
      label: 'Rieden',
      provincie: 9,
      slug: 'rieden-gemeinde',
    },
    {
      code: '093710148148',
      label: 'Schmidmühlen',
      provincie: 9,
      slug: 'schmidmuehlen',
    },
    {
      code: '093710150150',
      label: 'Schnaittenbach',
      provincie: 9,
      slug: 'schnaittenbach',
    },
    {
      code: '093710151151',
      label: 'Sulzbach-Rosenberg',
      provincie: 9,
      slug: 'sulzbach-rosenberg',
    },
    {
      code: '093710154154',
      label: 'Ursensollen',
      provincie: 9,
      slug: 'ursensollen',
    },
    {
      code: '093710156156',
      label: 'Vilseck',
      provincie: 9,
      slug: 'vilseck',
    },
    {
      code: '093715301123',
      label: 'Gebenbach',
      provincie: 9,
      slug: 'gebenbach',
    },
    {
      code: '093715301126',
      label: 'Hahnbach',
      provincie: 9,
      slug: 'hahnbach',
    },
    {
      code: '093715302128',
      label: 'Hirschbach',
      provincie: 9,
      slug: 'hirschbach',
    },
    {
      code: '093715302135',
      label: 'Königstein',
      provincie: 9,
      slug: 'koenigstein',
    },
    {
      code: '093715303140',
      label: 'Etzelwang',
      provincie: 9,
      slug: 'etzelwang',
    },
    {
      code: '093715303141',
      label: 'Neukirchen b.Sulzbach-Rosenberg',
      provincie: 9,
      slug: 'neukirchen-b-sulzbach-rosenberg',
    },
    {
      code: '093715303157',
      label: 'Weigendorf',
      provincie: 9,
      slug: 'weigendorf',
    },
    {
      code: '093715304116',
      label: 'Birgland',
      provincie: 9,
      slug: 'birgland',
    },
    {
      code: '093715304131',
      label: 'Illschwang',
      provincie: 9,
      slug: 'illschwang',
    },
    {
      code: '093720112112',
      label: 'Arnschwang',
      provincie: 9,
      slug: 'arnschwang',
    },
    {
      code: '093720113113',
      label: 'Arrach',
      provincie: 9,
      slug: 'arrach',
    },
    {
      code: '093720115115',
      label: 'Blaibach',
      provincie: 9,
      slug: 'blaibach',
    },
    {
      code: '093720116116',
      label: 'Cham',
      provincie: 9,
      slug: 'cham',
    },
    {
      code: '093720117117',
      label: 'Chamerau',
      provincie: 9,
      slug: 'chamerau',
    },
    {
      code: '093720124124',
      label: 'Eschlkam',
      provincie: 9,
      slug: 'eschlkam',
    },
    {
      code: '093720126126',
      label: 'Furth im Wald',
      provincie: 9,
      slug: 'furth-im-wald',
    },
    {
      code: '093720130130',
      label: 'Grafenwiesen',
      provincie: 9,
      slug: 'grafenwiesen',
    },
    {
      code: '093720135135',
      label: 'Hohenwarth',
      provincie: 9,
      slug: 'hohenwarth',
    },
    {
      code: '093720137137',
      label: 'Bad Kötzting',
      provincie: 9,
      slug: 'bad-koetzting',
    },
    {
      code: '093720138138',
      label: 'Lam',
      provincie: 9,
      slug: 'lam',
    },
    {
      code: '093720143143',
      label: 'Miltach',
      provincie: 9,
      slug: 'miltach',
    },
    {
      code: '093720144144',
      label: 'Neukirchen b.Hl.Blut',
      provincie: 9,
      slug: 'neukirchen-b-hl-blut',
    },
    {
      code: '093720146146',
      label: 'Pemfling',
      provincie: 9,
      slug: 'pemfling',
    },
    {
      code: '093720151151',
      label: 'Rimbach',
      provincie: 9,
      slug: 'rimbach-gemeinde',
    },
    {
      code: '093720153153',
      label: 'Roding',
      provincie: 9,
      slug: 'roding',
    },
    {
      code: '093720154154',
      label: 'Rötz',
      provincie: 9,
      slug: 'roetz',
    },
    {
      code: '093720155155',
      label: 'Runding',
      provincie: 9,
      slug: 'runding',
    },
    {
      code: '093720157157',
      label: 'Schönthal',
      provincie: 9,
      slug: 'schoenthal',
    },
    {
      code: '093720158158',
      label: 'Schorndorf',
      provincie: 9,
      slug: 'schorndorf-gemeinde',
    },
    {
      code: '093720164164',
      label: 'Traitsching',
      provincie: 9,
      slug: 'traitsching',
    },
    {
      code: '093720168168',
      label: 'Waffenbrunn',
      provincie: 9,
      slug: 'waffenbrunn',
    },
    {
      code: '093720171171',
      label: 'Waldmünchen',
      provincie: 9,
      slug: 'waldmuenchen',
    },
    {
      code: '093720175175',
      label: 'Willmering',
      provincie: 9,
      slug: 'willmering',
    },
    {
      code: '093720177177',
      label: 'Zandt',
      provincie: 9,
      slug: 'zandt',
    },
    {
      code: '093720178178',
      label: 'Lohberg',
      provincie: 9,
      slug: 'lohberg',
    },
    {
      code: '093725308163',
      label: 'Tiefenbach',
      provincie: 9,
      slug: 'tiefenbach-gemeinde',
    },
    {
      code: '093725308165',
      label: 'Treffelstein',
      provincie: 9,
      slug: 'treffelstein',
    },
    {
      code: '093725310147',
      label: 'Pösing',
      provincie: 9,
      slug: 'poesing',
    },
    {
      code: '093725310161',
      label: 'Stamsried',
      provincie: 9,
      slug: 'stamsried',
    },
    {
      code: '093725312128',
      label: 'Gleißenberg',
      provincie: 9,
      slug: 'gleissenberg',
    },
    {
      code: '093725312174',
      label: 'Weiding',
      provincie: 9,
      slug: 'weiding',
    },
    {
      code: '093725313149',
      label: 'Reichenbach',
      provincie: 9,
      slug: 'reichenbach-gemeinde',
    },
    {
      code: '093725313170',
      label: 'Walderbach',
      provincie: 9,
      slug: 'walderbach',
    },
    {
      code: '093725317167',
      label: 'Zell',
      provincie: 9,
      slug: 'zell',
    },
    {
      code: '093725317169',
      label: 'Wald',
      provincie: 9,
      slug: 'wald-gemeinde',
    },
    {
      code: '093725318125',
      label: 'Falkenstein',
      provincie: 9,
      slug: 'falkenstein-gemeinde',
    },
    {
      code: '093725318142',
      label: 'Michelsneukirchen',
      provincie: 9,
      slug: 'michelsneukirchen',
    },
    {
      code: '093725318150',
      label: 'Rettenbach',
      provincie: 9,
      slug: 'rettenbach',
    },
    {
      code: '093730112112',
      label: 'Berching',
      provincie: 9,
      slug: 'berching',
    },
    {
      code: '093730113113',
      label: 'Berg b.Neumarkt i.d.OPf.',
      provincie: 9,
      slug: 'berg-b-neumarkt-i-d-opf',
    },
    {
      code: '093730115115',
      label: 'Breitenbrunn',
      provincie: 9,
      slug: 'breitenbrunn',
    },
    {
      code: '093730119119',
      label: 'Deining',
      provincie: 9,
      slug: 'deining',
    },
    {
      code: '093730121121',
      label: 'Dietfurt a.d.Altmühl',
      provincie: 9,
      slug: 'dietfurt-a-d-altmuehl',
    },
    {
      code: '093730126126',
      label: 'Freystadt',
      provincie: 9,
      slug: 'freystadt',
    },
    {
      code: '093730134134',
      label: 'Hohenfels',
      provincie: 9,
      slug: 'hohenfels-gemeinde',
    },
    {
      code: '093730140140',
      label: 'Lauterhofen',
      provincie: 9,
      slug: 'lauterhofen',
    },
    {
      code: '093730143143',
      label: 'Lupburg',
      provincie: 9,
      slug: 'lupburg',
    },
    {
      code: '093730146146',
      label: 'Mühlhausen',
      provincie: 9,
      slug: 'muehlhausen-gemeinde',
    },
    {
      code: '093730147147',
      label: 'Neumarkt i.d.OPf.',
      provincie: 9,
      slug: 'neumarkt-i-d-opf',
    },
    {
      code: '093730151151',
      label: 'Parsberg',
      provincie: 9,
      slug: 'parsberg',
    },
    {
      code: '093730155155',
      label: 'Postbauer-Heng',
      provincie: 9,
      slug: 'postbauer-heng',
    },
    {
      code: '093730156156',
      label: 'Pyrbaum',
      provincie: 9,
      slug: 'pyrbaum',
    },
    {
      code: '093730160160',
      label: 'Seubersdorf i.d.OPf.',
      provincie: 9,
      slug: 'seubersdorf-i-d-opf',
    },
    {
      code: '093730167167',
      label: 'Velburg',
      provincie: 9,
      slug: 'velburg',
    },
    {
      code: '093735321114',
      label: 'Berngau',
      provincie: 9,
      slug: 'berngau',
    },
    {
      code: '093735321153',
      label: 'Pilsach',
      provincie: 9,
      slug: 'pilsach',
    },
    {
      code: '093735321159',
      label: 'Sengenthal',
      provincie: 9,
      slug: 'sengenthal',
    },
    {
      code: '093740111111',
      label: 'Altenstadt a.d.Waldnaab',
      provincie: 9,
      slug: 'altenstadt-a-d-waldnaab',
    },
    {
      code: '093740118118',
      label: 'Eslarn',
      provincie: 9,
      slug: 'eslarn',
    },
    {
      code: '093740121121',
      label: 'Floß',
      provincie: 9,
      slug: 'floss',
    },
    {
      code: '093740122122',
      label: 'Flossenbürg',
      provincie: 9,
      slug: 'flossenbuerg',
    },
    {
      code: '093740124124',
      label: 'Grafenwöhr',
      provincie: 9,
      slug: 'grafenwoehr',
    },
    {
      code: '093740133133',
      label: 'Luhe-Wildenau',
      provincie: 9,
      slug: 'luhe-wildenau',
    },
    {
      code: '093740134134',
      label: 'Mantel',
      provincie: 9,
      slug: 'mantel',
    },
    {
      code: '093740137137',
      label: 'Moosbach',
      provincie: 9,
      slug: 'moosbach',
    },
    {
      code: '093740139139',
      label: 'Neustadt a.d.Waldnaab',
      provincie: 9,
      slug: 'neustadt-a-d-waldnaab',
    },
    {
      code: '093740162162',
      label: 'Vohenstrauß',
      provincie: 9,
      slug: 'vohenstrauss',
    },
    {
      code: '093740164164',
      label: 'Waidhaus',
      provincie: 9,
      slug: 'waidhaus',
    },
    {
      code: '093740165165',
      label: 'Waldthurn',
      provincie: 9,
      slug: 'waldthurn',
    },
    {
      code: '093740168168',
      label: 'Windischeschenbach',
      provincie: 9,
      slug: 'windischeschenbach',
    },
    {
      code: '093745323128',
      label: 'Kirchendemenreuth',
      provincie: 9,
      slug: 'kirchendemenreuth',
    },
    {
      code: '093745323144',
      label: 'Parkstein',
      provincie: 9,
      slug: 'parkstein',
    },
    {
      code: '093745323150',
      label: 'Püchersreuth',
      provincie: 9,
      slug: 'puechersreuth',
    },
    {
      code: '093745323158',
      label: 'Störnstein',
      provincie: 9,
      slug: 'stoernstein',
    },
    {
      code: '093745323160',
      label: 'Theisseil',
      provincie: 9,
      slug: 'theisseil',
    },
    {
      code: '093745324148',
      label: 'Trabitz',
      provincie: 9,
      slug: 'trabitz',
    },
    {
      code: '093745324149',
      label: 'Pressath',
      provincie: 9,
      slug: 'pressath',
    },
    {
      code: '093745324156',
      label: 'Schwarzenbach',
      provincie: 9,
      slug: 'schwarzenbach',
    },
    {
      code: '093745325119',
      label: 'Etzenricht',
      provincie: 9,
      slug: 'etzenricht',
    },
    {
      code: '093745325131',
      label: 'Kohlberg',
      provincie: 9,
      slug: 'kohlberg-gemeinde',
    },
    {
      code: '093745325166',
      label: 'Weiherhammer',
      provincie: 9,
      slug: 'weiherhammer',
    },
    {
      code: '093745326129',
      label: 'Kirchenthumbach',
      provincie: 9,
      slug: 'kirchenthumbach',
    },
    {
      code: '093745326155',
      label: 'Schlammersdorf',
      provincie: 9,
      slug: 'schlammersdorf',
    },
    {
      code: '093745326163',
      label: 'Vorbach',
      provincie: 9,
      slug: 'vorbach',
    },
    {
      code: '093745327117',
      label: 'Eschenbach i.d.OPf.',
      provincie: 9,
      slug: 'eschenbach-i-d-opf',
    },
    {
      code: '093745327140',
      label: 'Neustadt am Kulm',
      provincie: 9,
      slug: 'neustadt-am-kulm',
    },
    {
      code: '093745327157',
      label: 'Speinshart',
      provincie: 9,
      slug: 'speinshart',
    },
    {
      code: '093745329127',
      label: 'Irchenrieth',
      provincie: 9,
      slug: 'irchenrieth',
    },
    {
      code: '093745329146',
      label: 'Pirk',
      provincie: 9,
      slug: 'pirk',
    },
    {
      code: '093745329154',
      label: 'Schirmitz',
      provincie: 9,
      slug: 'schirmitz',
    },
    {
      code: '093745329170',
      label: 'Bechtsrieth',
      provincie: 9,
      slug: 'bechtsrieth',
    },
    {
      code: '093745330132',
      label: 'Leuchtenberg',
      provincie: 9,
      slug: 'leuchtenberg',
    },
    {
      code: '093745330159',
      label: 'Tännesberg',
      provincie: 9,
      slug: 'taennesberg',
    },
    {
      code: '093745331123',
      label: 'Georgenberg',
      provincie: 9,
      slug: 'georgenberg',
    },
    {
      code: '093745331147',
      label: 'Pleystein',
      provincie: 9,
      slug: 'pleystein',
    },
    {
      code: '093750117117',
      label: 'Barbing',
      provincie: 9,
      slug: 'barbing',
    },
    {
      code: '093750118118',
      label: 'Beratzhausen',
      provincie: 9,
      slug: 'beratzhausen',
    },
    {
      code: '093750119119',
      label: 'Bernhardswald',
      provincie: 9,
      slug: 'bernhardswald',
    },
    {
      code: '093750143143',
      label: 'Hagelstadt',
      provincie: 9,
      slug: 'hagelstadt',
    },
    {
      code: '093750148148',
      label: 'Hemau',
      provincie: 9,
      slug: 'hemau',
    },
    {
      code: '093750161161',
      label: 'Köfering',
      provincie: 9,
      slug: 'koefering',
    },
    {
      code: '093750165165',
      label: 'Lappersdorf',
      provincie: 9,
      slug: 'lappersdorf',
    },
    {
      code: '093750170170',
      label: 'Mintraching',
      provincie: 9,
      slug: 'mintraching',
    },
    {
      code: '093750174174',
      label: 'Neutraubling',
      provincie: 9,
      slug: 'neutraubling',
    },
    {
      code: '093750175175',
      label: 'Nittendorf',
      provincie: 9,
      slug: 'nittendorf',
    },
    {
      code: '093750179179',
      label: 'Obertraubling',
      provincie: 9,
      slug: 'obertraubling',
    },
    {
      code: '093750180180',
      label: 'Pentling',
      provincie: 9,
      slug: 'pentling',
    },
    {
      code: '093750181181',
      label: 'Pettendorf',
      provincie: 9,
      slug: 'pettendorf',
    },
    {
      code: '093750183183',
      label: 'Pfatter',
      provincie: 9,
      slug: 'pfatter',
    },
    {
      code: '093750190190',
      label: 'Regenstauf',
      provincie: 9,
      slug: 'regenstauf',
    },
    {
      code: '093750196196',
      label: 'Schierling',
      provincie: 9,
      slug: 'schierling',
    },
    {
      code: '093750199199',
      label: 'Sinzing',
      provincie: 9,
      slug: 'sinzing',
    },
    {
      code: '093750204204',
      label: 'Tegernheim',
      provincie: 9,
      slug: 'tegernheim',
    },
    {
      code: '093750205205',
      label: 'Thalmassing',
      provincie: 9,
      slug: 'thalmassing',
    },
    {
      code: '093750208208',
      label: 'Wenzenbach',
      provincie: 9,
      slug: 'wenzenbach',
    },
    {
      code: '093750209209',
      label: 'Wiesent',
      provincie: 9,
      slug: 'wiesent',
    },
    {
      code: '093750213213',
      label: 'Zeitlarn',
      provincie: 9,
      slug: 'zeitlarn',
    },
    {
      code: '093755332131',
      label: 'Duggendorf',
      provincie: 9,
      slug: 'duggendorf',
    },
    {
      code: '093755332153',
      label: 'Holzheim a.Forst',
      provincie: 9,
      slug: 'holzheim-a-forst',
    },
    {
      code: '093755332156',
      label: 'Kallmünz',
      provincie: 9,
      slug: 'kallmuenz',
    },
    {
      code: '093755333122',
      label: 'Brunn',
      provincie: 9,
      slug: 'brunn',
    },
    {
      code: '093755333127',
      label: 'Deuerling',
      provincie: 9,
      slug: 'deuerling',
    },
    {
      code: '093755333162',
      label: 'Laaber',
      provincie: 9,
      slug: 'laaber',
    },
    {
      code: '093755334184',
      label: 'Pielenhofen',
      provincie: 9,
      slug: 'pielenhofen',
    },
    {
      code: '093755334211',
      label: 'Wolfsegg',
      provincie: 9,
      slug: 'wolfsegg',
    },
    {
      code: '093755335114',
      label: 'Altenthann',
      provincie: 9,
      slug: 'altenthann',
    },
    {
      code: '093755335116',
      label: 'Bach a.d.Donau',
      provincie: 9,
      slug: 'bach-a-d-donau',
    },
    {
      code: '093755335130',
      label: 'Donaustauf',
      provincie: 9,
      slug: 'donaustauf',
    },
    {
      code: '093755336120',
      label: 'Brennberg',
      provincie: 9,
      slug: 'brennberg',
    },
    {
      code: '093755336210',
      label: 'Wörth a.d.Donau',
      provincie: 9,
      slug: 'woerth-a-d-donau',
    },
    {
      code: '093755337113',
      label: 'Alteglofsheim',
      provincie: 9,
      slug: 'alteglofsheim',
    },
    {
      code: '093755337182',
      label: 'Pfakofen',
      provincie: 9,
      slug: 'pfakofen',
    },
    {
      code: '093755338115',
      label: 'Aufhausen',
      provincie: 9,
      slug: 'aufhausen',
    },
    {
      code: '093755338171',
      label: 'Mötzing',
      provincie: 9,
      slug: 'moetzing',
    },
    {
      code: '093755338191',
      label: 'Riekofen',
      provincie: 9,
      slug: 'riekofen',
    },
    {
      code: '093755338201',
      label: 'Sünching',
      provincie: 9,
      slug: 'suenching',
    },
    {
      code: '093760116116',
      label: 'Bodenwöhr',
      provincie: 9,
      slug: 'bodenwoehr',
    },
    {
      code: '093760117117',
      label: 'Bruck i.d.OPf.',
      provincie: 9,
      slug: 'bruck-i-d-opf',
    },
    {
      code: '093760119119',
      label: 'Burglengenfeld',
      provincie: 9,
      slug: 'burglengenfeld',
    },
    {
      code: '093760125125',
      label: 'Fensterbach',
      provincie: 9,
      slug: 'fensterbach',
    },
    {
      code: '093760141141',
      label: 'Maxhütte-Haidhof',
      provincie: 9,
      slug: 'maxhuette-haidhof',
    },
    {
      code: '093760147147',
      label: 'Neunburg vorm Wald',
      provincie: 9,
      slug: 'neunburg-vorm-wald',
    },
    {
      code: '093760149149',
      label: 'Nittenau',
      provincie: 9,
      slug: 'nittenau',
    },
    {
      code: '093760150150',
      label: 'Wernberg-Köblitz',
      provincie: 9,
      slug: 'wernberg-koeblitz',
    },
    {
      code: '093760151151',
      label: 'Oberviechtach',
      provincie: 9,
      slug: 'oberviechtach',
    },
    {
      code: '093760159159',
      label: 'Schmidgaden',
      provincie: 9,
      slug: 'schmidgaden',
    },
    {
      code: '093760161161',
      label: 'Schwandorf',
      provincie: 9,
      slug: 'schwandorf',
    },
    {
      code: '093760170170',
      label: 'Teublitz',
      provincie: 9,
      slug: 'teublitz',
    },
    {
      code: '093765339131',
      label: 'Gleiritsch',
      provincie: 9,
      slug: 'gleiritsch',
    },
    {
      code: '093765339148',
      label: 'Niedermurach',
      provincie: 9,
      slug: 'niedermurach',
    },
    {
      code: '093765339171',
      label: 'Teunz',
      provincie: 9,
      slug: 'teunz',
    },
    {
      code: '093765339178',
      label: 'Winklarn',
      provincie: 9,
      slug: 'winklarn',
    },
    {
      code: '093765341112',
      label: 'Altendorf',
      provincie: 9,
      slug: 'altendorf',
    },
    {
      code: '093765341133',
      label: 'Guteneck',
      provincie: 9,
      slug: 'guteneck',
    },
    {
      code: '093765341144',
      label: 'Nabburg',
      provincie: 9,
      slug: 'nabburg',
    },
    {
      code: '093765342162',
      label: 'Schwarzach b.Nabburg',
      provincie: 9,
      slug: 'schwarzach-b-nabburg',
    },
    {
      code: '093765342163',
      label: 'Schwarzenfeld',
      provincie: 9,
      slug: 'schwarzenfeld',
    },
    {
      code: '093765342169',
      label: 'Stulln',
      provincie: 9,
      slug: 'stulln',
    },
    {
      code: '093765343153',
      label: 'Pfreimd',
      provincie: 9,
      slug: 'pfreimd',
    },
    {
      code: '093765343173',
      label: 'Trausnitz',
      provincie: 9,
      slug: 'trausnitz',
    },
    {
      code: '093765344160',
      label: 'Schönsee',
      provincie: 9,
      slug: 'schoensee',
    },
    {
      code: '093765344167',
      label: 'Stadlern',
      provincie: 9,
      slug: 'stadlern',
    },
    {
      code: '093765344176',
      label: 'Weiding',
      provincie: 9,
      slug: 'weiding-gemeinde',
    },
    {
      code: '093765345122',
      label: 'Dieterskirchen',
      provincie: 9,
      slug: 'dieterskirchen',
    },
    {
      code: '093765345146',
      label: 'Neukirchen-Balbini',
      provincie: 9,
      slug: 'neukirchen-balbini',
    },
    {
      code: '093765345164',
      label: 'Schwarzhofen',
      provincie: 9,
      slug: 'schwarzhofen',
    },
    {
      code: '093765345172',
      label: 'Thanstein',
      provincie: 9,
      slug: 'thanstein',
    },
    {
      code: '093765346168',
      label: 'Steinberg am See',
      provincie: 9,
      slug: 'steinberg-am-see',
    },
    {
      code: '093765346175',
      label: 'Wackersdorf',
      provincie: 9,
      slug: 'wackersdorf',
    },
    {
      code: '093770112112',
      label: 'Bärnau',
      provincie: 9,
      slug: 'baernau',
    },
    {
      code: '093770116116',
      label: 'Erbendorf',
      provincie: 9,
      slug: 'erbendorf',
    },
    {
      code: '093770118118',
      label: 'Friedenfels',
      provincie: 9,
      slug: 'friedenfels',
    },
    {
      code: '093770119119',
      label: 'Fuchsmühl',
      provincie: 9,
      slug: 'fuchsmuehl',
    },
    {
      code: '093770127127',
      label: 'Immenreuth',
      provincie: 9,
      slug: 'immenreuth',
    },
    {
      code: '093770131131',
      label: 'Konnersreuth',
      provincie: 9,
      slug: 'konnersreuth',
    },
    {
      code: '093770133133',
      label: 'Kulmain',
      provincie: 9,
      slug: 'kulmain',
    },
    {
      code: '093770139139',
      label: 'Mähring',
      provincie: 9,
      slug: 'maehring',
    },
    {
      code: '093770142142',
      label: 'Bad Neualbenreuth',
      provincie: 9,
      slug: 'bad-neualbenreuth',
    },
    {
      code: '093770146146',
      label: 'Plößberg',
      provincie: 9,
      slug: 'ploessberg',
    },
    {
      code: '093770154154',
      label: 'Tirschenreuth',
      provincie: 9,
      slug: 'tirschenreuth',
    },
    {
      code: '093770157157',
      label: 'Waldershof',
      provincie: 9,
      slug: 'waldershof',
    },
    {
      code: '093770158158',
      label: 'Waldsassen',
      provincie: 9,
      slug: 'waldsassen',
    },
    {
      code: '093775347137',
      label: 'Leonberg',
      provincie: 9,
      slug: 'leonberg-gemeinde',
    },
    {
      code: '093775347141',
      label: 'Mitterteich',
      provincie: 9,
      slug: 'mitterteich',
    },
    {
      code: '093775347145',
      label: 'Pechbrunn',
      provincie: 9,
      slug: 'pechbrunn',
    },
    {
      code: '093775348128',
      label: 'Kastl',
      provincie: 9,
      slug: 'kastl-gemeinde',
    },
    {
      code: '093775348129',
      label: 'Kemnath',
      provincie: 9,
      slug: 'kemnath',
    },
    {
      code: '093775349113',
      label: 'Brand',
      provincie: 9,
      slug: 'brand',
    },
    {
      code: '093775349115',
      label: 'Ebnath',
      provincie: 9,
      slug: 'ebnath',
    },
    {
      code: '093775349143',
      label: 'Neusorg',
      provincie: 9,
      slug: 'neusorg',
    },
    {
      code: '093775349148',
      label: 'Pullenreuth',
      provincie: 9,
      slug: 'pullenreuth',
    },
    {
      code: '093775350132',
      label: 'Krummennaab',
      provincie: 9,
      slug: 'krummennaab',
    },
    {
      code: '093775350149',
      label: 'Reuth b.Erbendorf',
      provincie: 9,
      slug: 'reuth-b-erbendorf',
    },
    {
      code: '093775351117',
      label: 'Falkenberg',
      provincie: 9,
      slug: 'falkenberg-gemeinde',
    },
    {
      code: '093775351159',
      label: 'Wiesau',
      provincie: 9,
      slug: 'wiesau',
    },
    {
      code: '094610000000',
      label: 'Bamberg',
      provincie: 9,
      slug: 'bamberg',
    },
    {
      code: '094620000000',
      label: 'Bayreuth',
      provincie: 9,
      slug: 'bayreuth',
    },
    {
      code: '094630000000',
      label: 'Coburg',
      provincie: 9,
      slug: 'coburg',
    },
    {
      code: '094640000000',
      label: 'Hof',
      provincie: 9,
      slug: 'hof-stadt',
    },
    {
      code: '094710111111',
      label: 'Altendorf',
      provincie: 9,
      slug: 'altendorf-gemeinde',
    },
    {
      code: '094710117117',
      label: 'Bischberg',
      provincie: 9,
      slug: 'bischberg',
    },
    {
      code: '094710119119',
      label: 'Breitengüßbach',
      provincie: 9,
      slug: 'breitenguessbach',
    },
    {
      code: '094710123123',
      label: 'Buttenheim',
      provincie: 9,
      slug: 'buttenheim',
    },
    {
      code: '094710131131',
      label: 'Frensdorf',
      provincie: 9,
      slug: 'frensdorf',
    },
    {
      code: '094710137137',
      label: 'Gundelsheim',
      provincie: 9,
      slug: 'gundelsheim-gemeinde',
    },
    {
      code: '094710140140',
      label: 'Hallstadt',
      provincie: 9,
      slug: 'hallstadt',
    },
    {
      code: '094710142142',
      label: 'Heiligenstadt i.OFr.',
      provincie: 9,
      slug: 'heiligenstadt-i-ofr',
    },
    {
      code: '094710145145',
      label: 'Hirschaid',
      provincie: 9,
      slug: 'hirschaid',
    },
    {
      code: '094710150150',
      label: 'Kemmern',
      provincie: 9,
      slug: 'kemmern',
    },
    {
      code: '094710155155',
      label: 'Litzendorf',
      provincie: 9,
      slug: 'litzendorf',
    },
    {
      code: '094710159159',
      label: 'Memmelsdorf',
      provincie: 9,
      slug: 'memmelsdorf',
    },
    {
      code: '094710165165',
      label: 'Oberhaid',
      provincie: 9,
      slug: 'oberhaid-gemeinde',
    },
    {
      code: '094710169169',
      label: 'Pettstadt',
      provincie: 9,
      slug: 'pettstadt',
    },
    {
      code: '094710172172',
      label: 'Pommersfelden',
      provincie: 9,
      slug: 'pommersfelden',
    },
    {
      code: '094710174174',
      label: 'Rattelsdorf',
      provincie: 9,
      slug: 'rattelsdorf',
    },
    {
      code: '094710185185',
      label: 'Scheßlitz',
      provincie: 9,
      slug: 'schesslitz',
    },
    {
      code: '094710191191',
      label: 'Stegaurach',
      provincie: 9,
      slug: 'stegaurach',
    },
    {
      code: '094710195195',
      label: 'Strullendorf',
      provincie: 9,
      slug: 'strullendorf',
    },
    {
      code: '094710207207',
      label: 'Viereth-Trunstadt',
      provincie: 9,
      slug: 'viereth-trunstadt',
    },
    {
      code: '094710208208',
      label: 'Walsdorf',
      provincie: 9,
      slug: 'walsdorf-gemeinde',
    },
    {
      code: '094710214214',
      label: 'Zapfendorf',
      provincie: 9,
      slug: 'zapfendorf',
    },
    {
      code: '094710220220',
      label: 'Schlüsselfeld',
      provincie: 9,
      slug: 'schluesselfeld',
    },
    {
      code: '094715401115',
      label: 'Baunach',
      provincie: 9,
      slug: 'baunach',
    },
    {
      code: '094715401133',
      label: 'Gerach',
      provincie: 9,
      slug: 'gerach-gemeinde',
    },
    {
      code: '094715401152',
      label: 'Lauter',
      provincie: 9,
      slug: 'lauter',
    },
    {
      code: '094715401175',
      label: 'Reckendorf',
      provincie: 9,
      slug: 'reckendorf',
    },
    {
      code: '094715403151',
      label: 'Königsfeld',
      provincie: 9,
      slug: 'koenigsfeld-gemeinde',
    },
    {
      code: '094715403189',
      label: 'Stadelhofen',
      provincie: 9,
      slug: 'stadelhofen',
    },
    {
      code: '094715403209',
      label: 'Wattendorf',
      provincie: 9,
      slug: 'wattendorf',
    },
    {
      code: '094715407122',
      label: 'Burgwindheim',
      provincie: 9,
      slug: 'burgwindheim',
    },
    {
      code: '094715407128',
      label: 'Ebrach',
      provincie: 9,
      slug: 'ebrach',
    },
    {
      code: '094715408120',
      label: 'Burgebrach',
      provincie: 9,
      slug: 'burgebrach',
    },
    {
      code: '094715408186',
      label: 'Schönbrunn i.Steigerwald',
      provincie: 9,
      slug: 'schoenbrunn-i-steigerwald',
    },
    {
      code: '094715445154',
      label: 'Lisberg',
      provincie: 9,
      slug: 'lisberg',
    },
    {
      code: '094715445173',
      label: 'Priesendorf',
      provincie: 9,
      slug: 'priesendorf',
    },
    {
      code: '094720111111',
      label: 'Ahorntal',
      provincie: 9,
      slug: 'ahorntal',
    },
    {
      code: '094720116116',
      label: 'Bad Berneck i.Fichtelgebirge',
      provincie: 9,
      slug: 'bad-berneck-i-fichtelgebirge',
    },
    {
      code: '094720119119',
      label: 'Bindlach',
      provincie: 9,
      slug: 'bindlach',
    },
    {
      code: '094720121121',
      label: 'Bischofsgrün',
      provincie: 9,
      slug: 'bischofsgruen',
    },
    {
      code: '094720131131',
      label: 'Eckersdorf',
      provincie: 9,
      slug: 'eckersdorf',
    },
    {
      code: '094720138138',
      label: 'Fichtelberg',
      provincie: 9,
      slug: 'fichtelberg',
    },
    {
      code: '094720139139',
      label: 'Gefrees',
      provincie: 9,
      slug: 'gefrees',
    },
    {
      code: '094720143143',
      label: 'Goldkronach',
      provincie: 9,
      slug: 'goldkronach',
    },
    {
      code: '094720150150',
      label: 'Heinersreuth',
      provincie: 9,
      slug: 'heinersreuth',
    },
    {
      code: '094720164164',
      label: 'Mehlmeisel',
      provincie: 9,
      slug: 'mehlmeisel',
    },
    {
      code: '094720175175',
      label: 'Pegnitz',
      provincie: 9,
      slug: 'pegnitz',
    },
    {
      code: '094720179179',
      label: 'Pottenstein',
      provincie: 9,
      slug: 'pottenstein',
    },
    {
      code: '094720190190',
      label: 'Speichersdorf',
      provincie: 9,
      slug: 'speichersdorf',
    },
    {
      code: '094720197197',
      label: 'Waischenfeld',
      provincie: 9,
      slug: 'waischenfeld',
    },
    {
      code: '094720198198',
      label: 'Warmensteinach',
      provincie: 9,
      slug: 'warmensteinach',
    },
    {
      code: '094725412115',
      label: 'Aufseß',
      provincie: 9,
      slug: 'aufsess',
    },
    {
      code: '094725412154',
      label: 'Hollfeld',
      provincie: 9,
      slug: 'hollfeld',
    },
    {
      code: '094725412176',
      label: 'Plankenfels',
      provincie: 9,
      slug: 'plankenfels',
    },
    {
      code: '094725413141',
      label: 'Glashütten',
      provincie: 9,
      slug: 'glashuetten-gemeinde',
    },
    {
      code: '094725413167',
      label: 'Mistelgau',
      provincie: 9,
      slug: 'mistelgau',
    },
    {
      code: '094725414140',
      label: 'Gesees',
      provincie: 9,
      slug: 'gesees',
    },
    {
      code: '094725414155',
      label: 'Hummeltal',
      provincie: 9,
      slug: 'hummeltal',
    },
    {
      code: '094725414166',
      label: 'Mistelbach',
      provincie: 9,
      slug: 'mistelbach',
    },
    {
      code: '094725415133',
      label: 'Emtmannsberg',
      provincie: 9,
      slug: 'emtmannsberg',
    },
    {
      code: '094725415156',
      label: 'Kirchenpingarten',
      provincie: 9,
      slug: 'kirchenpingarten',
    },
    {
      code: '094725415188',
      label: 'Seybothenreuth',
      provincie: 9,
      slug: 'seybothenreuth',
    },
    {
      code: '094725415199',
      label: 'Weidenberg',
      provincie: 9,
      slug: 'weidenberg',
    },
    {
      code: '094725416127',
      label: 'Creußen',
      provincie: 9,
      slug: 'creussen',
    },
    {
      code: '094725416146',
      label: 'Haag',
      provincie: 9,
      slug: 'haag',
    },
    {
      code: '094725416180',
      label: 'Prebitz',
      provincie: 9,
      slug: 'prebitz',
    },
    {
      code: '094725416184',
      label: 'Schnabelwaid',
      provincie: 9,
      slug: 'schnabelwaid',
    },
    {
      code: '094725417118',
      label: 'Betzenstein',
      provincie: 9,
      slug: 'betzenstein',
    },
    {
      code: '094725417177',
      label: 'Plech',
      provincie: 9,
      slug: 'plech',
    },
    {
      code: '094730112112',
      label: 'Ahorn',
      provincie: 9,
      slug: 'ahorn-gemeinde',
    },
    {
      code: '094730120120',
      label: 'Dörfles-Esbach',
      provincie: 9,
      slug: 'doerfles-esbach',
    },
    {
      code: '094730121121',
      label: 'Ebersdorf b.Coburg',
      provincie: 9,
      slug: 'ebersdorf-b-coburg',
    },
    {
      code: '094730132132',
      label: 'Großheirath',
      provincie: 9,
      slug: 'grossheirath',
    },
    {
      code: '094730138138',
      label: 'Itzgrund',
      provincie: 9,
      slug: 'itzgrund',
    },
    {
      code: '094730141141',
      label: 'Lautertal',
      provincie: 9,
      slug: 'lautertal',
    },
    {
      code: '094730144144',
      label: 'Meeder',
      provincie: 9,
      slug: 'meeder',
    },
    {
      code: '094730151151',
      label: 'Neustadt b.Coburg',
      provincie: 9,
      slug: 'neustadt-b-coburg',
    },
    {
      code: '094730158158',
      label: 'Bad Rodach',
      provincie: 9,
      slug: 'bad-rodach',
    },
    {
      code: '094730159159',
      label: 'Rödental',
      provincie: 9,
      slug: 'roedental',
    },
    {
      code: '094730165165',
      label: 'Seßlach',
      provincie: 9,
      slug: 'sesslach',
    },
    {
      code: '094730166166',
      label: 'Sonnefeld',
      provincie: 9,
      slug: 'sonnefeld',
    },
    {
      code: '094730170170',
      label: 'Untersiemau',
      provincie: 9,
      slug: 'untersiemau',
    },
    {
      code: '094730174174',
      label: 'Weidhausen b.Coburg',
      provincie: 9,
      slug: 'weidhausen-b-coburg',
    },
    {
      code: '094730175175',
      label: 'Weitramsdorf',
      provincie: 9,
      slug: 'weitramsdorf',
    },
    {
      code: '094735418134',
      label: 'Grub a.Forst',
      provincie: 9,
      slug: 'grub-a-forst',
    },
    {
      code: '094735418153',
      label: 'Niederfüllbach',
      provincie: 9,
      slug: 'niederfuellbach',
    },
    {
      code: '094740123123',
      label: 'Eggolsheim',
      provincie: 9,
      slug: 'eggolsheim',
    },
    {
      code: '094740124124',
      label: 'Egloffstein',
      provincie: 9,
      slug: 'egloffstein',
    },
    {
      code: '094740126126',
      label: 'Forchheim',
      provincie: 9,
      slug: 'forchheim-stadt',
    },
    {
      code: '094740129129',
      label: 'Gößweinstein',
      provincie: 9,
      slug: 'goessweinstein',
    },
    {
      code: '094740133133',
      label: 'Hallerndorf',
      provincie: 9,
      slug: 'hallerndorf',
    },
    {
      code: '094740134134',
      label: 'Hausen',
      provincie: 9,
      slug: 'hausen-gemeinde',
    },
    {
      code: '094740135135',
      label: 'Heroldsbach',
      provincie: 9,
      slug: 'heroldsbach',
    },
    {
      code: '094740140140',
      label: 'Igensdorf',
      provincie: 9,
      slug: 'igensdorf',
    },
    {
      code: '094740146146',
      label: 'Langensendelbach',
      provincie: 9,
      slug: 'langensendelbach',
    },
    {
      code: '094740154154',
      label: 'Neunkirchen a.Brand',
      provincie: 9,
      slug: 'neunkirchen-a-brand',
    },
    {
      code: '094740156156',
      label: 'Obertrubach',
      provincie: 9,
      slug: 'obertrubach',
    },
    {
      code: '094740161161',
      label: 'Pretzfeld',
      provincie: 9,
      slug: 'pretzfeld',
    },
    {
      code: '094740176176',
      label: 'Wiesenttal',
      provincie: 9,
      slug: 'wiesenttal',
    },
    {
      code: '094745420121',
      label: 'Ebermannstadt',
      provincie: 9,
      slug: 'ebermannstadt',
    },
    {
      code: '094745420168',
      label: 'Unterleinleiter',
      provincie: 9,
      slug: 'unterleinleiter',
    },
    {
      code: '094745422145',
      label: 'Kunreuth',
      provincie: 9,
      slug: 'kunreuth',
    },
    {
      code: '094745422158',
      label: 'Pinzberg',
      provincie: 9,
      slug: 'pinzberg',
    },
    {
      code: '094745422175',
      label: 'Wiesenthau',
      provincie: 9,
      slug: 'wiesenthau',
    },
    {
      code: '094745423143',
      label: 'Kirchehrenbach',
      provincie: 9,
      slug: 'kirchehrenbach',
    },
    {
      code: '094745423147',
      label: 'Leutenbach',
      provincie: 9,
      slug: 'leutenbach-gemeinde',
    },
    {
      code: '094745423171',
      label: 'Weilersbach',
      provincie: 9,
      slug: 'weilersbach',
    },
    {
      code: '094745425122',
      label: 'Effeltrich',
      provincie: 9,
      slug: 'effeltrich',
    },
    {
      code: '094745425160',
      label: 'Poxdorf',
      provincie: 9,
      slug: 'poxdorf',
    },
    {
      code: '094745426119',
      label: 'Dormitz',
      provincie: 9,
      slug: 'dormitz',
    },
    {
      code: '094745426137',
      label: 'Hetzles',
      provincie: 9,
      slug: 'hetzles',
    },
    {
      code: '094745426144',
      label: 'Kleinsendelbach',
      provincie: 9,
      slug: 'kleinsendelbach',
    },
    {
      code: '094745427132',
      label: 'Gräfenberg',
      provincie: 9,
      slug: 'graefenberg',
    },
    {
      code: '094745427138',
      label: 'Hiltpoltstein',
      provincie: 9,
      slug: 'hiltpoltstein',
    },
    {
      code: '094745427173',
      label: 'Weißenohe',
      provincie: 9,
      slug: 'weissenohe',
    },
    {
      code: '094750112112',
      label: 'Bad Steben',
      provincie: 9,
      slug: 'bad-steben',
    },
    {
      code: '094750113113',
      label: 'Berg',
      provincie: 9,
      slug: 'berg-gemeinde',
    },
    {
      code: '094750120120',
      label: 'Döhlau',
      provincie: 9,
      slug: 'doehlau',
    },
    {
      code: '094750128128',
      label: 'Geroldsgrün',
      provincie: 9,
      slug: 'geroldsgruen',
    },
    {
      code: '094750136136',
      label: 'Helmbrechts',
      provincie: 9,
      slug: 'helmbrechts',
    },
    {
      code: '094750141141',
      label: 'Köditz',
      provincie: 9,
      slug: 'koeditz',
    },
    {
      code: '094750142142',
      label: 'Konradsreuth',
      provincie: 9,
      slug: 'konradsreuth',
    },
    {
      code: '094750154154',
      label: 'Münchberg',
      provincie: 9,
      slug: 'muenchberg',
    },
    {
      code: '094750156156',
      label: 'Naila',
      provincie: 9,
      slug: 'naila',
    },
    {
      code: '094750158158',
      label: 'Oberkotzau',
      provincie: 9,
      slug: 'oberkotzau',
    },
    {
      code: '094750161161',
      label: 'Regnitzlosau',
      provincie: 9,
      slug: 'regnitzlosau',
    },
    {
      code: '094750162162',
      label: 'Rehau',
      provincie: 9,
      slug: 'rehau',
    },
    {
      code: '094750168168',
      label: 'Schwarzenbach a.d.Saale',
      provincie: 9,
      slug: 'schwarzenbach-a-d-saale',
    },
    {
      code: '094750169169',
      label: 'Schwarzenbach a.Wald',
      provincie: 9,
      slug: 'schwarzenbach-a-wald',
    },
    {
      code: '094750171171',
      label: 'Selbitz',
      provincie: 9,
      slug: 'selbitz',
    },
    {
      code: '094750175175',
      label: 'Stammbach',
      provincie: 9,
      slug: 'stammbach',
    },
    {
      code: '094750189189',
      label: 'Zell im Fichtelgebirge',
      provincie: 9,
      slug: 'zell-im-fichtelgebirge',
    },
    {
      code: '094755428137',
      label: 'Issigau',
      provincie: 9,
      slug: 'issigau',
    },
    {
      code: '094755428146',
      label: 'Lichtenberg',
      provincie: 9,
      slug: 'lichtenberg',
    },
    {
      code: '094755430123',
      label: 'Feilitzsch',
      provincie: 9,
      slug: 'feilitzsch',
    },
    {
      code: '094755430127',
      label: 'Gattendorf',
      provincie: 9,
      slug: 'gattendorf',
    },
    {
      code: '094755430181',
      label: 'Töpen',
      provincie: 9,
      slug: 'toepen',
    },
    {
      code: '094755430182',
      label: 'Trogen',
      provincie: 9,
      slug: 'trogen',
    },
    {
      code: '094755431145',
      label: 'Leupoldsgrün',
      provincie: 9,
      slug: 'leupoldsgruen',
    },
    {
      code: '094755431165',
      label: 'Schauenstein',
      provincie: 9,
      slug: 'schauenstein',
    },
    {
      code: '094755432174',
      label: 'Sparneck',
      provincie: 9,
      slug: 'sparneck',
    },
    {
      code: '094755432184',
      label: 'Weißdorf',
      provincie: 9,
      slug: 'weissdorf',
    },
    {
      code: '094760145145',
      label: 'Kronach',
      provincie: 9,
      slug: 'kronach',
    },
    {
      code: '094760146146',
      label: 'Küps',
      provincie: 9,
      slug: 'kueps',
    },
    {
      code: '094760152152',
      label: 'Ludwigsstadt',
      provincie: 9,
      slug: 'ludwigsstadt',
    },
    {
      code: '094760159159',
      label: 'Nordhalben',
      provincie: 9,
      slug: 'nordhalben',
    },
    {
      code: '094760164164',
      label: 'Pressig',
      provincie: 9,
      slug: 'pressig',
    },
    {
      code: '094760175175',
      label: 'Steinbach a.Wald',
      provincie: 9,
      slug: 'steinbach-a-wald',
    },
    {
      code: '094760177177',
      label: 'Steinwiesen',
      provincie: 9,
      slug: 'steinwiesen',
    },
    {
      code: '094760178178',
      label: 'Stockheim',
      provincie: 9,
      slug: 'stockheim',
    },
    {
      code: '094760179179',
      label: 'Tettau',
      provincie: 9,
      slug: 'tettau',
    },
    {
      code: '094760183183',
      label: 'Marktrodach',
      provincie: 9,
      slug: 'marktrodach',
    },
    {
      code: '094760184184',
      label: 'Wallenfels',
      provincie: 9,
      slug: 'wallenfels',
    },
    {
      code: '094760185185',
      label: 'Weißenbrunn',
      provincie: 9,
      slug: 'weissenbrunn',
    },
    {
      code: '094760189189',
      label: 'Wilhelmsthal',
      provincie: 9,
      slug: 'wilhelmsthal',
    },
    {
      code: '094765433166',
      label: 'Reichenbach',
      provincie: 9,
      slug: 'reichenbach-gemeinde',
    },
    {
      code: '094765433180',
      label: 'Teuschnitz',
      provincie: 9,
      slug: 'teuschnitz',
    },
    {
      code: '094765433182',
      label: 'Tschirn',
      provincie: 9,
      slug: 'tschirn',
    },
    {
      code: '094765434154',
      label: 'Mitwitz',
      provincie: 9,
      slug: 'mitwitz',
    },
    {
      code: '094765434171',
      label: 'Schneckenlohe',
      provincie: 9,
      slug: 'schneckenlohe',
    },
    {
      code: '094770121121',
      label: 'Himmelkron',
      provincie: 9,
      slug: 'himmelkron',
    },
    {
      code: '094770128128',
      label: 'Kulmbach',
      provincie: 9,
      slug: 'kulmbach',
    },
    {
      code: '094770136136',
      label: 'Mainleus',
      provincie: 9,
      slug: 'mainleus',
    },
    {
      code: '094770139139',
      label: 'Marktschorgast',
      provincie: 9,
      slug: 'marktschorgast',
    },
    {
      code: '094770142142',
      label: 'Neudrossenfeld',
      provincie: 9,
      slug: 'neudrossenfeld',
    },
    {
      code: '094770143143',
      label: 'Neuenmarkt',
      provincie: 9,
      slug: 'neuenmarkt',
    },
    {
      code: '094770148148',
      label: 'Presseck',
      provincie: 9,
      slug: 'presseck',
    },
    {
      code: '094770157157',
      label: 'Thurnau',
      provincie: 9,
      slug: 'thurnau',
    },
    {
      code: '094770163163',
      label: 'Wirsberg',
      provincie: 9,
      slug: 'wirsberg',
    },
    {
      code: '094775435151',
      label: 'Rugendorf',
      provincie: 9,
      slug: 'rugendorf',
    },
    {
      code: '094775435156',
      label: 'Stadtsteinach',
      provincie: 9,
      slug: 'stadtsteinach',
    },
    {
      code: '094775436117',
      label: 'Grafengehaig',
      provincie: 9,
      slug: 'grafengehaig',
    },
    {
      code: '094775436138',
      label: 'Marktleugast',
      provincie: 9,
      slug: 'marktleugast',
    },
    {
      code: '094775437118',
      label: 'Guttenberg',
      provincie: 9,
      slug: 'guttenberg',
    },
    {
      code: '094775437129',
      label: 'Kupferberg',
      provincie: 9,
      slug: 'kupferberg',
    },
    {
      code: '094775437135',
      label: 'Ludwigschorgast',
      provincie: 9,
      slug: 'ludwigschorgast',
    },
    {
      code: '094775437159',
      label: 'Untersteinach',
      provincie: 9,
      slug: 'untersteinach',
    },
    {
      code: '094775438124',
      label: 'Kasendorf',
      provincie: 9,
      slug: 'kasendorf',
    },
    {
      code: '094775438164',
      label: 'Wonsees',
      provincie: 9,
      slug: 'wonsees',
    },
    {
      code: '094775439119',
      label: 'Harsdorf',
      provincie: 9,
      slug: 'harsdorf',
    },
    {
      code: '094775439127',
      label: 'Ködnitz',
      provincie: 9,
      slug: 'koednitz',
    },
    {
      code: '094775439158',
      label: 'Trebgast',
      provincie: 9,
      slug: 'trebgast',
    },
    {
      code: '094780111111',
      label: 'Altenkunstadt',
      provincie: 9,
      slug: 'altenkunstadt',
    },
    {
      code: '094780116116',
      label: 'Burgkunstadt',
      provincie: 9,
      slug: 'burgkunstadt',
    },
    {
      code: '094780120120',
      label: 'Ebensfeld',
      provincie: 9,
      slug: 'ebensfeld',
    },
    {
      code: '094780139139',
      label: 'Lichtenfels',
      provincie: 9,
      slug: 'lichtenfels-stadt',
    },
    {
      code: '094780145145',
      label: 'Michelau i.OFr.',
      provincie: 9,
      slug: 'michelau-i-ofr',
    },
    {
      code: '094780165165',
      label: 'Bad Staffelstein',
      provincie: 9,
      slug: 'bad-staffelstein',
    },
    {
      code: '094780176176',
      label: 'Weismain',
      provincie: 9,
      slug: 'weismain',
    },
    {
      code: '094785441143',
      label: 'Marktgraitz',
      provincie: 9,
      slug: 'marktgraitz',
    },
    {
      code: '094785441155',
      label: 'Redwitz a.d.Rodach',
      provincie: 9,
      slug: 'redwitz-a-d-rodach',
    },
    {
      code: '094785446127',
      label: 'Hochstadt a.Main',
      provincie: 9,
      slug: 'hochstadt-a-main',
    },
    {
      code: '094785446144',
      label: 'Marktzeuln',
      provincie: 9,
      slug: 'marktzeuln',
    },
    {
      code: '094790112112',
      label: 'Arzberg',
      provincie: 9,
      slug: 'arzberg',
    },
    {
      code: '094790129129',
      label: 'Kirchenlamitz',
      provincie: 9,
      slug: 'kirchenlamitz',
    },
    {
      code: '094790135135',
      label: 'Marktleuthen',
      provincie: 9,
      slug: 'marktleuthen',
    },
    {
      code: '094790136136',
      label: 'Marktredwitz',
      provincie: 9,
      slug: 'marktredwitz',
    },
    {
      code: '094790145145',
      label: 'Röslau',
      provincie: 9,
      slug: 'roeslau',
    },
    {
      code: '094790150150',
      label: 'Schönwald',
      provincie: 9,
      slug: 'schoenwald',
    },
    {
      code: '094790152152',
      label: 'Selb',
      provincie: 9,
      slug: 'selb',
    },
    {
      code: '094790166166',
      label: 'Weißenstadt',
      provincie: 9,
      slug: 'weissenstadt',
    },
    {
      code: '094790169169',
      label: 'Wunsiedel',
      provincie: 9,
      slug: 'wunsiedel',
    },
    {
      code: '094795442126',
      label: 'Höchstädt i.Fichtelgebirge',
      provincie: 9,
      slug: 'hoechstaedt-i-fichtelgebirge',
    },
    {
      code: '094795442158',
      label: 'Thiersheim',
      provincie: 9,
      slug: 'thiersheim',
    },
    {
      code: '094795442159',
      label: 'Thierstein',
      provincie: 9,
      slug: 'thierstein',
    },
    {
      code: '094795443127',
      label: 'Hohenberg a.d.Eger',
      provincie: 9,
      slug: 'hohenberg-a-d-eger',
    },
    {
      code: '094795443147',
      label: 'Schirnding',
      provincie: 9,
      slug: 'schirnding',
    },
    {
      code: '094795444111',
      label: 'Bad Alexandersbad',
      provincie: 9,
      slug: 'bad-alexandersbad',
    },
    {
      code: '094795444138',
      label: 'Nagel',
      provincie: 9,
      slug: 'nagel',
    },
    {
      code: '094795444161',
      label: 'Tröstau',
      provincie: 9,
      slug: 'troestau',
    },
    {
      code: '095610000000',
      label: 'Ansbach',
      provincie: 9,
      slug: 'ansbach',
    },
    {
      code: '095620000000',
      label: 'Erlangen',
      provincie: 9,
      slug: 'erlangen',
    },
    {
      code: '095630000000',
      label: 'Fürth',
      provincie: 9,
      slug: 'fuerth-stadt',
    },
    {
      code: '095640000000',
      label: 'Nürnberg',
      provincie: 9,
      slug: 'nuernberg',
    },
    {
      code: '095650000000',
      label: 'Schwabach',
      provincie: 9,
      slug: 'schwabach',
    },
    {
      code: '095710113113',
      label: 'Arberg',
      provincie: 9,
      slug: 'arberg',
    },
    {
      code: '095710114114',
      label: 'Aurach',
      provincie: 9,
      slug: 'aurach',
    },
    {
      code: '095710115115',
      label: 'Bechhofen',
      provincie: 9,
      slug: 'bechhofen-gemeinde',
    },
    {
      code: '095710127127',
      label: 'Burgoberbach',
      provincie: 9,
      slug: 'burgoberbach',
    },
    {
      code: '095710130130',
      label: 'Colmberg',
      provincie: 9,
      slug: 'colmberg',
    },
    {
      code: '095710135135',
      label: 'Dietenhofen',
      provincie: 9,
      slug: 'dietenhofen',
    },
    {
      code: '095710136136',
      label: 'Dinkelsbühl',
      provincie: 9,
      slug: 'dinkelsbuehl',
    },
    {
      code: '095710139139',
      label: 'Dürrwangen',
      provincie: 9,
      slug: 'duerrwangen',
    },
    {
      code: '095710145145',
      label: 'Feuchtwangen',
      provincie: 9,
      slug: 'feuchtwangen',
    },
    {
      code: '095710146146',
      label: 'Flachslanden',
      provincie: 9,
      slug: 'flachslanden',
    },
    {
      code: '095710165165',
      label: 'Heilsbronn',
      provincie: 9,
      slug: 'heilsbronn',
    },
    {
      code: '095710166166',
      label: 'Herrieden',
      provincie: 9,
      slug: 'herrieden',
    },
    {
      code: '095710170170',
      label: 'Langfurth',
      provincie: 9,
      slug: 'langfurth',
    },
    {
      code: '095710171171',
      label: 'Lehrberg',
      provincie: 9,
      slug: 'lehrberg',
    },
    {
      code: '095710174174',
      label: 'Leutershausen',
      provincie: 9,
      slug: 'leutershausen',
    },
    {
      code: '095710175175',
      label: 'Lichtenau',
      provincie: 9,
      slug: 'lichtenau-gemeinde',
    },
    {
      code: '095710177177',
      label: 'Merkendorf',
      provincie: 9,
      slug: 'merkendorf',
    },
    {
      code: '095710180180',
      label: 'Neuendettelsau',
      provincie: 9,
      slug: 'neuendettelsau',
    },
    {
      code: '095710183183',
      label: 'Oberdachstetten',
      provincie: 9,
      slug: 'oberdachstetten',
    },
    {
      code: '095710190190',
      label: 'Petersaurach',
      provincie: 9,
      slug: 'petersaurach',
    },
    {
      code: '095710193193',
      label: 'Rothenburg ob der Tauber',
      provincie: 9,
      slug: 'rothenburg-ob-der-tauber',
    },
    {
      code: '095710196196',
      label: 'Sachsen b.Ansbach',
      provincie: 9,
      slug: 'sachsen-b-ansbach',
    },
    {
      code: '095710199199',
      label: 'Schnelldorf',
      provincie: 9,
      slug: 'schnelldorf',
    },
    {
      code: '095710200200',
      label: 'Schopfloch',
      provincie: 9,
      slug: 'schopfloch-gemeinde',
    },
    {
      code: '095710214214',
      label: 'Wassertrüdingen',
      provincie: 9,
      slug: 'wassertruedingen',
    },
    {
      code: '095710226226',
      label: 'Windsbach',
      provincie: 9,
      slug: 'windsbach',
    },
    {
      code: '095715501111',
      label: 'Adelshofen',
      provincie: 9,
      slug: 'adelshofen-gemeinde',
    },
    {
      code: '095715501152',
      label: 'Gebsattel',
      provincie: 9,
      slug: 'gebsattel',
    },
    {
      code: '095715501155',
      label: 'Geslau',
      provincie: 9,
      slug: 'geslau',
    },
    {
      code: '095715501169',
      label: 'Insingen',
      provincie: 9,
      slug: 'insingen',
    },
    {
      code: '095715501181',
      label: 'Neusitz',
      provincie: 9,
      slug: 'neusitz',
    },
    {
      code: '095715501188',
      label: 'Ohrenbach',
      provincie: 9,
      slug: 'ohrenbach',
    },
    {
      code: '095715501205',
      label: 'Steinsfeld',
      provincie: 9,
      slug: 'steinsfeld',
    },
    {
      code: '095715501225',
      label: 'Windelsbach',
      provincie: 9,
      slug: 'windelsbach',
    },
    {
      code: '095715502125',
      label: 'Buch a.Wald',
      provincie: 9,
      slug: 'buch-a-wald',
    },
    {
      code: '095715502134',
      label: 'Diebach',
      provincie: 9,
      slug: 'diebach',
    },
    {
      code: '095715502137',
      label: 'Dombühl',
      provincie: 9,
      slug: 'dombuehl',
    },
    {
      code: '095715502198',
      label: 'Schillingsfürst',
      provincie: 9,
      slug: 'schillingsfuerst',
    },
    {
      code: '095715502222',
      label: 'Wettringen',
      provincie: 9,
      slug: 'wettringen-gemeinde',
    },
    {
      code: '095715502228',
      label: 'Wörnitz',
      provincie: 9,
      slug: 'woernitz',
    },
    {
      code: '095715504122',
      label: 'Bruckberg',
      provincie: 9,
      slug: 'bruckberg-gemeinde',
    },
    {
      code: '095715504194',
      label: 'Rügland',
      provincie: 9,
      slug: 'ruegland',
    },
    {
      code: '095715504217',
      label: 'Weihenzell',
      provincie: 9,
      slug: 'weihenzell',
    },
    {
      code: '095715506189',
      label: 'Ornbau',
      provincie: 9,
      slug: 'ornbau',
    },
    {
      code: '095715506216',
      label: 'Weidenbach',
      provincie: 9,
      slug: 'weidenbach-gemeinde',
    },
    {
      code: '095715507128',
      label: 'Burk',
      provincie: 9,
      slug: 'burk',
    },
    {
      code: '095715507132',
      label: 'Dentlein a.Forst',
      provincie: 9,
      slug: 'dentlein-a-forst',
    },
    {
      code: '095715507223',
      label: 'Wieseth',
      provincie: 9,
      slug: 'wieseth',
    },
    {
      code: '095715508179',
      label: 'Mönchsroth',
      provincie: 9,
      slug: 'moenchsroth',
    },
    {
      code: '095715508218',
      label: 'Weiltingen',
      provincie: 9,
      slug: 'weiltingen',
    },
    {
      code: '095715508224',
      label: 'Wilburgstetten',
      provincie: 9,
      slug: 'wilburgstetten',
    },
    {
      code: '095715509141',
      label: 'Ehingen',
      provincie: 9,
      slug: 'ehingen',
    },
    {
      code: '095715509154',
      label: 'Gerolfingen',
      provincie: 9,
      slug: 'gerolfingen',
    },
    {
      code: '095715509192',
      label: 'Röckingen',
      provincie: 9,
      slug: 'roeckingen',
    },
    {
      code: '095715509208',
      label: 'Unterschwaningen',
      provincie: 9,
      slug: 'unterschwaningen',
    },
    {
      code: '095715509227',
      label: 'Wittelshofen',
      provincie: 9,
      slug: 'wittelshofen',
    },
    {
      code: '095715538178',
      label: 'Mitteleschenbach',
      provincie: 9,
      slug: 'mitteleschenbach',
    },
    {
      code: '095715538229',
      label: 'Wolframs-Eschenbach',
      provincie: 9,
      slug: 'wolframs-eschenbach',
    },
    {
      code: '095720111111',
      label: 'Adelsdorf',
      provincie: 9,
      slug: 'adelsdorf',
    },
    {
      code: '095720115115',
      label: 'Baiersdorf',
      provincie: 9,
      slug: 'baiersdorf',
    },
    {
      code: '095720119119',
      label: 'Bubenreuth',
      provincie: 9,
      slug: 'bubenreuth',
    },
    {
      code: '095720121121',
      label: 'Eckental',
      provincie: 9,
      slug: 'eckental',
    },
    {
      code: '095720130130',
      label: 'Hemhofen',
      provincie: 9,
      slug: 'hemhofen',
    },
    {
      code: '095720131131',
      label: 'Heroldsberg',
      provincie: 9,
      slug: 'heroldsberg',
    },
    {
      code: '095720132132',
      label: 'Herzogenaurach',
      provincie: 9,
      slug: 'herzogenaurach',
    },
    {
      code: '095720135135',
      label: 'Höchstadt a.d.Aisch',
      provincie: 9,
      slug: 'hoechstadt-a-d-aisch',
    },
    {
      code: '095720137137',
      label: 'Kalchreuth',
      provincie: 9,
      slug: 'kalchreuth',
    },
    {
      code: '095720142142',
      label: 'Möhrendorf',
      provincie: 9,
      slug: 'moehrendorf',
    },
    {
      code: '095720149149',
      label: 'Röttenbach',
      provincie: 9,
      slug: 'roettenbach',
    },
    {
      code: '095720160160',
      label: 'Wachenroth',
      provincie: 9,
      slug: 'wachenroth',
    },
    {
      code: '095720164164',
      label: 'Weisendorf',
      provincie: 9,
      slug: 'weisendorf',
    },
    {
      code: '095725510126',
      label: 'Gremsdorf',
      provincie: 9,
      slug: 'gremsdorf',
    },
    {
      code: '095725510139',
      label: 'Lonnerstadt',
      provincie: 9,
      slug: 'lonnerstadt',
    },
    {
      code: '095725510143',
      label: 'Mühlhausen',
      provincie: 9,
      slug: 'muehlhausen-gemeinde',
    },
    {
      code: '095725510159',
      label: 'Vestenbergsgreuth',
      provincie: 9,
      slug: 'vestenbergsgreuth',
    },
    {
      code: '095725512114',
      label: 'Aurachtal',
      provincie: 9,
      slug: 'aurachtal',
    },
    {
      code: '095725512147',
      label: 'Oberreichenbach',
      provincie: 9,
      slug: 'oberreichenbach-gemeinde',
    },
    {
      code: '095725514120',
      label: 'Buckenhof',
      provincie: 9,
      slug: 'buckenhof',
    },
    {
      code: '095725514141',
      label: 'Marloffstein',
      provincie: 9,
      slug: 'marloffstein',
    },
    {
      code: '095725514154',
      label: 'Spardorf',
      provincie: 9,
      slug: 'spardorf',
    },
    {
      code: '095725514158',
      label: 'Uttenreuth',
      provincie: 9,
      slug: 'uttenreuth',
    },
    {
      code: '095725539127',
      label: 'Großenseebach',
      provincie: 9,
      slug: 'grossenseebach',
    },
    {
      code: '095725539133',
      label: 'Heßdorf',
      provincie: 9,
      slug: 'hessdorf',
    },
    {
      code: '095730111111',
      label: 'Ammerndorf',
      provincie: 9,
      slug: 'ammerndorf',
    },
    {
      code: '095730114114',
      label: 'Cadolzburg',
      provincie: 9,
      slug: 'cadolzburg',
    },
    {
      code: '095730115115',
      label: 'Großhabersdorf',
      provincie: 9,
      slug: 'grosshabersdorf',
    },
    {
      code: '095730120120',
      label: 'Langenzenn',
      provincie: 9,
      slug: 'langenzenn',
    },
    {
      code: '095730122122',
      label: 'Oberasbach',
      provincie: 9,
      slug: 'oberasbach',
    },
    {
      code: '095730124124',
      label: 'Puschendorf',
      provincie: 9,
      slug: 'puschendorf',
    },
    {
      code: '095730125125',
      label: 'Roßtal',
      provincie: 9,
      slug: 'rosstal',
    },
    {
      code: '095730127127',
      label: 'Stein',
      provincie: 9,
      slug: 'stein-stadt',
    },
    {
      code: '095730133133',
      label: 'Wilhermsdorf',
      provincie: 9,
      slug: 'wilhermsdorf',
    },
    {
      code: '095730134134',
      label: 'Zirndorf',
      provincie: 9,
      slug: 'zirndorf',
    },
    {
      code: '095735517126',
      label: 'Seukendorf',
      provincie: 9,
      slug: 'seukendorf',
    },
    {
      code: '095735517130',
      label: 'Veitsbronn',
      provincie: 9,
      slug: 'veitsbronn',
    },
    {
      code: '095735540123',
      label: 'Obermichelbach',
      provincie: 9,
      slug: 'obermichelbach',
    },
    {
      code: '095735540129',
      label: 'Tuchenbach',
      provincie: 9,
      slug: 'tuchenbach',
    },
    {
      code: '095740112112',
      label: 'Altdorf b.Nürnberg',
      provincie: 9,
      slug: 'altdorf-b-nuernberg',
    },
    {
      code: '095740117117',
      label: 'Burgthann',
      provincie: 9,
      slug: 'burgthann',
    },
    {
      code: '095740123123',
      label: 'Feucht',
      provincie: 9,
      slug: 'feucht',
    },
    {
      code: '095740132132',
      label: 'Hersbruck',
      provincie: 9,
      slug: 'hersbruck',
    },
    {
      code: '095740135135',
      label: 'Kirchensittenbach',
      provincie: 9,
      slug: 'kirchensittenbach',
    },
    {
      code: '095740138138',
      label: 'Lauf a.d.Pegnitz',
      provincie: 9,
      slug: 'lauf-a-d-pegnitz',
    },
    {
      code: '095740139139',
      label: 'Leinburg',
      provincie: 9,
      slug: 'leinburg',
    },
    {
      code: '095740140140',
      label: 'Neuhaus a.d.Pegnitz',
      provincie: 9,
      slug: 'neuhaus-a-d-pegnitz',
    },
    {
      code: '095740141141',
      label: 'Neunkirchen a.Sand',
      provincie: 9,
      slug: 'neunkirchen-a-sand',
    },
    {
      code: '095740146146',
      label: 'Ottensoos',
      provincie: 9,
      slug: 'ottensoos',
    },
    {
      code: '095740147147',
      label: 'Pommelsbrunn',
      provincie: 9,
      slug: 'pommelsbrunn',
    },
    {
      code: '095740150150',
      label: 'Reichenschwand',
      provincie: 9,
      slug: 'reichenschwand',
    },
    {
      code: '095740152152',
      label: 'Röthenbach a.d.Pegnitz',
      provincie: 9,
      slug: 'roethenbach-a-d-pegnitz',
    },
    {
      code: '095740154154',
      label: 'Rückersdorf',
      provincie: 9,
      slug: 'rueckersdorf',
    },
    {
      code: '095740155155',
      label: 'Schnaittach',
      provincie: 9,
      slug: 'schnaittach',
    },
    {
      code: '095740156156',
      label: 'Schwaig b.Nürnberg',
      provincie: 9,
      slug: 'schwaig-b-nuernberg',
    },
    {
      code: '095740157157',
      label: 'Schwarzenbruck',
      provincie: 9,
      slug: 'schwarzenbruck',
    },
    {
      code: '095740158158',
      label: 'Simmelsdorf',
      provincie: 9,
      slug: 'simmelsdorf',
    },
    {
      code: '095740164164',
      label: 'Winkelhaid',
      provincie: 9,
      slug: 'winkelhaid',
    },
    {
      code: '095745527129',
      label: 'Hartenstein',
      provincie: 9,
      slug: 'hartenstein',
    },
    {
      code: '095745527160',
      label: 'Velden',
      provincie: 9,
      slug: 'velden-stadt',
    },
    {
      code: '095745527161',
      label: 'Vorra',
      provincie: 9,
      slug: 'vorra',
    },
    {
      code: '095745528111',
      label: 'Alfeld',
      provincie: 9,
      slug: 'alfeld',
    },
    {
      code: '095745528128',
      label: 'Happurg',
      provincie: 9,
      slug: 'happurg',
    },
    {
      code: '095745529120',
      label: 'Engelthal',
      provincie: 9,
      slug: 'engelthal',
    },
    {
      code: '095745529131',
      label: 'Henfenfeld',
      provincie: 9,
      slug: 'henfenfeld',
    },
    {
      code: '095745529145',
      label: 'Offenhausen',
      provincie: 9,
      slug: 'offenhausen',
    },
    {
      code: '095750112112',
      label: 'Bad Windsheim',
      provincie: 9,
      slug: 'bad-windsheim',
    },
    {
      code: '095750116116',
      label: 'Burghaslach',
      provincie: 9,
      slug: 'burghaslach',
    },
    {
      code: '095750119119',
      label: 'Dietersheim',
      provincie: 9,
      slug: 'dietersheim',
    },
    {
      code: '095750121121',
      label: 'Emskirchen',
      provincie: 9,
      slug: 'emskirchen',
    },
    {
      code: '095750135135',
      label: 'Ipsheim',
      provincie: 9,
      slug: 'ipsheim',
    },
    {
      code: '095750145145',
      label: 'Markt Erlbach',
      provincie: 9,
      slug: 'markt-erlbach',
    },
    {
      code: '095750153153',
      label: 'Neustadt a.d.Aisch',
      provincie: 9,
      slug: 'neustadt-a-d-aisch',
    },
    {
      code: '095750156156',
      label: 'Obernzenn',
      provincie: 9,
      slug: 'obernzenn',
    },
    {
      code: '095755518138',
      label: 'Langenfeld',
      provincie: 9,
      slug: 'langenfeld-gemeinde',
    },
    {
      code: '095755518144',
      label: 'Markt Bibart',
      provincie: 9,
      slug: 'markt-bibart',
    },
    {
      code: '095755518147',
      label: 'Markt Taschendorf',
      provincie: 9,
      slug: 'markt-taschendorf',
    },
    {
      code: '095755518157',
      label: 'Oberscheinfeld',
      provincie: 9,
      slug: 'oberscheinfeld',
    },
    {
      code: '095755518161',
      label: 'Scheinfeld',
      provincie: 9,
      slug: 'scheinfeld',
    },
    {
      code: '095755518165',
      label: 'Sugenheim',
      provincie: 9,
      slug: 'sugenheim',
    },
    {
      code: '095755519122',
      label: 'Ergersheim',
      provincie: 9,
      slug: 'ergersheim',
    },
    {
      code: '095755519127',
      label: 'Gollhofen',
      provincie: 9,
      slug: 'gollhofen',
    },
    {
      code: '095755519130',
      label: 'Hemmersheim',
      provincie: 9,
      slug: 'hemmersheim',
    },
    {
      code: '095755519134',
      label: 'Ippesheim',
      provincie: 9,
      slug: 'ippesheim',
    },
    {
      code: '095755519146',
      label: 'Markt Nordheim',
      provincie: 9,
      slug: 'markt-nordheim',
    },
    {
      code: '095755519155',
      label: 'Oberickelsheim',
      provincie: 9,
      slug: 'oberickelsheim',
    },
    {
      code: '095755519163',
      label: 'Simmershofen',
      provincie: 9,
      slug: 'simmershofen',
    },
    {
      code: '095755519168',
      label: 'Uffenheim',
      provincie: 9,
      slug: 'uffenheim',
    },
    {
      code: '095755519179',
      label: 'Weigenheim',
      provincie: 9,
      slug: 'weigenheim',
    },
    {
      code: '095755520129',
      label: 'Hagenbüchach',
      provincie: 9,
      slug: 'hagenbuechach',
    },
    {
      code: '095755520181',
      label: 'Wilhelmsdorf',
      provincie: 9,
      slug: 'wilhelmsdorf-gemeinde',
    },
    {
      code: '095755521113',
      label: 'Baudenbach',
      provincie: 9,
      slug: 'baudenbach',
    },
    {
      code: '095755521118',
      label: 'Diespeck',
      provincie: 9,
      slug: 'diespeck',
    },
    {
      code: '095755521128',
      label: 'Gutenstetten',
      provincie: 9,
      slug: 'gutenstetten',
    },
    {
      code: '095755521150',
      label: 'Münchsteinach',
      provincie: 9,
      slug: 'muenchsteinach',
    },
    {
      code: '095755522117',
      label: 'Dachsbach',
      provincie: 9,
      slug: 'dachsbach',
    },
    {
      code: '095755522125',
      label: 'Gerhardshofen',
      provincie: 9,
      slug: 'gerhardshofen',
    },
    {
      code: '095755522167',
      label: 'Uehlfeld',
      provincie: 9,
      slug: 'uehlfeld',
    },
    {
      code: '095755524115',
      label: 'Burgbernheim',
      provincie: 9,
      slug: 'burgbernheim',
    },
    {
      code: '095755524124',
      label: 'Gallmersgarten',
      provincie: 9,
      slug: 'gallmersgarten',
    },
    {
      code: '095755524133',
      label: 'Illesheim',
      provincie: 9,
      slug: 'illesheim',
    },
    {
      code: '095755524143',
      label: 'Marktbergel',
      provincie: 9,
      slug: 'marktbergel',
    },
    {
      code: '095755525152',
      label: 'Neuhof a.d.Zenn',
      provincie: 9,
      slug: 'neuhof-a-d-zenn',
    },
    {
      code: '095755525166',
      label: 'Trautskirchen',
      provincie: 9,
      slug: 'trautskirchen',
    },
    {
      code: '095760111111',
      label: 'Abenberg',
      provincie: 9,
      slug: 'abenberg',
    },
    {
      code: '095760113113',
      label: 'Allersberg',
      provincie: 9,
      slug: 'allersberg',
    },
    {
      code: '095760117117',
      label: 'Büchenbach',
      provincie: 9,
      slug: 'buechenbach',
    },
    {
      code: '095760121121',
      label: 'Georgensgmünd',
      provincie: 9,
      slug: 'georgensgmuend',
    },
    {
      code: '095760122122',
      label: 'Greding',
      provincie: 9,
      slug: 'greding',
    },
    {
      code: '095760126126',
      label: 'Heideck',
      provincie: 9,
      slug: 'heideck',
    },
    {
      code: '095760127127',
      label: 'Hilpoltstein',
      provincie: 9,
      slug: 'hilpoltstein',
    },
    {
      code: '095760128128',
      label: 'Kammerstein',
      provincie: 9,
      slug: 'kammerstein',
    },
    {
      code: '095760132132',
      label: 'Schwanstetten',
      provincie: 9,
      slug: 'schwanstetten',
    },
    {
      code: '095760137137',
      label: 'Rednitzhembach',
      provincie: 9,
      slug: 'rednitzhembach',
    },
    {
      code: '095760141141',
      label: 'Röttenbach',
      provincie: 9,
      slug: 'roettenbach-gemeinde',
    },
    {
      code: '095760142142',
      label: 'Rohr',
      provincie: 9,
      slug: 'rohr',
    },
    {
      code: '095760143143',
      label: 'Roth',
      provincie: 9,
      slug: 'roth-stadt',
    },
    {
      code: '095760147147',
      label: 'Spalt',
      provincie: 9,
      slug: 'spalt',
    },
    {
      code: '095760148148',
      label: 'Thalmässing',
      provincie: 9,
      slug: 'thalmaessing',
    },
    {
      code: '095760151151',
      label: 'Wendelstein',
      provincie: 9,
      slug: 'wendelstein',
    },
    {
      code: '095770114114',
      label: 'Muhr a.See',
      provincie: 9,
      slug: 'muhr-a-see',
    },
    {
      code: '095770136136',
      label: 'Gunzenhausen',
      provincie: 9,
      slug: 'gunzenhausen',
    },
    {
      code: '095770148148',
      label: 'Langenaltheim',
      provincie: 9,
      slug: 'langenaltheim',
    },
    {
      code: '095770158158',
      label: 'Pappenheim',
      provincie: 9,
      slug: 'pappenheim',
    },
    {
      code: '095770161161',
      label: 'Pleinfeld',
      provincie: 9,
      slug: 'pleinfeld',
    },
    {
      code: '095770162162',
      label: 'Polsingen',
      provincie: 9,
      slug: 'polsingen',
    },
    {
      code: '095770168168',
      label: 'Solnhofen',
      provincie: 9,
      slug: 'solnhofen',
    },
    {
      code: '095770173173',
      label: 'Treuchtlingen',
      provincie: 9,
      slug: 'treuchtlingen',
    },
    {
      code: '095770177177',
      label: 'Weißenburg i.Bay.',
      provincie: 9,
      slug: 'weissenburg-i-bay',
    },
    {
      code: '095775532111',
      label: 'Absberg',
      provincie: 9,
      slug: 'absberg',
    },
    {
      code: '095775532138',
      label: 'Haundorf',
      provincie: 9,
      slug: 'haundorf',
    },
    {
      code: '095775532159',
      label: 'Pfofeld',
      provincie: 9,
      slug: 'pfofeld',
    },
    {
      code: '095775532172',
      label: 'Theilenhofen',
      provincie: 9,
      slug: 'theilenhofen',
    },
    {
      code: '095775533113',
      label: 'Alesheim',
      provincie: 9,
      slug: 'alesheim',
    },
    {
      code: '095775533122',
      label: 'Dittenheim',
      provincie: 9,
      slug: 'dittenheim',
    },
    {
      code: '095775533149',
      label: 'Markt Berolzheim',
      provincie: 9,
      slug: 'markt-berolzheim',
    },
    {
      code: '095775533150',
      label: 'Meinheim',
      provincie: 9,
      slug: 'meinheim',
    },
    {
      code: '095775534125',
      label: 'Ellingen',
      provincie: 9,
      slug: 'ellingen',
    },
    {
      code: '095775534127',
      label: 'Ettenstatt',
      provincie: 9,
      slug: 'ettenstatt',
    },
    {
      code: '095775534141',
      label: 'Höttingen',
      provincie: 9,
      slug: 'hoettingen',
    },
    {
      code: '095775535115',
      label: 'Bergen',
      provincie: 9,
      slug: 'bergen-gemeinde',
    },
    {
      code: '095775535120',
      label: 'Burgsalach',
      provincie: 9,
      slug: 'burgsalach',
    },
    {
      code: '095775535151',
      label: 'Nennslingen',
      provincie: 9,
      slug: 'nennslingen',
    },
    {
      code: '095775535163',
      label: 'Raitenbuch',
      provincie: 9,
      slug: 'raitenbuch',
    },
    {
      code: '095775536133',
      label: 'Gnotzheim',
      provincie: 9,
      slug: 'gnotzheim',
    },
    {
      code: '095775536140',
      label: 'Heidenheim',
      provincie: 9,
      slug: 'heidenheim',
    },
    {
      code: '095775536179',
      label: 'Westheim',
      provincie: 9,
      slug: 'westheim',
    },
    {
      code: '096610000000',
      label: 'Aschaffenburg',
      provincie: 9,
      slug: 'aschaffenburg',
    },
    {
      code: '096620000000',
      label: 'Schweinfurt',
      provincie: 9,
      slug: 'schweinfurt',
    },
    {
      code: '096630000000',
      label: 'Würzburg',
      provincie: 9,
      slug: 'wuerzburg',
    },
    {
      code: '096710111111',
      label: 'Alzenau',
      provincie: 9,
      slug: 'alzenau',
    },
    {
      code: '096710112112',
      label: 'Bessenbach',
      provincie: 9,
      slug: 'bessenbach',
    },
    {
      code: '096710114114',
      label: 'Karlstein a.Main',
      provincie: 9,
      slug: 'karlstein-a-main',
    },
    {
      code: '096710119119',
      label: 'Geiselbach',
      provincie: 9,
      slug: 'geiselbach',
    },
    {
      code: '096710120120',
      label: 'Glattbach',
      provincie: 9,
      slug: 'glattbach',
    },
    {
      code: '096710121121',
      label: 'Goldbach',
      provincie: 9,
      slug: 'goldbach',
    },
    {
      code: '096710122122',
      label: 'Großostheim',
      provincie: 9,
      slug: 'grossostheim',
    },
    {
      code: '096710124124',
      label: 'Haibach',
      provincie: 9,
      slug: 'haibach-gemeinde',
    },
    {
      code: '096710130130',
      label: 'Hösbach',
      provincie: 9,
      slug: 'hoesbach',
    },
    {
      code: '096710133133',
      label: 'Johannesberg',
      provincie: 9,
      slug: 'johannesberg',
    },
    {
      code: '096710134134',
      label: 'Kahl a.Main',
      provincie: 9,
      slug: 'kahl-a-main',
    },
    {
      code: '096710136136',
      label: 'Kleinostheim',
      provincie: 9,
      slug: 'kleinostheim',
    },
    {
      code: '096710139139',
      label: 'Laufach',
      provincie: 9,
      slug: 'laufach',
    },
    {
      code: '096710140140',
      label: 'Mainaschaff',
      provincie: 9,
      slug: 'mainaschaff',
    },
    {
      code: '096710143143',
      label: 'Mömbris',
      provincie: 9,
      slug: 'moembris',
    },
    {
      code: '096710148148',
      label: 'Rothenbuch',
      provincie: 9,
      slug: 'rothenbuch',
    },
    {
      code: '096710150150',
      label: 'Sailauf',
      provincie: 9,
      slug: 'sailauf',
    },
    {
      code: '096710155155',
      label: 'Stockstadt a.Main',
      provincie: 9,
      slug: 'stockstadt-a-main',
    },
    {
      code: '096710156156',
      label: 'Waldaschaff',
      provincie: 9,
      slug: 'waldaschaff',
    },
    {
      code: '096710157157',
      label: 'Weibersbrunn',
      provincie: 9,
      slug: 'weibersbrunn',
    },
    {
      code: '096715602126',
      label: 'Heigenbrücken',
      provincie: 9,
      slug: 'heigenbruecken',
    },
    {
      code: '096715602128',
      label: 'Heinrichsthal',
      provincie: 9,
      slug: 'heinrichsthal',
    },
    {
      code: '096715603127',
      label: 'Heimbuchenthal',
      provincie: 9,
      slug: 'heimbuchenthal',
    },
    {
      code: '096715603141',
      label: 'Mespelbrunn',
      provincie: 9,
      slug: 'mespelbrunn',
    },
    {
      code: '096715603160',
      label: 'Dammbach',
      provincie: 9,
      slug: 'dammbach',
    },
    {
      code: '096715604113',
      label: 'Blankenbach',
      provincie: 9,
      slug: 'blankenbach',
    },
    {
      code: '096715604135',
      label: 'Kleinkahl',
      provincie: 9,
      slug: 'kleinkahl',
    },
    {
      code: '096715604138',
      label: 'Krombach',
      provincie: 9,
      slug: 'krombach',
    },
    {
      code: '096715604152',
      label: 'Schöllkrippen',
      provincie: 9,
      slug: 'schoellkrippen',
    },
    {
      code: '096715604153',
      label: 'Sommerkahl',
      provincie: 9,
      slug: 'sommerkahl',
    },
    {
      code: '096715604159',
      label: 'Westerngrund',
      provincie: 9,
      slug: 'westerngrund',
    },
    {
      code: '096715604162',
      label: 'Wiesen',
      provincie: 9,
      slug: 'wiesen',
    },
    {
      code: '096720112112',
      label: 'Bad Bocklet',
      provincie: 9,
      slug: 'bad-bocklet',
    },
    {
      code: '096720113113',
      label: 'Bad Brückenau',
      provincie: 9,
      slug: 'bad-brueckenau',
    },
    {
      code: '096720114114',
      label: 'Bad Kissingen',
      provincie: 9,
      slug: 'bad-kissingen',
    },
    {
      code: '096720117117',
      label: 'Burkardroth',
      provincie: 9,
      slug: 'burkardroth',
    },
    {
      code: '096720127127',
      label: 'Hammelburg',
      provincie: 9,
      slug: 'hammelburg',
    },
    {
      code: '096720134134',
      label: 'Motten',
      provincie: 9,
      slug: 'motten',
    },
    {
      code: '096720135135',
      label: 'Münnerstadt',
      provincie: 9,
      slug: 'muennerstadt',
    },
    {
      code: '096720136136',
      label: 'Nüdlingen',
      provincie: 9,
      slug: 'nuedlingen',
    },
    {
      code: '096720139139',
      label: 'Oberthulba',
      provincie: 9,
      slug: 'oberthulba',
    },
    {
      code: '096720140140',
      label: 'Oerlenbach',
      provincie: 9,
      slug: 'oerlenbach',
    },
    {
      code: '096720161161',
      label: 'Wartmannsroth',
      provincie: 9,
      slug: 'wartmannsroth',
    },
    {
      code: '096720163163',
      label: 'Wildflecken',
      provincie: 9,
      slug: 'wildflecken',
    },
    {
      code: '096720166166',
      label: 'Zeitlofs',
      provincie: 9,
      slug: 'zeitlofs',
    },
    {
      code: '096725606126',
      label: 'Geroda',
      provincie: 9,
      slug: 'geroda',
    },
    {
      code: '096725606138',
      label: 'Oberleichtersbach',
      provincie: 9,
      slug: 'oberleichtersbach',
    },
    {
      code: '096725606145',
      label: 'Riedenberg',
      provincie: 9,
      slug: 'riedenberg',
    },
    {
      code: '096725606149',
      label: 'Schondra',
      provincie: 9,
      slug: 'schondra',
    },
    {
      code: '096725607121',
      label: 'Elfershausen',
      provincie: 9,
      slug: 'elfershausen',
    },
    {
      code: '096725607124',
      label: 'Fuchsstadt',
      provincie: 9,
      slug: 'fuchsstadt',
    },
    {
      code: '096725608111',
      label: 'Aura a.d.Saale',
      provincie: 9,
      slug: 'aura-a-d-saale',
    },
    {
      code: '096725608122',
      label: 'Euerdorf',
      provincie: 9,
      slug: 'euerdorf',
    },
    {
      code: '096725608142',
      label: 'Ramsthal',
      provincie: 9,
      slug: 'ramsthal',
    },
    {
      code: '096725608155',
      label: 'Sulzthal',
      provincie: 9,
      slug: 'sulzthal',
    },
    {
      code: '096725609131',
      label: 'Maßbach',
      provincie: 9,
      slug: 'massbach',
    },
    {
      code: '096725609143',
      label: 'Rannungen',
      provincie: 9,
      slug: 'rannungen',
    },
    {
      code: '096725609157',
      label: 'Thundorf i.UFr.',
      provincie: 9,
      slug: 'thundorf-i-ufr',
    },
    {
      code: '096730114114',
      label: 'Bad Neustadt a.d.Saale',
      provincie: 9,
      slug: 'bad-neustadt-a-d-saale',
    },
    {
      code: '096730117117',
      label: 'Bischofsheim i.d.Rhön',
      provincie: 9,
      slug: 'bischofsheim-i-d-rhoen',
    },
    {
      code: '096730141141',
      label: 'Bad Königshofen i.Grabfeld',
      provincie: 9,
      slug: 'bad-koenigshofen-i-grabfeld',
    },
    {
      code: '096730149149',
      label: 'Oberelsbach',
      provincie: 9,
      slug: 'oberelsbach',
    },
    {
      code: '096730162162',
      label: 'Sandberg',
      provincie: 9,
      slug: 'sandberg',
    },
    {
      code: '096735633116',
      label: 'Bastheim',
      provincie: 9,
      slug: 'bastheim',
    },
    {
      code: '096735633130',
      label: 'Hendungen',
      provincie: 9,
      slug: 'hendungen',
    },
    {
      code: '096735633142',
      label: 'Mellrichstadt',
      provincie: 9,
      slug: 'mellrichstadt',
    },
    {
      code: '096735633151',
      label: 'Oberstreu',
      provincie: 9,
      slug: 'oberstreu',
    },
    {
      code: '096735633170',
      label: 'Stockheim',
      provincie: 9,
      slug: 'stockheim-gemeinde',
    },
    {
      code: '096735634113',
      label: 'Aubstadt',
      provincie: 9,
      slug: 'aubstadt',
    },
    {
      code: '096735634126',
      label: 'Großbardorf',
      provincie: 9,
      slug: 'grossbardorf',
    },
    {
      code: '096735634131',
      label: 'Herbstadt',
      provincie: 9,
      slug: 'herbstadt',
    },
    {
      code: '096735634134',
      label: 'Höchheim',
      provincie: 9,
      slug: 'hoechheim',
    },
    {
      code: '096735634172',
      label: 'Sulzdorf a.d.Lederhecke',
      provincie: 9,
      slug: 'sulzdorf-a-d-lederhecke',
    },
    {
      code: '096735634173',
      label: 'Sulzfeld',
      provincie: 9,
      slug: 'sulzfeld-gemeinde',
    },
    {
      code: '096735634174',
      label: 'Trappstadt',
      provincie: 9,
      slug: 'trappstadt',
    },
    {
      code: '096735635135',
      label: 'Hohenroth',
      provincie: 9,
      slug: 'hohenroth',
    },
    {
      code: '096735635146',
      label: 'Niederlauer',
      provincie: 9,
      slug: 'niederlauer',
    },
    {
      code: '096735635156',
      label: 'Rödelmaier',
      provincie: 9,
      slug: 'roedelmaier',
    },
    {
      code: '096735635161',
      label: 'Salz',
      provincie: 9,
      slug: 'salz-gemeinde',
    },
    {
      code: '096735635163',
      label: 'Schönau a.d.Brend',
      provincie: 9,
      slug: 'schoenau-a-d-brend',
    },
    {
      code: '096735635171',
      label: 'Strahlungen',
      provincie: 9,
      slug: 'strahlungen',
    },
    {
      code: '096735635186',
      label: 'Burglauer',
      provincie: 9,
      slug: 'burglauer',
    },
    {
      code: '096735637123',
      label: 'Fladungen',
      provincie: 9,
      slug: 'fladungen',
    },
    {
      code: '096735637129',
      label: 'Hausen',
      provincie: 9,
      slug: 'hausen-gemeinde',
    },
    {
      code: '096735637147',
      label: 'Nordheim v.d.Rhön',
      provincie: 9,
      slug: 'nordheim-v-d-rhoen',
    },
    {
      code: '096735638133',
      label: 'Heustreu',
      provincie: 9,
      slug: 'heustreu',
    },
    {
      code: '096735638136',
      label: 'Hollstadt',
      provincie: 9,
      slug: 'hollstadt',
    },
    {
      code: '096735638175',
      label: 'Unsleben',
      provincie: 9,
      slug: 'unsleben',
    },
    {
      code: '096735638183',
      label: 'Wollbach',
      provincie: 9,
      slug: 'wollbach',
    },
    {
      code: '096735639153',
      label: 'Ostheim v.d.Rhön',
      provincie: 9,
      slug: 'ostheim-v-d-rhoen',
    },
    {
      code: '096735639167',
      label: 'Sondheim v.d.Rhön',
      provincie: 9,
      slug: 'sondheim-v-d-rhoen',
    },
    {
      code: '096735639182',
      label: 'Willmars',
      provincie: 9,
      slug: 'willmars',
    },
    {
      code: '096735640127',
      label: 'Großeibstadt',
      provincie: 9,
      slug: 'grosseibstadt',
    },
    {
      code: '096735640160',
      label: 'Saal a.d.Saale',
      provincie: 9,
      slug: 'saal-a-d-saale',
    },
    {
      code: '096735640184',
      label: 'Wülfershausen a.d.Saale',
      provincie: 9,
      slug: 'wuelfershausen-a-d-saale',
    },
    {
      code: '096740133133',
      label: 'Eltmann',
      provincie: 9,
      slug: 'eltmann',
    },
    {
      code: '096740147147',
      label: 'Haßfurt',
      provincie: 9,
      slug: 'hassfurt',
    },
    {
      code: '096740159159',
      label: 'Oberaurach',
      provincie: 9,
      slug: 'oberaurach',
    },
    {
      code: '096740163163',
      label: 'Knetzgau',
      provincie: 9,
      slug: 'knetzgau',
    },
    {
      code: '096740164164',
      label: 'Königsberg i.Bay.',
      provincie: 9,
      slug: 'koenigsberg-i-bay',
    },
    {
      code: '096740171171',
      label: 'Maroldsweisach',
      provincie: 9,
      slug: 'maroldsweisach',
    },
    {
      code: '096740187187',
      label: 'Rauhenebrach',
      provincie: 9,
      slug: 'rauhenebrach',
    },
    {
      code: '096740195195',
      label: 'Sand a.Main',
      provincie: 9,
      slug: 'sand-a-main',
    },
    {
      code: '096740210210',
      label: 'Untermerzbach',
      provincie: 9,
      slug: 'untermerzbach',
    },
    {
      code: '096740221221',
      label: 'Zeil a.Main',
      provincie: 9,
      slug: 'zeil-a-main',
    },
    {
      code: '096745610118',
      label: 'Breitbrunn',
      provincie: 9,
      slug: 'breitbrunn',
    },
    {
      code: '096745610129',
      label: 'Ebelsbach',
      provincie: 9,
      slug: 'ebelsbach',
    },
    {
      code: '096745610160',
      label: 'Kirchlauter',
      provincie: 9,
      slug: 'kirchlauter',
    },
    {
      code: '096745610201',
      label: 'Stettfeld',
      provincie: 9,
      slug: 'stettfeld',
    },
    {
      code: '096745611130',
      label: 'Ebern',
      provincie: 9,
      slug: 'ebern',
    },
    {
      code: '096745611184',
      label: 'Pfarrweisach',
      provincie: 9,
      slug: 'pfarrweisach',
    },
    {
      code: '096745611190',
      label: 'Rentweinsdorf',
      provincie: 9,
      slug: 'rentweinsdorf',
    },
    {
      code: '096745612111',
      label: 'Aidhausen',
      provincie: 9,
      slug: 'aidhausen',
    },
    {
      code: '096745612120',
      label: 'Bundorf',
      provincie: 9,
      slug: 'bundorf',
    },
    {
      code: '096745612121',
      label: 'Burgpreppach',
      provincie: 9,
      slug: 'burgpreppach',
    },
    {
      code: '096745612149',
      label: 'Hofheim i.UFr.',
      provincie: 9,
      slug: 'hofheim-i-ufr',
    },
    {
      code: '096745612153',
      label: 'Riedbach',
      provincie: 9,
      slug: 'riedbach',
    },
    {
      code: '096745612223',
      label: 'Ermershausen',
      provincie: 9,
      slug: 'ermershausen',
    },
    {
      code: '096745613139',
      label: 'Gädheim',
      provincie: 9,
      slug: 'gaedheim',
    },
    {
      code: '096745613180',
      label: 'Theres',
      provincie: 9,
      slug: 'theres',
    },
    {
      code: '096745613219',
      label: 'Wonfurt',
      provincie: 9,
      slug: 'wonfurt',
    },
    {
      code: '096750117117',
      label: 'Dettelbach',
      provincie: 9,
      slug: 'dettelbach',
    },
    {
      code: '096750127127',
      label: 'Geiselwind',
      provincie: 9,
      slug: 'geiselwind',
    },
    {
      code: '096750141141',
      label: 'Kitzingen',
      provincie: 9,
      slug: 'kitzingen',
    },
    {
      code: '096750144144',
      label: 'Mainbernheim',
      provincie: 9,
      slug: 'mainbernheim',
    },
    {
      code: '096750158158',
      label: 'Prichsenstadt',
      provincie: 9,
      slug: 'prichsenstadt',
    },
    {
      code: '096750165165',
      label: 'Schwarzach a.Main',
      provincie: 9,
      slug: 'schwarzach-a-main',
    },
    {
      code: '096755614111',
      label: 'Abtswind',
      provincie: 9,
      slug: 'abtswind',
    },
    {
      code: '096755614116',
      label: 'Castell',
      provincie: 9,
      slug: 'castell',
    },
    {
      code: '096755614162',
      label: 'Rüdenhausen',
      provincie: 9,
      slug: 'ruedenhausen',
    },
    {
      code: '096755614178',
      label: 'Wiesentheid',
      provincie: 9,
      slug: 'wiesentheid',
    },
    {
      code: '096755615131',
      label: 'Großlangheim',
      provincie: 9,
      slug: 'grosslangheim',
    },
    {
      code: '096755615142',
      label: 'Kleinlangheim',
      provincie: 9,
      slug: 'kleinlangheim',
    },
    {
      code: '096755615177',
      label: 'Wiesenbronn',
      provincie: 9,
      slug: 'wiesenbronn',
    },
    {
      code: '096755616139',
      label: 'Iphofen',
      provincie: 9,
      slug: 'iphofen',
    },
    {
      code: '096755616148',
      label: 'Markt Einersheim',
      provincie: 9,
      slug: 'markt-einersheim',
    },
    {
      code: '096755616161',
      label: 'Rödelsee',
      provincie: 9,
      slug: 'roedelsee',
    },
    {
      code: '096755616179',
      label: 'Willanzheim',
      provincie: 9,
      slug: 'willanzheim',
    },
    {
      code: '096755617112',
      label: 'Albertshofen',
      provincie: 9,
      slug: 'albertshofen',
    },
    {
      code: '096755617113',
      label: 'Biebelried',
      provincie: 9,
      slug: 'biebelried',
    },
    {
      code: '096755617114',
      label: 'Buchbrunn',
      provincie: 9,
      slug: 'buchbrunn',
    },
    {
      code: '096755617146',
      label: 'Mainstockheim',
      provincie: 9,
      slug: 'mainstockheim',
    },
    {
      code: '096755617170',
      label: 'Sulzfeld a.Main',
      provincie: 9,
      slug: 'sulzfeld-a-main',
    },
    {
      code: '096755618147',
      label: 'Marktbreit',
      provincie: 9,
      slug: 'marktbreit',
    },
    {
      code: '096755618149',
      label: 'Marktsteft',
      provincie: 9,
      slug: 'marktsteft',
    },
    {
      code: '096755618150',
      label: 'Martinsheim',
      provincie: 9,
      slug: 'martinsheim',
    },
    {
      code: '096755618156',
      label: 'Obernbreit',
      provincie: 9,
      slug: 'obernbreit',
    },
    {
      code: '096755618166',
      label: 'Segnitz',
      provincie: 9,
      slug: 'segnitz',
    },
    {
      code: '096755618167',
      label: 'Seinsheim',
      provincie: 9,
      slug: 'seinsheim',
    },
    {
      code: '096755619155',
      label: 'Nordheim a.Main',
      provincie: 9,
      slug: 'nordheim-a-main',
    },
    {
      code: '096755619169',
      label: 'Sommerach',
      provincie: 9,
      slug: 'sommerach',
    },
    {
      code: '096755619174',
      label: 'Volkach',
      provincie: 9,
      slug: 'volkach',
    },
    {
      code: '096760112112',
      label: 'Amorbach',
      provincie: 9,
      slug: 'amorbach',
    },
    {
      code: '096760117117',
      label: 'Collenberg',
      provincie: 9,
      slug: 'collenberg',
    },
    {
      code: '096760118118',
      label: 'Dorfprozelten',
      provincie: 9,
      slug: 'dorfprozelten',
    },
    {
      code: '096760119119',
      label: 'Eichenbühl',
      provincie: 9,
      slug: 'eichenbuehl',
    },
    {
      code: '096760121121',
      label: 'Elsenfeld',
      provincie: 9,
      slug: 'elsenfeld',
    },
    {
      code: '096760122122',
      label: 'Erlenbach a.Main',
      provincie: 9,
      slug: 'erlenbach-a-main',
    },
    {
      code: '096760123123',
      label: 'Eschau',
      provincie: 9,
      slug: 'eschau',
    },
    {
      code: '096760124124',
      label: 'Faulbach',
      provincie: 9,
      slug: 'faulbach',
    },
    {
      code: '096760125125',
      label: 'Großheubach',
      provincie: 9,
      slug: 'grossheubach',
    },
    {
      code: '096760126126',
      label: 'Großwallstadt',
      provincie: 9,
      slug: 'grosswallstadt',
    },
    {
      code: '096760131131',
      label: 'Kirchzell',
      provincie: 9,
      slug: 'kirchzell',
    },
    {
      code: '096760134134',
      label: 'Klingenberg a.Main',
      provincie: 9,
      slug: 'klingenberg-a-main',
    },
    {
      code: '096760136136',
      label: 'Leidersbach',
      provincie: 9,
      slug: 'leidersbach',
    },
    {
      code: '096760139139',
      label: 'Miltenberg',
      provincie: 9,
      slug: 'miltenberg',
    },
    {
      code: '096760140140',
      label: 'Mömlingen',
      provincie: 9,
      slug: 'moemlingen',
    },
    {
      code: '096760144144',
      label: 'Niedernberg',
      provincie: 9,
      slug: 'niedernberg',
    },
    {
      code: '096760145145',
      label: 'Obernburg a.Main',
      provincie: 9,
      slug: 'obernburg-a-main',
    },
    {
      code: '096760156156',
      label: 'Schneeberg',
      provincie: 9,
      slug: 'schneeberg',
    },
    {
      code: '096760160160',
      label: 'Sulzbach a.Main',
      provincie: 9,
      slug: 'sulzbach-a-main',
    },
    {
      code: '096760165165',
      label: 'Weilbach',
      provincie: 9,
      slug: 'weilbach',
    },
    {
      code: '096760169169',
      label: 'Wörth a.Main',
      provincie: 9,
      slug: 'woerth-a-main',
    },
    {
      code: '096765626116',
      label: 'Bürgstadt',
      provincie: 9,
      slug: 'buergstadt',
    },
    {
      code: '096765626143',
      label: 'Neunkirchen',
      provincie: 9,
      slug: 'neunkirchen-gemeinde',
    },
    {
      code: '096765627132',
      label: 'Kleinheubach',
      provincie: 9,
      slug: 'kleinheubach',
    },
    {
      code: '096765627135',
      label: 'Laudenbach',
      provincie: 9,
      slug: 'laudenbach-gemeinde',
    },
    {
      code: '096765627153',
      label: 'Rüdenau',
      provincie: 9,
      slug: 'ruedenau',
    },
    {
      code: '096765630128',
      label: 'Hausen',
      provincie: 9,
      slug: 'hausen-gemeinde',
    },
    {
      code: '096765630133',
      label: 'Kleinwallstadt',
      provincie: 9,
      slug: 'kleinwallstadt',
    },
    {
      code: '096765631141',
      label: 'Mönchberg',
      provincie: 9,
      slug: 'moenchberg',
    },
    {
      code: '096765631151',
      label: 'Röllbach',
      provincie: 9,
      slug: 'roellbach',
    },
    {
      code: '096765632111',
      label: 'Altenbuch',
      provincie: 9,
      slug: 'altenbuch',
    },
    {
      code: '096765632158',
      label: 'Stadtprozelten',
      provincie: 9,
      slug: 'stadtprozelten',
    },
    {
      code: '096770114114',
      label: 'Arnstein',
      provincie: 9,
      slug: 'arnstein',
    },
    {
      code: '096770127127',
      label: 'Eußenheim',
      provincie: 9,
      slug: 'eussenheim',
    },
    {
      code: '096770129129',
      label: 'Frammersbach',
      provincie: 9,
      slug: 'frammersbach',
    },
    {
      code: '096770131131',
      label: 'Gemünden a.Main',
      provincie: 9,
      slug: 'gemuenden-a-main',
    },
    {
      code: '096770148148',
      label: 'Karlstadt',
      provincie: 9,
      slug: 'karlstadt',
    },
    {
      code: '096770154154',
      label: 'Triefenstein',
      provincie: 9,
      slug: 'triefenstein',
    },
    {
      code: '096770155155',
      label: 'Lohr a.Main',
      provincie: 9,
      slug: 'lohr-a-main',
    },
    {
      code: '096770157157',
      label: 'Marktheidenfeld',
      provincie: 9,
      slug: 'marktheidenfeld',
    },
    {
      code: '096770177177',
      label: 'Rieneck',
      provincie: 9,
      slug: 'rieneck',
    },
    {
      code: '096775620137',
      label: 'Hasloch',
      provincie: 9,
      slug: 'hasloch',
    },
    {
      code: '096775620151',
      label: 'Kreuzwertheim',
      provincie: 9,
      slug: 'kreuzwertheim',
    },
    {
      code: '096775620182',
      label: 'Schollbrunn',
      provincie: 9,
      slug: 'schollbrunn',
    },
    {
      code: '096775621119',
      label: 'Birkenfeld',
      provincie: 9,
      slug: 'birkenfeld-gemeinde',
    },
    {
      code: '096775621120',
      label: 'Bischbrunn',
      provincie: 9,
      slug: 'bischbrunn',
    },
    {
      code: '096775621125',
      label: 'Erlenbach b.Marktheidenfeld',
      provincie: 9,
      slug: 'erlenbach-b-marktheidenfeld',
    },
    {
      code: '096775621126',
      label: 'Esselbach',
      provincie: 9,
      slug: 'esselbach',
    },
    {
      code: '096775621135',
      label: 'Hafenlohr',
      provincie: 9,
      slug: 'hafenlohr',
    },
    {
      code: '096775621146',
      label: 'Karbach',
      provincie: 9,
      slug: 'karbach-gemeinde',
    },
    {
      code: '096775621178',
      label: 'Roden',
      provincie: 9,
      slug: 'roden',
    },
    {
      code: '096775621181',
      label: 'Rothenfels',
      provincie: 9,
      slug: 'rothenfels',
    },
    {
      code: '096775621193',
      label: 'Urspringen',
      provincie: 9,
      slug: 'urspringen',
    },
    {
      code: '096775622116',
      label: 'Aura i.Sinngrund',
      provincie: 9,
      slug: 'aura-i-sinngrund',
    },
    {
      code: '096775622122',
      label: 'Burgsinn',
      provincie: 9,
      slug: 'burgsinn',
    },
    {
      code: '096775622128',
      label: 'Fellen',
      provincie: 9,
      slug: 'fellen',
    },
    {
      code: '096775622159',
      label: 'Mittelsinn',
      provincie: 9,
      slug: 'mittelsinn',
    },
    {
      code: '096775622169',
      label: 'Obersinn',
      provincie: 9,
      slug: 'obersinn',
    },
    {
      code: '096775623132',
      label: 'Gössenheim',
      provincie: 9,
      slug: 'goessenheim',
    },
    {
      code: '096775623133',
      label: 'Gräfendorf',
      provincie: 9,
      slug: 'graefendorf',
    },
    {
      code: '096775623149',
      label: 'Karsbach',
      provincie: 9,
      slug: 'karsbach',
    },
    {
      code: '096775624164',
      label: 'Neuendorf',
      provincie: 9,
      slug: 'neuendorf-gemeinde',
    },
    {
      code: '096775624166',
      label: 'Neustadt a.Main',
      provincie: 9,
      slug: 'neustadt-a-main',
    },
    {
      code: '096775624172',
      label: 'Rechtenbach',
      provincie: 9,
      slug: 'rechtenbach',
    },
    {
      code: '096775624186',
      label: 'Steinfeld',
      provincie: 9,
      slug: 'steinfeld-gemeinde',
    },
    {
      code: '096775625142',
      label: 'Himmelstadt',
      provincie: 9,
      slug: 'himmelstadt',
    },
    {
      code: '096775625175',
      label: 'Retzstadt',
      provincie: 9,
      slug: 'retzstadt',
    },
    {
      code: '096775625189',
      label: 'Thüngen',
      provincie: 9,
      slug: 'thuengen',
    },
    {
      code: '096775625203',
      label: 'Zellingen',
      provincie: 9,
      slug: 'zellingen',
    },
    {
      code: '096775656165',
      label: 'Neuhütten',
      provincie: 9,
      slug: 'neuhuetten-gemeinde',
    },
    {
      code: '096775656170',
      label: 'Partenstein',
      provincie: 9,
      slug: 'partenstein',
    },
    {
      code: '096775656200',
      label: 'Wiesthal',
      provincie: 9,
      slug: 'wiesthal',
    },
    {
      code: '096780115115',
      label: 'Bergrheinfeld',
      provincie: 9,
      slug: 'bergrheinfeld',
    },
    {
      code: '096780123123',
      label: 'Dittelbrunn',
      provincie: 9,
      slug: 'dittelbrunn',
    },
    {
      code: '096780128128',
      label: 'Euerbach',
      provincie: 9,
      slug: 'euerbach',
    },
    {
      code: '096780132132',
      label: 'Geldersheim',
      provincie: 9,
      slug: 'geldersheim',
    },
    {
      code: '096780135135',
      label: 'Gochsheim',
      provincie: 9,
      slug: 'gochsheim',
    },
    {
      code: '096780136136',
      label: 'Grafenrheinfeld',
      provincie: 9,
      slug: 'grafenrheinfeld',
    },
    {
      code: '096780138138',
      label: 'Grettstadt',
      provincie: 9,
      slug: 'grettstadt',
    },
    {
      code: '096780150150',
      label: 'Kolitzheim',
      provincie: 9,
      slug: 'kolitzheim',
    },
    {
      code: '096780160160',
      label: 'Niederwerrn',
      provincie: 9,
      slug: 'niederwerrn',
    },
    {
      code: '096780168168',
      label: 'Poppenhausen',
      provincie: 9,
      slug: 'poppenhausen',
    },
    {
      code: '096780170170',
      label: 'Röthlein',
      provincie: 9,
      slug: 'roethlein',
    },
    {
      code: '096780174174',
      label: 'Schonungen',
      provincie: 9,
      slug: 'schonungen',
    },
    {
      code: '096780176176',
      label: 'Schwebheim',
      provincie: 9,
      slug: 'schwebheim',
    },
    {
      code: '096780178178',
      label: 'Sennfeld',
      provincie: 9,
      slug: 'sennfeld',
    },
    {
      code: '096780181181',
      label: 'Stadtlauringen',
      provincie: 9,
      slug: 'stadtlauringen',
    },
    {
      code: '096780186186',
      label: 'Üchtelhausen',
      provincie: 9,
      slug: 'uechtelhausen',
    },
    {
      code: '096780190190',
      label: 'Waigolshausen',
      provincie: 9,
      slug: 'waigolshausen',
    },
    {
      code: '096780192192',
      label: 'Wasserlosen',
      provincie: 9,
      slug: 'wasserlosen',
    },
    {
      code: '096780193193',
      label: 'Werneck',
      provincie: 9,
      slug: 'werneck',
    },
    {
      code: '096785642122',
      label: 'Dingolshausen',
      provincie: 9,
      slug: 'dingolshausen',
    },
    {
      code: '096785642124',
      label: 'Donnersdorf',
      provincie: 9,
      slug: 'donnersdorf',
    },
    {
      code: '096785642130',
      label: 'Frankenwinheim',
      provincie: 9,
      slug: 'frankenwinheim',
    },
    {
      code: '096785642134',
      label: 'Gerolzhofen',
      provincie: 9,
      slug: 'gerolzhofen',
    },
    {
      code: '096785642153',
      label: 'Lülsfeld',
      provincie: 9,
      slug: 'luelsfeld',
    },
    {
      code: '096785642157',
      label: 'Michelau i.Steigerwald',
      provincie: 9,
      slug: 'michelau-i-steigerwald',
    },
    {
      code: '096785642164',
      label: 'Oberschwarzach',
      provincie: 9,
      slug: 'oberschwarzach',
    },
    {
      code: '096785642183',
      label: 'Sulzheim',
      provincie: 9,
      slug: 'sulzheim-gemeinde',
    },
    {
      code: '096785643175',
      label: 'Schwanfeld',
      provincie: 9,
      slug: 'schwanfeld',
    },
    {
      code: '096785643196',
      label: 'Wipfeld',
      provincie: 9,
      slug: 'wipfeld',
    },
    {
      code: '096790126126',
      label: 'Eisingen',
      provincie: 9,
      slug: 'eisingen-gemeinde',
    },
    {
      code: '096790134134',
      label: 'Gaukönigshofen',
      provincie: 9,
      slug: 'gaukoenigshofen',
    },
    {
      code: '096790136136',
      label: 'Gerbrunn',
      provincie: 9,
      slug: 'gerbrunn',
    },
    {
      code: '096790142142',
      label: 'Güntersleben',
      provincie: 9,
      slug: 'guentersleben',
    },
    {
      code: '096790143143',
      label: 'Hausen b.Würzburg',
      provincie: 9,
      slug: 'hausen-b-wuerzburg',
    },
    {
      code: '096790147147',
      label: 'Höchberg',
      provincie: 9,
      slug: 'hoechberg',
    },
    {
      code: '096790155155',
      label: 'Kleinrinderfeld',
      provincie: 9,
      slug: 'kleinrinderfeld',
    },
    {
      code: '096790156156',
      label: 'Kürnach',
      provincie: 9,
      slug: 'kuernach',
    },
    {
      code: '096790164164',
      label: 'Neubrunn',
      provincie: 9,
      slug: 'neubrunn',
    },
    {
      code: '096790170170',
      label: 'Ochsenfurt',
      provincie: 9,
      slug: 'ochsenfurt',
    },
    {
      code: '096790175175',
      label: 'Randersacker',
      provincie: 9,
      slug: 'randersacker',
    },
    {
      code: '096790176176',
      label: 'Reichenberg',
      provincie: 9,
      slug: 'reichenberg-gemeinde',
    },
    {
      code: '096790180180',
      label: 'Rimpar',
      provincie: 9,
      slug: 'rimpar',
    },
    {
      code: '096790185185',
      label: 'Rottendorf',
      provincie: 9,
      slug: 'rottendorf',
    },
    {
      code: '096790193193',
      label: 'Theilheim',
      provincie: 9,
      slug: 'theilheim',
    },
    {
      code: '096790194194',
      label: 'Thüngersheim',
      provincie: 9,
      slug: 'thuengersheim',
    },
    {
      code: '096790200200',
      label: 'Leinach',
      provincie: 9,
      slug: 'leinach',
    },
    {
      code: '096790201201',
      label: 'Unterpleichfeld',
      provincie: 9,
      slug: 'unterpleichfeld',
    },
    {
      code: '096790202202',
      label: 'Veitshöchheim',
      provincie: 9,
      slug: 'veitshoechheim',
    },
    {
      code: '096790204204',
      label: 'Waldbrunn',
      provincie: 9,
      slug: 'waldbrunn-gemeinde',
    },
    {
      code: '096790205205',
      label: 'Waldbüttelbrunn',
      provincie: 9,
      slug: 'waldbuettelbrunn',
    },
    {
      code: '096790209209',
      label: 'Zell a.Main',
      provincie: 9,
      slug: 'zell-a-main',
    },
    {
      code: '096795644114',
      label: 'Aub',
      provincie: 9,
      slug: 'aub',
    },
    {
      code: '096795644135',
      label: 'Gelchsheim',
      provincie: 9,
      slug: 'gelchsheim',
    },
    {
      code: '096795644188',
      label: 'Sonderhofen',
      provincie: 9,
      slug: 'sonderhofen',
    },
    {
      code: '096795645117',
      label: 'Bergtheim',
      provincie: 9,
      slug: 'bergtheim',
    },
    {
      code: '096795645169',
      label: 'Oberpleichfeld',
      provincie: 9,
      slug: 'oberpleichfeld',
    },
    {
      code: '096795646124',
      label: 'Eibelstadt',
      provincie: 9,
      slug: 'eibelstadt',
    },
    {
      code: '096795646131',
      label: 'Frickenhausen a.Main',
      provincie: 9,
      slug: 'frickenhausen-a-main',
    },
    {
      code: '096795646187',
      label: 'Sommerhausen',
      provincie: 9,
      slug: 'sommerhausen',
    },
    {
      code: '096795646206',
      label: 'Winterhausen',
      provincie: 9,
      slug: 'winterhausen',
    },
    {
      code: '096795647130',
      label: 'Estenfeld',
      provincie: 9,
      slug: 'estenfeld',
    },
    {
      code: '096795647167',
      label: 'Eisenheim',
      provincie: 9,
      slug: 'eisenheim',
    },
    {
      code: '096795647174',
      label: 'Prosselsheim',
      provincie: 9,
      slug: 'prosselsheim',
    },
    {
      code: '096795648122',
      label: 'Bütthard',
      provincie: 9,
      slug: 'buetthard',
    },
    {
      code: '096795648138',
      label: 'Giebelstadt',
      provincie: 9,
      slug: 'giebelstadt',
    },
    {
      code: '096795649144',
      label: 'Helmstadt',
      provincie: 9,
      slug: 'helmstadt',
    },
    {
      code: '096795649149',
      label: 'Holzkirchen',
      provincie: 9,
      slug: 'holzkirchen-gemeinde',
    },
    {
      code: '096795649177',
      label: 'Remlingen',
      provincie: 9,
      slug: 'remlingen',
    },
    {
      code: '096795649196',
      label: 'Uettingen',
      provincie: 9,
      slug: 'uettingen',
    },
    {
      code: '096795650137',
      label: 'Geroldshausen',
      provincie: 9,
      slug: 'geroldshausen',
    },
    {
      code: '096795650153',
      label: 'Kirchheim',
      provincie: 9,
      slug: 'kirchheim-gemeinde',
    },
    {
      code: '096795651154',
      label: 'Kist',
      provincie: 9,
      slug: 'kist',
    },
    {
      code: '096795651165',
      label: 'Altertheim',
      provincie: 9,
      slug: 'altertheim',
    },
    {
      code: '096795652128',
      label: 'Erlabrunn',
      provincie: 9,
      slug: 'erlabrunn',
    },
    {
      code: '096795652161',
      label: 'Margetshöchheim',
      provincie: 9,
      slug: 'margetshoechheim',
    },
    {
      code: '096795654118',
      label: 'Bieberehren',
      provincie: 9,
      slug: 'bieberehren',
    },
    {
      code: '096795654179',
      label: 'Riedenheim',
      provincie: 9,
      slug: 'riedenheim',
    },
    {
      code: '096795654182',
      label: 'Röttingen',
      provincie: 9,
      slug: 'roettingen',
    },
    {
      code: '096795654192',
      label: 'Tauberrettersheim',
      provincie: 9,
      slug: 'tauberrettersheim',
    },
    {
      code: '096795655141',
      label: 'Greußenheim',
      provincie: 9,
      slug: 'greussenheim',
    },
    {
      code: '096795655146',
      label: 'Hettstadt',
      provincie: 9,
      slug: 'hettstadt',
    },
    {
      code: '097610000000',
      label: 'Augsburg',
      provincie: 9,
      slug: 'augsburg',
    },
    {
      code: '097620000000',
      label: 'Kaufbeuren',
      provincie: 9,
      slug: 'kaufbeuren',
    },
    {
      code: '097630000000',
      label: 'Kempten (Allgäu)',
      provincie: 9,
      slug: 'kempten-allgaeu',
    },
    {
      code: '097640000000',
      label: 'Memmingen',
      provincie: 9,
      slug: 'memmingen',
    },
    {
      code: '097710112112',
      label: 'Affing',
      provincie: 9,
      slug: 'affing',
    },
    {
      code: '097710113113',
      label: 'Aichach',
      provincie: 9,
      slug: 'aichach',
    },
    {
      code: '097710130130',
      label: 'Friedberg',
      provincie: 9,
      slug: 'friedberg',
    },
    {
      code: '097710140140',
      label: 'Hollenbach',
      provincie: 9,
      slug: 'hollenbach',
    },
    {
      code: '097710141141',
      label: 'Inchenhofen',
      provincie: 9,
      slug: 'inchenhofen',
    },
    {
      code: '097710142142',
      label: 'Kissing',
      provincie: 9,
      slug: 'kissing',
    },
    {
      code: '097710145145',
      label: 'Merching',
      provincie: 9,
      slug: 'merching',
    },
    {
      code: '097710158158',
      label: 'Rehling',
      provincie: 9,
      slug: 'rehling',
    },
    {
      code: '097710160160',
      label: 'Ried',
      provincie: 9,
      slug: 'ried',
    },
    {
      code: '097715701114',
      label: 'Aindling',
      provincie: 9,
      slug: 'aindling',
    },
    {
      code: '097715701155',
      label: 'Petersdorf',
      provincie: 9,
      slug: 'petersdorf',
    },
    {
      code: '097715701169',
      label: 'Todtenweis',
      provincie: 9,
      slug: 'todtenweis',
    },
    {
      code: '097715703144',
      label: 'Kühbach',
      provincie: 9,
      slug: 'kuehbach',
    },
    {
      code: '097715703162',
      label: 'Schiltberg',
      provincie: 9,
      slug: 'schiltberg',
    },
    {
      code: '097715704111',
      label: 'Adelzhausen',
      provincie: 9,
      slug: 'adelzhausen',
    },
    {
      code: '097715704122',
      label: 'Dasing',
      provincie: 9,
      slug: 'dasing',
    },
    {
      code: '097715704129',
      label: 'Eurasburg',
      provincie: 9,
      slug: 'eurasburg-gemeinde',
    },
    {
      code: '097715704149',
      label: 'Obergriesbach',
      provincie: 9,
      slug: 'obergriesbach',
    },
    {
      code: '097715704165',
      label: 'Sielenbach',
      provincie: 9,
      slug: 'sielenbach',
    },
    {
      code: '097715705146',
      label: 'Mering',
      provincie: 9,
      slug: 'mering',
    },
    {
      code: '097715705163',
      label: 'Schmiechen',
      provincie: 9,
      slug: 'schmiechen',
    },
    {
      code: '097715705168',
      label: 'Steindorf',
      provincie: 9,
      slug: 'steindorf',
    },
    {
      code: '097715771156',
      label: 'Pöttmes',
      provincie: 9,
      slug: 'poettmes',
    },
    {
      code: '097715771176',
      label: 'Baar (Schwaben)',
      provincie: 9,
      slug: 'baar-schwaben',
    },
    {
      code: '097720111111',
      label: 'Adelsried',
      provincie: 9,
      slug: 'adelsried',
    },
    {
      code: '097720115115',
      label: 'Altenmünster',
      provincie: 9,
      slug: 'altenmuenster',
    },
    {
      code: '097720117117',
      label: 'Aystetten',
      provincie: 9,
      slug: 'aystetten',
    },
    {
      code: '097720121121',
      label: 'Biberbach',
      provincie: 9,
      slug: 'biberbach',
    },
    {
      code: '097720125125',
      label: 'Bobingen',
      provincie: 9,
      slug: 'bobingen',
    },
    {
      code: '097720130130',
      label: 'Diedorf',
      provincie: 9,
      slug: 'diedorf',
    },
    {
      code: '097720131131',
      label: 'Dinkelscherben',
      provincie: 9,
      slug: 'dinkelscherben',
    },
    {
      code: '097720141141',
      label: 'Fischach',
      provincie: 9,
      slug: 'fischach',
    },
    {
      code: '097720145145',
      label: 'Gablingen',
      provincie: 9,
      slug: 'gablingen',
    },
    {
      code: '097720147147',
      label: 'Gersthofen',
      provincie: 9,
      slug: 'gersthofen',
    },
    {
      code: '097720149149',
      label: 'Graben',
      provincie: 9,
      slug: 'graben',
    },
    {
      code: '097720159159',
      label: 'Horgau',
      provincie: 9,
      slug: 'horgau',
    },
    {
      code: '097720163163',
      label: 'Königsbrunn',
      provincie: 9,
      slug: 'koenigsbrunn',
    },
    {
      code: '097720167167',
      label: 'Kutzenhausen',
      provincie: 9,
      slug: 'kutzenhausen',
    },
    {
      code: '097720171171',
      label: 'Langweid a.Lech',
      provincie: 9,
      slug: 'langweid-a-lech',
    },
    {
      code: '097720177177',
      label: 'Meitingen',
      provincie: 9,
      slug: 'meitingen',
    },
    {
      code: '097720184184',
      label: 'Neusäß',
      provincie: 9,
      slug: 'neusaess',
    },
    {
      code: '097720200200',
      label: 'Schwabmünchen',
      provincie: 9,
      slug: 'schwabmuenchen',
    },
    {
      code: '097720202202',
      label: 'Stadtbergen',
      provincie: 9,
      slug: 'stadtbergen',
    },
    {
      code: '097720207207',
      label: 'Thierhaupten',
      provincie: 9,
      slug: 'thierhaupten',
    },
    {
      code: '097720215215',
      label: 'Wehringen',
      provincie: 9,
      slug: 'wehringen',
    },
    {
      code: '097720223223',
      label: 'Zusmarshausen',
      provincie: 9,
      slug: 'zusmarshausen',
    },
    {
      code: '097725706114',
      label: 'Allmannshofen',
      provincie: 9,
      slug: 'allmannshofen',
    },
    {
      code: '097725706134',
      label: 'Ehingen',
      provincie: 9,
      slug: 'ehingen-gemeinde',
    },
    {
      code: '097725706136',
      label: 'Ellgau',
      provincie: 9,
      slug: 'ellgau',
    },
    {
      code: '097725706166',
      label: 'Kühlenthal',
      provincie: 9,
      slug: 'kuehlenthal',
    },
    {
      code: '097725706185',
      label: 'Nordendorf',
      provincie: 9,
      slug: 'nordendorf',
    },
    {
      code: '097725706217',
      label: 'Westendorf',
      provincie: 9,
      slug: 'westendorf',
    },
    {
      code: '097725707126',
      label: 'Bonstetten',
      provincie: 9,
      slug: 'bonstetten',
    },
    {
      code: '097725707137',
      label: 'Emersacker',
      provincie: 9,
      slug: 'emersacker',
    },
    {
      code: '097725707156',
      label: 'Heretsried',
      provincie: 9,
      slug: 'heretsried',
    },
    {
      code: '097725707216',
      label: 'Welden',
      provincie: 9,
      slug: 'welden',
    },
    {
      code: '097725708148',
      label: 'Gessertshausen',
      provincie: 9,
      slug: 'gessertshausen',
    },
    {
      code: '097725708211',
      label: 'Ustersbach',
      provincie: 9,
      slug: 'ustersbach',
    },
    {
      code: '097725709168',
      label: 'Langenneufnach',
      provincie: 9,
      slug: 'langenneufnach',
    },
    {
      code: '097725709178',
      label: 'Mickhausen',
      provincie: 9,
      slug: 'mickhausen',
    },
    {
      code: '097725709179',
      label: 'Mittelneufnach',
      provincie: 9,
      slug: 'mittelneufnach',
    },
    {
      code: '097725709197',
      label: 'Scherstetten',
      provincie: 9,
      slug: 'scherstetten',
    },
    {
      code: '097725709214',
      label: 'Walkertshofen',
      provincie: 9,
      slug: 'walkertshofen',
    },
    {
      code: '097725710151',
      label: 'Großaitingen',
      provincie: 9,
      slug: 'grossaitingen',
    },
    {
      code: '097725710160',
      label: 'Kleinaitingen',
      provincie: 9,
      slug: 'kleinaitingen',
    },
    {
      code: '097725710186',
      label: 'Oberottmarshausen',
      provincie: 9,
      slug: 'oberottmarshausen',
    },
    {
      code: '097725711162',
      label: 'Klosterlechfeld',
      provincie: 9,
      slug: 'klosterlechfeld',
    },
    {
      code: '097725711209',
      label: 'Untermeitingen',
      provincie: 9,
      slug: 'untermeitingen',
    },
    {
      code: '097725712157',
      label: 'Hiltenfingen',
      provincie: 9,
      slug: 'hiltenfingen',
    },
    {
      code: '097725712170',
      label: 'Langerringen',
      provincie: 9,
      slug: 'langerringen',
    },
    {
      code: '097730117117',
      label: 'Bissingen',
      provincie: 9,
      slug: 'bissingen',
    },
    {
      code: '097730122122',
      label: 'Buttenwiesen',
      provincie: 9,
      slug: 'buttenwiesen',
    },
    {
      code: '097730125125',
      label: 'Dillingen a.d.Donau',
      provincie: 9,
      slug: 'dillingen-a-d-donau',
    },
    {
      code: '097730144144',
      label: 'Lauingen (Donau)',
      provincie: 9,
      slug: 'lauingen-donau',
    },
    {
      code: '097735713113',
      label: 'Bächingen a.d.Brenz',
      provincie: 9,
      slug: 'baechingen-a-d-brenz',
    },
    {
      code: '097735713136',
      label: 'Gundelfingen a.d.Donau',
      provincie: 9,
      slug: 'gundelfingen-a-d-donau',
    },
    {
      code: '097735713137',
      label: 'Haunsheim',
      provincie: 9,
      slug: 'haunsheim',
    },
    {
      code: '097735713153',
      label: 'Medlingen',
      provincie: 9,
      slug: 'medlingen',
    },
    {
      code: '097735714112',
      label: 'Bachhagel',
      provincie: 9,
      slug: 'bachhagel',
    },
    {
      code: '097735714170',
      label: 'Syrgenstein',
      provincie: 9,
      slug: 'syrgenstein',
    },
    {
      code: '097735714187',
      label: 'Zöschingen',
      provincie: 9,
      slug: 'zoeschingen',
    },
    {
      code: '097735715147',
      label: 'Mödingen',
      provincie: 9,
      slug: 'moedingen',
    },
    {
      code: '097735715183',
      label: 'Wittislingen',
      provincie: 9,
      slug: 'wittislingen',
    },
    {
      code: '097735715186',
      label: 'Ziertheim',
      provincie: 9,
      slug: 'ziertheim',
    },
    {
      code: '097735716119',
      label: 'Blindheim',
      provincie: 9,
      slug: 'blindheim',
    },
    {
      code: '097735716139',
      label: 'Höchstädt a.d.Donau',
      provincie: 9,
      slug: 'hoechstaedt-a-d-donau',
    },
    {
      code: '097735716146',
      label: 'Lutzingen',
      provincie: 9,
      slug: 'lutzingen',
    },
    {
      code: '097735716150',
      label: 'Finningen',
      provincie: 9,
      slug: 'finningen',
    },
    {
      code: '097735716164',
      label: 'Schwenningen',
      provincie: 9,
      slug: 'schwenningen-gemeinde',
    },
    {
      code: '097735718116',
      label: 'Binswangen',
      provincie: 9,
      slug: 'binswangen',
    },
    {
      code: '097735718143',
      label: 'Laugna',
      provincie: 9,
      slug: 'laugna',
    },
    {
      code: '097735718179',
      label: 'Villenbach',
      provincie: 9,
      slug: 'villenbach',
    },
    {
      code: '097735718182',
      label: 'Wertingen',
      provincie: 9,
      slug: 'wertingen',
    },
    {
      code: '097735718188',
      label: 'Zusamaltheim',
      provincie: 9,
      slug: 'zusamaltheim',
    },
    {
      code: '097735719111',
      label: 'Aislingen',
      provincie: 9,
      slug: 'aislingen',
    },
    {
      code: '097735719133',
      label: 'Glött',
      provincie: 9,
      slug: 'gloett',
    },
    {
      code: '097735719140',
      label: 'Holzheim',
      provincie: 9,
      slug: 'holzheim-gemeinde',
    },
    {
      code: '097740116116',
      label: 'Ursberg',
      provincie: 9,
      slug: 'ursberg',
    },
    {
      code: '097740119119',
      label: 'Bibertal',
      provincie: 9,
      slug: 'bibertal',
    },
    {
      code: '097740121121',
      label: 'Burgau',
      provincie: 9,
      slug: 'burgau',
    },
    {
      code: '097740122122',
      label: 'Burtenbach',
      provincie: 9,
      slug: 'burtenbach',
    },
    {
      code: '097740135135',
      label: 'Günzburg',
      provincie: 9,
      slug: 'guenzburg',
    },
    {
      code: '097740144144',
      label: 'Jettingen-Scheppach',
      provincie: 9,
      slug: 'jettingen-scheppach',
    },
    {
      code: '097740145145',
      label: 'Kammeltal',
      provincie: 9,
      slug: 'kammeltal',
    },
    {
      code: '097740150150',
      label: 'Krumbach (Schwaben)',
      provincie: 9,
      slug: 'krumbach-schwaben',
    },
    {
      code: '097740155155',
      label: 'Leipheim',
      provincie: 9,
      slug: 'leipheim',
    },
    {
      code: '097740162162',
      label: 'Neuburg a.d.Kammel',
      provincie: 9,
      slug: 'neuburg-a-d-kammel',
    },
    {
      code: '097745727136',
      label: 'Gundremmingen',
      provincie: 9,
      slug: 'gundremmingen',
    },
    {
      code: '097745727171',
      label: 'Offingen',
      provincie: 9,
      slug: 'offingen',
    },
    {
      code: '097745727174',
      label: 'Rettenbach',
      provincie: 9,
      slug: 'rettenbach-gemeinde',
    },
    {
      code: '097745728127',
      label: 'Dürrlauingen',
      provincie: 9,
      slug: 'duerrlauingen',
    },
    {
      code: '097745728140',
      label: 'Haldenwang',
      provincie: 9,
      slug: 'haldenwang',
    },
    {
      code: '097745728151',
      label: 'Landensberg',
      provincie: 9,
      slug: 'landensberg',
    },
    {
      code: '097745728178',
      label: 'Röfingen',
      provincie: 9,
      slug: 'roefingen',
    },
    {
      code: '097745728196',
      label: 'Winterbach',
      provincie: 9,
      slug: 'winterbach-gemeinde',
    },
    {
      code: '097745729118',
      label: 'Bubesheim',
      provincie: 9,
      slug: 'bubesheim',
    },
    {
      code: '097745729148',
      label: 'Kötz',
      provincie: 9,
      slug: 'koetz',
    },
    {
      code: '097745730133',
      label: 'Ellzee',
      provincie: 9,
      slug: 'ellzee',
    },
    {
      code: '097745730143',
      label: 'Ichenhausen',
      provincie: 9,
      slug: 'ichenhausen',
    },
    {
      code: '097745730191',
      label: 'Waldstetten',
      provincie: 9,
      slug: 'waldstetten-gemeinde',
    },
    {
      code: '097745731111',
      label: 'Aletshausen',
      provincie: 9,
      slug: 'aletshausen',
    },
    {
      code: '097745731117',
      label: 'Breitenthal',
      provincie: 9,
      slug: 'breitenthal-gemeinde',
    },
    {
      code: '097745731124',
      label: 'Deisenhausen',
      provincie: 9,
      slug: 'deisenhausen',
    },
    {
      code: '097745731129',
      label: 'Ebershausen',
      provincie: 9,
      slug: 'ebershausen',
    },
    {
      code: '097745731189',
      label: 'Wiesenbach',
      provincie: 9,
      slug: 'wiesenbach-gemeinde',
    },
    {
      code: '097745731192',
      label: 'Waltenhausen',
      provincie: 9,
      slug: 'waltenhausen',
    },
    {
      code: '097745732115',
      label: 'Balzhausen',
      provincie: 9,
      slug: 'balzhausen',
    },
    {
      code: '097745732160',
      label: 'Münsterhausen',
      provincie: 9,
      slug: 'muensterhausen',
    },
    {
      code: '097745732185',
      label: 'Thannhausen',
      provincie: 9,
      slug: 'thannhausen',
    },
    {
      code: '097745733166',
      label: 'Aichen',
      provincie: 9,
      slug: 'aichen',
    },
    {
      code: '097745733198',
      label: 'Ziemetshausen',
      provincie: 9,
      slug: 'ziemetshausen',
    },
    {
      code: '097750115115',
      label: 'Bellenberg',
      provincie: 9,
      slug: 'bellenberg',
    },
    {
      code: '097750129129',
      label: 'Illertissen',
      provincie: 9,
      slug: 'illertissen',
    },
    {
      code: '097750134134',
      label: 'Nersingen',
      provincie: 9,
      slug: 'nersingen',
    },
    {
      code: '097750135135',
      label: 'Neu-Ulm',
      provincie: 9,
      slug: 'neu-ulm',
    },
    {
      code: '097750139139',
      label: 'Elchingen',
      provincie: 9,
      slug: 'elchingen',
    },
    {
      code: '097750149149',
      label: 'Roggenburg',
      provincie: 9,
      slug: 'roggenburg',
    },
    {
      code: '097750152152',
      label: 'Senden',
      provincie: 9,
      slug: 'senden-stadt',
    },
    {
      code: '097750162162',
      label: 'Vöhringen',
      provincie: 9,
      slug: 'voehringen-stadt',
    },
    {
      code: '097750164164',
      label: 'Weißenhorn',
      provincie: 9,
      slug: 'weissenhorn',
    },
    {
      code: '097755739126',
      label: 'Holzheim',
      provincie: 9,
      slug: 'holzheim-gemeinde',
    },
    {
      code: '097755739143',
      label: 'Pfaffenhofen a.d.Roth',
      provincie: 9,
      slug: 'pfaffenhofen-a-d-roth',
    },
    {
      code: '097755740111',
      label: 'Altenstadt',
      provincie: 9,
      slug: 'altenstadt-gemeinde',
    },
    {
      code: '097755740132',
      label: 'Kellmünz a.d.Iller',
      provincie: 9,
      slug: 'kellmuenz-a-d-iller',
    },
    {
      code: '097755740142',
      label: 'Osterberg',
      provincie: 9,
      slug: 'osterberg',
    },
    {
      code: '097755741118',
      label: 'Buch',
      provincie: 9,
      slug: 'buch-gemeinde',
    },
    {
      code: '097755741141',
      label: 'Oberroth',
      provincie: 9,
      slug: 'oberroth',
    },
    {
      code: '097755741161',
      label: 'Unterroth',
      provincie: 9,
      slug: 'unterroth',
    },
    {
      code: '097760111111',
      label: 'Bodolz',
      provincie: 9,
      slug: 'bodolz',
    },
    {
      code: '097760114114',
      label: 'Heimenkirch',
      provincie: 9,
      slug: 'heimenkirch',
    },
    {
      code: '097760116116',
      label: 'Lindau (Bodensee)',
      provincie: 9,
      slug: 'lindau-bodensee',
    },
    {
      code: '097760117117',
      label: 'Lindenberg i.Allgäu',
      provincie: 9,
      slug: 'lindenberg-i-allgaeu',
    },
    {
      code: '097760120120',
      label: 'Nonnenhorn',
      provincie: 9,
      slug: 'nonnenhorn',
    },
    {
      code: '097760122122',
      label: 'Opfenbach',
      provincie: 9,
      slug: 'opfenbach',
    },
    {
      code: '097760125125',
      label: 'Scheidegg',
      provincie: 9,
      slug: 'scheidegg',
    },
    {
      code: '097760128128',
      label: 'Wasserburg (Bodensee)',
      provincie: 9,
      slug: 'wasserburg-bodensee',
    },
    {
      code: '097760129129',
      label: 'Weiler-Simmerberg',
      provincie: 9,
      slug: 'weiler-simmerberg',
    },
    {
      code: '097760131131',
      label: 'Hergatz',
      provincie: 9,
      slug: 'hergatz',
    },
    {
      code: '097765735115',
      label: 'Hergensweiler',
      provincie: 9,
      slug: 'hergensweiler',
    },
    {
      code: '097765735126',
      label: 'Sigmarszell',
      provincie: 9,
      slug: 'sigmarszell',
    },
    {
      code: '097765735130',
      label: 'Weißensberg',
      provincie: 9,
      slug: 'weissensberg',
    },
    {
      code: '097765737112',
      label: 'Gestratz',
      provincie: 9,
      slug: 'gestratz',
    },
    {
      code: '097765737113',
      label: 'Grünenbach',
      provincie: 9,
      slug: 'gruenenbach',
    },
    {
      code: '097765737118',
      label: 'Maierhöfen',
      provincie: 9,
      slug: 'maierhoefen',
    },
    {
      code: '097765737124',
      label: 'Röthenbach (Allgäu)',
      provincie: 9,
      slug: 'roethenbach-allgaeu',
    },
    {
      code: '097765738121',
      label: 'Oberreute',
      provincie: 9,
      slug: 'oberreute',
    },
    {
      code: '097765738127',
      label: 'Stiefenhofen',
      provincie: 9,
      slug: 'stiefenhofen',
    },
    {
      code: '097770129129',
      label: 'Füssen',
      provincie: 9,
      slug: 'fuessen',
    },
    {
      code: '097770130130',
      label: 'Germaringen',
      provincie: 9,
      slug: 'germaringen',
    },
    {
      code: '097770147147',
      label: 'Lechbruck am See',
      provincie: 9,
      slug: 'lechbruck-am-see',
    },
    {
      code: '097770151151',
      label: 'Marktoberdorf',
      provincie: 9,
      slug: 'marktoberdorf',
    },
    {
      code: '097770152152',
      label: 'Mauerstetten',
      provincie: 9,
      slug: 'mauerstetten',
    },
    {
      code: '097770153153',
      label: 'Nesselwang',
      provincie: 9,
      slug: 'nesselwang',
    },
    {
      code: '097770159159',
      label: 'Pfronten',
      provincie: 9,
      slug: 'pfronten',
    },
    {
      code: '097770165165',
      label: 'Ronsberg',
      provincie: 9,
      slug: 'ronsberg',
    },
    {
      code: '097770169169',
      label: 'Schwangau',
      provincie: 9,
      slug: 'schwangau',
    },
    {
      code: '097770173173',
      label: 'Halblech',
      provincie: 9,
      slug: 'halblech',
    },
    {
      code: '097775748121',
      label: 'Buchloe',
      provincie: 9,
      slug: 'buchloe',
    },
    {
      code: '097775748140',
      label: 'Jengen',
      provincie: 9,
      slug: 'jengen',
    },
    {
      code: '097775748145',
      label: 'Lamerdingen',
      provincie: 9,
      slug: 'lamerdingen',
    },
    {
      code: '097775748177',
      label: 'Waal',
      provincie: 9,
      slug: 'waal',
    },
    {
      code: '097775749139',
      label: 'Irsee',
      provincie: 9,
      slug: 'irsee',
    },
    {
      code: '097775749158',
      label: 'Pforzen',
      provincie: 9,
      slug: 'pforzen',
    },
    {
      code: '097775749164',
      label: 'Rieden',
      provincie: 9,
      slug: 'rieden-gemeinde',
    },
    {
      code: '097775751141',
      label: 'Kaltental',
      provincie: 9,
      slug: 'kaltental',
    },
    {
      code: '097775751155',
      label: 'Oberostendorf',
      provincie: 9,
      slug: 'oberostendorf',
    },
    {
      code: '097775751157',
      label: 'Osterzell',
      provincie: 9,
      slug: 'osterzell',
    },
    {
      code: '097775751172',
      label: 'Stöttwang',
      provincie: 9,
      slug: 'stoettwang',
    },
    {
      code: '097775751182',
      label: 'Westendorf',
      provincie: 9,
      slug: 'westendorf-gemeinde',
    },
    {
      code: '097775752111',
      label: 'Aitrang',
      provincie: 9,
      slug: 'aitrang',
    },
    {
      code: '097775752112',
      label: 'Biessenhofen',
      provincie: 9,
      slug: 'biessenhofen',
    },
    {
      code: '097775752118',
      label: 'Bidingen',
      provincie: 9,
      slug: 'bidingen',
    },
    {
      code: '097775752167',
      label: 'Ruderatshofen',
      provincie: 9,
      slug: 'ruderatshofen',
    },
    {
      code: '097775753114',
      label: 'Baisweil',
      provincie: 9,
      slug: 'baisweil',
    },
    {
      code: '097775753124',
      label: 'Eggenthal',
      provincie: 9,
      slug: 'eggenthal',
    },
    {
      code: '097775753128',
      label: 'Friesenried',
      provincie: 9,
      slug: 'friesenried',
    },
    {
      code: '097775754138',
      label: 'Günzach',
      provincie: 9,
      slug: 'guenzach',
    },
    {
      code: '097775754154',
      label: 'Obergünzburg',
      provincie: 9,
      slug: 'oberguenzburg',
    },
    {
      code: '097775754176',
      label: 'Untrasried',
      provincie: 9,
      slug: 'untrasried',
    },
    {
      code: '097775755131',
      label: 'Görisried',
      provincie: 9,
      slug: 'goerisried',
    },
    {
      code: '097775755144',
      label: 'Kraftisried',
      provincie: 9,
      slug: 'kraftisried',
    },
    {
      code: '097775755175',
      label: 'Unterthingau',
      provincie: 9,
      slug: 'unterthingau',
    },
    {
      code: '097775756125',
      label: 'Eisenberg',
      provincie: 9,
      slug: 'eisenberg',
    },
    {
      code: '097775756135',
      label: 'Hopferau',
      provincie: 9,
      slug: 'hopferau',
    },
    {
      code: '097775756149',
      label: 'Lengenwang',
      provincie: 9,
      slug: 'lengenwang',
    },
    {
      code: '097775756168',
      label: 'Rückholz',
      provincie: 9,
      slug: 'rueckholz',
    },
    {
      code: '097775756170',
      label: 'Seeg',
      provincie: 9,
      slug: 'seeg',
    },
    {
      code: '097775756179',
      label: 'Wald',
      provincie: 9,
      slug: 'wald-gemeinde',
    },
    {
      code: '097775770163',
      label: 'Rieden am Forggensee',
      provincie: 9,
      slug: 'rieden-am-forggensee',
    },
    {
      code: '097775770166',
      label: 'Roßhaupten',
      provincie: 9,
      slug: 'rosshaupten',
    },
    {
      code: '097775772171',
      label: 'Stötten a.Auerberg',
      provincie: 9,
      slug: 'stoetten-a-auerberg',
    },
    {
      code: '097775772183',
      label: 'Rettenbach a.Auerberg',
      provincie: 9,
      slug: 'rettenbach-a-auerberg',
    },
    {
      code: '097780116116',
      label: 'Bad Wörishofen',
      provincie: 9,
      slug: 'bad-woerishofen',
    },
    {
      code: '097780123123',
      label: 'Buxheim',
      provincie: 9,
      slug: 'buxheim-gemeinde',
    },
    {
      code: '097780137137',
      label: 'Ettringen',
      provincie: 9,
      slug: 'ettringen-gemeinde',
    },
    {
      code: '097780168168',
      label: 'Markt Rettenbach',
      provincie: 9,
      slug: 'markt-rettenbach',
    },
    {
      code: '097780169169',
      label: 'Markt Wald',
      provincie: 9,
      slug: 'markt-wald',
    },
    {
      code: '097780173173',
      label: 'Mindelheim',
      provincie: 9,
      slug: 'mindelheim',
    },
    {
      code: '097780196196',
      label: 'Sontheim',
      provincie: 9,
      slug: 'sontheim',
    },
    {
      code: '097780204204',
      label: 'Tussenhausen',
      provincie: 9,
      slug: 'tussenhausen',
    },
    {
      code: '097785757119',
      label: 'Böhen',
      provincie: 9,
      slug: 'boehen',
    },
    {
      code: '097785757149',
      label: 'Hawangen',
      provincie: 9,
      slug: 'hawangen',
    },
    {
      code: '097785757186',
      label: 'Ottobeuren',
      provincie: 9,
      slug: 'ottobeuren',
    },
    {
      code: '097785758115',
      label: 'Babenhausen',
      provincie: 9,
      slug: 'babenhausen-gemeinde',
    },
    {
      code: '097785758130',
      label: 'Egg a.d.Günz',
      provincie: 9,
      slug: 'egg-a-d-guenz',
    },
    {
      code: '097785758157',
      label: 'Kirchhaslach',
      provincie: 9,
      slug: 'kirchhaslach',
    },
    {
      code: '097785758184',
      label: 'Oberschönegg',
      provincie: 9,
      slug: 'oberschoenegg',
    },
    {
      code: '097785758217',
      label: 'Winterrieden',
      provincie: 9,
      slug: 'winterrieden',
    },
    {
      code: '097785758221',
      label: 'Kettershausen',
      provincie: 9,
      slug: 'kettershausen',
    },
    {
      code: '097785759121',
      label: 'Breitenbrunn',
      provincie: 9,
      slug: 'breitenbrunn-gemeinde',
    },
    {
      code: '097785759183',
      label: 'Oberrieden',
      provincie: 9,
      slug: 'oberrieden',
    },
    {
      code: '097785759187',
      label: 'Pfaffenhausen',
      provincie: 9,
      slug: 'pfaffenhausen',
    },
    {
      code: '097785759190',
      label: 'Salgen',
      provincie: 9,
      slug: 'salgen',
    },
    {
      code: '097785760134',
      label: 'Eppishausen',
      provincie: 9,
      slug: 'eppishausen',
    },
    {
      code: '097785760158',
      label: 'Kirchheim i.Schw.',
      provincie: 9,
      slug: 'kirchheim-i-schw',
    },
    {
      code: '097785761120',
      label: 'Boos',
      provincie: 9,
      slug: 'boos-gemeinde',
    },
    {
      code: '097785761139',
      label: 'Fellheim',
      provincie: 9,
      slug: 'fellheim',
    },
    {
      code: '097785761150',
      label: 'Heimertingen',
      provincie: 9,
      slug: 'heimertingen',
    },
    {
      code: '097785761177',
      label: 'Niederrieden',
      provincie: 9,
      slug: 'niederrieden',
    },
    {
      code: '097785761188',
      label: 'Pleß',
      provincie: 9,
      slug: 'pless',
    },
    {
      code: '097785762136',
      label: 'Erkheim',
      provincie: 9,
      slug: 'erkheim',
    },
    {
      code: '097785762163',
      label: 'Lauben',
      provincie: 9,
      slug: 'lauben',
    },
    {
      code: '097785762180',
      label: 'Kammlach',
      provincie: 9,
      slug: 'kammlach',
    },
    {
      code: '097785762214',
      label: 'Westerheim',
      provincie: 9,
      slug: 'westerheim-gemeinde',
    },
    {
      code: '097785764111',
      label: 'Amberg',
      provincie: 9,
      slug: 'amberg-gemeinde',
    },
    {
      code: '097785764203',
      label: 'Türkheim',
      provincie: 9,
      slug: 'tuerkheim',
    },
    {
      code: '097785764209',
      label: 'Rammingen',
      provincie: 9,
      slug: 'rammingen-gemeinde',
    },
    {
      code: '097785764216',
      label: 'Wiedergeltingen',
      provincie: 9,
      slug: 'wiedergeltingen',
    },
    {
      code: '097785765118',
      label: 'Benningen',
      provincie: 9,
      slug: 'benningen',
    },
    {
      code: '097785765151',
      label: 'Holzgünz',
      provincie: 9,
      slug: 'holzguenz',
    },
    {
      code: '097785765162',
      label: 'Lachen',
      provincie: 9,
      slug: 'lachen',
    },
    {
      code: '097785765171',
      label: 'Memmingerberg',
      provincie: 9,
      slug: 'memmingerberg',
    },
    {
      code: '097785765202',
      label: 'Trunkelsberg',
      provincie: 9,
      slug: 'trunkelsberg',
    },
    {
      code: '097785765205',
      label: 'Ungerhausen',
      provincie: 9,
      slug: 'ungerhausen',
    },
    {
      code: '097785766113',
      label: 'Apfeltrach',
      provincie: 9,
      slug: 'apfeltrach',
    },
    {
      code: '097785766127',
      label: 'Dirlewang',
      provincie: 9,
      slug: 'dirlewang',
    },
    {
      code: '097785766199',
      label: 'Stetten',
      provincie: 9,
      slug: 'stetten-gemeinde',
    },
    {
      code: '097785766207',
      label: 'Unteregg',
      provincie: 9,
      slug: 'unteregg',
    },
    {
      code: '097785767161',
      label: 'Kronburg',
      provincie: 9,
      slug: 'kronburg',
    },
    {
      code: '097785767164',
      label: 'Lautrach',
      provincie: 9,
      slug: 'lautrach',
    },
    {
      code: '097785767165',
      label: 'Legau',
      provincie: 9,
      slug: 'legau',
    },
    {
      code: '097785768144',
      label: 'Bad Grönenbach',
      provincie: 9,
      slug: 'bad-groenenbach',
    },
    {
      code: '097785768218',
      label: 'Wolfertschwenden',
      provincie: 9,
      slug: 'wolfertschwenden',
    },
    {
      code: '097785768219',
      label: 'Woringen',
      provincie: 9,
      slug: 'woringen',
    },
    {
      code: '097790115115',
      label: 'Asbach-Bäumenheim',
      provincie: 9,
      slug: 'asbach-baeumenheim',
    },
    {
      code: '097790131131',
      label: 'Donauwörth',
      provincie: 9,
      slug: 'donauwoerth',
    },
    {
      code: '097790147147',
      label: 'Fremdingen',
      provincie: 9,
      slug: 'fremdingen',
    },
    {
      code: '097790155155',
      label: 'Harburg (Schwaben)',
      provincie: 9,
      slug: 'harburg-schwaben',
    },
    {
      code: '097790169169',
      label: 'Kaisheim',
      provincie: 9,
      slug: 'kaisheim',
    },
    {
      code: '097790178178',
      label: 'Marxheim',
      provincie: 9,
      slug: 'marxheim',
    },
    {
      code: '097790181181',
      label: 'Mertingen',
      provincie: 9,
      slug: 'mertingen',
    },
    {
      code: '097790185185',
      label: 'Möttingen',
      provincie: 9,
      slug: 'moettingen',
    },
    {
      code: '097790194194',
      label: 'Nördlingen',
      provincie: 9,
      slug: 'noerdlingen',
    },
    {
      code: '097790196196',
      label: 'Oberndorf a.Lech',
      provincie: 9,
      slug: 'oberndorf-a-lech',
    },
    {
      code: '097790201201',
      label: 'Rain',
      provincie: 9,
      slug: 'rain-stadt',
    },
    {
      code: '097790218218',
      label: 'Tapfheim',
      provincie: 9,
      slug: 'tapfheim',
    },
    {
      code: '097795720176',
      label: 'Maihingen',
      provincie: 9,
      slug: 'maihingen',
    },
    {
      code: '097795720177',
      label: 'Marktoffingen',
      provincie: 9,
      slug: 'marktoffingen',
    },
    {
      code: '097795720224',
      label: 'Wallerstein',
      provincie: 9,
      slug: 'wallerstein',
    },
    {
      code: '097795721117',
      label: 'Auhausen',
      provincie: 9,
      slug: 'auhausen',
    },
    {
      code: '097795721138',
      label: 'Ehingen a.Ries',
      provincie: 9,
      slug: 'ehingen-a-ries',
    },
    {
      code: '097795721154',
      label: 'Hainsfarth',
      provincie: 9,
      slug: 'hainsfarth',
    },
    {
      code: '097795721180',
      label: 'Megesheim',
      provincie: 9,
      slug: 'megesheim',
    },
    {
      code: '097795721188',
      label: 'Munningen',
      provincie: 9,
      slug: 'munningen',
    },
    {
      code: '097795721197',
      label: 'Oettingen i.Bay.',
      provincie: 9,
      slug: 'oettingen-i-bay',
    },
    {
      code: '097795722111',
      label: 'Alerheim',
      provincie: 9,
      slug: 'alerheim',
    },
    {
      code: '097795722112',
      label: 'Amerdingen',
      provincie: 9,
      slug: 'amerdingen',
    },
    {
      code: '097795722130',
      label: 'Deiningen',
      provincie: 9,
      slug: 'deiningen',
    },
    {
      code: '097795722136',
      label: 'Ederheim',
      provincie: 9,
      slug: 'ederheim',
    },
    {
      code: '097795722146',
      label: 'Forheim',
      provincie: 9,
      slug: 'forheim',
    },
    {
      code: '097795722162',
      label: 'Hohenaltheim',
      provincie: 9,
      slug: 'hohenaltheim',
    },
    {
      code: '097795722184',
      label: 'Mönchsdeggingen',
      provincie: 9,
      slug: 'moenchsdeggingen',
    },
    {
      code: '097795722203',
      label: 'Reimlingen',
      provincie: 9,
      slug: 'reimlingen',
    },
    {
      code: '097795722226',
      label: 'Wechingen',
      provincie: 9,
      slug: 'wechingen',
    },
    {
      code: '097795723148',
      label: 'Fünfstetten',
      provincie: 9,
      slug: 'fuenfstetten',
    },
    {
      code: '097795723167',
      label: 'Huisheim',
      provincie: 9,
      slug: 'huisheim',
    },
    {
      code: '097795723198',
      label: 'Otting',
      provincie: 9,
      slug: 'otting',
    },
    {
      code: '097795723228',
      label: 'Wemding',
      provincie: 9,
      slug: 'wemding',
    },
    {
      code: '097795723231',
      label: 'Wolferstadt',
      provincie: 9,
      slug: 'wolferstadt',
    },
    {
      code: '097795724126',
      label: 'Buchdorf',
      provincie: 9,
      slug: 'buchdorf',
    },
    {
      code: '097795724129',
      label: 'Daiting',
      provincie: 9,
      slug: 'daiting',
    },
    {
      code: '097795724186',
      label: 'Monheim',
      provincie: 9,
      slug: 'monheim',
    },
    {
      code: '097795724206',
      label: 'Rögling',
      provincie: 9,
      slug: 'roegling',
    },
    {
      code: '097795724217',
      label: 'Tagmersheim',
      provincie: 9,
      slug: 'tagmersheim',
    },
    {
      code: '097795725149',
      label: 'Genderkingen',
      provincie: 9,
      slug: 'genderkingen',
    },
    {
      code: '097795725163',
      label: 'Holzheim',
      provincie: 9,
      slug: 'holzheim-gemeinde',
    },
    {
      code: '097795725187',
      label: 'Münster',
      provincie: 9,
      slug: 'muenster-gemeinde',
    },
    {
      code: '097795725192',
      label: 'Niederschönenfeld',
      provincie: 9,
      slug: 'niederschoenenfeld',
    },
    {
      code: '097800112112',
      label: 'Altusried',
      provincie: 9,
      slug: 'altusried',
    },
    {
      code: '097800114114',
      label: 'Betzigau',
      provincie: 9,
      slug: 'betzigau',
    },
    {
      code: '097800115115',
      label: 'Blaichach',
      provincie: 9,
      slug: 'blaichach',
    },
    {
      code: '097800117117',
      label: 'Buchenberg',
      provincie: 9,
      slug: 'buchenberg',
    },
    {
      code: '097800118118',
      label: 'Burgberg i.Allgäu',
      provincie: 9,
      slug: 'burgberg-i-allgaeu',
    },
    {
      code: '097800119119',
      label: 'Dietmannsried',
      provincie: 9,
      slug: 'dietmannsried',
    },
    {
      code: '097800120120',
      label: 'Durach',
      provincie: 9,
      slug: 'durach',
    },
    {
      code: '097800122122',
      label: 'Haldenwang',
      provincie: 9,
      slug: 'haldenwang-gemeinde',
    },
    {
      code: '097800123123',
      label: 'Bad Hindelang',
      provincie: 9,
      slug: 'bad-hindelang',
    },
    {
      code: '097800124124',
      label: 'Immenstadt i.Allgäu',
      provincie: 9,
      slug: 'immenstadt-i-allgaeu',
    },
    {
      code: '097800125125',
      label: 'Lauben',
      provincie: 9,
      slug: 'lauben-gemeinde',
    },
    {
      code: '097800128128',
      label: 'Oy-Mittelberg',
      provincie: 9,
      slug: 'oy-mittelberg',
    },
    {
      code: '097800132132',
      label: 'Oberstaufen',
      provincie: 9,
      slug: 'oberstaufen',
    },
    {
      code: '097800133133',
      label: 'Oberstdorf',
      provincie: 9,
      slug: 'oberstdorf',
    },
    {
      code: '097800137137',
      label: 'Rettenberg',
      provincie: 9,
      slug: 'rettenberg',
    },
    {
      code: '097800139139',
      label: 'Sonthofen',
      provincie: 9,
      slug: 'sonthofen',
    },
    {
      code: '097800140140',
      label: 'Sulzberg',
      provincie: 9,
      slug: 'sulzberg',
    },
    {
      code: '097800143143',
      label: 'Waltenhofen',
      provincie: 9,
      slug: 'waltenhofen',
    },
    {
      code: '097800145145',
      label: 'Wertach',
      provincie: 9,
      slug: 'wertach',
    },
    {
      code: '097800146146',
      label: 'Wiggensbach',
      provincie: 9,
      slug: 'wiggensbach',
    },
    {
      code: '097800147147',
      label: 'Wildpoldsried',
      provincie: 9,
      slug: 'wildpoldsried',
    },
    {
      code: '097805742113',
      label: 'Balderschwang',
      provincie: 9,
      slug: 'balderschwang',
    },
    {
      code: '097805742116',
      label: 'Bolsterlang',
      provincie: 9,
      slug: 'bolsterlang',
    },
    {
      code: '097805742121',
      label: 'Fischen i.Allgäu',
      provincie: 9,
      slug: 'fischen-i-allgaeu',
    },
    {
      code: '097805742131',
      label: 'Obermaiselstein',
      provincie: 9,
      slug: 'obermaiselstein',
    },
    {
      code: '097805742134',
      label: 'Ofterschwang',
      provincie: 9,
      slug: 'ofterschwang',
    },
    {
      code: '097805745127',
      label: 'Missen-Wilhams',
      provincie: 9,
      slug: 'missen-wilhams',
    },
    {
      code: '097805745144',
      label: 'Weitnau',
      provincie: 9,
      slug: 'weitnau',
    },
    {
      code: '100410100100',
      label: 'Saarbrücken',
      provincie: 10,
      slug: 'saarbruecken',
    },
    {
      code: '100410511511',
      label: 'Friedrichsthal',
      provincie: 10,
      slug: 'friedrichsthal',
    },
    {
      code: '100410512512',
      label: 'Großrosseln',
      provincie: 10,
      slug: 'grossrosseln',
    },
    {
      code: '100410513513',
      label: 'Heusweiler',
      provincie: 10,
      slug: 'heusweiler',
    },
    {
      code: '100410514514',
      label: 'Kleinblittersdorf',
      provincie: 10,
      slug: 'kleinblittersdorf',
    },
    {
      code: '100410515515',
      label: 'Püttlingen',
      provincie: 10,
      slug: 'puettlingen',
    },
    {
      code: '100410516516',
      label: 'Quierschied',
      provincie: 10,
      slug: 'quierschied',
    },
    {
      code: '100410517517',
      label: 'Riegelsberg',
      provincie: 10,
      slug: 'riegelsberg',
    },
    {
      code: '100410518518',
      label: 'Sulzbach/Saar',
      provincie: 10,
      slug: 'sulzbach-saar',
    },
    {
      code: '100410519519',
      label: 'Völklingen',
      provincie: 10,
      slug: 'voelklingen',
    },
    {
      code: '100420111111',
      label: 'Beckingen',
      provincie: 10,
      slug: 'beckingen',
    },
    {
      code: '100420112112',
      label: 'Losheim am See',
      provincie: 10,
      slug: 'losheim-am-see',
    },
    {
      code: '100420113113',
      label: 'Merzig',
      provincie: 10,
      slug: 'merzig',
    },
    {
      code: '100420114114',
      label: 'Mettlach',
      provincie: 10,
      slug: 'mettlach',
    },
    {
      code: '100420115115',
      label: 'Perl',
      provincie: 10,
      slug: 'perl',
    },
    {
      code: '100420116116',
      label: 'Wadern',
      provincie: 10,
      slug: 'wadern',
    },
    {
      code: '100420117117',
      label: 'Weiskirchen',
      provincie: 10,
      slug: 'weiskirchen',
    },
    {
      code: '100430111111',
      label: 'Eppelborn',
      provincie: 10,
      slug: 'eppelborn',
    },
    {
      code: '100430112112',
      label: 'Illingen',
      provincie: 10,
      slug: 'illingen-gemeinde',
    },
    {
      code: '100430113113',
      label: 'Merchweiler',
      provincie: 10,
      slug: 'merchweiler',
    },
    {
      code: '100430114114',
      label: 'Neunkirchen',
      provincie: 10,
      slug: 'neunkirchen-stadt',
    },
    {
      code: '100430115115',
      label: 'Ottweiler',
      provincie: 10,
      slug: 'ottweiler',
    },
    {
      code: '100430116116',
      label: 'Schiffweiler',
      provincie: 10,
      slug: 'schiffweiler',
    },
    {
      code: '100430117117',
      label: 'Spiesen-Elversberg',
      provincie: 10,
      slug: 'spiesen-elversberg',
    },
    {
      code: '100440111111',
      label: 'Dillingen/Saar',
      provincie: 10,
      slug: 'dillingen-saar',
    },
    {
      code: '100440112112',
      label: 'Lebach',
      provincie: 10,
      slug: 'lebach',
    },
    {
      code: '100440113113',
      label: 'Nalbach',
      provincie: 10,
      slug: 'nalbach',
    },
    {
      code: '100440114114',
      label: 'Rehlingen-Siersburg',
      provincie: 10,
      slug: 'rehlingen-siersburg',
    },
    {
      code: '100440115115',
      label: 'Saarlouis',
      provincie: 10,
      slug: 'saarlouis',
    },
    {
      code: '100440116116',
      label: 'Saarwellingen',
      provincie: 10,
      slug: 'saarwellingen',
    },
    {
      code: '100440117117',
      label: 'Schmelz',
      provincie: 10,
      slug: 'schmelz',
    },
    {
      code: '100440118118',
      label: 'Schwalbach',
      provincie: 10,
      slug: 'schwalbach',
    },
    {
      code: '100440119119',
      label: 'Überherrn',
      provincie: 10,
      slug: 'ueberherrn',
    },
    {
      code: '100440120120',
      label: 'Wadgassen',
      provincie: 10,
      slug: 'wadgassen',
    },
    {
      code: '100440121121',
      label: 'Wallerfangen',
      provincie: 10,
      slug: 'wallerfangen',
    },
    {
      code: '100440122122',
      label: 'Bous',
      provincie: 10,
      slug: 'bous',
    },
    {
      code: '100440123123',
      label: 'Ensdorf',
      provincie: 10,
      slug: 'ensdorf-gemeinde',
    },
    {
      code: '100450111111',
      label: 'Bexbach',
      provincie: 10,
      slug: 'bexbach',
    },
    {
      code: '100450112112',
      label: 'Blieskastel',
      provincie: 10,
      slug: 'blieskastel',
    },
    {
      code: '100450113113',
      label: 'Gersheim',
      provincie: 10,
      slug: 'gersheim',
    },
    {
      code: '100450114114',
      label: 'Homburg',
      provincie: 10,
      slug: 'homburg',
    },
    {
      code: '100450115115',
      label: 'Kirkel',
      provincie: 10,
      slug: 'kirkel',
    },
    {
      code: '100450116116',
      label: 'Mandelbachtal',
      provincie: 10,
      slug: 'mandelbachtal',
    },
    {
      code: '100450117117',
      label: 'St. Ingbert',
      provincie: 10,
      slug: 'st-ingbert',
    },
    {
      code: '100460111111',
      label: 'Freisen',
      provincie: 10,
      slug: 'freisen',
    },
    {
      code: '100460112112',
      label: 'Marpingen',
      provincie: 10,
      slug: 'marpingen',
    },
    {
      code: '100460113113',
      label: 'Namborn',
      provincie: 10,
      slug: 'namborn',
    },
    {
      code: '100460114114',
      label: 'Nohfelden',
      provincie: 10,
      slug: 'nohfelden',
    },
    {
      code: '100460115115',
      label: 'Nonnweiler',
      provincie: 10,
      slug: 'nonnweiler',
    },
    {
      code: '100460116116',
      label: 'Oberthal',
      provincie: 10,
      slug: 'oberthal',
    },
    {
      code: '100460117117',
      label: 'St. Wendel',
      provincie: 10,
      slug: 'st-wendel',
    },
    {
      code: '100460118118',
      label: 'Tholey',
      provincie: 10,
      slug: 'tholey',
    },
    {
      code: '110000000000',
      label: 'Berlin',
      provincie: 11,
      slug: 'berlin',
    },
    {
      code: '120510000000',
      label: 'Brandenburg an der Havel',
      provincie: 12,
      slug: 'brandenburg-an-der-havel',
    },
    {
      code: '120520000000',
      label: 'Cottbus',
      provincie: 12,
      slug: 'cottbus',
    },
    {
      code: '120530000000',
      label: 'Frankfurt (Oder)',
      provincie: 12,
      slug: 'frankfurt-oder',
    },
    {
      code: '120540000000',
      label: 'Potsdam',
      provincie: 12,
      slug: 'potsdam',
    },
    {
      code: '120600005005',
      label: 'Ahrensfelde',
      provincie: 12,
      slug: 'ahrensfelde',
    },
    {
      code: '120600020020',
      label: 'Bernau bei Berlin',
      provincie: 12,
      slug: 'bernau-bei-berlin',
    },
    {
      code: '120600052052',
      label: 'Eberswalde',
      provincie: 12,
      slug: 'eberswalde',
    },
    {
      code: '120600181181',
      label: 'Panketal',
      provincie: 12,
      slug: 'panketal',
    },
    {
      code: '120600198198',
      label: 'Schorfheide',
      provincie: 12,
      slug: 'schorfheide',
    },
    {
      code: '120600269269',
      label: 'Wandlitz',
      provincie: 12,
      slug: 'wandlitz',
    },
    {
      code: '120600280280',
      label: 'Werneuchen',
      provincie: 12,
      slug: 'werneuchen',
    },
    {
      code: '120605003024',
      label: 'Biesenthal',
      provincie: 12,
      slug: 'biesenthal',
    },
    {
      code: '120605003034',
      label: 'Breydin',
      provincie: 12,
      slug: 'breydin',
    },
    {
      code: '120605003154',
      label: 'Marienwerder',
      provincie: 12,
      slug: 'marienwerder',
    },
    {
      code: '120605003161',
      label: 'Melchow',
      provincie: 12,
      slug: 'melchow',
    },
    {
      code: '120605003192',
      label: 'Rüdnitz',
      provincie: 12,
      slug: 'ruednitz',
    },
    {
      code: '120605003250',
      label: 'Sydower Fließ',
      provincie: 12,
      slug: 'sydower-fliess',
    },
    {
      code: '120605006012',
      label: 'Althüttendorf',
      provincie: 12,
      slug: 'althuettendorf',
    },
    {
      code: '120605006068',
      label: 'Friedrichswalde',
      provincie: 12,
      slug: 'friedrichswalde',
    },
    {
      code: '120605006100',
      label: 'Joachimsthal',
      provincie: 12,
      slug: 'joachimsthal',
    },
    {
      code: '120605006296',
      label: 'Ziethen',
      provincie: 12,
      slug: 'ziethen-gemeinde',
    },
    {
      code: '120605011036',
      label: 'Britz',
      provincie: 12,
      slug: 'britz',
    },
    {
      code: '120605011045',
      label: 'Chorin',
      provincie: 12,
      slug: 'chorin',
    },
    {
      code: '120605011092',
      label: 'Hohenfinow',
      provincie: 12,
      slug: 'hohenfinow',
    },
    {
      code: '120605011128',
      label: 'Liepe',
      provincie: 12,
      slug: 'liepe',
    },
    {
      code: '120605011149',
      label: 'Lunow-Stolzenhagen',
      provincie: 12,
      slug: 'lunow-stolzenhagen',
    },
    {
      code: '120605011172',
      label: 'Niederfinow',
      provincie: 12,
      slug: 'niederfinow',
    },
    {
      code: '120605011176',
      label: 'Oderberg',
      provincie: 12,
      slug: 'oderberg',
    },
    {
      code: '120605011185',
      label: 'Parsteinsee',
      provincie: 12,
      slug: 'parsteinsee',
    },
    {
      code: '120610020020',
      label: 'Bestensee',
      provincie: 12,
      slug: 'bestensee',
    },
    {
      code: '120610112112',
      label: 'Eichwalde',
      provincie: 12,
      slug: 'eichwalde',
    },
    {
      code: '120610217217',
      label: 'Heidesee',
      provincie: 12,
      slug: 'heidesee',
    },
    {
      code: '120610219219',
      label: 'Heideblick',
      provincie: 12,
      slug: 'heideblick',
    },
    {
      code: '120610260260',
      label: 'Königs Wusterhausen',
      provincie: 12,
      slug: 'koenigs-wusterhausen',
    },
    {
      code: '120610316316',
      label: 'Lübben (Spreewald)',
      provincie: 12,
      slug: 'luebben-spreewald',
    },
    {
      code: '120610320320',
      label: 'Luckau',
      provincie: 12,
      slug: 'luckau',
    },
    {
      code: '120610329329',
      label: 'Märkische Heide',
      provincie: 12,
      slug: 'maerkische-heide',
    },
    {
      code: '120610332332',
      label: 'Mittenwalde',
      provincie: 12,
      slug: 'mittenwalde',
    },
    {
      code: '120610433433',
      label: 'Schönefeld',
      provincie: 12,
      slug: 'schoenefeld',
    },
    {
      code: '120610444444',
      label: 'Schulzendorf',
      provincie: 12,
      slug: 'schulzendorf',
    },
    {
      code: '120610540540',
      label: 'Wildau',
      provincie: 12,
      slug: 'wildau',
    },
    {
      code: '120610572572',
      label: 'Zeuthen',
      provincie: 12,
      slug: 'zeuthen',
    },
    {
      code: '120615108192',
      label: 'Groß Köris',
      provincie: 12,
      slug: 'gross-koeris',
    },
    {
      code: '120615108216',
      label: 'Halbe',
      provincie: 12,
      slug: 'halbe',
    },
    {
      code: '120615108328',
      label: 'Märkisch Buchholz',
      provincie: 12,
      slug: 'maerkisch-buchholz',
    },
    {
      code: '120615108344',
      label: 'Münchehofe',
      provincie: 12,
      slug: 'muenchehofe',
    },
    {
      code: '120615108448',
      label: 'Schwerin',
      provincie: 12,
      slug: 'schwerin',
    },
    {
      code: '120615108492',
      label: 'Teupitz',
      provincie: 12,
      slug: 'teupitz',
    },
    {
      code: '120615113005',
      label: 'Alt Zauche-Wußwerk',
      provincie: 12,
      slug: 'alt-zauche-wusswerk',
    },
    {
      code: '120615113061',
      label: 'Byhleguhre-Byhlen',
      provincie: 12,
      slug: 'byhleguhre-byhlen',
    },
    {
      code: '120615113224',
      label: 'Jamlitz',
      provincie: 12,
      slug: 'jamlitz',
    },
    {
      code: '120615113308',
      label: 'Lieberose',
      provincie: 12,
      slug: 'lieberose',
    },
    {
      code: '120615113352',
      label: 'Neu Zauche',
      provincie: 12,
      slug: 'neu-zauche',
    },
    {
      code: '120615113450',
      label: 'Schwielochsee',
      provincie: 12,
      slug: 'schwielochsee',
    },
    {
      code: '120615113470',
      label: 'Spreewaldheide',
      provincie: 12,
      slug: 'spreewaldheide',
    },
    {
      code: '120615113476',
      label: 'Straupitz (Spreewald)',
      provincie: 12,
      slug: 'straupitz-spreewald',
    },
    {
      code: '120615114017',
      label: 'Bersteland',
      provincie: 12,
      slug: 'bersteland',
    },
    {
      code: '120615114097',
      label: 'Drahnsdorf',
      provincie: 12,
      slug: 'drahnsdorf',
    },
    {
      code: '120615114164',
      label: 'Golßen',
      provincie: 12,
      slug: 'golssen',
    },
    {
      code: '120615114244',
      label: 'Kasel-Golzig',
      provincie: 12,
      slug: 'kasel-golzig',
    },
    {
      code: '120615114265',
      label: 'Krausnick-Groß Wasserburg',
      provincie: 12,
      slug: 'krausnick-gross-wasserburg',
    },
    {
      code: '120615114405',
      label: 'Rietzneuendorf-Staakow',
      provincie: 12,
      slug: 'rietzneuendorf-staakow',
    },
    {
      code: '120615114428',
      label: 'Schlepzig',
      provincie: 12,
      slug: 'schlepzig',
    },
    {
      code: '120615114435',
      label: 'Schönwald',
      provincie: 12,
      slug: 'schoenwald-gemeinde',
    },
    {
      code: '120615114471',
      label: 'Steinreich',
      provincie: 12,
      slug: 'steinreich',
    },
    {
      code: '120615114510',
      label: 'Unterspreewald',
      provincie: 12,
      slug: 'unterspreewald',
    },
    {
      code: '120620092092',
      label: 'Doberlug-Kirchhain',
      provincie: 12,
      slug: 'doberlug-kirchhain',
    },
    {
      code: '120620124124',
      label: 'Elsterwerda',
      provincie: 12,
      slug: 'elsterwerda',
    },
    {
      code: '120620140140',
      label: 'Finsterwalde',
      provincie: 12,
      slug: 'finsterwalde',
    },
    {
      code: '120620224224',
      label: 'Herzberg (Elster)',
      provincie: 12,
      slug: 'herzberg-elster',
    },
    {
      code: '120620410410',
      label: 'Röderland',
      provincie: 12,
      slug: 'roederland',
    },
    {
      code: '120620461461',
      label: 'Schönewalde',
      provincie: 12,
      slug: 'schoenewalde',
    },
    {
      code: '120620469469',
      label: 'Sonnewalde',
      provincie: 12,
      slug: 'sonnewalde',
    },
    {
      code: '120625031024',
      label: 'Bad Liebenwerda',
      provincie: 12,
      slug: 'bad-liebenwerda',
    },
    {
      code: '120625031128',
      label: 'Falkenberg/Elster',
      provincie: 12,
      slug: 'falkenberg-elster',
    },
    {
      code: '120625031341',
      label: 'Mühlberg/Elbe',
      provincie: 12,
      slug: 'muehlberg-elbe',
    },
    {
      code: '120625031500',
      label: 'Uebigau-Wahrenbrück',
      provincie: 12,
      slug: 'uebigau-wahrenbrueck',
    },
    {
      code: '120625202219',
      label: 'Heideland',
      provincie: 12,
      slug: 'heideland',
    },
    {
      code: '120625202417',
      label: 'Rückersdorf',
      provincie: 12,
      slug: 'rueckersdorf-gemeinde',
    },
    {
      code: '120625202440',
      label: 'Schilda',
      provincie: 12,
      slug: 'schilda',
    },
    {
      code: '120625202453',
      label: 'Schönborn',
      provincie: 12,
      slug: 'schoenborn-gemeinde',
    },
    {
      code: '120625202492',
      label: 'Tröbitz',
      provincie: 12,
      slug: 'troebitz',
    },
    {
      code: '120625205088',
      label: 'Crinitz',
      provincie: 12,
      slug: 'crinitz',
    },
    {
      code: '120625205293',
      label: 'Lichterfeld-Schacksdorf',
      provincie: 12,
      slug: 'lichterfeld-schacksdorf',
    },
    {
      code: '120625205333',
      label: 'Massen-Niederlausitz',
      provincie: 12,
      slug: 'massen-niederlausitz',
    },
    {
      code: '120625205425',
      label: 'Sallgast',
      provincie: 12,
      slug: 'sallgast',
    },
    {
      code: '120625207177',
      label: 'Gorden-Staupitz',
      provincie: 12,
      slug: 'gorden-staupitz',
    },
    {
      code: '120625207240',
      label: 'Hohenleipisch',
      provincie: 12,
      slug: 'hohenleipisch',
    },
    {
      code: '120625207372',
      label: 'Plessa',
      provincie: 12,
      slug: 'plessa',
    },
    {
      code: '120625207464',
      label: 'Schraden',
      provincie: 12,
      slug: 'schraden',
    },
    {
      code: '120625209134',
      label: 'Fichtwald',
      provincie: 12,
      slug: 'fichtwald',
    },
    {
      code: '120625209237',
      label: 'Hohenbucko',
      provincie: 12,
      slug: 'hohenbucko',
    },
    {
      code: '120625209282',
      label: 'Kremitzaue',
      provincie: 12,
      slug: 'kremitzaue',
    },
    {
      code: '120625209289',
      label: 'Lebusa',
      provincie: 12,
      slug: 'lebusa',
    },
    {
      code: '120625209445',
      label: 'Schlieben',
      provincie: 12,
      slug: 'schlieben',
    },
    {
      code: '120625211196',
      label: 'Gröden',
      provincie: 12,
      slug: 'groeden',
    },
    {
      code: '120625211208',
      label: 'Großthiemig',
      provincie: 12,
      slug: 'grossthiemig',
    },
    {
      code: '120625211232',
      label: 'Hirschfeld',
      provincie: 12,
      slug: 'hirschfeld',
    },
    {
      code: '120625211336',
      label: 'Merzdorf',
      provincie: 12,
      slug: 'merzdorf',
    },
    {
      code: '120630036036',
      label: 'Brieselang',
      provincie: 12,
      slug: 'brieselang',
    },
    {
      code: '120630056056',
      label: 'Dallgow-Döberitz',
      provincie: 12,
      slug: 'dallgow-doeberitz',
    },
    {
      code: '120630080080',
      label: 'Falkensee',
      provincie: 12,
      slug: 'falkensee',
    },
    {
      code: '120630148148',
      label: 'Ketzin/Havel',
      provincie: 12,
      slug: 'ketzin-havel',
    },
    {
      code: '120630189189',
      label: 'Milower Land',
      provincie: 12,
      slug: 'milower-land',
    },
    {
      code: '120630208208',
      label: 'Nauen',
      provincie: 12,
      slug: 'nauen',
    },
    {
      code: '120630244244',
      label: 'Premnitz',
      provincie: 12,
      slug: 'premnitz',
    },
    {
      code: '120630252252',
      label: 'Rathenow',
      provincie: 12,
      slug: 'rathenow',
    },
    {
      code: '120630273273',
      label: 'Schönwalde-Glien',
      provincie: 12,
      slug: 'schoenwalde-glien',
    },
    {
      code: '120630357357',
      label: 'Wustermark',
      provincie: 12,
      slug: 'wustermark',
    },
    {
      code: '120635302088',
      label: 'Friesack',
      provincie: 12,
      slug: 'friesack',
    },
    {
      code: '120635302142',
      label: 'Wiesenaue',
      provincie: 12,
      slug: 'wiesenaue',
    },
    {
      code: '120635302202',
      label: 'Mühlenberge',
      provincie: 12,
      slug: 'muehlenberge',
    },
    {
      code: '120635302228',
      label: 'Paulinenaue',
      provincie: 12,
      slug: 'paulinenaue',
    },
    {
      code: '120635302240',
      label: 'Pessin',
      provincie: 12,
      slug: 'pessin',
    },
    {
      code: '120635302256',
      label: 'Retzow',
      provincie: 12,
      slug: 'retzow',
    },
    {
      code: '120635306165',
      label: 'Kotzen',
      provincie: 12,
      slug: 'kotzen',
    },
    {
      code: '120635306186',
      label: 'Märkisch Luch',
      provincie: 12,
      slug: 'maerkisch-luch',
    },
    {
      code: '120635306212',
      label: 'Nennhausen',
      provincie: 12,
      slug: 'nennhausen',
    },
    {
      code: '120635306293',
      label: 'Stechow-Ferchesar',
      provincie: 12,
      slug: 'stechow-ferchesar',
    },
    {
      code: '120635309094',
      label: 'Gollenberg',
      provincie: 12,
      slug: 'gollenberg-gemeinde',
    },
    {
      code: '120635309112',
      label: 'Großderschau',
      provincie: 12,
      slug: 'grossderschau',
    },
    {
      code: '120635309134',
      label: 'Havelaue',
      provincie: 12,
      slug: 'havelaue',
    },
    {
      code: '120635309161',
      label: 'Kleßen-Görne',
      provincie: 12,
      slug: 'klessen-goerne',
    },
    {
      code: '120635309260',
      label: 'Rhinow',
      provincie: 12,
      slug: 'rhinow',
    },
    {
      code: '120635309274',
      label: 'Seeblick',
      provincie: 12,
      slug: 'seeblick',
    },
    {
      code: '120640029029',
      label: 'Altlandsberg',
      provincie: 12,
      slug: 'altlandsberg',
    },
    {
      code: '120640044044',
      label: 'Bad Freienwalde (Oder)',
      provincie: 12,
      slug: 'bad-freienwalde-oder',
    },
    {
      code: '120640136136',
      label: 'Fredersdorf-Vogelsdorf',
      provincie: 12,
      slug: 'fredersdorf-vogelsdorf',
    },
    {
      code: '120640227227',
      label: 'Hoppegarten',
      provincie: 12,
      slug: 'hoppegarten',
    },
    {
      code: '120640274274',
      label: 'Letschin',
      provincie: 12,
      slug: 'letschin',
    },
    {
      code: '120640317317',
      label: 'Müncheberg',
      provincie: 12,
      slug: 'muencheberg',
    },
    {
      code: '120640336336',
      label: 'Neuenhagen bei Berlin',
      provincie: 12,
      slug: 'neuenhagen-bei-berlin',
    },
    {
      code: '120640380380',
      label: 'Petershagen/Eggersdorf',
      provincie: 12,
      slug: 'petershagen-eggersdorf',
    },
    {
      code: '120640428428',
      label: 'Rüdersdorf bei Berlin',
      provincie: 12,
      slug: 'ruedersdorf-bei-berlin',
    },
    {
      code: '120640448448',
      label: 'Seelow',
      provincie: 12,
      slug: 'seelow',
    },
    {
      code: '120640472472',
      label: 'Strausberg',
      provincie: 12,
      slug: 'strausberg',
    },
    {
      code: '120640512512',
      label: 'Wriezen',
      provincie: 12,
      slug: 'wriezen',
    },
    {
      code: '120645403053',
      label: 'Beiersdorf-Freudenberg',
      provincie: 12,
      slug: 'beiersdorf-freudenberg',
    },
    {
      code: '120645403125',
      label: 'Falkenberg',
      provincie: 12,
      slug: 'falkenberg-gemeinde',
    },
    {
      code: '120645403205',
      label: 'Heckelberg-Brunow',
      provincie: 12,
      slug: 'heckelberg-brunow',
    },
    {
      code: '120645403222',
      label: 'Höhenland',
      provincie: 12,
      slug: 'hoehenland',
    },
    {
      code: '120645404009',
      label: 'Alt Tucheband',
      provincie: 12,
      slug: 'alt-tucheband',
    },
    {
      code: '120645404057',
      label: 'Bleyen-Genschmar',
      provincie: 12,
      slug: 'bleyen-genschmar',
    },
    {
      code: '120645404172',
      label: 'Golzow',
      provincie: 12,
      slug: 'golzow',
    },
    {
      code: '120645404266',
      label: 'Küstriner Vorland',
      provincie: 12,
      slug: 'kuestriner-vorland',
    },
    {
      code: '120645404538',
      label: 'Zechin',
      provincie: 12,
      slug: 'zechin',
    },
    {
      code: '120645406268',
      label: 'Lebus',
      provincie: 12,
      slug: 'lebus',
    },
    {
      code: '120645406388',
      label: 'Podelzig',
      provincie: 12,
      slug: 'podelzig',
    },
    {
      code: '120645406420',
      label: 'Reitwein',
      provincie: 12,
      slug: 'reitwein',
    },
    {
      code: '120645406480',
      label: 'Treplin',
      provincie: 12,
      slug: 'treplin',
    },
    {
      code: '120645406539',
      label: 'Zeschdorf',
      provincie: 12,
      slug: 'zeschdorf',
    },
    {
      code: '120645408084',
      label: 'Buckow (Märkische Schweiz)',
      provincie: 12,
      slug: 'buckow-maerkische-schweiz',
    },
    {
      code: '120645408153',
      label: 'Garzau-Garzin',
      provincie: 12,
      slug: 'garzau-garzin',
    },
    {
      code: '120645408303',
      label: 'Märkische Höhe',
      provincie: 12,
      slug: 'maerkische-hoehe',
    },
    {
      code: '120645408370',
      label: 'Oberbarnim',
      provincie: 12,
      slug: 'oberbarnim',
    },
    {
      code: '120645408408',
      label: 'Rehfelde',
      provincie: 12,
      slug: 'rehfelde',
    },
    {
      code: '120645408484',
      label: 'Waldsieversdorf',
      provincie: 12,
      slug: 'waldsieversdorf',
    },
    {
      code: '120645412128',
      label: 'Falkenhagen (Mark)',
      provincie: 12,
      slug: 'falkenhagen-mark',
    },
    {
      code: '120645412130',
      label: 'Fichtenhöhe',
      provincie: 12,
      slug: 'fichtenhoehe',
    },
    {
      code: '120645412190',
      label: 'Gusow-Platkow',
      provincie: 12,
      slug: 'gusow-platkow',
    },
    {
      code: '120645412288',
      label: 'Lietzen',
      provincie: 12,
      slug: 'lietzen',
    },
    {
      code: '120645412290',
      label: 'Lindendorf',
      provincie: 12,
      slug: 'lindendorf',
    },
    {
      code: '120645412340',
      label: 'Neuhardenberg',
      provincie: 12,
      slug: 'neuhardenberg',
    },
    {
      code: '120645412482',
      label: 'Vierlinden',
      provincie: 12,
      slug: 'vierlinden',
    },
    {
      code: '120645414061',
      label: 'Bliesdorf',
      provincie: 12,
      slug: 'bliesdorf',
    },
    {
      code: '120645414349',
      label: 'Neulewin',
      provincie: 12,
      slug: 'neulewin',
    },
    {
      code: '120645414365',
      label: 'Neutrebbin',
      provincie: 12,
      slug: 'neutrebbin',
    },
    {
      code: '120645414371',
      label: 'Oderaue',
      provincie: 12,
      slug: 'oderaue',
    },
    {
      code: '120645414393',
      label: 'Prötzel',
      provincie: 12,
      slug: 'proetzel',
    },
    {
      code: '120645414417',
      label: 'Reichenow-Möglin',
      provincie: 12,
      slug: 'reichenow-moeglin',
    },
    {
      code: '120650036036',
      label: 'Birkenwerder',
      provincie: 12,
      slug: 'birkenwerder',
    },
    {
      code: '120650084084',
      label: 'Fürstenberg/Havel',
      provincie: 12,
      slug: 'fuerstenberg-havel',
    },
    {
      code: '120650096096',
      label: 'Glienicke/Nordbahn',
      provincie: 12,
      slug: 'glienicke-nordbahn',
    },
    {
      code: '120650136136',
      label: 'Hennigsdorf',
      provincie: 12,
      slug: 'hennigsdorf',
    },
    {
      code: '120650144144',
      label: 'Hohen Neuendorf',
      provincie: 12,
      slug: 'hohen-neuendorf',
    },
    {
      code: '120650165165',
      label: 'Kremmen',
      provincie: 12,
      slug: 'kremmen',
    },
    {
      code: '120650180180',
      label: 'Leegebruch',
      provincie: 12,
      slug: 'leegebruch',
    },
    {
      code: '120650193193',
      label: 'Liebenwalde',
      provincie: 12,
      slug: 'liebenwalde',
    },
    {
      code: '120650198198',
      label: 'Löwenberger Land',
      provincie: 12,
      slug: 'loewenberger-land',
    },
    {
      code: '120650225225',
      label: 'Mühlenbecker Land',
      provincie: 12,
      slug: 'muehlenbecker-land',
    },
    {
      code: '120650251251',
      label: 'Oberkrämer',
      provincie: 12,
      slug: 'oberkraemer',
    },
    {
      code: '120650256256',
      label: 'Oranienburg',
      provincie: 12,
      slug: 'oranienburg',
    },
    {
      code: '120650332332',
      label: 'Velten',
      provincie: 12,
      slug: 'velten',
    },
    {
      code: '120650356356',
      label: 'Zehdenick',
      provincie: 12,
      slug: 'zehdenick',
    },
    {
      code: '120655502100',
      label: 'Gransee',
      provincie: 12,
      slug: 'gransee',
    },
    {
      code: '120655502117',
      label: 'Großwoltersdorf',
      provincie: 12,
      slug: 'grosswoltersdorf',
    },
    {
      code: '120655502276',
      label: 'Schönermark',
      provincie: 12,
      slug: 'schoenermark',
    },
    {
      code: '120655502301',
      label: 'Sonnenberg',
      provincie: 12,
      slug: 'sonnenberg',
    },
    {
      code: '120655502310',
      label: 'Stechlin',
      provincie: 12,
      slug: 'stechlin',
    },
    {
      code: '120660052052',
      label: 'Calau',
      provincie: 12,
      slug: 'calau',
    },
    {
      code: '120660112112',
      label: 'Großräschen',
      provincie: 12,
      slug: 'grossraeschen',
    },
    {
      code: '120660176176',
      label: 'Lauchhammer',
      provincie: 12,
      slug: 'lauchhammer',
    },
    {
      code: '120660196196',
      label: 'Lübbenau/Spreewald',
      provincie: 12,
      slug: 'luebbenau-spreewald',
    },
    {
      code: '120660285285',
      label: 'Schipkau',
      provincie: 12,
      slug: 'schipkau',
    },
    {
      code: '120660296296',
      label: 'Schwarzheide',
      provincie: 12,
      slug: 'schwarzheide',
    },
    {
      code: '120660304304',
      label: 'Senftenberg',
      provincie: 12,
      slug: 'senftenberg',
    },
    {
      code: '120660320320',
      label: 'Vetschau/Spreewald',
      provincie: 12,
      slug: 'vetschau-spreewald',
    },
    {
      code: '120665601008',
      label: 'Altdöbern',
      provincie: 12,
      slug: 'altdoebern',
    },
    {
      code: '120665601041',
      label: 'Bronkow',
      provincie: 12,
      slug: 'bronkow',
    },
    {
      code: '120665601202',
      label: 'Luckaitztal',
      provincie: 12,
      slug: 'luckaitztal',
    },
    {
      code: '120665601226',
      label: 'Neu-Seeland',
      provincie: 12,
      slug: 'neu-seeland',
    },
    {
      code: '120665601228',
      label: 'Neupetershain',
      provincie: 12,
      slug: 'neupetershain',
    },
    {
      code: '120665606064',
      label: 'Frauendorf',
      provincie: 12,
      slug: 'frauendorf',
    },
    {
      code: '120665606104',
      label: 'Großkmehlen',
      provincie: 12,
      slug: 'grosskmehlen',
    },
    {
      code: '120665606168',
      label: 'Kroppen',
      provincie: 12,
      slug: 'kroppen',
    },
    {
      code: '120665606188',
      label: 'Lindenau',
      provincie: 12,
      slug: 'lindenau',
    },
    {
      code: '120665606240',
      label: 'Ortrand',
      provincie: 12,
      slug: 'ortrand',
    },
    {
      code: '120665606316',
      label: 'Tettau',
      provincie: 12,
      slug: 'tettau-gemeinde',
    },
    {
      code: '120665607116',
      label: 'Grünewald',
      provincie: 12,
      slug: 'gruenewald',
    },
    {
      code: '120665607120',
      label: 'Guteborn',
      provincie: 12,
      slug: 'guteborn',
    },
    {
      code: '120665607124',
      label: 'Hermsdorf',
      provincie: 12,
      slug: 'hermsdorf',
    },
    {
      code: '120665607132',
      label: 'Hohenbocka',
      provincie: 12,
      slug: 'hohenbocka',
    },
    {
      code: '120665607272',
      label: 'Ruhland',
      provincie: 12,
      slug: 'ruhland',
    },
    {
      code: '120665607292',
      label: 'Schwarzbach',
      provincie: 12,
      slug: 'schwarzbach',
    },
    {
      code: '120670036036',
      label: 'Beeskow',
      provincie: 12,
      slug: 'beeskow',
    },
    {
      code: '120670120120',
      label: 'Eisenhüttenstadt',
      provincie: 12,
      slug: 'eisenhuettenstadt',
    },
    {
      code: '120670124124',
      label: 'Erkner',
      provincie: 12,
      slug: 'erkner',
    },
    {
      code: '120670137137',
      label: 'Friedland',
      provincie: 12,
      slug: 'friedland-stadt',
    },
    {
      code: '120670144144',
      label: 'Fürstenwalde/Spree',
      provincie: 12,
      slug: 'fuerstenwalde-spree',
    },
    {
      code: '120670201201',
      label: 'Grünheide (Mark)',
      provincie: 12,
      slug: 'gruenheide-mark',
    },
    {
      code: '120670426426',
      label: 'Rietz-Neuendorf',
      provincie: 12,
      slug: 'rietz-neuendorf',
    },
    {
      code: '120670440440',
      label: 'Schöneiche bei Berlin',
      provincie: 12,
      slug: 'schoeneiche-bei-berlin',
    },
    {
      code: '120670481481',
      label: 'Storkow (Mark)',
      provincie: 12,
      slug: 'storkow-mark',
    },
    {
      code: '120670493493',
      label: 'Tauche',
      provincie: 12,
      slug: 'tauche',
    },
    {
      code: '120670544544',
      label: 'Woltersdorf',
      provincie: 12,
      slug: 'woltersdorf-gemeinde',
    },
    {
      code: '120675701076',
      label: 'Brieskow-Finkenheerd',
      provincie: 12,
      slug: 'brieskow-finkenheerd',
    },
    {
      code: '120675701180',
      label: 'Groß Lindow',
      provincie: 12,
      slug: 'gross-lindow',
    },
    {
      code: '120675701508',
      label: 'Vogelsang',
      provincie: 12,
      slug: 'vogelsang',
    },
    {
      code: '120675701528',
      label: 'Wiesenau',
      provincie: 12,
      slug: 'wiesenau',
    },
    {
      code: '120675701552',
      label: 'Ziltendorf',
      provincie: 12,
      slug: 'ziltendorf',
    },
    {
      code: '120675705292',
      label: 'Lawitz',
      provincie: 12,
      slug: 'lawitz',
    },
    {
      code: '120675705338',
      label: 'Neißemünde',
      provincie: 12,
      slug: 'neissemuende',
    },
    {
      code: '120675705357',
      label: 'Neuzelle',
      provincie: 12,
      slug: 'neuzelle',
    },
    {
      code: '120675706040',
      label: 'Berkenbrück',
      provincie: 12,
      slug: 'berkenbrueck',
    },
    {
      code: '120675706072',
      label: 'Briesen (Mark)',
      provincie: 12,
      slug: 'briesen-mark',
    },
    {
      code: '120675706237',
      label: 'Jacobsdorf',
      provincie: 12,
      slug: 'jacobsdorf',
    },
    {
      code: '120675706473',
      label: 'Steinhöfel',
      provincie: 12,
      slug: 'steinhoefel',
    },
    {
      code: '120675707024',
      label: 'Bad Saarow',
      provincie: 12,
      slug: 'bad-saarow',
    },
    {
      code: '120675707112',
      label: 'Diensdorf-Radlow',
      provincie: 12,
      slug: 'diensdorf-radlow',
    },
    {
      code: '120675707288',
      label: 'Langewahl',
      provincie: 12,
      slug: 'langewahl',
    },
    {
      code: '120675707413',
      label: 'Reichenwalde',
      provincie: 12,
      slug: 'reichenwalde',
    },
    {
      code: '120675707520',
      label: 'Wendisch Rietz',
      provincie: 12,
      slug: 'wendisch-rietz',
    },
    {
      code: '120675708205',
      label: 'Grunow-Dammendorf',
      provincie: 12,
      slug: 'grunow-dammendorf',
    },
    {
      code: '120675708324',
      label: 'Mixdorf',
      provincie: 12,
      slug: 'mixdorf',
    },
    {
      code: '120675708336',
      label: 'Müllrose',
      provincie: 12,
      slug: 'muellrose',
    },
    {
      code: '120675708397',
      label: 'Ragow-Merz',
      provincie: 12,
      slug: 'ragow-merz',
    },
    {
      code: '120675708438',
      label: 'Schlaubetal',
      provincie: 12,
      slug: 'schlaubetal',
    },
    {
      code: '120675708458',
      label: 'Siehdichum',
      provincie: 12,
      slug: 'siehdichum',
    },
    {
      code: '120675709173',
      label: 'Gosen-Neu Zittau',
      provincie: 12,
      slug: 'gosen-neu-zittau',
    },
    {
      code: '120675709408',
      label: 'Rauen',
      provincie: 12,
      slug: 'rauen',
    },
    {
      code: '120675709469',
      label: 'Spreenhagen',
      provincie: 12,
      slug: 'spreenhagen',
    },
    {
      code: '120680117117',
      label: 'Fehrbellin',
      provincie: 12,
      slug: 'fehrbellin',
    },
    {
      code: '120680181181',
      label: 'Heiligengrabe',
      provincie: 12,
      slug: 'heiligengrabe',
    },
    {
      code: '120680264264',
      label: 'Kyritz',
      provincie: 12,
      slug: 'kyritz',
    },
    {
      code: '120680320320',
      label: 'Neuruppin',
      provincie: 12,
      slug: 'neuruppin',
    },
    {
      code: '120680353353',
      label: 'Rheinsberg',
      provincie: 12,
      slug: 'rheinsberg',
    },
    {
      code: '120680468468',
      label: 'Wittstock/Dosse',
      provincie: 12,
      slug: 'wittstock-dosse',
    },
    {
      code: '120680477477',
      label: 'Wusterhausen/Dosse',
      provincie: 12,
      slug: 'wusterhausen-dosse',
    },
    {
      code: '120685804188',
      label: 'Herzberg (Mark)',
      provincie: 12,
      slug: 'herzberg-mark',
    },
    {
      code: '120685804280',
      label: 'Lindow (Mark)',
      provincie: 12,
      slug: 'lindow-mark',
    },
    {
      code: '120685804372',
      label: 'Rüthnick',
      provincie: 12,
      slug: 'ruethnick',
    },
    {
      code: '120685804437',
      label: 'Vielitzsee',
      provincie: 12,
      slug: 'vielitzsee',
    },
    {
      code: '120685805052',
      label: 'Breddin',
      provincie: 12,
      slug: 'breddin',
    },
    {
      code: '120685805109',
      label: 'Dreetz',
      provincie: 12,
      slug: 'dreetz',
    },
    {
      code: '120685805324',
      label: 'Neustadt (Dosse)',
      provincie: 12,
      slug: 'neustadt-dosse',
    },
    {
      code: '120685805409',
      label: 'Sieversdorf-Hohenofen',
      provincie: 12,
      slug: 'sieversdorf-hohenofen',
    },
    {
      code: '120685805417',
      label: 'Stüdenitz-Schönermark',
      provincie: 12,
      slug: 'stuedenitz-schoenermark',
    },
    {
      code: '120685805501',
      label: 'Zernitz-Lohm',
      provincie: 12,
      slug: 'zernitz-lohm',
    },
    {
      code: '120685807072',
      label: 'Dabergotz',
      provincie: 12,
      slug: 'dabergotz',
    },
    {
      code: '120685807306',
      label: 'Märkisch Linden',
      provincie: 12,
      slug: 'maerkisch-linden',
    },
    {
      code: '120685807413',
      label: 'Storbeck-Frankendorf',
      provincie: 12,
      slug: 'storbeck-frankendorf',
    },
    {
      code: '120685807425',
      label: 'Temnitzquell',
      provincie: 12,
      slug: 'temnitzquell',
    },
    {
      code: '120685807426',
      label: 'Temnitztal',
      provincie: 12,
      slug: 'temnitztal',
    },
    {
      code: '120685807452',
      label: 'Walsleben',
      provincie: 12,
      slug: 'walsleben',
    },
    {
      code: '120690017017',
      label: 'Beelitz',
      provincie: 12,
      slug: 'beelitz',
    },
    {
      code: '120690020020',
      label: 'Bad Belzig',
      provincie: 12,
      slug: 'bad-belzig',
    },
    {
      code: '120690249249',
      label: 'Groß Kreutz (Havel)',
      provincie: 12,
      slug: 'gross-kreutz-havel',
    },
    {
      code: '120690304304',
      label: 'Kleinmachnow',
      provincie: 12,
      slug: 'kleinmachnow',
    },
    {
      code: '120690306306',
      label: 'Kloster Lehnin',
      provincie: 12,
      slug: 'kloster-lehnin',
    },
    {
      code: '120690397397',
      label: 'Michendorf',
      provincie: 12,
      slug: 'michendorf',
    },
    {
      code: '120690454454',
      label: 'Nuthetal',
      provincie: 12,
      slug: 'nuthetal',
    },
    {
      code: '120690590590',
      label: 'Schwielowsee',
      provincie: 12,
      slug: 'schwielowsee',
    },
    {
      code: '120690596596',
      label: 'Seddiner See',
      provincie: 12,
      slug: 'seddiner-see',
    },
    {
      code: '120690604604',
      label: 'Stahnsdorf',
      provincie: 12,
      slug: 'stahnsdorf',
    },
    {
      code: '120690616616',
      label: 'Teltow',
      provincie: 12,
      slug: 'teltow',
    },
    {
      code: '120690632632',
      label: 'Treuenbrietzen',
      provincie: 12,
      slug: 'treuenbrietzen',
    },
    {
      code: '120690656656',
      label: 'Werder (Havel)',
      provincie: 12,
      slug: 'werder-havel',
    },
    {
      code: '120690665665',
      label: 'Wiesenburg/Mark',
      provincie: 12,
      slug: 'wiesenburg-mark',
    },
    {
      code: '120695902018',
      label: 'Beetzsee',
      provincie: 12,
      slug: 'beetzsee',
    },
    {
      code: '120695902019',
      label: 'Beetzseeheide',
      provincie: 12,
      slug: 'beetzseeheide',
    },
    {
      code: '120695902270',
      label: 'Havelsee',
      provincie: 12,
      slug: 'havelsee',
    },
    {
      code: '120695902460',
      label: 'Päwesin',
      provincie: 12,
      slug: 'paewesin',
    },
    {
      code: '120695902541',
      label: 'Roskow',
      provincie: 12,
      slug: 'roskow',
    },
    {
      code: '120695904052',
      label: 'Borkheide',
      provincie: 12,
      slug: 'borkheide',
    },
    {
      code: '120695904056',
      label: 'Borkwalde',
      provincie: 12,
      slug: 'borkwalde',
    },
    {
      code: '120695904076',
      label: 'Brück',
      provincie: 12,
      slug: 'brueck',
    },
    {
      code: '120695904216',
      label: 'Golzow',
      provincie: 12,
      slug: 'golzow-gemeinde',
    },
    {
      code: '120695904345',
      label: 'Linthe',
      provincie: 12,
      slug: 'linthe',
    },
    {
      code: '120695904470',
      label: 'Planebruch',
      provincie: 12,
      slug: 'planebruch',
    },
    {
      code: '120695910402',
      label: 'Mühlenfließ',
      provincie: 12,
      slug: 'muehlenfliess',
    },
    {
      code: '120695910448',
      label: 'Niemegk',
      provincie: 12,
      slug: 'niemegk',
    },
    {
      code: '120695910474',
      label: 'Planetal',
      provincie: 12,
      slug: 'planetal',
    },
    {
      code: '120695910485',
      label: 'Rabenstein/Fläming',
      provincie: 12,
      slug: 'rabenstein-flaeming',
    },
    {
      code: '120695917028',
      label: 'Bensdorf',
      provincie: 12,
      slug: 'bensdorf',
    },
    {
      code: '120695917537',
      label: 'Rosenau',
      provincie: 12,
      slug: 'rosenau',
    },
    {
      code: '120695917688',
      label: 'Wusterwitz',
      provincie: 12,
      slug: 'wusterwitz',
    },
    {
      code: '120695918089',
      label: 'Buckautal',
      provincie: 12,
      slug: 'buckautal',
    },
    {
      code: '120695918224',
      label: 'Görzke',
      provincie: 12,
      slug: 'goerzke',
    },
    {
      code: '120695918232',
      label: 'Gräben',
      provincie: 12,
      slug: 'graeben',
    },
    {
      code: '120695918648',
      label: 'Wenzlow',
      provincie: 12,
      slug: 'wenzlow',
    },
    {
      code: '120695918680',
      label: 'Wollin',
      provincie: 12,
      slug: 'wollin',
    },
    {
      code: '120695918696',
      label: 'Ziesar',
      provincie: 12,
      slug: 'ziesar',
    },
    {
      code: '120700125125',
      label: 'Groß Pankow (Prignitz)',
      provincie: 12,
      slug: 'gross-pankow-prignitz',
    },
    {
      code: '120700149149',
      label: 'Gumtow',
      provincie: 12,
      slug: 'gumtow',
    },
    {
      code: '120700173173',
      label: 'Karstädt',
      provincie: 12,
      slug: 'karstaedt',
    },
    {
      code: '120700296296',
      label: 'Perleberg',
      provincie: 12,
      slug: 'perleberg',
    },
    {
      code: '120700302302',
      label: 'Plattenburg',
      provincie: 12,
      slug: 'plattenburg',
    },
    {
      code: '120700316316',
      label: 'Pritzwalk',
      provincie: 12,
      slug: 'pritzwalk',
    },
    {
      code: '120700424424',
      label: 'Wittenberge',
      provincie: 12,
      slug: 'wittenberge',
    },
    {
      code: '120705001008',
      label: 'Bad Wilsnack',
      provincie: 12,
      slug: 'bad-wilsnack',
    },
    {
      code: '120705001052',
      label: 'Breese',
      provincie: 12,
      slug: 'breese',
    },
    {
      code: '120705001241',
      label: 'Legde/Quitzöbel',
      provincie: 12,
      slug: 'legde-quitzoebel',
    },
    {
      code: '120705001348',
      label: 'Rühstädt',
      provincie: 12,
      slug: 'ruehstaedt',
    },
    {
      code: '120705001416',
      label: 'Weisen',
      provincie: 12,
      slug: 'weisen',
    },
    {
      code: '120705005060',
      label: 'Cumlosen',
      provincie: 12,
      slug: 'cumlosen',
    },
    {
      code: '120705005236',
      label: 'Lanz',
      provincie: 12,
      slug: 'lanz',
    },
    {
      code: '120705005244',
      label: 'Lenzen (Elbe)',
      provincie: 12,
      slug: 'lenzen-elbe',
    },
    {
      code: '120705005246',
      label: 'Lenzerwische',
      provincie: 12,
      slug: 'lenzerwische',
    },
    {
      code: '120705006096',
      label: 'Gerdshagen',
      provincie: 12,
      slug: 'gerdshagen',
    },
    {
      code: '120705006153',
      label: 'Halenbeck-Rohlsdorf',
      provincie: 12,
      slug: 'halenbeck-rohlsdorf',
    },
    {
      code: '120705006222',
      label: 'Kümmernitztal',
      provincie: 12,
      slug: 'kuemmernitztal',
    },
    {
      code: '120705006266',
      label: 'Marienfließ',
      provincie: 12,
      slug: 'marienfliess',
    },
    {
      code: '120705006280',
      label: 'Meyenburg',
      provincie: 12,
      slug: 'meyenburg',
    },
    {
      code: '120705009028',
      label: 'Berge',
      provincie: 12,
      slug: 'berge-gemeinde',
    },
    {
      code: '120705009145',
      label: 'Gülitz-Reetz',
      provincie: 12,
      slug: 'guelitz-reetz',
    },
    {
      code: '120705009300',
      label: 'Pirow',
      provincie: 12,
      slug: 'pirow',
    },
    {
      code: '120705009325',
      label: 'Putlitz',
      provincie: 12,
      slug: 'putlitz',
    },
    {
      code: '120705009393',
      label: 'Triglitz',
      provincie: 12,
      slug: 'triglitz',
    },
    {
      code: '120710057057',
      label: 'Drebkau',
      provincie: 12,
      slug: 'drebkau',
    },
    {
      code: '120710076076',
      label: 'Forst (Lausitz)',
      provincie: 12,
      slug: 'forst-lausitz',
    },
    {
      code: '120710160160',
      label: 'Guben',
      provincie: 12,
      slug: 'guben',
    },
    {
      code: '120710244244',
      label: 'Kolkwitz',
      provincie: 12,
      slug: 'kolkwitz',
    },
    {
      code: '120710301301',
      label: 'Neuhausen/Spree',
      provincie: 12,
      slug: 'neuhausen-spree',
    },
    {
      code: '120710337337',
      label: 'Schenkendöbern',
      provincie: 12,
      slug: 'schenkendoebern',
    },
    {
      code: '120710372372',
      label: 'Spremberg',
      provincie: 12,
      slug: 'spremberg',
    },
    {
      code: '120710408408',
      label: 'Welzow',
      provincie: 12,
      slug: 'welzow',
    },
    {
      code: '120715101028',
      label: 'Briesen',
      provincie: 12,
      slug: 'briesen',
    },
    {
      code: '120715101032',
      label: 'Burg (Spreewald)',
      provincie: 12,
      slug: 'burg-spreewald',
    },
    {
      code: '120715101041',
      label: 'Dissen-Striesow',
      provincie: 12,
      slug: 'dissen-striesow',
    },
    {
      code: '120715101164',
      label: 'Guhrow',
      provincie: 12,
      slug: 'guhrow',
    },
    {
      code: '120715101341',
      label: 'Schmogrow-Fehrow',
      provincie: 12,
      slug: 'schmogrow-fehrow',
    },
    {
      code: '120715101412',
      label: 'Werben',
      provincie: 12,
      slug: 'werben',
    },
    {
      code: '120715102044',
      label: 'Döbern',
      provincie: 12,
      slug: 'doebern',
    },
    {
      code: '120715102074',
      label: 'Felixsee',
      provincie: 12,
      slug: 'felixsee',
    },
    {
      code: '120715102153',
      label: 'Groß Schacksdorf-Simmersdorf',
      provincie: 12,
      slug: 'gross-schacksdorf-simmersdorf',
    },
    {
      code: '120715102189',
      label: 'Jämlitz-Klein Düben',
      provincie: 12,
      slug: 'jaemlitz-klein-dueben',
    },
    {
      code: '120715102294',
      label: 'Neiße-Malxetal',
      provincie: 12,
      slug: 'neisse-malxetal',
    },
    {
      code: '120715102392',
      label: 'Tschernitz',
      provincie: 12,
      slug: 'tschernitz',
    },
    {
      code: '120715102414',
      label: 'Wiesengrund',
      provincie: 12,
      slug: 'wiesengrund',
    },
    {
      code: '120715107052',
      label: 'Drachhausen',
      provincie: 12,
      slug: 'drachhausen',
    },
    {
      code: '120715107060',
      label: 'Drehnow',
      provincie: 12,
      slug: 'drehnow',
    },
    {
      code: '120715107176',
      label: 'Heinersbrück',
      provincie: 12,
      slug: 'heinersbrueck',
    },
    {
      code: '120715107193',
      label: 'Jänschwalde',
      provincie: 12,
      slug: 'jaenschwalde',
    },
    {
      code: '120715107304',
      label: 'Peitz',
      provincie: 12,
      slug: 'peitz',
    },
    {
      code: '120715107384',
      label: 'Tauer',
      provincie: 12,
      slug: 'tauer',
    },
    {
      code: '120715107386',
      label: 'Teichland',
      provincie: 12,
      slug: 'teichland',
    },
    {
      code: '120715107401',
      label: 'Turnow-Preilack',
      provincie: 12,
      slug: 'turnow-preilack',
    },
    {
      code: '120720002002',
      label: 'Am Mellensee',
      provincie: 12,
      slug: 'am-mellensee',
    },
    {
      code: '120720014014',
      label: 'Baruth/Mark',
      provincie: 12,
      slug: 'baruth-mark',
    },
    {
      code: '120720017017',
      label: 'Blankenfelde-Mahlow',
      provincie: 12,
      slug: 'blankenfelde-mahlow',
    },
    {
      code: '120720120120',
      label: 'Großbeeren',
      provincie: 12,
      slug: 'grossbeeren',
    },
    {
      code: '120720169169',
      label: 'Jüterbog',
      provincie: 12,
      slug: 'jueterbog',
    },
    {
      code: '120720232232',
      label: 'Luckenwalde',
      provincie: 12,
      slug: 'luckenwalde',
    },
    {
      code: '120720240240',
      label: 'Ludwigsfelde',
      provincie: 12,
      slug: 'ludwigsfelde',
    },
    {
      code: '120720297297',
      label: 'Niedergörsdorf',
      provincie: 12,
      slug: 'niedergoersdorf',
    },
    {
      code: '120720312312',
      label: 'Nuthe-Urstromtal',
      provincie: 12,
      slug: 'nuthe-urstromtal',
    },
    {
      code: '120720340340',
      label: 'Rangsdorf',
      provincie: 12,
      slug: 'rangsdorf',
    },
    {
      code: '120720426426',
      label: 'Trebbin',
      provincie: 12,
      slug: 'trebbin',
    },
    {
      code: '120720477477',
      label: 'Zossen',
      provincie: 12,
      slug: 'zossen',
    },
    {
      code: '120725204053',
      label: 'Dahme/Mark',
      provincie: 12,
      slug: 'dahme-mark',
    },
    {
      code: '120725204055',
      label: 'Dahmetal',
      provincie: 12,
      slug: 'dahmetal',
    },
    {
      code: '120725204157',
      label: 'Ihlow',
      provincie: 12,
      slug: 'ihlow-gemeinde',
    },
    {
      code: '120725204298',
      label: 'Niederer Fläming',
      provincie: 12,
      slug: 'niederer-flaeming',
    },
    {
      code: '120730008008',
      label: 'Angermünde',
      provincie: 12,
      slug: 'angermuende',
    },
    {
      code: '120730069069',
      label: 'Boitzenburger Land',
      provincie: 12,
      slug: 'boitzenburger-land',
    },
    {
      code: '120730384384',
      label: 'Lychen',
      provincie: 12,
      slug: 'lychen',
    },
    {
      code: '120730429429',
      label: 'Nordwestuckermark',
      provincie: 12,
      slug: 'nordwestuckermark',
    },
    {
      code: '120730452452',
      label: 'Prenzlau',
      provincie: 12,
      slug: 'prenzlau',
    },
    {
      code: '120730572572',
      label: 'Templin',
      provincie: 12,
      slug: 'templin',
    },
    {
      code: '120730579579',
      label: 'Uckerland',
      provincie: 12,
      slug: 'uckerland',
    },
    {
      code: '120735051440',
      label: 'Pinnow',
      provincie: 12,
      slug: 'pinnow',
    },
    {
      code: '120735051532',
      label: 'Schwedt/Oder',
      provincie: 12,
      slug: 'schwedt-oder',
    },
    {
      code: '120735303085',
      label: 'Brüssow',
      provincie: 12,
      slug: 'bruessow',
    },
    {
      code: '120735303093',
      label: 'Carmzow-Wallmow',
      provincie: 12,
      slug: 'carmzow-wallmow',
    },
    {
      code: '120735303216',
      label: 'Göritz',
      provincie: 12,
      slug: 'goeritz',
    },
    {
      code: '120735303490',
      label: 'Schenkenberg',
      provincie: 12,
      slug: 'schenkenberg',
    },
    {
      code: '120735303520',
      label: 'Schönfeld',
      provincie: 12,
      slug: 'schoenfeld',
    },
    {
      code: '120735304097',
      label: 'Casekow',
      provincie: 12,
      slug: 'casekow',
    },
    {
      code: '120735304189',
      label: 'Gartz (Oder)',
      provincie: 12,
      slug: 'gartz-oder',
    },
    {
      code: '120735304309',
      label: 'Hohenselchow-Groß Pinnow',
      provincie: 12,
      slug: 'hohenselchow-gross-pinnow',
    },
    {
      code: '120735304393',
      label: 'Mescherin',
      provincie: 12,
      slug: 'mescherin',
    },
    {
      code: '120735304565',
      label: 'Tantow',
      provincie: 12,
      slug: 'tantow',
    },
    {
      code: '120735305157',
      label: 'Flieth-Stegelitz',
      provincie: 12,
      slug: 'flieth-stegelitz',
    },
    {
      code: '120735305201',
      label: 'Gerswalde',
      provincie: 12,
      slug: 'gerswalde',
    },
    {
      code: '120735305396',
      label: 'Milmersdorf',
      provincie: 12,
      slug: 'milmersdorf',
    },
    {
      code: '120735305404',
      label: 'Mittenwalde',
      provincie: 12,
      slug: 'mittenwalde-gemeinde',
    },
    {
      code: '120735305569',
      label: 'Temmen-Ringenwalde',
      provincie: 12,
      slug: 'temmen-ringenwalde',
    },
    {
      code: '120735306225',
      label: 'Gramzow',
      provincie: 12,
      slug: 'gramzow',
    },
    {
      code: '120735306261',
      label: 'Grünow',
      provincie: 12,
      slug: 'gruenow',
    },
    {
      code: '120735306430',
      label: 'Oberuckersee',
      provincie: 12,
      slug: 'oberuckersee',
    },
    {
      code: '120735306458',
      label: 'Randowtal',
      provincie: 12,
      slug: 'randowtal',
    },
    {
      code: '120735306578',
      label: 'Uckerfelde',
      provincie: 12,
      slug: 'uckerfelde',
    },
    {
      code: '120735306645',
      label: 'Zichow',
      provincie: 12,
      slug: 'zichow',
    },
    {
      code: '130030000000',
      label: 'Rostock',
      provincie: 13,
      slug: 'rostock',
    },
    {
      code: '130040000000',
      label: 'Schwerin',
      provincie: 13,
      slug: 'schwerin-stadt',
    },
    {
      code: '130710027027',
      label: 'Dargun',
      provincie: 13,
      slug: 'dargun',
    },
    {
      code: '130710029029',
      label: 'Demmin',
      provincie: 13,
      slug: 'demmin',
    },
    {
      code: '130710033033',
      label: 'Feldberger Seenlandschaft',
      provincie: 13,
      slug: 'feldberger-seenlandschaft',
    },
    {
      code: '130710107107',
      label: 'Neubrandenburg',
      provincie: 13,
      slug: 'neubrandenburg',
    },
    {
      code: '130710110110',
      label: 'Neustrelitz',
      provincie: 13,
      slug: 'neustrelitz',
    },
    {
      code: '130710156156',
      label: 'Waren (Müritz)',
      provincie: 13,
      slug: 'waren-mueritz',
    },
    {
      code: '130715151008',
      label: 'Beggerow',
      provincie: 13,
      slug: 'beggerow',
    },
    {
      code: '130715151014',
      label: 'Borrentin',
      provincie: 13,
      slug: 'borrentin',
    },
    {
      code: '130715151064',
      label: 'Hohenbollentin',
      provincie: 13,
      slug: 'hohenbollentin',
    },
    {
      code: '130715151065',
      label: 'Hohenmocker',
      provincie: 13,
      slug: 'hohenmocker',
    },
    {
      code: '130715151072',
      label: 'Kentzlin',
      provincie: 13,
      slug: 'kentzlin',
    },
    {
      code: '130715151076',
      label: 'Kletzin',
      provincie: 13,
      slug: 'kletzin',
    },
    {
      code: '130715151089',
      label: 'Lindenberg',
      provincie: 13,
      slug: 'lindenberg-gemeinde',
    },
    {
      code: '130715151096',
      label: 'Meesiger',
      provincie: 13,
      slug: 'meesiger',
    },
    {
      code: '130715151112',
      label: 'Nossendorf',
      provincie: 13,
      slug: 'nossendorf',
    },
    {
      code: '130715151128',
      label: 'Sarow',
      provincie: 13,
      slug: 'sarow',
    },
    {
      code: '130715151131',
      label: 'Schönfeld',
      provincie: 13,
      slug: 'schoenfeld-gemeinde',
    },
    {
      code: '130715151136',
      label: 'Siedenbrünzow',
      provincie: 13,
      slug: 'siedenbruenzow',
    },
    {
      code: '130715151139',
      label: 'Sommersdorf',
      provincie: 13,
      slug: 'sommersdorf',
    },
    {
      code: '130715151148',
      label: 'Utzedel',
      provincie: 13,
      slug: 'utzedel',
    },
    {
      code: '130715151150',
      label: 'Verchen',
      provincie: 13,
      slug: 'verchen',
    },
    {
      code: '130715151157',
      label: 'Warrenzin',
      provincie: 13,
      slug: 'warrenzin',
    },
    {
      code: '130715152028',
      label: 'Datzetal',
      provincie: 13,
      slug: 'datzetal',
    },
    {
      code: '130715152035',
      label: 'Friedland',
      provincie: 13,
      slug: 'friedland-stadt',
    },
    {
      code: '130715152037',
      label: 'Galenbeck',
      provincie: 13,
      slug: 'galenbeck',
    },
    {
      code: '130715153007',
      label: 'Basedow',
      provincie: 13,
      slug: 'basedow-gemeinde',
    },
    {
      code: '130715153032',
      label: 'Faulenrost',
      provincie: 13,
      slug: 'faulenrost',
    },
    {
      code: '130715153039',
      label: 'Gielow',
      provincie: 13,
      slug: 'gielow',
    },
    {
      code: '130715153084',
      label: 'Kummerow',
      provincie: 13,
      slug: 'kummerow',
    },
    {
      code: '130715153092',
      label: 'Malchin',
      provincie: 13,
      slug: 'malchin',
    },
    {
      code: '130715153109',
      label: 'Neukalen',
      provincie: 13,
      slug: 'neukalen',
    },
    {
      code: '130715154001',
      label: 'Alt Schwerin',
      provincie: 13,
      slug: 'alt-schwerin',
    },
    {
      code: '130715154036',
      label: 'Fünfseen',
      provincie: 13,
      slug: 'fuenfseen',
    },
    {
      code: '130715154043',
      label: 'Göhren-Lebbin',
      provincie: 13,
      slug: 'goehren-lebbin',
    },
    {
      code: '130715154093',
      label: 'Malchow',
      provincie: 13,
      slug: 'malchow',
    },
    {
      code: '130715154113',
      label: 'Nossentiner Hütte',
      provincie: 13,
      slug: 'nossentiner-huette',
    },
    {
      code: '130715154138',
      label: 'Silz',
      provincie: 13,
      slug: 'silz-gemeinde',
    },
    {
      code: '130715154155',
      label: 'Walow',
      provincie: 13,
      slug: 'walow',
    },
    {
      code: '130715154171',
      label: 'Zislow',
      provincie: 13,
      slug: 'zislow',
    },
    {
      code: '130715155099',
      label: 'Mirow',
      provincie: 13,
      slug: 'mirow',
    },
    {
      code: '130715155119',
      label: 'Priepert',
      provincie: 13,
      slug: 'priepert',
    },
    {
      code: '130715155159',
      label: 'Wesenberg',
      provincie: 13,
      slug: 'wesenberg-stadt',
    },
    {
      code: '130715155167',
      label: 'Wustrow',
      provincie: 13,
      slug: 'wustrow',
    },
    {
      code: '130715156011',
      label: 'Blankensee',
      provincie: 13,
      slug: 'blankensee',
    },
    {
      code: '130715156012',
      label: 'Blumenholz',
      provincie: 13,
      slug: 'blumenholz',
    },
    {
      code: '130715156025',
      label: 'Carpin',
      provincie: 13,
      slug: 'carpin',
    },
    {
      code: '130715156042',
      label: 'Godendorf',
      provincie: 13,
      slug: 'godendorf',
    },
    {
      code: '130715156058',
      label: 'Grünow',
      provincie: 13,
      slug: 'gruenow-gemeinde',
    },
    {
      code: '130715156066',
      label: 'Hohenzieritz',
      provincie: 13,
      slug: 'hohenzieritz',
    },
    {
      code: '130715156075',
      label: 'Klein Vielen',
      provincie: 13,
      slug: 'klein-vielen',
    },
    {
      code: '130715156080',
      label: 'Kratzeburg',
      provincie: 13,
      slug: 'kratzeburg',
    },
    {
      code: '130715156100',
      label: 'Möllenbeck',
      provincie: 13,
      slug: 'moellenbeck',
    },
    {
      code: '130715156147',
      label: 'Userin',
      provincie: 13,
      slug: 'userin',
    },
    {
      code: '130715156162',
      label: 'Wokuhl-Dabelow',
      provincie: 13,
      slug: 'wokuhl-dabelow',
    },
    {
      code: '130715157009',
      label: 'Beseritz',
      provincie: 13,
      slug: 'beseritz',
    },
    {
      code: '130715157010',
      label: 'Blankenhof',
      provincie: 13,
      slug: 'blankenhof',
    },
    {
      code: '130715157019',
      label: 'Brunn',
      provincie: 13,
      slug: 'brunn-gemeinde',
    },
    {
      code: '130715157104',
      label: 'Neddemin',
      provincie: 13,
      slug: 'neddemin',
    },
    {
      code: '130715157108',
      label: 'Neuenkirchen',
      provincie: 13,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '130715157111',
      label: 'Neverin',
      provincie: 13,
      slug: 'neverin',
    },
    {
      code: '130715157140',
      label: 'Sponholz',
      provincie: 13,
      slug: 'sponholz',
    },
    {
      code: '130715157141',
      label: 'Staven',
      provincie: 13,
      slug: 'staven',
    },
    {
      code: '130715157145',
      label: 'Trollenhagen',
      provincie: 13,
      slug: 'trollenhagen',
    },
    {
      code: '130715157161',
      label: 'Woggersin',
      provincie: 13,
      slug: 'woggersin',
    },
    {
      code: '130715157166',
      label: 'Wulkenzin',
      provincie: 13,
      slug: 'wulkenzin',
    },
    {
      code: '130715157170',
      label: 'Zirzow',
      provincie: 13,
      slug: 'zirzow',
    },
    {
      code: '130715158005',
      label: 'Ankershagen',
      provincie: 13,
      slug: 'ankershagen',
    },
    {
      code: '130715158101',
      label: 'Möllenhagen',
      provincie: 13,
      slug: 'moellenhagen',
    },
    {
      code: '130715158115',
      label: 'Penzlin',
      provincie: 13,
      slug: 'penzlin',
    },
    {
      code: '130715158173',
      label: 'Kuckssee',
      provincie: 13,
      slug: 'kuckssee',
    },
    {
      code: '130715159003',
      label: 'Altenhof',
      provincie: 13,
      slug: 'altenhof-gemeinde',
    },
    {
      code: '130715159013',
      label: 'Bollewick',
      provincie: 13,
      slug: 'bollewick',
    },
    {
      code: '130715159020',
      label: 'Buchholz',
      provincie: 13,
      slug: 'buchholz-gemeinde',
    },
    {
      code: '130715159023',
      label: 'Bütow',
      provincie: 13,
      slug: 'buetow',
    },
    {
      code: '130715159034',
      label: 'Fincken',
      provincie: 13,
      slug: 'fincken',
    },
    {
      code: '130715159045',
      label: 'Gotthun',
      provincie: 13,
      slug: 'gotthun',
    },
    {
      code: '130715159053',
      label: 'Groß Kelle',
      provincie: 13,
      slug: 'gross-kelle',
    },
    {
      code: '130715159073',
      label: 'Kieve',
      provincie: 13,
      slug: 'kieve',
    },
    {
      code: '130715159087',
      label: 'Lärz',
      provincie: 13,
      slug: 'laerz',
    },
    {
      code: '130715159088',
      label: 'Leizen',
      provincie: 13,
      slug: 'leizen',
    },
    {
      code: '130715159097',
      label: 'Melz',
      provincie: 13,
      slug: 'melz',
    },
    {
      code: '130715159118',
      label: 'Priborn',
      provincie: 13,
      slug: 'priborn',
    },
    {
      code: '130715159122',
      label: 'Rechlin',
      provincie: 13,
      slug: 'rechlin',
    },
    {
      code: '130715159124',
      label: 'Röbel/Müritz',
      provincie: 13,
      slug: 'roebel-mueritz',
    },
    {
      code: '130715159133',
      label: 'Schwarz',
      provincie: 13,
      slug: 'schwarz',
    },
    {
      code: '130715159137',
      label: 'Sietow',
      provincie: 13,
      slug: 'sietow',
    },
    {
      code: '130715159143',
      label: 'Stuer',
      provincie: 13,
      slug: 'stuer',
    },
    {
      code: '130715159175',
      label: 'Eldetal',
      provincie: 13,
      slug: 'eldetal',
    },
    {
      code: '130715159176',
      label: 'Südmüritz',
      provincie: 13,
      slug: 'suedmueritz',
    },
    {
      code: '130715160047',
      label: 'Grabowhöfe',
      provincie: 13,
      slug: 'grabowhoefe',
    },
    {
      code: '130715160056',
      label: 'Groß Plasten',
      provincie: 13,
      slug: 'gross-plasten',
    },
    {
      code: '130715160063',
      label: 'Hohen Wangelin',
      provincie: 13,
      slug: 'hohen-wangelin',
    },
    {
      code: '130715160069',
      label: 'Jabel',
      provincie: 13,
      slug: 'jabel',
    },
    {
      code: '130715160071',
      label: 'Kargow',
      provincie: 13,
      slug: 'kargow',
    },
    {
      code: '130715160077',
      label: 'Klink',
      provincie: 13,
      slug: 'klink',
    },
    {
      code: '130715160078',
      label: 'Klocksin',
      provincie: 13,
      slug: 'klocksin',
    },
    {
      code: '130715160103',
      label: 'Moltzow',
      provincie: 13,
      slug: 'moltzow',
    },
    {
      code: '130715160144',
      label: 'Torgelow am See',
      provincie: 13,
      slug: 'torgelow-am-see',
    },
    {
      code: '130715160154',
      label: 'Vollrathsruhe',
      provincie: 13,
      slug: 'vollrathsruhe',
    },
    {
      code: '130715160172',
      label: 'Peenehagen',
      provincie: 13,
      slug: 'peenehagen',
    },
    {
      code: '130715160174',
      label: 'Schloen-Dratow',
      provincie: 13,
      slug: 'schloen-dratow',
    },
    {
      code: '130715161021',
      label: 'Burg Stargard',
      provincie: 13,
      slug: 'burg-stargard',
    },
    {
      code: '130715161026',
      label: 'Cölpin',
      provincie: 13,
      slug: 'coelpin',
    },
    {
      code: '130715161055',
      label: 'Groß Nemerow',
      provincie: 13,
      slug: 'gross-nemerow',
    },
    {
      code: '130715161067',
      label: 'Holldorf',
      provincie: 13,
      slug: 'holldorf',
    },
    {
      code: '130715161090',
      label: 'Lindetal',
      provincie: 13,
      slug: 'lindetal',
    },
    {
      code: '130715161117',
      label: 'Pragsdorf',
      provincie: 13,
      slug: 'pragsdorf',
    },
    {
      code: '130715162015',
      label: 'Bredenfelde',
      provincie: 13,
      slug: 'bredenfelde',
    },
    {
      code: '130715162018',
      label: 'Briggow',
      provincie: 13,
      slug: 'briggow',
    },
    {
      code: '130715162048',
      label: 'Grammentin',
      provincie: 13,
      slug: 'grammentin',
    },
    {
      code: '130715162060',
      label: 'Gülzow',
      provincie: 13,
      slug: 'guelzow-gemeinde',
    },
    {
      code: '130715162068',
      label: 'Ivenack',
      provincie: 13,
      slug: 'ivenack',
    },
    {
      code: '130715162070',
      label: 'Jürgenstorf',
      provincie: 13,
      slug: 'juergenstorf',
    },
    {
      code: '130715162074',
      label: 'Kittendorf',
      provincie: 13,
      slug: 'kittendorf',
    },
    {
      code: '130715162079',
      label: 'Knorrendorf',
      provincie: 13,
      slug: 'knorrendorf',
    },
    {
      code: '130715162102',
      label: 'Mölln',
      provincie: 13,
      slug: 'moelln-gemeinde',
    },
    {
      code: '130715162123',
      label: 'Ritzerow',
      provincie: 13,
      slug: 'ritzerow',
    },
    {
      code: '130715162127',
      label: 'Rosenow',
      provincie: 13,
      slug: 'rosenow',
    },
    {
      code: '130715162142',
      label: 'Stavenhagen',
      provincie: 13,
      slug: 'stavenhagen',
    },
    {
      code: '130715162169',
      label: 'Zettemin',
      provincie: 13,
      slug: 'zettemin',
    },
    {
      code: '130715163002',
      label: 'Altenhagen',
      provincie: 13,
      slug: 'altenhagen',
    },
    {
      code: '130715163004',
      label: 'Altentreptow',
      provincie: 13,
      slug: 'altentreptow',
    },
    {
      code: '130715163006',
      label: 'Bartow',
      provincie: 13,
      slug: 'bartow',
    },
    {
      code: '130715163016',
      label: 'Breesen',
      provincie: 13,
      slug: 'breesen',
    },
    {
      code: '130715163022',
      label: 'Burow',
      provincie: 13,
      slug: 'burow',
    },
    {
      code: '130715163041',
      label: 'Gnevkow',
      provincie: 13,
      slug: 'gnevkow',
    },
    {
      code: '130715163044',
      label: 'Golchen',
      provincie: 13,
      slug: 'golchen',
    },
    {
      code: '130715163049',
      label: 'Grapzow',
      provincie: 13,
      slug: 'grapzow',
    },
    {
      code: '130715163050',
      label: 'Grischow',
      provincie: 13,
      slug: 'grischow',
    },
    {
      code: '130715163057',
      label: 'Groß Teetzleben',
      provincie: 13,
      slug: 'gross-teetzleben',
    },
    {
      code: '130715163059',
      label: 'Gültz',
      provincie: 13,
      slug: 'gueltz',
    },
    {
      code: '130715163081',
      label: 'Kriesow',
      provincie: 13,
      slug: 'kriesow',
    },
    {
      code: '130715163120',
      label: 'Pripsleben',
      provincie: 13,
      slug: 'pripsleben',
    },
    {
      code: '130715163125',
      label: 'Röckwitz',
      provincie: 13,
      slug: 'roeckwitz',
    },
    {
      code: '130715163135',
      label: 'Siedenbollentin',
      provincie: 13,
      slug: 'siedenbollentin',
    },
    {
      code: '130715163146',
      label: 'Tützpatz',
      provincie: 13,
      slug: 'tuetzpatz',
    },
    {
      code: '130715163158',
      label: 'Werder',
      provincie: 13,
      slug: 'werder',
    },
    {
      code: '130715163160',
      label: 'Wildberg',
      provincie: 13,
      slug: 'wildberg-gemeinde',
    },
    {
      code: '130715163163',
      label: 'Wolde',
      provincie: 13,
      slug: 'wolde',
    },
    {
      code: '130715164054',
      label: 'Groß Miltzow',
      provincie: 13,
      slug: 'gross-miltzow',
    },
    {
      code: '130715164083',
      label: 'Kublank',
      provincie: 13,
      slug: 'kublank',
    },
    {
      code: '130715164105',
      label: 'Neetzka',
      provincie: 13,
      slug: 'neetzka',
    },
    {
      code: '130715164130',
      label: 'Schönbeck',
      provincie: 13,
      slug: 'schoenbeck',
    },
    {
      code: '130715164132',
      label: 'Schönhausen',
      provincie: 13,
      slug: 'schoenhausen',
    },
    {
      code: '130715164153',
      label: 'Voigtsdorf',
      provincie: 13,
      slug: 'voigtsdorf',
    },
    {
      code: '130715164164',
      label: 'Woldegk',
      provincie: 13,
      slug: 'woldegk',
    },
    {
      code: '130720006006',
      label: 'Bad Doberan',
      provincie: 13,
      slug: 'bad-doberan',
    },
    {
      code: '130720029029',
      label: 'Dummerstorf',
      provincie: 13,
      slug: 'dummerstorf',
    },
    {
      code: '130720036036',
      label: 'Graal-Müritz',
      provincie: 13,
      slug: 'graal-mueritz',
    },
    {
      code: '130720043043',
      label: 'Güstrow',
      provincie: 13,
      slug: 'guestrow',
    },
    {
      code: '130720058058',
      label: 'Kröpelin',
      provincie: 13,
      slug: 'kroepelin',
    },
    {
      code: '130720060060',
      label: 'Kühlungsborn',
      provincie: 13,
      slug: 'kuehlungsborn',
    },
    {
      code: '130720074074',
      label: 'Neubukow',
      provincie: 13,
      slug: 'neubukow',
    },
    {
      code: '130720091091',
      label: 'Sanitz',
      provincie: 13,
      slug: 'sanitz',
    },
    {
      code: '130720093093',
      label: 'Satow',
      provincie: 13,
      slug: 'satow',
    },
    {
      code: '130720106106',
      label: 'Teterow',
      provincie: 13,
      slug: 'teterow',
    },
    {
      code: '130725251001',
      label: 'Admannshagen-Bargeshagen',
      provincie: 13,
      slug: 'admannshagen-bargeshagen',
    },
    {
      code: '130725251007',
      label: 'Bartenshagen-Parkentin',
      provincie: 13,
      slug: 'bartenshagen-parkentin',
    },
    {
      code: '130725251017',
      label: 'Börgerende-Rethwisch',
      provincie: 13,
      slug: 'boergerende-rethwisch',
    },
    {
      code: '130725251047',
      label: 'Hohenfelde',
      provincie: 13,
      slug: 'hohenfelde-gemeinde',
    },
    {
      code: '130725251075',
      label: 'Nienhagen',
      provincie: 13,
      slug: 'nienhagen-gemeinde',
    },
    {
      code: '130725251083',
      label: 'Reddelich',
      provincie: 13,
      slug: 'reddelich',
    },
    {
      code: '130725251086',
      label: 'Retschow',
      provincie: 13,
      slug: 'retschow',
    },
    {
      code: '130725251099',
      label: 'Steffenshagen',
      provincie: 13,
      slug: 'steffenshagen',
    },
    {
      code: '130725251117',
      label: 'Wittenbeck',
      provincie: 13,
      slug: 'wittenbeck',
    },
    {
      code: '130725252009',
      label: 'Baumgarten',
      provincie: 13,
      slug: 'baumgarten',
    },
    {
      code: '130725252013',
      label: 'Bernitt',
      provincie: 13,
      slug: 'bernitt',
    },
    {
      code: '130725252020',
      label: 'Bützow',
      provincie: 13,
      slug: 'buetzow',
    },
    {
      code: '130725252028',
      label: 'Dreetz',
      provincie: 13,
      slug: 'dreetz-gemeinde',
    },
    {
      code: '130725252050',
      label: 'Jürgenshagen',
      provincie: 13,
      slug: 'juergenshagen',
    },
    {
      code: '130725252053',
      label: 'Klein Belitz',
      provincie: 13,
      slug: 'klein-belitz',
    },
    {
      code: '130725252078',
      label: 'Penzin',
      provincie: 13,
      slug: 'penzin',
    },
    {
      code: '130725252089',
      label: 'Rühn',
      provincie: 13,
      slug: 'ruehn',
    },
    {
      code: '130725252101',
      label: 'Steinhagen',
      provincie: 13,
      slug: 'steinhagen-gemeinde',
    },
    {
      code: '130725252104',
      label: 'Tarnow',
      provincie: 13,
      slug: 'tarnow',
    },
    {
      code: '130725252114',
      label: 'Warnow',
      provincie: 13,
      slug: 'warnow',
    },
    {
      code: '130725252120',
      label: 'Zepelin',
      provincie: 13,
      slug: 'zepelin',
    },
    {
      code: '130725253019',
      label: 'Broderstorf',
      provincie: 13,
      slug: 'broderstorf',
    },
    {
      code: '130725253081',
      label: 'Poppendorf',
      provincie: 13,
      slug: 'poppendorf',
    },
    {
      code: '130725253087',
      label: 'Roggentin',
      provincie: 13,
      slug: 'roggentin',
    },
    {
      code: '130725253108',
      label: 'Thulendorf',
      provincie: 13,
      slug: 'thulendorf',
    },
    {
      code: '130725254004',
      label: 'Altkalen',
      provincie: 13,
      slug: 'altkalen',
    },
    {
      code: '130725254010',
      label: 'Behren-Lübchin',
      provincie: 13,
      slug: 'behren-luebchin',
    },
    {
      code: '130725254031',
      label: 'Finkenthal',
      provincie: 13,
      slug: 'finkenthal',
    },
    {
      code: '130725254035',
      label: 'Gnoien',
      provincie: 13,
      slug: 'gnoien',
    },
    {
      code: '130725254111',
      label: 'Walkendorf',
      provincie: 13,
      slug: 'walkendorf',
    },
    {
      code: '130725255033',
      label: 'Glasewitz',
      provincie: 13,
      slug: 'glasewitz',
    },
    {
      code: '130725255039',
      label: 'Groß Schwiesow',
      provincie: 13,
      slug: 'gross-schwiesow',
    },
    {
      code: '130725255042',
      label: 'Gülzow-Prüzen',
      provincie: 13,
      slug: 'guelzow-pruezen',
    },
    {
      code: '130725255044',
      label: 'Gutow',
      provincie: 13,
      slug: 'gutow',
    },
    {
      code: '130725255055',
      label: 'Klein Upahl',
      provincie: 13,
      slug: 'klein-upahl',
    },
    {
      code: '130725255061',
      label: 'Kuhs',
      provincie: 13,
      slug: 'kuhs',
    },
    {
      code: '130725255067',
      label: 'Lohmen',
      provincie: 13,
      slug: 'lohmen',
    },
    {
      code: '130725255069',
      label: 'Lüssow',
      provincie: 13,
      slug: 'luessow',
    },
    {
      code: '130725255071',
      label: 'Mistorf',
      provincie: 13,
      slug: 'mistorf',
    },
    {
      code: '130725255073',
      label: 'Mühl Rosin',
      provincie: 13,
      slug: 'muehl-rosin',
    },
    {
      code: '130725255079',
      label: 'Plaaz',
      provincie: 13,
      slug: 'plaaz',
    },
    {
      code: '130725255084',
      label: 'Reimershagen',
      provincie: 13,
      slug: 'reimershagen',
    },
    {
      code: '130725255092',
      label: 'Sarmstorf',
      provincie: 13,
      slug: 'sarmstorf',
    },
    {
      code: '130725255119',
      label: 'Zehna',
      provincie: 13,
      slug: 'zehna',
    },
    {
      code: '130725256026',
      label: 'Dobbin-Linstow',
      provincie: 13,
      slug: 'dobbin-linstow',
    },
    {
      code: '130725256048',
      label: 'Hoppenrade',
      provincie: 13,
      slug: 'hoppenrade',
    },
    {
      code: '130725256056',
      label: 'Krakow am See',
      provincie: 13,
      slug: 'krakow-am-see',
    },
    {
      code: '130725256059',
      label: 'Kuchelmiß',
      provincie: 13,
      slug: 'kuchelmiss',
    },
    {
      code: '130725256063',
      label: 'Lalendorf',
      provincie: 13,
      slug: 'lalendorf',
    },
    {
      code: '130725257027',
      label: 'Dolgen am See',
      provincie: 13,
      slug: 'dolgen-am-see',
    },
    {
      code: '130725257046',
      label: 'Hohen Sprenz',
      provincie: 13,
      slug: 'hohen-sprenz',
    },
    {
      code: '130725257062',
      label: 'Laage',
      provincie: 13,
      slug: 'laage',
    },
    {
      code: '130725257112',
      label: 'Wardow',
      provincie: 13,
      slug: 'wardow',
    },
    {
      code: '130725258003',
      label: 'Alt Sührkow',
      provincie: 13,
      slug: 'alt-suehrkow',
    },
    {
      code: '130725258023',
      label: 'Dahmen',
      provincie: 13,
      slug: 'dahmen',
    },
    {
      code: '130725258024',
      label: 'Dalkendorf',
      provincie: 13,
      slug: 'dalkendorf',
    },
    {
      code: '130725258038',
      label: 'Groß Roge',
      provincie: 13,
      slug: 'gross-roge',
    },
    {
      code: '130725258040',
      label: 'Groß Wokern',
      provincie: 13,
      slug: 'gross-wokern',
    },
    {
      code: '130725258041',
      label: 'Groß Wüstenfelde',
      provincie: 13,
      slug: 'gross-wuestenfelde',
    },
    {
      code: '130725258045',
      label: 'Hohen Demzin',
      provincie: 13,
      slug: 'hohen-demzin',
    },
    {
      code: '130725258049',
      label: 'Jördenstorf',
      provincie: 13,
      slug: 'joerdenstorf',
    },
    {
      code: '130725258066',
      label: 'Lelkendorf',
      provincie: 13,
      slug: 'lelkendorf',
    },
    {
      code: '130725258082',
      label: 'Prebberede',
      provincie: 13,
      slug: 'prebberede',
    },
    {
      code: '130725258094',
      label: 'Schorssow',
      provincie: 13,
      slug: 'schorssow',
    },
    {
      code: '130725258096',
      label: 'Schwasdorf',
      provincie: 13,
      slug: 'schwasdorf',
    },
    {
      code: '130725258103',
      label: 'Sukow-Levitzow',
      provincie: 13,
      slug: 'sukow-levitzow',
    },
    {
      code: '130725258109',
      label: 'Thürkow',
      provincie: 13,
      slug: 'thuerkow',
    },
    {
      code: '130725258113',
      label: 'Warnkenhagen',
      provincie: 13,
      slug: 'warnkenhagen',
    },
    {
      code: '130725259002',
      label: 'Alt Bukow',
      provincie: 13,
      slug: 'alt-bukow',
    },
    {
      code: '130725259005',
      label: 'Am Salzhaff',
      provincie: 13,
      slug: 'am-salzhaff',
    },
    {
      code: '130725259008',
      label: 'Bastorf',
      provincie: 13,
      slug: 'bastorf',
    },
    {
      code: '130725259014',
      label: 'Biendorf',
      provincie: 13,
      slug: 'biendorf',
    },
    {
      code: '130725259022',
      label: 'Carinerland',
      provincie: 13,
      slug: 'carinerland',
    },
    {
      code: '130725259085',
      label: 'Rerik',
      provincie: 13,
      slug: 'rerik',
    },
    {
      code: '130725260012',
      label: 'Bentwisch',
      provincie: 13,
      slug: 'bentwisch',
    },
    {
      code: '130725260015',
      label: 'Blankenhagen',
      provincie: 13,
      slug: 'blankenhagen',
    },
    {
      code: '130725260032',
      label: 'Gelbensande',
      provincie: 13,
      slug: 'gelbensande',
    },
    {
      code: '130725260072',
      label: 'Mönchhagen',
      provincie: 13,
      slug: 'moenchhagen',
    },
    {
      code: '130725260088',
      label: 'Rövershagen',
      provincie: 13,
      slug: 'roevershagen',
    },
    {
      code: '130725261011',
      label: 'Benitz',
      provincie: 13,
      slug: 'benitz',
    },
    {
      code: '130725261018',
      label: 'Bröbberow',
      provincie: 13,
      slug: 'broebberow',
    },
    {
      code: '130725261051',
      label: 'Kassow',
      provincie: 13,
      slug: 'kassow',
    },
    {
      code: '130725261090',
      label: 'Rukieten',
      provincie: 13,
      slug: 'rukieten',
    },
    {
      code: '130725261095',
      label: 'Schwaan',
      provincie: 13,
      slug: 'schwaan',
    },
    {
      code: '130725261110',
      label: 'Vorbeck',
      provincie: 13,
      slug: 'vorbeck',
    },
    {
      code: '130725261116',
      label: 'Wiendorf',
      provincie: 13,
      slug: 'wiendorf',
    },
    {
      code: '130725262021',
      label: 'Cammin',
      provincie: 13,
      slug: 'cammin',
    },
    {
      code: '130725262034',
      label: 'Gnewitz',
      provincie: 13,
      slug: 'gnewitz',
    },
    {
      code: '130725262037',
      label: 'Grammow',
      provincie: 13,
      slug: 'grammow',
    },
    {
      code: '130725262076',
      label: 'Nustrow',
      provincie: 13,
      slug: 'nustrow',
    },
    {
      code: '130725262097',
      label: 'Selpin',
      provincie: 13,
      slug: 'selpin',
    },
    {
      code: '130725262102',
      label: 'Stubbendorf',
      provincie: 13,
      slug: 'stubbendorf',
    },
    {
      code: '130725262105',
      label: 'Tessin',
      provincie: 13,
      slug: 'tessin',
    },
    {
      code: '130725262107',
      label: 'Thelkow',
      provincie: 13,
      slug: 'thelkow',
    },
    {
      code: '130725262118',
      label: 'Zarnewanz',
      provincie: 13,
      slug: 'zarnewanz',
    },
    {
      code: '130725263030',
      label: 'Elmenhorst/Lichtenhagen',
      provincie: 13,
      slug: 'elmenhorst-lichtenhagen',
    },
    {
      code: '130725263057',
      label: 'Kritzmow',
      provincie: 13,
      slug: 'kritzmow',
    },
    {
      code: '130725263064',
      label: 'Lambrechtshagen',
      provincie: 13,
      slug: 'lambrechtshagen',
    },
    {
      code: '130725263077',
      label: 'Papendorf',
      provincie: 13,
      slug: 'papendorf',
    },
    {
      code: '130725263080',
      label: 'Pölchow',
      provincie: 13,
      slug: 'poelchow',
    },
    {
      code: '130725263098',
      label: 'Stäbelow',
      provincie: 13,
      slug: 'staebelow',
    },
    {
      code: '130725263121',
      label: 'Ziesendorf',
      provincie: 13,
      slug: 'ziesendorf',
    },
    {
      code: '130730011011',
      label: 'Binz',
      provincie: 13,
      slug: 'binz',
    },
    {
      code: '130730035035',
      label: 'Grimmen',
      provincie: 13,
      slug: 'grimmen',
    },
    {
      code: '130730055055',
      label: 'Marlow',
      provincie: 13,
      slug: 'marlow',
    },
    {
      code: '130730070070',
      label: 'Putbus',
      provincie: 13,
      slug: 'putbus',
    },
    {
      code: '130730080080',
      label: 'Sassnitz',
      provincie: 13,
      slug: 'sassnitz',
    },
    {
      code: '130730088088',
      label: 'Stralsund',
      provincie: 13,
      slug: 'stralsund',
    },
    {
      code: '130730089089',
      label: 'Süderholz',
      provincie: 13,
      slug: 'suederholz',
    },
    {
      code: '130730105105',
      label: 'Zingst',
      provincie: 13,
      slug: 'zingst',
    },
    {
      code: '130735351005',
      label: 'Altenpleen',
      provincie: 13,
      slug: 'altenpleen',
    },
    {
      code: '130735351037',
      label: 'Groß Mohrdorf',
      provincie: 13,
      slug: 'gross-mohrdorf',
    },
    {
      code: '130735351044',
      label: 'Klausdorf',
      provincie: 13,
      slug: 'klausdorf',
    },
    {
      code: '130735351046',
      label: 'Kramerhof',
      provincie: 13,
      slug: 'kramerhof',
    },
    {
      code: '130735351066',
      label: 'Preetz',
      provincie: 13,
      slug: 'preetz-gemeinde',
    },
    {
      code: '130735351068',
      label: 'Prohn',
      provincie: 13,
      slug: 'prohn',
    },
    {
      code: '130735352009',
      label: 'Barth',
      provincie: 13,
      slug: 'barth',
    },
    {
      code: '130735352018',
      label: 'Divitz-Spoldershagen',
      provincie: 13,
      slug: 'divitz-spoldershagen',
    },
    {
      code: '130735352025',
      label: 'Fuhlendorf',
      provincie: 13,
      slug: 'fuhlendorf-gemeinde',
    },
    {
      code: '130735352042',
      label: 'Karnin',
      provincie: 13,
      slug: 'karnin',
    },
    {
      code: '130735352043',
      label: 'Kenz-Küstrow',
      provincie: 13,
      slug: 'kenz-kuestrow',
    },
    {
      code: '130735352051',
      label: 'Löbnitz',
      provincie: 13,
      slug: 'loebnitz',
    },
    {
      code: '130735352053',
      label: 'Lüdershagen',
      provincie: 13,
      slug: 'luedershagen',
    },
    {
      code: '130735352069',
      label: 'Pruchten',
      provincie: 13,
      slug: 'pruchten',
    },
    {
      code: '130735352077',
      label: 'Saal',
      provincie: 13,
      slug: 'saal',
    },
    {
      code: '130735352094',
      label: 'Trinwillershagen',
      provincie: 13,
      slug: 'trinwillershagen',
    },
    {
      code: '130735353010',
      label: 'Bergen auf Rügen',
      provincie: 13,
      slug: 'bergen-auf-ruegen',
    },
    {
      code: '130735353014',
      label: 'Buschvitz',
      provincie: 13,
      slug: 'buschvitz',
    },
    {
      code: '130735353027',
      label: 'Garz/Rügen',
      provincie: 13,
      slug: 'garz-ruegen',
    },
    {
      code: '130735353038',
      label: 'Gustow',
      provincie: 13,
      slug: 'gustow',
    },
    {
      code: '130735353049',
      label: 'Lietzow',
      provincie: 13,
      slug: 'lietzow',
    },
    {
      code: '130735353063',
      label: 'Parchtitz',
      provincie: 13,
      slug: 'parchtitz',
    },
    {
      code: '130735353064',
      label: 'Patzig',
      provincie: 13,
      slug: 'patzig',
    },
    {
      code: '130735353065',
      label: 'Poseritz',
      provincie: 13,
      slug: 'poseritz',
    },
    {
      code: '130735353072',
      label: 'Ralswiek',
      provincie: 13,
      slug: 'ralswiek',
    },
    {
      code: '130735353074',
      label: 'Rappin',
      provincie: 13,
      slug: 'rappin',
    },
    {
      code: '130735353083',
      label: 'Sehlen',
      provincie: 13,
      slug: 'sehlen',
    },
    {
      code: '130735354002',
      label: 'Ahrenshoop',
      provincie: 13,
      slug: 'ahrenshoop',
    },
    {
      code: '130735354012',
      label: 'Born a.Darß',
      provincie: 13,
      slug: 'born-a-darss',
    },
    {
      code: '130735354017',
      label: 'Dierhagen',
      provincie: 13,
      slug: 'dierhagen',
    },
    {
      code: '130735354067',
      label: 'Prerow',
      provincie: 13,
      slug: 'prerow',
    },
    {
      code: '130735354100',
      label: 'Wieck a.Darß',
      provincie: 13,
      slug: 'wieck-a-darss',
    },
    {
      code: '130735354103',
      label: 'Wustrow',
      provincie: 13,
      slug: 'wustrow-gemeinde',
    },
    {
      code: '130735355024',
      label: 'Franzburg',
      provincie: 13,
      slug: 'franzburg',
    },
    {
      code: '130735355029',
      label: 'Glewitz',
      provincie: 13,
      slug: 'glewitz',
    },
    {
      code: '130735355034',
      label: 'Gremersdorf-Buchholz',
      provincie: 13,
      slug: 'gremersdorf-buchholz',
    },
    {
      code: '130735355057',
      label: 'Millienhagen-Oebelitz',
      provincie: 13,
      slug: 'millienhagen-oebelitz',
    },
    {
      code: '130735355062',
      label: 'Papenhagen',
      provincie: 13,
      slug: 'papenhagen',
    },
    {
      code: '130735355076',
      label: 'Richtenberg',
      provincie: 13,
      slug: 'richtenberg',
    },
    {
      code: '130735355086',
      label: 'Splietsdorf',
      provincie: 13,
      slug: 'splietsdorf',
    },
    {
      code: '130735355096',
      label: 'Velgast',
      provincie: 13,
      slug: 'velgast',
    },
    {
      code: '130735355097',
      label: 'Weitenhagen',
      provincie: 13,
      slug: 'weitenhagen',
    },
    {
      code: '130735355098',
      label: 'Wendisch Baggendorf',
      provincie: 13,
      slug: 'wendisch-baggendorf',
    },
    {
      code: '130735356023',
      label: 'Elmenhorst',
      provincie: 13,
      slug: 'elmenhorst-gemeinde',
    },
    {
      code: '130735356090',
      label: 'Sundhagen',
      provincie: 13,
      slug: 'sundhagen',
    },
    {
      code: '130735356102',
      label: 'Wittenhagen',
      provincie: 13,
      slug: 'wittenhagen',
    },
    {
      code: '130735357006',
      label: 'Baabe',
      provincie: 13,
      slug: 'baabe',
    },
    {
      code: '130735357031',
      label: 'Göhren',
      provincie: 13,
      slug: 'goehren',
    },
    {
      code: '130735357048',
      label: 'Lancken-Granitz',
      provincie: 13,
      slug: 'lancken-granitz',
    },
    {
      code: '130735357084',
      label: 'Sellin',
      provincie: 13,
      slug: 'sellin',
    },
    {
      code: '130735357106',
      label: 'Zirkow',
      provincie: 13,
      slug: 'zirkow',
    },
    {
      code: '130735357107',
      label: 'Mönchgut',
      provincie: 13,
      slug: 'moenchgut',
    },
    {
      code: '130735358036',
      label: 'Groß Kordshagen',
      provincie: 13,
      slug: 'gross-kordshagen',
    },
    {
      code: '130735358041',
      label: 'Jakobsdorf',
      provincie: 13,
      slug: 'jakobsdorf',
    },
    {
      code: '130735358054',
      label: 'Lüssow',
      provincie: 13,
      slug: 'luessow-gemeinde',
    },
    {
      code: '130735358060',
      label: 'Niepars',
      provincie: 13,
      slug: 'niepars',
    },
    {
      code: '130735358061',
      label: 'Pantelitz',
      provincie: 13,
      slug: 'pantelitz',
    },
    {
      code: '130735358087',
      label: 'Steinhagen',
      provincie: 13,
      slug: 'steinhagen-gemeinde',
    },
    {
      code: '130735358099',
      label: 'Wendorf',
      provincie: 13,
      slug: 'wendorf',
    },
    {
      code: '130735358104',
      label: 'Zarrendorf',
      provincie: 13,
      slug: 'zarrendorf',
    },
    {
      code: '130735359004',
      label: 'Altenkirchen',
      provincie: 13,
      slug: 'altenkirchen-gemeinde',
    },
    {
      code: '130735359013',
      label: 'Breege',
      provincie: 13,
      slug: 'breege',
    },
    {
      code: '130735359019',
      label: 'Dranske',
      provincie: 13,
      slug: 'dranske',
    },
    {
      code: '130735359030',
      label: 'Glowe',
      provincie: 13,
      slug: 'glowe',
    },
    {
      code: '130735359052',
      label: 'Lohme',
      provincie: 13,
      slug: 'lohme',
    },
    {
      code: '130735359071',
      label: 'Putgarten',
      provincie: 13,
      slug: 'putgarten',
    },
    {
      code: '130735359078',
      label: 'Sagard',
      provincie: 13,
      slug: 'sagard',
    },
    {
      code: '130735359101',
      label: 'Wiek',
      provincie: 13,
      slug: 'wiek',
    },
    {
      code: '130735360007',
      label: 'Bad Sülze',
      provincie: 13,
      slug: 'bad-suelze',
    },
    {
      code: '130735360015',
      label: 'Dettmannsdorf',
      provincie: 13,
      slug: 'dettmannsdorf',
    },
    {
      code: '130735360016',
      label: 'Deyelsdorf',
      provincie: 13,
      slug: 'deyelsdorf',
    },
    {
      code: '130735360020',
      label: 'Drechow',
      provincie: 13,
      slug: 'drechow',
    },
    {
      code: '130735360022',
      label: 'Eixen',
      provincie: 13,
      slug: 'eixen',
    },
    {
      code: '130735360032',
      label: 'Grammendorf',
      provincie: 13,
      slug: 'grammendorf',
    },
    {
      code: '130735360033',
      label: 'Gransebieth',
      provincie: 13,
      slug: 'gransebieth',
    },
    {
      code: '130735360039',
      label: 'Hugoldsdorf',
      provincie: 13,
      slug: 'hugoldsdorf',
    },
    {
      code: '130735360050',
      label: 'Lindholz',
      provincie: 13,
      slug: 'lindholz',
    },
    {
      code: '130735360093',
      label: 'Tribsees',
      provincie: 13,
      slug: 'tribsees',
    },
    {
      code: '130735361001',
      label: 'Ahrenshagen-Daskow',
      provincie: 13,
      slug: 'ahrenshagen-daskow',
    },
    {
      code: '130735361075',
      label: 'Ribnitz-Damgarten',
      provincie: 13,
      slug: 'ribnitz-damgarten',
    },
    {
      code: '130735361082',
      label: 'Schlemmin',
      provincie: 13,
      slug: 'schlemmin',
    },
    {
      code: '130735361085',
      label: 'Semlow',
      provincie: 13,
      slug: 'semlow',
    },
    {
      code: '130735362003',
      label: 'Altefähr',
      provincie: 13,
      slug: 'altefaehr',
    },
    {
      code: '130735362021',
      label: 'Dreschvitz',
      provincie: 13,
      slug: 'dreschvitz',
    },
    {
      code: '130735362028',
      label: 'Gingst',
      provincie: 13,
      slug: 'gingst',
    },
    {
      code: '130735362040',
      label: 'Insel Hiddensee',
      provincie: 13,
      slug: 'insel-hiddensee',
    },
    {
      code: '130735362045',
      label: 'Kluis',
      provincie: 13,
      slug: 'kluis',
    },
    {
      code: '130735362059',
      label: 'Neuenkirchen',
      provincie: 13,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '130735362073',
      label: 'Rambin',
      provincie: 13,
      slug: 'rambin',
    },
    {
      code: '130735362079',
      label: 'Samtens',
      provincie: 13,
      slug: 'samtens',
    },
    {
      code: '130735362081',
      label: 'Schaprode',
      provincie: 13,
      slug: 'schaprode',
    },
    {
      code: '130735362092',
      label: 'Trent',
      provincie: 13,
      slug: 'trent',
    },
    {
      code: '130735362095',
      label: 'Ummanz',
      provincie: 13,
      slug: 'ummanz',
    },
    {
      code: '130740026026',
      label: 'Grevesmühlen',
      provincie: 13,
      slug: 'grevesmuehlen',
    },
    {
      code: '130740035035',
      label: 'Insel Poel',
      provincie: 13,
      slug: 'insel-poel',
    },
    {
      code: '130740087087',
      label: 'Wismar',
      provincie: 13,
      slug: 'wismar',
    },
    {
      code: '130745451002',
      label: 'Bad Kleinen',
      provincie: 13,
      slug: 'bad-kleinen',
    },
    {
      code: '130745451003',
      label: 'Barnekow',
      provincie: 13,
      slug: 'barnekow',
    },
    {
      code: '130745451008',
      label: 'Bobitz',
      provincie: 13,
      slug: 'bobitz',
    },
    {
      code: '130745451019',
      label: 'Dorf Mecklenburg',
      provincie: 13,
      slug: 'dorf-mecklenburg',
    },
    {
      code: '130745451030',
      label: 'Groß Stieten',
      provincie: 13,
      slug: 'gross-stieten',
    },
    {
      code: '130745451031',
      label: 'Hohen Viecheln',
      provincie: 13,
      slug: 'hohen-viecheln',
    },
    {
      code: '130745451047',
      label: 'Lübow',
      provincie: 13,
      slug: 'luebow',
    },
    {
      code: '130745451053',
      label: 'Metelsdorf',
      provincie: 13,
      slug: 'metelsdorf',
    },
    {
      code: '130745451082',
      label: 'Ventschow',
      provincie: 13,
      slug: 'ventschow',
    },
    {
      code: '130745452020',
      label: 'Dragun',
      provincie: 13,
      slug: 'dragun',
    },
    {
      code: '130745452021',
      label: 'Gadebusch',
      provincie: 13,
      slug: 'gadebusch',
    },
    {
      code: '130745452040',
      label: 'Kneese',
      provincie: 13,
      slug: 'kneese',
    },
    {
      code: '130745452043',
      label: 'Krembz',
      provincie: 13,
      slug: 'krembz',
    },
    {
      code: '130745452054',
      label: 'Mühlen Eichsen',
      provincie: 13,
      slug: 'muehlen-eichsen',
    },
    {
      code: '130745452068',
      label: 'Roggendorf',
      provincie: 13,
      slug: 'roggendorf',
    },
    {
      code: '130745452070',
      label: 'Rögnitz',
      provincie: 13,
      slug: 'roegnitz',
    },
    {
      code: '130745452081',
      label: 'Veelböken',
      provincie: 13,
      slug: 'veelboeken',
    },
    {
      code: '130745453005',
      label: 'Bernstorf',
      provincie: 13,
      slug: 'bernstorf',
    },
    {
      code: '130745453022',
      label: 'Gägelow',
      provincie: 13,
      slug: 'gaegelow',
    },
    {
      code: '130745453069',
      label: 'Roggenstorf',
      provincie: 13,
      slug: 'roggenstorf',
    },
    {
      code: '130745453071',
      label: 'Rüting',
      provincie: 13,
      slug: 'rueting',
    },
    {
      code: '130745453077',
      label: 'Testorf-Steinfort',
      provincie: 13,
      slug: 'testorf-steinfort',
    },
    {
      code: '130745453079',
      label: 'Upahl',
      provincie: 13,
      slug: 'upahl',
    },
    {
      code: '130745453085',
      label: 'Warnow',
      provincie: 13,
      slug: 'warnow-gemeinde',
    },
    {
      code: '130745453093',
      label: 'Stepenitztal',
      provincie: 13,
      slug: 'stepenitztal',
    },
    {
      code: '130745454010',
      label: 'Boltenhagen',
      provincie: 13,
      slug: 'boltenhagen',
    },
    {
      code: '130745454016',
      label: 'Damshagen',
      provincie: 13,
      slug: 'damshagen',
    },
    {
      code: '130745454032',
      label: 'Hohenkirchen',
      provincie: 13,
      slug: 'hohenkirchen',
    },
    {
      code: '130745454037',
      label: 'Kalkhorst',
      provincie: 13,
      slug: 'kalkhorst',
    },
    {
      code: '130745454039',
      label: 'Klütz',
      provincie: 13,
      slug: 'kluetz',
    },
    {
      code: '130745454089',
      label: 'Zierow',
      provincie: 13,
      slug: 'zierow',
    },
    {
      code: '130745455001',
      label: 'Alt Meteln',
      provincie: 13,
      slug: 'alt-meteln',
    },
    {
      code: '130745455012',
      label: 'Brüsewitz',
      provincie: 13,
      slug: 'bruesewitz',
    },
    {
      code: '130745455014',
      label: 'Cramonshagen',
      provincie: 13,
      slug: 'cramonshagen',
    },
    {
      code: '130745455015',
      label: 'Dalberg-Wendelstorf',
      provincie: 13,
      slug: 'dalberg-wendelstorf',
    },
    {
      code: '130745455024',
      label: 'Gottesgabe',
      provincie: 13,
      slug: 'gottesgabe',
    },
    {
      code: '130745455025',
      label: 'Grambow',
      provincie: 13,
      slug: 'grambow',
    },
    {
      code: '130745455038',
      label: 'Klein Trebbow',
      provincie: 13,
      slug: 'klein-trebbow',
    },
    {
      code: '130745455048',
      label: 'Lübstorf',
      provincie: 13,
      slug: 'luebstorf',
    },
    {
      code: '130745455050',
      label: 'Lützow',
      provincie: 13,
      slug: 'luetzow',
    },
    {
      code: '130745455061',
      label: 'Perlin',
      provincie: 13,
      slug: 'perlin',
    },
    {
      code: '130745455062',
      label: 'Pingelshagen',
      provincie: 13,
      slug: 'pingelshagen',
    },
    {
      code: '130745455064',
      label: 'Pokrent',
      provincie: 13,
      slug: 'pokrent',
    },
    {
      code: '130745455072',
      label: 'Schildetal',
      provincie: 13,
      slug: 'schildetal',
    },
    {
      code: '130745455075',
      label: 'Seehof',
      provincie: 13,
      slug: 'seehof',
    },
    {
      code: '130745455088',
      label: 'Zickhusen',
      provincie: 13,
      slug: 'zickhusen',
    },
    {
      code: '130745456004',
      label: 'Benz',
      provincie: 13,
      slug: 'benz',
    },
    {
      code: '130745456007',
      label: 'Blowatz',
      provincie: 13,
      slug: 'blowatz',
    },
    {
      code: '130745456009',
      label: 'Boiensdorf',
      provincie: 13,
      slug: 'boiensdorf',
    },
    {
      code: '130745456034',
      label: 'Hornstorf',
      provincie: 13,
      slug: 'hornstorf',
    },
    {
      code: '130745456044',
      label: 'Krusenhagen',
      provincie: 13,
      slug: 'krusenhagen',
    },
    {
      code: '130745456056',
      label: 'Neuburg',
      provincie: 13,
      slug: 'neuburg',
    },
    {
      code: '130745457006',
      label: 'Bibow',
      provincie: 13,
      slug: 'bibow',
    },
    {
      code: '130745457023',
      label: 'Glasin',
      provincie: 13,
      slug: 'glasin',
    },
    {
      code: '130745457036',
      label: 'Jesendorf',
      provincie: 13,
      slug: 'jesendorf',
    },
    {
      code: '130745457046',
      label: 'Lübberstorf',
      provincie: 13,
      slug: 'luebberstorf',
    },
    {
      code: '130745457057',
      label: 'Neukloster',
      provincie: 13,
      slug: 'neukloster',
    },
    {
      code: '130745457060',
      label: 'Passee',
      provincie: 13,
      slug: 'passee',
    },
    {
      code: '130745457084',
      label: 'Warin',
      provincie: 13,
      slug: 'warin',
    },
    {
      code: '130745457090',
      label: 'Zurow',
      provincie: 13,
      slug: 'zurow',
    },
    {
      code: '130745457091',
      label: 'Züsow',
      provincie: 13,
      slug: 'zuesow',
    },
    {
      code: '130745458013',
      label: 'Carlow',
      provincie: 13,
      slug: 'carlow',
    },
    {
      code: '130745458018',
      label: 'Dechow',
      provincie: 13,
      slug: 'dechow',
    },
    {
      code: '130745458028',
      label: 'Groß Molzahn',
      provincie: 13,
      slug: 'gross-molzahn',
    },
    {
      code: '130745458033',
      label: 'Holdorf',
      provincie: 13,
      slug: 'holdorf-gemeinde',
    },
    {
      code: '130745458042',
      label: 'Königsfeld',
      provincie: 13,
      slug: 'koenigsfeld-gemeinde',
    },
    {
      code: '130745458065',
      label: 'Rehna',
      provincie: 13,
      slug: 'rehna',
    },
    {
      code: '130745458066',
      label: 'Rieps',
      provincie: 13,
      slug: 'rieps',
    },
    {
      code: '130745458073',
      label: 'Schlagsdorf',
      provincie: 13,
      slug: 'schlagsdorf',
    },
    {
      code: '130745458078',
      label: 'Thandorf',
      provincie: 13,
      slug: 'thandorf',
    },
    {
      code: '130745458080',
      label: 'Utecht',
      provincie: 13,
      slug: 'utecht',
    },
    {
      code: '130745458092',
      label: 'Wedendorfersee',
      provincie: 13,
      slug: 'wedendorfersee',
    },
    {
      code: '130745459017',
      label: 'Dassow',
      provincie: 13,
      slug: 'dassow',
    },
    {
      code: '130745459027',
      label: 'Grieben',
      provincie: 13,
      slug: 'grieben',
    },
    {
      code: '130745459049',
      label: 'Lüdersdorf',
      provincie: 13,
      slug: 'luedersdorf',
    },
    {
      code: '130745459052',
      label: 'Menzendorf',
      provincie: 13,
      slug: 'menzendorf',
    },
    {
      code: '130745459067',
      label: 'Roduchelstorf',
      provincie: 13,
      slug: 'roduchelstorf',
    },
    {
      code: '130745459074',
      label: 'Schönberg',
      provincie: 13,
      slug: 'schoenberg-stadt',
    },
    {
      code: '130745459076',
      label: 'Selmsdorf',
      provincie: 13,
      slug: 'selmsdorf',
    },
    {
      code: '130745459094',
      label: 'Siemz-Niendorf',
      provincie: 13,
      slug: 'siemz-niendorf',
    },
    {
      code: '130750005005',
      label: 'Anklam',
      provincie: 13,
      slug: 'anklam',
    },
    {
      code: '130750039039',
      label: 'Greifswald',
      provincie: 13,
      slug: 'greifswald',
    },
    {
      code: '130750049049',
      label: 'Heringsdorf',
      provincie: 13,
      slug: 'heringsdorf-gemeinde',
    },
    {
      code: '130750105105',
      label: 'Pasewalk',
      provincie: 13,
      slug: 'pasewalk',
    },
    {
      code: '130750130130',
      label: 'Strasburg (Uckermark)',
      provincie: 13,
      slug: 'strasburg-uckermark',
    },
    {
      code: '130750136136',
      label: 'Ueckermünde',
      provincie: 13,
      slug: 'ueckermuende',
    },
    {
      code: '130755551021',
      label: 'Buggenhagen',
      provincie: 13,
      slug: 'buggenhagen',
    },
    {
      code: '130755551072',
      label: 'Krummin',
      provincie: 13,
      slug: 'krummin',
    },
    {
      code: '130755551074',
      label: 'Lassan',
      provincie: 13,
      slug: 'lassan',
    },
    {
      code: '130755551087',
      label: 'Lütow',
      provincie: 13,
      slug: 'luetow',
    },
    {
      code: '130755551124',
      label: 'Sauzin',
      provincie: 13,
      slug: 'sauzin',
    },
    {
      code: '130755551144',
      label: 'Wolgast',
      provincie: 13,
      slug: 'wolgast',
    },
    {
      code: '130755551147',
      label: 'Zemitz',
      provincie: 13,
      slug: 'zemitz',
    },
    {
      code: '130755552001',
      label: 'Ahlbeck',
      provincie: 13,
      slug: 'ahlbeck',
    },
    {
      code: '130755552003',
      label: 'Altwarp',
      provincie: 13,
      slug: 'altwarp',
    },
    {
      code: '130755552031',
      label: 'Eggesin',
      provincie: 13,
      slug: 'eggesin',
    },
    {
      code: '130755552037',
      label: 'Grambin',
      provincie: 13,
      slug: 'grambin',
    },
    {
      code: '130755552051',
      label: 'Hintersee',
      provincie: 13,
      slug: 'hintersee',
    },
    {
      code: '130755552075',
      label: 'Leopoldshagen',
      provincie: 13,
      slug: 'leopoldshagen',
    },
    {
      code: '130755552078',
      label: 'Liepgarten',
      provincie: 13,
      slug: 'liepgarten',
    },
    {
      code: '130755552084',
      label: 'Lübs',
      provincie: 13,
      slug: 'luebs',
    },
    {
      code: '130755552085',
      label: 'Luckow',
      provincie: 13,
      slug: 'luckow',
    },
    {
      code: '130755552089',
      label: 'Meiersberg',
      provincie: 13,
      slug: 'meiersberg',
    },
    {
      code: '130755552093',
      label: 'Mönkebude',
      provincie: 13,
      slug: 'moenkebude',
    },
    {
      code: '130755552139',
      label: 'Vogelsang-Warsin',
      provincie: 13,
      slug: 'vogelsang-warsin',
    },
    {
      code: '130755553007',
      label: 'Bargischow',
      provincie: 13,
      slug: 'bargischow',
    },
    {
      code: '130755553013',
      label: 'Blesewitz',
      provincie: 13,
      slug: 'blesewitz',
    },
    {
      code: '130755553015',
      label: 'Boldekow',
      provincie: 13,
      slug: 'boldekow',
    },
    {
      code: '130755553020',
      label: 'Bugewitz',
      provincie: 13,
      slug: 'bugewitz',
    },
    {
      code: '130755553022',
      label: 'Butzow',
      provincie: 13,
      slug: 'butzow',
    },
    {
      code: '130755553029',
      label: 'Ducherow',
      provincie: 13,
      slug: 'ducherow',
    },
    {
      code: '130755553053',
      label: 'Iven',
      provincie: 13,
      slug: 'iven',
    },
    {
      code: '130755553068',
      label: 'Krien',
      provincie: 13,
      slug: 'krien',
    },
    {
      code: '130755553073',
      label: 'Krusenfelde',
      provincie: 13,
      slug: 'krusenfelde',
    },
    {
      code: '130755553088',
      label: 'Medow',
      provincie: 13,
      slug: 'medow',
    },
    {
      code: '130755553098',
      label: 'Neu Kosenow',
      provincie: 13,
      slug: 'neu-kosenow',
    },
    {
      code: '130755553101',
      label: 'Neuenkirchen',
      provincie: 13,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '130755553110',
      label: 'Postlow',
      provincie: 13,
      slug: 'postlow',
    },
    {
      code: '130755553116',
      label: 'Rossin',
      provincie: 13,
      slug: 'rossin',
    },
    {
      code: '130755553122',
      label: 'Sarnow',
      provincie: 13,
      slug: 'sarnow',
    },
    {
      code: '130755553127',
      label: 'Spantekow',
      provincie: 13,
      slug: 'spantekow',
    },
    {
      code: '130755553128',
      label: 'Stolpe an der Peene',
      provincie: 13,
      slug: 'stolpe-an-der-peene',
    },
    {
      code: '130755553155',
      label: 'Neetzow-Liepen',
      provincie: 13,
      slug: 'neetzow-liepen',
    },
    {
      code: '130755554002',
      label: 'Alt Tellin',
      provincie: 13,
      slug: 'alt-tellin',
    },
    {
      code: '130755554009',
      label: 'Bentzin',
      provincie: 13,
      slug: 'bentzin',
    },
    {
      code: '130755554023',
      label: 'Daberkow',
      provincie: 13,
      slug: 'daberkow',
    },
    {
      code: '130755554054',
      label: 'Jarmen',
      provincie: 13,
      slug: 'jarmen',
    },
    {
      code: '130755554070',
      label: 'Kruckow',
      provincie: 13,
      slug: 'kruckow',
    },
    {
      code: '130755554134',
      label: 'Tutow',
      provincie: 13,
      slug: 'tutow',
    },
    {
      code: '130755554140',
      label: 'Völschow',
      provincie: 13,
      slug: 'voelschow',
    },
    {
      code: '130755555008',
      label: 'Behrenhoff',
      provincie: 13,
      slug: 'behrenhoff',
    },
    {
      code: '130755555025',
      label: 'Dargelin',
      provincie: 13,
      slug: 'dargelin',
    },
    {
      code: '130755555027',
      label: 'Dersekow',
      provincie: 13,
      slug: 'dersekow',
    },
    {
      code: '130755555050',
      label: 'Hinrichshagen',
      provincie: 13,
      slug: 'hinrichshagen',
    },
    {
      code: '130755555076',
      label: 'Levenhagen',
      provincie: 13,
      slug: 'levenhagen',
    },
    {
      code: '130755555091',
      label: 'Mesekenhagen',
      provincie: 13,
      slug: 'mesekenhagen',
    },
    {
      code: '130755555102',
      label: 'Neuenkirchen',
      provincie: 13,
      slug: 'neuenkirchen-gemeinde',
    },
    {
      code: '130755555141',
      label: 'Wackerow',
      provincie: 13,
      slug: 'wackerow',
    },
    {
      code: '130755555142',
      label: 'Weitenhagen',
      provincie: 13,
      slug: 'weitenhagen-gemeinde',
    },
    {
      code: '130755556011',
      label: 'Bergholz',
      provincie: 13,
      slug: 'bergholz',
    },
    {
      code: '130755556012',
      label: 'Blankensee',
      provincie: 13,
      slug: 'blankensee-gemeinde',
    },
    {
      code: '130755556016',
      label: 'Boock',
      provincie: 13,
      slug: 'boock',
    },
    {
      code: '130755556035',
      label: 'Glasow',
      provincie: 13,
      slug: 'glasow',
    },
    {
      code: '130755556038',
      label: 'Grambow',
      provincie: 13,
      slug: 'grambow-gemeinde',
    },
    {
      code: '130755556067',
      label: 'Krackow',
      provincie: 13,
      slug: 'krackow',
    },
    {
      code: '130755556079',
      label: 'Löcknitz',
      provincie: 13,
      slug: 'loecknitz',
    },
    {
      code: '130755556095',
      label: 'Nadrensee',
      provincie: 13,
      slug: 'nadrensee',
    },
    {
      code: '130755556107',
      label: 'Penkun',
      provincie: 13,
      slug: 'penkun',
    },
    {
      code: '130755556108',
      label: 'Plöwen',
      provincie: 13,
      slug: 'ploewen',
    },
    {
      code: '130755556113',
      label: 'Ramin',
      provincie: 13,
      slug: 'ramin',
    },
    {
      code: '130755556117',
      label: 'Rossow',
      provincie: 13,
      slug: 'rossow',
    },
    {
      code: '130755556119',
      label: 'Rothenklempenow',
      provincie: 13,
      slug: 'rothenklempenow',
    },
    {
      code: '130755557018',
      label: 'Brünzow',
      provincie: 13,
      slug: 'bruenzow',
    },
    {
      code: '130755557046',
      label: 'Hanshagen',
      provincie: 13,
      slug: 'hanshagen',
    },
    {
      code: '130755557059',
      label: 'Katzow',
      provincie: 13,
      slug: 'katzow',
    },
    {
      code: '130755557060',
      label: 'Kemnitz',
      provincie: 13,
      slug: 'kemnitz',
    },
    {
      code: '130755557069',
      label: 'Kröslin',
      provincie: 13,
      slug: 'kroeslin',
    },
    {
      code: '130755557081',
      label: 'Loissin',
      provincie: 13,
      slug: 'loissin',
    },
    {
      code: '130755557083',
      label: 'Lubmin',
      provincie: 13,
      slug: 'lubmin',
    },
    {
      code: '130755557097',
      label: 'Neu Boltenhagen',
      provincie: 13,
      slug: 'neu-boltenhagen',
    },
    {
      code: '130755557120',
      label: 'Rubenow',
      provincie: 13,
      slug: 'rubenow',
    },
    {
      code: '130755557146',
      label: 'Wusterhusen',
      provincie: 13,
      slug: 'wusterhusen',
    },
    {
      code: '130755558036',
      label: 'Görmin',
      provincie: 13,
      slug: 'goermin',
    },
    {
      code: '130755558082',
      label: 'Loitz',
      provincie: 13,
      slug: 'loitz',
    },
    {
      code: '130755558123',
      label: 'Sassen-Trantow',
      provincie: 13,
      slug: 'sassen-trantow',
    },
    {
      code: '130755559004',
      label: 'Altwigshagen',
      provincie: 13,
      slug: 'altwigshagen',
    },
    {
      code: '130755559033',
      label: 'Ferdinandshof',
      provincie: 13,
      slug: 'ferdinandshof',
    },
    {
      code: '130755559045',
      label: 'Hammer a.d.Uecker',
      provincie: 13,
      slug: 'hammer-a-d-uecker',
    },
    {
      code: '130755559048',
      label: 'Heinrichswalde',
      provincie: 13,
      slug: 'heinrichswalde',
    },
    {
      code: '130755559118',
      label: 'Rothemühl',
      provincie: 13,
      slug: 'rothemuehl',
    },
    {
      code: '130755559131',
      label: 'Torgelow',
      provincie: 13,
      slug: 'torgelow',
    },
    {
      code: '130755559143',
      label: 'Wilhelmsburg',
      provincie: 13,
      slug: 'wilhelmsburg',
    },
    {
      code: '130755560017',
      label: 'Brietzig',
      provincie: 13,
      slug: 'brietzig',
    },
    {
      code: '130755560032',
      label: 'Fahrenwalde',
      provincie: 13,
      slug: 'fahrenwalde',
    },
    {
      code: '130755560042',
      label: 'Groß Luckow',
      provincie: 13,
      slug: 'gross-luckow',
    },
    {
      code: '130755560055',
      label: 'Jatznick',
      provincie: 13,
      slug: 'jatznick',
    },
    {
      code: '130755560063',
      label: 'Koblentz',
      provincie: 13,
      slug: 'koblentz',
    },
    {
      code: '130755560071',
      label: 'Krugsdorf',
      provincie: 13,
      slug: 'krugsdorf',
    },
    {
      code: '130755560103',
      label: 'Nieden',
      provincie: 13,
      slug: 'nieden',
    },
    {
      code: '130755560104',
      label: 'Papendorf',
      provincie: 13,
      slug: 'papendorf-gemeinde',
    },
    {
      code: '130755560109',
      label: 'Polzow',
      provincie: 13,
      slug: 'polzow',
    },
    {
      code: '130755560115',
      label: 'Rollwitz',
      provincie: 13,
      slug: 'rollwitz',
    },
    {
      code: '130755560126',
      label: 'Schönwalde',
      provincie: 13,
      slug: 'schoenwalde',
    },
    {
      code: '130755560138',
      label: 'Viereck',
      provincie: 13,
      slug: 'viereck',
    },
    {
      code: '130755560149',
      label: 'Zerrenthin',
      provincie: 13,
      slug: 'zerrenthin',
    },
    {
      code: '130755561058',
      label: 'Karlshagen',
      provincie: 13,
      slug: 'karlshagen',
    },
    {
      code: '130755561092',
      label: 'Mölschow',
      provincie: 13,
      slug: 'moelschow',
    },
    {
      code: '130755561106',
      label: 'Peenemünde',
      provincie: 13,
      slug: 'peenemuende',
    },
    {
      code: '130755561133',
      label: 'Trassenheide',
      provincie: 13,
      slug: 'trassenheide',
    },
    {
      code: '130755561151',
      label: 'Zinnowitz',
      provincie: 13,
      slug: 'zinnowitz',
    },
    {
      code: '130755562010',
      label: 'Benz',
      provincie: 13,
      slug: 'benz-gemeinde',
    },
    {
      code: '130755562026',
      label: 'Dargen',
      provincie: 13,
      slug: 'dargen',
    },
    {
      code: '130755562034',
      label: 'Garz',
      provincie: 13,
      slug: 'garz',
    },
    {
      code: '130755562056',
      label: 'Kamminke',
      provincie: 13,
      slug: 'kamminke',
    },
    {
      code: '130755562065',
      label: 'Korswandt',
      provincie: 13,
      slug: 'korswandt',
    },
    {
      code: '130755562066',
      label: 'Koserow',
      provincie: 13,
      slug: 'koserow',
    },
    {
      code: '130755562080',
      label: 'Loddin',
      provincie: 13,
      slug: 'loddin',
    },
    {
      code: '130755562090',
      label: 'Mellenthin',
      provincie: 13,
      slug: 'mellenthin',
    },
    {
      code: '130755562111',
      label: 'Pudagla',
      provincie: 13,
      slug: 'pudagla',
    },
    {
      code: '130755562114',
      label: 'Rankwitz',
      provincie: 13,
      slug: 'rankwitz',
    },
    {
      code: '130755562129',
      label: 'Stolpe auf Usedom',
      provincie: 13,
      slug: 'stolpe-auf-usedom',
    },
    {
      code: '130755562135',
      label: 'Ückeritz',
      provincie: 13,
      slug: 'ueckeritz',
    },
    {
      code: '130755562137',
      label: 'Usedom',
      provincie: 13,
      slug: 'usedom',
    },
    {
      code: '130755562148',
      label: 'Zempin',
      provincie: 13,
      slug: 'zempin',
    },
    {
      code: '130755562152',
      label: 'Zirchow',
      provincie: 13,
      slug: 'zirchow',
    },
    {
      code: '130755563006',
      label: 'Bandelin',
      provincie: 13,
      slug: 'bandelin',
    },
    {
      code: '130755563040',
      label: 'Gribow',
      provincie: 13,
      slug: 'gribow',
    },
    {
      code: '130755563041',
      label: 'Groß Kiesow',
      provincie: 13,
      slug: 'gross-kiesow',
    },
    {
      code: '130755563043',
      label: 'Groß Polzin',
      provincie: 13,
      slug: 'gross-polzin',
    },
    {
      code: '130755563044',
      label: 'Gützkow',
      provincie: 13,
      slug: 'guetzkow',
    },
    {
      code: '130755563061',
      label: 'Klein Bünzow',
      provincie: 13,
      slug: 'klein-buenzow',
    },
    {
      code: '130755563094',
      label: 'Murchin',
      provincie: 13,
      slug: 'murchin',
    },
    {
      code: '130755563121',
      label: 'Rubkow',
      provincie: 13,
      slug: 'rubkow',
    },
    {
      code: '130755563125',
      label: 'Schmatzin',
      provincie: 13,
      slug: 'schmatzin',
    },
    {
      code: '130755563145',
      label: 'Wrangelsburg',
      provincie: 13,
      slug: 'wrangelsburg',
    },
    {
      code: '130755563150',
      label: 'Ziethen',
      provincie: 13,
      slug: 'ziethen-gemeinde',
    },
    {
      code: '130755563154',
      label: 'Züssow',
      provincie: 13,
      slug: 'zuessow',
    },
    {
      code: '130755563156',
      label: 'Karlsburg',
      provincie: 13,
      slug: 'karlsburg',
    },
    {
      code: '130760014014',
      label: 'Boizenburg/Elbe',
      provincie: 13,
      slug: 'boizenburg-elbe',
    },
    {
      code: '130760060060',
      label: 'Hagenow',
      provincie: 13,
      slug: 'hagenow',
    },
    {
      code: '130760088088',
      label: 'Lübtheen',
      provincie: 13,
      slug: 'luebtheen',
    },
    {
      code: '130760090090',
      label: 'Ludwigslust',
      provincie: 13,
      slug: 'ludwigslust',
    },
    {
      code: '130760108108',
      label: 'Parchim',
      provincie: 13,
      slug: 'parchim',
    },
    {
      code: '130765652009',
      label: 'Bengerstorf',
      provincie: 13,
      slug: 'bengerstorf',
    },
    {
      code: '130765652010',
      label: 'Besitz',
      provincie: 13,
      slug: 'besitz',
    },
    {
      code: '130765652016',
      label: 'Brahlstorf',
      provincie: 13,
      slug: 'brahlstorf',
    },
    {
      code: '130765652030',
      label: 'Dersenow',
      provincie: 13,
      slug: 'dersenow',
    },
    {
      code: '130765652054',
      label: 'Gresse',
      provincie: 13,
      slug: 'gresse',
    },
    {
      code: '130765652055',
      label: 'Greven',
      provincie: 13,
      slug: 'greven-gemeinde',
    },
    {
      code: '130765652102',
      label: 'Neu Gülze',
      provincie: 13,
      slug: 'neu-guelze',
    },
    {
      code: '130765652106',
      label: 'Nostorf',
      provincie: 13,
      slug: 'nostorf',
    },
    {
      code: '130765652122',
      label: 'Schwanheide',
      provincie: 13,
      slug: 'schwanheide',
    },
    {
      code: '130765652136',
      label: 'Teldau',
      provincie: 13,
      slug: 'teldau',
    },
    {
      code: '130765652138',
      label: 'Tessin b.Boizenburg',
      provincie: 13,
      slug: 'tessin-b-boizenburg',
    },
    {
      code: '130765654034',
      label: 'Dömitz',
      provincie: 13,
      slug: 'doemitz',
    },
    {
      code: '130765654053',
      label: 'Grebs-Niendorf',
      provincie: 13,
      slug: 'grebs-niendorf',
    },
    {
      code: '130765654067',
      label: 'Karenz',
      provincie: 13,
      slug: 'karenz',
    },
    {
      code: '130765654093',
      label: 'Malk Göhren',
      provincie: 13,
      slug: 'malk-goehren',
    },
    {
      code: '130765654094',
      label: 'Malliß',
      provincie: 13,
      slug: 'malliss',
    },
    {
      code: '130765654103',
      label: 'Neu Kaliß',
      provincie: 13,
      slug: 'neu-kaliss',
    },
    {
      code: '130765654143',
      label: 'Vielank',
      provincie: 13,
      slug: 'vielank',
    },
    {
      code: '130765655040',
      label: 'Gallin-Kuppentin',
      provincie: 13,
      slug: 'gallin-kuppentin',
    },
    {
      code: '130765655051',
      label: 'Granzin',
      provincie: 13,
      slug: 'granzin',
    },
    {
      code: '130765655075',
      label: 'Kreien',
      provincie: 13,
      slug: 'kreien',
    },
    {
      code: '130765655077',
      label: 'Kritzow',
      provincie: 13,
      slug: 'kritzow',
    },
    {
      code: '130765655089',
      label: 'Lübz',
      provincie: 13,
      slug: 'luebz',
    },
    {
      code: '130765655109',
      label: 'Passow',
      provincie: 13,
      slug: 'passow',
    },
    {
      code: '130765655125',
      label: 'Siggelkow',
      provincie: 13,
      slug: 'siggelkow',
    },
    {
      code: '130765655151',
      label: 'Werder',
      provincie: 13,
      slug: 'werder-gemeinde',
    },
    {
      code: '130765655165',
      label: 'Gehlsbach',
      provincie: 13,
      slug: 'gehlsbach',
    },
    {
      code: '130765655168',
      label: 'Ruhner Berge',
      provincie: 13,
      slug: 'ruhner-berge',
    },
    {
      code: '130765656032',
      label: 'Dobbertin',
      provincie: 13,
      slug: 'dobbertin',
    },
    {
      code: '130765656048',
      label: 'Goldberg',
      provincie: 13,
      slug: 'goldberg',
    },
    {
      code: '130765656096',
      label: 'Mestlin',
      provincie: 13,
      slug: 'mestlin',
    },
    {
      code: '130765656104',
      label: 'Neu Poserin',
      provincie: 13,
      slug: 'neu-poserin',
    },
    {
      code: '130765656135',
      label: 'Techentin',
      provincie: 13,
      slug: 'techentin',
    },
    {
      code: '130765657003',
      label: 'Balow',
      provincie: 13,
      slug: 'balow',
    },
    {
      code: '130765657021',
      label: 'Brunow',
      provincie: 13,
      slug: 'brunow',
    },
    {
      code: '130765657027',
      label: 'Dambeck',
      provincie: 13,
      slug: 'dambeck',
    },
    {
      code: '130765657037',
      label: 'Eldena',
      provincie: 13,
      slug: 'eldena',
    },
    {
      code: '130765657049',
      label: 'Gorlosen',
      provincie: 13,
      slug: 'gorlosen',
    },
    {
      code: '130765657050',
      label: 'Grabow',
      provincie: 13,
      slug: 'grabow',
    },
    {
      code: '130765657069',
      label: 'Karstädt',
      provincie: 13,
      slug: 'karstaedt-gemeinde',
    },
    {
      code: '130765657076',
      label: 'Kremmin',
      provincie: 13,
      slug: 'kremmin',
    },
    {
      code: '130765657097',
      label: 'Milow',
      provincie: 13,
      slug: 'milow',
    },
    {
      code: '130765657098',
      label: 'Möllenbeck',
      provincie: 13,
      slug: 'moellenbeck-gemeinde',
    },
    {
      code: '130765657100',
      label: 'Muchow',
      provincie: 13,
      slug: 'muchow',
    },
    {
      code: '130765657115',
      label: 'Prislich',
      provincie: 13,
      slug: 'prislich',
    },
    {
      code: '130765657161',
      label: 'Zierzow',
      provincie: 13,
      slug: 'zierzow',
    },
    {
      code: '130765658002',
      label: 'Alt Zachun',
      provincie: 13,
      slug: 'alt-zachun',
    },
    {
      code: '130765658004',
      label: 'Bandenitz',
      provincie: 13,
      slug: 'bandenitz',
    },
    {
      code: '130765658008',
      label: 'Belsch',
      provincie: 13,
      slug: 'belsch',
    },
    {
      code: '130765658013',
      label: 'Bobzin',
      provincie: 13,
      slug: 'bobzin',
    },
    {
      code: '130765658019',
      label: 'Bresegard bei Picher',
      provincie: 13,
      slug: 'bresegard-bei-picher',
    },
    {
      code: '130765658041',
      label: 'Gammelin',
      provincie: 13,
      slug: 'gammelin',
    },
    {
      code: '130765658057',
      label: 'Groß Krams',
      provincie: 13,
      slug: 'gross-krams',
    },
    {
      code: '130765658064',
      label: 'Hoort',
      provincie: 13,
      slug: 'hoort',
    },
    {
      code: '130765658065',
      label: 'Hülseburg',
      provincie: 13,
      slug: 'huelseburg',
    },
    {
      code: '130765658070',
      label: 'Kirch Jesar',
      provincie: 13,
      slug: 'kirch-jesar',
    },
    {
      code: '130765658079',
      label: 'Kuhstorf',
      provincie: 13,
      slug: 'kuhstorf',
    },
    {
      code: '130765658099',
      label: 'Moraas',
      provincie: 13,
      slug: 'moraas',
    },
    {
      code: '130765658110',
      label: 'Pätow-Steegen',
      provincie: 13,
      slug: 'paetow-steegen',
    },
    {
      code: '130765658111',
      label: 'Picher',
      provincie: 13,
      slug: 'picher',
    },
    {
      code: '130765658116',
      label: 'Pritzier',
      provincie: 13,
      slug: 'pritzier',
    },
    {
      code: '130765658119',
      label: 'Redefin',
      provincie: 13,
      slug: 'redefin',
    },
    {
      code: '130765658131',
      label: 'Strohkirchen',
      provincie: 13,
      slug: 'strohkirchen',
    },
    {
      code: '130765658145',
      label: 'Warlitz',
      provincie: 13,
      slug: 'warlitz',
    },
    {
      code: '130765658169',
      label: 'Toddin',
      provincie: 13,
      slug: 'toddin',
    },
    {
      code: '130765659001',
      label: 'Alt Krenzlin',
      provincie: 13,
      slug: 'alt-krenzlin',
    },
    {
      code: '130765659018',
      label: 'Bresegard bei Eldena',
      provincie: 13,
      slug: 'bresegard-bei-eldena',
    },
    {
      code: '130765659046',
      label: 'Göhlen',
      provincie: 13,
      slug: 'goehlen',
    },
    {
      code: '130765659058',
      label: 'Groß Laasch',
      provincie: 13,
      slug: 'gross-laasch',
    },
    {
      code: '130765659086',
      label: 'Lübesse',
      provincie: 13,
      slug: 'luebesse',
    },
    {
      code: '130765659087',
      label: 'Lüblow',
      provincie: 13,
      slug: 'lueblow',
    },
    {
      code: '130765659118',
      label: 'Rastow',
      provincie: 13,
      slug: 'rastow',
    },
    {
      code: '130765659134',
      label: 'Sülstorf',
      provincie: 13,
      slug: 'suelstorf',
    },
    {
      code: '130765659141',
      label: 'Uelitz',
      provincie: 13,
      slug: 'uelitz',
    },
    {
      code: '130765659146',
      label: 'Warlow',
      provincie: 13,
      slug: 'warlow',
    },
    {
      code: '130765659156',
      label: 'Wöbbelin',
      provincie: 13,
      slug: 'woebbelin',
    },
    {
      code: '130765660012',
      label: 'Blievenstorf',
      provincie: 13,
      slug: 'blievenstorf',
    },
    {
      code: '130765660017',
      label: 'Brenz',
      provincie: 13,
      slug: 'brenz',
    },
    {
      code: '130765660105',
      label: 'Neustadt-Glewe',
      provincie: 13,
      slug: 'neustadt-glewe',
    },
    {
      code: '130765662035',
      label: 'Domsühl',
      provincie: 13,
      slug: 'domsuehl',
    },
    {
      code: '130765662056',
      label: 'Groß Godems',
      provincie: 13,
      slug: 'gross-godems',
    },
    {
      code: '130765662068',
      label: 'Karrenzin',
      provincie: 13,
      slug: 'karrenzin',
    },
    {
      code: '130765662085',
      label: 'Lewitzrand',
      provincie: 13,
      slug: 'lewitzrand',
    },
    {
      code: '130765662120',
      label: 'Rom',
      provincie: 13,
      slug: 'rom',
    },
    {
      code: '130765662126',
      label: 'Spornitz',
      provincie: 13,
      slug: 'spornitz',
    },
    {
      code: '130765662129',
      label: 'Stolpe',
      provincie: 13,
      slug: 'stolpe-gemeinde',
    },
    {
      code: '130765662160',
      label: 'Ziegendorf',
      provincie: 13,
      slug: 'ziegendorf',
    },
    {
      code: '130765662162',
      label: 'Zölkow',
      provincie: 13,
      slug: 'zoelkow',
    },
    {
      code: '130765662164',
      label: 'Obere Warnow',
      provincie: 13,
      slug: 'obere-warnow',
    },
    {
      code: '130765663006',
      label: 'Barkhagen',
      provincie: 13,
      slug: 'barkhagen',
    },
    {
      code: '130765663114',
      label: 'Plau am See',
      provincie: 13,
      slug: 'plau-am-see',
    },
    {
      code: '130765663166',
      label: 'Ganzlin',
      provincie: 13,
      slug: 'ganzlin',
    },
    {
      code: '130765664011',
      label: 'Blankenberg',
      provincie: 13,
      slug: 'blankenberg',
    },
    {
      code: '130765664015',
      label: 'Borkow',
      provincie: 13,
      slug: 'borkow',
    },
    {
      code: '130765664020',
      label: 'Brüel',
      provincie: 13,
      slug: 'brueel',
    },
    {
      code: '130765664026',
      label: 'Dabel',
      provincie: 13,
      slug: 'dabel',
    },
    {
      code: '130765664062',
      label: 'Hohen Pritz',
      provincie: 13,
      slug: 'hohen-pritz',
    },
    {
      code: '130765664072',
      label: 'Kobrow',
      provincie: 13,
      slug: 'kobrow',
    },
    {
      code: '130765664078',
      label: 'Kuhlen-Wendorf',
      provincie: 13,
      slug: 'kuhlen-wendorf',
    },
    {
      code: '130765664101',
      label: 'Mustin',
      provincie: 13,
      slug: 'mustin-gemeinde',
    },
    {
      code: '130765664128',
      label: 'Sternberg',
      provincie: 13,
      slug: 'sternberg',
    },
    {
      code: '130765664148',
      label: 'Weitendorf',
      provincie: 13,
      slug: 'weitendorf',
    },
    {
      code: '130765664155',
      label: 'Witzin',
      provincie: 13,
      slug: 'witzin',
    },
    {
      code: '130765664167',
      label: 'Kloster Tempzin',
      provincie: 13,
      slug: 'kloster-tempzin',
    },
    {
      code: '130765665036',
      label: 'Dümmer',
      provincie: 13,
      slug: 'duemmer',
    },
    {
      code: '130765665063',
      label: 'Holthusen',
      provincie: 13,
      slug: 'holthusen',
    },
    {
      code: '130765665071',
      label: 'Klein Rogahn',
      provincie: 13,
      slug: 'klein-rogahn',
    },
    {
      code: '130765665107',
      label: 'Pampow',
      provincie: 13,
      slug: 'pampow',
    },
    {
      code: '130765665121',
      label: 'Schossin',
      provincie: 13,
      slug: 'schossin',
    },
    {
      code: '130765665130',
      label: 'Stralendorf',
      provincie: 13,
      slug: 'stralendorf',
    },
    {
      code: '130765665147',
      label: 'Warsow',
      provincie: 13,
      slug: 'warsow',
    },
    {
      code: '130765665154',
      label: 'Wittenförden',
      provincie: 13,
      slug: 'wittenfoerden',
    },
    {
      code: '130765665163',
      label: 'Zülow',
      provincie: 13,
      slug: 'zuelow',
    },
    {
      code: '130765666152',
      label: 'Wittenburg',
      provincie: 13,
      slug: 'wittenburg',
    },
    {
      code: '130765666153',
      label: 'Wittendörp',
      provincie: 13,
      slug: 'wittendoerp',
    },
    {
      code: '130765667039',
      label: 'Gallin',
      provincie: 13,
      slug: 'gallin',
    },
    {
      code: '130765667073',
      label: 'Kogel',
      provincie: 13,
      slug: 'kogel',
    },
    {
      code: '130765667092',
      label: 'Lüttow-Valluhn',
      provincie: 13,
      slug: 'luettow-valluhn',
    },
    {
      code: '130765667142',
      label: 'Vellahn',
      provincie: 13,
      slug: 'vellahn',
    },
    {
      code: '130765667159',
      label: 'Zarrentin am Schaalsee',
      provincie: 13,
      slug: 'zarrentin-am-schaalsee',
    },
    {
      code: '130765668005',
      label: 'Banzkow',
      provincie: 13,
      slug: 'banzkow',
    },
    {
      code: '130765668007',
      label: 'Barnin',
      provincie: 13,
      slug: 'barnin',
    },
    {
      code: '130765668023',
      label: 'Bülow',
      provincie: 13,
      slug: 'buelow',
    },
    {
      code: '130765668024',
      label: 'Cambs',
      provincie: 13,
      slug: 'cambs',
    },
    {
      code: '130765668025',
      label: 'Crivitz',
      provincie: 13,
      slug: 'crivitz',
    },
    {
      code: '130765668029',
      label: 'Demen',
      provincie: 13,
      slug: 'demen',
    },
    {
      code: '130765668033',
      label: 'Dobin am See',
      provincie: 13,
      slug: 'dobin-am-see',
    },
    {
      code: '130765668038',
      label: 'Friedrichsruhe',
      provincie: 13,
      slug: 'friedrichsruhe',
    },
    {
      code: '130765668044',
      label: 'Gneven',
      provincie: 13,
      slug: 'gneven',
    },
    {
      code: '130765668080',
      label: 'Langen Brütz',
      provincie: 13,
      slug: 'langen-bruetz',
    },
    {
      code: '130765668082',
      label: 'Leezen',
      provincie: 13,
      slug: 'leezen-gemeinde',
    },
    {
      code: '130765668112',
      label: 'Pinnow',
      provincie: 13,
      slug: 'pinnow-gemeinde',
    },
    {
      code: '130765668113',
      label: 'Plate',
      provincie: 13,
      slug: 'plate',
    },
    {
      code: '130765668117',
      label: 'Raben Steinfeld',
      provincie: 13,
      slug: 'raben-steinfeld',
    },
    {
      code: '130765668133',
      label: 'Sukow',
      provincie: 13,
      slug: 'sukow',
    },
    {
      code: '130765668140',
      label: 'Tramm',
      provincie: 13,
      slug: 'tramm-gemeinde',
    },
    {
      code: '130765668158',
      label: 'Zapel',
      provincie: 13,
      slug: 'zapel',
    },
    {
      code: '145110000000',
      label: 'Chemnitz',
      provincie: 14,
      slug: 'chemnitz',
    },
    {
      code: '145210010010',
      label: 'Amtsberg',
      provincie: 14,
      slug: 'amtsberg',
    },
    {
      code: '145210020020',
      label: 'Annaberg-Buchholz',
      provincie: 14,
      slug: 'annaberg-buchholz',
    },
    {
      code: '145210035035',
      label: 'Aue-Bad Schlema',
      provincie: 14,
      slug: 'aue-bad-schlema',
    },
    {
      code: '145210110110',
      label: 'Breitenbrunn/Erzgeb.',
      provincie: 14,
      slug: 'breitenbrunn-erzgeb',
    },
    {
      code: '145210130130',
      label: 'Crottendorf',
      provincie: 14,
      slug: 'crottendorf',
    },
    {
      code: '145210150150',
      label: 'Drebach',
      provincie: 14,
      slug: 'drebach',
    },
    {
      code: '145210160160',
      label: 'Ehrenfriedersdorf',
      provincie: 14,
      slug: 'ehrenfriedersdorf',
    },
    {
      code: '145210170170',
      label: 'Eibenstock',
      provincie: 14,
      slug: 'eibenstock',
    },
    {
      code: '145210200200',
      label: 'Gelenau/Erzgeb.',
      provincie: 14,
      slug: 'gelenau-erzgeb',
    },
    {
      code: '145210240240',
      label: 'Großolbersdorf',
      provincie: 14,
      slug: 'grossolbersdorf',
    },
    {
      code: '145210250250',
      label: 'Großrückerswalde',
      provincie: 14,
      slug: 'grossrueckerswalde',
    },
    {
      code: '145210260260',
      label: 'Grünhain-Beierfeld',
      provincie: 14,
      slug: 'gruenhain-beierfeld',
    },
    {
      code: '145210290290',
      label: 'Hohndorf',
      provincie: 14,
      slug: 'hohndorf',
    },
    {
      code: '145210310310',
      label: 'Jahnsdorf/Erzgeb.',
      provincie: 14,
      slug: 'jahnsdorf-erzgeb',
    },
    {
      code: '145210320320',
      label: 'Johanngeorgenstadt',
      provincie: 14,
      slug: 'johanngeorgenstadt',
    },
    {
      code: '145210330330',
      label: 'Jöhstadt',
      provincie: 14,
      slug: 'joehstadt',
    },
    {
      code: '145210355355',
      label: 'Lauter-Bernsbach',
      provincie: 14,
      slug: 'lauter-bernsbach',
    },
    {
      code: '145210370370',
      label: 'Lößnitz',
      provincie: 14,
      slug: 'loessnitz',
    },
    {
      code: '145210390390',
      label: 'Marienberg',
      provincie: 14,
      slug: 'marienberg',
    },
    {
      code: '145210400400',
      label: 'Mildenau',
      provincie: 14,
      slug: 'mildenau',
    },
    {
      code: '145210410410',
      label: 'Neukirchen/Erzgeb.',
      provincie: 14,
      slug: 'neukirchen-erzgeb',
    },
    {
      code: '145210440440',
      label: 'Oberwiesenthal',
      provincie: 14,
      slug: 'oberwiesenthal',
    },
    {
      code: '145210450450',
      label: 'Oelsnitz/Erzgeb.',
      provincie: 14,
      slug: 'oelsnitz-erzgeb',
    },
    {
      code: '145210460460',
      label: 'Olbernhau',
      provincie: 14,
      slug: 'olbernhau',
    },
    {
      code: '145210495495',
      label: 'Pockau-Lengefeld',
      provincie: 14,
      slug: 'pockau-lengefeld',
    },
    {
      code: '145210500500',
      label: 'Raschau-Markersbach',
      provincie: 14,
      slug: 'raschau-markersbach',
    },
    {
      code: '145210530530',
      label: 'Schneeberg',
      provincie: 14,
      slug: 'schneeberg-stadt',
    },
    {
      code: '145210540540',
      label: 'Schönheide',
      provincie: 14,
      slug: 'schoenheide',
    },
    {
      code: '145210550550',
      label: 'Schwarzenberg/Erzgeb.',
      provincie: 14,
      slug: 'schwarzenberg-erzgeb',
    },
    {
      code: '145210560560',
      label: 'Sehmatal',
      provincie: 14,
      slug: 'sehmatal',
    },
    {
      code: '145210600600',
      label: 'Stützengrün',
      provincie: 14,
      slug: 'stuetzengruen',
    },
    {
      code: '145210620620',
      label: 'Thalheim/Erzgeb.',
      provincie: 14,
      slug: 'thalheim-erzgeb',
    },
    {
      code: '145210630630',
      label: 'Thermalbad Wiesenbad',
      provincie: 14,
      slug: 'thermalbad-wiesenbad',
    },
    {
      code: '145210640640',
      label: 'Thum',
      provincie: 14,
      slug: 'thum',
    },
    {
      code: '145210670670',
      label: 'Wolkenstein',
      provincie: 14,
      slug: 'wolkenstein',
    },
    {
      code: '145215101060',
      label: 'Bärenstein',
      provincie: 14,
      slug: 'baerenstein',
    },
    {
      code: '145215101340',
      label: 'Königswalde',
      provincie: 14,
      slug: 'koenigswalde',
    },
    {
      code: '145215103040',
      label: 'Auerbach',
      provincie: 14,
      slug: 'auerbach-gemeinde',
    },
    {
      code: '145215103120',
      label: 'Burkhardtsdorf',
      provincie: 14,
      slug: 'burkhardtsdorf',
    },
    {
      code: '145215103230',
      label: 'Gornsdorf',
      provincie: 14,
      slug: 'gornsdorf',
    },
    {
      code: '145215110210',
      label: 'Geyer',
      provincie: 14,
      slug: 'geyer',
    },
    {
      code: '145215110610',
      label: 'Tannenberg',
      provincie: 14,
      slug: 'tannenberg',
    },
    {
      code: '145215115380',
      label: 'Lugau/Erzgeb.',
      provincie: 14,
      slug: 'lugau-erzgeb',
    },
    {
      code: '145215115430',
      label: 'Niederwürschnitz',
      provincie: 14,
      slug: 'niederwuerschnitz',
    },
    {
      code: '145215130510',
      label: 'Scheibenberg',
      provincie: 14,
      slug: 'scheibenberg',
    },
    {
      code: '145215130520',
      label: 'Schlettau',
      provincie: 14,
      slug: 'schlettau',
    },
    {
      code: '145215132140',
      label: 'Deutschneudorf',
      provincie: 14,
      slug: 'deutschneudorf',
    },
    {
      code: '145215132280',
      label: 'Heidersdorf',
      provincie: 14,
      slug: 'heidersdorf',
    },
    {
      code: '145215132570',
      label: 'Seiffen/Erzgeb.',
      provincie: 14,
      slug: 'seiffen-erzgeb',
    },
    {
      code: '145215133420',
      label: 'Niederdorf',
      provincie: 14,
      slug: 'niederdorf',
    },
    {
      code: '145215133590',
      label: 'Stollberg/Erzgeb.',
      provincie: 14,
      slug: 'stollberg-erzgeb',
    },
    {
      code: '145215138220',
      label: 'Gornau/Erzgeb.',
      provincie: 14,
      slug: 'gornau-erzgeb',
    },
    {
      code: '145215138690',
      label: 'Zschopau',
      provincie: 14,
      slug: 'zschopau',
    },
    {
      code: '145215139080',
      label: 'Bockau',
      provincie: 14,
      slug: 'bockau',
    },
    {
      code: '145215139700',
      label: 'Zschorlau',
      provincie: 14,
      slug: 'zschorlau',
    },
    {
      code: '145215140180',
      label: 'Elterlein',
      provincie: 14,
      slug: 'elterlein',
    },
    {
      code: '145215140710',
      label: 'Zwönitz',
      provincie: 14,
      slug: 'zwoenitz',
    },
    {
      code: '145215405090',
      label: 'Börnichen/Erzgeb.',
      provincie: 14,
      slug: 'boernichen-erzgeb',
    },
    {
      code: '145215405270',
      label: 'Grünhainichen',
      provincie: 14,
      slug: 'gruenhainichen',
    },
    {
      code: '145220020020',
      label: 'Augustusburg',
      provincie: 14,
      slug: 'augustusburg',
    },
    {
      code: '145220035035',
      label: 'Bobritzsch-Hilbersdorf',
      provincie: 14,
      slug: 'bobritzsch-hilbersdorf',
    },
    {
      code: '145220050050',
      label: 'Brand-Erbisdorf',
      provincie: 14,
      slug: 'brand-erbisdorf',
    },
    {
      code: '145220070070',
      label: 'Claußnitz',
      provincie: 14,
      slug: 'claussnitz',
    },
    {
      code: '145220080080',
      label: 'Döbeln',
      provincie: 14,
      slug: 'doebeln',
    },
    {
      code: '145220110110',
      label: 'Eppendorf',
      provincie: 14,
      slug: 'eppendorf',
    },
    {
      code: '145220120120',
      label: 'Erlau',
      provincie: 14,
      slug: 'erlau',
    },
    {
      code: '145220140140',
      label: 'Flöha',
      provincie: 14,
      slug: 'floeha',
    },
    {
      code: '145220150150',
      label: 'Frankenberg/Sa.',
      provincie: 14,
      slug: 'frankenberg-sa',
    },
    {
      code: '145220170170',
      label: 'Frauenstein',
      provincie: 14,
      slug: 'frauenstein',
    },
    {
      code: '145220180180',
      label: 'Freiberg',
      provincie: 14,
      slug: 'freiberg',
    },
    {
      code: '145220190190',
      label: 'Geringswalde',
      provincie: 14,
      slug: 'geringswalde',
    },
    {
      code: '145220200200',
      label: 'Großhartmannsdorf',
      provincie: 14,
      slug: 'grosshartmannsdorf',
    },
    {
      code: '145220210210',
      label: 'Großschirma',
      provincie: 14,
      slug: 'grossschirma',
    },
    {
      code: '145220220220',
      label: 'Großweitzschen',
      provincie: 14,
      slug: 'grossweitzschen',
    },
    {
      code: '145220230230',
      label: 'Hainichen',
      provincie: 14,
      slug: 'hainichen',
    },
    {
      code: '145220240240',
      label: 'Halsbrücke',
      provincie: 14,
      slug: 'halsbruecke',
    },
    {
      code: '145220250250',
      label: 'Hartha',
      provincie: 14,
      slug: 'hartha',
    },
    {
      code: '145220260260',
      label: 'Hartmannsdorf',
      provincie: 14,
      slug: 'hartmannsdorf',
    },
    {
      code: '145220275275',
      label: 'Jahnatal',
      provincie: 14,
      slug: 'jahnatal',
    },
    {
      code: '145220290290',
      label: 'Königshain-Wiederau',
      provincie: 14,
      slug: 'koenigshain-wiederau',
    },
    {
      code: '145220300300',
      label: 'Kriebstein',
      provincie: 14,
      slug: 'kriebstein',
    },
    {
      code: '145220310310',
      label: 'Leisnig',
      provincie: 14,
      slug: 'leisnig',
    },
    {
      code: '145220320320',
      label: 'Leubsdorf',
      provincie: 14,
      slug: 'leubsdorf-gemeinde',
    },
    {
      code: '145220330330',
      label: 'Lichtenau',
      provincie: 14,
      slug: 'lichtenau-gemeinde',
    },
    {
      code: '145220350350',
      label: 'Lunzenau',
      provincie: 14,
      slug: 'lunzenau',
    },
    {
      code: '145220390390',
      label: 'Mulda/Sa.',
      provincie: 14,
      slug: 'mulda-sa',
    },
    {
      code: '145220400400',
      label: 'Neuhausen/Erzgeb.',
      provincie: 14,
      slug: 'neuhausen-erzgeb',
    },
    {
      code: '145220420420',
      label: 'Niederwiesa',
      provincie: 14,
      slug: 'niederwiesa',
    },
    {
      code: '145220430430',
      label: 'Oberschöna',
      provincie: 14,
      slug: 'oberschoena',
    },
    {
      code: '145220440440',
      label: 'Oederan',
      provincie: 14,
      slug: 'oederan',
    },
    {
      code: '145220460460',
      label: 'Penig',
      provincie: 14,
      slug: 'penig',
    },
    {
      code: '145220470470',
      label: 'Rechenberg-Bienenmühle',
      provincie: 14,
      slug: 'rechenberg-bienenmuehle',
    },
    {
      code: '145220480480',
      label: 'Reinsberg',
      provincie: 14,
      slug: 'reinsberg',
    },
    {
      code: '145220500500',
      label: 'Rossau',
      provincie: 14,
      slug: 'rossau',
    },
    {
      code: '145220510510',
      label: 'Roßwein',
      provincie: 14,
      slug: 'rosswein',
    },
    {
      code: '145220540540',
      label: 'Striegistal',
      provincie: 14,
      slug: 'striegistal',
    },
    {
      code: '145220570570',
      label: 'Waldheim',
      provincie: 14,
      slug: 'waldheim',
    },
    {
      code: '145220580580',
      label: 'Wechselburg',
      provincie: 14,
      slug: 'wechselburg',
    },
    {
      code: '145225102060',
      label: 'Burgstädt',
      provincie: 14,
      slug: 'burgstaedt',
    },
    {
      code: '145225102380',
      label: 'Mühlau',
      provincie: 14,
      slug: 'muehlau',
    },
    {
      code: '145225102550',
      label: 'Taura',
      provincie: 14,
      slug: 'taura',
    },
    {
      code: '145225113340',
      label: 'Lichtenberg/Erzgeb.',
      provincie: 14,
      slug: 'lichtenberg-erzgeb',
    },
    {
      code: '145225113590',
      label: 'Weißenborn/Erzgeb.',
      provincie: 14,
      slug: 'weissenborn-erzgeb',
    },
    {
      code: '145225119010',
      label: 'Altmittweida',
      provincie: 14,
      slug: 'altmittweida',
    },
    {
      code: '145225119360',
      label: 'Mittweida',
      provincie: 14,
      slug: 'mittweida',
    },
    {
      code: '145225126280',
      label: 'Königsfeld',
      provincie: 14,
      slug: 'koenigsfeld-gemeinde',
    },
    {
      code: '145225126490',
      label: 'Rochlitz',
      provincie: 14,
      slug: 'rochlitz',
    },
    {
      code: '145225126530',
      label: 'Seelitz',
      provincie: 14,
      slug: 'seelitz',
    },
    {
      code: '145225126600',
      label: 'Zettlitz',
      provincie: 14,
      slug: 'zettlitz',
    },
    {
      code: '145225129090',
      label: 'Dorfchemnitz',
      provincie: 14,
      slug: 'dorfchemnitz',
    },
    {
      code: '145225129520',
      label: 'Sayda',
      provincie: 14,
      slug: 'sayda',
    },
    {
      code: '145230010010',
      label: 'Adorf/Vogtl.',
      provincie: 14,
      slug: 'adorf-vogtl',
    },
    {
      code: '145230020020',
      label: 'Auerbach/Vogtl.',
      provincie: 14,
      slug: 'auerbach-vogtl',
    },
    {
      code: '145230030030',
      label: 'Bad Brambach',
      provincie: 14,
      slug: 'bad-brambach',
    },
    {
      code: '145230040040',
      label: 'Bad Elster',
      provincie: 14,
      slug: 'bad-elster',
    },
    {
      code: '145230090090',
      label: 'Ellefeld',
      provincie: 14,
      slug: 'ellefeld',
    },
    {
      code: '145230100100',
      label: 'Elsterberg',
      provincie: 14,
      slug: 'elsterberg',
    },
    {
      code: '145230160160',
      label: 'Klingenthal',
      provincie: 14,
      slug: 'klingenthal',
    },
    {
      code: '145230170170',
      label: 'Lengenfeld',
      provincie: 14,
      slug: 'lengenfeld',
    },
    {
      code: '145230200200',
      label: 'Markneukirchen',
      provincie: 14,
      slug: 'markneukirchen',
    },
    {
      code: '145230245245',
      label: 'Muldenhammer',
      provincie: 14,
      slug: 'muldenhammer',
    },
    {
      code: '145230280280',
      label: 'Neumark',
      provincie: 14,
      slug: 'neumark',
    },
    {
      code: '145230310310',
      label: 'Pausa-Mühltroff',
      provincie: 14,
      slug: 'pausa-muehltroff',
    },
    {
      code: '145230320320',
      label: 'Plauen',
      provincie: 14,
      slug: 'plauen',
    },
    {
      code: '145230330330',
      label: 'Pöhl',
      provincie: 14,
      slug: 'poehl',
    },
    {
      code: '145230360360',
      label: 'Rodewisch',
      provincie: 14,
      slug: 'rodewisch',
    },
    {
      code: '145230365365',
      label: 'Rosenbach/Vogtl.',
      provincie: 14,
      slug: 'rosenbach-vogtl',
    },
    {
      code: '145230380380',
      label: 'Steinberg',
      provincie: 14,
      slug: 'steinberg-gemeinde',
    },
    {
      code: '145230450450',
      label: 'Weischlitz',
      provincie: 14,
      slug: 'weischlitz',
    },
    {
      code: '145235107120',
      label: 'Falkenstein/Vogtl.',
      provincie: 14,
      slug: 'falkenstein-vogtl',
    },
    {
      code: '145235107130',
      label: 'Grünbach',
      provincie: 14,
      slug: 'gruenbach',
    },
    {
      code: '145235107290',
      label: 'Neustadt/Vogtl.',
      provincie: 14,
      slug: 'neustadt-vogtl',
    },
    {
      code: '145235120190',
      label: 'Limbach',
      provincie: 14,
      slug: 'limbach-gemeinde',
    },
    {
      code: '145235120260',
      label: 'Netzschkau',
      provincie: 14,
      slug: 'netzschkau',
    },
    {
      code: '145235122060',
      label: 'Bösenbrunn',
      provincie: 14,
      slug: 'boesenbrunn',
    },
    {
      code: '145235122080',
      label: 'Eichigt',
      provincie: 14,
      slug: 'eichigt',
    },
    {
      code: '145235122300',
      label: 'Oelsnitz/Vogtl.',
      provincie: 14,
      slug: 'oelsnitz-vogtl',
    },
    {
      code: '145235122440',
      label: 'Triebel/Vogtl.',
      provincie: 14,
      slug: 'triebel-vogtl',
    },
    {
      code: '145235125150',
      label: 'Heinsdorfergrund',
      provincie: 14,
      slug: 'heinsdorfergrund',
    },
    {
      code: '145235125340',
      label: 'Reichenbach im Vogtland',
      provincie: 14,
      slug: 'reichenbach-im-vogtland',
    },
    {
      code: '145235131230',
      label: 'Mühlental',
      provincie: 14,
      slug: 'muehlental',
    },
    {
      code: '145235131370',
      label: 'Schöneck/Vogtl.',
      provincie: 14,
      slug: 'schoeneck-vogtl',
    },
    {
      code: '145235134270',
      label: 'Neuensalz',
      provincie: 14,
      slug: 'neuensalz',
    },
    {
      code: '145235134430',
      label: 'Treuen',
      provincie: 14,
      slug: 'treuen',
    },
    {
      code: '145235402050',
      label: 'Bergen',
      provincie: 14,
      slug: 'bergen-gemeinde',
    },
    {
      code: '145235402410',
      label: 'Theuma',
      provincie: 14,
      slug: 'theuma',
    },
    {
      code: '145235402420',
      label: 'Tirpersdorf',
      provincie: 14,
      slug: 'tirpersdorf',
    },
    {
      code: '145235402460',
      label: 'Werda',
      provincie: 14,
      slug: 'werda',
    },
    {
      code: '145240020020',
      label: 'Callenberg',
      provincie: 14,
      slug: 'callenberg',
    },
    {
      code: '145240060060',
      label: 'Fraureuth',
      provincie: 14,
      slug: 'fraureuth',
    },
    {
      code: '145240070070',
      label: 'Gersdorf',
      provincie: 14,
      slug: 'gersdorf',
    },
    {
      code: '145240080080',
      label: 'Glauchau',
      provincie: 14,
      slug: 'glauchau',
    },
    {
      code: '145240090090',
      label: 'Hartenstein',
      provincie: 14,
      slug: 'hartenstein-stadt',
    },
    {
      code: '145240120120',
      label: 'Hohenstein-Ernstthal',
      provincie: 14,
      slug: 'hohenstein-ernstthal',
    },
    {
      code: '145240140140',
      label: 'Langenbernsdorf',
      provincie: 14,
      slug: 'langenbernsdorf',
    },
    {
      code: '145240150150',
      label: 'Langenweißbach',
      provincie: 14,
      slug: 'langenweissbach',
    },
    {
      code: '145240170170',
      label: 'Lichtentanne',
      provincie: 14,
      slug: 'lichtentanne',
    },
    {
      code: '145240200200',
      label: 'Mülsen',
      provincie: 14,
      slug: 'muelsen',
    },
    {
      code: '145240210210',
      label: 'Neukirchen/Pleiße',
      provincie: 14,
      slug: 'neukirchen-pleisse',
    },
    {
      code: '145240230230',
      label: 'Oberlungwitz',
      provincie: 14,
      slug: 'oberlungwitz',
    },
    {
      code: '145240250250',
      label: 'Reinsdorf',
      provincie: 14,
      slug: 'reinsdorf',
    },
    {
      code: '145240300300',
      label: 'Werdau',
      provincie: 14,
      slug: 'werdau',
    },
    {
      code: '145240310310',
      label: 'Wildenfels',
      provincie: 14,
      slug: 'wildenfels',
    },
    {
      code: '145240320320',
      label: 'Wilkau-Haßlau',
      provincie: 14,
      slug: 'wilkau-hasslau',
    },
    {
      code: '145240330330',
      label: 'Zwickau',
      provincie: 14,
      slug: 'zwickau',
    },
    {
      code: '145245104030',
      label: 'Crimmitschau',
      provincie: 14,
      slug: 'crimmitschau',
    },
    {
      code: '145245104050',
      label: 'Dennheritz',
      provincie: 14,
      slug: 'dennheritz',
    },
    {
      code: '145245111040',
      label: 'Crinitzberg',
      provincie: 14,
      slug: 'crinitzberg',
    },
    {
      code: '145245111100',
      label: 'Hartmannsdorf b.Kirchberg',
      provincie: 14,
      slug: 'hartmannsdorf-b-kirchberg',
    },
    {
      code: '145245111110',
      label: 'Hirschfeld',
      provincie: 14,
      slug: 'hirschfeld-gemeinde',
    },
    {
      code: '145245111130',
      label: 'Kirchberg',
      provincie: 14,
      slug: 'kirchberg-stadt',
    },
    {
      code: '145245114180',
      label: 'Limbach-Oberfrohna',
      provincie: 14,
      slug: 'limbach-oberfrohna',
    },
    {
      code: '145245114220',
      label: 'Niederfrohna',
      provincie: 14,
      slug: 'niederfrohna',
    },
    {
      code: '145245118190',
      label: 'Meerane',
      provincie: 14,
      slug: 'meerane',
    },
    {
      code: '145245118270',
      label: 'Schönberg',
      provincie: 14,
      slug: 'schoenberg-gemeinde',
    },
    {
      code: '145245128010',
      label: 'Bernsdorf',
      provincie: 14,
      slug: 'bernsdorf',
    },
    {
      code: '145245128160',
      label: 'Lichtenstein/Sa.',
      provincie: 14,
      slug: 'lichtenstein-sa',
    },
    {
      code: '145245128280',
      label: 'St. Egidien',
      provincie: 14,
      slug: 'st-egidien',
    },
    {
      code: '145245135240',
      label: 'Oberwiera',
      provincie: 14,
      slug: 'oberwiera',
    },
    {
      code: '145245135260',
      label: 'Remse',
      provincie: 14,
      slug: 'remse',
    },
    {
      code: '145245135290',
      label: 'Waldenburg',
      provincie: 14,
      slug: 'waldenburg-stadt',
    },
    {
      code: '146120000000',
      label: 'Dresden',
      provincie: 14,
      slug: 'dresden',
    },
    {
      code: '146250010010',
      label: 'Arnsdorf',
      provincie: 14,
      slug: 'arnsdorf',
    },
    {
      code: '146250020020',
      label: 'Bautzen',
      provincie: 14,
      slug: 'bautzen',
    },
    {
      code: '146250030030',
      label: 'Bernsdorf',
      provincie: 14,
      slug: 'bernsdorf-stadt',
    },
    {
      code: '146250060060',
      label: 'Burkau',
      provincie: 14,
      slug: 'burkau',
    },
    {
      code: '146250090090',
      label: 'Cunewalde',
      provincie: 14,
      slug: 'cunewalde',
    },
    {
      code: '146250100100',
      label: 'Demitz-Thumitz',
      provincie: 14,
      slug: 'demitz-thumitz',
    },
    {
      code: '146250110110',
      label: 'Doberschau-Gaußig',
      provincie: 14,
      slug: 'doberschau-gaussig',
    },
    {
      code: '146250120120',
      label: 'Elsterheide',
      provincie: 14,
      slug: 'elsterheide',
    },
    {
      code: '146250130130',
      label: 'Elstra',
      provincie: 14,
      slug: 'elstra',
    },
    {
      code: '146250150150',
      label: 'Göda',
      provincie: 14,
      slug: 'goeda',
    },
    {
      code: '146250160160',
      label: 'Großdubrau',
      provincie: 14,
      slug: 'grossdubrau',
    },
    {
      code: '146250200200',
      label: 'Großröhrsdorf',
      provincie: 14,
      slug: 'grossroehrsdorf',
    },
    {
      code: '146250220220',
      label: 'Haselbachtal',
      provincie: 14,
      slug: 'haselbachtal',
    },
    {
      code: '146250230230',
      label: 'Hochkirch',
      provincie: 14,
      slug: 'hochkirch',
    },
    {
      code: '146250240240',
      label: 'Hoyerswerda',
      provincie: 14,
      slug: 'hoyerswerda',
    },
    {
      code: '146250250250',
      label: 'Kamenz',
      provincie: 14,
      slug: 'kamenz',
    },
    {
      code: '146250280280',
      label: 'Königswartha',
      provincie: 14,
      slug: 'koenigswartha',
    },
    {
      code: '146250290290',
      label: 'Kubschütz',
      provincie: 14,
      slug: 'kubschuetz',
    },
    {
      code: '146250310310',
      label: 'Lauta',
      provincie: 14,
      slug: 'lauta',
    },
    {
      code: '146250330330',
      label: 'Lohsa',
      provincie: 14,
      slug: 'lohsa',
    },
    {
      code: '146250340340',
      label: 'Malschwitz',
      provincie: 14,
      slug: 'malschwitz',
    },
    {
      code: '146250380380',
      label: 'Neukirch/Lausitz',
      provincie: 14,
      slug: 'neukirch-lausitz',
    },
    {
      code: '146250420420',
      label: 'Oßling',
      provincie: 14,
      slug: 'ossling',
    },
    {
      code: '146250430430',
      label: 'Ottendorf-Okrilla',
      provincie: 14,
      slug: 'ottendorf-okrilla',
    },
    {
      code: '146250480480',
      label: 'Radeberg',
      provincie: 14,
      slug: 'radeberg',
    },
    {
      code: '146250490490',
      label: 'Radibor',
      provincie: 14,
      slug: 'radibor',
    },
    {
      code: '146250525525',
      label: 'Schirgiswalde-Kirschau',
      provincie: 14,
      slug: 'schirgiswalde-kirschau',
    },
    {
      code: '146250530530',
      label: 'Schmölln-Putzkau',
      provincie: 14,
      slug: 'schmoelln-putzkau',
    },
    {
      code: '146250550550',
      label: 'Schwepnitz',
      provincie: 14,
      slug: 'schwepnitz',
    },
    {
      code: '146250560560',
      label: 'Sohland a.d.Spree',
      provincie: 14,
      slug: 'sohland-a-d-spree',
    },
    {
      code: '146250570570',
      label: 'Spreetal',
      provincie: 14,
      slug: 'spreetal',
    },
    {
      code: '146250590590',
      label: 'Steinigtwolmsdorf',
      provincie: 14,
      slug: 'steinigtwolmsdorf',
    },
    {
      code: '146250600600',
      label: 'Wachau',
      provincie: 14,
      slug: 'wachau',
    },
    {
      code: '146250610610',
      label: 'Weißenberg',
      provincie: 14,
      slug: 'weissenberg',
    },
    {
      code: '146250630630',
      label: 'Wilthen',
      provincie: 14,
      slug: 'wilthen',
    },
    {
      code: '146250640640',
      label: 'Wittichenau',
      provincie: 14,
      slug: 'wittichenau',
    },
    {
      code: '146255207040',
      label: 'Bischofswerda',
      provincie: 14,
      slug: 'bischofswerda',
    },
    {
      code: '146255207510',
      label: 'Rammenau',
      provincie: 14,
      slug: 'rammenau',
    },
    {
      code: '146255211140',
      label: 'Frankenthal',
      provincie: 14,
      slug: 'frankenthal',
    },
    {
      code: '146255211170',
      label: 'Großharthau',
      provincie: 14,
      slug: 'grossharthau',
    },
    {
      code: '146255212190',
      label: 'Großpostwitz/O.L.',
      provincie: 14,
      slug: 'grosspostwitz-o-l',
    },
    {
      code: '146255212390',
      label: 'Obergurig',
      provincie: 14,
      slug: 'obergurig',
    },
    {
      code: '146255218270',
      label: 'Königsbrück',
      provincie: 14,
      slug: 'koenigsbrueck',
    },
    {
      code: '146255218300',
      label: 'Laußnitz',
      provincie: 14,
      slug: 'laussnitz',
    },
    {
      code: '146255218370',
      label: 'Neukirch',
      provincie: 14,
      slug: 'neukirch-gemeinde',
    },
    {
      code: '146255223360',
      label: 'Neschwitz',
      provincie: 14,
      slug: 'neschwitz',
    },
    {
      code: '146255223460',
      label: 'Puschwitz',
      provincie: 14,
      slug: 'puschwitz',
    },
    {
      code: '146255231180',
      label: 'Großnaundorf',
      provincie: 14,
      slug: 'grossnaundorf',
    },
    {
      code: '146255231320',
      label: 'Lichtenberg',
      provincie: 14,
      slug: 'lichtenberg-gemeinde',
    },
    {
      code: '146255231410',
      label: 'Ohorn',
      provincie: 14,
      slug: 'ohorn',
    },
    {
      code: '146255231450',
      label: 'Pulsnitz',
      provincie: 14,
      slug: 'pulsnitz',
    },
    {
      code: '146255231580',
      label: 'Steina',
      provincie: 14,
      slug: 'steina',
    },
    {
      code: '146255501080',
      label: 'Crostwitz',
      provincie: 14,
      slug: 'crostwitz',
    },
    {
      code: '146255501350',
      label: 'Nebelschütz',
      provincie: 14,
      slug: 'nebelschuetz',
    },
    {
      code: '146255501440',
      label: 'Panschwitz-Kuckau',
      provincie: 14,
      slug: 'panschwitz-kuckau',
    },
    {
      code: '146255501470',
      label: 'Räckelwitz',
      provincie: 14,
      slug: 'raeckelwitz',
    },
    {
      code: '146255501500',
      label: 'Ralbitz-Rosenthal',
      provincie: 14,
      slug: 'ralbitz-rosenthal',
    },
    {
      code: '146260060060',
      label: 'Boxberg/O.L.',
      provincie: 14,
      slug: 'boxberg-o-l',
    },
    {
      code: '146260085085',
      label: 'Ebersbach-Neugersdorf',
      provincie: 14,
      slug: 'ebersbach-neugersdorf',
    },
    {
      code: '146260110110',
      label: 'Görlitz',
      provincie: 14,
      slug: 'goerlitz',
    },
    {
      code: '146260180180',
      label: 'Herrnhut',
      provincie: 14,
      slug: 'herrnhut',
    },
    {
      code: '146260245245',
      label: 'Kottmar',
      provincie: 14,
      slug: 'kottmar',
    },
    {
      code: '146260250250',
      label: 'Krauschwitz i.d.O.L.',
      provincie: 14,
      slug: 'krauschwitz-i-d-o-l',
    },
    {
      code: '146260280280',
      label: 'Leutersdorf',
      provincie: 14,
      slug: 'leutersdorf',
    },
    {
      code: '146260300300',
      label: 'Markersdorf',
      provincie: 14,
      slug: 'markersdorf',
    },
    {
      code: '146260310310',
      label: 'Mittelherwigsdorf',
      provincie: 14,
      slug: 'mittelherwigsdorf',
    },
    {
      code: '146260370370',
      label: 'Niesky',
      provincie: 14,
      slug: 'niesky',
    },
    {
      code: '146260390390',
      label: 'Oderwitz',
      provincie: 14,
      slug: 'oderwitz',
    },
    {
      code: '146260420420',
      label: 'Ostritz',
      provincie: 14,
      slug: 'ostritz',
    },
    {
      code: '146260530530',
      label: 'Seifhennersdorf',
      provincie: 14,
      slug: 'seifhennersdorf',
    },
    {
      code: '146260610610',
      label: 'Zittau',
      provincie: 14,
      slug: 'zittau',
    },
    {
      code: '146265203010',
      label: 'Bad Muskau',
      provincie: 14,
      slug: 'bad-muskau',
    },
    {
      code: '146265203100',
      label: 'Gablenz',
      provincie: 14,
      slug: 'gablenz',
    },
    {
      code: '146265206030',
      label: 'Bernstadt a.d.Eigen',
      provincie: 14,
      slug: 'bernstadt-a-d-eigen',
    },
    {
      code: '146265206500',
      label: 'Schönau-Berzdorf a.d.Eigen',
      provincie: 14,
      slug: 'schoenau-berzdorf-a-d-eigen',
    },
    {
      code: '146265214140',
      label: 'Großschönau',
      provincie: 14,
      slug: 'grossschoenau',
    },
    {
      code: '146265214170',
      label: 'Hainewalde',
      provincie: 14,
      slug: 'hainewalde',
    },
    {
      code: '146265220150',
      label: 'Großschweidnitz',
      provincie: 14,
      slug: 'grossschweidnitz',
    },
    {
      code: '146265220270',
      label: 'Lawalde',
      provincie: 14,
      slug: 'lawalde',
    },
    {
      code: '146265220290',
      label: 'Löbau',
      provincie: 14,
      slug: 'loebau',
    },
    {
      code: '146265220470',
      label: 'Rosenbach',
      provincie: 14,
      slug: 'rosenbach',
    },
    {
      code: '146265224070',
      label: 'Dürrhennersdorf',
      provincie: 14,
      slug: 'duerrhennersdorf',
    },
    {
      code: '146265224350',
      label: 'Neusalza-Spremberg',
      provincie: 14,
      slug: 'neusalza-spremberg',
    },
    {
      code: '146265224510',
      label: 'Schönbach',
      provincie: 14,
      slug: 'schoenbach-gemeinde',
    },
    {
      code: '146265227050',
      label: 'Bertsdorf-Hörnitz',
      provincie: 14,
      slug: 'bertsdorf-hoernitz',
    },
    {
      code: '146265227210',
      label: 'Jonsdorf',
      provincie: 14,
      slug: 'jonsdorf',
    },
    {
      code: '146265227400',
      label: 'Olbersdorf',
      provincie: 14,
      slug: 'olbersdorf',
    },
    {
      code: '146265227430',
      label: 'Oybin',
      provincie: 14,
      slug: 'oybin',
    },
    {
      code: '146265228020',
      label: 'Beiersdorf',
      provincie: 14,
      slug: 'beiersdorf',
    },
    {
      code: '146265228410',
      label: 'Oppach',
      provincie: 14,
      slug: 'oppach',
    },
    {
      code: '146265232240',
      label: 'Königshain',
      provincie: 14,
      slug: 'koenigshain',
    },
    {
      code: '146265232450',
      label: 'Reichenbach/O.L.',
      provincie: 14,
      slug: 'reichenbach-o-l',
    },
    {
      code: '146265232570',
      label: 'Vierkirchen',
      provincie: 14,
      slug: 'vierkirchen-gemeinde',
    },
    {
      code: '146265233260',
      label: 'Kreba-Neudorf',
      provincie: 14,
      slug: 'kreba-neudorf',
    },
    {
      code: '146265233460',
      label: 'Rietschen',
      provincie: 14,
      slug: 'rietschen',
    },
    {
      code: '146265235160',
      label: 'Hähnichen',
      provincie: 14,
      slug: 'haehnichen',
    },
    {
      code: '146265235480',
      label: 'Rothenburg/O.L.',
      provincie: 14,
      slug: 'rothenburg-o-l',
    },
    {
      code: '146265237120',
      label: 'Groß Düben',
      provincie: 14,
      slug: 'gross-dueben',
    },
    {
      code: '146265237490',
      label: 'Schleife',
      provincie: 14,
      slug: 'schleife',
    },
    {
      code: '146265237560',
      label: 'Trebendorf',
      provincie: 14,
      slug: 'trebendorf',
    },
    {
      code: '146265242590',
      label: 'Weißkeißel',
      provincie: 14,
      slug: 'weisskeissel',
    },
    {
      code: '146265242600',
      label: 'Weißwasser/O.L.',
      provincie: 14,
      slug: 'weisswasser-o-l',
    },
    {
      code: '146265502190',
      label: 'Hohendubrau',
      provincie: 14,
      slug: 'hohendubrau',
    },
    {
      code: '146265502320',
      label: 'Mücka',
      provincie: 14,
      slug: 'muecka',
    },
    {
      code: '146265502440',
      label: 'Quitzdorf am See',
      provincie: 14,
      slug: 'quitzdorf-am-see',
    },
    {
      code: '146265502580',
      label: 'Waldhufen',
      provincie: 14,
      slug: 'waldhufen',
    },
    {
      code: '146265503200',
      label: 'Horka',
      provincie: 14,
      slug: 'horka',
    },
    {
      code: '146265503230',
      label: 'Kodersdorf',
      provincie: 14,
      slug: 'kodersdorf',
    },
    {
      code: '146265503330',
      label: 'Neißeaue',
      provincie: 14,
      slug: 'neisseaue',
    },
    {
      code: '146265503520',
      label: 'Schöpstal',
      provincie: 14,
      slug: 'schoepstal',
    },
    {
      code: '146270010010',
      label: 'Coswig',
      provincie: 14,
      slug: 'coswig',
    },
    {
      code: '146270020020',
      label: 'Diera-Zehren',
      provincie: 14,
      slug: 'diera-zehren',
    },
    {
      code: '146270030030',
      label: 'Ebersbach',
      provincie: 14,
      slug: 'ebersbach',
    },
    {
      code: '146270050050',
      label: 'Gröditz',
      provincie: 14,
      slug: 'groeditz',
    },
    {
      code: '146270060060',
      label: 'Großenhain',
      provincie: 14,
      slug: 'grossenhain',
    },
    {
      code: '146270070070',
      label: 'Hirschstein',
      provincie: 14,
      slug: 'hirschstein',
    },
    {
      code: '146270080080',
      label: 'Käbschütztal',
      provincie: 14,
      slug: 'kaebschuetztal',
    },
    {
      code: '146270100100',
      label: 'Klipphausen',
      provincie: 14,
      slug: 'klipphausen',
    },
    {
      code: '146270130130',
      label: 'Lommatzsch',
      provincie: 14,
      slug: 'lommatzsch',
    },
    {
      code: '146270140140',
      label: 'Meißen',
      provincie: 14,
      slug: 'meissen',
    },
    {
      code: '146270150150',
      label: 'Moritzburg',
      provincie: 14,
      slug: 'moritzburg',
    },
    {
      code: '146270170170',
      label: 'Niederau',
      provincie: 14,
      slug: 'niederau',
    },
    {
      code: '146270180180',
      label: 'Nossen',
      provincie: 14,
      slug: 'nossen',
    },
    {
      code: '146270200200',
      label: 'Priestewitz',
      provincie: 14,
      slug: 'priestewitz',
    },
    {
      code: '146270210210',
      label: 'Radebeul',
      provincie: 14,
      slug: 'radebeul',
    },
    {
      code: '146270220220',
      label: 'Radeburg',
      provincie: 14,
      slug: 'radeburg',
    },
    {
      code: '146270230230',
      label: 'Riesa',
      provincie: 14,
      slug: 'riesa',
    },
    {
      code: '146270260260',
      label: 'Stauchitz',
      provincie: 14,
      slug: 'stauchitz',
    },
    {
      code: '146270270270',
      label: 'Strehla',
      provincie: 14,
      slug: 'strehla',
    },
    {
      code: '146270290290',
      label: 'Thiendorf',
      provincie: 14,
      slug: 'thiendorf',
    },
    {
      code: '146270310310',
      label: 'Weinböhla',
      provincie: 14,
      slug: 'weinboehla',
    },
    {
      code: '146270360360',
      label: 'Zeithain',
      provincie: 14,
      slug: 'zeithain',
    },
    {
      code: '146275225040',
      label: 'Glaubitz',
      provincie: 14,
      slug: 'glaubitz',
    },
    {
      code: '146275225190',
      label: 'Nünchritz',
      provincie: 14,
      slug: 'nuenchritz',
    },
    {
      code: '146275234240',
      label: 'Röderaue',
      provincie: 14,
      slug: 'roederaue',
    },
    {
      code: '146275234340',
      label: 'Wülknitz',
      provincie: 14,
      slug: 'wuelknitz',
    },
    {
      code: '146275238110',
      label: 'Lampertswalde',
      provincie: 14,
      slug: 'lampertswalde',
    },
    {
      code: '146275238250',
      label: 'Schönfeld',
      provincie: 14,
      slug: 'schoenfeld-gemeinde',
    },
    {
      code: '146280050050',
      label: 'Bannewitz',
      provincie: 14,
      slug: 'bannewitz',
    },
    {
      code: '146280060060',
      label: 'Dippoldiswalde',
      provincie: 14,
      slug: 'dippoldiswalde',
    },
    {
      code: '146280100100',
      label: 'Dürrröhrsdorf-Dittersbach',
      provincie: 14,
      slug: 'duerrroehrsdorf-dittersbach',
    },
    {
      code: '146280110110',
      label: 'Freital',
      provincie: 14,
      slug: 'freital',
    },
    {
      code: '146280130130',
      label: 'Glashütte',
      provincie: 14,
      slug: 'glashuette',
    },
    {
      code: '146280160160',
      label: 'Heidenau',
      provincie: 14,
      slug: 'heidenau-stadt',
    },
    {
      code: '146280190190',
      label: 'Hohnstein',
      provincie: 14,
      slug: 'hohnstein',
    },
    {
      code: '146280220220',
      label: 'Kreischa',
      provincie: 14,
      slug: 'kreischa',
    },
    {
      code: '146280260260',
      label: 'Neustadt in Sachsen',
      provincie: 14,
      slug: 'neustadt-in-sachsen',
    },
    {
      code: '146280300300',
      label: 'Rabenau',
      provincie: 14,
      slug: 'rabenau-stadt',
    },
    {
      code: '146280360360',
      label: 'Sebnitz',
      provincie: 14,
      slug: 'sebnitz',
    },
    {
      code: '146280380380',
      label: 'Stolpen',
      provincie: 14,
      slug: 'stolpen',
    },
    {
      code: '146280410410',
      label: 'Wilsdruff',
      provincie: 14,
      slug: 'wilsdruff',
    },
    {
      code: '146285201010',
      label: 'Altenberg',
      provincie: 14,
      slug: 'altenberg',
    },
    {
      code: '146285201170',
      label: 'Hermsdorf/Erzgeb.',
      provincie: 14,
      slug: 'hermsdorf-erzgeb',
    },
    {
      code: '146285202020',
      label: 'Bad Gottleuba-Berggießhübel',
      provincie: 14,
      slug: 'bad-gottleuba-berggiesshuebel',
    },
    {
      code: '146285202040',
      label: 'Bahretal',
      provincie: 14,
      slug: 'bahretal',
    },
    {
      code: '146285202230',
      label: 'Liebstadt',
      provincie: 14,
      slug: 'liebstadt',
    },
    {
      code: '146285204030',
      label: 'Bad Schandau',
      provincie: 14,
      slug: 'bad-schandau',
    },
    {
      code: '146285204320',
      label: 'Rathmannsdorf',
      provincie: 14,
      slug: 'rathmannsdorf',
    },
    {
      code: '146285204330',
      label: 'Reinhardtsdorf-Schöna',
      provincie: 14,
      slug: 'reinhardtsdorf-schoena',
    },
    {
      code: '146285209080',
      label: 'Dohna',
      provincie: 14,
      slug: 'dohna',
    },
    {
      code: '146285209250',
      label: 'Müglitztal',
      provincie: 14,
      slug: 'mueglitztal',
    },
    {
      code: '146285219140',
      label: 'Gohrisch',
      provincie: 14,
      slug: 'gohrisch',
    },
    {
      code: '146285219210',
      label: 'Königstein/Sächs.Schw.',
      provincie: 14,
      slug: 'koenigstein-saechs-schw',
    },
    {
      code: '146285219310',
      label: 'Rathen',
      provincie: 14,
      slug: 'rathen',
    },
    {
      code: '146285219340',
      label: 'Rosenthal-Bielatal',
      provincie: 14,
      slug: 'rosenthal-bielatal',
    },
    {
      code: '146285219390',
      label: 'Struppen',
      provincie: 14,
      slug: 'struppen',
    },
    {
      code: '146285221240',
      label: 'Lohmen',
      provincie: 14,
      slug: 'lohmen-gemeinde',
    },
    {
      code: '146285221370',
      label: 'Stadt Wehlen',
      provincie: 14,
      slug: 'stadt-wehlen',
    },
    {
      code: '146285229070',
      label: 'Dohma',
      provincie: 14,
      slug: 'dohma',
    },
    {
      code: '146285229270',
      label: 'Pirna',
      provincie: 14,
      slug: 'pirna',
    },
    {
      code: '146285230150',
      label: 'Hartmannsdorf-Reichenau',
      provincie: 14,
      slug: 'hartmannsdorf-reichenau',
    },
    {
      code: '146285230205',
      label: 'Klingenberg',
      provincie: 14,
      slug: 'klingenberg',
    },
    {
      code: '146285240090',
      label: 'Dorfhain',
      provincie: 14,
      slug: 'dorfhain',
    },
    {
      code: '146285240400',
      label: 'Tharandt',
      provincie: 14,
      slug: 'tharandt',
    },
    {
      code: '147130000000',
      label: 'Leipzig',
      provincie: 14,
      slug: 'leipzig',
    },
    {
      code: '147290030030',
      label: 'Bennewitz',
      provincie: 14,
      slug: 'bennewitz',
    },
    {
      code: '147290040040',
      label: 'Böhlen',
      provincie: 14,
      slug: 'boehlen',
    },
    {
      code: '147290050050',
      label: 'Borna',
      provincie: 14,
      slug: 'borna',
    },
    {
      code: '147290060060',
      label: 'Borsdorf',
      provincie: 14,
      slug: 'borsdorf',
    },
    {
      code: '147290070070',
      label: 'Brandis',
      provincie: 14,
      slug: 'brandis',
    },
    {
      code: '147290080080',
      label: 'Colditz',
      provincie: 14,
      slug: 'colditz',
    },
    {
      code: '147290140140',
      label: 'Frohburg',
      provincie: 14,
      slug: 'frohburg',
    },
    {
      code: '147290150150',
      label: 'Geithain',
      provincie: 14,
      slug: 'geithain',
    },
    {
      code: '147290160160',
      label: 'Grimma',
      provincie: 14,
      slug: 'grimma',
    },
    {
      code: '147290170170',
      label: 'Groitzsch',
      provincie: 14,
      slug: 'groitzsch',
    },
    {
      code: '147290190190',
      label: 'Großpösna',
      provincie: 14,
      slug: 'grosspoesna',
    },
    {
      code: '147290220220',
      label: 'Kitzscher',
      provincie: 14,
      slug: 'kitzscher',
    },
    {
      code: '147290245245',
      label: 'Lossatal',
      provincie: 14,
      slug: 'lossatal',
    },
    {
      code: '147290250250',
      label: 'Machern',
      provincie: 14,
      slug: 'machern',
    },
    {
      code: '147290260260',
      label: 'Markkleeberg',
      provincie: 14,
      slug: 'markkleeberg',
    },
    {
      code: '147290270270',
      label: 'Markranstädt',
      provincie: 14,
      slug: 'markranstaedt',
    },
    {
      code: '147290320320',
      label: 'Neukieritzsch',
      provincie: 14,
      slug: 'neukieritzsch',
    },
    {
      code: '147290360360',
      label: 'Regis-Breitingen',
      provincie: 14,
      slug: 'regis-breitingen',
    },
    {
      code: '147290370370',
      label: 'Rötha',
      provincie: 14,
      slug: 'roetha',
    },
    {
      code: '147290380380',
      label: 'Thallwitz',
      provincie: 14,
      slug: 'thallwitz',
    },
    {
      code: '147290400400',
      label: 'Trebsen/Mulde',
      provincie: 14,
      slug: 'trebsen-mulde',
    },
    {
      code: '147290410410',
      label: 'Wurzen',
      provincie: 14,
      slug: 'wurzen',
    },
    {
      code: '147290430430',
      label: 'Zwenkau',
      provincie: 14,
      slug: 'zwenkau',
    },
    {
      code: '147295301010',
      label: 'Bad Lausick',
      provincie: 14,
      slug: 'bad-lausick',
    },
    {
      code: '147295301330',
      label: 'Otterwisch',
      provincie: 14,
      slug: 'otterwisch',
    },
    {
      code: '147295307020',
      label: 'Belgershain',
      provincie: 14,
      slug: 'belgershain',
    },
    {
      code: '147295307300',
      label: 'Naunhof',
      provincie: 14,
      slug: 'naunhof',
    },
    {
      code: '147295307340',
      label: 'Parthenstein',
      provincie: 14,
      slug: 'parthenstein',
    },
    {
      code: '147295308100',
      label: 'Elstertrebnitz',
      provincie: 14,
      slug: 'elstertrebnitz',
    },
    {
      code: '147295308350',
      label: 'Pegau',
      provincie: 14,
      slug: 'pegau',
    },
    {
      code: '147300020020',
      label: 'Bad Düben',
      provincie: 14,
      slug: 'bad-dueben',
    },
    {
      code: '147300045045',
      label: 'Belgern-Schildau',
      provincie: 14,
      slug: 'belgern-schildau',
    },
    {
      code: '147300050050',
      label: 'Cavertitz',
      provincie: 14,
      slug: 'cavertitz',
    },
    {
      code: '147300060060',
      label: 'Dahlen',
      provincie: 14,
      slug: 'dahlen',
    },
    {
      code: '147300070070',
      label: 'Delitzsch',
      provincie: 14,
      slug: 'delitzsch',
    },
    {
      code: '147300080080',
      label: 'Doberschütz',
      provincie: 14,
      slug: 'doberschuetz',
    },
    {
      code: '147300110110',
      label: 'Eilenburg',
      provincie: 14,
      slug: 'eilenburg',
    },
    {
      code: '147300160160',
      label: 'Laußig',
      provincie: 14,
      slug: 'laussig',
    },
    {
      code: '147300170170',
      label: 'Liebschützberg',
      provincie: 14,
      slug: 'liebschuetzberg',
    },
    {
      code: '147300180180',
      label: 'Löbnitz',
      provincie: 14,
      slug: 'loebnitz-gemeinde',
    },
    {
      code: '147300190190',
      label: 'Mockrehna',
      provincie: 14,
      slug: 'mockrehna',
    },
    {
      code: '147300200200',
      label: 'Mügeln',
      provincie: 14,
      slug: 'muegeln',
    },
    {
      code: '147300210210',
      label: 'Naundorf',
      provincie: 14,
      slug: 'naundorf',
    },
    {
      code: '147300230230',
      label: 'Oschatz',
      provincie: 14,
      slug: 'oschatz',
    },
    {
      code: '147300250250',
      label: 'Rackwitz',
      provincie: 14,
      slug: 'rackwitz',
    },
    {
      code: '147300270270',
      label: 'Schkeuditz',
      provincie: 14,
      slug: 'schkeuditz',
    },
    {
      code: '147300300300',
      label: 'Taucha',
      provincie: 14,
      slug: 'taucha',
    },
    {
      code: '147300330330',
      label: 'Wermsdorf',
      provincie: 14,
      slug: 'wermsdorf',
    },
    {
      code: '147300340340',
      label: 'Wiedemar',
      provincie: 14,
      slug: 'wiedemar',
    },
    {
      code: '147305302010',
      label: 'Arzberg',
      provincie: 14,
      slug: 'arzberg-gemeinde',
    },
    {
      code: '147305302030',
      label: 'Beilrode',
      provincie: 14,
      slug: 'beilrode',
    },
    {
      code: '147305303090',
      label: 'Dommitzsch',
      provincie: 14,
      slug: 'dommitzsch',
    },
    {
      code: '147305303120',
      label: 'Elsnig',
      provincie: 14,
      slug: 'elsnig',
    },
    {
      code: '147305303320',
      label: 'Trossin',
      provincie: 14,
      slug: 'trossin',
    },
    {
      code: '147305306150',
      label: 'Krostitz',
      provincie: 14,
      slug: 'krostitz',
    },
    {
      code: '147305306280',
      label: 'Schönwölkau',
      provincie: 14,
      slug: 'schoenwoelkau',
    },
    {
      code: '147305311100',
      label: 'Dreiheide',
      provincie: 14,
      slug: 'dreiheide',
    },
    {
      code: '147305311310',
      label: 'Torgau',
      provincie: 14,
      slug: 'torgau',
    },
    {
      code: '147305601140',
      label: 'Jesewitz',
      provincie: 14,
      slug: 'jesewitz',
    },
    {
      code: '147305601360',
      label: 'Zschepplin',
      provincie: 14,
      slug: 'zschepplin',
    },
    {
      code: '150010000000',
      label: 'Dessau-Roßlau',
      provincie: 15,
      slug: 'dessau-rosslau',
    },
    {
      code: '150020000000',
      label: 'Halle (Saale)',
      provincie: 15,
      slug: 'halle-saale',
    },
    {
      code: '150030000000',
      label: 'Magdeburg',
      provincie: 15,
      slug: 'magdeburg',
    },
    {
      code: '150810030030',
      label: 'Arendsee (Altmark)',
      provincie: 15,
      slug: 'arendsee-altmark',
    },
    {
      code: '150810135135',
      label: 'Gardelegen',
      provincie: 15,
      slug: 'gardelegen',
    },
    {
      code: '150810240240',
      label: 'Kalbe (Milde)',
      provincie: 15,
      slug: 'kalbe-milde',
    },
    {
      code: '150810280280',
      label: 'Klötze',
      provincie: 15,
      slug: 'kloetze',
    },
    {
      code: '150810455455',
      label: 'Salzwedel',
      provincie: 15,
      slug: 'salzwedel',
    },
    {
      code: '150815051026',
      label: 'Apenburg-Winterfeld',
      provincie: 15,
      slug: 'apenburg-winterfeld',
    },
    {
      code: '150815051045',
      label: 'Beetzendorf',
      provincie: 15,
      slug: 'beetzendorf',
    },
    {
      code: '150815051095',
      label: 'Dähre',
      provincie: 15,
      slug: 'daehre',
    },
    {
      code: '150815051105',
      label: 'Diesdorf',
      provincie: 15,
      slug: 'diesdorf',
    },
    {
      code: '150815051225',
      label: 'Jübar',
      provincie: 15,
      slug: 'juebar',
    },
    {
      code: '150815051290',
      label: 'Kuhfelde',
      provincie: 15,
      slug: 'kuhfelde',
    },
    {
      code: '150815051440',
      label: 'Rohrberg',
      provincie: 15,
      slug: 'rohrberg',
    },
    {
      code: '150815051545',
      label: 'Wallstawe',
      provincie: 15,
      slug: 'wallstawe',
    },
    {
      code: '150820005005',
      label: 'Aken (Elbe)',
      provincie: 15,
      slug: 'aken-elbe',
    },
    {
      code: '150820015015',
      label: 'Bitterfeld-Wolfen',
      provincie: 15,
      slug: 'bitterfeld-wolfen',
    },
    {
      code: '150820180180',
      label: 'Köthen (Anhalt)',
      provincie: 15,
      slug: 'koethen-anhalt',
    },
    {
      code: '150820241241',
      label: 'Muldestausee',
      provincie: 15,
      slug: 'muldestausee',
    },
    {
      code: '150820256256',
      label: 'Osternienburger Land',
      provincie: 15,
      slug: 'osternienburger-land',
    },
    {
      code: '150820301301',
      label: 'Raguhn-Jeßnitz',
      provincie: 15,
      slug: 'raguhn-jessnitz',
    },
    {
      code: '150820340340',
      label: 'Sandersdorf-Brehna',
      provincie: 15,
      slug: 'sandersdorf-brehna',
    },
    {
      code: '150820377377',
      label: 'Südliches Anhalt',
      provincie: 15,
      slug: 'suedliches-anhalt',
    },
    {
      code: '150820430430',
      label: 'Zerbst/Anhalt',
      provincie: 15,
      slug: 'zerbst-anhalt',
    },
    {
      code: '150820440440',
      label: 'Zörbig',
      provincie: 15,
      slug: 'zoerbig',
    },
    {
      code: '150830040040',
      label: 'Barleben',
      provincie: 15,
      slug: 'barleben',
    },
    {
      code: '150830270270',
      label: 'Haldensleben',
      provincie: 15,
      slug: 'haldensleben',
    },
    {
      code: '150830298298',
      label: 'Hohe Börde',
      provincie: 15,
      slug: 'hohe-boerde',
    },
    {
      code: '150830390390',
      label: 'Niedere Börde',
      provincie: 15,
      slug: 'niedere-boerde',
    },
    {
      code: '150830411411',
      label: 'Oebisfelde-Weferlingen',
      provincie: 15,
      slug: 'oebisfelde-weferlingen',
    },
    {
      code: '150830415415',
      label: 'Oschersleben (Bode)',
      provincie: 15,
      slug: 'oschersleben-bode',
    },
    {
      code: '150830490490',
      label: 'Sülzetal',
      provincie: 15,
      slug: 'suelzetal',
    },
    {
      code: '150830531531',
      label: 'Wanzleben-Börde',
      provincie: 15,
      slug: 'wanzleben-boerde',
    },
    {
      code: '150830565565',
      label: 'Wolmirstedt',
      provincie: 15,
      slug: 'wolmirstedt',
    },
    {
      code: '150835051030',
      label: 'Angern',
      provincie: 15,
      slug: 'angern',
    },
    {
      code: '150835051120',
      label: 'Burgstall',
      provincie: 15,
      slug: 'burgstall',
    },
    {
      code: '150835051130',
      label: 'Colbitz',
      provincie: 15,
      slug: 'colbitz',
    },
    {
      code: '150835051361',
      label: 'Loitsche-Heinrichsberg',
      provincie: 15,
      slug: 'loitsche-heinrichsberg',
    },
    {
      code: '150835051440',
      label: 'Rogätz',
      provincie: 15,
      slug: 'rogaetz',
    },
    {
      code: '150835051557',
      label: 'Westheide',
      provincie: 15,
      slug: 'westheide',
    },
    {
      code: '150835051580',
      label: 'Zielitz',
      provincie: 15,
      slug: 'zielitz',
    },
    {
      code: '150835052020',
      label: 'Altenhausen',
      provincie: 15,
      slug: 'altenhausen',
    },
    {
      code: '150835052060',
      label: 'Beendorf',
      provincie: 15,
      slug: 'beendorf',
    },
    {
      code: '150835052115',
      label: 'Bülstringen',
      provincie: 15,
      slug: 'buelstringen',
    },
    {
      code: '150835052125',
      label: 'Calvörde',
      provincie: 15,
      slug: 'calvoerde',
    },
    {
      code: '150835052205',
      label: 'Erxleben',
      provincie: 15,
      slug: 'erxleben',
    },
    {
      code: '150835052230',
      label: 'Flechtingen',
      provincie: 15,
      slug: 'flechtingen',
    },
    {
      code: '150835052323',
      label: 'Ingersleben',
      provincie: 15,
      slug: 'ingersleben',
    },
    {
      code: '150835053190',
      label: 'Eilsleben',
      provincie: 15,
      slug: 'eilsleben',
    },
    {
      code: '150835053275',
      label: 'Harbke',
      provincie: 15,
      slug: 'harbke',
    },
    {
      code: '150835053320',
      label: 'Hötensleben',
      provincie: 15,
      slug: 'hoetensleben',
    },
    {
      code: '150835053485',
      label: 'Sommersdorf',
      provincie: 15,
      slug: 'sommersdorf-gemeinde',
    },
    {
      code: '150835053505',
      label: 'Ummendorf',
      provincie: 15,
      slug: 'ummendorf-gemeinde',
    },
    {
      code: '150835053515',
      label: 'Völpke',
      provincie: 15,
      slug: 'voelpke',
    },
    {
      code: '150835053535',
      label: 'Wefensleben',
      provincie: 15,
      slug: 'wefensleben',
    },
    {
      code: '150835054025',
      label: 'Am Großen Bruch',
      provincie: 15,
      slug: 'am-grossen-bruch',
    },
    {
      code: '150835054035',
      label: 'Ausleben',
      provincie: 15,
      slug: 'ausleben',
    },
    {
      code: '150835054245',
      label: 'Gröningen',
      provincie: 15,
      slug: 'groeningen',
    },
    {
      code: '150835054355',
      label: 'Kroppenstedt',
      provincie: 15,
      slug: 'kroppenstedt',
    },
    {
      code: '150840130130',
      label: 'Elsteraue',
      provincie: 15,
      slug: 'elsteraue',
    },
    {
      code: '150840235235',
      label: 'Hohenmölsen',
      provincie: 15,
      slug: 'hohenmoelsen',
    },
    {
      code: '150840315315',
      label: 'Lützen',
      provincie: 15,
      slug: 'luetzen',
    },
    {
      code: '150840355355',
      label: 'Naumburg (Saale)',
      provincie: 15,
      slug: 'naumburg-saale',
    },
    {
      code: '150840490490',
      label: 'Teuchern',
      provincie: 15,
      slug: 'teuchern',
    },
    {
      code: '150840550550',
      label: 'Weißenfels',
      provincie: 15,
      slug: 'weissenfels',
    },
    {
      code: '150840590590',
      label: 'Zeitz',
      provincie: 15,
      slug: 'zeitz',
    },
    {
      code: '150845051012',
      label: 'An der Poststraße',
      provincie: 15,
      slug: 'an-der-poststrasse',
    },
    {
      code: '150845051015',
      label: 'Bad Bibra',
      provincie: 15,
      slug: 'bad-bibra',
    },
    {
      code: '150845051125',
      label: 'Eckartsberga',
      provincie: 15,
      slug: 'eckartsberga',
    },
    {
      code: '150845051132',
      label: 'Finne',
      provincie: 15,
      slug: 'finne',
    },
    {
      code: '150845051133',
      label: 'Finneland',
      provincie: 15,
      slug: 'finneland',
    },
    {
      code: '150845051246',
      label: 'Kaiserpfalz',
      provincie: 15,
      slug: 'kaiserpfalz',
    },
    {
      code: '150845051282',
      label: 'Lanitz-Hassel-Tal',
      provincie: 15,
      slug: 'lanitz-hassel-tal',
    },
    {
      code: '150845052115',
      label: 'Droyßig',
      provincie: 15,
      slug: 'droyssig',
    },
    {
      code: '150845052207',
      label: 'Gutenborn',
      provincie: 15,
      slug: 'gutenborn',
    },
    {
      code: '150845052275',
      label: 'Kretzschau',
      provincie: 15,
      slug: 'kretzschau',
    },
    {
      code: '150845052442',
      label: 'Schnaudertal',
      provincie: 15,
      slug: 'schnaudertal',
    },
    {
      code: '150845052565',
      label: 'Wetterzeube',
      provincie: 15,
      slug: 'wetterzeube',
    },
    {
      code: '150845053025',
      label: 'Balgstädt',
      provincie: 15,
      slug: 'balgstaedt',
    },
    {
      code: '150845053135',
      label: 'Freyburg (Unstrut)',
      provincie: 15,
      slug: 'freyburg-unstrut',
    },
    {
      code: '150845053150',
      label: 'Gleina',
      provincie: 15,
      slug: 'gleina',
    },
    {
      code: '150845053170',
      label: 'Goseck',
      provincie: 15,
      slug: 'goseck',
    },
    {
      code: '150845053250',
      label: 'Karsdorf',
      provincie: 15,
      slug: 'karsdorf',
    },
    {
      code: '150845053285',
      label: 'Laucha an der Unstrut',
      provincie: 15,
      slug: 'laucha-an-der-unstrut',
    },
    {
      code: '150845053360',
      label: 'Nebra (Unstrut)',
      provincie: 15,
      slug: 'nebra-unstrut',
    },
    {
      code: '150845054013',
      label: 'Meineweh',
      provincie: 15,
      slug: 'meineweh',
    },
    {
      code: '150845054335',
      label: 'Mertendorf',
      provincie: 15,
      slug: 'mertendorf',
    },
    {
      code: '150845054341',
      label: 'Molauer Land',
      provincie: 15,
      slug: 'molauer-land',
    },
    {
      code: '150845054375',
      label: 'Osterfeld',
      provincie: 15,
      slug: 'osterfeld',
    },
    {
      code: '150845054445',
      label: 'Schönburg',
      provincie: 15,
      slug: 'schoenburg',
    },
    {
      code: '150845054470',
      label: 'Stößen',
      provincie: 15,
      slug: 'stoessen',
    },
    {
      code: '150845054560',
      label: 'Wethau',
      provincie: 15,
      slug: 'wethau',
    },
    {
      code: '150850040040',
      label: 'Ballenstedt',
      provincie: 15,
      slug: 'ballenstedt',
    },
    {
      code: '150850055055',
      label: 'Blankenburg (Harz)',
      provincie: 15,
      slug: 'blankenburg-harz',
    },
    {
      code: '150850110110',
      label: 'Falkenstein/Harz',
      provincie: 15,
      slug: 'falkenstein-harz',
    },
    {
      code: '150850135135',
      label: 'Halberstadt',
      provincie: 15,
      slug: 'halberstadt',
    },
    {
      code: '150850145145',
      label: 'Harzgerode',
      provincie: 15,
      slug: 'harzgerode',
    },
    {
      code: '150850185185',
      label: 'Huy',
      provincie: 15,
      slug: 'huy',
    },
    {
      code: '150850190190',
      label: 'Ilsenburg (Harz)',
      provincie: 15,
      slug: 'ilsenburg-harz',
    },
    {
      code: '150850227227',
      label: 'Nordharz',
      provincie: 15,
      slug: 'nordharz',
    },
    {
      code: '150850228228',
      label: 'Oberharz am Brocken',
      provincie: 15,
      slug: 'oberharz-am-brocken',
    },
    {
      code: '150850230230',
      label: 'Osterwieck',
      provincie: 15,
      slug: 'osterwieck',
    },
    {
      code: '150850235235',
      label: 'Quedlinburg',
      provincie: 15,
      slug: 'quedlinburg',
    },
    {
      code: '150850330330',
      label: 'Thale',
      provincie: 15,
      slug: 'thale',
    },
    {
      code: '150850370370',
      label: 'Wernigerode',
      provincie: 15,
      slug: 'wernigerode',
    },
    {
      code: '150855051090',
      label: 'Ditfurt',
      provincie: 15,
      slug: 'ditfurt',
    },
    {
      code: '150855051125',
      label: 'Groß Quenstedt',
      provincie: 15,
      slug: 'gross-quenstedt',
    },
    {
      code: '150855051140',
      label: 'Harsleben',
      provincie: 15,
      slug: 'harsleben',
    },
    {
      code: '150855051160',
      label: 'Hedersleben',
      provincie: 15,
      slug: 'hedersleben',
    },
    {
      code: '150855051285',
      label: 'Schwanebeck',
      provincie: 15,
      slug: 'schwanebeck',
    },
    {
      code: '150855051287',
      label: 'Selke-Aue',
      provincie: 15,
      slug: 'selke-aue',
    },
    {
      code: '150855051365',
      label: 'Wegeleben',
      provincie: 15,
      slug: 'wegeleben',
    },
    {
      code: '150860005005',
      label: 'Biederitz',
      provincie: 15,
      slug: 'biederitz',
    },
    {
      code: '150860015015',
      label: 'Burg',
      provincie: 15,
      slug: 'burg-stadt',
    },
    {
      code: '150860035035',
      label: 'Elbe-Parey',
      provincie: 15,
      slug: 'elbe-parey',
    },
    {
      code: '150860040040',
      label: 'Genthin',
      provincie: 15,
      slug: 'genthin',
    },
    {
      code: '150860055055',
      label: 'Gommern',
      provincie: 15,
      slug: 'gommern',
    },
    {
      code: '150860080080',
      label: 'Jerichow',
      provincie: 15,
      slug: 'jerichow',
    },
    {
      code: '150860140140',
      label: 'Möckern',
      provincie: 15,
      slug: 'moeckern',
    },
    {
      code: '150860145145',
      label: 'Möser',
      provincie: 15,
      slug: 'moeser',
    },
    {
      code: '150870015015',
      label: 'Allstedt',
      provincie: 15,
      slug: 'allstedt',
    },
    {
      code: '150870031031',
      label: 'Arnstein',
      provincie: 15,
      slug: 'arnstein-stadt',
    },
    {
      code: '150870130130',
      label: 'Eisleben',
      provincie: 15,
      slug: 'eisleben',
    },
    {
      code: '150870165165',
      label: 'Gerbstedt',
      provincie: 15,
      slug: 'gerbstedt',
    },
    {
      code: '150870220220',
      label: 'Hettstedt',
      provincie: 15,
      slug: 'hettstedt',
    },
    {
      code: '150870275275',
      label: 'Mansfeld',
      provincie: 15,
      slug: 'mansfeld',
    },
    {
      code: '150870370370',
      label: 'Sangerhausen',
      provincie: 15,
      slug: 'sangerhausen',
    },
    {
      code: '150870386386',
      label: 'Seegebiet Mansfelder Land',
      provincie: 15,
      slug: 'seegebiet-mansfelder-land',
    },
    {
      code: '150870412412',
      label: 'Südharz',
      provincie: 15,
      slug: 'suedharz',
    },
    {
      code: '150875051055',
      label: 'Berga',
      provincie: 15,
      slug: 'berga',
    },
    {
      code: '150875051101',
      label: 'Brücken-Hackpfüffel',
      provincie: 15,
      slug: 'bruecken-hackpfueffel',
    },
    {
      code: '150875051125',
      label: 'Edersleben',
      provincie: 15,
      slug: 'edersleben',
    },
    {
      code: '150875051250',
      label: 'Kelbra (Kyffhäuser)',
      provincie: 15,
      slug: 'kelbra-kyffhaeuser',
    },
    {
      code: '150875051440',
      label: 'Wallhausen',
      provincie: 15,
      slug: 'wallhausen-gemeinde',
    },
    {
      code: '150875052010',
      label: 'Ahlsdorf',
      provincie: 15,
      slug: 'ahlsdorf',
    },
    {
      code: '150875052045',
      label: 'Benndorf',
      provincie: 15,
      slug: 'benndorf',
    },
    {
      code: '150875052070',
      label: 'Blankenheim',
      provincie: 15,
      slug: 'blankenheim-gemeinde',
    },
    {
      code: '150875052075',
      label: 'Bornstedt',
      provincie: 15,
      slug: 'bornstedt',
    },
    {
      code: '150875052205',
      label: 'Helbra',
      provincie: 15,
      slug: 'helbra',
    },
    {
      code: '150875052210',
      label: 'Hergisdorf',
      provincie: 15,
      slug: 'hergisdorf',
    },
    {
      code: '150875052260',
      label: 'Klostermansfeld',
      provincie: 15,
      slug: 'klostermansfeld',
    },
    {
      code: '150875052470',
      label: 'Wimmelburg',
      provincie: 15,
      slug: 'wimmelburg',
    },
    {
      code: '150880020020',
      label: 'Bad Dürrenberg',
      provincie: 15,
      slug: 'bad-duerrenberg',
    },
    {
      code: '150880025025',
      label: 'Bad Lauchstädt',
      provincie: 15,
      slug: 'bad-lauchstaedt',
    },
    {
      code: '150880065065',
      label: 'Braunsbedra',
      provincie: 15,
      slug: 'braunsbedra',
    },
    {
      code: '150880150150',
      label: 'Kabelsketal',
      provincie: 15,
      slug: 'kabelsketal',
    },
    {
      code: '150880195195',
      label: 'Landsberg',
      provincie: 15,
      slug: 'landsberg',
    },
    {
      code: '150880205205',
      label: 'Leuna',
      provincie: 15,
      slug: 'leuna',
    },
    {
      code: '150880216216',
      label: 'Wettin-Löbejün',
      provincie: 15,
      slug: 'wettin-loebejuen',
    },
    {
      code: '150880220220',
      label: 'Merseburg',
      provincie: 15,
      slug: 'merseburg',
    },
    {
      code: '150880235235',
      label: 'Mücheln (Geiseltal)',
      provincie: 15,
      slug: 'muecheln-geiseltal',
    },
    {
      code: '150880295295',
      label: 'Petersberg',
      provincie: 15,
      slug: 'petersberg-gemeinde',
    },
    {
      code: '150880305305',
      label: 'Querfurt',
      provincie: 15,
      slug: 'querfurt',
    },
    {
      code: '150880319319',
      label: 'Salzatal',
      provincie: 15,
      slug: 'salzatal',
    },
    {
      code: '150880330330',
      label: 'Schkopau',
      provincie: 15,
      slug: 'schkopau',
    },
    {
      code: '150880365365',
      label: 'Teutschenthal',
      provincie: 15,
      slug: 'teutschenthal',
    },
    {
      code: '150885051030',
      label: 'Barnstädt',
      provincie: 15,
      slug: 'barnstaedt',
    },
    {
      code: '150885051100',
      label: 'Farnstädt',
      provincie: 15,
      slug: 'farnstaedt',
    },
    {
      code: '150885051250',
      label: 'Nemsdorf-Göhrendorf',
      provincie: 15,
      slug: 'nemsdorf-goehrendorf',
    },
    {
      code: '150885051265',
      label: 'Obhausen',
      provincie: 15,
      slug: 'obhausen',
    },
    {
      code: '150885051340',
      label: 'Schraplau',
      provincie: 15,
      slug: 'schraplau',
    },
    {
      code: '150885051355',
      label: 'Steigra',
      provincie: 15,
      slug: 'steigra',
    },
    {
      code: '150890015015',
      label: 'Aschersleben',
      provincie: 15,
      slug: 'aschersleben',
    },
    {
      code: '150890026026',
      label: 'Barby',
      provincie: 15,
      slug: 'barby',
    },
    {
      code: '150890030030',
      label: 'Bernburg (Saale)',
      provincie: 15,
      slug: 'bernburg-saale',
    },
    {
      code: '150890042042',
      label: 'Bördeland',
      provincie: 15,
      slug: 'boerdeland',
    },
    {
      code: '150890055055',
      label: 'Calbe (Saale)',
      provincie: 15,
      slug: 'calbe-saale',
    },
    {
      code: '150890175175',
      label: 'Hecklingen',
      provincie: 15,
      slug: 'hecklingen',
    },
    {
      code: '150890195195',
      label: 'Könnern',
      provincie: 15,
      slug: 'koennern',
    },
    {
      code: '150890235235',
      label: 'Nienburg (Saale)',
      provincie: 15,
      slug: 'nienburg-saale',
    },
    {
      code: '150890305305',
      label: 'Schönebeck (Elbe)',
      provincie: 15,
      slug: 'schoenebeck-elbe',
    },
    {
      code: '150890307307',
      label: 'Seeland',
      provincie: 15,
      slug: 'seeland',
    },
    {
      code: '150890310310',
      label: 'Staßfurt',
      provincie: 15,
      slug: 'stassfurt',
    },
    {
      code: '150895051041',
      label: 'Bördeaue',
      provincie: 15,
      slug: 'boerdeaue',
    },
    {
      code: '150895051043',
      label: 'Börde-Hakel',
      provincie: 15,
      slug: 'boerde-hakel',
    },
    {
      code: '150895051045',
      label: 'Borne',
      provincie: 15,
      slug: 'borne',
    },
    {
      code: '150895051075',
      label: 'Egeln',
      provincie: 15,
      slug: 'egeln',
    },
    {
      code: '150895051365',
      label: 'Wolmirsleben',
      provincie: 15,
      slug: 'wolmirsleben',
    },
    {
      code: '150895052005',
      label: 'Alsleben (Saale)',
      provincie: 15,
      slug: 'alsleben-saale',
    },
    {
      code: '150895052130',
      label: 'Giersleben',
      provincie: 15,
      slug: 'giersleben',
    },
    {
      code: '150895052165',
      label: 'Güsten',
      provincie: 15,
      slug: 'guesten',
    },
    {
      code: '150895052185',
      label: 'Ilberstedt',
      provincie: 15,
      slug: 'ilberstedt',
    },
    {
      code: '150895052245',
      label: 'Plötzkau',
      provincie: 15,
      slug: 'ploetzkau',
    },
    {
      code: '150900070070',
      label: 'Bismark (Altmark)',
      provincie: 15,
      slug: 'bismark-altmark',
    },
    {
      code: '150900225225',
      label: 'Havelberg',
      provincie: 15,
      slug: 'havelberg',
    },
    {
      code: '150900415415',
      label: 'Osterburg (Altmark)',
      provincie: 15,
      slug: 'osterburg-altmark',
    },
    {
      code: '150900535535',
      label: 'Stendal',
      provincie: 15,
      slug: 'stendal',
    },
    {
      code: '150900546546',
      label: 'Tangerhütte',
      provincie: 15,
      slug: 'tangerhuette',
    },
    {
      code: '150900550550',
      label: 'Tangermünde',
      provincie: 15,
      slug: 'tangermuende',
    },
    {
      code: '150905051010',
      label: 'Arneburg',
      provincie: 15,
      slug: 'arneburg',
    },
    {
      code: '150905051135',
      label: 'Eichstedt (Altmark)',
      provincie: 15,
      slug: 'eichstedt-altmark',
    },
    {
      code: '150905051180',
      label: 'Goldbeck',
      provincie: 15,
      slug: 'goldbeck',
    },
    {
      code: '150905051220',
      label: 'Hassel',
      provincie: 15,
      slug: 'hassel',
    },
    {
      code: '150905051245',
      label: 'Hohenberg-Krusemark',
      provincie: 15,
      slug: 'hohenberg-krusemark',
    },
    {
      code: '150905051270',
      label: 'Iden',
      provincie: 15,
      slug: 'iden',
    },
    {
      code: '150905051435',
      label: 'Rochau',
      provincie: 15,
      slug: 'rochau',
    },
    {
      code: '150905051610',
      label: 'Werben (Elbe)',
      provincie: 15,
      slug: 'werben-elbe',
    },
    {
      code: '150905052285',
      label: 'Kamern',
      provincie: 15,
      slug: 'kamern',
    },
    {
      code: '150905052310',
      label: 'Klietz',
      provincie: 15,
      slug: 'klietz',
    },
    {
      code: '150905052445',
      label: 'Sandau (Elbe)',
      provincie: 15,
      slug: 'sandau-elbe',
    },
    {
      code: '150905052485',
      label: 'Schollene',
      provincie: 15,
      slug: 'schollene',
    },
    {
      code: '150905052500',
      label: 'Schönhausen (Elbe)',
      provincie: 15,
      slug: 'schoenhausen-elbe',
    },
    {
      code: '150905052631',
      label: 'Wust-Fischbeck',
      provincie: 15,
      slug: 'wust-fischbeck',
    },
    {
      code: '150905053003',
      label: 'Aland',
      provincie: 15,
      slug: 'aland',
    },
    {
      code: '150905053007',
      label: 'Altmärkische Höhe',
      provincie: 15,
      slug: 'altmaerkische-hoehe',
    },
    {
      code: '150905053008',
      label: 'Altmärkische Wische',
      provincie: 15,
      slug: 'altmaerkische-wische',
    },
    {
      code: '150905053520',
      label: 'Seehausen (Altmark)',
      provincie: 15,
      slug: 'seehausen-altmark',
    },
    {
      code: '150905053635',
      label: 'Zehrental',
      provincie: 15,
      slug: 'zehrental',
    },
    {
      code: '150910010010',
      label: 'Annaburg',
      provincie: 15,
      slug: 'annaburg',
    },
    {
      code: '150910020020',
      label: 'Bad Schmiedeberg',
      provincie: 15,
      slug: 'bad-schmiedeberg',
    },
    {
      code: '150910060060',
      label: 'Coswig (Anhalt)',
      provincie: 15,
      slug: 'coswig-anhalt',
    },
    {
      code: '150910110110',
      label: 'Gräfenhainichen',
      provincie: 15,
      slug: 'graefenhainichen',
    },
    {
      code: '150910145145',
      label: 'Jessen (Elster)',
      provincie: 15,
      slug: 'jessen-elster',
    },
    {
      code: '150910160160',
      label: 'Kemberg',
      provincie: 15,
      slug: 'kemberg',
    },
    {
      code: '150910241241',
      label: 'Oranienbaum-Wörlitz',
      provincie: 15,
      slug: 'oranienbaum-woerlitz',
    },
    {
      code: '150910375375',
      label: 'Wittenberg',
      provincie: 15,
      slug: 'wittenberg',
    },
    {
      code: '150910391391',
      label: 'Zahna-Elster',
      provincie: 15,
      slug: 'zahna-elster',
    },
    {
      code: '160510000000',
      label: 'Erfurt',
      provincie: 16,
      slug: 'erfurt',
    },
    {
      code: '160520000000',
      label: 'Gera',
      provincie: 16,
      slug: 'gera',
    },
    {
      code: '160530000000',
      label: 'Jena',
      provincie: 16,
      slug: 'jena',
    },
    {
      code: '160540000000',
      label: 'Suhl',
      provincie: 16,
      slug: 'suhl',
    },
    {
      code: '160550000000',
      label: 'Weimar',
      provincie: 16,
      slug: 'weimar',
    },
    {
      code: '160610045045',
      label: 'Heilbad Heiligenstadt',
      provincie: 16,
      slug: 'heilbad-heiligenstadt',
    },
    {
      code: '160610074074',
      label: 'Niederorschel',
      provincie: 16,
      slug: 'niederorschel',
    },
    {
      code: '160610115115',
      label: 'Leinefelde-Worbis',
      provincie: 16,
      slug: 'leinefelde-worbis',
    },
    {
      code: '160610116116',
      label: 'Am Ohmberg',
      provincie: 16,
      slug: 'am-ohmberg',
    },
    {
      code: '160610117117',
      label: 'Sonnenstein',
      provincie: 16,
      slug: 'sonnenstein',
    },
    {
      code: '160610118118',
      label: 'Dingelstädt',
      provincie: 16,
      slug: 'dingelstaedt',
    },
    {
      code: '160615001003',
      label: 'Berlingerode',
      provincie: 16,
      slug: 'berlingerode',
    },
    {
      code: '160615001015',
      label: 'Brehme',
      provincie: 16,
      slug: 'brehme',
    },
    {
      code: '160615001026',
      label: 'Ecklingerode',
      provincie: 16,
      slug: 'ecklingerode',
    },
    {
      code: '160615001031',
      label: 'Ferna',
      provincie: 16,
      slug: 'ferna',
    },
    {
      code: '160615001094',
      label: 'Tastungen',
      provincie: 16,
      slug: 'tastungen',
    },
    {
      code: '160615001103',
      label: 'Wehnde',
      provincie: 16,
      slug: 'wehnde',
    },
    {
      code: '160615001114',
      label: 'Teistungen',
      provincie: 16,
      slug: 'teistungen',
    },
    {
      code: '160615006017',
      label: 'Breitenworbis',
      provincie: 16,
      slug: 'breitenworbis',
    },
    {
      code: '160615006019',
      label: 'Buhla',
      provincie: 16,
      slug: 'buhla',
    },
    {
      code: '160615006037',
      label: 'Gernrode',
      provincie: 16,
      slug: 'gernrode',
    },
    {
      code: '160615006044',
      label: 'Haynrode',
      provincie: 16,
      slug: 'haynrode',
    },
    {
      code: '160615006058',
      label: 'Kirchworbis',
      provincie: 16,
      slug: 'kirchworbis',
    },
    {
      code: '160615008001',
      label: 'Arenshausen',
      provincie: 16,
      slug: 'arenshausen',
    },
    {
      code: '160615008014',
      label: 'Bornhagen',
      provincie: 16,
      slug: 'bornhagen',
    },
    {
      code: '160615008021',
      label: 'Burgwalde',
      provincie: 16,
      slug: 'burgwalde',
    },
    {
      code: '160615008032',
      label: 'Freienhagen',
      provincie: 16,
      slug: 'freienhagen',
    },
    {
      code: '160615008033',
      label: 'Fretterode',
      provincie: 16,
      slug: 'fretterode',
    },
    {
      code: '160615008036',
      label: 'Gerbershausen',
      provincie: 16,
      slug: 'gerbershausen',
    },
    {
      code: '160615008048',
      label: 'Hohengandern',
      provincie: 16,
      slug: 'hohengandern',
    },
    {
      code: '160615008057',
      label: 'Kirchgandern',
      provincie: 16,
      slug: 'kirchgandern',
    },
    {
      code: '160615008066',
      label: 'Lindewerra',
      provincie: 16,
      slug: 'lindewerra',
    },
    {
      code: '160615008069',
      label: 'Marth',
      provincie: 16,
      slug: 'marth',
    },
    {
      code: '160615008078',
      label: 'Rohrberg',
      provincie: 16,
      slug: 'rohrberg-gemeinde',
    },
    {
      code: '160615008082',
      label: 'Rustenfelde',
      provincie: 16,
      slug: 'rustenfelde',
    },
    {
      code: '160615008083',
      label: 'Schachtebich',
      provincie: 16,
      slug: 'schachtebich',
    },
    {
      code: '160615008102',
      label: 'Wahlhausen',
      provincie: 16,
      slug: 'wahlhausen',
    },
    {
      code: '160615009012',
      label: 'Bodenrode-Westhausen',
      provincie: 16,
      slug: 'bodenrode-westhausen',
    },
    {
      code: '160615009034',
      label: 'Geisleden',
      provincie: 16,
      slug: 'geisleden',
    },
    {
      code: '160615009047',
      label: 'Heuthen',
      provincie: 16,
      slug: 'heuthen',
    },
    {
      code: '160615009076',
      label: 'Reinholterode',
      provincie: 16,
      slug: 'reinholterode',
    },
    {
      code: '160615009089',
      label: 'Steinbach',
      provincie: 16,
      slug: 'steinbach-gemeinde',
    },
    {
      code: '160615009107',
      label: 'Wingerode',
      provincie: 16,
      slug: 'wingerode',
    },
    {
      code: '160615013018',
      label: 'Büttstedt',
      provincie: 16,
      slug: 'buettstedt',
    },
    {
      code: '160615013027',
      label: 'Effelder',
      provincie: 16,
      slug: 'effelder',
    },
    {
      code: '160615013041',
      label: 'Großbartloff',
      provincie: 16,
      slug: 'grossbartloff',
    },
    {
      code: '160615013063',
      label: 'Küllstedt',
      provincie: 16,
      slug: 'kuellstedt',
    },
    {
      code: '160615013101',
      label: 'Wachstedt',
      provincie: 16,
      slug: 'wachstedt',
    },
    {
      code: '160615014023',
      label: 'Dieterode',
      provincie: 16,
      slug: 'dieterode',
    },
    {
      code: '160615014035',
      label: 'Geismar',
      provincie: 16,
      slug: 'geismar',
    },
    {
      code: '160615014056',
      label: 'Kella',
      provincie: 16,
      slug: 'kella',
    },
    {
      code: '160615014062',
      label: 'Krombach',
      provincie: 16,
      slug: 'krombach-gemeinde',
    },
    {
      code: '160615014075',
      label: 'Pfaffschwende',
      provincie: 16,
      slug: 'pfaffschwende',
    },
    {
      code: '160615014085',
      label: 'Schwobfeld',
      provincie: 16,
      slug: 'schwobfeld',
    },
    {
      code: '160615014086',
      label: 'Sickerode',
      provincie: 16,
      slug: 'sickerode',
    },
    {
      code: '160615014098',
      label: 'Volkerode',
      provincie: 16,
      slug: 'volkerode',
    },
    {
      code: '160615014105',
      label: 'Wiesenfeld',
      provincie: 16,
      slug: 'wiesenfeld',
    },
    {
      code: '160615014113',
      label: 'Schimberg',
      provincie: 16,
      slug: 'schimberg',
    },
    {
      code: '160615051002',
      label: 'Asbach-Sickenberg',
      provincie: 16,
      slug: 'asbach-sickenberg',
    },
    {
      code: '160615051024',
      label: 'Dietzenrode/Vatterode',
      provincie: 16,
      slug: 'dietzenrode-vatterode',
    },
    {
      code: '160615051119',
      label: 'Uder',
      provincie: 16,
      slug: 'uder',
    },
    {
      code: '160620005005',
      label: 'Ellrich',
      provincie: 16,
      slug: 'ellrich',
    },
    {
      code: '160620041041',
      label: 'Nordhausen',
      provincie: 16,
      slug: 'nordhausen',
    },
    {
      code: '160620049049',
      label: 'Sollstedt',
      provincie: 16,
      slug: 'sollstedt',
    },
    {
      code: '160620062062',
      label: 'Hohenstein',
      provincie: 16,
      slug: 'hohenstein-gemeinde',
    },
    {
      code: '160620063063',
      label: 'Werther',
      provincie: 16,
      slug: 'werther',
    },
    {
      code: '160620065065',
      label: 'Harztor',
      provincie: 16,
      slug: 'harztor',
    },
    {
      code: '160625053008',
      label: 'Görsbach',
      provincie: 16,
      slug: 'goersbach',
    },
    {
      code: '160625053054',
      label: 'Urbach',
      provincie: 16,
      slug: 'urbach-gemeinde',
    },
    {
      code: '160625053064',
      label: 'Heringen/Helme',
      provincie: 16,
      slug: 'heringen-helme',
    },
    {
      code: '160625054009',
      label: 'Großlohra',
      provincie: 16,
      slug: 'grosslohra',
    },
    {
      code: '160625054024',
      label: 'Kehmstedt',
      provincie: 16,
      slug: 'kehmstedt',
    },
    {
      code: '160625054026',
      label: 'Kleinfurra',
      provincie: 16,
      slug: 'kleinfurra',
    },
    {
      code: '160625054033',
      label: 'Lipprechterode',
      provincie: 16,
      slug: 'lipprechterode',
    },
    {
      code: '160625054037',
      label: 'Niedergebra',
      provincie: 16,
      slug: 'niedergebra',
    },
    {
      code: '160625054066',
      label: 'Bleicherode',
      provincie: 16,
      slug: 'bleicherode',
    },
    {
      code: '160630004004',
      label: 'Barchfeld-Immelborn',
      provincie: 16,
      slug: 'barchfeld-immelborn',
    },
    {
      code: '160630076076',
      label: 'Treffurt',
      provincie: 16,
      slug: 'treffurt',
    },
    {
      code: '160630078078',
      label: 'Unterbreizbach',
      provincie: 16,
      slug: 'unterbreizbach',
    },
    {
      code: '160630082082',
      label: 'Vacha',
      provincie: 16,
      slug: 'vacha',
    },
    {
      code: '160630092092',
      label: 'Wutha-Farnroda',
      provincie: 16,
      slug: 'wutha-farnroda',
    },
    {
      code: '160630097097',
      label: 'Gerstungen',
      provincie: 16,
      slug: 'gerstungen',
    },
    {
      code: '160630098098',
      label: 'Hörselberg-Hainich',
      provincie: 16,
      slug: 'hoerselberg-hainich',
    },
    {
      code: '160630099099',
      label: 'Bad Liebenstein',
      provincie: 16,
      slug: 'bad-liebenstein',
    },
    {
      code: '160630101101',
      label: 'Krayenberggemeinde',
      provincie: 16,
      slug: 'krayenberggemeinde',
    },
    {
      code: '160630103103',
      label: 'Werra-Suhl-Tal',
      provincie: 16,
      slug: 'werra-suhl-tal',
    },
    {
      code: '160630105105',
      label: 'Eisenach',
      provincie: 16,
      slug: 'eisenach-stadt',
    },
    {
      code: '160635006006',
      label: 'Berka v.d.Hainich',
      provincie: 16,
      slug: 'berka-v-d-hainich',
    },
    {
      code: '160635006008',
      label: 'Bischofroda',
      provincie: 16,
      slug: 'bischofroda',
    },
    {
      code: '160635006046',
      label: 'Krauthausen',
      provincie: 16,
      slug: 'krauthausen',
    },
    {
      code: '160635006049',
      label: 'Lauterbach',
      provincie: 16,
      slug: 'lauterbach-gemeinde',
    },
    {
      code: '160635006058',
      label: 'Nazza',
      provincie: 16,
      slug: 'nazza',
    },
    {
      code: '160635006104',
      label: 'Amt Creuzburg',
      provincie: 16,
      slug: 'amt-creuzburg',
    },
    {
      code: '160635051003',
      label: 'Bad Salzungen',
      provincie: 16,
      slug: 'bad-salzungen',
    },
    {
      code: '160635051051',
      label: 'Leimbach',
      provincie: 16,
      slug: 'leimbach-gemeinde',
    },
    {
      code: '160635056011',
      label: 'Buttlar',
      provincie: 16,
      slug: 'buttlar',
    },
    {
      code: '160635056032',
      label: 'Geisa',
      provincie: 16,
      slug: 'geisa',
    },
    {
      code: '160635056033',
      label: 'Gerstengrund',
      provincie: 16,
      slug: 'gerstengrund',
    },
    {
      code: '160635056068',
      label: 'Schleid',
      provincie: 16,
      slug: 'schleid-gemeinde',
    },
    {
      code: '160635057066',
      label: 'Ruhla',
      provincie: 16,
      slug: 'ruhla',
    },
    {
      code: '160635057071',
      label: 'Seebach',
      provincie: 16,
      slug: 'seebach-gemeinde',
    },
    {
      code: '160635059015',
      label: 'Dermbach',
      provincie: 16,
      slug: 'dermbach',
    },
    {
      code: '160635059023',
      label: 'Empfertshausen',
      provincie: 16,
      slug: 'empfertshausen',
    },
    {
      code: '160635059062',
      label: 'Oechsen',
      provincie: 16,
      slug: 'oechsen',
    },
    {
      code: '160635059084',
      label: 'Weilar',
      provincie: 16,
      slug: 'weilar',
    },
    {
      code: '160635059086',
      label: 'Wiesenthal',
      provincie: 16,
      slug: 'wiesenthal',
    },
    {
      code: '160640003003',
      label: 'Bad Langensalza',
      provincie: 16,
      slug: 'bad-langensalza',
    },
    {
      code: '160640046046',
      label: 'Mühlhausen/Thüringen',
      provincie: 16,
      slug: 'muehlhausen-thueringen',
    },
    {
      code: '160640071071',
      label: 'Unstruttal',
      provincie: 16,
      slug: 'unstruttal',
    },
    {
      code: '160640074074',
      label: 'Südeichsfeld',
      provincie: 16,
      slug: 'suedeichsfeld',
    },
    {
      code: '160640076076',
      label: 'Unstrut-Hainich',
      provincie: 16,
      slug: 'unstrut-hainich',
    },
    {
      code: '160645001004',
      label: 'Bad Tennstedt',
      provincie: 16,
      slug: 'bad-tennstedt',
    },
    {
      code: '160645001005',
      label: 'Ballhausen',
      provincie: 16,
      slug: 'ballhausen',
    },
    {
      code: '160645001007',
      label: 'Blankenburg',
      provincie: 16,
      slug: 'blankenburg',
    },
    {
      code: '160645001009',
      label: 'Bruchstedt',
      provincie: 16,
      slug: 'bruchstedt',
    },
    {
      code: '160645001021',
      label: 'Haussömmern',
      provincie: 16,
      slug: 'haussoemmern',
    },
    {
      code: '160645001027',
      label: 'Hornsömmern',
      provincie: 16,
      slug: 'hornsoemmern',
    },
    {
      code: '160645001033',
      label: 'Kirchheilingen',
      provincie: 16,
      slug: 'kirchheilingen',
    },
    {
      code: '160645001038',
      label: 'Kutzleben',
      provincie: 16,
      slug: 'kutzleben',
    },
    {
      code: '160645001045',
      label: 'Mittelsömmern',
      provincie: 16,
      slug: 'mittelsoemmern',
    },
    {
      code: '160645001061',
      label: 'Sundhausen',
      provincie: 16,
      slug: 'sundhausen',
    },
    {
      code: '160645001062',
      label: 'Tottleben',
      provincie: 16,
      slug: 'tottleben',
    },
    {
      code: '160645001064',
      label: 'Urleben',
      provincie: 16,
      slug: 'urleben',
    },
    {
      code: '160645051019',
      label: 'Großvargula',
      provincie: 16,
      slug: 'grossvargula',
    },
    {
      code: '160645051022',
      label: 'Herbsleben',
      provincie: 16,
      slug: 'herbsleben',
    },
    {
      code: '160645053032',
      label: 'Kammerforst',
      provincie: 16,
      slug: 'kammerforst-gemeinde',
    },
    {
      code: '160645053053',
      label: 'Oppershausen',
      provincie: 16,
      slug: 'oppershausen',
    },
    {
      code: '160645053075',
      label: 'Vogtei',
      provincie: 16,
      slug: 'vogtei',
    },
    {
      code: '160645055037',
      label: 'Körner',
      provincie: 16,
      slug: 'koerner',
    },
    {
      code: '160645055043',
      label: 'Marolterode',
      provincie: 16,
      slug: 'marolterode',
    },
    {
      code: '160645055077',
      label: 'Nottertal-Heilinger Höhen',
      provincie: 16,
      slug: 'nottertal-heilinger-hoehen',
    },
    {
      code: '160650003003',
      label: 'Bad Frankenhausen/Kyffhäuser',
      provincie: 16,
      slug: 'bad-frankenhausen-kyffhaeuser',
    },
    {
      code: '160650032032',
      label: 'Helbedündorf',
      provincie: 16,
      slug: 'helbeduendorf',
    },
    {
      code: '160650067067',
      label: 'Sondershausen',
      provincie: 16,
      slug: 'sondershausen',
    },
    {
      code: '160650085085',
      label: 'Kyffhäuserland',
      provincie: 16,
      slug: 'kyffhaeuserland',
    },
    {
      code: '160650087087',
      label: 'Roßleben-Wiehe',
      provincie: 16,
      slug: 'rossleben-wiehe',
    },
    {
      code: '160650089089',
      label: 'Greußen',
      provincie: 16,
      slug: 'greussen',
    },
    {
      code: '160655002012',
      label: 'Clingen',
      provincie: 16,
      slug: 'clingen',
    },
    {
      code: '160655002048',
      label: 'Niederbösa',
      provincie: 16,
      slug: 'niederboesa',
    },
    {
      code: '160655002051',
      label: 'Oberbösa',
      provincie: 16,
      slug: 'oberboesa',
    },
    {
      code: '160655002074',
      label: 'Topfstedt',
      provincie: 16,
      slug: 'topfstedt',
    },
    {
      code: '160655002075',
      label: 'Trebra',
      provincie: 16,
      slug: 'trebra',
    },
    {
      code: '160655002077',
      label: 'Wasserthaleben',
      provincie: 16,
      slug: 'wasserthaleben',
    },
    {
      code: '160655002079',
      label: 'Westgreußen',
      provincie: 16,
      slug: 'westgreussen',
    },
    {
      code: '160655052001',
      label: 'Abtsbessingen',
      provincie: 16,
      slug: 'abtsbessingen',
    },
    {
      code: '160655052005',
      label: 'Bellstedt',
      provincie: 16,
      slug: 'bellstedt',
    },
    {
      code: '160655052014',
      label: 'Ebeleben',
      provincie: 16,
      slug: 'ebeleben',
    },
    {
      code: '160655052018',
      label: 'Freienbessingen',
      provincie: 16,
      slug: 'freienbessingen',
    },
    {
      code: '160655052038',
      label: 'Holzsußra',
      provincie: 16,
      slug: 'holzsussra',
    },
    {
      code: '160655052058',
      label: 'Rockstedt',
      provincie: 16,
      slug: 'rockstedt',
    },
    {
      code: '160655055008',
      label: 'Borxleben',
      provincie: 16,
      slug: 'borxleben',
    },
    {
      code: '160655055019',
      label: 'Gehofen',
      provincie: 16,
      slug: 'gehofen',
    },
    {
      code: '160655055042',
      label: 'Kalbsrieth',
      provincie: 16,
      slug: 'kalbsrieth',
    },
    {
      code: '160655055046',
      label: 'Mönchpfiffel-Nikolausrieth',
      provincie: 16,
      slug: 'moenchpfiffel-nikolausrieth',
    },
    {
      code: '160655055056',
      label: 'Reinsdorf',
      provincie: 16,
      slug: 'reinsdorf-gemeinde',
    },
    {
      code: '160655055086',
      label: 'Artern',
      provincie: 16,
      slug: 'artern',
    },
    {
      code: '160655056016',
      label: 'Etzleben',
      provincie: 16,
      slug: 'etzleben',
    },
    {
      code: '160655056052',
      label: 'Oberheldrungen',
      provincie: 16,
      slug: 'oberheldrungen',
    },
    {
      code: '160655056088',
      label: 'An der Schmücke',
      provincie: 16,
      slug: 'an-der-schmuecke',
    },
    {
      code: '160660023023',
      label: 'Floh-Seligenthal',
      provincie: 16,
      slug: 'floh-seligenthal',
    },
    {
      code: '160660047047',
      label: 'Oberhof',
      provincie: 16,
      slug: 'oberhof',
    },
    {
      code: '160660063063',
      label: 'Schmalkalden',
      provincie: 16,
      slug: 'schmalkalden',
    },
    {
      code: '160660069069',
      label: 'Steinbach-Hallenberg',
      provincie: 16,
      slug: 'steinbach-hallenberg',
    },
    {
      code: '160660074074',
      label: 'Brotterode-Trusetal',
      provincie: 16,
      slug: 'brotterode-trusetal',
    },
    {
      code: '160660092092',
      label: 'Zella-Mehlis',
      provincie: 16,
      slug: 'zella-mehlis',
    },
    {
      code: '160660093093',
      label: 'Rhönblick',
      provincie: 16,
      slug: 'rhoenblick',
    },
    {
      code: '160660094094',
      label: 'Grabfeld',
      provincie: 16,
      slug: 'grabfeld',
    },
    {
      code: '160665005012',
      label: 'Birx',
      provincie: 16,
      slug: 'birx',
    },
    {
      code: '160665005019',
      label: 'Erbenhausen',
      provincie: 16,
      slug: 'erbenhausen',
    },
    {
      code: '160665005024',
      label: 'Frankenheim/Rhön',
      provincie: 16,
      slug: 'frankenheim-rhoen',
    },
    {
      code: '160665005052',
      label: 'Oberweid',
      provincie: 16,
      slug: 'oberweid',
    },
    {
      code: '160665005095',
      label: 'Kaltennordheim',
      provincie: 16,
      slug: 'kaltennordheim',
    },
    {
      code: '160665013025',
      label: 'Friedelshausen',
      provincie: 16,
      slug: 'friedelshausen',
    },
    {
      code: '160665013041',
      label: 'Mehmels',
      provincie: 16,
      slug: 'mehmels',
    },
    {
      code: '160665013064',
      label: 'Schwallungen',
      provincie: 16,
      slug: 'schwallungen',
    },
    {
      code: '160665013086',
      label: 'Wasungen',
      provincie: 16,
      slug: 'wasungen',
    },
    {
      code: '160665014005',
      label: 'Belrieth',
      provincie: 16,
      slug: 'belrieth',
    },
    {
      code: '160665014015',
      label: 'Christes',
      provincie: 16,
      slug: 'christes',
    },
    {
      code: '160665014016',
      label: 'Dillstädt',
      provincie: 16,
      slug: 'dillstaedt',
    },
    {
      code: '160665014017',
      label: 'Einhausen',
      provincie: 16,
      slug: 'einhausen-gemeinde',
    },
    {
      code: '160665014018',
      label: 'Ellingshausen',
      provincie: 16,
      slug: 'ellingshausen',
    },
    {
      code: '160665014038',
      label: 'Kühndorf',
      provincie: 16,
      slug: 'kuehndorf',
    },
    {
      code: '160665014039',
      label: 'Leutersdorf',
      provincie: 16,
      slug: 'leutersdorf-gemeinde',
    },
    {
      code: '160665014045',
      label: 'Neubrunn',
      provincie: 16,
      slug: 'neubrunn-gemeinde',
    },
    {
      code: '160665014049',
      label: 'Obermaßfeld-Grimmenthal',
      provincie: 16,
      slug: 'obermassfeld-grimmenthal',
    },
    {
      code: '160665014057',
      label: 'Ritschenhausen',
      provincie: 16,
      slug: 'ritschenhausen',
    },
    {
      code: '160665014058',
      label: 'Rohr',
      provincie: 16,
      slug: 'rohr-gemeinde',
    },
    {
      code: '160665014065',
      label: 'Schwarza',
      provincie: 16,
      slug: 'schwarza',
    },
    {
      code: '160665014079',
      label: 'Utendorf',
      provincie: 16,
      slug: 'utendorf',
    },
    {
      code: '160665014081',
      label: 'Vachdorf',
      provincie: 16,
      slug: 'vachdorf',
    },
    {
      code: '160665050042',
      label: 'Meiningen',
      provincie: 16,
      slug: 'meiningen',
    },
    {
      code: '160665050056',
      label: 'Rippershausen',
      provincie: 16,
      slug: 'rippershausen',
    },
    {
      code: '160665050076',
      label: 'Untermaßfeld',
      provincie: 16,
      slug: 'untermassfeld',
    },
    {
      code: '160665051013',
      label: 'Breitungen/Werra',
      provincie: 16,
      slug: 'breitungen-werra',
    },
    {
      code: '160665051022',
      label: 'Fambach',
      provincie: 16,
      slug: 'fambach',
    },
    {
      code: '160665051059',
      label: 'Rosa',
      provincie: 16,
      slug: 'rosa',
    },
    {
      code: '160665051061',
      label: 'Roßdorf',
      provincie: 16,
      slug: 'rossdorf-gemeinde',
    },
    {
      code: '160670019019',
      label: 'Friedrichroda',
      provincie: 16,
      slug: 'friedrichroda',
    },
    {
      code: '160670029029',
      label: 'Gotha',
      provincie: 16,
      slug: 'gotha',
    },
    {
      code: '160670064064',
      label: 'Bad Tabarz',
      provincie: 16,
      slug: 'bad-tabarz',
    },
    {
      code: '160670065065',
      label: 'Tambach-Dietharz/Thür.Wald',
      provincie: 16,
      slug: 'tambach-dietharz-thuer-wald',
    },
    {
      code: '160670072072',
      label: 'Waltershausen',
      provincie: 16,
      slug: 'waltershausen',
    },
    {
      code: '160670087087',
      label: 'Nesse-Apfelstädt',
      provincie: 16,
      slug: 'nesse-apfelstaedt',
    },
    {
      code: '160670088088',
      label: 'Hörsel',
      provincie: 16,
      slug: 'hoersel',
    },
    {
      code: '160675007004',
      label: 'Bienstädt',
      provincie: 16,
      slug: 'bienstaedt',
    },
    {
      code: '160675007016',
      label: 'Eschenbergen',
      provincie: 16,
      slug: 'eschenbergen',
    },
    {
      code: '160675007022',
      label: 'Friemar',
      provincie: 16,
      slug: 'friemar',
    },
    {
      code: '160675007047',
      label: 'Molschleben',
      provincie: 16,
      slug: 'molschleben',
    },
    {
      code: '160675007052',
      label: 'Nottleben',
      provincie: 16,
      slug: 'nottleben',
    },
    {
      code: '160675007055',
      label: 'Pferdingsleben',
      provincie: 16,
      slug: 'pferdingsleben',
    },
    {
      code: '160675007068',
      label: 'Tröchtelborn',
      provincie: 16,
      slug: 'troechtelborn',
    },
    {
      code: '160675007071',
      label: 'Tüttleben',
      provincie: 16,
      slug: 'tuettleben',
    },
    {
      code: '160675007082',
      label: 'Zimmernsupra',
      provincie: 16,
      slug: 'zimmernsupra',
    },
    {
      code: '160675012009',
      label: 'Dachwig',
      provincie: 16,
      slug: 'dachwig',
    },
    {
      code: '160675012011',
      label: 'Döllstädt',
      provincie: 16,
      slug: 'doellstaedt',
    },
    {
      code: '160675012026',
      label: 'Gierstädt',
      provincie: 16,
      slug: 'gierstaedt',
    },
    {
      code: '160675012033',
      label: 'Großfahner',
      provincie: 16,
      slug: 'grossfahner',
    },
    {
      code: '160675012067',
      label: 'Tonna',
      provincie: 16,
      slug: 'tonna',
    },
    {
      code: '160675050044',
      label: 'Luisenthal',
      provincie: 16,
      slug: 'luisenthal',
    },
    {
      code: '160675050053',
      label: 'Ohrdruf',
      provincie: 16,
      slug: 'ohrdruf',
    },
    {
      code: '160675052059',
      label: 'Schwabhausen',
      provincie: 16,
      slug: 'schwabhausen-gemeinde',
    },
    {
      code: '160675052089',
      label: 'Drei Gleichen',
      provincie: 16,
      slug: 'drei-gleichen',
    },
    {
      code: '160675053063',
      label: 'Sonneborn',
      provincie: 16,
      slug: 'sonneborn',
    },
    {
      code: '160675053091',
      label: 'Nessetal',
      provincie: 16,
      slug: 'nessetal',
    },
    {
      code: '160675054013',
      label: 'Emleben',
      provincie: 16,
      slug: 'emleben',
    },
    {
      code: '160675054092',
      label: 'Georgenthal',
      provincie: 16,
      slug: 'georgenthal',
    },
    {
      code: '160680034034',
      label: 'Kölleda',
      provincie: 16,
      slug: 'koelleda',
    },
    {
      code: '160680051051',
      label: 'Sömmerda',
      provincie: 16,
      slug: 'soemmerda',
    },
    {
      code: '160680058058',
      label: 'Weißensee',
      provincie: 16,
      slug: 'weissensee',
    },
    {
      code: '160680063063',
      label: 'Buttstädt',
      provincie: 16,
      slug: 'buttstaedt',
    },
    {
      code: '160685002002',
      label: 'Andisleben',
      provincie: 16,
      slug: 'andisleben',
    },
    {
      code: '160685002014',
      label: 'Gebesee',
      provincie: 16,
      slug: 'gebesee',
    },
    {
      code: '160685002045',
      label: 'Ringleben',
      provincie: 16,
      slug: 'ringleben',
    },
    {
      code: '160685002057',
      label: 'Walschleben',
      provincie: 16,
      slug: 'walschleben',
    },
    {
      code: '160685005005',
      label: 'Büchel',
      provincie: 16,
      slug: 'buechel-gemeinde',
    },
    {
      code: '160685005015',
      label: 'Griefstedt',
      provincie: 16,
      slug: 'griefstedt',
    },
    {
      code: '160685005022',
      label: 'Günstedt',
      provincie: 16,
      slug: 'guenstedt',
    },
    {
      code: '160685005064',
      label: 'Kindelbrück',
      provincie: 16,
      slug: 'kindelbrueck',
    },
    {
      code: '160685006019',
      label: 'Großneuhausen',
      provincie: 16,
      slug: 'grossneuhausen',
    },
    {
      code: '160685006033',
      label: 'Kleinneuhausen',
      provincie: 16,
      slug: 'kleinneuhausen',
    },
    {
      code: '160685006041',
      label: 'Ostramondra',
      provincie: 16,
      slug: 'ostramondra',
    },
    {
      code: '160685006042',
      label: 'Rastenberg',
      provincie: 16,
      slug: 'rastenberg',
    },
    {
      code: '160685009013',
      label: 'Gangloffsömmern',
      provincie: 16,
      slug: 'gangloffsoemmern',
    },
    {
      code: '160685009025',
      label: 'Haßleben',
      provincie: 16,
      slug: 'hassleben',
    },
    {
      code: '160685009044',
      label: 'Riethnordhausen',
      provincie: 16,
      slug: 'riethnordhausen',
    },
    {
      code: '160685009049',
      label: 'Schwerstedt',
      provincie: 16,
      slug: 'schwerstedt',
    },
    {
      code: '160685009053',
      label: 'Straußfurt',
      provincie: 16,
      slug: 'straussfurt',
    },
    {
      code: '160685009059',
      label: 'Werningshausen',
      provincie: 16,
      slug: 'werningshausen',
    },
    {
      code: '160685009062',
      label: 'Wundersleben',
      provincie: 16,
      slug: 'wundersleben',
    },
    {
      code: '160685012001',
      label: 'Alperstedt',
      provincie: 16,
      slug: 'alperstedt',
    },
    {
      code: '160685012007',
      label: 'Eckstedt',
      provincie: 16,
      slug: 'eckstedt',
    },
    {
      code: '160685012017',
      label: 'Großmölsen',
      provincie: 16,
      slug: 'grossmoelsen',
    },
    {
      code: '160685012021',
      label: 'Großrudestedt',
      provincie: 16,
      slug: 'grossrudestedt',
    },
    {
      code: '160685012032',
      label: 'Kleinmölsen',
      provincie: 16,
      slug: 'kleinmoelsen',
    },
    {
      code: '160685012036',
      label: 'Markvippach',
      provincie: 16,
      slug: 'markvippach',
    },
    {
      code: '160685012037',
      label: 'Nöda',
      provincie: 16,
      slug: 'noeda',
    },
    {
      code: '160685012039',
      label: 'Ollendorf',
      provincie: 16,
      slug: 'ollendorf',
    },
    {
      code: '160685012048',
      label: 'Schloßvippach',
      provincie: 16,
      slug: 'schlossvippach',
    },
    {
      code: '160685012052',
      label: 'Sprötau',
      provincie: 16,
      slug: 'sproetau',
    },
    {
      code: '160685012055',
      label: 'Udestedt',
      provincie: 16,
      slug: 'udestedt',
    },
    {
      code: '160685012056',
      label: 'Vogelsberg',
      provincie: 16,
      slug: 'vogelsberg',
    },
    {
      code: '160685050009',
      label: 'Elxleben',
      provincie: 16,
      slug: 'elxleben',
    },
    {
      code: '160685050061',
      label: 'Witterda',
      provincie: 16,
      slug: 'witterda',
    },
    {
      code: '160690012012',
      label: 'Eisfeld',
      provincie: 16,
      slug: 'eisfeld',
    },
    {
      code: '160690024024',
      label: 'Hildburghausen',
      provincie: 16,
      slug: 'hildburghausen',
    },
    {
      code: '160690042042',
      label: 'Schleusegrund',
      provincie: 16,
      slug: 'schleusegrund',
    },
    {
      code: '160690043043',
      label: 'Schleusingen',
      provincie: 16,
      slug: 'schleusingen',
    },
    {
      code: '160690053053',
      label: 'Veilsdorf',
      provincie: 16,
      slug: 'veilsdorf',
    },
    {
      code: '160690061061',
      label: 'Masserberg',
      provincie: 16,
      slug: 'masserberg',
    },
    {
      code: '160690062062',
      label: 'Römhild',
      provincie: 16,
      slug: 'roemhild',
    },
    {
      code: '160695002001',
      label: 'Ahlstädt',
      provincie: 16,
      slug: 'ahlstaedt',
    },
    {
      code: '160695002003',
      label: 'Beinerstadt',
      provincie: 16,
      slug: 'beinerstadt',
    },
    {
      code: '160695002004',
      label: 'Bischofrod',
      provincie: 16,
      slug: 'bischofrod',
    },
    {
      code: '160695002008',
      label: 'Dingsleben',
      provincie: 16,
      slug: 'dingsleben',
    },
    {
      code: '160695002009',
      label: 'Ehrenberg',
      provincie: 16,
      slug: 'ehrenberg',
    },
    {
      code: '160695002011',
      label: 'Eichenberg',
      provincie: 16,
      slug: 'eichenberg',
    },
    {
      code: '160695002016',
      label: 'Grimmelshausen',
      provincie: 16,
      slug: 'grimmelshausen',
    },
    {
      code: '160695002017',
      label: 'Grub',
      provincie: 16,
      slug: 'grub',
    },
    {
      code: '160695002021',
      label: 'Henfstädt',
      provincie: 16,
      slug: 'henfstaedt',
    },
    {
      code: '160695002025',
      label: 'Kloster Veßra',
      provincie: 16,
      slug: 'kloster-vessra',
    },
    {
      code: '160695002026',
      label: 'Lengfeld',
      provincie: 16,
      slug: 'lengfeld',
    },
    {
      code: '160695002028',
      label: 'Marisfeld',
      provincie: 16,
      slug: 'marisfeld',
    },
    {
      code: '160695002035',
      label: 'Oberstadt',
      provincie: 16,
      slug: 'oberstadt',
    },
    {
      code: '160695002037',
      label: 'Reurieth',
      provincie: 16,
      slug: 'reurieth',
    },
    {
      code: '160695002044',
      label: 'Schmeheim',
      provincie: 16,
      slug: 'schmeheim',
    },
    {
      code: '160695002047',
      label: 'St. Bernhard',
      provincie: 16,
      slug: 'st-bernhard',
    },
    {
      code: '160695002051',
      label: 'Themar',
      provincie: 16,
      slug: 'themar',
    },
    {
      code: '160695004041',
      label: 'Schlechtsart',
      provincie: 16,
      slug: 'schlechtsart',
    },
    {
      code: '160695004046',
      label: 'Schweickershausen',
      provincie: 16,
      slug: 'schweickershausen',
    },
    {
      code: '160695004049',
      label: 'Straufhain',
      provincie: 16,
      slug: 'straufhain',
    },
    {
      code: '160695004052',
      label: 'Ummerstadt',
      provincie: 16,
      slug: 'ummerstadt',
    },
    {
      code: '160695004056',
      label: 'Westhausen',
      provincie: 16,
      slug: 'westhausen-gemeinde',
    },
    {
      code: '160695004063',
      label: 'Heldburg',
      provincie: 16,
      slug: 'heldburg',
    },
    {
      code: '160695051006',
      label: 'Brünn/Thür.',
      provincie: 16,
      slug: 'bruenn-thuer',
    },
    {
      code: '160695051058',
      label: 'Auengrund',
      provincie: 16,
      slug: 'auengrund',
    },
    {
      code: '160700004004',
      label: 'Arnstadt',
      provincie: 16,
      slug: 'arnstadt',
    },
    {
      code: '160700028028',
      label: 'Amt Wachsenburg',
      provincie: 16,
      slug: 'amt-wachsenburg',
    },
    {
      code: '160700029029',
      label: 'Ilmenau',
      provincie: 16,
      slug: 'ilmenau',
    },
    {
      code: '160700048048',
      label: 'Stadtilm',
      provincie: 16,
      slug: 'stadtilm',
    },
    {
      code: '160700057057',
      label: 'Geratal',
      provincie: 16,
      slug: 'geratal',
    },
    {
      code: '160700058058',
      label: 'Großbreitenbach',
      provincie: 16,
      slug: 'grossbreitenbach',
    },
    {
      code: '160705002011',
      label: 'Elgersburg',
      provincie: 16,
      slug: 'elgersburg',
    },
    {
      code: '160705002034',
      label: 'Martinroda',
      provincie: 16,
      slug: 'martinroda',
    },
    {
      code: '160705002043',
      label: 'Plaue',
      provincie: 16,
      slug: 'plaue',
    },
    {
      code: '160705009001',
      label: 'Alkersleben',
      provincie: 16,
      slug: 'alkersleben',
    },
    {
      code: '160705009006',
      label: 'Bösleben-Wüllersleben',
      provincie: 16,
      slug: 'boesleben-wuellersleben',
    },
    {
      code: '160705009008',
      label: 'Dornheim',
      provincie: 16,
      slug: 'dornheim',
    },
    {
      code: '160705009012',
      label: 'Elleben',
      provincie: 16,
      slug: 'elleben',
    },
    {
      code: '160705009013',
      label: 'Elxleben',
      provincie: 16,
      slug: 'elxleben-gemeinde',
    },
    {
      code: '160705009041',
      label: 'Osthausen-Wülfershausen',
      provincie: 16,
      slug: 'osthausen-wuelfershausen',
    },
    {
      code: '160705009054',
      label: 'Witzleben',
      provincie: 16,
      slug: 'witzleben',
    },
    {
      code: '160710001001',
      label: 'Apolda',
      provincie: 16,
      slug: 'apolda',
    },
    {
      code: '160710003003',
      label: 'Bad Berka',
      provincie: 16,
      slug: 'bad-berka',
    },
    {
      code: '160710008008',
      label: 'Blankenhain',
      provincie: 16,
      slug: 'blankenhain',
    },
    {
      code: '160710101101',
      label: 'Ilmtal-Weinstraße',
      provincie: 16,
      slug: 'ilmtal-weinstrasse',
    },
    {
      code: '160710103103',
      label: 'Grammetal',
      provincie: 16,
      slug: 'grammetal',
    },
    {
      code: '160715007032',
      label: 'Hohenfelden',
      provincie: 16,
      slug: 'hohenfelden',
    },
    {
      code: '160715007043',
      label: 'Klettbach',
      provincie: 16,
      slug: 'klettbach',
    },
    {
      code: '160715007046',
      label: 'Kranichfeld',
      provincie: 16,
      slug: 'kranichfeld',
    },
    {
      code: '160715007059',
      label: 'Nauendorf',
      provincie: 16,
      slug: 'nauendorf',
    },
    {
      code: '160715007079',
      label: 'Rittersdorf',
      provincie: 16,
      slug: 'rittersdorf-gemeinde',
    },
    {
      code: '160715007087',
      label: 'Tonndorf',
      provincie: 16,
      slug: 'tonndorf',
    },
    {
      code: '160715008009',
      label: 'Buchfart',
      provincie: 16,
      slug: 'buchfart',
    },
    {
      code: '160715008013',
      label: 'Döbritschen',
      provincie: 16,
      slug: 'doebritschen',
    },
    {
      code: '160715008019',
      label: 'Frankendorf',
      provincie: 16,
      slug: 'frankendorf',
    },
    {
      code: '160715008025',
      label: 'Großschwabhausen',
      provincie: 16,
      slug: 'grossschwabhausen',
    },
    {
      code: '160715008027',
      label: 'Hammerstedt',
      provincie: 16,
      slug: 'hammerstedt',
    },
    {
      code: '160715008031',
      label: 'Hetschburg',
      provincie: 16,
      slug: 'hetschburg',
    },
    {
      code: '160715008037',
      label: 'Kapellendorf',
      provincie: 16,
      slug: 'kapellendorf',
    },
    {
      code: '160715008038',
      label: 'Kiliansroda',
      provincie: 16,
      slug: 'kiliansroda',
    },
    {
      code: '160715008042',
      label: 'Kleinschwabhausen',
      provincie: 16,
      slug: 'kleinschwabhausen',
    },
    {
      code: '160715008049',
      label: 'Lehnstedt',
      provincie: 16,
      slug: 'lehnstedt',
    },
    {
      code: '160715008053',
      label: 'Magdala',
      provincie: 16,
      slug: 'magdala',
    },
    {
      code: '160715008055',
      label: 'Mechelroda',
      provincie: 16,
      slug: 'mechelroda',
    },
    {
      code: '160715008056',
      label: 'Mellingen',
      provincie: 16,
      slug: 'mellingen',
    },
    {
      code: '160715008071',
      label: 'Oettern',
      provincie: 16,
      slug: 'oettern',
    },
    {
      code: '160715008089',
      label: 'Umpferstedt',
      provincie: 16,
      slug: 'umpferstedt',
    },
    {
      code: '160715008093',
      label: 'Vollersroda',
      provincie: 16,
      slug: 'vollersroda',
    },
    {
      code: '160715008095',
      label: 'Wiegendorf',
      provincie: 16,
      slug: 'wiegendorf',
    },
    {
      code: '160715051004',
      label: 'Bad Sulza',
      provincie: 16,
      slug: 'bad-sulza',
    },
    {
      code: '160715051015',
      label: 'Eberstedt',
      provincie: 16,
      slug: 'eberstedt',
    },
    {
      code: '160715051022',
      label: 'Großheringen',
      provincie: 16,
      slug: 'grossheringen',
    },
    {
      code: '160715051064',
      label: 'Niedertrebra',
      provincie: 16,
      slug: 'niedertrebra',
    },
    {
      code: '160715051069',
      label: 'Obertrebra',
      provincie: 16,
      slug: 'obertrebra',
    },
    {
      code: '160715051083',
      label: 'Schmiedehausen',
      provincie: 16,
      slug: 'schmiedehausen',
    },
    {
      code: '160715053005',
      label: 'Ballstedt',
      provincie: 16,
      slug: 'ballstedt',
    },
    {
      code: '160715053017',
      label: 'Ettersburg',
      provincie: 16,
      slug: 'ettersburg',
    },
    {
      code: '160715053061',
      label: 'Neumark',
      provincie: 16,
      slug: 'neumark-stadt',
    },
    {
      code: '160715053102',
      label: 'Am Ettersberg',
      provincie: 16,
      slug: 'am-ettersberg',
    },
    {
      code: '160720011011',
      label: 'Lauscha',
      provincie: 16,
      slug: 'lauscha',
    },
    {
      code: '160720015015',
      label: 'Schalkau',
      provincie: 16,
      slug: 'schalkau',
    },
    {
      code: '160720018018',
      label: 'Sonneberg',
      provincie: 16,
      slug: 'sonneberg',
    },
    {
      code: '160720019019',
      label: 'Steinach',
      provincie: 16,
      slug: 'steinach-stadt',
    },
    {
      code: '160720023023',
      label: 'Frankenblick',
      provincie: 16,
      slug: 'frankenblick',
    },
    {
      code: '160720024024',
      label: 'Föritztal',
      provincie: 16,
      slug: 'foeritztal',
    },
    {
      code: '160725051006',
      label: 'Goldisthal',
      provincie: 16,
      slug: 'goldisthal',
    },
    {
      code: '160725051013',
      label: 'Neuhaus am Rennweg',
      provincie: 16,
      slug: 'neuhaus-am-rennweg',
    },
    {
      code: '160730005005',
      label: 'Bad Blankenburg',
      provincie: 16,
      slug: 'bad-blankenburg',
    },
    {
      code: '160730076076',
      label: 'Rudolstadt',
      provincie: 16,
      slug: 'rudolstadt',
    },
    {
      code: '160730077077',
      label: 'Saalfeld/Saale',
      provincie: 16,
      slug: 'saalfeld-saale',
    },
    {
      code: '160730106106',
      label: 'Leutenberg',
      provincie: 16,
      slug: 'leutenberg',
    },
    {
      code: '160730109109',
      label: 'Uhlstädt-Kirchhasel',
      provincie: 16,
      slug: 'uhlstaedt-kirchhasel',
    },
    {
      code: '160730111111',
      label: 'Unterwellenborn',
      provincie: 16,
      slug: 'unterwellenborn',
    },
    {
      code: '160735005028',
      label: 'Gräfenthal',
      provincie: 16,
      slug: 'graefenthal',
    },
    {
      code: '160735005046',
      label: 'Lehesten',
      provincie: 16,
      slug: 'lehesten',
    },
    {
      code: '160735005067',
      label: 'Probstzella',
      provincie: 16,
      slug: 'probstzella',
    },
    {
      code: '160735012013',
      label: 'Cursdorf',
      provincie: 16,
      slug: 'cursdorf',
    },
    {
      code: '160735012014',
      label: 'Deesbach',
      provincie: 16,
      slug: 'deesbach',
    },
    {
      code: '160735012017',
      label: 'Döschnitz',
      provincie: 16,
      slug: 'doeschnitz',
    },
    {
      code: '160735012037',
      label: 'Katzhütte',
      provincie: 16,
      slug: 'katzhuette',
    },
    {
      code: '160735012055',
      label: 'Meura',
      provincie: 16,
      slug: 'meura',
    },
    {
      code: '160735012074',
      label: 'Rohrbach',
      provincie: 16,
      slug: 'rohrbach-gemeinde',
    },
    {
      code: '160735012082',
      label: 'Schwarzburg',
      provincie: 16,
      slug: 'schwarzburg',
    },
    {
      code: '160735012084',
      label: 'Sitzendorf',
      provincie: 16,
      slug: 'sitzendorf',
    },
    {
      code: '160735012094',
      label: 'Unterweißbach',
      provincie: 16,
      slug: 'unterweissbach',
    },
    {
      code: '160735012113',
      label: 'Schwarzatal',
      provincie: 16,
      slug: 'schwarzatal',
    },
    {
      code: '160735051002',
      label: 'Altenbeuthen',
      provincie: 16,
      slug: 'altenbeuthen',
    },
    {
      code: '160735051035',
      label: 'Hohenwarte',
      provincie: 16,
      slug: 'hohenwarte',
    },
    {
      code: '160735051038',
      label: 'Kaulsdorf',
      provincie: 16,
      slug: 'kaulsdorf',
    },
    {
      code: '160735051107',
      label: 'Drognitz',
      provincie: 16,
      slug: 'drognitz',
    },
    {
      code: '160735054001',
      label: 'Allendorf',
      provincie: 16,
      slug: 'allendorf-gemeinde',
    },
    {
      code: '160735054006',
      label: 'Bechstedt',
      provincie: 16,
      slug: 'bechstedt',
    },
    {
      code: '160735054112',
      label: 'Königsee',
      provincie: 16,
      slug: 'koenigsee',
    },
    {
      code: '160740044044',
      label: 'Kahla',
      provincie: 16,
      slug: 'kahla',
    },
    {
      code: '160745005012',
      label: 'Crossen an der Elster',
      provincie: 16,
      slug: 'crossen-an-der-elster',
    },
    {
      code: '160745005038',
      label: 'Hartmannsdorf',
      provincie: 16,
      slug: 'hartmannsdorf-gemeinde',
    },
    {
      code: '160745005039',
      label: 'Heideland',
      provincie: 16,
      slug: 'heideland-gemeinde',
    },
    {
      code: '160745005072',
      label: 'Rauda',
      provincie: 16,
      slug: 'rauda',
    },
    {
      code: '160745005092',
      label: 'Silbitz',
      provincie: 16,
      slug: 'silbitz',
    },
    {
      code: '160745005106',
      label: 'Walpernhain',
      provincie: 16,
      slug: 'walpernhain',
    },
    {
      code: '160745005116',
      label: 'Schkölen',
      provincie: 16,
      slug: 'schkoelen',
    },
    {
      code: '160745007007',
      label: 'Bremsnitz',
      provincie: 16,
      slug: 'bremsnitz',
    },
    {
      code: '160745007017',
      label: 'Eineborn',
      provincie: 16,
      slug: 'eineborn',
    },
    {
      code: '160745007022',
      label: 'Geisenhain',
      provincie: 16,
      slug: 'geisenhain',
    },
    {
      code: '160745007024',
      label: 'Gneus',
      provincie: 16,
      slug: 'gneus',
    },
    {
      code: '160745007029',
      label: 'Großbockedra',
      provincie: 16,
      slug: 'grossbockedra',
    },
    {
      code: '160745007045',
      label: 'Karlsdorf',
      provincie: 16,
      slug: 'karlsdorf',
    },
    {
      code: '160745007046',
      label: 'Kleinbockedra',
      provincie: 16,
      slug: 'kleinbockedra',
    },
    {
      code: '160745007047',
      label: 'Kleinebersdorf',
      provincie: 16,
      slug: 'kleinebersdorf',
    },
    {
      code: '160745007053',
      label: 'Lippersdorf-Erdmannsdorf',
      provincie: 16,
      slug: 'lippersdorf-erdmannsdorf',
    },
    {
      code: '160745007056',
      label: 'Meusebach',
      provincie: 16,
      slug: 'meusebach',
    },
    {
      code: '160745007064',
      label: 'Oberbodnitz',
      provincie: 16,
      slug: 'oberbodnitz',
    },
    {
      code: '160745007066',
      label: 'Ottendorf',
      provincie: 16,
      slug: 'ottendorf-gemeinde',
    },
    {
      code: '160745007071',
      label: 'Rattelsdorf',
      provincie: 16,
      slug: 'rattelsdorf-gemeinde',
    },
    {
      code: '160745007074',
      label: 'Rausdorf',
      provincie: 16,
      slug: 'rausdorf-gemeinde',
    },
    {
      code: '160745007077',
      label: 'Renthendorf',
      provincie: 16,
      slug: 'renthendorf',
    },
    {
      code: '160745007097',
      label: 'Tautendorf',
      provincie: 16,
      slug: 'tautendorf',
    },
    {
      code: '160745007101',
      label: 'Tissa',
      provincie: 16,
      slug: 'tissa',
    },
    {
      code: '160745007102',
      label: 'Trockenborn-Wolfersdorf',
      provincie: 16,
      slug: 'trockenborn-wolfersdorf',
    },
    {
      code: '160745007103',
      label: 'Tröbnitz',
      provincie: 16,
      slug: 'troebnitz',
    },
    {
      code: '160745007107',
      label: 'Waltersdorf',
      provincie: 16,
      slug: 'waltersdorf',
    },
    {
      code: '160745007108',
      label: 'Weißbach',
      provincie: 16,
      slug: 'weissbach-gemeinde',
    },
    {
      code: '160745011002',
      label: 'Altenberga',
      provincie: 16,
      slug: 'altenberga',
    },
    {
      code: '160745011004',
      label: 'Bibra',
      provincie: 16,
      slug: 'bibra',
    },
    {
      code: '160745011008',
      label: 'Bucha',
      provincie: 16,
      slug: 'bucha',
    },
    {
      code: '160745011016',
      label: 'Eichenberg',
      provincie: 16,
      slug: 'eichenberg-gemeinde',
    },
    {
      code: '160745011021',
      label: 'Freienorla',
      provincie: 16,
      slug: 'freienorla',
    },
    {
      code: '160745011031',
      label: 'Großeutersdorf',
      provincie: 16,
      slug: 'grosseutersdorf',
    },
    {
      code: '160745011033',
      label: 'Großpürschütz',
      provincie: 16,
      slug: 'grosspuerschuetz',
    },
    {
      code: '160745011034',
      label: 'Gumperda',
      provincie: 16,
      slug: 'gumperda',
    },
    {
      code: '160745011042',
      label: 'Hummelshain',
      provincie: 16,
      slug: 'hummelshain',
    },
    {
      code: '160745011048',
      label: 'Kleineutersdorf',
      provincie: 16,
      slug: 'kleineutersdorf',
    },
    {
      code: '160745011049',
      label: 'Laasdorf',
      provincie: 16,
      slug: 'laasdorf',
    },
    {
      code: '160745011052',
      label: 'Lindig',
      provincie: 16,
      slug: 'lindig',
    },
    {
      code: '160745011057',
      label: 'Milda',
      provincie: 16,
      slug: 'milda',
    },
    {
      code: '160745011065',
      label: 'Orlamünde',
      provincie: 16,
      slug: 'orlamuende',
    },
    {
      code: '160745011076',
      label: 'Reinstädt',
      provincie: 16,
      slug: 'reinstaedt',
    },
    {
      code: '160745011079',
      label: 'Rothenstein',
      provincie: 16,
      slug: 'rothenstein',
    },
    {
      code: '160745011087',
      label: 'Schöps',
      provincie: 16,
      slug: 'schoeps',
    },
    {
      code: '160745011089',
      label: 'Seitenroda',
      provincie: 16,
      slug: 'seitenroda',
    },
    {
      code: '160745011095',
      label: 'Sulza',
      provincie: 16,
      slug: 'sulza',
    },
    {
      code: '160745011104',
      label: 'Unterbodnitz',
      provincie: 16,
      slug: 'unterbodnitz',
    },
    {
      code: '160745011114',
      label: 'Zöllnitz',
      provincie: 16,
      slug: 'zoellnitz',
    },
    {
      code: '160745014041',
      label: 'Hermsdorf',
      provincie: 16,
      slug: 'hermsdorf-stadt',
    },
    {
      code: '160745014059',
      label: 'Mörsdorf',
      provincie: 16,
      slug: 'moersdorf-gemeinde',
    },
    {
      code: '160745014075',
      label: 'Reichenbach',
      provincie: 16,
      slug: 'reichenbach-gemeinde',
    },
    {
      code: '160745014084',
      label: 'Schleifreisen',
      provincie: 16,
      slug: 'schleifreisen',
    },
    {
      code: '160745014093',
      label: 'St. Gangloff',
      provincie: 16,
      slug: 'st-gangloff',
    },
    {
      code: '160745015011',
      label: 'Dornburg-Camburg',
      provincie: 16,
      slug: 'dornburg-camburg',
    },
    {
      code: '160745015019',
      label: 'Frauenprießnitz',
      provincie: 16,
      slug: 'frauenpriessnitz',
    },
    {
      code: '160745015026',
      label: 'Golmsdorf',
      provincie: 16,
      slug: 'golmsdorf',
    },
    {
      code: '160745015032',
      label: 'Großlöbichau',
      provincie: 16,
      slug: 'grossloebichau',
    },
    {
      code: '160745015036',
      label: 'Hainichen',
      provincie: 16,
      slug: 'hainichen-gemeinde',
    },
    {
      code: '160745015043',
      label: 'Jenalöbnitz',
      provincie: 16,
      slug: 'jenaloebnitz',
    },
    {
      code: '160745015051',
      label: 'Lehesten',
      provincie: 16,
      slug: 'lehesten-gemeinde',
    },
    {
      code: '160745015054',
      label: 'Löberschütz',
      provincie: 16,
      slug: 'loeberschuetz',
    },
    {
      code: '160745015063',
      label: 'Neuengönna',
      provincie: 16,
      slug: 'neuengoenna',
    },
    {
      code: '160745015096',
      label: 'Tautenburg',
      provincie: 16,
      slug: 'tautenburg',
    },
    {
      code: '160745015099',
      label: 'Thierschneck',
      provincie: 16,
      slug: 'thierschneck',
    },
    {
      code: '160745015112',
      label: 'Wichmar',
      provincie: 16,
      slug: 'wichmar',
    },
    {
      code: '160745015113',
      label: 'Zimmern',
      provincie: 16,
      slug: 'zimmern',
    },
    {
      code: '160745050058',
      label: 'Möckern',
      provincie: 16,
      slug: 'moeckern-gemeinde',
    },
    {
      code: '160745050081',
      label: 'Ruttersdorf-Lotschen',
      provincie: 16,
      slug: 'ruttersdorf-lotschen',
    },
    {
      code: '160745050094',
      label: 'Stadtroda',
      provincie: 16,
      slug: 'stadtroda',
    },
    {
      code: '160745051009',
      label: 'Bürgel',
      provincie: 16,
      slug: 'buergel',
    },
    {
      code: '160745051028',
      label: 'Graitschen b.Bürgel',
      provincie: 16,
      slug: 'graitschen-b-buergel',
    },
    {
      code: '160745051061',
      label: 'Nausnitz',
      provincie: 16,
      slug: 'nausnitz',
    },
    {
      code: '160745051068',
      label: 'Poxdorf',
      provincie: 16,
      slug: 'poxdorf-gemeinde',
    },
    {
      code: '160745052018',
      label: 'Eisenberg',
      provincie: 16,
      slug: 'eisenberg-stadt',
    },
    {
      code: '160745052025',
      label: 'Gösen',
      provincie: 16,
      slug: 'goesen',
    },
    {
      code: '160745052037',
      label: 'Hainspitz',
      provincie: 16,
      slug: 'hainspitz',
    },
    {
      code: '160745052055',
      label: 'Mertendorf',
      provincie: 16,
      slug: 'mertendorf-gemeinde',
    },
    {
      code: '160745052067',
      label: 'Petersberg',
      provincie: 16,
      slug: 'petersberg-gemeinde',
    },
    {
      code: '160745052073',
      label: 'Rauschwitz',
      provincie: 16,
      slug: 'rauschwitz',
    },
    {
      code: '160745053001',
      label: 'Albersdorf',
      provincie: 16,
      slug: 'albersdorf-gemeinde',
    },
    {
      code: '160745053003',
      label: 'Bad Klosterlausnitz',
      provincie: 16,
      slug: 'bad-klosterlausnitz',
    },
    {
      code: '160745053005',
      label: 'Bobeck',
      provincie: 16,
      slug: 'bobeck',
    },
    {
      code: '160745053082',
      label: 'Scheiditz',
      provincie: 16,
      slug: 'scheiditz',
    },
    {
      code: '160745053085',
      label: 'Schlöben',
      provincie: 16,
      slug: 'schloeben',
    },
    {
      code: '160745053086',
      label: 'Schöngleina',
      provincie: 16,
      slug: 'schoengleina',
    },
    {
      code: '160745053091',
      label: 'Serba',
      provincie: 16,
      slug: 'serba',
    },
    {
      code: '160745053098',
      label: 'Tautenhain',
      provincie: 16,
      slug: 'tautenhain',
    },
    {
      code: '160745053105',
      label: 'Waldeck',
      provincie: 16,
      slug: 'waldeck-gemeinde',
    },
    {
      code: '160745053109',
      label: 'Weißenborn',
      provincie: 16,
      slug: 'weissenborn-gemeinde',
    },
    {
      code: '160750046046',
      label: 'Hirschberg',
      provincie: 16,
      slug: 'hirschberg-stadt',
    },
    {
      code: '160750062062',
      label: 'Bad Lobenstein',
      provincie: 16,
      slug: 'bad-lobenstein',
    },
    {
      code: '160750085085',
      label: 'Pößneck',
      provincie: 16,
      slug: 'poessneck',
    },
    {
      code: '160750098098',
      label: 'Schleiz',
      provincie: 16,
      slug: 'schleiz',
    },
    {
      code: '160750131131',
      label: 'Gefell',
      provincie: 16,
      slug: 'gefell-stadt',
    },
    {
      code: '160750132132',
      label: 'Tanna',
      provincie: 16,
      slug: 'tanna',
    },
    {
      code: '160750133133',
      label: 'Wurzbach',
      provincie: 16,
      slug: 'wurzbach',
    },
    {
      code: '160750134134',
      label: 'Remptendorf',
      provincie: 16,
      slug: 'remptendorf',
    },
    {
      code: '160750135135',
      label: 'Saalburg-Ebersdorf',
      provincie: 16,
      slug: 'saalburg-ebersdorf',
    },
    {
      code: '160750136136',
      label: 'Rosenthal am Rennsteig',
      provincie: 16,
      slug: 'rosenthal-am-rennsteig',
    },
    {
      code: '160755004014',
      label: 'Dittersdorf',
      provincie: 16,
      slug: 'dittersdorf',
    },
    {
      code: '160755004033',
      label: 'Görkwitz',
      provincie: 16,
      slug: 'goerkwitz',
    },
    {
      code: '160755004034',
      label: 'Göschitz',
      provincie: 16,
      slug: 'goeschitz',
    },
    {
      code: '160755004048',
      label: 'Kirschkau',
      provincie: 16,
      slug: 'kirschkau',
    },
    {
      code: '160755004063',
      label: 'Löhma',
      provincie: 16,
      slug: 'loehma',
    },
    {
      code: '160755004068',
      label: 'Moßbach',
      provincie: 16,
      slug: 'mossbach',
    },
    {
      code: '160755004072',
      label: 'Neundorf (bei Schleiz)',
      provincie: 16,
      slug: 'neundorf-bei-schleiz',
    },
    {
      code: '160755004076',
      label: 'Oettersdorf',
      provincie: 16,
      slug: 'oettersdorf',
    },
    {
      code: '160755004083',
      label: 'Plothen',
      provincie: 16,
      slug: 'plothen',
    },
    {
      code: '160755004084',
      label: 'Pörmitz',
      provincie: 16,
      slug: 'poermitz',
    },
    {
      code: '160755004109',
      label: 'Tegau',
      provincie: 16,
      slug: 'tegau',
    },
    {
      code: '160755004119',
      label: 'Volkmannsdorf',
      provincie: 16,
      slug: 'volkmannsdorf',
    },
    {
      code: '160755005006',
      label: 'Bodelwitz',
      provincie: 16,
      slug: 'bodelwitz',
    },
    {
      code: '160755005016',
      label: 'Döbritz',
      provincie: 16,
      slug: 'doebritz',
    },
    {
      code: '160755005031',
      label: 'Gertewitz',
      provincie: 16,
      slug: 'gertewitz',
    },
    {
      code: '160755005039',
      label: 'Grobengereuth',
      provincie: 16,
      slug: 'grobengereuth',
    },
    {
      code: '160755005054',
      label: 'Langenorla',
      provincie: 16,
      slug: 'langenorla',
    },
    {
      code: '160755005056',
      label: 'Lausnitz b.Neustadt an der Orla',
      provincie: 16,
      slug: 'lausnitz-b-neustadt-an-der-orla',
    },
    {
      code: '160755005074',
      label: 'Nimritz',
      provincie: 16,
      slug: 'nimritz',
    },
    {
      code: '160755005075',
      label: 'Oberoppurg',
      provincie: 16,
      slug: 'oberoppurg',
    },
    {
      code: '160755005077',
      label: 'Oppurg',
      provincie: 16,
      slug: 'oppurg',
    },
    {
      code: '160755005087',
      label: 'Quaschwitz',
      provincie: 16,
      slug: 'quaschwitz',
    },
    {
      code: '160755005105',
      label: 'Solkwitz',
      provincie: 16,
      slug: 'solkwitz',
    },
    {
      code: '160755005121',
      label: 'Weira',
      provincie: 16,
      slug: 'weira',
    },
    {
      code: '160755005124',
      label: 'Wernburg',
      provincie: 16,
      slug: 'wernburg',
    },
    {
      code: '160755011019',
      label: 'Dreitzsch',
      provincie: 16,
      slug: 'dreitzsch',
    },
    {
      code: '160755011029',
      label: 'Geroda',
      provincie: 16,
      slug: 'geroda-gemeinde',
    },
    {
      code: '160755011057',
      label: 'Lemnitz',
      provincie: 16,
      slug: 'lemnitz',
    },
    {
      code: '160755011065',
      label: 'Miesitz',
      provincie: 16,
      slug: 'miesitz',
    },
    {
      code: '160755011066',
      label: 'Mittelpöllnitz',
      provincie: 16,
      slug: 'mittelpoellnitz',
    },
    {
      code: '160755011093',
      label: 'Rosendorf',
      provincie: 16,
      slug: 'rosendorf',
    },
    {
      code: '160755011099',
      label: 'Schmieritz',
      provincie: 16,
      slug: 'schmieritz',
    },
    {
      code: '160755011114',
      label: 'Tömmelsdorf',
      provincie: 16,
      slug: 'toemmelsdorf',
    },
    {
      code: '160755011116',
      label: 'Triptis',
      provincie: 16,
      slug: 'triptis',
    },
    {
      code: '160755013023',
      label: 'Eßbach',
      provincie: 16,
      slug: 'essbach',
    },
    {
      code: '160755013035',
      label: 'Gössitz',
      provincie: 16,
      slug: 'goessitz',
    },
    {
      code: '160755013047',
      label: 'Keila',
      provincie: 16,
      slug: 'keila',
    },
    {
      code: '160755013069',
      label: 'Moxa',
      provincie: 16,
      slug: 'moxa',
    },
    {
      code: '160755013079',
      label: 'Paska',
      provincie: 16,
      slug: 'paska',
    },
    {
      code: '160755013081',
      label: 'Peuschen',
      provincie: 16,
      slug: 'peuschen',
    },
    {
      code: '160755013088',
      label: 'Ranis',
      provincie: 16,
      slug: 'ranis',
    },
    {
      code: '160755013101',
      label: 'Schmorda',
      provincie: 16,
      slug: 'schmorda',
    },
    {
      code: '160755013102',
      label: 'Schöndorf',
      provincie: 16,
      slug: 'schoendorf-gemeinde',
    },
    {
      code: '160755013103',
      label: 'Seisla',
      provincie: 16,
      slug: 'seisla',
    },
    {
      code: '160755013125',
      label: 'Wilhelmsdorf',
      provincie: 16,
      slug: 'wilhelmsdorf-gemeinde',
    },
    {
      code: '160755013127',
      label: 'Ziegenrück',
      provincie: 16,
      slug: 'ziegenrueck',
    },
    {
      code: '160755013129',
      label: 'Krölpa',
      provincie: 16,
      slug: 'kroelpa',
    },
    {
      code: '160755050051',
      label: 'Kospoda',
      provincie: 16,
      slug: 'kospoda',
    },
    {
      code: '160755050073',
      label: 'Neustadt an der Orla',
      provincie: 16,
      slug: 'neustadt-an-der-orla',
    },
    {
      code: '160760022022',
      label: 'Greiz',
      provincie: 16,
      slug: 'greiz',
    },
    {
      code: '160760061061',
      label: 'Ronneburg',
      provincie: 16,
      slug: 'ronneburg-stadt',
    },
    {
      code: '160760088088',
      label: 'Harth-Pöllnitz',
      provincie: 16,
      slug: 'harth-poellnitz',
    },
    {
      code: '160760089089',
      label: 'Kraftsdorf',
      provincie: 16,
      slug: 'kraftsdorf',
    },
    {
      code: '160760092092',
      label: 'Auma-Weidatal',
      provincie: 16,
      slug: 'auma-weidatal',
    },
    {
      code: '160760093093',
      label: 'Mohlsdorf-Teichwolframsdorf',
      provincie: 16,
      slug: 'mohlsdorf-teichwolframsdorf',
    },
    {
      code: '160760094094',
      label: 'Berga-Wünschendorf',
      provincie: 16,
      slug: 'berga-wuenschendorf',
    },
    {
      code: '160765004009',
      label: 'Braunichswalde',
      provincie: 16,
      slug: 'braunichswalde',
    },
    {
      code: '160765004017',
      label: 'Endschütz',
      provincie: 16,
      slug: 'endschuetz',
    },
    {
      code: '160765004019',
      label: 'Gauern',
      provincie: 16,
      slug: 'gauern',
    },
    {
      code: '160765004027',
      label: 'Hilbersdorf',
      provincie: 16,
      slug: 'hilbersdorf',
    },
    {
      code: '160765004034',
      label: 'Kauern',
      provincie: 16,
      slug: 'kauern',
    },
    {
      code: '160765004043',
      label: 'Linda b.Weida',
      provincie: 16,
      slug: 'linda-b-weida',
    },
    {
      code: '160765004055',
      label: 'Paitzdorf',
      provincie: 16,
      slug: 'paitzdorf',
    },
    {
      code: '160765004062',
      label: 'Rückersdorf',
      provincie: 16,
      slug: 'rueckersdorf-gemeinde',
    },
    {
      code: '160765004069',
      label: 'Seelingstädt',
      provincie: 16,
      slug: 'seelingstaedt',
    },
    {
      code: '160765004074',
      label: 'Teichwitz',
      provincie: 16,
      slug: 'teichwitz',
    },
    {
      code: '160765006007',
      label: 'Bocka',
      provincie: 16,
      slug: 'bocka',
    },
    {
      code: '160765006033',
      label: 'Hundhaupten',
      provincie: 16,
      slug: 'hundhaupten',
    },
    {
      code: '160765006042',
      label: 'Lederhose',
      provincie: 16,
      slug: 'lederhose',
    },
    {
      code: '160765006044',
      label: 'Lindenkreuz',
      provincie: 16,
      slug: 'lindenkreuz',
    },
    {
      code: '160765006049',
      label: 'Münchenbernsdorf',
      provincie: 16,
      slug: 'muenchenbernsdorf',
    },
    {
      code: '160765006064',
      label: 'Saara',
      provincie: 16,
      slug: 'saara',
    },
    {
      code: '160765006068',
      label: 'Schwarzbach',
      provincie: 16,
      slug: 'schwarzbach-gemeinde',
    },
    {
      code: '160765006086',
      label: 'Zedlitz',
      provincie: 16,
      slug: 'zedlitz',
    },
    {
      code: '160765008006',
      label: 'Bethenhausen',
      provincie: 16,
      slug: 'bethenhausen',
    },
    {
      code: '160765008008',
      label: 'Brahmenau',
      provincie: 16,
      slug: 'brahmenau',
    },
    {
      code: '160765008023',
      label: 'Großenstein',
      provincie: 16,
      slug: 'grossenstein',
    },
    {
      code: '160765008028',
      label: 'Hirschfeld',
      provincie: 16,
      slug: 'hirschfeld-gemeinde',
    },
    {
      code: '160765008036',
      label: 'Korbußen',
      provincie: 16,
      slug: 'korbussen',
    },
    {
      code: '160765008058',
      label: 'Pölzig',
      provincie: 16,
      slug: 'poelzig',
    },
    {
      code: '160765008059',
      label: 'Reichstädt',
      provincie: 16,
      slug: 'reichstaedt',
    },
    {
      code: '160765008067',
      label: 'Schwaara',
      provincie: 16,
      slug: 'schwaara',
    },
    {
      code: '160765051003',
      label: 'Bad Köstritz',
      provincie: 16,
      slug: 'bad-koestritz',
    },
    {
      code: '160765051012',
      label: 'Caaschwitz',
      provincie: 16,
      slug: 'caaschwitz',
    },
    {
      code: '160765053014',
      label: 'Crimla',
      provincie: 16,
      slug: 'crimla',
    },
    {
      code: '160765053079',
      label: 'Weida',
      provincie: 16,
      slug: 'weida',
    },
    {
      code: '160765054041',
      label: 'Langenwolschendorf',
      provincie: 16,
      slug: 'langenwolschendorf',
    },
    {
      code: '160765054081',
      label: 'Weißendorf',
      provincie: 16,
      slug: 'weissendorf',
    },
    {
      code: '160765054087',
      label: 'Zeulenroda-Triebes',
      provincie: 16,
      slug: 'zeulenroda-triebes',
    },
    {
      code: '160765056029',
      label: 'Hohenleuben',
      provincie: 16,
      slug: 'hohenleuben',
    },
    {
      code: '160765056039',
      label: 'Langenwetzendorf',
      provincie: 16,
      slug: 'langenwetzendorf',
    },
    {
      code: '160770001001',
      label: 'Altenburg',
      provincie: 16,
      slug: 'altenburg',
    },
    {
      code: '160770028028',
      label: 'Lucka',
      provincie: 16,
      slug: 'lucka',
    },
    {
      code: '160770032032',
      label: 'Meuselwitz',
      provincie: 16,
      slug: 'meuselwitz',
    },
    {
      code: '160775004005',
      label: 'Fockendorf',
      provincie: 16,
      slug: 'fockendorf',
    },
    {
      code: '160775004007',
      label: 'Gerstenberg',
      provincie: 16,
      slug: 'gerstenberg',
    },
    {
      code: '160775004015',
      label: 'Haselbach',
      provincie: 16,
      slug: 'haselbach-gemeinde',
    },
    {
      code: '160775004048',
      label: 'Treben',
      provincie: 16,
      slug: 'treben',
    },
    {
      code: '160775004052',
      label: 'Windischleuba',
      provincie: 16,
      slug: 'windischleuba',
    },
    {
      code: '160775005008',
      label: 'Göhren',
      provincie: 16,
      slug: 'goehren-gemeinde',
    },
    {
      code: '160775005009',
      label: 'Göllnitz',
      provincie: 16,
      slug: 'goellnitz',
    },
    {
      code: '160775005022',
      label: 'Kriebitzsch',
      provincie: 16,
      slug: 'kriebitzsch',
    },
    {
      code: '160775005027',
      label: 'Lödla',
      provincie: 16,
      slug: 'loedla',
    },
    {
      code: '160775005031',
      label: 'Mehna',
      provincie: 16,
      slug: 'mehna',
    },
    {
      code: '160775005034',
      label: 'Monstab',
      provincie: 16,
      slug: 'monstab',
    },
    {
      code: '160775005042',
      label: 'Rositz',
      provincie: 16,
      slug: 'rositz',
    },
    {
      code: '160775005044',
      label: 'Starkenberg',
      provincie: 16,
      slug: 'starkenberg',
    },
    {
      code: '160775009016',
      label: 'Heukewalde',
      provincie: 16,
      slug: 'heukewalde',
    },
    {
      code: '160775009018',
      label: 'Jonaswalde',
      provincie: 16,
      slug: 'jonaswalde',
    },
    {
      code: '160775009026',
      label: 'Löbichau',
      provincie: 16,
      slug: 'loebichau',
    },
    {
      code: '160775009041',
      label: 'Posterstein',
      provincie: 16,
      slug: 'posterstein',
    },
    {
      code: '160775009047',
      label: 'Thonhausen',
      provincie: 16,
      slug: 'thonhausen',
    },
    {
      code: '160775009049',
      label: 'Vollmershain',
      provincie: 16,
      slug: 'vollmershain',
    },
    {
      code: '160775050012',
      label: 'Gößnitz',
      provincie: 16,
      slug: 'goessnitz',
    },
    {
      code: '160775050017',
      label: 'Heyersdorf',
      provincie: 16,
      slug: 'heyersdorf',
    },
    {
      code: '160775050039',
      label: 'Ponitz',
      provincie: 16,
      slug: 'ponitz',
    },
    {
      code: '160775051011',
      label: 'Göpfersdorf',
      provincie: 16,
      slug: 'goepfersdorf',
    },
    {
      code: '160775051023',
      label: 'Langenleuba-Niederhain',
      provincie: 16,
      slug: 'langenleuba-niederhain',
    },
    {
      code: '160775051036',
      label: 'Nobitz',
      provincie: 16,
      slug: 'nobitz',
    },
    {
      code: '160775052003',
      label: 'Dobitschen',
      provincie: 16,
      slug: 'dobitschen',
    },
    {
      code: '160775052043',
      label: 'Schmölln',
      provincie: 16,
      slug: 'schmoelln',
    },
  ],
  // DE-LOKALBEHOERDE-END
}

// TODO: add country check instead of municipalitycode only (first match across all deployments; ambiguous if a code exists in >1 country)
const getProvinceByMunicipalityCode = (code) => {
  return Object.values(gemeentenByDeployment).flat().find((gemeente) => gemeente.code === code)?.provincie
}

// TODO: add country check instead of municipalitycode only (first match across all deployments; ambiguous if a code exists in >1 country)
const getCountryCodeByMunicipalityCode = (code) => {
  return Object.keys(gemeentenByDeployment).find(key => gemeentenByDeployment[key].some(gemeente => gemeente.code === code))
}

module.exports = {
  deprecatedCodesByDeployment,
  gemeentenByDeployment,
  getCountryCodeByMunicipalityCode,
  getProvinceByMunicipalityCode,
}
